import trainingAdminTranslations from "../app/components/dashboard/training/trainingAdminTranslations";
import { trainingParticipantNo } from "./trainingParticipantTranslations";
// UI strings: Norwegian Bokmål (loaded as i18n resources `nb` and `no` in src/i18n.js).
export const no = {


    translation: {
        "trainingAdmin.jsonLanguage": "Ukjent språk. Bruk nb, en, sv eller pl, og ikke oversett til kursets eget språk.",
        "trainingAdmin.jsonLanguageMismatch": "JSON-en er skrevet på et annet språk enn kurset. Ta med en komplett oversettelse til kursets språk, eller bruk «Erstatt innhold».",
        "trainingAdmin.jsonTranslations": "En oversettelse viser til en side, et kort eller et svaralternativ som ikke finnes i kurset.",
        "trainingAdmin.languages": "Språk",
        "trainingAdmin.validationTranslations": "Fullfør eller fjern oversettelser som mangler tekst før publisering.",
        "trainingAdmin.translation.baseTitle": "Kursets språk",
        "trainingAdmin.translation.baseHint": "Språket kurset er skrevet på. Deltakere ser dette språket hvis kurset ikke finnes på deres språk.",
        "trainingAdmin.translation.title": "Oversettelser",
        "trainingAdmin.translation.hint": "Legg til språk kurset skal være tilgjengelig på. Deltakerne velger språk øverst i kurset. Spørsmål, fasit, dokumenter og bilder er de samme på alle språk, og svarene gjelder uansett språk.",
        "trainingAdmin.translation.missing": "Mangler: {{count}}",
        "trainingAdmin.translation.complete": "Komplett",
        "trainingAdmin.translation.edit": "Rediger",
        "trainingAdmin.translation.ai": "Oversett med AI",
        "trainingAdmin.translation.aiBusy": "Oversetter …",
        "trainingAdmin.translation.aiDone": "AI fylte inn {{count}} tekster. Les gjennom før du publiserer.",
        "trainingAdmin.translation.add": "Legg til språk:",
        "trainingAdmin.translation.saveFirst": "Lagre kurset før du bruker AI-oversettelse.",
        "trainingAdmin.translation.editorTitle": "Oversettelse til {{language}}",
        "trainingAdmin.translation.onlyMissing": "Vis bare tekster som mangler",
        "trainingAdmin.translation.nothingMissing": "Alle tekster er oversatt.",
        "trainingAdmin.translation.done": "Lukk oversettelsen",
        "trainingAdmin.translation.courseTitle": "Kurstittel",
        "trainingAdmin.translation.courseDescription": "Kursbeskrivelse",
        "trainingAdmin.translation.pageTitle": "Sidetittel",
        "trainingAdmin.translation.cardTitle": "Korttittel",
        "trainingAdmin.translation.cardBody": "Innhold",
        "trainingAdmin.translation.explanation": "Forklaring etter svar",
        "trainingAdmin.translation.imageAlt": "Bildetekst (alternativ tekst)",
        "trainingAdmin.translation.option": "Svaralternativ",
        "trainingParticipant.languages.title": "Kurset er tilgjengelig på flere språk",
        "trainingParticipant.languages.hint": "Velg språket du vil ta kurset på. Svarene dine gjelder på alle språk.",
        "trainingParticipant.languages.choose": "Velg språk for kurset",
        "pmStepper.decrease": "Reduser",
        "pmStepper.increase": "Øk",
        "hseCompliance.source.manual": "Lagt til",
        "hseCompliance.source.audience": "Målgruppe",
        "hseCompliance.source.training": "Via opplæring",
        "hseCompliance.source.training_named": "Opplæring: {{title}}",
        "hseCompliance.source.creator": "Forfatter",
        "hseCompliance.status.acknowledged": "Bekreftet",
        "hseCompliance.status.pending": "Venter",
        "hseCompliance.status.pending_due": "Frist {{date}}",
        "hseCompliance.status.overdue": "Forfalt",
        "hseCompliance.status.optional": "Ikke påkrevd",
        "hseCompliance.status.no_access": "Ikke tilknyttet",
        "hseCompliance.status.exempt": "Forfatter",
        "hseCompliance.via.training": "via opplæring",
        "hseCompliance.via.carried_forward": "videreført fra forrige versjon",
        "hseCompliance.via.creator": "forfatter",
        "hseCompliance.due.overdue_flag": "Forfalt",
        "hseCompliance.due.soon_flag": "Snart",
        "hseCompliance.postpone.dots_label": "{{used}} av {{max}} utsettelser brukt",
        "hseCompliance.people.search": "Søk etter person …",
        "hseCompliance.people.empty": "Ingen treff",
        "hseCompliance.people.remove": "Fjern {{name}}",
        "hseCompliance.people.selected": "{{count}} valgt",
        "hseCompliance.audience.all": "Alle ansatte",
        "hseCompliance.audience.all_desc": "{{count}} ansatte nå – nye ansatte får tilgang automatisk",
        "hseCompliance.audience.positions": "Utvalgte stillinger",
        "hseCompliance.audience.positions_desc": "Følger stillingen – endrer seg når noen bytter stilling",
        "hseCompliance.audience.none": "Bare enkeltpersoner",
        "hseCompliance.audience.none_desc": "Bare personene du legger til, og deltakere i opplæring som bruker dokumentet",
        "hseCompliance.dialog.menu_label": "Tilgang og lesekrav",
        "hseCompliance.dialog.eyebrow": "HMS-dokument",
        "hseCompliance.dialog.title": "Tilgang og lesekrav",
        "hseCompliance.dialog.title_bulk": "Tilgang og lesekrav for {{count}} dokumenter",
        "hseCompliance.dialog.subtitle": "Hvem som skal lese dokumentet, og når det må være bekreftet",
        "hseCompliance.dialog.subtitle_bulk": "Slå på delene du vil endre. Resten beholdes per dokument.",
        "hseCompliance.dialog.load_error": "Kunne ikke laste tilgang og lesekrav",
        "hseCompliance.dialog.save_error": "Kunne ikke lagre tilgang og lesekrav",
        "hseCompliance.dialog.saved": "Tilgang og lesekrav er lagret",
        "hseCompliance.dialog.saved_bulk": "Lagret for {{count}} dokumenter",
        "hseCompliance.dialog.save": "Lagre",
        "hseCompliance.dialog.save_bulk": "Bruk på {{count}} dokumenter",
        "hseCompliance.dialog.bulk_action": "Tilgang og lesekrav ({{count}})",
        "hseCompliance.dialog.audience_title": "Hvem har tilgang",
        "hseCompliance.dialog.audience_hint": "En regel gjelder også nye ansatte. Du slipper å oppdatere hvert dokument.",
        "hseCompliance.dialog.positions_label": "Stillinger",
        "hseCompliance.dialog.positions_empty": "Firmaet har ingen aktive stillinger. Legg dem til under ansatte.",
        "hseCompliance.dialog.people_extra_label": "Personer i tillegg",
        "hseCompliance.dialog.people_only_label": "Personer med tilgang",
        "hseCompliance.dialog.people_add_label": "Legg til personer",
        "hseCompliance.dialog.people_help": "Gi tilgang til enkeltpersoner utenfor regelen, for eksempel innleide.",
        "hseCompliance.dialog.people_add_help": "Personene legges til på alle valgte dokumenter. Ingen fjernes.",
        "hseCompliance.dialog.reach": "{{count}} av {{total}} ansatte får tilgang (i tillegg til deltakere i opplæring).",
        "hseCompliance.dialog.reach_bulk": "Regelen gir {{count}} ansatte tilgang i dag.",
        "hseCompliance.dialog.requirement_title": "Lesekrav",
        "hseCompliance.dialog.requirement_hint": "Påkrevde dokumenter får frist, påminnelse og varsel til leder og HMS-ansvarlig.",
        "hseCompliance.dialog.required_label": "Påkrevd å lese og bekrefte",
        "hseCompliance.dialog.required_desc": "Alle med tilgang må bekrefte «lest og forstått» innen fristen. Fullført opplæring med dokumentet teller.",
        "hseCompliance.dialog.not_required_help": "Dokumentet er tilgjengelig som oppslag. Ingen frist eller påminnelser.",
        "hseCompliance.dialog.deadline_label": "Frist",
        "hseCompliance.dialog.deadline_help": "Fra tildeling – også for nye ansatte og nye versjoner.",
        "hseCompliance.dialog.postponements_label": "Antall utsettelser",
        "hseCompliance.dialog.postponements_help": "Hvor mange ganger den ansatte selv kan utsette.",
        "hseCompliance.dialog.postpone_days_label": "Maks per utsettelse",
        "hseCompliance.dialog.postpone_days_help": "Når utsettelsene er brukt opp, varsles leder og HMS-ansvarlig.",
        "hseCompliance.dialog.days": "dager",
        "hseCompliance.dialog.training_title": "Via opplæring",
        "hseCompliance.dialog.training_hint": "Opplæring som bruker dokumentet gir deltakerne tilgang, og fullført opplæring teller som bekreftet.",
        "hseCompliance.dialog.training_empty": "Ingen aktiv opplæring bruker dette dokumentet.",
        "hseCompliance.dialog.fact_readers": "Har tilgang",
        "hseCompliance.dialog.fact_readers_value": "{{count}} av {{total}}",
        "hseCompliance.dialog.open_employees": "Se rutiner per ansatt →",
        "hseCompliance.dialog.change_access": "Endre tilgang",
        "hseCompliance.dialog.change_requirement": "Endre lesekrav",
        "hseCompliance.dialog.error_positions": "Velg minst én stilling.",
        "hseCompliance.dialog.error_nothing": "Slå på det du vil endre.",
        "hseCompliance.notice.exempt_title": "Du er forfatter",
        "hseCompliance.notice.exempt_desc": "Forfatteren trenger ikke bekrefte eget dokument.",
        "hseCompliance.notice.done_title": "Lest og forstått",
        "hseCompliance.notice.done_direct": "Du bekreftet {{date}}.",
        "hseCompliance.notice.done_training": "Bekreftet gjennom fullført opplæring {{date}}. Du trenger ikke bekrefte på nytt.",
        "hseCompliance.notice.done_carried": "Endringen i denne versjonen krevde ikke ny bekreftelse.",
        "hseCompliance.notice.optional_title": "Til orientering",
        "hseCompliance.notice.optional_desc": "Dokumentet er ikke påkrevd å bekrefte, men du kan gjerne bekrefte at du har lest det.",
        "hseCompliance.notice.due_title": "Må leses innen {{date}} ({{count}} dager igjen)",
        "hseCompliance.notice.due_title_one": "Må leses innen {{date}} (1 dag igjen)",
        "hseCompliance.notice.overdue_title": "Fristen var {{date}}",
        "hseCompliance.notice.required_desc": "Les dokumentet og bekreft at du har lest og forstått det. Leder og HMS-ansvarlig varsles når fristen passeres.",
        "hseCompliance.notice.postponements_left": "{{count}} utsettelser igjen",
        "hseCompliance.notice.postponements_left_one": "1 utsettelse igjen",
        "hseCompliance.notice.postpone": "Utsett",
        "hseCompliance.notice.postpone_choose": "Velg antall dager",
        "hseCompliance.notice.postpone_confirm": "Utsett {{count}} dager",
        "hseCompliance.notice.postpone_confirm_one": "Utsett 1 dag",
        "hseCompliance.notice.days": "{{count}} dager",
        "hseCompliance.notice.days_one": "1 dag",
        "hseCompliance.notice.postponed": "Ny frist: {{date}}",
        "hseCompliance.reminder.label": "Lesekrav for HMS-dokumenter",
        "hseCompliance.reminder.title": "{{count}} HMS-rutiner må leses og bekreftes",
        "hseCompliance.reminder.title_one": "1 HMS-rutine må leses og bekreftes",
        "hseCompliance.reminder.overdue_title": "{{count}} HMS-rutiner har passert fristen",
        "hseCompliance.reminder.overdue_title_one": "1 HMS-rutine har passert fristen",
        "hseCompliance.reminder.next_due": "Neste frist {{date}}",
        "hseCompliance.reminder.was_due": "Fristen var {{date}}",
        "hseCompliance.reminder.open_one": "Les nå",
        "hseCompliance.reminder.open_all": "Se rutinene",
        "hseCompliance.reminder.snooze": "Skjul i en time",
        "hseCompliance.home.none": "Ingen HMS-rutiner venter på deg",
        "hseCompliance.home.required": "{{count}} påkrevde rutiner venter på deg",
        "hseCompliance.home.required_one": "1 påkrevd rutine venter på deg",
        "hseCompliance.home.overdue": "{{count}} har passert fristen",
        "hseCompliance.home.overdue_one": "1 har passert fristen",
        "hseCompliance.home.show_all": "Vis alle ({{count}})",
        "employee_handbook.library.no_chapter": "Uten kapittel",
        "employee_handbook.library.must_read_title": "Må leses ({{count}})",
        "employee_handbook.library.must_read_hint": "Påkrevde rutiner. Les og bekreft før fristen.",
        "employee_handbook.library.show_all": "Vis alle ({{count}})",
        "employee_handbook.library.search": "Søk i tittel, nummer eller kapittel",
        "employee_handbook.library.clear_search": "Tøm søk",
        "employee_handbook.library.filter_label": "Vis dokumenter",
        "employee_handbook.library.filter_all": "Alle",
        "employee_handbook.library.filter_required": "Må leses",
        "employee_handbook.library.filter_done": "Bekreftet",
        "employee_handbook.library.discipline_label": "Fag",
        "employee_handbook.library.discipline_all": "Alle fag",
        "employee_handbook.library.toc": "Kapitler",
        "employee_handbook.library.toc_all": "Alle kapitler",
        "employee_handbook.library.results": "{{count}} dokumenter",
        "employee_handbook.library.results_one": "1 dokument",
        "employee_handbook.library.empty_title": "Ingen dokumenter passer",
        "employee_handbook.library.empty_desc": "Prøv et annet søk eller fjern filtrene.",
        "employee_handbook.library.clear": "Fjern filtre",
        "hseCompliance.notice.postpone_error": "Kunne ikke utsette fristen",
        "hseCompliance.employees.title": "Rutiner per ansatt",
        "hseCompliance.employees.subtitle": "Påkrevd lesing, frister og tilgang for hver ansatt",
        "hseCompliance.employees.read_overview": "Lest / forstått",
        "hseCompliance.employees.kpi_overdue": "Ansatte med forfalt",
        "hseCompliance.employees.kpi_overdue_hint": "{{count}} forfalte dokumenter totalt",
        "hseCompliance.employees.kpi_pending": "Venter på bekreftelse",
        "hseCompliance.employees.kpi_pending_hint": "Innenfor fristen",
        "hseCompliance.employees.kpi_employees": "Ansatte",
        "hseCompliance.employees.kpi_documents": "Godkjente rutiner",
        "hseCompliance.employees.search": "Søk etter ansatt eller stilling",
        "hseCompliance.employees.filter": "Filter",
        "hseCompliance.employees.filter_all": "Alle",
        "hseCompliance.employees.filter_overdue": "Forfalt",
        "hseCompliance.employees.filter_pending": "Venter",
        "hseCompliance.employees.filter_missing": "Mangler tilgang",
        "hseCompliance.employees.col_employee": "Ansatt",
        "hseCompliance.employees.col_progress": "Påkrevd lesing",
        "hseCompliance.employees.col_next_due": "Neste frist",
        "hseCompliance.employees.col_without_access": "Ikke tilknyttet",
        "hseCompliance.employees.progress_label": "{{done}} av {{total}} bekreftet",
        "hseCompliance.employees.empty_title": "Ingen ansatte å vise",
        "hseCompliance.employees.empty_desc": "Ingen treff for søket eller filteret.",
        "hseCompliance.employees.clear_filters": "Fjern filtre",
        "hseCompliance.routines.title": "Rutiner for ansatt",
        "hseCompliance.routines.subtitle": "Alle godkjente HMS-rutiner",
        "hseCompliance.routines.kpi_overdue": "Forfalt",
        "hseCompliance.routines.kpi_pending": "Venter",
        "hseCompliance.routines.kpi_acknowledged": "Bekreftet",
        "hseCompliance.routines.kpi_no_access": "Ikke tilknyttet",
        "hseCompliance.routines.search": "Søk i rutiner",
        "hseCompliance.routines.filter": "Filter",
        "hseCompliance.routines.filter_all": "Alle",
        "hseCompliance.routines.filter_no_access": "Ikke tilknyttet",
        "hseCompliance.routines.filter_pending": "Venter",
        "hseCompliance.routines.filter_overdue": "Forfalt",
        "hseCompliance.routines.filter_acknowledged": "Bekreftet",
        "hseCompliance.routines.manage_hint": "Velg rutiner for å gi tilgang eller fjerne tilgang du har lagt til. Tilgang fra målgruppe og opplæring styres på dokumentet og i opplæringen.",
        "hseCompliance.routines.change_error": "Kunne ikke endre tilgangen",
        "hseCompliance.routines.granted": "Tilgang gitt til {{count}} rutiner",
        "hseCompliance.routines.revoked": "Tilgang fjernet fra {{count}} rutiner",
        "hseCompliance.routines.no_chapter": "Uten kapittel",
        "hseCompliance.routines.former_title": "Tidligere ansatt",
        "hseCompliance.routines.former_desc": "Personen har sluttet. Historikken vises, men får ikke nye frister.",
        "hseCompliance.routines.empty_title": "Ingen rutiner å vise",
        "hseCompliance.routines.empty_desc": "Ingen treff for søket eller filteret.",
        "hseCompliance.routines.select_all": "Velg alle synlige",
        "hseCompliance.routines.select_one": "Velg {{title}}",
        "hseCompliance.routines.col_document": "Rutine",
        "hseCompliance.routines.col_access": "Tilgang",
        "hseCompliance.routines.col_status": "Status",
        "hseCompliance.routines.col_due": "Frist",
        "hseCompliance.routines.col_action": "Handling",
        "hseCompliance.routines.required": "Påkrevd",
        "hseCompliance.routines.not_required": "Ikke påkrevd",
        "hseCompliance.routines.no_access": "Ingen tilgang",
        "hseCompliance.routines.grant": "Gi tilgang",
        "hseCompliance.routines.add_manual": "Legg til fast",
        "hseCompliance.routines.remove": "Fjern",
        "hseCompliance.routines.bulk_grant": "Gi tilgang ({{count}})",
        "hseCompliance.routines.bulk_remove": "Fjern tilgang ({{count}})",
        "hseCompliance.overview.summary_overdue": "Forfalt",
        "hseCompliance.overview.overdue_count": "{{count}} forfalt",
        "hseCompliance.overview.open_routines": "Se rutiner for ansatt",
        "hseCompliance.approve.eyebrow": "Godkjenn revisjon",
        "hseCompliance.approve.title": "Godkjenn versjon {{version}}",
        "hseCompliance.approve.subtitle": "Velg om endringen krever at de ansatte bekrefter dokumentet på nytt",
        "hseCompliance.approve.reack_label": "Krever ny lesebekreftelse",
        "hseCompliance.approve.reack_on": "Alle med lesekrav må lese og bekrefte den nye versjonen innen fristen.",
        "hseCompliance.approve.reack_off": "Mindre endring: tidligere «lest og forstått» videreføres. Bare de som ikke hadde bekreftet, får frist.",
        "featureAnnouncements.eyebrow": "Ny funksjon",
        "featureAnnouncements.eyebrow_counter": "Ny funksjon · {{current}} av {{total}}",
        "featureAnnouncements.confirm": "Forstått",
        "featureAnnouncements.learn_more": "Vis meg",
        "featureAnnouncements.language.title": "Nytt språk: {{language}}",
        "featureAnnouncements.language.subtitle": "Promang er nå tilgjengelig på dette språket. Vil du bytte språk?",
        "featureAnnouncements.language.hint": "Du kan endre språk når som helst under brukerinnstillinger.",
        "featureAnnouncements.language.keep": "Behold {{language}}",
        "featureAnnouncements.language.switch": "Bytt til {{language}}",
        "featureAnnouncements.language.switch_failed": "Kunne ikke lagre språkvalget. Prøv igjen.",
        "agreementWorkflow.typeHint": "Velg avtaletype og se standardverdier, avtaletekst og vilkår.",
        "agreementWorkflow.applyDefaults": "Bruk forslagene fra typen",
        "agreementWorkflow.preserveEdits": "Felter du har endret selv, beholdes når du bytter type eller mal.",
        "agreementWorkflow.draftHint": "Kladd og tilbud følges ikke opp som service. Avtalen blir aktiv når kundens godkjenning eller signering er registrert.",
        "agreementWorkflow.saveDraft": "Lagre kladd",
        "agreementWorkflow.created": "Avtalekladden er opprettet.",
        "agreementWorkflow.openAgreement": "Åpne avtalen",
        "agreementWorkflow.createdRefreshFailed": "Avtalen er opprettet, men tilknyttet visning kunne ikke oppdateres. Åpne avtalen for å fortsette.",
        "agreementWorkflow.unknown": "Vi kunne ikke bekrefte resultatet. Kontroller avtalestatus før du prøver igjen.",
        "agreementWorkflow.noticeMonths": "Oppsigelsestid (måneder)",
        "agreementWorkflow.durationYears": "Avtalevarighet (år)",
        "agreementWorkflow.agreementText": "Avtaletekst",
        "agreementWorkflow.noFollowUp": "Ingen serviceoppfølging",
        "agreementWorkflow.title": "Avtalefase og godkjenning",
        "agreementWorkflow.activeHint": "Avtalen er aktiv og inngår i serviceoppfølgingen.",
        "agreementWorkflow.toProposal": "Sett i tilbudsfase",
        "agreementWorkflow.toDraft": "Tilbake til kladd",
        "agreementWorkflow.send": "Send tilbud til kunde",
        "agreementWorkflow.approve": "Registrer godkjenning/signering",
        "agreementWorkflow.reject": "Merk avslått",
        "agreementWorkflow.signingHint": "Avtalen er til signering. Ved retur til kladd vil tidligere signering ikke aktivere avtalen.",
        "agreementWorkflow.approvalHint": "Registrer kundens godkjenning eller manuelle signering. Startdato og serviceintervall må være fylt ut før aktivering.",
        "agreementWorkflow.approver": "Godkjent/signert av hos kunden",
        "agreementWorkflow.approvedOn": "Dato for godkjenning/signering",
        "agreementWorkflow.methodLabel": "Metode",
        "agreementWorkflow.method.manual_signature": "Manuell signering",
        "agreementWorkflow.method.manual_approval": "Manuell godkjenning",
        "agreementWorkflow.method.posten": "Signert med Posten",
        "agreementWorkflow.evidence": "Signert PDF (valgfritt)",
        "agreementWorkflow.uploadEvidence": "Last opp signert PDF i Dokumenter",
        "agreementWorkflow.documentsFailed": "Kunne ikke hente vedlegg. Prøv å åpne dialogen på nytt.",
        "agreementWorkflow.confirmApproval": "Bekreft og aktiver avtalen",
        "agreementWorkflow.sendHint": "Den lagrede avtalen sendes som PDF. Utsendelse aktiverer ikke serviceoppfølging.",
        "agreementWorkflow.recipient": "Mottakerens e-post",
        "agreementWorkflow.recipientName": "Mottakerens navn",
        "agreementWorkflow.message": "Melding til kunden",
        "agreementWorkflow.sent": "Tilbudet er sendt.",
        "agreementWorkflow.sendUnknown": "Utsendelsen er ikke bekreftet. Kontroller e-postloggen og mottakeren før en eventuell ny utsendelse.",
        "agreementWorkflow.updated": "Avtalefasen er oppdatert.",
        "agreementWorkflow.updatedRefreshFailed": "Endringen er lagret, men visningen kunne ikke oppdateres.",
        "agreementWorkflow.refreshFailed": "Kunne ikke kontrollere avtalestatus. Prøv statuskontrollen igjen.",
        "agreementWorkflow.checkStatus": "Kontroller status",
        "agreementWorkflow.delivery.sent": "Sendt",
        "agreementWorkflow.delivery.sending": "Utsendelse påbegynt",
        "agreementWorkflow.delivery.unknown": "Uavklart utsendelse",
        "agreementWorkflow.delivery.not_sent": "Ikke sendt",
        "agreementWorkflow.resolveNotSent": "Merk som ikke sendt",
        "agreementWorkflow.resolveSent": "Merk som sendt",
        "agreementWorkflow.resolvedNotSent": "Utsendelsen er merket som ikke sendt. Du kan sende på nytt.",
        "agreementWorkflow.resolvedSent": "Utsendelsen er merket som sendt. E-posten sendes ikke på nytt.",
        "agreementWorkflow.status.draft": "Kladd",
        "agreementWorkflow.status.proposal": "Tilbudsfase",
        "agreementWorkflow.status.awaiting_signature": "Til signering",
        "agreementWorkflow.status.active": "Aktiv",
        "agreementWorkflow.status.rejected": "Avslått",
        "agreementWorkflow.typeDefaults": "Forslag ved opprettelse",

        "labels.printSelected": "Skriv ut etiketter ({{count}})",
        "labels.fields.navn": "Navn",
        "labels.fields.nr": "Nummer",
        "labels.fields.pris": "Pris",
        "labels.fields.beskrivelse": "Beskrivelse",
        "labels.fields.merke": "Merke",
        "labels.fields.kategori": "Kategori",
        "labels.fields.lokasjon": "Lokasjon",
        "labels.fields.url": "Lenke (QR)",
        "labels.fields.dato": "Dato",
        "labels.fields.kunde": "Kunde",
        "labels.fields.adresse": "Adresse",
        "labels.fields.modell": "Modell",
        "labels.fields.serienr": "Serienummer",
        "labels.fields.info": "Tilleggsinfo",
        "labels.designer.title": "Skriv ut etikett",
        "labels.designer.loading": "Henter data…",
        "labels.designer.prev": "Forrige",
        "labels.designer.next": "Neste",
        "labels.designer.refresh": "Hent data på nytt",
        "labels.designer.close": "Lukk",
        "labels.designer.printer": "Skriver",
        "labels.designer.media": "Etikettrull",
        "labels.designer.mediaContinuous": "{{id}} · {{w}} mm løpende",
        "labels.designer.mediaDieCut": "{{id}} · {{w}} × {{h}} mm",
        "labels.designer.length": "Lengde i mm",
        "labels.designer.browserPrintHint": "Skrives ut via nettleserens utskriftsdialog",
        "labels.designer.autoLayout": "Auto-oppsett",
        "labels.designer.autoLayoutHint": "Lag standardoppsett for denne etikettstørrelsen",
        "labels.designer.tools": "Elementer",
        "labels.designer.kind.text": "Tekst",
        "labels.designer.kind.barcode": "Strekkode",
        "labels.designer.kind.qr": "QR-kode",
        "labels.designer.kind.line": "Linje",
        "labels.designer.grid": "Rutenett",
        "labels.designer.zoomOut": "Zoom ut",
        "labels.designer.zoomFit": "Tilpass",
        "labels.designer.zoomIn": "Zoom inn",
        "labels.designer.loadFailed": "Kunne ikke hente data til etiketten.",
        "labels.designer.retry": "Prøv igjen",
        "labels.designer.empty": "Ingen data å skrive ut.",
        "labels.designer.feedContinuous": "Løpende tape · kuttes automatisk",
        "labels.designer.feedDieCut": "Stanset etikett",
        "labels.designer.overridden": "Manuelt overstyrt",
        "labels.designer.inspector": "Egenskaper",
        "labels.designer.duplicate": "Dupliser",
        "labels.designer.delete": "Slett",
        "labels.designer.content": "Innhold",
        "labels.designer.manual": "Manuelt",
        "labels.designer.fromData": "Fra data",
        "labels.designer.dataValue": "Data",
        "labels.designer.reset": "Tilbakestill",
        "labels.designer.template": "Mal",
        "labels.designer.templatePlaceholder": "Mal, f.eks. {navn}",
        "labels.designer.font": "Skrift",
        "labels.designer.size": "Størrelse i pt",
        "labels.designer.weight": "Vekt",
        "labels.designer.weightNormal": "Normal",
        "labels.designer.weightBold": "Fet",
        "labels.designer.align": "Justering",
        "labels.designer.alignLeft": "Venstre",
        "labels.designer.alignCenter": "Midt",
        "labels.designer.alignRight": "Høyre",
        "labels.designer.shrinkToFit": "Krymp for å passe",
        "labels.designer.showText": "Vis tekst",
        "labels.designer.code39Info": "Code 39 · {{count}} tegn",
        "labels.designer.code39Dropped": "Code 39 støtter bare A–Z, 0–9, mellomrom, - og . – andre tegn utelates.",
        "labels.designer.widthShort": "B",
        "labels.designer.heightShort": "H",
        "labels.designer.geom.x": "X-posisjon i mm",
        "labels.designer.geom.y": "Y-posisjon i mm",
        "labels.designer.geom.w": "Bredde i mm",
        "labels.designer.geom.h": "Høyde i mm",
        "labels.designer.fields": "Datafelter",
        "labels.designer.clickToInsert": "Klikk for å sette inn",
        "labels.designer.newField": "Sett inn {{field}}",
        "labels.designer.overrideCount": "{{count}} manuelt endret",
        "labels.designer.dots": "punkter",
        "labels.designer.copies": "Antall",
        "labels.designer.printAll": "Alle ({{count}})",
        "labels.designer.cancel": "Avbryt",
        "labels.designer.print": "Skriv ut",
        "labels.designer.sent": "{{count}} etiketter sendt til utskrift ({{printer}})",
        "labels.designer.printFailed": "Kunne ikke åpne utskrift. Prøv igjen.",
        "labels.designer.newText": "Ny tekst",
        "inventory.picking.labels_for_lines": "Etiketter for alle varer i dokumentet",
        "inventory.picking.quick_print.tooltip": "Skriv ut etikett",
        "inventory.picking.quick_print.document_tooltip": "Dokumentetikett (nummer, kunde, adresse, type)",
        "inventory.stock.title": "Lagerbeholdning",
        "inventory.stock.subtitle": "Beholdning og tilgjengelig antall per produkt, med lagerfilter og etikettutskrift.",
        "inventory.stock.search": "Søk etter produkt…",
        "inventory.stock.storage": "Lager",
        "inventory.stock.tracked": "Lagerført antall",
        "inventory.stock.min": "Min",
        "inventory.stock.max": "Maks",
        "inventory.stock.legacyWarning": "Beholdningen bygger på eldre lagerdata uten godkjent åpningsbeholdning. Bruk verdirapporten før du tolker tallene regnskapsmessig.",
        "inventory.stock.selection": "Valgte produkter",
        "inventory.stock.selected": "{{count}} produkter valgt",
        "inventory.stock.printLabels": "Skriv ut etiketter",
        "inventory.stock.loadFailed": "Kunne ikke hente lagerbeholdningen. Prøv igjen.",
        "inventory.stock.loading": "Henter lagerbeholdning…",
        "inventory.stock.empty": "Ingen produkter funnet",
        "inventory.stock.emptyHint": "Prøv et annet søk eller fjern filtrene.",
        "inventory.stock.clearFilters": "Fjern filtre",
        "inventory.stock.selectAll": "Velg alle synlige produkter",
        "inventory.stock.selectProduct": "Velg {{product}}",
        "inventory.stock.product": "Produkt",
        "inventory.stock.outgoing": "Utgående",
        "inventory.stock.incoming": "Innkommende",
        "inventory.stock.available": "Tilgjengelig",
        "inventory.count.csv.invalid_quantity": "Rad {{row}} har ugyldig antall. Bruk 0 eller et positivt tall med høyst fire desimaler.",
        "inventoryPurchases.title": "Innkjøp",
        "inventoryPurchases.eyebrow": "Innkjøp",
        "inventoryPurchases.overview": "Oversikt over innkjøp",
        "inventoryPurchases.openOrders": "Åpne ordrer",
        "inventoryPurchases.draftOrders": "Utkast",
        "inventoryPurchases.overdueOrders": "Forsinket",
        "inventoryPurchases.exVat": "eks. mva",
        "inventoryPurchases.unknownAmount": "Beløp ikke komplett",
        "inventoryPurchases.activeOrders": "Aktive bestillinger",
        "inventoryPurchases.notSent": "Ikke sendt til leverandør",
        "inventoryPurchases.pastDelivery": "Passert ønsket leveringsdato",
        "inventoryPurchases.statusTabs": "Innkjøpsstatus",
        "inventoryPurchases.tab.all": "Alle",
        "inventoryPurchases.tab.draft": "Utkast",
        "inventoryPurchases.tab.openTab": "Åpne",
        "inventoryPurchases.tab.received": "Mottatt",
        "inventoryPurchases.project": "Prosjekt",
        "inventoryPurchases.amount": "Beløp eks. mva",
        "inventoryPurchases.lineCount": "{{count}} linjer",
        "inventoryPurchases.overdue": "Forsinket",
        "inventoryPurchase.details": "Detaljer",
        "inventoryPurchase.project": "Prosjekt",
        "inventoryPurchase.contact": "Kontaktperson hos leverandør",
        "inventoryPurchase.contactHint": "Velg eller opprett kontakt. Sending bruker denne e-posten først.",
        "inventoryPurchase.sendToContact": "Leverandørens kontakt",
        "inventoryPurchase.sendToContactNamed": "Kontakt · {{name}}",
        "inventoryPurchase.contactEmailMissing": "Kontaktpersonen mangler e-post.",
        "inventoryPurchase.chooseProject": "Velg prosjekt",
        "inventoryPurchase.deliveryAddress": "Leveringsadresse",
        "inventoryPurchase.localAddressHint": "Intern opplysning i Promang. Tripletex bruker foreløpig firmaets leveringsadresse.",
        "inventoryPurchase.costCode": "Kostnadskode",
        "inventoryPurchase.localCostCodeHint": "Intern kode i Promang, ikke overført til Tripletex.",
        "inventoryPurchase.summary": "Sammendrag",
        "inventoryPurchase.netAmount": "Sum eks. mva",
        "inventoryPurchase.grossAmount": "Totalt inkl. mva",
        "inventoryPurchase.orderLines": "Ordrelinjer",
        "inventoryPurchase.itemNumber": "Varenr.",
        "inventoryPurchase.product": "Produkt",
        "inventoryPurchase.comment": "Kommentar",
        "inventoryPurchase.lineTotal": "Total",
        "inventoryPurchase.addProduct": "Legg til produkt",
        "inventoryPurchase.addFirstProduct": "Legg til første produkt",
        "inventoryPurchase.emptyLines": "Ingen produkter lagt til ennå",
        "inventoryPurchase.send": "Send",
        "inventoryPurchase.sending": "Sender…",
        "inventoryPurchase.sendAsMe": "Meg",
        "inventoryPurchase.lineTitle": "Varenavn",
        "inventoryPurchase.changeProduct": "Bytt produkt",
        "inventoryPurchase.unit": "Enhet",
        "inventoryPurchase.saveDraft": "Lagre utkast",
        "inventoryPurchase.sendToSupplier": "Send til leverandør",
        "inventoryPurchase.sendDialogTitle": "Send innkjøp til leverandør",
        "inventoryPurchase.sendMessageLabel": "Melding til leverandør",
        "inventoryPurchase.missingId": "Mangler ID",
        "inventoryPurchase.sendFailed": "Noe gikk galt. Kunne ikke sende innkjøp.",
        "inventoryPurchase.sendNeedsSave": "Lagre utkastet før sending. Utsendingen ble ikke startet.",
        "inventoryPurchases.subtitle": "Bestillinger fra leverandører, levering og Tripletex-status samlet på ett sted.",
        "inventoryPurchases.new": "Nytt innkjøp",
        "inventoryPurchases.search": "Søk etter innkjøp…",
        "inventoryPurchases.filterStatus": "Filtrer på status",
        "inventoryPurchases.loading": "Henter innkjøp…",
        "inventoryPurchases.loadFailed": "Kunne ikke hente innkjøp. Prøv igjen.",
        "inventoryPurchases.number": "Innkjøpsnummer",
        "inventoryPurchases.supplier": "Leverandør",
        "inventoryPurchases.purchaseDate": "Innkjøpsdato",
        "inventoryPurchases.deliveryDate": "Leveringsdato",
        "inventoryPurchases.status": "Status",
        "inventoryPurchases.delivery": "Leverandørutsending",
        "inventoryPurchases.sync": "Tripletex",
        "inventoryPurchases.reference": "Referanse",
        "inventoryPurchases.open": "Åpne",
        "inventoryPurchases.empty": "Ingen innkjøp ennå",
        "inventoryPurchases.emptyHint": "Opprett et innkjøp for å komme i gang.",
        "inventoryPurchases.emptyFiltered": "Ingen innkjøp passer med søket eller filtrene.",
        "inventoryPurchases.clearFilters": "Fjern filtre",
        "inventoryPurchases.status.draft": "Utkast",
        "inventoryPurchases.status.sent": "Sendt",
        "inventoryPurchases.status.confirmed": "Bekreftet",
        "inventoryPurchases.status.received": "Mottatt",
        "inventoryPurchases.status.cancelled": "Kansellert",
        "inventoryPurchases.createTitle": "Opprett innkjøp",
        "inventoryPurchases.createHint": "Velg leverandør. Resten av innkjøpet fyller du ut på neste side.",
        "inventoryPurchases.continue": "Fortsett",
        "inventoryPurchases.searchSupplier": "Søk etter leverandør…",
        "inventoryPurchases.noSuppliers": "Ingen leverandører funnet",
        "inventoryPurchases.loadingSuppliers": "Henter leverandører…",
        "inventoryPurchases.supplierLoadFailed": "Kunne ikke hente leverandører. Prøv søket igjen.",
        "inventoryPurchases.supplierRequired": "Velg en leverandør før du oppretter innkjøpet.",
        "inventoryPurchases.createFailed": "Innkjøpet kunne ikke opprettes. Kontroller feltene og prøv igjen.",
        "inventoryPurchases.createUnknown": "Det er uklart om innkjøpet ble opprettet. Kontroller listen før du prøver på nytt.",
        "inventoryPurchases.recoveryTitle": "Kontroller uavklart innkjøp",
        "inventoryPurchases.recoveryHint": "Forsøket er bevart med samme nøkkel. Gjenoppta det samme forsøket for å unngå duplikat; ny kladd er bare mulig etter endelig avvisning fra serveren.",
        "inventoryPurchases.pendingAttempt": "Lagret opprettingsforsøk",
        "inventoryPurchases.pendingSummary": "Leverandør: {{supplier}} · Dato: {{date}} · Referanse: {{reference}}",
        "inventoryPurchases.checkBeforeRetry": "Kontroller innkjøpslisten før du sender dette forsøket på nytt.",
        "inventoryPurchases.storageUnavailable": "Nettleseren kunne ikke lagre operasjonsnøkkelen. Innkjøpet ble ikke sendt; prøv når sesjonslagring fungerer.",
        "inventoryPurchases.payloadConflict": "Serveren avviste nøkkelen for dette innholdet. Forsøket er bevart; undersøk mulig eksisterende innkjøp før videre handling.",
        "inventoryPurchases.checkFailed": "Kunne ikke kontrollere innkjøpslisten. Prøv igjen; forsøket er fortsatt bevart.",
        "inventoryPurchases.listChecked": "Første listeside er kontrollert. Treffene under kan være eldre, like innkjøp; en manglende rad beviser ikke at forsøket feilet. Du kan trygt gjenoppta eksakt samme forsøk.",
        "inventoryPurchases.possibleMatches": "Mulige treff på første listeside",
        "inventoryPurchases.checking": "Kontrollerer…",
        "inventoryPurchases.newAttempt": "Rett avvist kladd",
        "inventoryPurchases.retrySame": "Gjenoppta samme forsøk",
        "inventoryPurchases.created": "Innkjøpet er opprettet.",
        "inventoryPurchases.cancel": "Avbryt",
        "inventoryPurchases.create": "Opprett",
        "inventoryPurchases.creating": "Oppretter…",
        "inventoryPurchases.checkList": "Kontroller innkjøpslisten",
        "inventoryReconciliation.title": "Avstemming mot regnskap",
        "inventoryReconciliation.nowHint": "Lagerverdien over vises per nå. Regnskapsavstemmingen bruker hele valgte kalenderperiode; pågående periode kan ikke gi et endelig avvik.",
        "inventoryIntegration.receiptUnsupported": "Tripletex-mottak er utilgjengelig. Mottaket er fortsatt lagerført i Promang.",
        "inventoryReceipt.syncTitle": "Lagerføring og synkronisering",
        "inventoryReceipt.localPosted": "Lagerført i Promang",
        "inventoryReceipt.remoteConfirmed": "Mottaket er også bekreftet i Tripletex. Eventuelle restvarer følger samme innkjøp.",
        "inventoryReceipt.remotePending": "Tripletex har ikke bekreftet synkroniseringen ennå. Ikke registrer mottaket på nytt.",
        "inventoryReceipt.resumeHint": "Kontrollen leser status i Tripletex og fortsetter fra siste bekreftede steg. Endrede mengder, produkter eller lager stoppes for avstemming.",
        "inventoryReceipt.resumeSync": "Kontroller og fullfør synk",
        "inventoryReceipt.checkingSync": "Kontrollerer Tripletex…",
        "inventoryReceipt.resumeFailed": "Synkroniseringen kunne ikke bekreftes. Oppdater status og kontroller avvik under lagerinnstillinger. Mottaket er fortsatt lagerført lokalt.",
        "inventoryReconciliation.bookClosing": "Bokført utgående verdi",
        "inventoryReconciliation.bookOpening": "Bokført inngående verdi",
        "inventoryReconciliation.approvedBaselines": "Godkjente inngående saldoer",
        "inventoryReconciliation.bookProvisional": "Foreløpig verdi. Synk eller periode er ikke komplett.",
        "inventoryReconciliation.bookDifference": "Avvik mot bokført verdi",
        "inventoryReconciliation.bookIncomplete": "Bokført verdi kan først sammenlignes med godkjent inngående saldo og komplett synk for lukket periode.",
        "inventoryReconciliation.bookAsOf": "Bokført verdi per synk",
        "inventoryReconciliation.addBaseline": "Legg til inngående regnskapssaldo",
        "inventoryReconciliation.baselineHint": "Godkjenn dokumentert saldo per konto før periodestart. Den kan ikke endres etter lagring.",
        "inventoryReconciliation.account": "Konto",
        "inventoryReconciliation.baselineDate": "Saldodato",
        "inventoryReconciliation.openingBalance": "Inngående saldo (NOK)",
        "inventoryReconciliation.evidence": "Dokumentasjon / referanse",
        "inventoryReconciliation.baselineFailed": "Saldoen kunne ikke lagres. Kontroller dato, beløp og om saldo allerede finnes.",
        "inventoryReconciliation.saveBaseline": "Godkjenn saldo",
        "inventoryReconciliation.hint": "Sammenlign bevegelse i fysisk lagerverdi med bokførte bevegelser på valgte lagerkontoer i perioden.",
        "inventoryReconciliation.companyWide": "Avstemmingen gjelder hele firmaet, uavhengig av produkt- og lagerfilteret i tabellen.",
        "inventoryReconciliation.accounts": "Lagerkontoer",
        "inventoryReconciliation.chooseAccount": "Velg konto",
        "inventoryReconciliation.addAccount": "Legg til konto",
        "inventoryReconciliation.loadFailed": "Kunne ikke hente avstemmingen.",
        "inventoryReconciliation.loading": "Henter avstemming…",
        "inventoryReconciliation.physicalMovement": "Lagerbevegelse",
        "inventoryReconciliation.ledgerMovement": "Bokført periodebevegelse",
        "inventoryReconciliation.difference": "Avvik i perioden",
        "inventoryReconciliation.notComparable": "Kan ikke sammenlignes",
        "inventoryReconciliation.opening": "Inngående lagerverdi",
        "inventoryReconciliation.closing": "Utgående lagerverdi",
        "inventoryReconciliation.incomplete": "Sammenligning krever fullstendig kosthistorikk, valgte kontoer og bekreftet regnskapssynk for perioden.",
        "inventoryReconciliation.source": "Kilde: lokalt synkroniserte Tripletex-bilag",
        "inventoryReconciliation.lastCovered": "Siste dekkende synk",
        "inventoryReconciliation.noBookBalance": "Bokført saldo vises ikke uten verifisert inngående saldo.",
        "inventoryIntegration.title": "Innkjøpssynk",
        "inventoryIntegration.field": "Felt",
        "inventoryIntegration.sourceSystem": "Kildesystem",
        "inventoryIntegration.compare.number": "Ordrenummer",
        "inventoryIntegration.compare.supplier": "Leverandør-ID",
        "inventoryIntegration.compare.date": "Bestillingsdato",
        "inventoryIntegration.compare.deliveryDate": "Leveringsdato",
        "inventoryIntegration.compare.status": "Status / lukket",
        "inventoryIntegration.closed": "Lukket",
        "inventoryIntegration.open": "Åpen",
        "inventoryIntegration.noLines": "Ingen produktlinjer i tilgjengelige data.",
        "inventoryIntegration.hint": "Promang eier lager og innkjøp. Se overgang mot Tripletex og saker som trenger gjennomgang.",
        "inventoryIntegration.loadFailed": "Kunne ikke hente synkstatus. Prøv igjen.",
        "inventoryIntegration.mutationFailed": "Handlingen kunne ikke bekreftes. Oppdater status før du prøver igjen.",
        "inventoryIntegration.conflictChanged": "Innkjøpet eller Tripletex-ordren ble endret. Sammenlign de oppdaterte verdiene før du bekrefter valget på nytt.",
        "inventoryIntegration.queued": "Synk er lagt i kø. Oppdater senere for bekreftet resultat.",
        "inventoryIntegration.loading": "Henter synkstatus…",
        "inventoryIntegration.mode": "Driftsmodus",
        "inventoryIntegration.mode.off": "Synk avslått",
        "inventoryIntegration.mode.bridge": "Toveis overgang",
        "inventoryIntegration.mode.local_only": "Kun Promang",
        "inventoryIntegration.remoteCapability": "Tripletex logistikk",
        "inventoryIntegration.capability.available": "Tilgjengelig",
        "inventoryIntegration.capability.missing": "Ingen tilgang",
        "inventoryIntegration.capability.unchecked": "Ikke kontrollert",
        "inventoryIntegration.pending": "Venter på bekreftelse",
        "inventoryIntegration.needsReview": "Trenger gjennomgang",
        "inventoryIntegration.logisticsMissing": "Tripletex Logistikk Basis er ikke tilgjengelig. Lokalt lager og innkjøp i Promang fortsetter.",
        "inventoryIntegration.lastVerified": "Sist verifisert",
        "inventoryIntegration.syncNow": "Start avstemming",
        "inventoryIntegration.conflicts": "Synkkonflikter",
        "inventoryIntegration.conflict": "Konflikt",
        "inventoryIntegration.review": "Gå gjennom",
        "inventoryIntegration.reviewHint": "Sammenlign bestillingen i begge systemer før du velger hvilken versjon som skal gjelde. Serveren kontrollerer fjernversjonen på nytt.",
        "inventoryIntegration.reason": "Årsak",
        "inventoryIntegration.remoteVersion": "Tripletex-versjon",
        "inventoryIntegration.resolution": "Valg",
        "inventoryIntegration.choose": "Velg handling",
        "inventoryIntegration.keepLocal": "Behold Promang-versjonen",
        "inventoryIntegration.acceptRemote": "Bruk Tripletex-versjonen",
        "inventoryIntegration.applyResolution": "Bekreft valg",
        "inventoryPurchase.conflict": "Innkjøpet er endret et annet sted. Ulagret arbeid er bevart; last inn på nytt og sammenlign før du fortsetter.",
        "inventoryPurchase.unknownSave": "Lagringsresultatet er ukjent. Ulagret arbeid er bevart; kontroller innkjøpet før nytt forsøk.",
        "inventoryPurchase.finishHeaderFirst": "Vent til endringene i innkjøpet er lagret før du endrer produktlinjer.",
        "inventoryPurchase.markSentManually": "Marker sendt manuelt",
        "inventoryPurchase.markingSent": "Markerer som sendt...",
        "inventoryPurchase.markSentFailed": "Kunne ikke markere innkjøpet som sendt.",
        "inventoryPurchase.markConfirmedFailed": "Kunne ikke markere innkjøpet som bekreftet.",
        "inventoryPurchase.markSentSuccess": "Innkjøpet er markert som sendt manuelt.",
        "inventoryPurchase.markConfirmedSuccess": "Innkjøpet er markert som bekreftet.",
        "inventoryPurchase.confirmed": "Bekreftet",
        "inventoryPurchase.goodsReceipt": "Varemottak",
        "inventoryPurchase.tripletexSync": "Tripletex-synk",
        "inventoryPurchase.delivery.not_sent": "Ikke sendt",
        "inventoryPurchase.delivery.queued": "Utsending venter",
        "inventoryPurchase.deliveryQueued": "Utsendingen er lagt i kø. Sjekk status før du regner den som levert.",
        "inventoryPurchase.sendQueueHint": "Utsendingen legges i kø. Levering til leverandøren er først bekreftet når transportstatus viser «levert».",
        "inventoryPurchase.delivery.accepted": "Levering bekreftet av transport",
        "inventoryPurchase.delivery.manual": "Markert sendt manuelt",
        "inventoryPurchase.delivery.unknown": "Ukjent leveringsresultat",
        "inventoryPurchase.delivery.failed": "Utsending feilet",
        "inventoryPurchase.sync.queued": "Venter",
        "inventoryPurchase.sync.not_sent": "Ikke synkronisert",
        "inventoryPurchase.sync.processing": "Synkroniserer",
        "inventoryPurchase.sync.synced": "Synkronisert",
        "inventoryPurchase.sync.unknown": "Ukjent resultat",
        "inventoryPurchase.sync.conflict": "Konflikt",
        "inventoryPurchase.sync.failed": "Feilet",
        "inventoryPurchase.sync.unsupported": "Utilgjengelig",
        "inventoryPurchase.addProducts": "Legg til produktlinjer",
        "inventoryPurchase.addProductsHint": "Søk først i leverandørens produkter. Hvis ingen passer, vises salgsprodukter som knyttes til leverandøren når du lagrer. Velg flere produkter, antall og innkjøpspris her.",
        "supplierProducts.title": "Leverandørprodukter",
        "supplierProducts.description": "Artikkelnummer, varenavn og innkjøpspris hos hver leverandør.",
        "supplierProducts.add": "Knytt til leverandør",
        "supplierProducts.supplier": "Leverandør",
        "supplierProducts.chooseSupplier": "Velg leverandør",
        "supplierProducts.itemNumber": "Leverandørens artikkelnummer",
        "supplierProducts.productTitle": "Leverandørens varenavn",
        "supplierProducts.purchasePrice": "Innkjøpspris",
        "supplierProducts.empty": "Ingen leverandørprodukter er knyttet til dette produktet.",
        "supplierProducts.loadFailed": "Kunne ikke hente leverandørprodukter.",
        "supplierProducts.saveFailed": "Kunne ikke lagre leverandørproduktet.",
        "supplierProducts.linked": "Leverandørprodukt",
        "supplierProducts.willLink": "Salgsprodukt · kobles ved lagring",
        "supplierProducts.salesProduct": "Salgsprodukt",
        "supplierProducts.supplierDescription": "Varer knyttet til denne leverandøren. Åpne salgsproduktet for å endre artikkelnummer, navn og innkjøpspris.",
        "supplierProducts.search": "Søk i leverandørprodukter…",
        "supplierProducts.emptySupplier": "Ingen produkter er knyttet til denne leverandøren ennå.",
        "inventoryPurchase.chooseProducts": "Velg produkter",
        "inventoryPurchase.quantity": "Antall",
        "inventoryPurchase.price": "Kostpris",
        "inventoryPurchase.actions": "Handlinger",
        "inventoryPurchase.remove": "Fjern",
        "inventoryPurchase.noProducts": "Ingen produkter valgt ennå.",
        "inventoryPurchase.close": "Lukk",
        "inventoryPurchase.saving": "Lagrer…",
        "inventoryPurchase.retrySame": "Kontroller resultat med samme nøkkel",
        "inventoryPurchase.addSelected": "Legg til {{count}} linjer",
        "inventoryPurchase.quantityInvalid": "Antall må være større enn null på alle linjer.",
        "inventoryPurchase.addFailed": "Kunne ikke legge til produktlinjer.",
        "inventoryPurchase.unknownAdd": "Resultatet er ukjent. Linjene og operasjonsnøkkelen er bevart. Kontroller med samme nøkkel før du gjør endringer.",
        "inventoryPurchase.linesAdded": "Produktlinjene er lagt til.",
        "inventoryPurchase.title": "Innkjøp",
        "inventoryPurchase.loading": "Laster…",
        "inventoryPurchase.loadError": "Kunne ikke hente innkjøp",
        "inventoryPurchase.notFound": "Innkjøp ikke funnet",
        "inventoryPurchase.back": "Tilbake",
        "inventoryPurchase.purchaseDate": "Innkjøpsdato",
        "inventoryPurchase.deliveryDate": "Leveringsdato",
        "inventoryPurchase.sendDate": "Senddato",
        "inventoryPurchase.reference": "Referanse",
        "inventoryPurchase.removeConfirm": "Er du sikker på at du vil fjerne denne linjen?",
        "inventoryPurchase.lineRemoved": "Linje fjernet",
        "inventoryPurchase.removeFailed": "Kunne ikke fjerne linje",
        "inventoryPurchase.markingConfirmed": "Markerer som bekreftet…",
        "inventoryPurchase.status.draft": "Utkast",
        "inventoryPurchase.status.sent": "Sendt",
        "inventoryPurchase.status.confirmed": "Bekreftet",
        "inventoryPurchase.status.received": "Mottatt",
        "inventoryPurchase.status.cancelled": "Kansellert",
        "inventoryValuation.title": "Lagerverdi",
        "inventoryOpening.title": "Inngående lagerbalanse",
        "inventoryOpening.emptyCounts": "Godkjente fulltellinger inneholder ingen produkter. En nullåpning er gyldig når alle lagre og tellinger er bekreftet.",
        "inventoryOpening.countDayOpen": "Telledagen er ikke avsluttet i Europe/Oslo. Vent til neste dag før inngående balanse godkjennes.",
        "inventoryOpening.allStorages": "Alle lagre som krever full telling",
        "inventoryOpening.inactive": "Inaktivt",
        "inventoryOpening.hint": "Godkjenn en full telling fra dagen før for hvert lager før lagerverdien kan regnes som komplett.",
        "inventoryOpening.approved": "Inngående lagerbalanse er godkjent fra {{date}}.",
        "inventoryOpening.open": "Klargjør inngående balanse",
        "inventoryOpening.irreversible": "Dette posterer inngående lagerbeholdning og kan ikke endres etter godkjenning. Kontroller telling, kostpris og dokumentasjon nøye.",
        "inventoryOpening.effectiveDate": "Gjelder fra dato",
        "inventoryOpening.method": "Kostmetode",
        "inventoryOpening.chooseMethod": "Velg kostmetode",
        "inventoryOpening.weightedAverage": "Vektet gjennomsnitt",
        "inventoryOpening.loading": "Kontrollerer godkjente tellinger…",
        "inventoryOpening.previewFailed": "Kunne ikke hente tellinger for valgt dato.",
        "inventoryOpening.countDate": "Telling må være full og godkjent {{date}}",
        "inventoryOpening.rows": "{{count}} tellelinjer",
        "inventoryOpening.missingStorages": "Mangler godkjent full telling for lager",
        "inventoryOpening.legacyPartialUsed": "Minst én godkjent telling var lagret som delvis (eldre standard). Den brukes som lagerets telling for denne datoen.",
        "inventoryOpening.latestApproved": "Siste godkjente telling for {{storage}} er {{date}} ({{coverage}}). Sett «Gjelder fra» til dagen etter telledatoen.",
        "inventoryOpening.coverageFull": "full",
        "inventoryOpening.coveragePartial": "delvis",
        "inventoryOpening.invalidCounts": "Tellinger har ikke alle linjer godkjent",
        "inventoryOpening.duplicateProducts": "Samme produkt finnes flere ganger i ett lager. Rett tellingen først.",
        "inventoryOpening.unknownCosts": "{{count}} linjer mangler kostpris. Verdien blir ufullstendig til kostgrunnlag er dokumentert.",
        "inventoryOpening.quantity": "Antall",
        "inventoryOpening.costStatus": "Koststatus",
        "inventoryOpening.unitCost": "Enhetskost (NOK)",
        "inventoryOpening.evidence": "Kostgrunnlag / referanse",
        "inventoryOpening.known": "Dokumentert",
        "inventoryOpening.certify": "Jeg bekrefter at alle lagre er talt fullt dagen før, og at hver linje og kostgrunnlag er kontrollert.",
        "inventoryOpening.costEvidenceRequired": "Alle verdsatte linjer med antall over null trenger gyldig enhetskost og dokumentasjon.",
        "inventoryOpening.approveFailed": "Kunne ikke godkjenne inngående lagerbalanse.",
        "inventoryOpening.unknownOutcome": "Resultatet er ukjent. Kontroller status før du forsøker på nytt.",
        "inventoryOpening.checkStatus": "Kontroller status",
        "inventoryOpening.approve": "Godkjenn inngående balanse",
        "inventoryValuation.currentPeriod": "Denne måneden",
        "inventoryValuation.openReport": "Åpne rapport",
        "inventoryValuation.totalValue": "Total lagerverdi",
        "inventoryValuation.unvaluedQuantity": "Antall uten kostpris",
        "inventoryValuation.valuedSubtotal": "Verdsatt delsum",
        "inventoryValuation.openingMissing": "Inngående lagerbalanse og kostmetode er ikke godkjent. Lagerverdien er foreløpig ufullstendig.",
        "inventoryReceipt.postedImmutable": "Postert varemottak kan ikke endres. Bruk en dokumentert korreksjon.",
        "inventoryReceipt.storageLoadFailed": "Kunne ikke hente lagre. Prøv igjen før du lagrer varemottaket.",
        "inventoryReceipt.saveFailed": "Kunne ikke lagre varemottaket.",
        "inventoryReceipt.unknownOutcome": "Resultatet er ukjent. Kontroller mottaket med samme operasjonsnøkkel før du gjør endringer.",
        "inventoryReceipt.remaining": "Gjenstår",
        "inventoryReceipt.receiveRemaining": "Motta rest",
        "inventoryReceipt.saving": "Lagrer…",
        "inventoryReceipt.retrySame": "Kontroller resultat med samme nøkkel",
        "inventoryReceipt.quantityInvalid": "Antall må være 0 eller et positivt tall med høyst fire desimaler.",
        "inventoryReceipt.addProduct": "Legg til minst én mottakslinje før du lagrer.",
        "inventoryCost.title": "Kostkorrigeringer",
        "inventoryCost.hint": "Dokumenter etterfølgende leverandørfaktura mot et postert varemottak. Lagerverdien beregnes på nytt uten å endre innkjøpsordren.",
        "inventoryCost.new": "Ny kostkorrigering",
        "inventoryCost.loading": "Henter kostdata…",
        "inventoryCost.historyFailed": "Kunne ikke hente kostkorrigeringer.",
        "inventoryCost.empty": "Ingen kostkorrigeringer registrert.",
        "inventoryCost.receipt": "Varemottak",
        "inventoryCost.invoice": "Leverandørfaktura",
        "inventoryCost.unitCost": "Ny enhetskost",
        "inventoryCost.approved": "Godkjent",
        "inventoryCost.formHint": "Velg et postert varemottak og legg inn dokumentert kost fra leverandørfaktura. Dette kan ikke angres ved å redigere innkjøpsordren.",
        "inventoryCost.searchReceipt": "Søk etter varemottak",
        "inventoryCost.searchPlaceholder": "Produkt, varenummer eller mottaksnummer",
        "inventoryCost.receiptsFailed": "Kunne ikke hente varemottak. Prøv søket igjen.",
        "inventoryCost.openingRequired": "Godkjenn inngående lagerbalanse før kostkorrigering kan registreres.",
        "inventoryCost.noReceipts": "Ingen posterte varemottak funnet.",
        "inventoryCost.product": "Produkt",
        "inventoryCost.quantity": "Antall",
        "inventoryCost.previous": "Forrige",
        "inventoryCost.next": "Neste",
        "inventoryCost.selected": "Valgt mottaksbevegelse #{{id}}",
        "inventoryCost.evidence": "Begrunnelse og dokumentasjon",
        "inventoryCost.error.invalid": "Kontroller mottak, beløp, fakturareferanse og dokumentasjon. Ingen korrigering ble registrert.",
        "inventoryCost.error.forbidden": "Du har ikke lenger tilgang til å registrere kostkorrigering.",
        "inventoryCost.error.noRemaining": "Mottaket er helt forbrukt. Fakturaavviket må håndteres regnskapsmessig; det kan ikke legges til gjenværende lagerverdi.",
        "inventoryCost.error.unknown": "Resultatet er ukjent. Kontroller med samme operasjonsnøkkel; feltene er låst for å unngå duplikater.",
        "inventoryCost.error.conflict": "Konflikt ved lagring. Kontroller korrigeringen før du fortsetter.",
        "inventoryCost.startNewAfterConflict": "Avslutt konflikten og start nytt forsøk",
        "inventoryCost.saved": "Kostkorrigeringen er godkjent.",
        "inventoryCost.impact": "Effekt på gjenværende lagerverdi",
        "inventoryCost.impactUnknown": "Ukjent fordi tidligere kost manglet",
        "inventoryCost.close": "Lukk",
        "inventoryCost.saving": "Lagrer…",
        "inventoryCost.retry": "Kontroller med samme nøkkel",
        "inventoryCost.save": "Godkjenn korrigering",
        "inventoryValuation.eyebrow": "Lager og regnskap",
        "inventoryValuation.hint": "Beholdning og anskaffelsesverdi for valgt periode, beregnet fra posteringer.",
        "inventoryValuation.now": "Nå",
        "inventoryValuation.refresh": "Oppdater",
        "inventoryValuation.export": "Eksporter",
        "inventoryValuation.printPdf": "Skriv ut PDF",
        "inventoryValuation.printing": "Lager PDF…",
        "inventoryValuation.printFailed": "Kunne ikke lage PDF. Prøv igjen.",
        "inventoryValuation.exporting": "Eksporterer…",
        "inventoryValuation.download": "Last ned CSV",
        "inventoryValuation.checkExport": "Kontroller eksport",
        "inventoryValuation.retryExport": "Kontroller med samme nøkkel",
        "inventoryValuation.exportUnknown": "Eksportresultatet er ukjent. Kontroller med samme operasjonsnøkkel.",
        "inventoryValuation.exportQueued": "Eksporten behandles. Kontroller status før nedlasting.",
        "inventoryValuation.exportStatus.queued": "Eksporten venter på behandling.",
        "inventoryValuation.exportStatus.processing": "Eksporten behandles.",
        "inventoryValuation.exportStatus.completed": "Eksporten er klar til nedlasting.",
        "inventoryValuation.exportStatus.failed": "Eksporten feilet. Kontroller status før nytt forsøk.",
        "inventoryValuation.exportStatus.unknown": "Resultatet er ukjent. Kontroller med samme nøkkel.",
        "inventoryValuation.search": "Søk etter produkt eller nummer",
        "inventoryValuation.storage": "Lager",
        "inventoryValuation.forbidden": "Du har ikke tilgang til lagerverdi.",
        "inventoryValuation.loadFailed": "Kunne ikke hente lagerverdi. Prøv igjen.",
        "inventoryValuation.incomplete": "Historikken er ikke komplett for denne perioden. Tidligste pålitelige dato: {{date}}.",
        "inventoryValuation.opening": "Inngående verdi",
        "inventoryValuation.incoming": "Inn, inkl. flytting",
        "inventoryValuation.outgoing": "Ut, inkl. flytting",
        "inventoryValuation.closing": "Utgående verdi",
        "inventoryValuation.method": "Kostmetode",
        "inventoryValuation.unvalued": "Antall uten kostpris",
        "inventoryValuation.asOf": "Beregnet",
        "inventoryValuation.rows": "Vareliste for lagerverdi",
        "inventoryValuation.loading": "Henter lagerverdi…",
        "inventoryValuation.product": "Produkt",
        "inventoryValuation.openingQuantity": "Inngående antall",
        "inventoryValuation.receivedQuantity": "Mottatt",
        "inventoryValuation.issuedQuantity": "Tatt ut",
        "inventoryValuation.closingQuantity": "Utgående antall",
        "inventoryValuation.missingCost": "Mangler kostpris",
        "inventoryValuation.incompleteAmount": "Ikke beregnet",
        "inventoryValuation.estimated": "Estimert",
        "inventoryValuation.empty": "Ingen varer for valgt periode og filter.",
        "inventoryValuation.movements": "Bevegelser",
        "inventoryValuation.movementsFailed": "Kunne ikke hente bevegelser.",
        "inventoryValuation.clearFilters": "Fjern filtre",
        "inventoryValuation.estimatesWarning": "{{count}} lagerrader har estimert kost ({{opening}} fra inngående balanse, {{period}} fra perioden). Beløpene er foreløpige; avvik mot regnskap vises ikke som endelig.",
        "inventoryValuation.movementsShown": "Viser {{shown}} av {{total}} bevegelser",
        "inventoryValuation.loadMoreMovements": "Vis flere bevegelser",
        "inventoryValuation.movement": "Bevegelse",
        "inventoryValuation.openSource": "Åpne kilde",
        "inventoryValuation.noMovements": "Ingen bevegelser i valgt periode.",
        "dashboardDesign.writeUpdate": "Skriv en oppdatering",
        "dashboardDesign.updatePrompt": "Hva skjer? Bruk @ for å nevne, / for å lenke en modul",
        "dashboardDesign.mentionEmployee": "Nevn en ansatt",
        "dashboardDesign.dayOverview": "Dagens oversikt",
        "dashboardDesign.dayTasks": "Alle oppgaver for dagen",
        "dashboardDesign.agendaDescription": "Arbeidsordre, aktiviteter, prosjekter og avtaler i en samlet liste.",
        "dashboardDesign.calendarHint": "Kalenderen kan fortsatt brukes for full oversikt og planlegging.",
        "dashboardDesign.viewCalendar": "Se kalender",
        "dashboardDesign.timeRegistration": "Timeregistrering",
        "dashboardDesign.hoursHint": "Registrer og juster timer for dagens arbeid.",
        "dashboardDesign.openHours": "Åpne timeregistrering",
        "dashboardDesign.registeredDay": "Registrert på valgt dag",
        "dashboardDesign.emptyHours": "Ingen timer registrert ennå.",
        "dashboardDesign.noProject": "Uten prosjekt",
        "dashboardDesign.handbook": "Personalhåndbok",
        "dashboardDesign.handbookHint": "Direkte tilgang til håndbok, kollegaer og registrering av hendelser.",
        "dashboardDesign.openHandbook": "Gå til håndbok",
        "dashboardDesign.handbookDetails": "Rutiner, dokumentasjon og felles praksis.",
        "dashboardDesign.colleagues": "Kollegaer",
        "dashboardDesign.colleagueDetails": "Finn ansatte og intern kontaktinformasjon.",
        "dashboardDesign.tools": "Verktøy",
        "dashboardDesign.toolsDetails": "Se verktøy som er tildelt deg.",
        "dashboardDesign.incident": "Registrer hendelse",
        "dashboardDesign.incidentDetails": "Opprett HMS-hendelse eller avvik.",
        "dashboardDesign.driving": "Kjørebok",
        "dashboardDesign.drivingHint": "Status på innkjørt kjøretøy og hurtigtilgang til kjøretøyvalg.",
        "dashboardDesign.adminHint": "Snarvei til de viktigste administrative oppgavene.",
        "dashboardDesign.employees": "Ansatte",
        "dashboardDesign.employeesHint": "Administrer brukere, roller og tilgang.",
        "dashboardDesign.loadingVehicle": "Laster kjøretøy",
        "dashboardDesign.noVehicle": "Ingen bil valgt",
        "dashboardDesign.noDriver": "Ikke registrert som sjåfør",
        "dashboardDesign.selectVehicle": "Åpne kjørebok og velg bil",
        "dashboardDesign.noDriverProfile": "Ingen førerprofil tilgjengelig",
        "dashboardDesign.dayAssignments": "Dagens oppdrag",
        "dashboardDesign.daySummary": "{{count}} oppdrag · {{hours}} t planlagt",
        "dashboardDesign.hourLines": "{{count}} linjer",
        "dashboardDesign.distanceToday": "{{distance}} km kjørt i dag",
        "dashboardDesign.title": "Dashboard",
        "dashboardDesign.subtitleAdmin": "Oversikt over dagens oppdrag, oppgaver som krever handling og økonomi.",
        "dashboardDesign.subtitlePersonal": "Dine oppdrag, timer og oppgaver for dagen.",
        "dashboardDesign.registerHours": "Registrer timer",
        "dashboardDesign.newWorkOrder": "Ny arbeidsordre",
        "dashboardDesign.newIncident": "Registrer hendelse",
        "dashboardDesign.keyFigures": "Dagens nøkkeltall",
        "dashboardDesign.assignments": "Dine oppdrag",
        "dashboardDesign.plannedHours": "{{hours}} t planlagt",
        "dashboardDesign.service": "Service",
        "dashboardDesign.workOrders": "Arbeidsordre",
        "dashboardDesign.hours": "Timer",
        "dashboardDesign.yourDay": "Dine oppdrag på valgt dag",
        "dashboardDesign.yourHours": "Dine registrerte timer",
        "dashboardDesign.setup": "Fullfør oppsettet",
        "dashboardDesign.setupCount": "{{areas}} områder trenger oppmerksomhet · {{count}} punkter",
        "dashboardDesign.hide": "Skjul",
        "dashboardDesign.showAll": "Vis alle",
        "dashboardDesign.filterDay": "Filtrer dagens oppdrag",
        "dashboardDesign.all": "Alle",
        "dashboardDesign.date": "Velg dato",
        "dashboardDesign.eventsError": "Kunne ikke hente oppdragene.",
        "dashboardDesign.hoursError": "Kunne ikke hente timene.",
        "dashboardDesign.retry": "Prøv igjen",
        "dashboardDesign.loading": "Laster…",
        "dashboardDesign.noEvents": "Ingen oppdrag registrert denne dagen",
        "dashboardDesign.noFilterEvents": "Ingen oppdrag passer filteret",
        "dashboardDesign.weekHours": "Dine timer denne uken",
        "dashboardDesign.weekTotal": "{{hours}} t registrert denne uken",
        "dashboardDesign.admin": "Administrasjon",
        "dashboardDesign.theme": "Utseende",
        "dashboardDesign.light": "Lyst tema",
        "dashboardDesign.dark": "Mørkt tema",
        "dashboardDesign.visibleTo": "Synlig for: {{audience}}",
        "dashboardDesign.attention": "Krever handling",
        "dashboardDesign.statsError": "Kunne ikke hente oppfølgingspunktene.",
        "dashboardDesign.economy": "Økonomi",
        "dashboardDesign.details": "Se detaljer",
        "recipients.label": "E-postadresse",
        "recipients.count": "{{count}} mottakere",
        "recipients.me": "Meg",
        "recipients.channel.private_email": "Privat e-post",
        "recipients.channel.work_email": "Jobb-e-post",
        "recipients.group.customer": "Kundens kontakter",
        "recipients.group.team": "Kontakt hos oss",
        "recipients.group.other": "Andre kontakter",
        "recipients.placeholder": "Søk etter kontakt eller skriv e-postadresse",
        "recipients.placeholderMore": "navn@eksempel.no",
        "recipients.manual": "Manuell",
        "recipients.remove": "Fjern {{email}}",
        "recipients.showContacts": "Vis kontakter",
        "recipients.add": "Legg til {{email}}",
        "recipients.help": "Velg fra listen, eller skriv en adresse og trykk Enter. Skill flere med komma.",
        "recipients.singleHelp": "Velg fra listen, eller skriv en adresse og trykk Enter. Denne sendingen har én mottaker.",
        "recipients.singleOnly": "Velg én e-postadresse for denne sendingen.",
        "recipients.extraLimit": "Du kan velge flere prosjektkontakter og én annen eller manuell adresse.",
        "recipients.invalid": "Kontroller adressen: {{value}}",
        "recipients.finishInput": "Velg en kontakt, eller fullfør adressen med Enter før du sender.",
        "recipients.loading": "Henter kontakter…",
        "recipients.loadFailed": "Noen kontakter kunne ikke hentes. Du kan fortsatt skrive en adresse manuelt.",
        "recipients.retry": "Prøv igjen",
        "recipients.empty": "Ingen kontakter funnet. Skriv en fullstendig e-postadresse for å legge til manuelt.",
        "recipients.moreResults": "Viser inntil 30 treff per gruppe. Søk for å finne flere.",
        "recipients.keyMove": "↑↓ naviger",
        "recipients.keySelect": "Enter velg / legg til",
        "recipients.keyClose": "Esc lukk",

        "hse.sja.fields.required": "Fyll ut dette feltet.",
        "hse.sja.fields.choose_score": "Velg verdi (1–5)",
        "hse.sja.fields.hazard": "Fare",
        "hse.sja.fields.add_hazard": "Legg til fare",
        "hse.sja.fields.remove_hazard": "Fjern fare",
        "hse.sja.fields.remove_step": "Fjern arbeidssteg",
        "hse.sja.fields.existing_measures": "Eksisterende tiltak",
        "hse.sja.fields.additional_measures": "Ytterligere tiltak",
        "hse.sja.fields.score": "Risiko: {{likelihood}} × {{consequence}} = {{score}}",
        "hse.sja.fields.fix_errors": "Kontroller de markerte feltene før lagring.",
        "hse.sja.fields.save_unknown": "Lagringen kunne ikke bekreftes. Behold denne siden og kontroller SJA-listen i en ny fane før du prøver igjen.",

        "deviation.health.title": "Avviksvarsling – leveringsstatus",
        "deviation.health.trigger": "Innstillingen velger utsendelsesmåte. Åpne et avvik, velg Send varsel og mottakere for å starte utsending. Nye avvik sendes ikke automatisk.",
        "deviation.health.unverified": "Oppsettet er kontrollert uten å sende e-post. Levering til mottaker og drift av den planlagte jobben er ikke bekreftet.",
        "deviation.health.mail_unconfigured": "E-postutsending er deaktivert eller mangler en konfigurert e-postforbindelse. Be administrator kontrollere firmaets e-postforbindelse og serverens e-postoppsett.",
        "deviation.health.digest_overdue": "Samleposter venter mer enn to timer etter planlagt sending. Be driftsansvarlig kontrollere planlagt jobb og køarbeider.",
        "deviation.health.digest_failed": "En eller flere samleposter har feilet. Kontroller sendeloggen på avviket og e-postforbindelsen før nytt forsøk.",
        "deviation.health.digest_inactive": "Det finnes ventende samleposter, men samlepost er ikke valgt lenger. Disse sendes ikke automatisk som enkeltmeldinger.",
        "deviation.health.digest_scheduler": "Samlepost krever at driftsansvarlig setter opp deviations:daily_digest hver time og en aktiv køarbeider for mailers. Denne siden kan ikke bekrefte at jobben kjører.",
        "deviation.health.counts": "Samlepost: {{pending}} venter · {{overdue}} forsinket · {{failed}} feilet",

        "trainingAdmin.healthTitle": trainingAdminTranslations.no["trainingAdmin.healthTitle"],
        "trainingAdmin.healthNeedsFix": trainingAdminTranslations.no["trainingAdmin.healthNeedsFix"],
        "trainingAdmin.healthSummary": trainingAdminTranslations.no["trainingAdmin.healthSummary"],
        "trainingAdmin.healthSummaryHint": trainingAdminTranslations.no["trainingAdmin.healthSummaryHint"],
        "trainingAdmin.healthShow": trainingAdminTranslations.no["trainingAdmin.healthShow"],
        "trainingAdmin.healthBlocked": trainingAdminTranslations.no["trainingAdmin.healthBlocked"],
        "trainingAdmin.healthDetails": trainingAdminTranslations.no["trainingAdmin.healthDetails"],
        "trainingAdmin.healthHelp": trainingAdminTranslations.no["trainingAdmin.healthHelp"],
        "trainingAdmin.healthChecking": trainingAdminTranslations.no["trainingAdmin.healthChecking"],
        "trainingAdmin.healthClear": trainingAdminTranslations.no["trainingAdmin.healthClear"],
        "trainingAdmin.healthProblem": trainingAdminTranslations.no["trainingAdmin.healthProblem"],
        "trainingAdmin.healthDocument": trainingAdminTranslations.no["trainingAdmin.healthDocument"],
        "trainingAdmin.healthImage": trainingAdminTranslations.no["trainingAdmin.healthImage"],
        "trainingAdmin.healthRecheck": trainingAdminTranslations.no["trainingAdmin.healthRecheck"],
        "trainingParticipant.dependencyTitle": trainingParticipantNo["trainingParticipant.dependencyTitle"],
        "trainingParticipant.dependencyHelp": trainingParticipantNo["trainingParticipant.dependencyHelp"],
        "trainingParticipant.dependencyOwner": trainingParticipantNo["trainingParticipant.dependencyOwner"],
        "trainingAdmin.jsonTools": trainingAdminTranslations.no["trainingAdmin.jsonTools"],
        "trainingAdmin.jsonContent": trainingAdminTranslations.no["trainingAdmin.jsonContent"],
        "trainingAdmin.jsonAi": trainingAdminTranslations.no["trainingAdmin.jsonAi"],
        "trainingAdmin.jsonScope": trainingAdminTranslations.no["trainingAdmin.jsonScope"],
        "trainingAdmin.jsonCopy": trainingAdminTranslations.no["trainingAdmin.jsonCopy"],
        "trainingAdmin.jsonReload": trainingAdminTranslations.no["trainingAdmin.jsonReload"],
        "trainingAdmin.jsonExample": trainingAdminTranslations.no["trainingAdmin.jsonExample"],
        "trainingAdmin.jsonImport": trainingAdminTranslations.no["trainingAdmin.jsonImport"],
        "trainingAdmin.jsonReplace": trainingAdminTranslations.no["trainingAdmin.jsonReplace"],
        "trainingAdmin.jsonAppend": trainingAdminTranslations.no["trainingAdmin.jsonAppend"],
        "trainingAdmin.jsonReplaceHint": trainingAdminTranslations.no["trainingAdmin.jsonReplaceHint"],
        "trainingAdmin.jsonAppendHint": trainingAdminTranslations.no["trainingAdmin.jsonAppendHint"],
        "trainingAdmin.jsonReview": trainingAdminTranslations.no["trainingAdmin.jsonReview"],
        "trainingAdmin.jsonReviewSummary": trainingAdminTranslations.no["trainingAdmin.jsonReviewSummary"],
        "trainingAdmin.jsonReferences": trainingAdminTranslations.no["trainingAdmin.jsonReferences"],
        "trainingAdmin.jsonApply": trainingAdminTranslations.no["trainingAdmin.jsonApply"],
        "trainingAdmin.jsonApplied": trainingAdminTranslations.no["trainingAdmin.jsonApplied"],
        "trainingAdmin.jsonReadOnly": trainingAdminTranslations.no["trainingAdmin.jsonReadOnly"],
        "trainingAdmin.jsonAiHint": trainingAdminTranslations.no["trainingAdmin.jsonAiHint"],
        "trainingAdmin.jsonCopyAi": trainingAdminTranslations.no["trainingAdmin.jsonCopyAi"],
        "trainingAdmin.jsonCopied": trainingAdminTranslations.no["trainingAdmin.jsonCopied"],
        "trainingAdmin.jsonClipboardFailed": trainingAdminTranslations.no["trainingAdmin.jsonClipboardFailed"],
        "trainingAdmin.jsonInvalid": trainingAdminTranslations.no["trainingAdmin.jsonInvalid"],
        "trainingAdmin.jsonUnsupported": trainingAdminTranslations.no["trainingAdmin.jsonUnsupported"],
        "trainingAdmin.jsonSize": trainingAdminTranslations.no["trainingAdmin.jsonSize"],
        "trainingAdmin.jsonIdentity": trainingAdminTranslations.no["trainingAdmin.jsonIdentity"],
        "trainingAdmin.jsonAnswers": trainingAdminTranslations.no["trainingAdmin.jsonAnswers"],
        "trainingAdmin.jsonDependency": trainingAdminTranslations.no["trainingAdmin.jsonDependency"],
        "trainingAdmin.jsonReference": trainingAdminTranslations.no["trainingAdmin.jsonReference"],
        "trainingAdmin.jsonAudienceInvalid": trainingAdminTranslations.no["trainingAdmin.jsonAudienceInvalid"],
        "trainingAdmin.jsonPositionsFailed": trainingAdminTranslations.no["trainingAdmin.jsonPositionsFailed"],
        "trainingAdmin.jsonPositionsLoading": trainingAdminTranslations.no["trainingAdmin.jsonPositionsLoading"],
        "trainingAdmin.jsonPositionsIncluded": trainingAdminTranslations.no["trainingAdmin.jsonPositionsIncluded"],
        "trainingAdmin.jsonDocumentsLoading": trainingAdminTranslations.no["trainingAdmin.jsonDocumentsLoading"],
        "trainingAdmin.jsonDocumentsFailed": trainingAdminTranslations.no["trainingAdmin.jsonDocumentsFailed"],
        "trainingAdmin.jsonDocumentsIncluded": trainingAdminTranslations.no["trainingAdmin.jsonDocumentsIncluded"],
        "trainingAdmin.jsonDocumentsEmpty": trainingAdminTranslations.no["trainingAdmin.jsonDocumentsEmpty"],
        "trainingAdmin.jsonIncludeExcerpts": trainingAdminTranslations.no["trainingAdmin.jsonIncludeExcerpts"],
        "trainingAdmin.jsonIncludeExcerptsHelp": trainingAdminTranslations.no["trainingAdmin.jsonIncludeExcerptsHelp"],
        "trainingAdmin.jsonDocumentUnknown": trainingAdminTranslations.no["trainingAdmin.jsonDocumentUnknown"],
        "trainingAdmin.documentAccessHint": trainingAdminTranslations.no["trainingAdmin.documentAccessHint"],
        "trainingAdmin.jsonPositionsEmpty": trainingAdminTranslations.no["trainingAdmin.jsonPositionsEmpty"],
        "trainingAdmin.jsonAudienceChanges": trainingAdminTranslations.no["trainingAdmin.jsonAudienceChanges"],
        "trainingAdmin.jsonAudienceUnchanged": trainingAdminTranslations.no["trainingAdmin.jsonAudienceUnchanged"],
        "trainingAdmin.deliveries": trainingAdminTranslations.no["trainingAdmin.deliveries"],
        "trainingAdmin.deliveryPending": trainingAdminTranslations.no["trainingAdmin.deliveryPending"],
        "trainingAdmin.deliverySending": trainingAdminTranslations.no["trainingAdmin.deliverySending"],
        "trainingAdmin.deliverySent": trainingAdminTranslations.no["trainingAdmin.deliverySent"],
        "trainingAdmin.deliveryFailed": trainingAdminTranslations.no["trainingAdmin.deliveryFailed"],
        "trainingAdmin.deliveryUnknown": trainingAdminTranslations.no["trainingAdmin.deliveryUnknown"],
        "trainingAdmin.deliveryCancelled": trainingAdminTranslations.no["trainingAdmin.deliveryCancelled"],
        "trainingAdmin.deliveryDigest": trainingAdminTranslations.no["trainingAdmin.deliveryDigest"],
        "trainingAdmin.recipient": trainingAdminTranslations.no["trainingAdmin.recipient"],
        "trainingAdmin.scheduledAt": trainingAdminTranslations.no["trainingAdmin.scheduledAt"],
        "trainingAdmin.sentAt": trainingAdminTranslations.no["trainingAdmin.sentAt"],
        "trainingAdmin.deliveryPolicy": trainingAdminTranslations.no["trainingAdmin.deliveryPolicy"],
        "trainingAdmin.deliveryNoRetry": trainingAdminTranslations.no["trainingAdmin.deliveryNoRetry"],
        "trainingAdmin.deliveryFailureHint": trainingAdminTranslations.no["trainingAdmin.deliveryFailureHint"],

        "trainingAdmin.dueBefore": trainingAdminTranslations.no["trainingAdmin.dueBefore"],
        "trainingAdmin.archive": trainingAdminTranslations.no["trainingAdmin.archive"],
        "trainingAdmin.archived": trainingAdminTranslations.no["trainingAdmin.archived"],
        "trainingAdmin.archiveInfo": trainingAdminTranslations.no["trainingAdmin.archiveInfo"],
        "trainingParticipant.reminders": trainingParticipantNo["trainingParticipant.reminders"],
        "trainingParticipant.reminderCount": trainingParticipantNo["trainingParticipant.reminderCount"],
        "trainingParticipant.snoozeReminders": trainingParticipantNo["trainingParticipant.snoozeReminders"],

        "trainingAdmin.receipt": trainingAdminTranslations.no["trainingAdmin.receipt"],
        "trainingAdmin.receiptKind": trainingAdminTranslations.no["trainingAdmin.receiptKind"],
        "trainingAdmin.cardKey": trainingAdminTranslations.no["trainingAdmin.cardKey"],
        "trainingAdmin.sourceRevision": trainingAdminTranslations.no["trainingAdmin.sourceRevision"],
        "trainingAdmin.acknowledged": trainingAdminTranslations.no["trainingAdmin.acknowledged"],
        "trainingAdmin.createdEvent": trainingAdminTranslations.no["trainingAdmin.createdEvent"],
        "trainingAdmin.savedEvent": trainingAdminTranslations.no["trainingAdmin.savedEvent"],
        "trainingAdmin.copiedEvent": trainingAdminTranslations.no["trainingAdmin.copiedEvent"],
        "trainingAdmin.publishedEvent": trainingAdminTranslations.no["trainingAdmin.publishedEvent"],
        "trainingAdmin.assignedEvent": trainingAdminTranslations.no["trainingAdmin.assignedEvent"],
        "trainingAdmin.startedEvent": trainingAdminTranslations.no["trainingAdmin.startedEvent"],
        "trainingAdmin.answeredEvent": trainingAdminTranslations.no["trainingAdmin.answeredEvent"],
        "trainingAdmin.documentOpenedEvent": trainingAdminTranslations.no["trainingAdmin.documentOpenedEvent"],
        "trainingAdmin.completedEvent": trainingAdminTranslations.no["trainingAdmin.completedEvent"],
        "trainingAdmin.extendedEvent": trainingAdminTranslations.no["trainingAdmin.extendedEvent"],
        "trainingAdmin.archivedEvent": trainingAdminTranslations.no["trainingAdmin.archivedEvent"],

        "trainingAdmin.title": trainingAdminTranslations.no["trainingAdmin.title"],
        "trainingAdmin.intro": trainingAdminTranslations.no["trainingAdmin.intro"],
        "trainingAdmin.guides": trainingAdminTranslations.no["trainingAdmin.guides"],
        "trainingAdmin.reports": trainingAdminTranslations.no["trainingAdmin.reports"],
        "trainingAdmin.audit": trainingAdminTranslations.no["trainingAdmin.audit"],
        "trainingAdmin.newGuide": trainingAdminTranslations.no["trainingAdmin.newGuide"],
        "trainingAdmin.edit": trainingAdminTranslations.no["trainingAdmin.edit"],
        "trainingAdmin.revise": trainingAdminTranslations.no["trainingAdmin.revise"],
        "trainingAdmin.copy": trainingAdminTranslations.no["trainingAdmin.copy"],
        "trainingAdmin.deactivate": trainingAdminTranslations.no["trainingAdmin.deactivate"],
        "trainingAdmin.reactivate": trainingAdminTranslations.no["trainingAdmin.reactivate"],
        "trainingAdmin.deactivateInfo": trainingAdminTranslations.no["trainingAdmin.deactivateInfo"],
        "trainingAdmin.reactivateInfo": trainingAdminTranslations.no["trainingAdmin.reactivateInfo"],
        "trainingAdmin.copyInfo": trainingAdminTranslations.no["trainingAdmin.copyInfo"],
        "trainingAdmin.saved": trainingAdminTranslations.no["trainingAdmin.saved"],
        "trainingAdmin.published": trainingAdminTranslations.no["trainingAdmin.published"],
        "trainingAdmin.updated": trainingAdminTranslations.no["trainingAdmin.updated"],
        "trainingAdmin.saving": trainingAdminTranslations.no["trainingAdmin.saving"],
        "trainingAdmin.loadError": trainingAdminTranslations.no["trainingAdmin.loadError"],
        "trainingAdmin.reload": trainingAdminTranslations.no["trainingAdmin.reload"],
        "trainingAdmin.refreshWarning": trainingAdminTranslations.no["trainingAdmin.refreshWarning"],
        "trainingAdmin.unknown": trainingAdminTranslations.no["trainingAdmin.unknown"],
        "trainingAdmin.checkStatus": trainingAdminTranslations.no["trainingAdmin.checkStatus"],
        "trainingAdmin.conflict": trainingAdminTranslations.no["trainingAdmin.conflict"],
        "trainingAdmin.loadServer": trainingAdminTranslations.no["trainingAdmin.loadServer"],
        "trainingAdmin.useServer": trainingAdminTranslations.no["trainingAdmin.useServer"],
        "trainingAdmin.serverVersion": trainingAdminTranslations.no["trainingAdmin.serverVersion"],
        "trainingAdmin.unsaved": trainingAdminTranslations.no["trainingAdmin.unsaved"],
        "trainingAdmin.discard": trainingAdminTranslations.no["trainingAdmin.discard"],
        "trainingAdmin.keepEditing": trainingAdminTranslations.no["trainingAdmin.keepEditing"],
        "trainingAdmin.leaveQuestion": trainingAdminTranslations.no["trainingAdmin.leaveQuestion"],
        "trainingAdmin.saveDraft": trainingAdminTranslations.no["trainingAdmin.saveDraft"],
        "trainingAdmin.publish": trainingAdminTranslations.no["trainingAdmin.publish"],
        "trainingAdmin.publishConfirm": trainingAdminTranslations.no["trainingAdmin.publishConfirm"],
        "trainingAdmin.publishInfo": trainingAdminTranslations.no["trainingAdmin.publishInfo"],
        "trainingAdmin.about": trainingAdminTranslations.no["trainingAdmin.about"],
        "trainingAdmin.content": trainingAdminTranslations.no["trainingAdmin.content"],
        "trainingAdmin.audience": trainingAdminTranslations.no["trainingAdmin.audience"],
        "trainingAdmin.followup": trainingAdminTranslations.no["trainingAdmin.followup"],
        "trainingAdmin.review": trainingAdminTranslations.no["trainingAdmin.review"],
        "trainingAdmin.name": trainingAdminTranslations.no["trainingAdmin.name"],
        "trainingAdmin.purpose": trainingAdminTranslations.no["trainingAdmin.purpose"],
        "trainingAdmin.minutes": trainingAdminTranslations.no["trainingAdmin.minutes"],
        "trainingAdmin.owner": trainingAdminTranslations.no["trainingAdmin.owner"],
        "trainingAdmin.selectOwner": trainingAdminTranslations.no["trainingAdmin.selectOwner"],
        "trainingAdmin.revision": trainingAdminTranslations.no["trainingAdmin.revision"],
        "trainingAdmin.changeNote": trainingAdminTranslations.no["trainingAdmin.changeNote"],
        "trainingAdmin.addPage": trainingAdminTranslations.no["trainingAdmin.addPage"],
        "trainingAdmin.page": trainingAdminTranslations.no["trainingAdmin.page"],
        "trainingAdmin.pageTitle": trainingAdminTranslations.no["trainingAdmin.pageTitle"],
        "trainingAdmin.addCard": trainingAdminTranslations.no["trainingAdmin.addCard"],
        "trainingAdmin.card": trainingAdminTranslations.no["trainingAdmin.card"],
        "trainingAdmin.cardTitle": trainingAdminTranslations.no["trainingAdmin.cardTitle"],
        "trainingAdmin.cardType": trainingAdminTranslations.no["trainingAdmin.cardType"],
        "trainingAdmin.body": trainingAdminTranslations.no["trainingAdmin.body"],
        "trainingAdmin.contentType": trainingAdminTranslations.no["trainingAdmin.contentType"],
        "trainingAdmin.acknowledgementType": trainingAdminTranslations.no["trainingAdmin.acknowledgementType"],
        "trainingAdmin.singleType": trainingAdminTranslations.no["trainingAdmin.singleType"],
        "trainingAdmin.multipleType": trainingAdminTranslations.no["trainingAdmin.multipleType"],
        "trainingAdmin.documentType": trainingAdminTranslations.no["trainingAdmin.documentType"],
        "trainingAdmin.required": trainingAdminTranslations.no["trainingAdmin.required"],
        "trainingAdmin.options": trainingAdminTranslations.no["trainingAdmin.options"],
        "trainingAdmin.addOption": trainingAdminTranslations.no["trainingAdmin.addOption"],
        "trainingAdmin.correct": trainingAdminTranslations.no["trainingAdmin.correct"],
        "trainingAdmin.explanation": trainingAdminTranslations.no["trainingAdmin.explanation"],
        "trainingAdmin.moveUp": trainingAdminTranslations.no["trainingAdmin.moveUp"],
        "trainingAdmin.moveDown": trainingAdminTranslations.no["trainingAdmin.moveDown"],
        "trainingAdmin.remove": trainingAdminTranslations.no["trainingAdmin.remove"],
        "trainingAdmin.dependency": trainingAdminTranslations.no["trainingAdmin.dependency"],
        "trainingAdmin.imageAlt": trainingAdminTranslations.no["trainingAdmin.imageAlt"],
        "trainingAdmin.saveBeforeImage": trainingAdminTranslations.no["trainingAdmin.saveBeforeImage"],
        "trainingAdmin.imageReady": trainingAdminTranslations.no["trainingAdmin.imageReady"],
        "trainingAdmin.document": trainingAdminTranslations.no["trainingAdmin.document"],
        "trainingAdmin.documentSearch": trainingAdminTranslations.no["trainingAdmin.documentSearch"],
        "trainingAdmin.noDocuments": trainingAdminTranslations.no["trainingAdmin.noDocuments"],
        "trainingAdmin.boundVersion": trainingAdminTranslations.no["trainingAdmin.boundVersion"],
        "trainingAdmin.readRequired": trainingAdminTranslations.no["trainingAdmin.readRequired"],
        "trainingAdmin.allUsers": trainingAdminTranslations.no["trainingAdmin.allUsers"],
        "trainingAdmin.positions": trainingAdminTranslations.no["trainingAdmin.positions"],
        "trainingAdmin.namedUsers": trainingAdminTranslations.no["trainingAdmin.namedUsers"],
        "trainingAdmin.audienceHint": trainingAdminTranslations.no["trainingAdmin.audienceHint"],
        "trainingAdmin.searchPeople": trainingAdminTranslations.no["trainingAdmin.searchPeople"],
        "trainingAdmin.requirement": trainingAdminTranslations.no["trainingAdmin.requirement"],
        "trainingAdmin.immediate": trainingAdminTranslations.no["trainingAdmin.immediate"],
        "trainingAdmin.deadline": trainingAdminTranslations.no["trainingAdmin.deadline"],
        "trainingAdmin.optional": trainingAdminTranslations.no["trainingAdmin.optional"],
        "trainingAdmin.newUsersOnly": trainingAdminTranslations.no["trainingAdmin.newUsersOnly"],
        "trainingAdmin.newUsersOnlyHint": trainingAdminTranslations.no["trainingAdmin.newUsersOnlyHint"],
        "trainingAdmin.newUsersImmediateWarning": trainingAdminTranslations.no["trainingAdmin.newUsersImmediateWarning"],
        "trainingAdmin.deadlineType": trainingAdminTranslations.no["trainingAdmin.deadlineType"],
        "trainingAdmin.fixedDate": trainingAdminTranslations.no["trainingAdmin.fixedDate"],
        "trainingAdmin.relativeDays": trainingAdminTranslations.no["trainingAdmin.relativeDays"],
        "trainingAdmin.dueAt": trainingAdminTranslations.no["trainingAdmin.dueAt"],
        "trainingAdmin.dueDays": trainingAdminTranslations.no["trainingAdmin.dueDays"],
        "trainingAdmin.snooze": trainingAdminTranslations.no["trainingAdmin.snooze"],
        "trainingAdmin.immediateWarning": trainingAdminTranslations.no["trainingAdmin.immediateWarning"],
        "trainingAdmin.overdueWarning": trainingAdminTranslations.no["trainingAdmin.overdueWarning"],
        "trainingAdmin.emailOptIn": trainingAdminTranslations.no["trainingAdmin.emailOptIn"],
        "trainingAdmin.emailHint": trainingAdminTranslations.no["trainingAdmin.emailHint"],
        "trainingAdmin.cadence": trainingAdminTranslations.no["trainingAdmin.cadence"],
        "trainingAdmin.daily": trainingAdminTranslations.no["trainingAdmin.daily"],
        "trainingAdmin.weekly": trainingAdminTranslations.no["trainingAdmin.weekly"],
        "trainingAdmin.events": trainingAdminTranslations.no["trainingAdmin.events"],
        "trainingAdmin.completed": trainingAdminTranslations.no["trainingAdmin.completed"],
        "trainingAdmin.overdue": trainingAdminTranslations.no["trainingAdmin.overdue"],
        "trainingAdmin.blocked": trainingAdminTranslations.no["trainingAdmin.blocked"],
        "trainingAdmin.preview": trainingAdminTranslations.no["trainingAdmin.preview"],
        "trainingAdmin.desktop": trainingAdminTranslations.no["trainingAdmin.desktop"],
        "trainingAdmin.mobile": trainingAdminTranslations.no["trainingAdmin.mobile"],
        "trainingAdmin.previewHint": trainingAdminTranslations.no["trainingAdmin.previewHint"],
        "trainingAdmin.impact": trainingAdminTranslations.no["trainingAdmin.impact"],
        "trainingAdmin.reviewImpact": trainingAdminTranslations.no["trainingAdmin.reviewImpact"],
        "trainingAdmin.affectedUsers": trainingAdminTranslations.no["trainingAdmin.affectedUsers"],
        "trainingAdmin.withoutPosition": trainingAdminTranslations.no["trainingAdmin.withoutPosition"],
        "trainingAdmin.changedCards": trainingAdminTranslations.no["trainingAdmin.changedCards"],
        "trainingAdmin.carriedCards": trainingAdminTranslations.no["trainingAdmin.carriedCards"],
        "trainingAdmin.removedCards": trainingAdminTranslations.no["trainingAdmin.removedCards"],
        "trainingAdmin.dependencyProblems": trainingAdminTranslations.no["trainingAdmin.dependencyProblems"],
        "trainingAdmin.acknowledgeImpact": trainingAdminTranslations.no["trainingAdmin.acknowledgeImpact"],
        "trainingAdmin.saveForReview": trainingAdminTranslations.no["trainingAdmin.saveForReview"],
        "trainingAdmin.emptyGuides": trainingAdminTranslations.no["trainingAdmin.emptyGuides"],
        "trainingAdmin.emptyHint": trainingAdminTranslations.no["trainingAdmin.emptyHint"],
        "trainingAdmin.noResults": trainingAdminTranslations.no["trainingAdmin.noResults"],
        "trainingAdmin.status": trainingAdminTranslations.no["trainingAdmin.status"],
        "trainingAdmin.draft": trainingAdminTranslations.no["trainingAdmin.draft"],
        "trainingAdmin.active": trainingAdminTranslations.no["trainingAdmin.active"],
        "trainingAdmin.inactive": trainingAdminTranslations.no["trainingAdmin.inactive"],
        "trainingAdmin.notStarted": trainingAdminTranslations.no["trainingAdmin.notStarted"],
        "trainingAdmin.inProgress": trainingAdminTranslations.no["trainingAdmin.inProgress"],
        "trainingAdmin.snoozed": trainingAdminTranslations.no["trainingAdmin.snoozed"],
        "trainingAdmin.exempt": trainingAdminTranslations.no["trainingAdmin.exempt"],
        "trainingAdmin.withdrawn": trainingAdminTranslations.no["trainingAdmin.withdrawn"],
        "trainingAdmin.user": trainingAdminTranslations.no["trainingAdmin.user"],
        "trainingAdmin.guide": trainingAdminTranslations.no["trainingAdmin.guide"],
        "trainingAdmin.progress": trainingAdminTranslations.no["trainingAdmin.progress"],
        "trainingAdmin.actions": trainingAdminTranslations.no["trainingAdmin.actions"],
        "trainingAdmin.perGuide": trainingAdminTranslations.no["trainingAdmin.perGuide"],
        "trainingAdmin.perUser": trainingAdminTranslations.no["trainingAdmin.perUser"],
        "trainingAdmin.exportCsv": trainingAdminTranslations.no["trainingAdmin.exportCsv"],
        "trainingAdmin.exportPdf": trainingAdminTranslations.no["trainingAdmin.exportPdf"],
        "trainingAdmin.details": trainingAdminTranslations.no["trainingAdmin.details"],
        "trainingAdmin.giveExemption": trainingAdminTranslations.no["trainingAdmin.giveExemption"],
        "trainingAdmin.extendDeadline": trainingAdminTranslations.no["trainingAdmin.extendDeadline"],
        "trainingAdmin.reason": trainingAdminTranslations.no["trainingAdmin.reason"],
        "trainingAdmin.exemptionInfo": trainingAdminTranslations.no["trainingAdmin.exemptionInfo"],
        "trainingAdmin.at": trainingAdminTranslations.no["trainingAdmin.at"],
        "trainingAdmin.actor": trainingAdminTranslations.no["trainingAdmin.actor"],
        "trainingAdmin.event": trainingAdminTranslations.no["trainingAdmin.event"],
        "trainingAdmin.attempt": trainingAdminTranslations.no["trainingAdmin.attempt"],
        "trainingAdmin.response": trainingAdminTranslations.no["trainingAdmin.response"],
        "trainingAdmin.correctResult": trainingAdminTranslations.no["trainingAdmin.correctResult"],
        "trainingAdmin.incorrectResult": trainingAdminTranslations.no["trainingAdmin.incorrectResult"],
        "trainingAdmin.carried": trainingAdminTranslations.no["trainingAdmin.carried"],
        "trainingAdmin.previous": trainingAdminTranslations.no["trainingAdmin.previous"],
        "trainingAdmin.next": trainingAdminTranslations.no["trainingAdmin.next"],
        "trainingAdmin.cancel": trainingAdminTranslations.no["trainingAdmin.cancel"],
        "trainingAdmin.close": trainingAdminTranslations.no["trainingAdmin.close"],
        "trainingAdmin.confirm": trainingAdminTranslations.no["trainingAdmin.confirm"],
        "trainingAdmin.readOnly": trainingAdminTranslations.no["trainingAdmin.readOnly"],
        "trainingAdmin.priceOnRequest": trainingAdminTranslations.no["trainingAdmin.priceOnRequest"],
        "trainingAdmin.commercialActivation": trainingAdminTranslations.no["trainingAdmin.commercialActivation"],
        "trainingAdmin.responsibleReports": trainingAdminTranslations.no["trainingAdmin.responsibleReports"],
        "trainingAdmin.validationTitle": trainingAdminTranslations.no["trainingAdmin.validationTitle"],
        "trainingAdmin.validationCards": trainingAdminTranslations.no["trainingAdmin.validationCards"],
        "trainingAdmin.validationAnswer": trainingAdminTranslations.no["trainingAdmin.validationAnswer"],
        "trainingAdmin.validationAudience": trainingAdminTranslations.no["trainingAdmin.validationAudience"],
        "trainingAdmin.validationDocument": trainingAdminTranslations.no["trainingAdmin.validationDocument"],
        "trainingAdmin.validationImage": trainingAdminTranslations.no["trainingAdmin.validationImage"],
        "trainingAdmin.validationReason": trainingAdminTranslations.no["trainingAdmin.validationReason"],
        "trainingParticipant.title": trainingParticipantNo["trainingParticipant.title"],
        "trainingAdmin.snoozeBeforeDeadline": trainingAdminTranslations.no["trainingAdmin.snoozeBeforeDeadline"],
        "trainingAdmin.mandatorySnooze": trainingAdminTranslations.no["trainingAdmin.mandatorySnooze"],
        "trainingAdmin.mandatorySnoozeHint": trainingAdminTranslations.no["trainingAdmin.mandatorySnoozeHint"],
        "trainingParticipant.mandatoryDeferHint": trainingParticipantNo["trainingParticipant.mandatoryDeferHint"],
        "trainingParticipant.mandatoryDeferValidation": trainingParticipantNo["trainingParticipant.mandatoryDeferValidation"],
        "trainingParticipant.adminDefer": trainingParticipantNo["trainingParticipant.adminDefer"],
        "trainingParticipant.adminDeferShort": trainingParticipantNo["trainingParticipant.adminDeferShort"],
        "trainingParticipant.adminDeferHint": trainingParticipantNo["trainingParticipant.adminDeferHint"],
        "trainingParticipant.adminDeferProgress": trainingParticipantNo["trainingParticipant.adminDeferProgress"],
        "trainingParticipant.adminDeferChoiceHint": trainingParticipantNo["trainingParticipant.adminDeferChoiceHint"],
        "trainingParticipant.adminDeferValidation": trainingParticipantNo["trainingParticipant.adminDeferValidation"],
        "trainingParticipant.creatorApproved": trainingParticipantNo["trainingParticipant.creatorApproved"],
        "trainingParticipant.creatorApprovalStatement": trainingParticipantNo["trainingParticipant.creatorApprovalStatement"],
        "trainingParticipant.requiredDialogTitle": trainingParticipantNo["trainingParticipant.requiredDialogTitle"],
        "trainingParticipant.requiredDialogIntro": trainingParticipantNo["trainingParticipant.requiredDialogIntro"],
        "trainingParticipant.goToTraining": trainingParticipantNo["trainingParticipant.goToTraining"],
        "trainingParticipant.openGuide": trainingParticipantNo["trainingParticipant.openGuide"],
        "trainingParticipant.showRequirements": trainingParticipantNo["trainingParticipant.showRequirements"],
        "trainingParticipant.intro": trainingParticipantNo["trainingParticipant.intro"],
        "trainingParticipant.gateIntro": trainingParticipantNo["trainingParticipant.gateIntro"],
        "trainingParticipant.requiredCount": trainingParticipantNo["trainingParticipant.requiredCount"],
        "trainingParticipant.completedCount": trainingParticipantNo["trainingParticipant.completedCount"],
        "trainingParticipant.assignments": trainingParticipantNo["trainingParticipant.assignments"],
        "trainingParticipant.history": trainingParticipantNo["trainingParticipant.history"],
        "trainingParticipant.group.required": trainingParticipantNo["trainingParticipant.group.required"],
        "trainingParticipant.group.deadline": trainingParticipantNo["trainingParticipant.group.deadline"],
        "trainingParticipant.group.optional": trainingParticipantNo["trainingParticipant.group.optional"],
        "trainingParticipant.group.recommended": trainingParticipantNo["trainingParticipant.group.recommended"],
        "trainingParticipant.group.completed": trainingParticipantNo["trainingParticipant.group.completed"],
        "trainingParticipant.status.not_started": trainingParticipantNo["trainingParticipant.status.not_started"],
        "trainingParticipant.status.assigned": trainingParticipantNo["trainingParticipant.status.assigned"],
        "trainingParticipant.status.in_progress": trainingParticipantNo["trainingParticipant.status.in_progress"],
        "trainingParticipant.status.completed": trainingParticipantNo["trainingParticipant.status.completed"],
        "trainingParticipant.status.passed": trainingParticipantNo["trainingParticipant.status.passed"],
        "trainingParticipant.status.snoozed": trainingParticipantNo["trainingParticipant.status.snoozed"],
        "trainingParticipant.status.overdue": trainingParticipantNo["trainingParticipant.status.overdue"],
        "trainingParticipant.status.exempt": trainingParticipantNo["trainingParticipant.status.exempt"],
        "trainingParticipant.status.withdrawn": trainingParticipantNo["trainingParticipant.status.withdrawn"],
        "trainingParticipant.status.blocked_dependency": trainingParticipantNo["trainingParticipant.status.blocked_dependency"],
        "trainingParticipant.progress": trainingParticipantNo["trainingParticipant.progress"],
        "trainingParticipant.due": trainingParticipantNo["trainingParticipant.due"],
        "trainingParticipant.snoozedUntil": trainingParticipantNo["trainingParticipant.snoozedUntil"],
        "trainingParticipant.start": trainingParticipantNo["trainingParticipant.start"],
        "trainingParticipant.continue": trainingParticipantNo["trainingParticipant.continue"],
        "trainingParticipant.view": trainingParticipantNo["trainingParticipant.view"],
        "trainingParticipant.snooze": trainingParticipantNo["trainingParticipant.snooze"],
        "trainingParticipant.snoozeHint": trainingParticipantNo["trainingParticipant.snoozeHint"],
        "trainingParticipant.remindAt": trainingParticipantNo["trainingParticipant.remindAt"],
        "trainingParticipant.saveReminder": trainingParticipantNo["trainingParticipant.saveReminder"],
        "trainingParticipant.snoozeValidation": trainingParticipantNo["trainingParticipant.snoozeValidation"],
        "trainingParticipant.subscriptionInactive": trainingParticipantNo["trainingParticipant.subscriptionInactive"],
        "trainingParticipant.noAssignments": trainingParticipantNo["trainingParticipant.noAssignments"],
        "trainingParticipant.noHistory": trainingParticipantNo["trainingParticipant.noHistory"],
        "trainingParticipant.guide": trainingParticipantNo["trainingParticipant.guide"],
        "trainingParticipant.revisionLabel": trainingParticipantNo["trainingParticipant.revisionLabel"],
        "trainingParticipant.completedAt": trainingParticipantNo["trainingParticipant.completedAt"],
        "trainingParticipant.receipt": trainingParticipantNo["trainingParticipant.receipt"],
        "trainingParticipant.loading": trainingParticipantNo["trainingParticipant.loading"],
        "trainingParticipant.saving": trainingParticipantNo["trainingParticipant.saving"],
        "trainingParticipant.saved": trainingParticipantNo["trainingParticipant.saved"],
        "trainingParticipant.savedRefreshFailed": trainingParticipantNo["trainingParticipant.savedRefreshFailed"],
        "trainingParticipant.loadFailed": trainingParticipantNo["trainingParticipant.loadFailed"],
        "trainingParticipant.revisionChanged": trainingParticipantNo["trainingParticipant.revisionChanged"],
        "trainingParticipant.accessChanged": trainingParticipantNo["trainingParticipant.accessChanged"],
        "trainingParticipant.unknownOutcome": trainingParticipantNo["trainingParticipant.unknownOutcome"],
        "trainingParticipant.sameAttempt": trainingParticipantNo["trainingParticipant.sameAttempt"],
        "trainingParticipant.statusFailed": trainingParticipantNo["trainingParticipant.statusFailed"],
        "trainingParticipant.checkStatus": trainingParticipantNo["trainingParticipant.checkStatus"],
        "trainingParticipant.retrySame": trainingParticipantNo["trainingParticipant.retrySame"],
        "trainingParticipant.refresh": trainingParticipantNo["trainingParticipant.refresh"],
        "trainingParticipant.back": trainingParticipantNo["trainingParticipant.back"],
        "trainingParticipant.next": trainingParticipantNo["trainingParticipant.next"],
        "trainingParticipant.close": trainingParticipantNo["trainingParticipant.close"],
        "trainingParticipant.finish": trainingParticipantNo["trainingParticipant.finish"],
        "trainingParticipant.revision": trainingParticipantNo["trainingParticipant.revision"],
        "trainingParticipant.pageCount": trainingParticipantNo["trainingParticipant.pageCount"],
        "trainingParticipant.revisionProgress": trainingParticipantNo["trainingParticipant.revisionProgress"],
        "trainingParticipant.carried": trainingParticipantNo["trainingParticipant.carried"],
        "trainingParticipant.multipleHint": trainingParticipantNo["trainingParticipant.multipleHint"],
        "trainingParticipant.singleHint": trainingParticipantNo["trainingParticipant.singleHint"],
        "trainingParticipant.readDocument": trainingParticipantNo["trainingParticipant.readDocument"],
        "trainingParticipant.moreInformation": trainingParticipantNo["trainingParticipant.moreInformation"],
        "trainingParticipant.confirmContent": trainingParticipantNo["trainingParticipant.confirmContent"],
        "trainingParticipant.answerPassed": trainingParticipantNo["trainingParticipant.answerPassed"],
        "trainingParticipant.answerIncorrect": trainingParticipantNo["trainingParticipant.answerIncorrect"],
        "trainingParticipant.checkAnswer": trainingParticipantNo["trainingParticipant.checkAnswer"],
        "trainingParticipant.confirm": trainingParticipantNo["trainingParticipant.confirm"],
        "trainingParticipant.completed": trainingParticipantNo["trainingParticipant.completed"],
        "trainingParticipant.completionStatement": trainingParticipantNo["trainingParticipant.completionStatement"],
        "trainingParticipant.emptyGuide": trainingParticipantNo["trainingParticipant.emptyGuide"],
        "trainingParticipant.previewNotice": trainingParticipantNo["trainingParticipant.previewNotice"],
        "trainingParticipant.previewImage": trainingParticipantNo["trainingParticipant.previewImage"],
        "trainingParticipant.imageFailed": trainingParticipantNo["trainingParticipant.imageFailed"],
        "trainingParticipant.document": trainingParticipantNo["trainingParticipant.document"],
        "trainingParticipant.backToGuide": trainingParticipantNo["trainingParticipant.backToGuide"],
        "trainingParticipant.documentRevision": trainingParticipantNo["trainingParticipant.documentRevision"],
        "trainingParticipant.documentFailed": trainingParticipantNo["trainingParticipant.documentFailed"],
        "trainingParticipant.textAlternative": trainingParticipantNo["trainingParticipant.textAlternative"],
        "trainingParticipant.documentPages": trainingParticipantNo["trainingParticipant.documentPages"],
        "trainingParticipant.readUnderstood": trainingParticipantNo["trainingParticipant.readUnderstood"],
        "trainingParticipant.confirmReading": trainingParticipantNo["trainingParticipant.confirmReading"],
        "trainingParticipant.previewConfirm": trainingParticipantNo["trainingParticipant.previewConfirm"],
        "trainingParticipant.cardNumber": trainingParticipantNo["trainingParticipant.cardNumber"],
        "trainingParticipant.carriedReceipt": trainingParticipantNo["trainingParticipant.carriedReceipt"],
        "trainingParticipant.confirmedReceipt": trainingParticipantNo["trainingParticipant.confirmedReceipt"],
        "trainingParticipant.recovery": trainingParticipantNo["trainingParticipant.recovery"],
        "trainingParticipant.adminRecovery": trainingParticipantNo["trainingParticipant.adminRecovery"],
        "trainingParticipant.checkingRequirements": trainingParticipantNo["trainingParticipant.checkingRequirements"],
        "trainingParticipant.gateFailed": trainingParticipantNo["trainingParticipant.gateFailed"],
        "trainingParticipant.gateRecovery": trainingParticipantNo["trainingParticipant.gateRecovery"],

        "serviceReminders.title": "Automatiske avtalepåminnelser",
        "serviceReminders.intro": "Velg når og hvordan kunden skal få en påminnelse. Alle kanaler er slått av som standard.",
        "serviceReminders.visit": "Før bekreftet service",
        "serviceReminders.visitHint": "Minner kunden om et kommende servicebesøk som er bekreftet.",
        "serviceReminders.visitDays": "dager før avtalt dato",
        "serviceReminders.confirmation": "Venter på bekreftelse",
        "serviceReminders.confirmationHint": "Følger opp en sendt avtale som kunden ennå ikke har bekreftet.",
        "serviceReminders.confirmationDays": "dager etter at avtalen ble sendt",
        "serviceReminders.sms": "SMS",
        "serviceReminders.email": "E-post",
        "serviceReminders.once": "Én påminnelse per avtale og kanal. Flyttes avtalen, kan en ny påminnelse sendes. Det sendes ikke på eller etter avtaledagen.",
        "serviceReminders.save": "Lagre påminnelser",
        "serviceReminders.invalidDays": "Bruk et helt antall dager fra 1 til 365.",
        "serviceReminders.unknown": "Vi kunne ikke bekrefte lagringen. Hent lagrede innstillinger før du prøver igjen.",
        "serviceReminders.reload": "Hent lagrede innstillinger",
        "serviceReminders.disabledHint": "Ingen kanal valgt betyr at påminnelsen er slått av.",
        "serviceReminders.history": "Avtalepåminnelse",
        "serviceReminders.state.sent": "Sendt",
        "serviceReminders.state.sending": "Sending startet – resultat ikke bekreftet",
        "serviceReminders.state.unknown": "Uavklart – sendes ikke på nytt uten sikker avklaring",
        "serviceReminders.state.retrying": "Ikke sendt – nytt forsøk er planlagt",
        "serviceReminders.state.connection_required": "Kontroller tilkoblingen til firmaets innboks",
        "serviceReminders.state.lookup_unavailable": "Leveringsstatus er midlertidig utilgjengelig",
        "serviceReminders.state.failed": "Ikke sendt – automatiske forsøk avsluttet",
        "serviceReminders.state.skipped": "Ikke sendt",
        "histories.action.service_appointment_reminder": "Avtalepåminnelse",
        "collaboration.changed.order": "Ordren har nye endringer",
        "collaboration.changed.calculation": "Kalkylen har nye endringer",
        "collaboration.changed.meeting_minutes_meeting": "Møtet har nye endringer",
        "collaboration.changed.project_plan": "Prosjektplanen har nye endringer",
        "collaboration.title": "Samarbeid",
        "collaboration.live": "Sanntid tilkoblet",
        "collaboration.offline": "Sanntid utilgjengelig – kontroller siste versjon før lagring",
        "collaboration.viewing": "ser på",
        "collaboration.editing": "redigerer",
        "collaboration.away": "inaktiv",
        "collaboration.changed": "Rapporten har nye endringer",
        "collaboration.reviewNeeded": "Kontroller siste versjon før du prøver igjen",
        "collaboration.keepDraft": "Kladden din er beholdt. Kontroller siste versjon før du fortsetter å lagre.",
        "collaboration.minimize": "Minimer varsel",
        "collaboration.reload": "Hent siste versjon",
        "collaboration.discardWarning": "Ny innlasting fjerner ulagrede endringer på denne siden og i åpne dialoger. Kopier tekst du vil beholde før du fortsetter.",
        "collaboration.keepEditing": "Behold kladden",
        "collaboration.confirmReload": "Forkast kladd og last inn",
        "collaboration.section.overview": "Oversikt",
        "collaboration.section.info": "Informasjon",
        "collaboration.section.report": "Rapporttekst",
        "collaboration.section.checklist": "Sjekkliste",
        "collaboration.section.items": "Vareforbruk",
        "collaboration.section.hours": "Timer",
        "collaboration.section.variables": "Variabler",
        "collaboration.section.price": "Prislinjer",
        "collaboration.section.team": "Ansvarlige",
        "collaboration.section.status": "Status",
        "collaboration.section.agenda": "Agenda",
        "collaboration.section.plan": "Plan",
        "collaboration.section.resources": "Ressurser",
        "reportWizard.details": "Opplysninger",
        "reportWizard.review": "Gjennomgang",
        "reportWizard.eyebrow": "Ny servicerapport",
        "reportWizard.subtitle": "Velg type, fyll inn opplysningene og kontroller før rapporten opprettes.",
        "reportWizard.section.parties": "Kunde og prosjekt",
        "reportWizard.section.partiesHint": "Hvem rapporten gjelder, og hvor den hører hjemme.",
        "reportWizard.section.job": "Oppdrag",
        "reportWizard.section.jobHint": "Dato, anlegg og sjekkliste for oppdraget.",
        "reportWizard.section.text": "Beskrivelser",
        "reportWizard.section.textHint": "Tekst kunden ser, og interne notater.",
        "reportWizard.section.addressHint": "Hvor jobben utføres. Standard er kundens adresse.",
        "reportWizard.section.billingHint": "Valgfritt. Fakturamottaker og prosjektøkonomi.",
        "pickers.system.placeholder": "Velg anlegg",
        "pickers.system.needsCustomer": "Velg kunde først",
        "pickers.system.search": "Søk produkt, serienummer eller plassering",
        "pickers.system.empty": "Kunden har ingen anlegg ennå",
        "pickers.system.create": "Nytt anlegg",
        "pickers.address.placeholder": "Velg oppdragsadresse",
        "pickers.address.search": "Søk navn eller adresse",
        "pickers.address.filterCompany": "Bedriften",
        "pickers.address.filterProject": "Prosjekt",
        "pickers.address.filterCustomer": "Kundens",
        "pickers.address.filterAll": "Alle",
        "pickers.address.empty": "Ingen adresser i dette utvalget",
        "pickers.address.create": "Ny adresse",
        "pickers.address.companyPostal": "Postadresse",
        "pickers.address.companyPhysical": "Besøksadresse",
        "pickers.address.companyPostalAndPhysical": "Post- og besøksadresse",
        "pickers.search": "Søk …",
        "pickers.clear": "Fjern valg",
        "pickers.clearSearch": "Tøm søk",
        "pickers.filters": "Filter",
        "pickers.empty": "Ingen treff",
        "pickers.emptyQuery": "Ingen treff for «{{query}}»",
        "pickers.loadFailed": "Kunne ikke hente listen.",
        "pickers.retry": "Prøv igjen",
        "pickers.moreResults": "Viser de {{count}} første. Søk for å snevre inn.",
        "pickers.hintMove": "↑↓ flytt",
        "pickers.hintSelect": "↵ velg",
        "pickers.hintClose": "esc lukk",
        "pickers.customer.placeholder": "Velg kunde",
        "pickers.customer.search": "Søk navn, kundenummer eller adresse",
        "pickers.customer.filterAll": "Alle",
        "pickers.customer.filterCompany": "Bedrift",
        "pickers.customer.filterPrivate": "Privat",
        "pickers.customer.create": "Ny kunde",
        "pickers.project.placeholder": "Velg prosjekt",
        "pickers.project.search": "Søk navn eller prosjektnummer",
        "pickers.project.filterCustomer": "Kundens",
        "pickers.project.filterActive": "Aktive",
        "pickers.project.filterInactive": "Avsluttede",
        "pickers.project.empty": "Ingen prosjekter i dette utvalget",
        "pickers.contact.placeholder": "Velg kontakt",
        "pickers.contact.search": "Søk navn, e-post eller telefon",
        "pickers.contact.filterCustomer": "Kundens",
        "pickers.contact.filterAll": "Alle",
        "pickers.contact.empty": "Ingen kontakter i dette utvalget",
        "pickers.contact.create": "Ny kontakt",
        "pickers.folder.label": "Mappe",
        "pickers.folder.placeholder": "Velg mappe",
        "pickers.folder.needsProject": "Velg prosjekt først",
        "pickers.folder.search": "Søk i mapper",
        "pickers.folder.empty": "Prosjektet har ingen mapper",
        "reportWizard.invoiceCustomer": "Fakturakunde",
        "reportWizard.intro": "Guidet rapportopprettelse",
        "reportWizard.typeHint": "Velg rapporttypen som passer oppdraget. Se anbefalte innstillinger før du går videre.",
        "reportWizard.typeRange": "Viser {{from}}–{{to}} av {{total}} typer",
        "reportWizard.previousTypes": "Forrige typer",
        "reportWizard.nextTypes": "Neste typer",
        "reportWizard.selectedType": "Valgt type: {{title}}",
        "reportWizard.searchTypes": "Søk etter rapporttype",
        "reportWizard.noResults": "Ingen treff. Prøv et annet søk.",
        "reportWizard.loadFailed": "Kunne ikke hente valgene.",
        "reportWizard.template": "Bruk som mal",
        "reportWizard.suggestion": "Vis som forslag",
        "reportWizard.recommended": "Anbefalte innstillinger",
        "reportWizard.applyDefaults": "Bruk anbefalte innstillinger",
        "reportWizard.preserveEdits": "Fyller inn felter du ikke har endret. Egen tekst og egne valg beholdes.",
        "reportWizard.noChecklist": "Ingen forhåndsvalgt sjekkliste",
        "reportWizard.searchChecklist": "Søk etter sjekklistemal",
        "reportWizard.internalDescription": "Intern beskrivelse",
        "reportWizard.customerVisible": "Synlig for kunden.",
        "reportWizard.internalOnly": "Kun synlig internt.",
        "reportWizard.applied": "Anbefalte innstillinger er tatt i bruk",
        "reportWizard.manual": "Egne innstillinger",
        "reportWizard.billingOptions": "Fakturering og prosjektøkonomi",
        "reportWizard.reviewHint": "Kontroller innholdet. Rapporten opprettes først når du bekrefter nedenfor.",
        "reportWizard.afterCreate": "Etter opprettelse kan du fylle ut sjekklisten og legge til timer, varer, prislinjer og dokumenter i rapporten.",
        "reportWizard.create": "Opprett rapport",
        "reportWizard.unknown": "Vi kunne ikke bekrefte om rapporten ble opprettet. Kontroller rapportoversikten før du prøver igjen.",
        "reportWizard.unknownType": "Vi kunne ikke bekrefte lagringen. Lukk og last rapporttypen på nytt før du prøver igjen.",
        "reportWizard.refreshFailed": "Rapporten er opprettet, men tilknytningen eller oppdateringen av visningen kunne ikke bekreftes. Ikke opprett på nytt.",
        "reportWizard.saved": "Rapporten er opprettet.",
        "reportWizard.openReport": "Åpne rapport",
        "reportWizard.settingsHint": "Disse feltene brukes ved opprettelse av nye rapporter. Eksisterende rapporter endres ikke. Beskrivelsen av selve typen ovenfor er kun en veiledning.",
        "reportWizard.application": "Bruk ved opprettelse",
        "reportWizard.defaultChecklist": "Anbefalt sjekklistemal",
        "reportWizard.enableChecklist": "Aktiver «Sjekkliste» nedenfor for å bruke denne malen ved opprettelse.",
        "reportWizard.defaultDescription": "Standard beskrivelse i rapport",
        "reportWizard.defaultInternalDescription": "Standard intern beskrivelse",
        "reportWizard.module.checklist": "Sjekkliste",
        "reportWizard.module.items": "Varer",
        "reportWizard.module.hours": "Timer",
        "reportWizard.module.variables": "Variabler",
        "reportWizard.module.system": "Anlegg",
        "reportWizard.module.agreement": "Avtale",
        "reportWizard.type": "Rapporttype",
        "reportWizard.next": "Neste",
        "reportWizard.orderDate": "Ordredato",
        "reportWizard.useCustomerAddress": "Bruk kundens adresse",
        "reportWizard.deliveryAddress": "Oppdragsadresse",
        "reportWizard.system": "Anlegg",
        "reportWizard.loading": "Laster …",
        "reportWizard.retry": "Prøv igjen",









































        "serviceSettings.title": "Serviceinnstillinger",
        "serviceSettings.hour_product": "Standardprodukt for servicetimer",
        "serviceSettings.product": "Produkt",
        "serviceSettings.search_label": "Søk",
        "serviceSettings.previous": "Forrige",
        "serviceSettings.next": "Neste",
        "serviceSettings.name": "Navn",
        "serviceSettings.interval": "Intervall",
        "serviceSettings.report_type": "Rapporttype",
        "serviceSettings.agreement_type": "Avtaletype",
        "serviceSettings.agreement_start_date": "Avtalestart",
        "serviceSettings.title_no_ampersand": "Tittel kan ikke inneholde symbolet «&»",
        "serviceSettings.description": "Beskrivelse",
        "serviceSettings.conditions": "Betingelser",
        "serviceSettings.active": "Aktiv",
        "serviceSettings.system": "Anlegg",
        "serviceSettings.simple_report": "Enkel rapport",
        "serviceSettings.agreement": "Avtale",
        "serviceSettings.items": "Varer",
        "serviceSettings.checklist": "Sjekkliste",
        "serviceSettings.hours": "Timer",
        "serviceSettings.variables": "Variabler",
        "itemListDetail.change_product": "Bytt produkt",
        "serviceSettings.eyebrow": "Service / innstillinger",
        "serviceSettings.intro": "Tilpass avtaler, rapporter og standardvalg for en mer oversiktlig servicehverdag.",
        "serviceSettings.types": "Typer og rapportguider",
        "serviceSettings.general": "Generelt",
        "serviceSettings.agreement_hint": "Vilkår og rapportvalg som brukes når du oppretter serviceavtaler.",
        "serviceSettings.report_hint": "Velg innhold og funksjoner for hver rapporttype.",
        "serviceSettings.variable_hint": "Navngi målinger og andre variabler som brukes i rapportene.",
        "serviceSettings.search": "Søk etter type…",
        "serviceSettings.no_results": "Ingen treff",
        "serviceSettings.search_hint": "Prøv et annet søkeord.",
        "serviceSettings.empty": "Ingen typer ennå",
        "serviceSettings.empty_hint": "Legg til den første typen for å komme i gang.",
        "serviceSettings.load_failed": "Kunne ikke hente innstillingene.",
        "serviceSettings.save_failed": "Kunne ikke lagre. Kontroller feltene og prøv igjen.",
        "serviceSettings.unknown": "Lagringen kunne ikke bekreftes. Last siden på nytt og kontroller resultatet før du prøver igjen.",
        "serviceSettings.saved_type": "«{{title}}» er lagret.",
        "serviceSettings.create_reports": "Opprett rapporter ved utførelse",
        "serviceSettings.mission_hint": "Opprett både rapport og ordre når avtalen utføres. Avslått opprettes bare ordre.",
        "serviceSettings.report_content": "Rapportens innhold og tilgjengelighet",
        "serviceSettings.notifications": "Rapportvarsler",
        "serviceSettings.notifications_hint": "Angi hvem som skal varsles når en rapport ferdigstilles.",
        "serviceSettings.email": "E-post for ferdigstilte rapporter",
        "serviceSettings.product_hint": "Produktet som brukes som standard ved registrering av servicetimer.",
        "serviceSettings.conditions_hint": "Standardvilkår som også følger e-post ved bekreftelse av avtale.",
        "serviceSettings.unsaved": "Du har ulagrede endringer.",
        "serviceSettings.save_hint": "Endringer lagres når du velger Lagre innstillinger.",
        "serviceSettings.save": "Lagre innstillinger",
        "serviceSettings.no_access": "Du har ikke tilgang til serviceinnstillingene.",
        "itemListDetail.heading": "Vareforbruk",
        "itemListDetail.pick_date": "Plukkdato",
        "itemListDetail.save_date": "Lagre dato",
        "itemListDetail.eyebrow": "Prosjekt / vareforbruk",
        "itemListDetail.back": "Tilbake til prosjekt",
        "itemListDetail.refresh": "Oppdater",
        "itemListDetail.pdf": "Last ned PDF",
        "itemListDetail.pdf_failed": "PDF kunne ikke hentes. Prøv igjen.",
        "itemListDetail.pdf_ready": "PDF er klar for nedlasting.",
        "itemListDetail.load_failed": "Kunne ikke hente vareforbruket. Velg Oppdater for å prøve igjen.",
        "itemListDetail.loading": "Laster…",
        "itemListDetail.add": "Legg til produkter",
        "itemListDetail.edit": "Rediger",
        "itemListDetail.title": "Produkt / tittel",
        "itemListDetail.description": "Beskrivelse",
        "itemListDetail.quantity": "Antall",
        "itemListDetail.purchase_price": "Innkjøpspris eks. mva.",
        "itemListDetail.sales_price": "Salgspris eks. mva.",
        "itemListDetail.discount": "Rabatt (%)",
        "itemListDetail.surcharge": "Påslag (%)",
        "itemListDetail.price_options": "Flere prisvalg",
        "itemListDetail.product_id": "Produkt-ID",
        "itemListDetail.status": "Status",
        "itemListDetail.approval_comment": "Kommentar",
        "itemListDetail.line": "Linje {{number}}",
        "itemListDetail.lines": "Produktlinjer",
        "itemListDetail.total_purchase": "Innkjøpssum eks. mva.",
        "itemListDetail.total_sales": "Salgsverdi eks. mva. før rabatt/påslag",
        "itemListDetail.line_total": "Innkjøpssum",
        "itemListDetail.products": "Produkter",
        "itemListDetail.filter": "Søk i vareforbruket…",
        "itemListDetail.empty": "Ingen produkter å vise.",
        "itemListDetail.edit_line": "Rediger {{title}}",
        "itemListDetail.remove_line": "Fjern {{title}}",
        "itemListDetail.edit_hint": "Rediger produkt, antall og innkjøpspris fra blyanten på hver linje. Endringer føres i historikken.",
        "itemListDetail.locked_hint": "Listen er låst for redigering. Admin kan gjenåpne innsendt eller godkjent vareforbruk. Fakturerte lister forblir låst.",
        "itemListDetail.action_reopen": "Gjenåpne vareforbruk",
        "itemListDetail.action_submit": "Send til godkjenning",
        "itemListDetail.action_approve": "Godkjenn",
        "itemListDetail.action_reject": "Avslå",
        "itemListDetail.action_invoice": "Marker fakturert manuelt",
        "itemListDetail.action_delete": "Slett varelisten",
        "itemListDetail.action_remove": "Fjern produkt",
        "itemListDetail.confirm": "Bekreft",
        "itemListDetail.confirm_hint": "Bekreft handlingen for «{{title}}».",
        "itemListDetail.reopen_hint": "Listen åpnes for redigering og må sendes til ny godkjenning. Tidligere godkjenning og denne gjenåpningen vises i historikken.",
        "itemListDetail.completed": "Handlingen er utført.",
        "itemListDetail.find_product": "Finn produkt",
        "itemListDetail.search_hint": "Navn, produktnummer eller QR-kode",
        "itemListDetail.scan": "Skann QR-kode",
        "itemListDetail.stop_camera": "Stopp kamera",
        "itemListDetail.camera_failed": "Kunne ikke åpne kamera. Sjekk kameratilgang eller bruk søkefeltet.",
        "itemListDetail.searching": "Søker etter produkter…",
        "itemListDetail.search_failed": "Produktsøket feilet.",
        "itemListDetail.results": "{{count}} produkter funnet",
        "itemListDetail.select": "Velg",
        "itemListDetail.manual": "Legg til manuell linje",
        "itemListDetail.remove": "Fjern",
        "itemListDetail.save": "Lagre",
        "itemListDetail.saving": "Lagrer…",
        "itemListDetail.saved": "Lagret",
        "itemListDetail.save_failed": "Kunne ikke lagre. Kontroller feltene.",
        "itemListDetail.invalid": "Fyll ut produkt/tittel. Antall må være større enn 0, og priser/rabatt/påslag må være 0 eller positive tall.",
        "itemListDetail.discard": "Forkaste ulagrede endringer?",
        "itemListDetail.unknown": "Resultatet er ukjent. Behold verdiene, lukk dialogen og oppdater listen for å kontrollere resultatet før et nytt forsøk.",
        "itemListDetail.refresh_failed": "Endringen er lagret, men listen kunne ikke oppdateres. Lukk dialogen og velg Oppdater.",
        "itemListDetail.progress": "{{count}} av {{total}} linjer lagret",
        "itemListDetail.product_change_hint": "Produktbytte beholder antall og priser. Juster dem ved behov; produktregisteret endres ikke.",
        "itemListDetail.history": "Historikk",
        "itemListDetail.history_hint": "Registrerte endringer med bruker, tidspunkt og før-/etterverdier. Eldre endringer som ikke ble loggført, vises ikke.",
        "itemListDetail.history_failed": "Kunne ikke hente historikken.",
        "itemListDetail.history_empty": "Ingen loggførte endringer ennå.",
        "itemListDetail.system": "System",
        "itemListDetail.event_create": "Liste opprettet",
        "itemListDetail.event_update": "Liste endret",
        "itemListDetail.event_destroy": "Liste slettet",
        "itemListDetail.event_add_item": "Produkt lagt til",
        "itemListDetail.event_update_item": "Produktlinje endret",
        "itemListDetail.event_remove_item": "Produkt fjernet",
        "itemListDetail.event_approve": "Godkjent",
        "itemListDetail.event_reject": "Avslått",
        "itemListDetail.event_submit_for_approval": "Sendt til godkjenning",
        "itemListDetail.event_mark_invoiced_manually": "Markert fakturert manuelt",
        "itemListDetail.event_reopen": "Gjenåpnet for redigering",
        "service.agreements.subs.facility_select": "Velg registrert anlegg",
        "service.agreements.subs.facility_manual": "Skriv inn manuelt",
        "service.agreements.subs.filter_manual": "Manuell filtertekst",
        "service.agreements.subs.filter_products": "Produkter som rader",
        "service.agreements.subs.find_filter_product": "Søk og legg til filterprodukt",
        "service.agreements.subs.filters_empty": "Søk etter et produkt for å legge til en filterrad.",
        "service.agreements.subs.use_suggestion": "Bruk forslag: {{suggestion}}",
        "service.agreements.subs.address_loading": "Henter anleggets adresse…",
        "service.agreements.subs.address_failed": "Kunne ikke hente anleggets adresse.",
        "itemListDetail.bulk_add": "Legg til produkter i bulk",
        "itemListDetail.add_selected": "Legg til valgte ({{count}})",
        "itemListDetail.scan_no_exact_match": "Ingen eksakt treff på skannet kode. Bruk Søk manuelt.",
        "product.selector.dialog_title": "Velg produkt",
        "product.selector.dialog_title_multiple": "Velg produkter",
        "service.agreements.subs.quantity": "Antall",
        "service.agreements.subs.quantity_invalid": "Antall må være større enn 0 og høyst 10 000.",
        "service.agreements.subs.save_unknown": "Lagringen kunne ikke bekreftes. Lukk dialogen og last listen på nytt for å kontrollere resultatet før et nytt forsøk.",
  "service.agreements.filters.active": "Aktive avtaler",
  "service.agreements.filters.service_soon": "Service snart",
  "relatedEntries.search": "Søk i listen…",
  "relatedEntries.preview": "Forhåndsvis",
  "relatedEntries.previewEntry": "Forhåndsvis #{{number}}",
  "relatedEntries.filters": "Filtre",
  "relatedEntries.clear": "Nullstill filtre",
  "relatedEntries.newest": "Nyeste først",
  "relatedEntries.loading": "Laster…",
  "relatedEntries.loadFailed": "Kunne ikke hente listen.",
  "relatedEntries.retry": "Prøv igjen",
  "relatedEntries.empty": "Ingen treff",
  "relatedEntries.emptyHint": "Prøv et annet søk eller endre filtrene.",
  "relatedEntries.loadMore": "Vis flere",
  "relatedEntries.select": "Velg #{{number}}",
  "relatedEntries.created": "Opprettet",
  "relatedEntries.date": "Dato",
  "relatedEntries.agreed": "Avtalt dato",
  "relatedEntries.delivery": "Leveringsdato",
  "relatedEntries.due": "Frist",
  "relatedEntries.nextService": "Neste service",
  "relatedEntries.project": "Prosjekt",
  "relatedEntries.customer": "Kunde",
  "relatedEntries.address": "Adresse",
  "relatedEntries.description": "Beskrivelse",
  "relatedEntries.viewFullDescription": "Vis hele beskrivelsen",
  "relatedEntries.viewFullDescriptionEntry": "Vis hele beskrivelsen for #{{number}}",
  "relatedEntries.descriptionDialogTitle": "Rapportbeskrivelse",
  "relatedEntries.descriptionDialogEyebrow": "Rapport #{{number}}",
  "relatedEntries.assigned": "Ansvarlig",
  "relatedEntries.type": "Type",
  "relatedEntries.serial": "Serienummer",
  "relatedEntries.reports": "Rapporter",
  "relatedEntries.orders": "Ordrer",
  "relatedEntries.workOrders": "Arbeidsordrer",
  "relatedEntries.agreements": "Avtaler",
  "relatedEntries.projects": "Prosjekter",
  "relatedEntries.cases": "Saker",
  "relatedEntries.facilities": "Anlegg",
        "hourBilling.workspace": "Timekontroll",
        "hourBilling.refresh": "Oppdater",
        "hourBilling.searchHours": "Søk etter ansatt, prosjekt eller beskrivelse…",
        "hourBilling.selectInTable": "Velg timer i tabellen",
        "hourBilling.tableHint": "Kryss av enkeltvis eller velg hele siden. Utvalget nullstilles når du bytter side eller filter.",
        "hourBilling.clearSelection": "Fjern utvalg",
        "hourBilling.selectPage": "Velg alle på denne siden",
        "hourBilling.selectEntry": "Velg timeføring",
        "hourBilling.employeeDate": "Ansatt / dato",
        "hourBilling.project": "Prosjekt",
        "hourBilling.actions": "Handling",
        "hourBilling.editEntry": "Avstem",
        "hourBilling.emptyHint": "Listen viser innleide timer som mangler full fakturadekning. Prøv å justere søk eller filtre.",
        "hourBilling.search_orders": "Søk ordrenummer, referanse eller kommentar…",
        "hourBilling.search_invoices": "Søk fakturanummer, leverandør, bilag eller beskrivelse…",
        "hourBilling.searching": "Søker i alle tilgjengelige treff…",
        "hourBilling.searchResults": "{{count}} treff vises",
        "hourBilling.noChoices": "Ingen passende treff. Prøv et annet søk.",
        "hourBilling.searchFailed": "Søket kunne ikke fullføres.",
        "hourBilling.moreChoices": "Vis flere treff",
        "hourBilling.applySelection": "Endringene gjelder alle valgte føringer.",
        "hourBilling.customerSection": "Fakturering til kunde",
        "hourBilling.costSection": "Innleie og kostnadsdekning",
        "hourBilling.salarySection": "Lønn og egne ansatte",
        "hourBilling.reloadStatus": "Hent siste status",
        "hourBilling.unknownSave": "Lagringen kunne ikke bekreftes. Hent siste status før du gjør flere endringer, slik at du ikke lagrer på nytt uten å vite resultatet.",
        "hourBilling.hours": "timer",
        "announcements.communication": "Kommunikasjon",
        "announcements.headline": "Hold alle oppdatert",
        "announcements.intro": "Samle viktig informasjon, rutiner og nyheter. Velg hvem som skal se meldingen og hvordan den skal nå frem.",
        "announcements.scheduled": "Planlagt",
        "announcements.expired": "Utløpt",
        "announcements.all": "Alle",
        "announcements.search": "Søk i meldinger…",
        "announcements.filter": "Filtrer på publiseringsstatus",
        "announcements.noDate": "Ikke angitt",
        "announcements.empty": "Den første meldingen starter her",
        "announcements.emptyHint": "Skriv en oppdatering til kollegaene, en intern rutine eller en nyhet for nettsiden.",
        "announcements.noMatches": "Ingen meldinger passer søket",
        "announcements.searchHint": "Prøv et annet søkeord eller statusfilter.",
        "announcements.preview": "Meldingsvisning",
        "announcements.channelApp": "App / nettside",
        "announcements.channelEmail": "E-post",
        "announcements.edit": "Rediger melding",
        "announcements.message": "Skriv meldingen",
        "announcements.messageHint": "En tydelig overskrift og kort tekst gjør informasjonen lett å finne igjen.",
        "announcements.titlePlaceholder": "Hva vil du dele?",
        "announcements.bodyPlaceholder": "Skriv det mottakerne trenger å vite…",
        "announcements.in_appHint": "Meldingen vises for valgt målgruppe når den er publisert og innenfor perioden.",
        "announcements.email_enabledHint": "Velg mottakere og bekreft utsending etter lagring. Lagring sender ingen e-post.",
        "announcements.visibility": "Publisering og periode",
        "announcements.publishToggle": "Publiser meldingen",
        "announcements.visibilityHint": "Av betyr utkast. Med en fremtidig startdato blir meldingen synlig fra det tidspunktet. E-post sendes gjennom et eget valg.",
        "announcements.saveHint": "E-post sendes i et eget steg",
        "announcements.discard": "Forkaste ulagrede endringer i meldingen?",
        "announcements.searchRecipients": "Søk etter mottaker…",
        "announcements.selectVisible": "Velg alle tilgjengelige i søket",
        "announcements.noRecipients": "Ingen mottakere i dette søket",
        "announcements.selected": "{{count}} mottakere valgt",
        "announcements.confirmTitle": "Bekreft e-postutsending",
        "announcements.confirmHint": "Du sender den lagrede meldingen til {{count}} valgte mottakere. En fremtidig startdato planlegger utsendingen. Allerede registrerte mottakere sendes ikke på nytt.",
        "announcements.confirmSend": "Bekreft utsending",
        "announcements.sending": "Registrerer utsending…",
        "announcements.sendFailed": "Utsendingen kunne ikke bekreftes. Oppdater leveringsstatus før du prøver igjen.",
        "hourBilling.open": "Fakturering / avstemming",
        "hourBilling.selectFirst": "Kryss av én eller flere timer for å merke som fakturert eller avstemme.",
        "hourBilling.unchanged": "Behold uendret",
        "hourBilling.customer_invoiced": "Fakturert kunde",
        "hourBilling.hired_invoiced": "Innleie fakturert",
        "hourBilling.billing_order_id": "Knytt til ordre",
        "hourBilling.supplierinvoice_id": "Leverandørfaktura",
        "hourBilling.salary_voucher_id": "Lønnsbilag",
        "hourBilling.bulkHint": "Velg bare feltene som skal endres. Alle valgte timer lagres samlet. Godkjenning av timer påvirkes ikke.",
        "hourBilling.commonOptions": "Viser koblinger som passer alle valgte timer. Ved fakturakobling må timene være innleide; juster dekning per føring. Eksisterende koblinger erstattes bare når du velger en ny verdi.",
        "hourBilling.selection": "{{count}} valgte føringer",
        "hourBilling.entries": "Timeføringer",
        "hourBilling.current": "Nåværende status",
        "hourBilling.notInvoiced": "Ikke fakturert kunde",
        "hourBilling.invoiceRef": "Faktura #{{id}} · {{hours}} t dekket",
        "hourBilling.saveSelected": "Lagre for valgte timer",
        "hourBilling.discard": "Forkaste ulagrede endringer?",
        "hourBilling.conflict": "En av timene er endret siden du åpnet dialogen. Ingen endringer ble lagret. Hent siste versjon og velg endringene på nytt.",
        "hourBilling.selectEntries": "Velg timer for avstemming",
        "hourBilling.visiblePeriod": "Velg blant timeføringene i perioden og filteret du viser.",
        "hourBilling.selectAll": "Velg alle viste",
        "hourBilling.limit": "Velg maksimalt 100 føringer om gangen.",
        "common.retry": "Prøv igjen",
        "common.save": "Lagre",
        "project.billing_plan.save_settings_failed": "Kunne ikke bekrefte lagring av innstillingene.",
        "announcements.title": "Varsler og nyhetsbrev",
        "announcements.previousMessage": "Forrige melding",
        "announcements.deactivated": "Deaktivert",
        "announcements.deactivate": "Deaktiver melding",
        "announcements.reactivate": "Aktiver igjen",
        "announcements.stopHint": "Avslutt meldingen før sluttdatoen uten å slette innholdet.",
        "announcements.inactiveHint": "Meldingen er deaktivert. Innhold og datoer er beholdt.",
        "announcements.deactivateHint": "Meldingen skjules, og e-post som fortsatt venter i kø kanselleres. Allerede sendt eller påbegynt e-post kan ikke trekkes tilbake. Åpne dashboard oppdateres innen ett minutt; offentlige sider ved neste innlasting.",
        "announcements.reactivateHint": "Opprinnelige publiseringsvalg og datoer gjelder igjen. Utløpte meldinger må få ny sluttdato for å vises. Kansellert e-post sendes ikke automatisk på nytt.",
        "announcements.confirmDeactivate": "Ja, deaktiver",
        "announcements.confirmReactivate": "Ja, aktiver igjen",
        "announcements.deactivatedResult": "Meldingen er deaktivert. Ventende e-post er kansellert.",
        "announcements.reactivatedResult": "Meldingen er aktivert igjen med opprinnelige publiseringsvalg og datoer.",
        "announcements.activationNotApplied": "Gjeldende status er uendret. Du kan forsøke handlingen på nytt.",
        "announcements.activationFailed": "Handlingen ble avvist. Kontroller tilgang og oppdater siden.",
        "announcements.activationUnknown": "Resultatet kunne ikke bekreftes. Kontroller status før du prøver igjen.",
        "announcements.checkStatus": "Kontroller status",
        "announcements.nextMessage": "Neste melding",
        "announcements.new": "Ny melding",
        "announcements.body": "Innhold",
        "announcements.audience": "Målgruppe",
        "announcements.admin": "Kun admin",
        "announcements.users": "Alle brukere",
        "announcements.public": "Offentlig på nettsiden",
        "announcements.in_app": "Vis i app / på nettside",
        "announcements.email_enabled": "Aktiver e-post",
        "announcements.published": "Publisert",
        "announcements.draft": "Utkast",
        "announcements.starts_at": "Fra (valgfritt)",
        "announcements.ends_at": "Til (valgfritt)",
        "announcements.publicHint": "Publiserte offentlige meldinger vises på firmaets åpne meldingsside og er tilgjengelige for nettsideintegrasjoner. Innholdet er synlig for alle.",
        "announcements.openPublic": "Åpne offentlig meldingsside",
        "announcements.recipients": "Valgte e-postmottakere",
        "announcements.emailHint": "Lagre først. Sending bruker et øyeblikksbilde og sendes én gang per mottaker. Startdato planlegger sending. Ukjent utfall sendes ikke automatisk på nytt.",
        "announcements.send": "Send / planlegg e-post til valgte",
        "announcements.refresh": "Oppdater leveringsstatus",
        "announcements.queued": "E-post er lagt i kø. Se leveringsstatus nedenfor.",
        "announcements.saved": "Meldingen er lagret.",
        "announcements.loadFailed": "Kunne ikke hente meldinger.",
        "announcements.saveFailed": "Kunne ikke lagre. Utkastet er beholdt.",
        "announcements.delivery.pending": "Venter",
        "announcements.delivery.sending": "Sending pågår – kontroller ved lang ventetid",
        "announcements.delivery.sent": "Sendt",
        "announcements.delivery.unknown": "Ukjent utfall – kontroller e-postloggen",
        "announcements.delivery.failed": "Feilet",
        "announcements.delivery.cancelled": "Avbrutt",
        "documentUpload.attachments.pick": "Legg til dokument eller bilde",
        "documentUpload.attachments.add": "Legg til",
        "statusAttachments.attachmentPost": "Oppdatering med vedlegg",
        "statusAttachments.backgroundHint": "Vedlegg lastes opp i bakgrunnen etter publisering. Hold Promang åpent til opplastingen er ferdig.",
        "statusPhotos.photoPost": "Bildeoppdatering",
        "statusPhotos.destination": "Oppdatering #{{id}}",
        "statusPhotos.backgroundHint": "Bildene lastes opp i bakgrunnen etter publisering. Hold Promang åpent til opplastingen er ferdig.",
        "accounting.project_summary.methodology.labor_primary_mixed": "Bokførte lønnskostnader pluss estimat for timer uten bilags- eller fakturadekning. Avstem timer mot riktig lønnsbilag.",
        "project.summary.labor_source_mixed": "Bokført lønn og estimat for uavstemte timer",
        "project.summary.load_failed": "Kunne ikke laste prosjektsammendrag",
        "project.copy.success": "Kopiert til utklippstavle",
        "project.copy.failed": "Kunne ikke kopiere",
        "accounting.project_summary.labor_source_mixed": "Bokført lønn og estimat for uavstemte timer",
        "accounting.summary.labor_source_mixed": "Bokført lønn og estimat for uavstemte timer",
        "hourBilling.title": "Fakturering og kostnadsavstemming",
        "hourBilling.customer": "Fakturert kunde",
        "hourBilling.hired": "Innleid",
        "hourBilling.supplierInvoiced": "Innleie fakturert",
        "hourBilling.reminder": "Mangler fakturadekning",
        "hourBilling.order": "Knytt til ordre",
        "hourBilling.orderHint": "En fakturert ordre markerer automatisk timen som fakturert kunde.",
        "hourBilling.invoice": "Leverandørfaktura (forslag fra prosjekt/leverandør)",
        "hourBilling.invoiceHint": "Koblingen dekker kostnad, uavhengig av markeringene over. Resterende timer beholder estimert kostnad.",
        "hourBilling.coveredHours": "Timer på faktura",
        "hourBilling.rate": "Timepris eks. mva.",
        "hourBilling.salaryVoucher": "Avstemt mot lønnsbilag",
        "hourBilling.salaryHint": "Velg bare bilaget som faktisk dekker disse timene. Bokføringsdato fastslår ikke opptjeningsperioden.",
        "hourBilling.none": "Ingen kobling",
        "hourBilling.loadFailed": "Kunne ikke hente timeoppfølging.",
        "hourBilling.saveFailed": "Kunne ikke lagre timeoppfølging. Utkastet er beholdt.",
        "hourBilling.saved": "Faktureringsoppfølging lagret.",
        "hourBilling.followup": "Fakturaoppfølging timer",
        "hourBilling.followupHint": "Innleide timer uten full fakturadekning. Åpne en time for fakturaforslag og avstemming.",
        "hourBilling.noReminders": "Ingen innleide timer mangler fakturadekning.",
        "service.agreements.subs.edit": "Rediger inkludert anlegg",
        "service.agreements.subs.saved": "Anlegget er oppdatert.",
        "service.agreements.subs.save_failed": "Kunne ikke lagre anlegget.",
        "customer.systems.linked_customer": "Tilknyttet kunde",
        "customer.systems.move_hint": "Velg en annen kunde for å flytte anlegget, eller fjern kunden. Tidligere rapporter og historikk beholdes.",
        "customer.systems.save_failed": "Kunne ikke lagre anlegget.",
        "customer.systems.connections_history": "Tilknytninger og historikk",
        "customer.systems.load_failed": "Kunne ikke hente anleggsdata.",
        "customer.systems.no_customer": "Ingen kunde tilknyttet",
        "customer.systems.history_limit": "Viser de 100 siste oppføringene og tilknytningene du har tilgang til.",
        "customer.systems.all_title": "Anlegg",
        "deliveryRegistry.title": "Leveringsadresser",
        "deliveryRegistry.save": "Lagre",
        "deliveryRegistry.register": "Adresseregister",
        "deliveryRegistry.intro": "Oversikt over leveringsadresser registrert på firmaet. Finn, opprett og vedlikehold adresser som brukes i Promang.",
        "deliveryRegistry.search": "Søk på navn, adresse, postnummer eller poststed",
        "deliveryRegistry.new": "Ny leveringsadresse",
        "deliveryRegistry.edit": "Rediger adresse",
        "deliveryRegistry.editHint": "Endringer lagres på samme adresse og gjelder der adressen brukes. Kontroller navn og land før du lagrer.",
        "deliveryRegistry.newHint": "Opprett en leveringsadresse for firmaet. Adressen blir tilgjengelig i Promangs adressevelgere.",
        "deliveryRegistry.name": "Navn / mottaker",
        "deliveryRegistry.address": "Adresse",
        "deliveryRegistry.address2": "Adresselinje 2",
        "deliveryRegistry.postal": "Postnummer",
        "deliveryRegistry.place": "Poststed",
        "deliveryRegistry.country": "Land",
        "deliveryRegistry.optional": "(valgfritt)",
        "deliveryRegistry.selectCountry": "Velg land",
        "deliveryRegistry.required": "Feltet må fylles ut.",
        "deliveryRegistry.validCountry": "Velg en gyldig landkode.",
        "deliveryRegistry.loading": "Henter adresser…",
        "deliveryRegistry.loadFailed": "Kunne ikke hente adressene.",
        "deliveryRegistry.results": "{{count}} adresser funnet",
        "deliveryRegistry.empty": "Ingen adresser funnet",
        "deliveryRegistry.emptyHint": "Prøv et annet søk, fjern et filter eller opprett en ny adresse.",
        "deliveryRegistry.refresh": "Oppdater",
        "deliveryRegistry.complete": "Komplett",
        "deliveryRegistry.incomplete": "Mangler opplysninger",
        "deliveryRegistry.unnamed": "Adresse uten navn",
        "deliveryRegistry.previous": "Forrige",
        "deliveryRegistry.next": "Neste",
        "deliveryRegistry.page": "Side {{page}} av {{pages}}",
        "deliveryRegistry.discard": "Forkaste ulagrede adresseendringer?",
        "deliveryRegistry.saved": "Adressen er lagret.",
        "deliveryRegistry.saving": "Lagrer…",
        "deliveryRegistry.saveFailed": "Adressen kunne ikke lagres. Endringene er beholdt.",
        "deliveryRegistry.unknown": "Lagringsresultatet er ukjent. Kontroller status før du fortsetter.",
        "deliveryRegistry.createUnknown": "Lagringsresultatet er ukjent. Lukk dialogen og oppdater oversikten for å se om adressen er opprettet før du prøver igjen.",
        "deliveryRegistry.conflict": "Adressen er endret siden du åpnet den. Hent siste versjon og kontroller endringene før du lagrer.",
        "deliveryRegistry.reload": "Hent siste versjon",
        "deliveryRegistry.checkStatus": "Kontroller status",
        "deliveryRegistry.refreshWarning": "Adressen er lagret, men listen kunne ikke oppdateres. Lukk dialogen og oppdater oversikten.",
        "customer.systems.register": "Anleggsregister",
        "customerSettings.title": "Kundeinnstillinger",
        "customerSettings.eyebrow": "Kunder",
        "customerSettings.intro": "Administrer anleggstyper og frakttyper for firmaet. Endringene blir tilgjengelige i de eksisterende kunde-, anleggs- og ordreflytene.",
        "customerSettings.systems": "Anleggstyper",
        "customerSettings.systems_hint": "Typene som brukes når anlegg opprettes og filtreres.",
        "customerSettings.shipping": "Frakttyper",
        "customerSettings.shipping_hint": "Leveringsvalg, priser og tilgjengelighet for ordre og tilbud.",
        "customerSettings.add": "Legg til",
        "customerSettings.loading": "Laster innstillinger…",
        "customerSettings.load_failed": "Kunne ikke laste innstillingene.",
        "customerSettings.empty": "Ingen typer opprettet ennå.",
        "customerSettings.name": "Navn",
        "customerSettings.description": "Beskrivelse",
        "customerSettings.active": "Aktiv",
        "customerSettings.inactive": "Inaktiv",
        "customerSettings.public": "Tilgjengelig offentlig",
        "customerSettings.free": "Gratis frakt",
        "customerSettings.flat": "Fast pris",
        "customerSettings.calculate": "Beregn fraktpris",
        "customerSettings.price": "Pris eks. mva.",
        "customerSettings.price_value": "{{value}} eks. mva.",
        "customerSettings.free_over_ordertotal": "Gratis frakt over ordrebeløp",
        "customerSettings.shipping_help": "Inaktive frakttyper beholdes i innstillingene og kan aktiveres igjen. Beløp oppgis uten merverdiavgift.",
        "customerSettings.save": "Lagre",
        "customerSettings.saving": "Lagrer…",
        "customerSettings.saved": "Innstillingen er lagret.",
        "customerSettings.save_failed": "Kunne ikke lagre. Kontroller feltene og prøv igjen.",
        "customerSettings.title_required": "Oppgi et navn.",
        "customerSettings.invalid_price": "Beløp må være tall som er 0 eller større.",
        "customerSettings.unknown": "Vi fikk ikke bekreftet lagringen. Lukk og oppdater oversikten for å kontrollere resultatet før du forsøker på nytt.",
        "customerSettings.discard": "Forkaste ulagrede endringer?",
        "customerSettings.no_access": "Du har ikke tilgang til kundeinnstillinger.",
        "customer.systems.type_filter": "Anleggstype",
        "customer.systems.previous": "Forrige",
        "customer.systems.next": "Neste",
        "customer.systems.register_intro": "Finn anlegg, kunder og historikk på ett sted. Søk etter modell, produsent, serienummer eller artikkelnummer.",
        "customer.systems.searching": "Søker etter anlegg…",
        "customer.systems.search_complete": "Søk fullført · {{count}} anlegg på side {{page}}",
        "customer.systems.results": "{{count}} anlegg funnet",
        "customer.systems.page": "Side {{page}} av {{pages}}",
        "customer.systems.no_matches": "Ingen anlegg samsvarer med søket.",
        "customer.systems.search_help": "Prøv et annet søkeord eller fjern et filter.",
        "customer.systems.types_failed": "Anleggstypene kunne ikke lastes. Du kan fortsatt søke.",
        "customer.systems.refresh": "Oppdater",
        "customer.systems.serial_label": "Serienummer",
        "customer.systems.not_set": "Ikke oppgitt",
        "customer.systems.open_details": "Åpne anlegg og historikk",
        "customer.systems.merge_intro": "Finn anlegget du vil beholde. Søk i alle firmaets anlegg og kontroller valget før du knytter dem sammen.",
        "customer.systems.merge_from": "Anlegget som fjernes",
        "customer.systems.merge_keep": "Anlegget som beholdes",
        "customer.systems.clear_target": "Fjern valgt målanlegg",
        "customer.systems.merge_review": "Rapport- og serviceavtalekoblinger flyttes fra «{{source}}» til «{{target}}». Kilden fjernes fra oversikten. Kontroller at dette er samme fysiske anlegg.",
        "customer.systems.duplicates_count": "Andre anlegg med serienummeret: {{count}}",
        "customer.systems.duplicates_hint": "Mulige dubletter. Kontroller kunde, adresse og at dette er samme fysiske anlegg. Opplysningene på anlegget som beholdes endres ikke.",
        "customer.systems.duplicates_recommend": "Foreslått å beholde: {{title}} (#{{id}})",
        "customer.systems.duplicates_reason": "Forslaget har flest utfylte grunnopplysninger. Ved likt antall foreslås laveste ID.",
        "customer.systems.duplicates_review": "Vurder sammenslåing med #{{id}}",
        "customer.systems.duplicates_more": "{{count}} flere treff. Søk på serienummeret i dialogen for å se flere.",
        "customer.systems.merge_unknown": "Resultatet er ikke bekreftet. Kontroller status før du gjør noe mer; sammenkoblingen kan allerede være utført.",
        "customer.systems.check_merge": "Kontroller status",
        "customer.systems.refresh_warning": "Endringen er lagret, men oversikten kunne ikke oppdateres. Last listen på nytt.",
        "customer.systems.search": "Søk på serienummer, modell, artikkelnummer eller leveringsadresse",
        "customer.systems.all_types": "Alle typer",
        "customer.systems.history_action.create": "Opprettet",
        "customer.systems.history_action.update": "Oppdatert",
        "customer.systems.history_action.move": "Kunde endret",
        "customer.systems.history_action.merge": "Anlegg slått sammen",
        "project.item_list.saving_quantity": "Lagrer antall…",
        "statistics.date_from": "Fra dato",
        "statistics.date_to": "Til dato",
        "statistics.apply": "Vis periode",
        "statistics.all_time": "Hele perioden",
        "statistics.date_hint": "Filtrerer på datoen saken ble opprettet. Begge datoer er inkludert.",
        "statistics.invalid_period": "Fra-dato må være før eller lik til-dato.",
        "statistics.load_error": "Kunne ikke hente statistikk.",
        "statistics.cases_by_label": "Saker per etikett",
        "statistics.no_labels_with_cases": "Ingen etiketter med saker ennå",
        "project.item_list.reopen": "Åpne for redigering",
        "project.item_list.reopening": "Åpner varelisten for redigering…",
        "project.item_list.pdf_loading": "Lager PDF…",
        "offers.workspace.add_suggestions": "Legg valgte forslag til tilbudslinjer",
        "offers.workspace.suggestions_added": "Forslagene er lagt til. Kontroller mengder og fyll inn priser.",

        "offers.workspace.check_calculation": "Kalkylen inneholder beregningsfeil som må rettes.",
        "offers.workspace.conversion": "Fra tilbud til prosjekt",
        "offers.workspace.conversion_hint": "Det opprettes et prosjekt med tilbudets kunde og kontaktopplysninger. Aktiviteter og ordre opprettes når grunnlaget støtter det. Avtalt pris og ordre bruker akseptert revisjon når den finnes.",
        "offers.workspace.conversion_confirm": "Opprett prosjekt",

        "offers.workspace.conflict": "Tilbudet er endret av andre",
        "offers.workspace.conflict_hint": "Endringer i ulike felt flettes sammen. Velg hvilken verdi som skal brukes når samme felt er endret.",
        "offers.workspace.mine": "Min verdi",
        "offers.workspace.theirs": "Siste lagrede verdi",
        "offers.workspace.merge": "Flett og lagre",
        "offers.workspace.conflict_use_server": "Bruk siste lagrede versjon",
        "offers.workspace.conflict_resolve": "Velg verdi for hvert felt som er endret begge steder.",

        "offers.workspace.extract": "Les tekst fra PDF",
        "offers.workspace.extracting": "Leser sider …",
        "offers.workspace.extract_failed": "Kunne ikke hente lesbar PDF-tekst. Skannede dokumenter trenger tekstgjenkjenning; du kan lime inn teksten.",
        "offers.workspace.template_tests": "Test kalkylemalen",
        "offers.workspace.template_tests_hint": "Lagre et sett inndata med forventet pris. Testene bruker gjeldende beregningslogikk og endrer ikke tilbudet.",
        "offers.workspace.template_tests_empty": "Ingen lagrede tester ennå.",
        "offers.workspace.test_name": "Navn på testeksempel",
        "offers.workspace.expected": "Forventet pris",
        "offers.workspace.save_test": "Lagre test med disse inndataene",

        "offers.workspace.advanced": "Vis flere felt",
        "offers.workspace.purchase_price": "Kostpris per enhet",
        "offers.workspace.alternative_group": "Alternativgruppe",
        "offers.workspace.price_source": "Priskilde",
        "offers.workspace.price_dated_at": "Prisdato",
        "offers.workspace.discard_draft": "Forkast ulagret linje",
        "offers.workspace.outgoing": "Vedlegg til kunden",
        "offers.workspace.outgoing_hint": "Velg hvilke filer som skal sendes med tilbudet. Øvrige filer er arbeidsgrunnlag. Maksimalt 20 MB totalt.",
        "offers.workspace.outgoing_count": "Valgte vedlegg til kunden: {{count}}",
        "offers.workspace.delivery_queued": "Tilbudet venter på sending",
        "offers.workspace.delivery_processing": "Tilbudet sendes",
        "offers.workspace.delivery_sent": "Tilbudet er sendt",
        "offers.workspace.delivery_failed": "Sendingen feilet. Kontroller leveringen før nytt sendeforsøk.",
        "offers.workspace.delivery_finalization_failed": "E-post er sendt, men arkivering av revisjonen feilet. Ikke send på nytt.",
        "offers.workspace.delivery_draft_creation_failed": "Tilbudet er sendt. Neste utkast kunne ikke opprettes. Ikke send på nytt.",

        "offers.workspace.area_price": "Pris og kalkyle",
        "offers.workspace.area_document": "Kundedokument",
        "offers.workspace.area_activity": "Aktivitet",

        "offers.workspace.start": "Velg utgangspunkt",
        "offers.workspace.start_quick": "Raskt tilbud",
        "offers.workspace.start_quick_hint": "Skriv inn linjer og priser. Klar på få steg.",
        "offers.workspace.start_quick_detail": "Åpner kundevisning / tilbudslinjer. Best når du allerede vet prisene og ikke trenger kalkyle med timer, material og påslag.",
        "offers.workspace.start_template": "Bruk kalkylemal",
        "offers.workspace.start_template_hint": "Gjenbruk fagkunnskap og tilpass mengdene.",
        "offers.workspace.start_template_detail": "Åpner kalkyle og malvelger med en gang. Du kopierer en firmamal (eventuelt med veiviser) og tilpasser mengder — malen endres ikke.",
        "offers.workspace.start_detailed": "Detaljert kalkyle",
        "offers.workspace.start_detailed_hint": "Bygg opp fag, materialer, timer og påslag.",
        "offers.workspace.start_detailed_detail": "Åpner tom kalkyle-arbeidsflate. Bygg linjer, produkter, timer og struktur fra scratch — uten mal.",
        "offers.workspace.start_selected_label": "Valgt start",
        "offers.create.start_heading": "Hvordan vil du starte?",
        "offers.create.start_intro": "Alle tre lager samme type tilbud. Forskjellen er hvor du begynner å jobbe — du kan alltid bytte fane senere.",
        "offers.workspace.add_line": "Legg til linje",
        "offers.workspace.move_line": "Flytt linje",
        "offers.workspace.add_product": "Legg til produkt",
        "offers.workspace.add_selected_products": "Legg til valgte produkter",
        "offers.workspace.paste": "Lim inn fra regneark",
        "offers.workspace.paste_hint": "Tre kolonner: beskrivelse, mengde og enhetspris.",
        "offers.workspace.paste_error": "Kontroller at hver rad har beskrivelse, mengde og pris, skilt med tabulator.",
        "offers.workspace.bulk_discount": "Rabatt på valgte linjer (%)",
        "offers.workspace.apply": "Bruk endringene",
        "offers.workspace.select": "Velg linje",
        "offers.workspace.duplicate": "Dupliser linje",
        "offers.workspace.cancel": "Avbryt",
        "offers.workspace.retry": "Prøv lagring igjen",
        "offers.workspace.save_saved": "Alle endringer er lagret",
        "offers.workspace.save_pending": "Endringer venter på lagring",
        "offers.workspace.save_saving": "Lagrer endringer …",
        "offers.workspace.save_error": "Endringene er ikke lagret. Prøv igjen før du fortsetter.",
        "offers.workspace.regenerate_hint": "Kundelinjer fra kalkylen oppdateres. Manuelle linjer beholdes. Kontroller kundetilpasninger før du fortsetter.",
        "offers.workspace.empty_title": "Hva skal du levere?",
        "offers.workspace.empty_hint": "Legg til din første linje eller lim inn et prisoppsett. Du kan legge til detaljert kalkyle senere.",
        "offers.workspace.customer_total": "Tilbudspris eks. mva. · uten valgfrie tillegg",
        "offers.workspace.inclusion": "Inngår i tilbudet",
        "offers.workspace.included": "Inkludert",
        "offers.workspace.optional": "Valgfritt tillegg",
        "offers.workspace.excluded": "Tatt ut",
        "offers.workspace.review": "Kontroll og sending",
        "offers.workspace.review_hint": "Kontroller pris, innhold og mottaker før tilbudet sendes.",
        "offers.workspace.check_customer": "Velg kunde for tilbudet.",
        "offers.workspace.check_empty": "Legg til minst én inkludert tilbudslinje.",
        "offers.workspace.check_description": "En eller flere linjer mangler beskrivelse.",
        "offers.workspace.check_price": "En eller flere inkluderte linjer har nullpris.",
        "offers.workspace.check_quantity": "Mengden må være større enn null.",
        "offers.workspace.check_expired": "Tilbudets gyldighetsdato har passert.",
        "offers.workspace.check_margin": "Kostnadene er høyere enn tilbudsprisen.",
        "offers.workspace.check_alternatives": "En alternativgruppe har mer enn ett inkludert valg.",
        "offers.send.missing_id": "Tilbuds-ID mangler. Lagre tilbudet før sending.",
        "offers.workspace.cover.title": "Forside",
        "offers.workspace.cover.subtitle": "Konfigurer forside for PDF-eksport av tilbudet.",
        "offers.workspace.cover.active": "Aktiv",
        "offers.workspace.cover.inactive": "Inaktiv",
        "offers.workspace.cover.field_title": "Tittel",
        "offers.workspace.cover.title_placeholder": "Skriv inn tittel for forside…",
        "offers.workspace.cover.title_hint": "Tittelen vises på forsiden av PDF-en",
        "offers.workspace.cover.description": "Beskrivelse",
        "offers.workspace.cover.description_placeholder": "Skriv inn beskrivelse for forside…",
        "offers.workspace.cover.image": "Forsidebilde",
        "offers.workspace.cover.selected_image": "Valgt forsidebilde: {{title}}",
        "offers.workspace.cover.no_image_title": "Ingen tittel",
        "offers.workspace.cover.image_first_hint": "Det første bildet du laster opp vil bli brukt som forsidebilde",
        "offers.workspace.cover.image_pdf_hint": "Bildet vil vises på hele forsiden i PDF-en",
        "offers.workspace.cover.inactive_hint": "Aktiver forside for å konfigurere innholdet.",
        "offers.workspace.fix": "Åpne",
        "offers.workspace.ready": "Ingen mangler funnet i linjekontrollen.",
        "offers.workspace.explain": "Hvorfor denne prisen?",
        "offers.workspace.scenario": "Hva hvis?",
        "offers.workspace.scenario_hint": "Prøv en endring uten å endre tilbudet. Beregningen gjelder samlet salg og kostnad.",
        "offers.workspace.sales_change": "Endring i salgspris (%)",
        "offers.workspace.cost_change": "Endring i kostnad (%)",
        "offers.workspace.cost": "Kostnad",
        "offers.workspace.margin": "Dekningsbidrag",
        "offers.workspace.cost_unknown": "Kostnadsgrunnlaget er ikke tilgjengelig.",
        "offers.workspace.reset": "Nullstill scenario",
        "offers.workspace.preview": "Åpne PDF",
        "offers.workspace.send": "Send tilbud",
        "offers.workspace.layout": "Dokumentformat",
        "offers.workspace.layout_simple": "Enkelt tilbudsark",
        "offers.workspace.layout_document": "Utformet tilbudsdokument",
        "offers.simpleDocument.info_title": "Tilbudsinfo",
        "offers.simpleDocument.info_hint": "Enkelt tilbudsark uten forside, tilbudsbrev og blokkstruktur. Samme innhold som PDF — enkelt.",
        "offers.simpleDocument.meta_customer": "Kunde",
        "offers.simpleDocument.meta_project": "Prosjekt",
        "offers.simpleDocument.meta_reference": "Referanse",
        "offers.simpleDocument.meta_offer_date": "Tilbudsdato",
        "offers.simpleDocument.meta_valid_to": "Gyldig til",
        "offers.simpleDocument.meta_contact": "Kontakt",
        "offers.simpleDocument.upgrade": "Bygg fullt tilbudsdokument",
        "offers.simpleDocument.upgrading": "Bytter…",
        "offers.simpleDocument.upgrade_success": "Dokumentbyggeren er klar",
        "offers.simpleDocument.upgrade_failed": "Kunne ikke bytte til fullt dokument",
        "offers.documentBuilder.switch_to_simple": "Bytt til enkelt tilbudsark",
        "offers.documentBuilder.switching_to_simple": "Bytter…",
        "offers.documentBuilder.switch_to_simple_confirm": "Bytte til enkelt tilbudsark? Blokkstrukturen (forside, brev og seksjoner) slettes og kan ikke angres.",
        "offers.documentBuilder.switch_to_simple_success": "Enkelt tilbudsark er aktivt",
        "offers.documentBuilder.switch_to_simple_failed": "Kunne ikke bytte til enkelt ark",
        "offers.workspace.undo": "Angre",
        "offers.workspace.redo": "Gjør om",
        "offers.workspace.density": "Tetthet",
        "offers.workspace.normal": "Normal",
        "offers.workspace.compact": "Kompakt",
        "offers.workspace.ai_source": "Analysen trenger dokumenttekst. Valg av fil alene leser ikke innholdet. Lim inn relevant tekst med sidehenvisninger.",
        "offers.workspace.title": "Beskrivelse",
        "offers.workspace.description": "Detaljbeskrivelse",
        "offers.workspace.quantity": "Mengde",
        "offers.workspace.sales_price": "Enhetspris",
        "offers.workspace.surcharge": "Påslag",
        "offers.workspace.unit_id": "Enhet",
        "offers.workspace.offer_group_id": "Gruppe",
        "offers.workspace.pricing_role": "Prisrolle",
        "offers.workspace.visible_to_customer": "Synlig for kunde",
        "offers.workspace.deleted": "Slettet linje",
        "offers.workspace.unsaved_leave": "Du har ulagrede endringer. Vil du forlate siden uten å lagre?",
        "offers.workspace.discount": "Rabatt (%)",
        "offers.workspace.total": "Sum",
        "offers.workspace.unit": "Enhet",
        "offers.workspace.remove_line": "Fjern linje",
        "offers.workspace.customer_email_missing": "Kundens e-post mangler",
        "offers.workspace.contact_email_missing": "Kontaktens e-post mangler",

        "loading.boot.initializing": "Klargjør arbeidsområdet",
        "loading.boot.syncing": "Synkroniserer modulene dine",
        "loading.boot.linking": "Oppretter sikker tilkobling",
        "loading.boot.finalizing": "Fullfører — nesten klart",
        "user_profile.title": "Brukerprofil",
        "user_profile.empty_value": "Ikke angitt",
        "user_profile.load_failed": "Kunne ikke laste profilen",
        "user_profile.load_failed_body": "Prøv å laste siden på nytt.",
        "user_profile.no_changes": "Ingen endringer å lagre",
        "user_profile.ignored_fields_notice": "Noen felt ble ikke lagret fordi de er låst",
        "user_profile.email_locked_hint": "Innloggings-e-post kan ikke endres her.",
        "user_profile.private_email_hint": "Valgfri privat adresse. Vises i e-postvelgeren ved sending av dokumenter.",
        "user_profile.field_locked_hint": "Dette feltet er låst og kan kun endres av en administrator.",
        "user_profile.add_field": "Legg til {{field}}",
        "user_profile.validation.name_required": "Navn er påkrevd",
        "user_profile.field.name": "Navn",
        "user_profile.field.email": "Jobb-e-post",
        "user_profile.field.private_email": "Privat e-post",
        "user_profile.field.mobile": "Privat mobil",
        "user_profile.field.mobile_work": "Jobbmobil",
        "user_profile.field.address": "Adresse",
        "user_profile.field.postal": "Postnr.",
        "user_profile.field.place": "Sted",
        "user_profile.field.birth_date": "Fødselsdato",
        "user_profile.field.social_security": "Fødselsnummer",
        "user_profile.field.account_number": "Kontonummer",
        "user_profile.section.contact": "Kontaktinformasjon",
        "user_profile.section.address": "Adresse",
        "user_profile.section.personal_details": "Personopplysninger",
        "user_profile.section.personal_details_hint": "Sensitive felt styres av tilgangen din.",
        "user_profile.section.children": "Barn",
        "user_profile.section.next_of_kin": "Pårørende",
        "user_profile.related_records.add": "Legg til",
        "user_profile.related_records.edit": "Rediger",
        "user_profile.related_records.delete": "Slett",
        "user_profile.related_records.actions": "Handlinger",
        "user_profile.related_records.active_count": "aktive",
        "user_profile.related_records.deactivated": "Deaktivert",
        "user_profile.related_records.deactivate_confirm": "Er du sikker på at du vil deaktivere denne oppføringen? Oppføringen vises fortsatt, men som deaktivert.",
        "user_profile.related_records.validation.name_required": "Navn er påkrevd",
        "user_profile.related_records.dialog.create_title": "Legg til oppføring",
        "user_profile.related_records.dialog.edit_title": "Rediger oppføring",
        "user_profile.related_records.dialog.save": "Lagre",
        "user_profile.related_records.dialog.saving": "Lagrer…",
        "user_profile.related_records.dialog.cancel": "Avbryt",
        "user_profile.related_records.save_success": "Oppføringen ble lagret",
        "user_profile.related_records.save_failed": "Kunne ikke lagre oppføringen",
        "user_profile.related_records.deactivate_success": "Oppføringen ble deaktivert",
        "user_profile.related_records.deactivate_failed": "Kunne ikke deaktivere oppføringen",
        "user_profile.children.empty_title": "Ingen barn lagt til",
        "user_profile.children.empty_desc": "Bruk pluss-knappen for å legge til barn.",
        "user_profile.children.field.name": "Navn",
        "user_profile.children.field.birth_date": "Fødselsdato",
        "user_profile.children.field.sole_custody": "Alene omsorg",
        "user_profile.children.field.extended_rights": "Utvidet rett",
        "user_profile.children.validation.birth_date_required": "Fødselsdato er påkrevd",
        "user_profile.next_of_kin.empty_title": "Ingen pårørende lagt til",
        "user_profile.next_of_kin.empty_desc": "Bruk pluss-knappen for å legge til pårørende.",
        "user_profile.next_of_kin.field.name": "Navn",
        "user_profile.next_of_kin.field.relationship_type": "Relasjon",
        "user_profile.next_of_kin.field.phone_number": "Telefon",
        "user_profile.next_of_kin.field.address": "Adresse",
        "user_profile.next_of_kin.validation.relationship_required": "Relasjon er påkrevd",
        "user_profile.next_of_kin.relationship.placeholder": "Velg relasjon",
        "user_profile.next_of_kin.relationship.SPOUSE": "Ektefelle",
        "user_profile.next_of_kin.relationship.PARTNER": "Partner",
        "user_profile.next_of_kin.relationship.PARENT": "Forelder",
        "user_profile.next_of_kin.relationship.CHILD": "Barn",
        "user_profile.next_of_kin.relationship.SIBLING": "Søsken",
        "user_profile.banner.employee_title": "Du er registrert som ansatt",
        "user_profile.banner.employee_body": "Du har tilgang til ansettelsesinformasjon og lønnslipper.",
        "user_profile.banner.hired_title": "Du er registrert som innleid",
        "user_profile.banner.hired_body": "Du er innleid og har ikke en ansettelse i denne bedriften.",
        "user_profile.tab.profile": "Profil",
        "user_profile.tab.email": "E-post",
        "user_profile.tab.employment": "Ansettelse",
        "user_profile.email.signature_title": "E-postsignatur",
        "user_profile.email.signature_help":
          "Signaturen settes inn automatisk når du sender e-post til kunden — ikke mens du skriver utkastet.",
        "user_profile.email.signature_placeholder": "Vennlig hilsen …",
        "user_profile.email.save": "Lagre signatur",
        "user_profile.employment.not_employee_title": "Ingen ansettelse",
        "user_profile.employment.not_employee_body": "Innleide brukere har ikke en ansettelse.",
        "user_profile.employment.none_title": "Ansettelse mangler",
        "user_profile.employment.none_body": "Det er ikke opprettet en ansettelse for deg ennå.",
        "user_profile.employment.title": "Ansettelsesinformasjon",
        "user_profile.employment.read_only_hint": "Disse opplysningene er kun til visning.",
        "user_profile.employment.working_posistion": "Stilling",
        "user_profile.employment.employee_number": "Ansattnummer",
        "user_profile.employment.employment_starts": "Ansettelsesdato",
        "user_profile.employment.agreement_type": "Avtaletype",
        "user_profile.employment.workplace": "Arbeidssted",
        "user_profile.employment.wages": "Lønn",
        "user_profile.employment.worktime": "Arbeidstid",
        "user_profile.employment.signed_at": "Signert dato",
        "user_profile.employment.signed_place": "Signert sted",
        "user_profile.employment.contract_title": "Arbeidsavtale",
        "user_profile.employment.contract_signed": "Arbeidsavtalen er signert",
        "user_profile.employment.download_contract": "Last ned signert avtale",
        "user_profile.employment.contract_unsigned_title": "Ikke signert",
        "user_profile.employment.contract_unsigned_body": "Arbeidsavtalen er ikke signert ennå.",
        "user_profile.quicklinks.payslips_title": "Lønnslipper",
        "user_profile.quicklinks.payslips_body": "Se og last ned dine lønnslipper",
        "user_profile.quicklinks.handbook_title": "Personalhåndbok",
        "user_profile.quicklinks.handbook_body": "Rutiner, retningslinjer og dokumenter",
        "user_profile.handbook.documents_hint": "KS/HMS-dokumenter til gjennomlesing",
        "user_profile.handbook.chapters_hint": "Kapitler i personalhåndboken",
        "user_profile.handbook.forms_hint": "Skjemaer du kan fylle ut",
        "user_profile.handbook.events_hint": "Registrerte hendelser",
        "user_profile.confirm.title": "Bekreft endringer",
        "user_profile.confirm.intro": "Kontroller endringene før du lagrer.",
        "user_profile.confirm.children_changed": "Endringer i barn",
        "user_profile.confirm.kin_changed": "Endringer i pårørende",
        "user_profile.confirm.confirm_button": "Bekreft og lagre",
        "user_profile.history.title": "Endringshistorikk",
        "user_profile.history.open": "Historikk",
        "user_profile.history.no_changes": "Ingen endringer registrert",
        "user_profile.history.empty_title": "Ingen historikk",
        "user_profile.history.empty_body": "Det finnes ingen endringer å vise ennå.",
        "user_profile.history.action_revert": "Tilbakestilt",
        "user_profile.history.action_update": "Oppdatert",
        "user_profile.history.reverted_from": "Tilbakestilt fra versjon #{{id}}",
        "user_profile.history.restore": "Gjenopprett denne versjonen",
        "loading.boot.secure_session": "sikker økt",
        "common.tabs.more": "Flere",
        "employeeSelector.hired_badge": "Innleid",
        "company.users.user_type.label": "Brukertype",
        "company.users.user_type.employee": "Ansatt",
        "company.users.user_type.hired": "Innleid",
        "company.users.user_type.supplier": "Leverandør (innleid fra)",
        "company.users.user_type.select_supplier": "Velg leverandør",
        "company.users.user_type.supplier_required": "Velg en leverandør for innleide brukere",
        "user_employment.hired_no_employment_title": "Innleid bruker",
        "user_employment.hired_no_employment": "Denne brukeren er innleid og kan ikke ha en ansettelse. Endre brukertype til Ansatt for å opprette en ansettelse.",
        "user_employment.tab": "Ansettelse",
        "user_work_schedule.tab": "Tidsplan",
        "user_work_schedule.label": "Arbeidsplan (timer)",
        "user_work_schedule.none": "Ingen valgt",
        "user_work_schedule.assign_title": "Velg arbeidsplan",
        "user_work_schedule.assign_hint": "Knyttes til timeregistrering, planlagt tid og fravær. For ansatte skaleres timer med stillingsprosent.",
        "user_work_schedule.manage_link": "Administrer arbeidsplaner →",
        "user_work_schedule.overview_title": "Oversikt",
        "user_work_schedule.overview_subtitle": "Timer per ukedag (justert for stillingsprosent der det gjelder)",
        "user_work_schedule.overview_empty": "Ingen arbeidsplan er valgt ennå.",
        "user_work_schedule.overview_empty_hint": "Velg en plan ovenfor for å se ukentlig oversikt og helligdager.",
        "user_work_schedule.info_title": "Arbeidsplan per bruker",
        "user_work_schedule.info_employee": "For ansatte lagres arbeidsplanen på ansettelsen. Stillingsprosent fra lønn påvirker planlagte timer.",
        "user_work_schedule.info_hired": "For innleide brukere lagres arbeidsplanen direkte på brukeren i firmaet (100 % av planen).",
        "user_work_schedule.not_available_title": "Arbeidsplan ikke tilgjengelig",
        "user_work_schedule.not_available_description": "Brukeren må være ansatt eller innleid før arbeidsplan kan knyttes. Opprett ansettelse eller sett brukertype til Innleid.",
        "user_work_schedule.saved": "Arbeidsplan lagret",
        "user_work_schedule.save_error": "Kunne ikke lagre arbeidsplan",
        "company.users.visibility.tag": "Skjult i velgere",
        "company.users.visibility.tag_hint": "Mangler oppsett som gjør at brukeren ikke vises i velgere",
        "company.users.visibility.inactive": "Inaktiv",
        "company.users.visibility.not_in_dropdown": "Vises ikke i nedtrekkslister (skru på «Vis i nedtrekksliste»)",
        "company.users.visibility.missing_supplier": "Mangler leverandør (innleid)",
        "company.users.visibility.not_employed": "Ikke ansatt eller innleid",
        "company.users.visibility.no_roles": "Ingen roller tildelt",
        "company.users.visibility.notice_title": "Denne brukeren er ikke fullt synlig",
        "company.users.visibility.notice_intro": "Følgende mangler eller må legges til før brukeren vises overalt (f.eks. i ansatt-/ressursvelgerne):",
        "company.users.visibility.inactive_hint": "Aktiver brukeren under Detaljer.",
        "company.users.visibility.not_in_dropdown_hint": "Skru på «Vis i nedtrekksliste» under Detaljer så brukeren vises i velgerne.",
        "company.users.visibility.missing_supplier_hint": "Velg leverandøren brukeren er innleid fra under Detaljer.",
        "company.users.visibility.not_employed_hint": "Opprett en ansettelse (Employment-fanen), eller sett brukertype til Innleid med leverandør.",
        "company.users.visibility.no_roles_hint": "Tildel minst én rolle under Roller-fanen.",
        "company.users.visibility.missing_work_schedule": "Mangler arbeidsplan (tidsplan)",
        "company.users.visibility.missing_work_schedule_hint": "Velg arbeidsplan under Tidsplan-fanen.",
        "tripletex_sync.title_default": "Tripletex-synkronisering",
        "tripletex_sync.retry": "Synkroniser til Tripletex på nytt",
        "tripletex_sync.retrying": "Synkroniserer…",
        "tripletex_sync.retry_queued": "Synkronisering til Tripletex er satt i kø på nytt.",
        "tripletex_sync.retry_failed": "Kunne ikke sette synkronisering til Tripletex i kø.",
        "tripletex_sync.open_customer": "Åpne kunde",
        "tripletex_sync.badge.column": "Tripletex",
        "tripletex_sync.badge.synced": "Synket",
        "tripletex_sync.badge.not_synced": "Ikke synket",
        "tripletex_sync.badge.blocked": "Blokkert",
        "tripletex_sync.badge.error": "Synk feilet",
        "tripletex_sync.badge.pending": "Venter",
        "tripletex_sync.dialog.open": "Åpne Tripletex-synk",
        "tripletex_sync.dialog.synced_body": "Prosjektet er synket med Tripletex.",
        "table_view.no_value": "Ingen verdi",
        "table_view.empty_title": "Ingen treff",
        "table_view.empty_subtitle": "Prøv å justere filtrene eller søket.",
        "table_view.loading_more": "Laster flere…",
        "table_view.rows_shown": "{{count}} rader vist",
        "table_view.columns": "Kolonner",
        "table_view.show_reorder_columns": "Vis og omorganiser kolonner",
        "table_view.locked": "låst",
        "table_view.view_name_prompt": "Navn på visning",
        "table_view.new_view": "Ny visning",
        "table_view.unsaved_changes": "Ulagrede endringer",
        "table_view.update_view": "Oppdater denne visningen",
        "table_view.save_as_new": "Lagre som ny visning…",
        "table_view.delete_view": "Slett visning",
        "table_view.view_tabs": "Visningar",
        "Assigned": "Tildelt",
        "Delete": "Slett",
        "Priority": "Prioritet",
        "Number": "Nummer",
        "Case": "Sak",
        "Details": "Detaljer",
        "History": "Historikk",
        "Due date": "Forfallsdato",
        "Saved": "Lagret",
        "Could not save changes": "Kunne ikke lagre endringer",
        "Mangler tittel": "Mangler tittel",
        "Ikke tildelt": "Ikke tildelt",
        "Overview": "Oversikt",
        "Customer / Project": "Kunde / Prosjekt",
        "Deviation": "Avvik",
        "Deviations": "Avvik",
        "Statuses": "Statuser",
        "Deviation Types": "Avvikstyper",
        "Priorities": "Prioriteringer",
        "Checklist": "Sjekkliste",
        "Sjekklister": "Sjekklister",
        "Uten tittel": "Uten tittel",
        "Type mangler": "Type mangler",
        "Ikke knyttet": "Ikke knyttet",
        "Avvik": "Avvik",
        "Appointment": "Avtale",
        "project_selector.favorites": "Favoritter",
        "project_selector.suggested": "Foreslåtte prosjekter",
        "project_selector.search_results": "Søkeresultater",
        "project_selector.projects": "Prosjekter",
        "project_selector.no_projects_found": "Ingen prosjekter funnet",
        "project_selector.no_projects_to_show": "Ingen prosjekter å vise",
        "project_selector.offer": "Tilbud",
        "project_selector.sub_of": "Under",
        "folder_selector.delete": "Slett",
        "folder_selector.delete_title": "Slette «{{name}}»?",
        "folder_selector.delete_desc": "Filene flyttes til overordnet mappe (eller prosjektets rot) og slettes ikke. Dette kan ikke angres.",
        "folder_selector.delete_desc_children": "Dette sletter også {{count}} undermapper. Filene flyttes til overordnet mappe (eller prosjektets rot) og slettes ikke.",
        "folder_selector.delete_failed": "Kunne ikke slette mappen",
        "project_list.scope.projects": "Prosjekter",
        "project_list.scope.offers": "Tilbud",
        "project_list.scope.all": "Alle",
        "project_list.filter.placeholder_status": "Status",
        "project_list.filter.placeholder_manager": "Prosjektleder",
        "project_list.filter.placeholder_tags": "Status-tagger",
        "project_list.column.status_tags": "Status-tag",
        "project_list.status_tags.save_error": "Kunne ikke lagre status-tag",
        "project.status_tags.title": "Status-tagger",
        "project.status_tags.hint": "Legg til eller endre uten å åpne redigering.",
        "project.status_tags.empty": "Ingen status-tagger",
        "project.status_tags.save_error": "Kunne ikke lagre status-tag",
        "case_list.filter.tags": "Etiketter",
        "case_list.search_placeholder": "Søk saker (f.eks. saksnummer)…",
        "case_list.filter_title": "Filtrer saker",
        "report_list.search_placeholder": "Søk rapporter…",
        "report_list.filter_title": "Filtrer rapporter",
        "report_list.filter.placeholder_customer": "Kunde",
        "report_list.filter.placeholder_project": "Prosjekt",
        "report_list.filter.placeholder_type": "Rapporttype",
        "report_list.filter.placeholder_date": "Datoperiode",
        "customer_list.search_placeholder": "Søk kunder…",
        "customer_list.filter_title": "Filtrer kunder",
        "customer_list.filter.placeholder_email": "E-post",
        "customer_list.filter.placeholder_address": "Adresse",
        "customer_list.filter.placeholder_sync": "Synkstatus",
        "customer_list.filter.placeholder_tags": "Etiketter",
        "customer_list.filter.placeholder_type": "Kundetype",
        "customer_list.filter.placeholder_region": "Region",
        "contact_list.search_placeholder": "Søk kontakter…",
        "contact_list.filter_title": "Filtrer kontakter",
        "contact_list.filter.placeholder_customer": "Kunde",
        "contact_list.filter.placeholder_company": "Firma",
        "contact_list.filter.placeholder_role": "Rolle",
        "contact_list.filter.placeholder_tags": "Etiketter",
        "contact_list.filter.placeholder_sync": "Synkstatus",
        "contact_list.filter.placeholder_status": "Status",
        "project_list.badge.offer": "Tilbud",
        "project_list.badge.subproject": "Underprosjekt",
        "project_list.sub_of": "Hører til",
        "project_list.financials.contract_sum": "Kontraktsum",
        "project_list.financials.invoiced": "Fakturert",
        "project_list.financials.costs": "Kostnader",
        "project_list.financials.result_margin": "Resultat / margin",
        "project_list.financials.remaining": "Innestående",
        "project.parent_project": "Overordnet prosjekt",
        "project.parent_project.none": "Ingen overordnet",
        "Case guide": "Case guide",
        "Guider": "Guider",
        "Guider tilgjengelig": "Guider tilgjengelig",
        "guider": "guider",
        "Velg hvilken guide du vil bruke for etterspurt info.": "Velg hvilken guide du vil bruke for etterspurt info.",
        "Velg hvilken guide du vil starte for denne saken.": "Velg hvilken guide du vil starte for denne saken.",
        "Dupliser guide": "Dupliser guide",
        "kopi": "kopi",
        "Uten navn": "Uten navn",
        "Rapportguide": "Rapportguide",
        "Rapportguider": "Rapportguider",
        "Opprett og rediger guidede flyter for rapportarbeid.": "Opprett og rediger guidede flyter for rapportarbeid.",
        "Guideomfang": "Guideomfang",
        "Velg om du vil redigere generelle rapportguider eller guider for en spesifikk rapporttype.": "Velg om du vil redigere generelle rapportguider eller guider for en spesifikk rapporttype.",
        "Tilbake til serviceinnstillinger": "Tilbake til serviceinnstillinger",
        "Generelle rapportguider": "Generelle rapportguider",
        "Opprett og rediger guidede flyter for rapportarbeid på egen side.": "Opprett og rediger guidede flyter for rapportarbeid på egen side.",
        "Åpne rapportguider": "Åpne rapportguider",
        "Caseguider": "Caseguider",
        "Opprett og rediger guidede flyter for saker.": "Opprett og rediger guidede flyter for saker.",
        "Guideomfang case": "Guideomfang (case type)",
        "Velg case type for å redigere guideflyten.": "Velg case type for å redigere guideflyten.",
        "Case guides scope intro":
          "Velg om du vil redigere generelle caseguider (alle typer) eller guider som gjelder én bestemt case type — samme mønster som rapportguider.",
        "Generelle caseguider": "Generelle caseguider",
        "Generell caseguide": "Generell",
        "Case guide scope general hint": "Guider som gjelder alle case typer.",
        "Case guide scope type hint":
          "Viser guider for denne case typen pluss eventuelle generelle guider. Type-spesifikke guider listes først.",
        "Tilbake til caseinnstillinger": "Tilbake til caseinnstillinger",
        "Åpne caseguider": "Åpne caseguider",
        "Opprett og rediger guidede flyter for saker på egen side.": "Opprett og rediger guidede flyter for saker på egen side.",
        "Ingen case typer er opprettet ennå.": "Ingen case typer er opprettet ennå.",
        "Caseguide-bygger på egen side": "Caseguide-bygger åpner på egen side.",
        "Åpne guidebygger": "Åpne guidebygger",
        "Case guide options connect to effect nodes":
          "Svarvalg har kun tekst og verdi. Bruk Koble på et valg og pek til en effekt-node på lerretet (etiketter, prioritet, frist osv.).",
        "Velg rapportguide": "Velg rapportguide",
        "Velg guiden som passer best med oppdraget.": "Velg guiden som passer best med oppdraget.",
        "Velg guide": "Velg guide",
        "Ny rapportguide": "Ny rapportguide",
        "Ny guide": "Ny guide",
        "Inaktiv": "Inaktiv",
        "Generell": "Generell",
        "Generell rapportguide": "Generell rapportguide",
        "Kan brukes på alle rapporttyper": "Kan brukes på alle rapporttyper",
        "spørsmål": "spørsmål",
        "Avslutt etter dette svaret": "Avslutt etter dette svaret",
        "Guide builder": "Guidebygger",
        "Effekter": "Effekter",
        "Effekt": "Effekt",
        "Effect-node": "Effect-node",
        "Guide flow palette effect id line": "Oppretter node på lerretet med effekt-id:",
        "Guide flow effect editor palette link": "Samme blokk i paletten / effekt-id",
        "Guide flow option connection": "Dette svaret går til",
        "Rapporttekst": "Rapporttekst",
        "Intern tekst": "Intern tekst",
        "Case oppfølging": "Case oppfølging",
        "Sjekkliste": "Sjekkliste",
        "Videre": "Videre",
        "Avslutt etter denne effekten": "Avslutt etter denne effekten",
        "Rediger effekt": "Rediger effekt",
        "Opprett spørsmål som noder og koble svar til neste spørsmål.": "Opprett spørsmål som noder og koble svar til neste spørsmål.",
        "Dra inn eller klikk for å opprette.": "Dra inn eller klikk for å opprette.",
        "Guide flow": "Guideflyt",
        "guide.flow.json_dialog_title": "Guideflyt — JSON og AI-instruks",
        "guide.flow.json_tab": "JSON",
        "guide.flow.ai_guide_tab": "Instruks til AI",
        "guide.flow.json_hint":
          "Kanter bygges automatisk fra `next_node_id` på svar og effekter. Lim inn eller rediger JSON og trykk Bruk på lerretet.",
        "guide.flow.copy_json": "Kopier JSON",
        "guide.flow.apply_json": "Bruk på lerret",
        "guide.flow.reload_from_canvas": "Last inn fra lerret",
        "guide.flow.reload_from_canvas_success": "Tekstfeltet er oppdatert fra lerretet.",
        "guide.flow.copy_json_success": "JSON er kopiert til utklippstavlen.",
        "guide.flow.clipboard_failed": "Klarte ikke å bruke utklippstavlen.",
        "guide.flow.json_invalid": "Ugyldig JSON eller flyt: {{message}}",
        "guide.flow.json_applied": "Guideflyten er oppdatert.",
        "guide.flow.copy_ai_guide": "Kopier AI-instruks",
        "guide.flow.ai_guide_copied": "AI-instruks kopiert.",
        "guide.flow.ai_empty": "AI returnerte tom flyt-JSON.",
        "guide.flow.ai_applied": "Guideflyt oppdatert fra AI.",
        "guide.flow.open_json": "JSON",
        "guide.flow.open_json_tooltip": "Vis, kopier, lim inn eller rediger guideflyten som JSON",
        "guide.flow.generate_with_ai": "Generer med AI",
        "guide.flow.ai_guide_intro":
          "Lim inn i eksterne AI-verktøy eller bruk Promangs innebygde generator. Tekniske nøkler samsvarer med `settings.flow` i API-et.",

        "Velg neste spørsmål for valgt svar.": "Velg neste spørsmål for valgt svar.",
        "Koble svar til neste spørsmål ved å bruke Koble-knappen på et svar.": "Koble svar til neste spørsmål ved å bruke Koble-knappen på et svar.",
        "Nytt spørsmål": "Nytt spørsmål",
        "Koble": "Koble",
        "Koble om": "Koble om",
        "Slett kobling": "Slett kobling",
        "Sett som start": "Sett som start",
        "Rediger spørsmål": "Rediger spørsmål",
        "Svarvalg": "Svarvalg",
        "Velg en node for å redigere.": "Velg en node for å redigere.",
        "Dato": "Dato",
        "Tid": "Tid",
        "Guidet rapport": "Guidet rapport",
        "Ingen rapportguide er tilgjengelig": "Ingen rapportguide er tilgjengelig",
        "Rapportguide lagret": "Rapportguide lagret",
        "Guiden kan fylle rapporttekst og lagrer svar for administrasjon.": "Guiden kan fylle rapporttekst og lagrer svar for administrasjon.",
        "Lagre rapporttypen før du konfigurerer guide.": "Lagre rapporttypen før du konfigurerer guide.",
        "Konfigurer spørsmål som kan fylle rapporttekst og lagre svar for administrasjon.": "Konfigurer spørsmål som kan fylle rapporttekst og lagre svar for administrasjon.",
        "Ta med svar i rapporttekst": "Ta med svar i rapporttekst",
        "Rapporttekst ved valg": "Rapporttekst ved valg",
        "Intern tekst ved valg": "Intern tekst ved valg",
        "Case oppfølging tittel": "Case oppfølging tittel",
        "Case oppfølging tekst": "Case oppfølging tekst",
        "Krever tiltak": "Krever tiltak",
        "Reklamasjon": "Reklamasjon",
        "Ingen sjekkliste": "Ingen sjekkliste",
        "Opprett sjekkliste": "Opprett sjekkliste",
        "Opprett oppfølger": "Opprett oppfølger",
        "Oppfølger beskrivelse": "Oppfølger beskrivelse",
        "Oppfølger intern beskrivelse": "Oppfølger intern beskrivelse",
        "Ingen sjekkliste på oppfølger": "Ingen sjekkliste på oppfølger",
        "Opprett avtale på oppfølger": "Opprett avtale på oppfølger",
        "Bruk samme avtaledato og tid som nåværende rapport": "Bruk samme avtaledato og tid som nåværende rapport",
        "Guidet case-opprettelse": "Guidet case-opprettelse",
        "Etterspørre info": "Etterspørre info",
        "Etterspurt info": "Etterspurt info",
        "Guidet opprettelse": "Guidet opprettelse",
        "Spørsmål": "Spørsmål",
        "Steg": "Steg",
        "Oppsummering": "Oppsummering",
        "guide.case_view_summary": "Se oppsummering",
        "guide.case_summary_review_intro": "Kontroller svarene før du bruker guiden.",
        "guide.case_chain_effect_title": "Start en annen caseguide",
        "guide.case_chain_effect_help":
          "Når denne guiden er brukt på saken, åpnes den valgte guiden automatisk (denne guiden fullføres først).",
        "guide.case_chain_pick_guide": "Neste guide",
        "guide.case_chain_none": "— ingen —",
        "guide.case_chain_started": "Åpner neste guide…",
        "guide.case_chain_summary_hint":
          "Etter at du bruker guiden, startes en annen guide automatisk på samme sak.",
        "Ingen guide-spørsmål er konfigurert.": "Ingen guide-spørsmål er konfigurert.",
        "Guiden foreslår": "Guiden foreslår",
        "etiketter": "etiketter",
        "Bruk guide": "Bruk guide",
        "Åpne guide": "Åpne guide",
        "Tilbake": "Tilbake",
        "Neste": "Neste",
        "Besvart": "Besvart",
        "Automatiske etiketter brukt": "Automatiske etiketter brukt",
        "Automatiske etiketter lagt til": "Automatiske etiketter lagt til",
        "Antall": "Antall",
        "Denne case typen krever guide før opprettelse": "Denne case typen krever guide før opprettelse",
        "Fyll ut guide": "Fyll ut guide",
        "Fyll ut guiden før saken opprettes": "Fyll ut guiden før saken opprettes",
        "besvarte etterspurt info": "besvarte etterspurt info",
        "fullførte guide": "fullførte guide",
        "Konfigurer spørsmål, valg og automatiske etiketter for denne case typen.": "Konfigurer spørsmål, valg og automatiske etiketter for denne case typen.",
        "Lagre case type før du konfigurerer guide.": "Lagre case type før du konfigurerer guide.",
        "Guide title": "Guide-tittel",
        "Guide description": "Guide-beskrivelse",
        "Aktiv": "Aktiv",
        "Legg til spørsmål": "Legg til spørsmål",
        "Lagre guide": "Lagre guide",
        "Spørsmålstekst": "Spørsmålstekst",
        "Påkrevd": "Påkrevd",
        "Valg": "Valg",
        "Valg 1": "Valg 1",
        "Valg label": "Valgtekst",
        "Verdi": "Verdi",
        "Fjern valg": "Fjern valg",
        "Automatiske etiketter": "Automatiske etiketter",
        "Legg til valg": "Legg til valg",
        "Select case type": "Velg case type",
        "Case Type": "Case type",
        "No results": "Ingen treff",
        "Select case type first": "Velg case type først",
        "No guide configured for this case type": "Ingen guide er konfigurert for denne case typen",
        "Ny case": "Ny case",
        "Velg case type først. Guiden hjelper deg å stille riktige spørsmål og foreslår etiketter automatisk.": "Velg case type først. Guiden hjelper deg å stille riktige spørsmål og foreslår etiketter automatisk.",
        "Title and case type are required": "Tittel og case type er påkrevd",
        "Case type is required": "Case type er påkrevd",
        "Velg case type først. Tittel genereres automatisk med AI etter opprettelse.": "Velg case type først. Tittel genereres automatisk med AI etter opprettelse.",
        "Guide åpnes etter opprettelse": "Guide åpnes etter opprettelse",
        "Etter opprettelse": "Etter opprettelse",
        "Velg case type først. Hvis typen har en guide kan du besvare den før saken opprettes.": "Velg case type først. Hvis typen har en guide kan du besvare den før saken opprettes.",
        "Valgfri guide for denne case typen": "Valgfri guide for denne case typen",
        "Type": "Type",
        "Detaljer": "Detaljer",
        "Velg type": "Velg type",
        "Saksdetaljer": "Saksdetaljer",
        "Guide besvart": "Guide besvart",
        "Klar til opprettelse": "Klar til opprettelse",
        "Se guide igjen": "Se guide igjen",
        "Start guide": "Start guide",
        "Hva slags case oppretter du?": "Hva slags case oppretter du?",
        "Case typen styrer hvilke spørsmål og automatiske forslag som vises.": "Case typen styrer hvilke spørsmål og automatiske forslag som vises.",
        "Guide": "Guide",
        "Ikke brukt": "Ikke brukt",
        "Ja": "Ja",
        "Nei": "Nei",
        "templates.title": "Maler",
        "templates.new": "Ny mal",
        "templates.edit": "Rediger mal",
        "templates.empty": "Ingen maler funnet.",
        "templates.search_placeholder": "Søk i maler...",
        "templates.editor_placeholder": "Skriv innholdet i malen...",
        "templates.editor_hint": "Lag gjenbrukbart rich text-innhold og knytt det til en kategori.",
        "templates.form.title": "Maldetaljer",
        "templates.form.subtitle": "Gi malen en tydelig tittel, kategori og rich text-innhold.",
        "templates.insert.append": "Lim inn sammen med eksisterende tekst",
        "templates.insert.replace": "Bytt ut hele teksten",
        "templates.insert.use": "Bruk mal",
        "templates.hero.kicker": "Innholdsbibliotek",
        "templates.hero.subtitle": "Organiser gjenbrukbare tekstmaler i kategorier og sett dem inn fra rich text-editorer.",
        "templates.filters.heading": "Søk og filter",
        "templates.filters.description": "Søk i maler eller filtrer på kategori.",
        "templates.categories.title": "Kategorier",
        "templates.categories.all": "Alle maler",
        "templates.categories.new": "Ny kategori",
        "templates.categories.edit": "Rediger kategori",
        "templates.categories.name": "Navn",
        "templates.categories.parent": "Overordnet kategori",
        "templates.categories.no_parent": "Ingen overordnet kategori",
        "templates.categories.description": "Beskrivelse",
        "templates.categories.uncategorized": "Ikke kategorisert",
        "templates.section.kicker": "Maler",
        "templates.section.title": "Alle maler",
        "templates.section.subtitle": "Velg en kategori for å se malene som er knyttet til den.",
        "templates.section.category_title": "Maler i kategorien",
        "templates.section.category_subtitle": "Maler som er knyttet til valgt kategori.",
        "company.settings.tabs.company": "Firma",
        "company.settings.tabs.employment_agreement": "Arbeidsavtale",
        "company.settings.tabs.employee_positions": "Firmastillinger",
        "company.integrations.title": "Integrasjoner",
        "company.integrations.subtitle": "Tjenester, API-apper og webhooks for firmaet",
        "company.integrations.tabs.services": "Tjenester",
        "company.integrations.tabs.apps": "API-apper",
        "company.integrations.tabs.webhooks": "Webhooks",
        "company.integrations.status.connected": "Tilkoblet",
        "company.integrations.status.missing": "Mangler oppsett",
        "company.integrations.events": "Hendelser",
        "company.integrations.show": "Vis",
        "company.integrations.hide": "Skjul",
        "company.integrations.copy": "Kopier",
        "company.integrations.copied": "Kopiert",
        "company.integrations.sync_tripletex": "Synk Tripletex med Promang",
        "company.integrations.delete_tripletex_subscriptions": "Slett Tripletex-abonnementer",
        "company.integrations.delete_tripletex_body": "Er du sikker på at du vil slette Tripletex-abonnementene?",
        "company.integrations.sync_products_title": "Synk av produkter",
        "company.integrations.sync_products_body": "Er du sikker på at du ønsker å synke produkter nå?",
        "company.integrations.sync_success": "Synk var vellykket",
        "company.integrations.tripletex.title": "Tripletex API",
        "company.integrations.tripletex.description": "Koble Promang til Tripletex",
        "company.integrations.bring.title": "Bring API",
        "company.integrations.bring.description": "Koble Promang til Bring",
        "company.integrations.stripe.title": "Stripe API",
        "company.integrations.stripe.description": "Koble Promang til Stripe",
        "company.integrations.automile.title": "Automile API",
        "company.integrations.automile.description": "Koble Promang til Automile",
        "company.integrations.google_maps.title": "Google Maps API",
        "company.integrations.google_maps.description": "Koble Promang til Google Maps",
        "company.integrations.webshop.title": "Nettbutikk",
        "company.integrations.webshop.description": "Koble Promang til nettbutikk",
        "company.integrations.phonero.title": "Phonero API",
        "company.integrations.phonero.description": "Koble Promang til Phonero for samtaler",
        "company.integrations.fields.tripletex_employee_token": "Tripletex ansatt-token",
        "company.integrations.fields.tripletex_hour_sync_if_approved_only": "Synk bare godkjente timer",
        "company.integrations.fields.bring_api_uid": "Bring API UID",
        "company.integrations.fields.bring_api_key": "Bring API-nøkkel",
        "company.integrations.fields.bring_main_customer_number": "Bring hovedkundenummer",
        "company.integrations.fields.stripe_webhook_secret": "Stripe webhook-secret",
        "company.integrations.fields.stripe_webhook_url": "Stripe webhook-URL",
        "company.integrations.fields.stripe_secret_key": "Stripe hemmelig nøkkel",
        "company.integrations.fields.automile_client_id": "Automile klient-ID",
        "company.integrations.fields.automile_client_secret": "Automile klient-secret",
        "company.integrations.fields.automile_username": "Automile brukernavn",
        "company.integrations.fields.automile_password": "Automile passord",
        "company.integrations.fields.google_maps_api_key": "Google Maps API-nøkkel",
        "company.integrations.fields.store_checkout_active": "Nettbutikk-kasse aktiv",
        "company.integrations.fields.webshop_products_url": "Nettbutikk produkt-URL",
        "company.integrations.fields.webshop_order_cancel_url": "Avbrutt ordre-URL",
        "company.integrations.fields.webshop_order_success_url": "Vellykket ordre-URL",
        "company.integrations.fields.phonero_username": "Phonero brukernavn",
        "company.integrations.fields.phonero_password": "Phonero passord",
        "company.integrations.fields.phonero_customer_id": "Phonero kundenummer",
        "company.oauth_apps.intro": "Opprett OAuth-klienter som eksterne apper bruker for å kalle Promang API. Firmaet eier appen og kan rulle nøkler.",
        "company.oauth_apps.new": "Ny API-app",
        "company.oauth_apps.name": "Navn",
        "company.oauth_apps.redirect": "Redirect URI",
        "company.oauth_apps.scopes": "Scopes",
        "company.oauth_apps.create": "Opprett app",
        "company.oauth_apps.created": "API-app opprettet",
        "company.oauth_apps.empty": "Ingen API-apper ennå.",
        "company.oauth_apps.secret_once": "Lagre uid og secret nå. Secret vises bare denne gangen.",
        "company.oauth_apps.roll": "Rull nøkler",
        "company.oauth_apps.rolled": "Nøkler rullet",
        "company.oauth_apps.delete": "Slett",
        "company.oauth_apps.deleted": "App slettet",
        "company.oauth_apps.deleted_badge": "Slettet",
        "company.oauth_apps.confirm_name": "Bekreft navn",
        "company.oauth_apps.load_failed": "Kunne ikke laste API-apper",
        "company.oauth_apps.create_failed": "Kunne ikke opprette API-app",
        "company.oauth_apps.roll_failed": "Kunne ikke rulle nøkler",
        "company.oauth_apps.delete_failed": "Kunne ikke slette app",
        "company.oauth_apps.delete_name_mismatch": "Skriv inn app-navnet for å slette",
        "cases.weply.type": "Weply",
        "cases.weply.other_fields": "Andre felter",
        "cases.weply.session": "Samtale",
        "company.webhooks.weply_title": "Koble et eksternt system",
        "company.webhooks.weply_step1": "Opprett en innkommende webhook og velg hvilke moduler den skal få tilgang til.",
        "company.webhooks.weply_step2": "I det eksterne systemet: slå på utgående webhook eller integrasjon.",
        "company.webhooks.weply_step3": "Lim inn Promang-URL-en som mottaker.",
        "company.webhooks.weply_step4": "Sett header X-Promang-Webhook-Secret til nøkkelen fra Promang.",
        "company.webhooks.connect_title": "Slik kobler du et eksternt system",
        "company.webhooks.connect_step1": "Opprett en innkommende webhook og velg hvilke moduler den skal få tilgang til.",
        "company.webhooks.connect_step2": "I det eksterne systemet: slå på utgående webhook eller integrasjon.",
        "company.webhooks.connect_step3": "Lim inn Promang-URL-en som mottaker.",
        "company.webhooks.connect_step4": "Sett header X-Promang-Webhook-Secret til nøkkelen fra Promang.",
        "company.webhooks.provider_lead": "Lead / chat",
        "company.webhooks.guide_title": "Hva kan webhooks brukes til?",
        "company.webhooks.guide_intro": "Webhooks kobler Promang til andre systemer. Innkommende tar imot data og oppretter poster i de modulene du gir tilgang til. Utgående sender hendelser fra Promang til en URL dere eier.",
        "company.webhooks.guide_inbound": "Et eksternt system POST-er til Promang-URL-en. Med tilgang kan webhooken opprette kunde, kontakt og sak (meldingen vises som eget kort i saken). Samme samtale (session) blir oppfølging på eksisterende sak.",
        "company.webhooks.guide_outbound": "Når kunde eller kontakt opprettes, oppdateres eller slettes, sender Promang et signert JSON-kall til mål-URL-en.",
        "company.webhooks.supported_now": "Støttes nå",
        "company.webhooks.coming_soon": "Kommer senere",
        "company.webhooks.modules_label": "Moduler webhooken har tilgang til",
        "company.webhooks.modules_help": "Velg hva denne webhooken kan opprette (inn) eller sende (ut). Sak og kontakt krever kunde.",
        "company.webhooks.labels_label": "Etiketter på nye saker",
        "company.webhooks.labels_help": "Velg firmaets saksetiketter som skal settes automatisk når webhooken oppretter en sak. Opprett etiketten først, for eksempel «Lead».",
        "company.webhooks.custom_fields_help": "Alle felt unntatt transcript/melding (navn, e-post, telefon, User Agent, Agent Name …) lagres som egendefinerte felter på saken.",
        "company.webhooks.labels_manage": "Administrer etiketter",
        "company.webhooks.labels_pick": "Velg etiketter",
        "company.webhooks.modules_blank": "Velg minst én modul.",
        "company.webhooks.module.customer": "Kunde",
        "company.webhooks.module.contact": "Kontakt",
        "company.webhooks.module.case": "Sak",
        "company.webhooks.module.project": "Prosjekt",
        "company.webhooks.module.order": "Ordre",
        "company.webhooks.module.report": "Servicerapport",
        "company.webhooks.new": "Ny webhook",
        "company.webhooks.name": "Navn",
        "company.webhooks.provider": "Leverandør",
        "company.webhooks.generic": "Generisk",
        "company.webhooks.direction": "Retning",
        "company.webhooks.inbound": "Innkommende",
        "company.webhooks.outbound": "Utgående",
        "company.webhooks.target_url": "Mål-URL",
        "company.webhooks.create": "Opprett webhook",
        "company.webhooks.created": "Webhook opprettet",
        "company.webhooks.empty": "Ingen webhooks ennå.",
        "company.webhooks.secret_once": "Lagre URL og nøkkel nå. Nøkkelen vises bare denne gangen.",
        "company.webhooks.header": "Header",
        "company.webhooks.roll": "Rull nøkkel",
        "company.webhooks.rolled": "Nøkkel rullet",
        "company.webhooks.enable": "Aktiver",
        "company.webhooks.disable": "Deaktiver",
        "company.webhooks.test": "Test",
        "company.webhooks.log": "Logg",
        "company.webhooks.delete": "Slett",
        "company.webhooks.deleted": "Webhook slettet",
        "company.webhooks.load_failed": "Kunne ikke laste webhooks",
        "company.webhooks.create_failed": "Kunne ikke opprette webhook",
        "company.webhooks.update_failed": "Kunne ikke oppdatere webhook",
        "company.webhooks.roll_failed": "Kunne ikke rulle nøkkel",
        "company.webhooks.delete_failed": "Kunne ikke slette webhook",
        "company.webhooks.test_queued": "Test er lagt i kø",
        "company.webhooks.test_failed": "Test feilet",
        "company.webhooks.deliveries_failed": "Kunne ikke laste leveringslogg",
        "company.employee_positions.help": "Felles stillingskatalog for selskapet. Brukes i oppgavemaler og arbeidsavtaler.",
        "company.employee_positions.saved": "Firmastillinger lagret",
        "company.employee_positions.employment_link": "Stillinger kobles til ansatte under bruker → Ansettelse.",
        "company.employee_positions.employment_link_action": "Gå til brukere",
        "company.employment_agreement.title": "Standard avtaletekst",
        "company.employment_agreement.description": "Denne teksten legges inn som felles avtaletekst i arbeidsavtale-PDF-en for ansatte.",
        "company.employment_agreement.placeholder": "Skriv standard avtaletekst for arbeidsavtaler...",
        "pagination.previous": "Forrige",
        "pagination.next": "Neste",
        "pagination.showing": "Viser {{current}} av {{total}}",
        "pagination.loadMore": "Last inn flere",
        "payslips.kicker": "Tripletex lønn",
        "payslips.title": "Lønn",
        "payslips.mine_title": "Mine lønnslipper",
        "payslips.admin_title": "Lønnslipper",
        "payslips.stats_title": "Statistikk",
        "payslips.description": "Se lønnslipper som er gjort tilgjengelig fra Tripletex uten å logge inn i Tripletex.",
        "payslips.admin_description": "Administrer og filtrer lønnslipper for ansatte. Krever bedriftsadministrator og rollen Lønn Admin. Bedriftsadministratorer ser bare egne lønnslipper uten denne rollen.",
        "payslips.stats_description": "Oversikt over lønnslippene som inngår i summene under (egne med mindre du er bedriftsadministrator med Lønn Admin).",
        "payslips.admin_forbidden": "Du trenger bedriftsadministrator og rollen Lønn Admin for å administrere alle lønnslipper i selskapet.",
        "payslips_admin": "Lønn Admin",
        "payslips.role_view_override_warning":
          "Rollevisning er aktiv — den endrer bare menyer/UI. API-et bruker fortsatt dine ekte roller. Slå av rollevisning (DevOps-menyen) for å samsvare med tilganger.",
        "payslips.loading": "Laster lønnslipper...",
        "payslips.empty": "Ingen lønnslipper er tilgjengelig ennå.",
        "payslips.error": "Kunne ikke hente lønnslipper.",
        "payslips.period": "Periode",
        "payslips.employee": "Ansatt",
        "payslips.voucher_date": "Bilagsdato",
        "payslips.available_date": "Tilgjengelig",
        "payslips.gross_amount": "Brutto",
        "payslips.amount": "Netto",
        "payslips.actions": "Handlinger",
        "payslips.open": "Åpne",
        "payslips.opening": "Åpner...",
        "payslips.sync_now": "Synkroniser nå",
        "payslips.syncing": "Synkroniserer...",
        "payslips.pdf_failed": "Kunne ikke åpne lønnsslippen. Prøv igjen.",
        "payslips.sync_failed": "Kunne ikke starte lønnssynk. Prøv igjen.",
        "payslips.employee_filter": "Ansatt",
        "payslips.stats_count": "Antall lønnslipper",
        "payslips.stats_gross": "Brutto totalt",
        "payslips.stats_net": "Netto totalt",
        "payslips.stats_average_net": "Snitt netto",
        "listbox.none": "Ikke valgt",
        "user_info.address": "Adresse",
        "user_info.address_hint": "Lagres på brukerprofilen og brukes som adressegrunnlag i ansettelsesflyten.",
        "user_employment.option_not_selected": "Ikke valgt",
        "user_employment.section_basic": "Ansettelsesgrunnlag",
        "user_employment.section_basic_hint": "Grunnleggende data for arbeidsforholdet og arbeidsavtalen.",
        "user_employment.employee_number": "Ansattnummer",
        "user_employment.employment_starts": "Ansettelse starter",
        "user_employment.employment_ends": "Sluttdato",
        "report.previous_work.title": "Tidligere arbeid",
        "report.previous_work.hint": "Kort oversikt hos kunden",
        "report.previous_work.empty": "Ingen tidligere rapporter funnet.",
        "report.previous_work.fallback": "Rapport {{number}}",
        "report.previous_work.open": "Se tidligere arbeid",
        "report.previous_work.dialog_title": "Tidligere arbeid",
        "report.previous_work.ai_title": "AI-oversikt",
        "report.previous_work.ai_generating": "Oppdaterer…",
        "report.previous_work.ai_error": "Kunne ikke hente oversikten.",
        "report.previous_work.ai_empty": "Ingen AI-oversikt ennå.",
        "report.previous_work.show_less": "Vis mindre",
        "report.previous_work.show_more": "Vis mer",
        "report.previous_work.see_more": "Vis mer",
        "report.previous_work.see_report": "Se rapport",
        "report.previous_work.see_checklist": "Se sjekkliste",
        "report.previous_work.images": "Bilder",
        "report.previous_work.report_label": "Rapport {{number}}",
        "report.previous_work.different_facility": "Annet anlegg",
        "report.previous_work.different_facility_hint": "Dette arbeidet gjelder et annet anlegg hos kunden.",
        "report.previous_work.jobs_heading": "Tidligere jobber",
        "report.previous_work.load_error": "Kunne ikke laste tidligere arbeid.",
        "report.previous_work.back_to_overview": "Tilbake til oversikt",
        "report.previous_work.crumb_overview": "Oversikt",
        "report.previous_work.crumb_report": "Rapport {{number}}",
        "report.previous_work.crumb_checklist": "Sjekkliste {{number}}",
        "report.previous_work.facility_history_title": "Historikk for anlegg",
        "report.previous_work.facility_history_empty": "Ingen tidligere rapporter på dette anlegget.",
        "report.previous_work.panel_load_error": "Kunne ikke laste innholdet.",
        "report.previous_work.open_full_report": "Åpne hele rapporten",
        "report.previous_work.no_checklist": "Ingen sjekkliste på denne rapporten.",
        "report.previous_work.checklist_ok": "Godkjent",
        "report.previous_work.checklist_deviation": "Avvik",
        "report.active_agreement.chip": "Aktiv serviceavtale {{number}}",
        "module_overview.tab.reports": "Rapporter",
        "module_overview.tab.agreements": "Serviceavtaler",
        "module_overview.tab.orders": "Ordrer",
        "module_overview.tab.projects": "Prosjekter",
        "module_overview.hide_details": "Skjul detaljer",
        "module_overview.show_details": "Vis detaljer",
        "module_overview.select_tab": "Velg fane",
        "module_overview.go_to_customer": "Gå til kunde",
        "module_overview.filter_reports": "Filtrer rapporter",
        "module_overview.filter_agreements": "Filtrer avtaler",
        "module_overview.filter_projects": "Filtrer prosjekter",
        "module_overview.search_projects": "Søk i prosjekter…",
        "customer.systems.tab": "Anlegg",
        "customer.systems.overview_title": "Kundens anlegg",
        "customer.systems.overview_hint": "Anlegg og systemer knyttet til kunden.",
        "customer.systems.add": "Legg til anlegg",
        "customer.systems.add_from_case": "Legg til anlegg",
        "customer.systems.empty": "Ingen anlegg registrert ennå.",
        "customer.systems.no_meta": "Ingen plassering eller serienummer",
        "customer.systems.other_comment": "Annen kommentar",
        "customer.systems.history": "Historikk",
        "customer.systems.spare_parts": "Reservedeler",
        "customer.systems.no_product_selected": "Velg et produkt først.",
        "customer.systems.select_existing": "Velg eksisterende anlegg",
        "customer.systems.select_existing_hint": "Knytt et anlegg som allerede finnes hos kunden.",
        "customer.systems.create_new": "Opprett nytt anlegg",
        "customer.systems.choose": "Velg",
        "customer.systems.detach": "Koble fra",
        "customer.systems.missing_customer": "Mangler kunde — kan ikke vise anlegg.",
        "customer.systems.dialog.view_title": "Anlegg",
        "customer.systems.dialog.edit_title": "Rediger anlegg",
        "customer.systems.dialog.create_title": "Nytt anlegg",
        "customer.systems.mode.existing": "Velg eksisterende",
        "customer.systems.mode.create": "Opprett nytt",
        "customer.systems.search_existing": "Søk i anlegg…",
        "customer.systems.no_existing_match": "Ingen anlegg samsvarer med søket.",
        "customer.systems.existing_count": "{{count}} anlegg registrert hos kunden",
        "customer.systems.open_product": "Åpne produkt",
        "customer.systems.form.equipment": "Utstyr",
        "customer.systems.form.location": "Plassering",
        "customer.systems.form.dates": "Årstall",
        "customer.systems.form.notes": "Notater",
        "customer.systems.card_title": "Anlegg",
        "customer.systems.status.linked": "Koblet",
        "customer.systems.status.missing": "Mangler",
        "customer.systems.status.required": "Påkrevd",
        "customer.systems.status.not_required": "Ikke påkrevd",
        "customer.systems.address": "Adresse",
        "customer.systems.not_linked": "Ikke knyttet",
        "customer.systems.attach": "Knytt anlegg",
        "customer.systems.select_product": "Velg et produkt",
        "customer.systems.none_selected": "Ingen valgt",
        "customer.systems.merge": "Knytt dobbelt",
        "customer.systems.merge_title": "Knytt anlegg mot et annet",
        "customer.systems.merge_hint": "Alt på «{{name}}» flyttes til det valgte anlegget. Dette anlegget fjernes.",
        "customer.systems.merge_choose_target": "Velg anlegg som skal beholdes",
        "customer.systems.merge_confirm": "Knytt og fjern",
        "customer.systems.merge_cancel": "Avbryt",
        "customer.systems.merge_working": "Knytter…",
        "customer.systems.merge_success": "Anleggene er knyttet",
        "customer.systems.merge_error": "Kunne ikke knytte anleggene",
        "case.transfer.action": "Overfør sak",
        "case.transfer.title": "Overfør sak",
        "case.transfer.intro": "Flytt informasjon til en annen sak i samme firma.",
        "case.transfer.same_customer_heading": "Åpne saker hos samme kunde",
        "case.transfer.no_same_customer": "Ingen andre åpne saker hos denne kunden.",
        "case.transfer.no_customer_hint": "Saken har ingen kunde, så du må søke i hele firmaet.",
        "case.transfer.search_heading": "Søk i firmaet",
        "case.transfer.search_button": "Søk etter sak",
        "case.transfer.confirm_title": "Bekreft overføring",
        "case.transfer.confirm_summary": "Overfør fra {{source}} til {{target}}.",
        "case.transfer.confirm_effects": "Kilde-saken lukkes og merkes som overført.",
        "case.transfer.different_customer_warning": "Målsaken tilhører en annen kunde.",
        "case.transfer.note_label": "Merknad",
        "case.transfer.note_placeholder": "Valgfri merknad til overføringen…",
        "case.transfer.confirm_button": "Overfør",
        "case.transfer.success": "Saken er overført.",
        "case.transfer.error": "Kunne ikke overføre saken.",
        "case.transfer.banner_out": "Overført til",
        "case.transfer.banner_in": "Mottatt fra",
        "case.transfer.tag_out": "Overført",
        "case.transfer.tag_in": "Mottatt overføring",
        "case.transfer.tag_in_count": "Mottatt overføring ({{count}})",
        "case.siblings.title": "{{count}} andre åpne saker hos kunden",
        "case.siblings.hint": "Sjekk om saken allerede følges opp et annet sted.",
        "case.siblings.more": "{{count}} saker til",
        "case.siblings.tag": "{{count}} åpne saker",
        "case.relations.tags_label": "Relaterte saker",
        "absence.overview.title": "Fravær — oversikt",
        "absence.overview.employee": "Ansatt",
        "absence.stats.load_failed": "Kunne ikke laste fraværsstatistikk",
        "work_stats.loading": "Henter arbeidstall…",
        "cases.create.dialog_title": "Ny sak",
        "cases.create.dialog_hint": "Fyll inn det som trengs for å opprette. Du redigerer saken etterpå på sakssiden.",
        "cases.create.type_required": "Sakstype er påkrevd",
        "cases.create.description_placeholder": "Kort beskrivelse…",
        "employment.end_date.badge": "Slutter {{date}}",
        "employment.end_date.ended_badge": "Sluttet {{date}}",
        "employment.end_date.until": "til {{date}}",
        "employment.end_date.plan_blocked": "{{name}} har sluttet {{date}} og kan ikke planlegges på eller etter denne dagen.",
        "employment.end_date.hours_blocked": "Kan ikke registrere timer etter sluttdato ({{date}}).",
        "user_employment.social_security": "Fødselsnummer",
        "user_employment.working_posistion": "Stilling",
        "user_employment.employee_position_none": "Ingen stilling valgt",
        "user_employment.workplace": "Arbeidssted",
        "user_employment.agreement_type": "Avtaletype",
        "user_employment.agreement_type_permanent": "Fast",
        "user_employment.agreement_type_temporary": "Midlertidig",
        "user_employment.agreement_type_hourly": "Tilkalling/timebasert",
        "user_employment.agreement_type_seasonal": "Sesong",
        "user_employment.agreement_type_other": "Annet",
        "user_employment.section_worktime": "Arbeidstid",
        "user_employment.section_worktime_hint": "Tidsrom som kan brukes i arbeidsavtalen.",
        "user_employment.worktime_regular_from": "Ordinær fra",
        "user_employment.worktime_regular_too": "Ordinær til",
        "user_employment.worktime_weekend_from": "Helg fra",
        "user_employment.worktime_weekend_too": "Helg til",
        "user_employment.worktime_regular_range": "Ordinær arbeidstid",
        "user_employment.worktime_weekend_range": "Helgearbeid",
        "user_employment.section_wages": "Lønn og tillegg",
        "user_employment.section_wages_hint": "Avtalte lønnsbetingelser. Lønnstabellen under beholdes for historikk og timeberegninger.",
        "user_employment.wages": "Lønn",
        "user_employment.wages_unit": "Lønn per",
        "user_employment.wage_unit_hour": "Time",
        "user_employment.wage_unit_month": "Måned",
        "user_employment.wage_unit_year": "År",
        "user_employment.wage_unit_fixed": "Fast avtalt",
        "user_employment.overtime_pay": "Overtidsgodtgjørelse",
        "user_employment.dismissal": "Oppsigelsestid",
        "user_employment.wage_other_addition": "Andre tillegg",
        "user_employment.wage_weekend_and_night_addition": "Helg-/nattillegg",
        "user_employment.collective_agreement": "Tariffavtale",
        "user_employment.section_contract_text": "Avtaletekst",
        "user_employment.section_contract_text_hint": "Tekstfelter som danner grunnlag for arbeidsavtale og intern dokumentasjon.",
        "user_employment.employment_instructions": "Stillingsinstruks",
        "user_employment.employment_allowance": "Godtgjørelse",
        "user_employment.notes": "Notater",
        "user_employment.other": "Annet",
        "user_employment.section_signature": "Signatur og betaling",
        "user_employment.section_signature_hint": "Signerings- og betalingsgrunnlag for arbeidsavtalen.",
        "user_employment.signed_place": "Signeringssted",
        "user_employment.signed_at": "Signeringsdato",
        "user_employment.account_number": "Kontonummer",
        "user_employment.hourly_costs_title": "Timepriser og kostnader",
        "user_employment.section_contract_actions": "Arbeidsavtale",
        "user_employment.section_contract_actions_hint": "Utskrift og signering kobles mot avtalegrunnlaget når PDF/signering er tilgjengelig.",
        "user_employment.contract_actions_notice_title": "Klar for neste fase",
        "user_employment.contract_actions_notice": "Datagrunnlaget kan nå fylles ut. Utskrift av arbeidsavtale og Posten signering kobles på i egen implementasjon.",
        "user_employment.print_contract": "Skriv ut arbeidsavtale",
        "user_employment.print_contract_unavailable": "PDF-rute for arbeidsavtale er ikke koblet på ennå.",
        "user_employment.send_to_signing": "Send til signering",
        "user_employment.signing_unavailable": "Posten signering implementeres av separat agent.",
        "user_employment.contract_title": "Arbeidsavtale",
        "user_employment.contract_description": "Arbeidsavtale til digital signering",
        "user_employment.preview_contract_draft": "Se utkast til arbeidsavtale",
        "user_employment.download_contract_draft_pdf": "Last ned PDF-utkast",
        "user_employment.draft_pdf_download_failed": "Kunne ikke laste ned PDF-utkast.",
        "user_employment.contract_draft_label": "Utkast",
        "user_employment.contract_draft_for": "For {{name}}",
        "user_employment.draft_notice_title": "Kontroller før signering",
        "user_employment.draft_notice": "Dette er en forhåndsvisning basert på lagrede og utfylte felt i skjemaet. Lagre endringer før du sender til signering.",
        "user_employment.employee_name": "Arbeidstaker",
        "signing.title": "Digital signering",
        "signing.description": "Send dokumentet til Posten Signering og følg signeringsstatus.",
        "signing.new_request": "Ny signeringsforespørsel",
        "signing.empty": "Ingen signeringsforespørsler er opprettet ennå.",
        "signing.sender_reference": "Referanse",
        "signing.signer_name": "Signaturnavn",
        "signing.national_identity_number": "Fødselsnummer / D-nummer",
        "signing.email": "E-post",
        "signing.mobile": "Mobil",
        "signing.identity_warning": "Bruk fødselsnummer/D-nummer når det er tilgjengelig. E-post/SMS-signering er gyldig, men Promang må da verifisere at riktig person signerte.",
        "signing.send": "Send til signering",
        "signing.created": "Signeringsforespørsel opprettet",
        "signing.refreshed": "Signeringsstatus oppdatert",
        "signing.refresh_status": "Oppdater status",
        "signing.download_signed": "Last ned signert PDF",
        "signing.errors.load_failed": "Kunne ikke hente signeringsforespørsler.",
        "signing.errors.create_failed": "Kunne ikke opprette signeringsforespørsel.",
        "signing.errors.poll_failed": "Kunne ikke oppdatere signeringsstatus.",
        "signing.errors.dispatch_unconfirmed": "Signeringen kunne ikke bekreftes. Start en ny forespørsel.",
        "signing.errors.activation_failed": "Avtalen kunne ikke aktiveres fra det signerte dokumentet.",
        "signing.errors.download_failed": "Kunne ikke laste ned signert dokument.",
        "signing.status.draft": "Utkast",
        "signing.status.queued": "I kø",
        "signing.status.sent": "Sendt",
        "signing.status.in_progress": "Pågår",
        "signing.status.completed": "Fullført",
        "signing.status.failed": "Feilet",
        "signing.status.rejected": "Avvist",
        "signing.status.expired": "Utløpt",
        "signing.status.cancelled": "Kansellert",
        "signing.status.waiting": "Venter",
        "signing.status.available": "Tilgjengelig",
        "signing.status.signed": "Signert",
        "histories.title": "Historikk",
        "histories.subtitle": "Aktivitet og endringer",
        "histories.last_updated": "Sist oppdatert",
        "histories.last_edited": "Sist redigert",
        "histories.by_prefix": "av",
        "histories.no_data": "Ingen data ennå",
        "histories.filter_action": "Filtrer på handling",
        "histories.filter_all": "Alle",
        "histories.empty_filter": "Ingen hendelser for dette filteret.",
        "histories.load_more": "Last inn mer",
        "histories.loading_more": "Laster …",
        "histories.close": "Lukk",
        "histories.system_user": "Systemet",
        "histories.unknown_user": "Ukjent",
        "histories.sync_changes_heading": "Synk-metadata",
        "histories.action.tripletex_retry": "satte Tripletex-synkronisering i kø på nytt for",
        "histories.tripletex_retry_pending": "Nytt synkforsøk er satt i kø. Dette bekrefter ikke at synkroniseringen er fullført.",
        "histories.action.tripletex_sync_attempt": "forsøkte Tripletex-synk for",
        "histories.action.tripletex_sync": "fullførte Tripletex-synk for",
        "histories.action.tripletex_sync_skipped": "hoppet over Tripletex-synk for",
        "histories.action.request_agreed_overtime": "forespurte avtalt overtid på",
        "histories.action.confirm_agreed_overtime": "bekreftet avtalt overtid på",
        "histories.action.reject_agreed_overtime": "avviste avtalt overtid på",
        "histories.action.lock": "låste",
        "histories.action.unlock": "låste opp",
        "histories.action.not_approved_notification": "sendte e-post: ikke godkjent for",
        "histories.action.approved_notification": "sendte e-post: godkjent for",
        "histories.action.send_email": "sendte referat til",
        "histories.outbound.not_approved": "Sendt e-post: ikke godkjent",
        "histories.outbound.approved": "Sendt e-post: godkjent",
        "histories.deviation_scope.deviation": "Avvik · tidslinje",
        "histories.deviation_scope.project": "Prosjekt · tidslinje",
        "histories.deviation_scope.customer": "Kunde · tidslinje",
        "deviation.work_order.label": "Arbeidsordre",
        "deviation.work_order.link_dialog_title": "Tilknytt arbeidsordre",
        "deviation.work_order.section_title": "Knyttet arbeidsordre",
        "deviation.work_order.link_submit": "Lagre",
        "deviation.work_order.link_open": "Tilknytt arbeidsordre",
        "deviation.work_order.open_linked": "Åpne arbeidsordre",
        "deviation.work_order.unlink": "Fjern tilknytning",
        "deviation.work_order.change": "Bytt",
        "deviation.work_order.mode_existing": "Velg eksisterende",
        "deviation.work_order.mode_create": "Opprett ny",
        "deviation.work_order.existing_intro":
          "Bare arbeidsordrer uten annet tilknyttet avvik vises. Arbeidsordren som allerede er knyttet til dette avviket, kan velges eller fjernes.",
        "deviation.work_order.create_intro":
          "Opprett ny arbeidsordre — den blir knyttet til dette avviket når du lagrer.",
        "deviation.work_order.create_button": "Opprett arbeidsordre",
        "deviation.work_order.linked_after_create":
          "Arbeidsordre opprettet og knyttet til avviket",
        "deviation.work_order.link_failed_after_create":
          "Arbeidsordren ble opprettet, men kunne ikke knyttes til avviket. Åpne avviket og knytt arbeidsordren manuelt.",
        "deviation.work_order.suggested_wo_title_full":
          "Avvik {{number}} · {{title}}",
        "deviation.work_order.suggested_wo_title_number_only":
          "Avvik {{number}}",
        "deviation.work_order.toast_saved": "Arbeidsordre oppdatert",
        "deviation.toast.save_failed": "Kunne ikke lagre",
        "deviation.toast.load_failed": "Kunne ikke laste avvik",
        "deviation.toast.item_deleted": "Innlegget ble slettet",
        "deviation.form.description_required": "Beskrivelse er påkrevd",
        "deviation.form.consequence_required": "Konsekvens er påkrevd",
        "deviation.form.date": "Avviksdato",
        "deviation.form.reference": "Referanse",
        "deviation.form.severity": "Alvorlighetsgrad",
        "deviation.print.report": "Skriv ut rapport",
        "deviation.print.download": "Last ned",
        "deviation.status_updates_title": "Oppdatering",
        "deviation.drawing_documents_description":
          "Bilder og tegningssnapshots knyttet til avviket (samme pin-grupper som i Tegninger).",
        "deviation.perform_work.title": "Utfør arbeid",
        "deviation.perform_work.intro":
          "Opprett en arbeidsordre knyttet til avviket. Velg når arbeidet skal utføres – uten tung administrasjon.",
        "deviation.perform_work.deviation_label": "Avvik",
        "deviation.perform_work.date_label": "Utførelsesdato",
        "deviation.perform_work.date_today": "I dag",
        "deviation.perform_work.date_tomorrow": "I morgen",
        "deviation.perform_work.date_custom": "Valgt dato",
        "deviation.perform_work.date_pick": "Dato",
        "deviation.perform_work.date_preview": "Arbeidsordren settes til {{date}}.",
        "deviation.perform_work.submit": "Utfør arbeid",
        "deviation.perform_work.submitting": "Oppretter…",
        "deviation.perform_work.success": "Arbeidsordre opprettet og knyttet til avviket",
        "deviation.perform_work.error": "Kunne ikke opprette arbeidsordre fra avviket",
        "deviation.form.work_order_heading": "Arbeidsordre fra avvik",
        "deviation.form.work_order_mode_none": "Ikke tilknyttet",
        "deviation.form.work_order_mode_existing": "Velg eksisterende",
        "deviation.form.work_order_mode_create": "Opprett ny",
        "deviation.form.work_order_create_timing_intro": "Hvordan skal oppdraget starte?",
        "deviation.form.work_order_perform_now": "Arbeid utføres nå",
        "deviation.form.work_order_plan_later": "Arbeid skal planlegges",
        "deviation.form.work_order_perform_now_help":
          "Arbeidsordre opprettes med avvikets tittel og beskrivelse, knyttes til avviket, og en hendelse (oppdrag) opprettes på valgt utfører – med start nå og 2 timer.",
        "deviation.form.work_order_plan_later_help":
          "Avviket lagres. Du sendes til å opprette arbeidsordre; den knyttes automatisk til avviket når du lagrer den nye ordren.",
        "deviation.form.executor_label": "Utfører oppdraget",
        "deviation.form.executor_pick": "Velg utfører",
        "deviation.form.executor_hint": "Hendelsen knyttes til denne brukeren.",
        "deviation.form.executor_dialog_help":
          "Den som skal stå som deltaker på hendelsen når oppdraget gjennomføres nå.",
        "deviation.form.need_project_customer_for_work_order":
          "Velg prosjekt og kunde (fra avviket) før du kan opprette eller planlegge arbeidsordre her.",
        "deviation.form.work_order_create_failed":
          "Kunne ikke opprette arbeidsordre.",
        "deviation.form.event_creation_failed":
          "Arbeidsordre ble opprettet, men hendelsen kunne ikke opprettes automatisk. Legg den til manuelt på arbeidsordren.",
        "deviation.form.work_order_and_event_saved":
          "Arbeidsordre og hendelse ble opprettet og knyttet til avviket.",
        "deviation.form.saved": "Lagret",
        "deviation.form.save_failed": "Noe gikk galt ved lagring.",
        "deviation.form.default_wo_title": "Avvik – arbeidsordre",
        "deviation.settings.hub_tab": "Avviksvarsel",
        "deviation.settings.title": "Avviksvarsel",
        "deviation.settings.hub_intro":
          "Velg om avviksvarsler sendes med en gang eller samles i én e-post per dag. Du kan også styre om avsender får kopi.",
        "deviation.settings.load_failed": "Kunne ikke laste innstillinger for avviksvarsel",
        "deviation.settings.saved": "Innstillinger lagret",
        "deviation.settings.save_failed": "Kunne ikke lagre innstillinger for avviksvarsel",
        "deviation.settings.send_mode.title": "Utsendelse",
        "deviation.settings.send_mode.description": "Bestem når e-post om avvik sendes til mottakerne.",
        "deviation.settings.send_mode.immediate": "Send med en gang",
        "deviation.settings.send_mode.immediate_help": "Mottakerne får e-post så snart avviket sendes.",
        "deviation.settings.send_mode.digest": "Samlepost",
        "deviation.settings.send_mode.digest_help":
          "Avvik samles per mottaker og sendes én gang per dag etter valgt klokkeslett (Europe/Oslo). Nye avvik etter dagens utsendelse venter til neste dag.",
        "deviation.settings.digest_hour": "Send samlepost kl. (Europe/Oslo)",
        "deviation.settings.copy_sender.title": "Kopi til avsender",
        "deviation.settings.copy_sender.description": "Velg om den som sender avviket også skal få e-post.",
        "deviation.settings.copy_sender.toggle": "Send kopi til avsender",
        "deviations.list.notified_none": "Ingen varsler sendt",
        "deviations.list.notified_compact_suffix": " (+{{count}})",
        "Dashboard": "Dashboard",
        "Overview of your workspace": "Oversikt over arbeidsområdet",
        "Collapse": "Skjul",
        "Expand": "Vis",
        "case": "Sak",
        "is mentioned here": "er nevnt her",
        "is mentioned elsewhere": "er nevnt andre steder",
        "sent_sms_to_customer": "Sendt SMS til kunde",
        "Resource Hub": "Ressurssenter",
        "resource_hub.faq.linked_records_title": "Koblede ressurser",
        "resource_hub.faq.linked_records_help":
          "Knytt innlegget til andre registreringer (HMS/KS-dokument, kjøretøy, produkt, rapport, kunde, prosjekt). Velg type og søk fram posten i listen — du trenger ikke skrive inn numerisk ID. For HMS/KS: skriv minst to tegn i søkefeltet for å finne dokumenter.",
        "resource_hub.faq.linked_records_add": "Legg til kobling",
        "resource_hub.faq.linked_records_type": "Ressurstype",
        "resource_hub.faq.linked_records_id": "ID",
        "resource_hub.faq.linked_records_pick": "Søk og velg …",
        "resource_hub.faq.linked_records_existing": "Tittel (lagret)",
        "resource_hub.faq.link_type.hse_document": "HMS / KS-dokument",
        "resource_hub.faq.link_type.vehicle": "Kjøretøy",
        "resource_hub.faq.link_type.product": "Produkt",
        "resource_hub.faq.link_type.report": "Rapport",
        "resource_hub.faq.link_type.customer": "Kunde",
        "resource_hub.faq.link_type.project": "Prosjekt",
        "resource_hub.faq.linked_records_placeholder_type": "Velg type",
        "service.agreements.list.title": "Serviceavtaler",
        "service.agreements.list.hero_kicker": "Service",
        "service.agreements.list.subtitle":
          "Søk, filtrer på visning og administrer periodiske serviceavtaler.",
        "service.agreements.list.meta.total": "Avtaler",
        "service.agreements.list.meta.new": "Nye",
        "service.agreements.list.new": "Ny avtale",
        "service.agreements.list.filters_heading": "Filter",
        "service.agreements.list.filters_description":
          "Avgrens listen med søk og forhåndsdefinerte visninger.",
        "service.agreements.list.search_placeholder": "Søk i avtaler …",
        "service.agreements.list.sort_label": "Sortering",
        "service.agreements.list.per_page": "Per side",
        "service.agreements.list.table_kicker": "Liste",
        "service.agreements.list.table_title": "Avtaler",
        "service.agreements.list.table_description":
          "Velg rader for massehandlinger fra verktøylinjen over.",
        "service.agreements.list.empty": "Ingen serviceavtaler funnet.",
        "service.agreements.list.empty_cancelled":
          "Ingen kansellerte avtaler funnet.",
        "service.agreements.list.load_error":
          "Kunne ikke hente serviceavtaler.",
        "service.agreements.list.retry": "Prøv igjen",
        "service.agreements.filter.view": "Visning",
        "service.agreements.filter.kind": "Avtaletype",
        "service.agreements.filter.kind_framework": "Rammeavtale",
        "service.agreements.filter.kind_service": "Serviceavtale",
        "service.agreements.view.service_soon": "Service snart (5 dager)",
        "service.agreements.view.active": "Aktive",
        "service.agreements.view.cancelled": "Kansellerte",
        "service.agreements.view.cancelled_hint":
          "Åpne en kansellert avtale for å reaktivere den.",
        "service.agreements.form.errors_summary":
          "Skjemaet har feil — rett dem før lagring.",
        "service.agreements.create_reports.title":
          "Opprett oppdrag for {{count}} valgte anlegg",
        "service.agreements.create_reports.settings_heading":
          "Innstillinger for oppdrag",
        "service.agreements.create_reports.settings_body":
          "Dette oppretter {{count}} oppdrag for valgte anlegg med innstillingene under. Feiler ett anlegg, lagres ingen (all-or-nothing).",
        "service.agreements.create_reports.single_report_label":
          "Én felles rapport (sjekklistepunkter per anlegg)",
        "service.agreements.create_reports.single_report_help":
          "På: én rapport med sjekklistepunkter for hvert valgte anlegg. Av: separate rapporter per anlegg.",
        "service.agreements.create_reports.checklist_type": "Sjekklitetype",
        "service.agreements.create_reports.checklist_type_help":
          "Valgfri sjekklitetype oppretter sjekklister automatisk for rapportene.",
        "service.agreements.create_reports.description_label":
          "Beskrivelsesmal",
        "service.agreements.create_reports.description_placeholder":
          "Valgfri beskrivelse for oppdragene…",
        "service.agreements.create_reports.description_help":
          "Beskrivelsen brukes på alle opprettede oppdrag.",
        "service.agreements.create_reports.single_mode_heading":
          "Én-rapport-modus",
        "service.agreements.create_reports.single_mode_body":
          "Sjekklistepunkter opprettes per valgt anlegg med formatet «{{reportType}}: [Anleggsnavn] - [Adresse]».",
        "service.agreements.create_reports.report_type_fallback": "Rapporttype",
        "service.agreements.create_reports.submit":
          "Opprett {{count}} oppdrag",
        "service.agreements.sort.next_service_asc":
          "Neste service — tidligst først",
        "service.agreements.sort.next_service_desc":
          "Neste service — senest først",
        "service.agreements.sort.created_desc": "Opprettet — nyeste først",
        "service.agreements.sort.created_asc": "Opprettet — eldste først",
        "service.agreements.table.col_title": "Tittel",
        "service.agreements.table.col_type": "Type",
        "service.agreements.table.col_project": "Prosjekt",
        "service.agreements.table.col_customer": "Kunde",
        "service.agreements.table.col_delivery": "Leveringsadresse",
        "service.agreements.table.col_next": "Neste service",
        "service.agreements.table.col_interval": "Intervall",
        "service.agreements.table.col_status": "Status",
        "service.agreements.table.col_days": "Dager til service",
        "service.agreements.table.missing_address": "Ingen leveringsadresse",
        "service.agreements.table.col_next_job": "Neste oppdrag",
        "service.agreements.next_job.section_title": "Neste oppdrag",
        "service.agreements.next_job.next_on": "Neste oppdrag skal utføres",
        "service.agreements.next_job.days_until":
          "Det er {{count}} dager til neste oppdrag.",
        "service.agreements.next_job.in_progress": "Oppdrag er under utførelse",
        "service.agreements.actions.missing_type":
          "Mangler type, avtale kan ikke utføres",
        "service.agreements.actions.create_report": "Opprett ny rapport",
        "service.agreements.actions.create_order": "Opprett ordre",
        "service.agreements.actions.go_to_report": "Gå til rapport",
        "service.agreements.actions.hint_create_report":
          "Ny rapport blir opprettet. Når oppdraget er ferdig, blir neste service dato satt ut ifra ferdigstillelsedato.",
        "service.agreements.actions.hint_create_order":
          "Ny ordre opprettes, og neste service dato blir satt automatisk av systemet.",
        "service.agreements.actions.prompt_report_title": "Opprett ny rapport",
        "service.agreements.actions.prompt_report_body":
          "Er du sikker på at du vil opprette en ny rapport for denne serviceavtalen?",
        "service.agreements.actions.prompt_order_title": "Opprett ny ordre",
        "service.agreements.actions.prompt_order_body":
          "Er du sikker på at du vil opprette en ny ordre for denne serviceavtalen?",
        "service.agreements.actions.err_no_agreement":
          "Kan ikke opprette uten serviceavtale",
        "service.agreements.actions.err_active_report_report":
          "Kan ikke opprette rapport når det er en aktiv rapport",
        "service.agreements.actions.err_active_report_order":
          "Kan ikke opprette ordre når det er en aktiv rapport",
        "service.agreements.actions.err_no_customer_report":
          "Kan ikke opprette rapport uten kunde",
        "service.agreements.actions.err_no_customer_order":
          "Kan ikke opprette ordre uten kunde",
        "service.agreements.actions.err_invalid_address":
          "Kan ikke opprette ordre eller rapport uten gyldig leveringsadresse med land.",
        "service.agreements.actions.err_cancelled":
          "Kansellerte avtaler kan ikke opprette oppdrag eller ordre.",
        "service.agreements.actions.err_no_orderlines":
          "Kan ikke opprette ordre uten ordrelinjer. Legg til linjer under ordrelinjer-fanen.",
        "service.agreements.actions.creating": "Oppretter…",
        "service.agreements.actions.cancelled": "Kansellert",
        "service.agreements.actions.reactivated": "Avtalen er aktivert igjen.",
        "service.agreements.actions.cancel_failed": "Kunne ikke kansellere serviceavtalen.",
        "service.agreements.actions.load_failed": "Kunne ikke laste serviceavtalen.",
        "service.agreements.actions.reactivate_failed": "Kunne ikke reaktivere serviceavtalen.",
        "service.agreements.actions.cancel": "Kanseller",
        "service.agreements.actions.reactivate": "Reaktiver",
        "service.agreements.actions.cancel_prompt_title": "Kanseller serviceavtale",
        "service.agreements.actions.cancel_prompt_body":
          "Er du sikker på at du vil kansellere denne serviceavtalen?",
        "service.agreements.actions.reactivate_prompt_title": "Reaktiver serviceavtale",
        "service.agreements.actions.reactivate_prompt_body":
          "Er du sikker på at du vil aktivere denne serviceavtalen igjen?",
        "service.agreements.header.status": "Status",
        "service.agreements.header.notes": "Notater",
        "service.agreements.header.history": "Historikk",
        "service.agreements.actions.export_pdf": "Eksporter PDF",
        "service.agreements.actions.pdf_exporting": "Lager PDF…",
        "service.agreements.actions.pdf_failed": "Kunne ikke lage PDF",
        "service.agreements.documents.pdf_only": "Kun PDF-filer er tillatt",
        "service.agreements.multi_edit.title":
          "Masserediger {{count}} avtaler",
        "service.agreements.multi_edit.subtitle":
          "Kun avtalefelt endres. Oppdrag og produkter berøres ikke.",
        "service.agreements.multi_edit.selected_heading": "Valgte avtaler",
        "service.agreements.multi_edit.fields_heading": "Felt som endres",
        "service.agreements.multi_edit.field.interval": "Serviceintervall",
        "service.agreements.multi_edit.field.unchanged": "Uendret",
        "service.agreements.multi_edit.unchanged_hint":
          "Tomme felt forblir uendret på alle valgte avtaler.",
        "service.agreements.multi_edit.confirm_title": "Bekreft masseredigering",
        "service.agreements.multi_edit.confirm_body":
          "Du er i ferd med å oppdatere {{count}} avtaler. Endringen kan ikke angres automatisk.",
        "service.agreements.multi_edit.back": "Tilbake",
        "service.agreements.multi_edit.saving": "Lagrer avtaler…",
        "service.agreements.multi_edit.success": "Avtalene ble oppdatert.",
        "service.agreements.multi_edit.success_detail":
          "Oppdatert {{ok}} av {{total}} (feilet: {{fail}}).",
        "service.agreements.multi_edit.error.save":
          "Kunne ikke lagre masseredigeringen. Utvalget er beholdt.",
        "service.agreements.multi_edit.error.empty_selection":
          "Ingen avtaler er valgt.",
        "service.agreements.multi_edit.error.no_fields":
          "Velg minst ett felt som skal endres.",
        "service.agreements.tabs.details": "Detaljer",
        "service.agreements.tabs.edit": "Rediger",
        "service.agreements.tabs.documents": "Dokumenter",
        "service.agreements.tabs.signing": "Signering",
        "service.agreements.tabs.orderlines": "Ordrelinjer",
        "service.agreements.tabs.reports": "Oppdrag",
        "service.agreements.tabs.orders": "Ordrer",
        "service.agreements.signing.document_title": "Serviceavtale {{number}}",
        "service.agreements.signing.non_sensitive_title": "Serviceavtale",
        "service.agreements.subs.designation_required": "Betegnelse er påkrevd",
        "service.agreements.badge.framework": "Rammeavtale",
        "service.agreements.badge.service": "Serviceavtale",
        "service.agreements.address.incomplete_banner":
          "Leveringsadressen er ufullstendig. Full adresse med land er påkrevd før ordre og rapport kan opprettes (Tripletex krever land på fraktseddel).",
        "service.agreements.table.incomplete_address": "Mangler land",
        "delivery_address.country": "Land",
        "delivery_address.country_required": "Land er påkrevd",
        "delivery_address.country_hint":
          "Påkrevd for Tripletex-fraktseddel og ordre.",
        "delivery_address.edit": "Rediger adresse",
        "delivery_address.edit_title": "Rediger leveringsadresse",
        "delivery_address.edit_load_error": "Kunne ikke laste leveringsadressen.",
        "service.agreements.form.section_type": "Avtaletype",
        "service.agreements.form.section_type_help":
          "En rammeavtale kan omfatte flere inkluderte anlegg og gir prioritet ved service.",
        "service.agreements.form.is_framework": "Dette er en rammeavtale",
        "service.agreements.form.is_framework_help":
          "Rammeavtale brukes når flere anlegg hos kunden dekkes av samme avtale.",
        "service.agreements.form.vat_included": "Priser inkludert mva.",
        "service.agreements.form.section_parties": "Parter og tilknytning",
        "service.agreements.form.invoice_to_project": "Fakturer til prosjektkunde",
        "service.agreements.form.customer": "Kunde",
        "service.agreements.form.invoice_customer": "Fakturakunde",
        "service.agreements.form.project": "Prosjekt",
        "service.agreements.form.system": "Anlegg",
        "service.agreements.form.customer_required": "Kunde er påkrevd",
        "service.agreements.form.order_date_required": "Ordredato er påkrevd",
        "service.agreements.form.type_required": "Type er påkrevd",
        "service.agreements.form.save_failed": "Kunne ikke lagre avtalen. Prøv igjen.",
        "service.agreements.modal.create": "Opprett serviceavtale",
        "service.agreements.modal.update": "Oppdater serviceavtale",
        "service.reports.edit.actions": "Handlinger",
        "company.users.roles.has_access": "Har tilgang",
        "service.agreements.form.section_period": "Avtaleperiode",
        "service.agreements.form.section_period_help":
          "Fra startdato, med valgfri varighet, oppsigelse og automatisk forlengelse.",
        "service.agreements.form.order_date": "Ordredato",
        "service.agreements.form.start_date": "Avtalen starter",
        "service.agreements.form.duration_years": "Varighet (år)",
        "service.agreements.form.notice_months": "Oppsigelse (måneder)",
        "service.agreements.form.period_end": "Sluttdato",
        "service.agreements.form.auto_renew": "Automatisk forlengelse med 1 år",
        "service.agreements.form.section_discount": "Rabattavtale",
        "service.agreements.form.section_discount_help":
          "Avtalerabatt som gjelder reservedeler, tjenester eller generelt.",
        "service.agreements.form.discount_percent": "Generell rabatt %",
        "service.agreements.form.discount_parts": "Rabatt reservedeler %",
        "service.agreements.form.discount_services": "Rabatt tjenester %",
        "service.agreements.form.section_prices": "Priser",
        "service.agreements.form.offer_price": "Beløp per intervall",
        "service.agreements.form.hourly_rate": "Timepris",
        "service.agreements.form.callout_fee": "Oppmøte",
        "service.agreements.form.parts_markup": "Påslag materiell %",
        "service.agreements.form.subcontractor_markup": "Påslag underleverandør %",
        "service.agreements.form.section_address": "Leveringsadresse",
        "service.agreements.form.section_address_help":
          "Full adresse med land. Påkrevd før ordre og rapport.",
        "service.agreements.form.delivery_address": "Leveringsadresse",
        "service.agreements.form.section_contacts": "Kontaktpersoner",
        "service.agreements.form.section_contacts_help":
          "Flere kontakter hos kunde og leverandør. Merk én hovedkontakt for signering.",
        "service.agreements.form.section_text": "Avtaletekst",
        "service.agreements.form.short_description": "Kort beskrivelse",
        "service.agreements.form.agreement_text": "Avtalens innhold",
        "service.agreements.form.agreement_text_placeholder":
          "Skriv hva avtalen omfatter …",
        "service.agreements.form.conditions": "Vilkår og betingelser",
        "service.agreements.form.conditions_placeholder":
          "KPI-regulering, tilkomst, HMS, ansvar …",
        "service.agreements.contacts.contact_required": "Velg en kundekontakt",
        "service.agreements.contacts.employee_required": "Velg en ansatt",
        "service.agreements.contacts.empty": "Ingen kontaktpersoner er lagt til ennå.",
        "service.agreements.contacts.party.customer": "Kunde",
        "service.agreements.contacts.party.supplier": "Leverandør",
        "service.agreements.contacts.primary": "Hovedkontakt",
        "service.agreements.contacts.employee": "Ansatt",
        "service.agreements.contacts.contact": "Kontakt",
        "service.agreements.contacts.role": "Rolle / tittel",
        "service.agreements.contacts.role_placeholder": "Daglig leder, styreleder …",
        "service.agreements.contacts.add_customer": "Legg til kundekontakt",
        "service.agreements.contacts.add_supplier": "Legg til leverandørkontakt",
        "service.agreements.info.overview": "Oversikt",
        "service.agreements.info.overview_help": "Parter, type og rammeavtale.",
        "service.agreements.info.type": "Type",
        "service.agreements.info.contacts": "Kontaktpersoner",
        "service.agreements.info.description": "Beskrivelse",
        "service.agreements.info.agreement_text": "Avtaletekst",
        "service.agreements.info.discount": "Rabattavtale",
        "service.agreements.info.interval": "Intervall",
        "service.agreements.info.next_date": "Neste service",
        "service.agreements.info.days_until": "Dager til neste",
        "service.agreements.info.last_service": "Forrige service",
        "service.agreements.info.vat_included": "Inkl. mva.",
        "service.agreements.form.section_type_hint":
          "Avtaletype styrer blant annet om oppdrag opprettes som rapport (mission).",
        "service.agreements.form.vat_included_hint":
          "Marker om beløpene i avtalen er inkludert merverdiavgift.",
        "service.agreements.form.interval_hint":
          "Styrer neste servicedato. Ved intervall per ordrelinje gjelder det linjer som følger avtalen.",
        "service.agreements.form.duration_years_hint":
          "Avtaleperiode i hele år. Brukes sammen med oppsigelse og automatisk forlengelse.",
        "service.agreements.form.notice_months_hint":
          "Hvor mange måneder før utløp avtalen må sies opp.",
        "service.agreements.form.auto_renew_hint":
          "Når perioden er ute forlenges avtalen automatisk med ett år, med mindre den er sagt opp.",
        "service.agreements.form.section_discount_hint":
          "Oppsummeringsrabatt øverst, og egne rabattsatser per kategori, produkt eller fritekst under.",
        "service.agreements.form.discount_percent_hint":
          "Generell rabattsats for avtalen. Bruk linjene under for mer presise satser.",
        "service.agreements.form.section_prices_help":
          "Avtalte priser med eget intervall. Ordrelinjer under fanen kopieres fortsatt til rapport og ordre.",
        "service.agreements.form.section_prices_hint":
          "Prislinjer er kontraktspriser. De kopieres ikke automatisk til ordre.",
        "service.agreements.form.offer_price_hint":
          "Samlet beløp per serviceintervall. Bruk prislinjer hvis du har flere beløp med ulike intervaller.",
        "service.agreements.form.hourly_rate_hint":
          "Avtalt timepris for servicearbeid.",
        "service.agreements.form.callout_fee_hint":
          "Fast beløp for oppmøte / utrykning.",
        "service.agreements.form.parts_markup_hint":
          "Påslag i prosent på materiell og reservedeler.",
        "service.agreements.form.subcontractor_markup_hint":
          "Påslag i prosent på underleverandører og innkjøpte tjenester.",
        "service.agreements.price_lines.help":
          "Flere prislinjer med ulike intervaller, for eksempel årlig filterservice og kvartalsvis tilsyn.",
        "service.agreements.price_lines.hint":
          "Dette er avtalens kontraktspriser. De vises i PDF og erstatter ikke ordrelinjer som kopieres til rapport/ordre.",
        "service.agreements.price_lines.empty": "Ingen prislinjer er lagt til ennå.",
        "service.agreements.price_lines.line": "Prislinje",
        "service.agreements.price_lines.title": "Beskrivelse",
        "service.agreements.price_lines.amount": "Beløp",
        "service.agreements.price_lines.interval": "Intervall",
        "service.agreements.price_lines.product": "Produkt (valgfritt)",
        "service.agreements.price_lines.description": "Tilleggsbeskrivelse",
        "service.agreements.form.interval_mode": "Intervall gjelder",
        "service.agreements.form.interval_mode_agreement": "Hele avtalen",
        "service.agreements.form.interval_mode_per_line": "Per ordrelinje",
        "service.agreements.form.interval_mode_hint": "Hele avtalen: ett intervall styrer neste servicedato. Per linje: hver ordrelinje har egen neste dato, og ett besøk tar med alle linjer som forfaller innen 30 dager.",
        "service.agreements.info.line_next": "Neste",
        "service.agreements.info.line_last": "Sist",
        "service.agreements.info.line_next_visit": "Neste besøk",
        "service.agreements.info.line_in_active_report": "I pågående oppdrag",
        "service.agreements.lines.title": "Tjenester og produkter",
        "service.agreements.lines.subtitle": "Det som inngår i avtalen. Linjene vises i avtalen og PDF-en, og kopieres til oppdrag og ordre når «Med i oppdrag/ordre» er på.",
        "service.agreements.lines.product": "Produkt",
        "service.agreements.lines.pick_product": "Velg produkt …",
        "service.agreements.lines.item_number": "Art.nr.",
        "service.agreements.lines.change": "Bytt",
        "service.agreements.lines.choose": "Velg",
        "service.agreements.lines.service_placeholder": "F.eks. Årlig kontroll av ventilasjonsanlegg",
        "service.agreements.lines.quantity": "Antall",
        "service.agreements.lines.unit_price": "Enhetspris",
        "service.agreements.lines.discount": "Rabatt %",
        "service.agreements.lines.total": "Sum",
        "service.agreements.lines.description": "Beskrivelse",
        "service.agreements.lines.add_description": "Legg til beskrivelse",
        "service.agreements.lines.add_service": "Legg til tjeneste",
        "service.agreements.lines.add_product": "Legg til produkt",
        "service.agreements.lines.move_up": "Flytt opp",
        "service.agreements.lines.move_down": "Flytt ned",
        "service.agreements.lines.remove": "Fjern linje",
        "service.agreements.lines.empty_title": "Ingen linjer ennå",
        "service.agreements.lines.empty_body": "Legg til tjenestene og produktene avtalen omfatter.",
        "service.agreements.lines.sum_jobs": "Med i oppdrag/ordre",
        "service.agreements.lines.sum_all": "Sum avtale eks. mva.",
        "service.agreements.lines.error_product": "Velg et produkt eller bytt til tjeneste.",
        "service.agreements.lines.error_title": "Skriv hva tjenesten er.",
        "service.agreements.lines.error_quantity": "Antall må være større enn 0.",
        "service.agreements.lines.error_price": "Pris må være et tall, 0 eller mer.",
        "service.agreements.lines.error_discount": "Rabatt må være mellom 0 og 100.",
        "Monthly": "Månedlig",
        "Yearly (12 months)": "Årlig (12 måneder)",
        "Half Yearly (6 months)": "Halvårlig (6 måneder)",
        "Quarterly (3 months)": "Kvartalsvis (3 måneder)",
        "Every 8 Months": "Hver 8. måned",
        "Every 10 Months": "Hver 10. måned",
        "Every 2 Years": "Hvert 2. år",
        "Every 3 Years": "Hvert 3. år",
        "Every 4 Years": "Hvert 4. år",
        "Every 5 Years": "Hvert 5. år",
        "service.agreements.lines.mode_agreement_hint": "Ett intervall for hele avtalen. Linjer kan likevel vise eget intervall i avtalen.",
        "service.agreements.lines.mode_per_line_hint": "Hver linje har egen neste dato. Ett besøk tar med linjene som forfaller innen 30 dager, og bare de kopieres til oppdrag og ordre.",
        "service.agreements.lines.type": "Type",
        "service.agreements.lines.type_product": "Produkt",
        "service.agreements.lines.type_service": "Tjeneste",
        "service.agreements.lines.service_title": "Tjeneste",
        "service.agreements.lines.interval": "Intervall",
        "service.agreements.lines.follows_agreement": "Følger avtalen",
        "service.agreements.lines.next_service_date": "Neste service",
        "service.agreements.lines.next_service_date_hint": "Beregnes automatisk. Endre bare for å flytte denne linjen.",
        "service.agreements.lines.next_service_date_new": "Tom dato: settes fra avtalens startdato.",
        "service.agreements.lines.include_in_jobs": "Med i oppdrag/ordre",
        "service.agreements.lines.include_in_jobs_hint": "Av: vises i avtalen og PDF, men kopieres ikke til oppdrag eller faktura.",
        "service.agreements.lines.contract_only": "Kun i avtalen",
        "service.agreements.lines.form_pointer": "Tjenester, produkter og priser legges inn under fanen Ordrelinjer. Der velger du også intervall per linje.",
        "service.agreements.price_lines.add": "Legg til prislinje",
        "service.agreements.price_lines.title_required": "Beskrivelse er påkrevd",
        "service.agreements.price_lines.amount_invalid": "Beløp må være et tall",
        "service.agreements.price_lines.quantity_invalid": "Antall må være et tall",
        "service.agreements.discount_lines.label_required": "Beskrivelse er påkrevd",
        "service.agreements.discount_lines.percent_required": "Rabattprosent er påkrevd",
        "service.agreements.discount_lines.percent_invalid": "Rabattprosent må være et tall",
        "service.agreements.discount_lines.category_required": "Velg en produktkategori",
        "service.agreements.discount_lines.product_required": "Velg et produkt",
        "service.agreements.discount_lines.help":
          "Rabattsats per produktkategori, enkeltprodukt eller som fritekst.",
        "service.agreements.discount_lines.hint":
          "Velg kategori eller produkt fra registeret, eller skriv inn hva rabatten gjelder manuelt.",
        "service.agreements.discount_lines.empty": "Ingen rabattsatser er lagt til ennå.",
        "service.agreements.discount_lines.label": "Gjelder (fritekst)",
        "service.agreements.discount_lines.percent": "Rabatt %",
        "service.agreements.discount_lines.category": "Produktkategori",
        "service.agreements.discount_lines.product": "Produkt",
        "service.agreements.discount_lines.add": "Legg til rabattsats",
        "service.agreements.discount_lines.kind.manual": "Fritekst",
        "service.agreements.discount_lines.kind.category": "Kategori",
        "service.agreements.discount_lines.kind.product": "Produkt",
        "service.agreements.guide.title": "Guide for serviceavtale",
        "service.agreements.guide.open": "Guide",
        "service.agreements.guide.tab": "Slik bruker du avtalen",
        "service.agreements.guide.items.kind.title": "Serviceavtale eller rammeavtale",
        "service.agreements.guide.items.kind.body":
          "Rammeavtale brukes når flere anlegg hos kunden dekkes. Marker rammeavtale og legg til inkluderte anlegg.",
        "service.agreements.guide.items.interval.title": "Intervall og neste service",
        "service.agreements.guide.items.interval.body":
          "Avtalens intervall styrer neste servicedato og når oppdrag skal opprettes. Prislinjer kan ha andre intervaller uten å endre dette.",
        "service.agreements.guide.items.price_lines.title": "Prislinjer",
        "service.agreements.guide.items.price_lines.body":
          "Avtalte beløp med eget intervall, for eksempel årlig avtalepris og kvartalsvis tilsyn. Vises i PDF.",
        "service.agreements.guide.items.discount_lines.title": "Rabattsatser",
        "service.agreements.guide.items.discount_lines.body":
          "Sett rabatt på kategori, produkt eller som fritekst. Oppsummeringsfeltene er generell rabatt på deler og tjenester.",
        "service.agreements.guide.items.address.title": "Leveringsadresse",
        "service.agreements.guide.items.address.body":
          "Full adresse med land er påkrevd før ordre og rapport kan opprettes (Tripletex-fraktseddel).",
        "service.agreements.guide.items.contacts.title": "Kontaktpersoner",
        "service.agreements.guide.items.contacts.body":
          "Legg til flere kontakter hos kunde og leverandør. Hovedkontakt brukes til signering i PDF.",
        "service.agreements.guide.items.orderlines.title": "Ordrelinjer",
        "service.agreements.guide.items.orderlines.body":
          "Fanen Ordrelinjer er operativt innhold som kopieres til rapport og ordre. Den er ikke det samme som kontraktsprisene.",
        "service.agreements.setup.tab": "Kom i gang",
        "service.agreements.setup.blocked":
          "Du kan ikke opprette avtale før minst én avtaletype er opprettet under Service → Innstillinger.",
        "service.agreements.setup.intro":
          "Sjekk at innstillinger er på plass før du lager avtaler. Avtaletyper er påkrevd. Rapporttyper anbefales.",
        "service.agreements.setup.open_settings": "Åpne innstillinger",
        "service.agreements.setup.open_guide": "Åpne setup-guide",
        "service.agreements.setup.count": "{{count}} registrert",
        "service.agreements.setup.steps.agreement_types.title": "Avtaletyper",
        "service.agreements.setup.steps.agreement_types.body":
          "Minst én avtaletype må finnes. Typen velges på avtalen og kan styre om oppdrag er rapport (mission).",
        "service.agreements.setup.steps.report_types.title": "Rapporttyper",
        "service.agreements.setup.steps.report_types.body":
          "Anbefalt: opprett rapporttyper som brukes når serviceoppdrag opprettes fra avtalen.",
        "service.agreements.setup.steps.linked_report_type.title": "Koble rapporttype til avtaletype",
        "service.agreements.setup.steps.linked_report_type.body":
          "Avtaletyper merket som oppdrag (mission) bør ha en rapporttype, ellers kan nye oppdrag mangle mal.",
        "service.agreements.next_date.section_title": "Neste servicedato",
        "service.agreements.next_date.section_help":
          "Flytt datoen frem eller tilbake, eller endre intervallet som beregner neste service.",
        "service.agreements.next_date.section_hint":
          "Dette påvirker neste oppdrag. Prislinjenes intervaller endres ikke her.",
        "service.agreements.next_date.edit_date": "Rediger dato",
        "service.agreements.next_date.edit_interval": "Rediger intervall",
        "service.agreements.next_date.edit_date_title": "Rediger neste servicedato",
        "service.agreements.next_date.edit_interval_title": "Rediger intervall for neste service",
        "service.agreements.next_job.section_hint":
          "Opprett rapport eller ordre for neste service. Krever gyldig leveringsadresse med land.",
        "service.agreements.subs.title": "Inkluderte anlegg",
        "service.agreements.subs.help":
          "Anlegg som dekkes av avtalen, med plassering, type og filter.",
        "service.agreements.subs.add": "Legg til anlegg",
        "service.agreements.subs.adding": "Legger til …",
        "service.agreements.subs.added": "Anlegg lagt til",
        "service.agreements.subs.add_failed": "Kunne ikke legge til anlegg",
        "service.agreements.subs.fetch_failed": "Kunne ikke hente inkluderte anlegg",
        "service.agreements.subs.delete": "Fjern anlegg",
        "service.agreements.subs.deleted": "Anlegg fjernet",
        "service.agreements.subs.delete_failed": "Kunne ikke fjerne anlegg",
        "service.agreements.subs.delete_confirm":
          "Er du sikker på at du vil fjerne dette anlegget fra avtalen?",
        "service.agreements.subs.select_all": "Velg alle",
        "service.agreements.subs.create_jobs": "Opprett oppdrag ({{count}})",
        "service.agreements.subs.reports_created": "Opprettet {{count}} oppdrag",
        "service.agreements.subs.reports_failed": "Kunne ikke opprette oppdrag",
        "service.agreements.subs.empty":
          "Ingen anlegg er inkludert ennå. Legg til anlegg for rammeavtalen.",
        "service.agreements.subs.col_location": "Plassering",
        "service.agreements.subs.col_equipment": "Anlegg",
        "service.agreements.subs.col_designation": "Benevnelse",
        "service.agreements.subs.col_filter": "Filter",
        "service.agreements.subs.name_optional": "Navn (valgfritt)",
        "service.agreements.subs.use_customer_address": "Bruk kundens adresse",
        "service.agreements.subs.use_system_address": "Bruk anleggets adresse",
        "service.agreements.subs.use_system_address_named": "Bruk anleggets adresse ({{address}})",
        "service.agreements.subs.system_address_missing": "Anlegget har ingen egen leveringsadresse ennå.",
        "service.report.order_dialog.title_create": "Opprett ordre fra rapport",
        "service.report.order_dialog.title_additional": "Opprett tilleggsordre",
        "service.report.product_line_dialog.title": "Produktlinje",
        "service.report.product_line_dialog.delete_line": "Slett linje",
        "service.report.product_line_dialog.delete_tooltip": "Slett linje",
        "service.report.product_line_dialog.delete_confirm_title":
          "Slette denne linjen permanent?",
        "service.report.product_line_dialog.delete_confirm_hint":
          "Handlingen kan ikke angres.",
        "service.report.product_line_dialog.delete_cancel": "Avbryt",
        "service.report.product_line_dialog.delete_confirm": "Slett",
        "service.report.product_line_dialog.delete_working": "Sletter…",
        "service.report.product_line_dialog.back_tooltip": "Tilbake til produktlinje",
        "service.report.order_dialog.dialog_eyebrow": "Ordre",
        "service.report.order_dialog.section_invoice": "Kunde og faktura",
        "service.report.order_dialog.section_km": "Kilometer",
        "service.report.order_dialog.section_price_lines": "Avtalte prislinjer",
        "service.report.order_dialog.section_order_group": "Ordregruppering",
        "service.report.order_dialog.price_lines_intro":
          "Følgende prislinjer legges automatisk til i ordren:",
        "service.report.order_dialog.price_lines_included_hours": "Inkluderte timer:",
        "service.report.order_dialog.price_lines_footer_note":
          "Disse prislinjene inkluderer {{hours}} timer som faktureres via prislinjene, ikke separat.",
        "service.report.order_dialog.generate_invoice": "Generer med ChatGPT",
        "service.report.order_dialog.generating_invoice": "Genererer…",
        "service.report.order_dialog.orders_heading": "Ordre på denne rapporten",
        "service.report.order_dialog.open_order": "Gå til ordre {{number}}",
        "service.report.order_dialog.create": "Opprett ordre",
        "service.report.order_dialog.create_another": "Opprett ny ordre",
        "service.report.order_dialog.follow_up_notice_title": "Tilleggsordre",
        "service.report.order_dialog.follow_up_notice_body":
          "Avtalte prislinjer ble lagt på første ordre fra rapporten og legges ikke inn automatisk på nye ordre. Du kan fakturere nye timer, kjøring og ordrelinjer som ikke allerede er fakturert.",
        "service.report.order_dialog.hours_rounding_label": "Avrunding av fakturerte timer",
        "service.report.order_dialog.hours_rounding_actual":
          "Faktisk registrert tid (ingen avrunding)",
        "service.report.order_dialog.hours_rounding_ceil_half":
          "Avrund opp til nærmeste halvtime (0,5 t)",
        "service.report.order_dialog.hours_rounding_nearest_half":
          "Avrund til nærmeste halvtime",
        "service.report.order_dialog.hours_rounding_ceil_hour": "Avrund opp til hele timer",
        "service.report.order_dialog.hours_rounding_nearest_hour": "Avrund til nærmeste hele time",
        "service.report.order_dialog.hours_rounding_hint":
          "Standard er faktisk tid. Velg avrunding kun når faktureringsregler krever det (tilsvarer gammel «avrund opp til halvtime» når du velger opp til halvtime).",
        "service.report.order_dialog.hour_lines_label": "Ordrelinjer for timer",
        "service.report.order_dialog.hour_lines_each":
          "Én linje per timeregistrering (anbefalt for oversikt)",
        "service.report.order_dialog.hour_lines_grouped":
          "Slå sammen per aktivitet (én linje per aktivitet)",
        "service.report.order_dialog.hour_lines_hint":
          "Flere registreringer samme dag på samme aktivitet blir én linje ved «slå sammen». Fast aktivitetsgebyr (budget_fee) blir fortsatt én linje per aktivitet.",
        "service.report.order_dialog.section_order_lines": "Ordrelinjer (vareforbruk)",
        "service.report.order_dialog.section_order_lines_subtitle":
          "{{selected}} av {{total}} ordrelinjer",
        "service.report.order_dialog.section_hours_subtitle":
          "{{selected}} av {{total}} timer",
        "service.report.order_dialog.section_hours_subtitle_manual":
          "Manuelle timer eller velg registreringer under",
        "service.report.order_dialog.toggle_order_lines_aria": "Fakturer ordrelinjer",
        "service.report.order_dialog.toggle_hours_aria": "Fakturer timer",
        "service.report.order_dialog.invoice_order_lines_switch":
          "Fakturer ordrelinjer ({{selected}} av {{total}} med forbruk valgt)",
        "service.report.order_dialog.pick_order_lines":
          "Velg ordrelinjer å fakturere (kun produkter med forbruk):",
        "service.report.order_dialog.no_consumption_lines":
          "Ingen ordrelinjer med forbruk registrert",
        "service.report.order_dialog.add_tilleggsarbeider_group_label":
          "Egen ordregruppe «Tilleggsarbeider»",
        "service.report.order_dialog.add_tilleggsarbeider_group_hint":
          "Slå av for å legge timer og tilhørende linjer i hovedgruppen (samme gruppe som fakturatittel/tekst). Nyttig når du kun vil ha ordrelinjer uten ekstra gruppe.",
        "service.report.order_dialog.section_hours": "Timer (tilleggsarbeid)",
        "service.report.order_dialog.invoice_hours_switch":
          "Fakturer timer ({{selected}} av {{total}} timer valgt)",
        "service.report.order_dialog.invoice_hours_switch_manual":
          "Fakturer timer (manuelt eller fra liste)",
        "service.report.order_dialog.hours_manual_notice_title": "Ingen fakturerbare timeregistreringer",
        "service.report.order_dialog.hours_manual_notice_body":
          "Alle timer kan ligge i avtalte prislinjer, eller ingen timer er registrert. Slå på fakturering og fyll inn manuelt timeantall under for å legge standard timeprodukt på ordren.",
        "service.report.order_dialog.pick_billable_hours":
          "Velg timer å fakturere (kun tilleggsarbeid):",
        "service.report.order_dialog.hours_settings_heading": "Timer-innstillinger",
        "service.report.order_dialog.manual_hours_label":
          "Manuelt timeantall (overstyrer valgte timer når utfylt)",
        "service.report.order_dialog.manual_hours_placeholder":
          "Påkrevd ved kun manuell fakturering — ellers valgfritt",
        "service.report.order_dialog.hours_discount_label": "Rabatt (%)",
        "service.report.order_dialog.hours_preview_heading": "Forhåndsvisning",
        "service.report.order_dialog.hours_preview_quantity": "Antall timer: {{hours}}",
        "service.report.order_dialog.hours_preview_discount": "Rabatt: {{pct}}%",
        "service.report.order_dialog.price_lines_select_hint":
          "Velg hvilke avtalte prislinjer som skal med på ordren.",
        "service.report.analyzer.title": "Rapportanalyse",
        "service.report.analyzer.run": "Kjør analyse",
        "service.report.analyzer.running": "Analyserer…",
        "service.report.analyzer.run_success": "Analyse fullført",
        "service.report.analyzer.run_failed": "Kunne ikke kjøre analyse",
        "service.report.analyzer.create_order": "Opprett ordre fra forslag",
        "service.report.analyzer.creating_order": "Oppretter ordre…",
        "service.report.analyzer.order_created": "Ordre opprettet fra analyse",
        "service.report.analyzer.order_failed": "Kunne ikke opprette ordre",
        "service.report.analyzer.checks_heading": "Kontroller",
        "service.report.analyzer.fix_required": "Må utbedres",
        "service.report.analyzer.improvements_heading": "Forbedringspunkter",
        "service.report.analyzer.suggested_invoice": "Foreslått fakturatekst",
        "service.report.analyzer.suggested_process_note": "Foreslått notat til rapportbehandling",
        "service.report.analyzer.process_required_title": "Rapportbehandling påkrevd",
        "service.report.analyzer.process_required_body":
          "Analysen fant alvorlige feil. Bruk «Behandle rapport» under for å avslå rapporten med notat — feltbrukeren får e-post.",
        "service.report.analyzer.not_run_title": "Ingen analyse kjørt",
        "service.report.analyzer.not_run_body":
          "Kjør analyse for å kontrollere sjekkliste, bilder, kundebeskrivelse og få forslag til faktura og ordre.",
        "service.report.analyzer.status.none": "Ikke analysert",
        "service.report.analyzer.status.pass": "Analyse OK — klar for rapportbehandling",
        "service.report.analyzer.status.warn": "Analyse fant forbedringspunkt",
        "service.report.analyzer.status.fail": "Analyse fant alvorlige feil",
        "service.report.process.analysis_prefill_title": "Fylt inn fra analyse",
        "service.report.process.analysis_prefill_body":
          "«Ikke godkjent» og notat er fylt inn fra analysefunn. Juster ved behov før lagring — feltbrukeren får e-post ved ikke godkjent.",
        "service.report.process.process_note_required": "Notat er påkrevd når rapporten ikke er godkjent",
        "service.report.correction.title": "Må utbedres",
        "service.report.correction.subtitle": "Rapporten er ikke godkjent. Rett opp det som står nedenfor og ferdigstill på nytt.",
        "service.report.correction.items_heading": "Punkter som må rettes",
        "service.report.correction.fallback_body": "Rapporten er ikke godkjent og må korrigeres. Kontakt kontoret hvis du er usikker på hva som skal rettes.",
        "service.report.correction.open_section": "Gå til seksjon",
        "service.report.analyzer.check.checklist_complete": "Sjekkliste",
        "service.report.analyzer.check.checklist_images": "Bilder på sjekkliste",
        "service.report.analyzer.check.work_documented": "Dokumentert arbeid",
        "service.report.analyzer.check.customer_issues_addressed": "Kundebeskrivelse",
        "service.report.analyzer.check.deviations_noted": "Avvik",
        "service.report.analyzer.check.item_consumption": "Vareforbruk",
        "service.report.analyzer.check.variables_complete": "Variabler",
        "service.report.analyzer.check.must_be_rectified": "Utbedring",
        "service.report.analyzer.check.complaint": "Reklamasjon",
        "service.report.analyzer.details.checklist_complete_incomplete":
          "{{incomplete}} av {{total}} punkter er ikke utfylt",
        "service.report.analyzer.details.checklist_images_missing":
          "Mangler bilder: {{titles}}",
        "service.report.analyzer.details.customer_preview":
          "Kundebeskrivelse: «{{preview}}»",
        "service.report.analyzer.details.deviations_count": "{{count}} avvik",
        "service.report.analyzer.details.item_consumption_unhandled":
          "{{count}} varer er ikke ferdig behandlet (må være «brukt på oppdrag» eller «ikke brukt»)",
        "item_consumption_not_handled":
          "Vareforbruk må være «brukt på oppdrag» eller «ikke brukt». «Tatt med i bilen» er kun midlertidig.",
        "item_consumption_handled": "Vareforbruk er ferdig behandlet",
        "service.report.finish.item_consumption_not_handled":
          "Vareforbruk må være satt til «brukt på oppdrag» eller «ikke brukt» før rapporten kan ferdigstilles. «Tatt med i bilen» er kun midlertidig.",
        "service.report.analyzer.details.variables_complete_incomplete":
          "{{count}} variabler er ufullstendig utfylt",
        "service.report.analyzer.message_fallback.fail": "Fant alvorlige mangler",
        "service.report.analyzer.message_fallback.warn": "Fant forbedringspunkt",
        "service.report.analyzer.message_fallback.pass": "OK",
        "service.report.analyzer.message_fallback.none": "",
        "Order Lines": "Orderlinjer",
        "Not chosen": "Ikke valgt",
        "Address": "Adresse",
        "None": "Mangler",
        "New": "Ny",
        "More": "Mer",
        "Order Confirmation Sent": "Ordrebekreftelse sendt",
        "Ready to be picked": "Klar til å plukkes",
        "Picked": "Plukket",
        "Packed": "Pakket",
        "Ready to be shipped": "Klar til å sendes",
        "Ready to be invoiced": "Klar til fakturering",
        "Invoiced": "Fakturert",
        "Cancelled": "Kansellert",
        "Accomplished": "Ferdigstilt",
        "Agreement confirmed": "Avtale bekreftet",
        "Agreement not confirmed": "Avtale ikke bekreftet",
        "Ongoing": "Pågående",
        "number.from": "Fra",
        "number.to": "Til",
        "updated": "Oppdatert",
        "product.add": "Legg til produkt",
        "product.update": "Oppdater produkt",
        "product.model_year": "Modellår",
        "product.replaced_by_product": "Erstattet av produkt",
        "product.replaced_by.banner_title": "Dette produktet er erstattet",
        "product.replaced_by.banner_description":
          "Bruk erstatningsproduktet for oppdatert informasjon, pris og lager.",
        "product.replaced_by.open_replacement": "Åpne erstatningsprodukt",
        "product.selector.open_product": "Åpne produkt",
        "product.selector.replaced_label": "Erstattet",
        "product.selector.search_placeholder": "Søk etter produkter …",
        "product.selector.empty_flat_list":
          "Søk eller bla i listen. Bruk trakten for å avgrense aktive, utgåtte eller lagerfilter.",
        "customer.system.product_search_placeholder":
          "Søk etter anlegg (produkter med reservedeler) …",
        "product.selector.filter_system_products": "System (produkter med reservedeler)",
        "product.selector.toggle_filters": "Vis filtre",
        "Show all": "Vis alle",
        "Show in new tab": "Vis i ny fane",
  
        "Welcome to Promang": "Welcome to React and react-i18next",
        "Sign in to your account": "Logg in i din konto",
        "product.brands": "Merkevarer",
        "product.brand": "Produkt Merke",
        "Complaint": "Reklamasjon",
        "Must be Rectified": "Må utbedres",
        "Internal Report": "Intern Rapport",
        "missing_system": "Mangler system",
        "missing_report": "Mangler rapport",
        "missing_customer": "Mangler kunde",
        "missing_order": "Mangler ordre",
        "missing_order_lines": "Mangler orderlinjer",
        "missing_hours": "Mangler timer",
        "customer.type": "Kundetype",
        "customer.name.required": "Kundenavn er påkrevd",
        "Contact information": "Kontaktinformasjon",
        "company.outbound_mail.title": "Utgående e-post (Microsoft)",
        "company.outbound_mail.description": "Velg hvilken delt firmapostkasse Promang skal sende fra (Microsoft 365). Tom eller uten Microsoft-fallback: bruk Promangs standard e-post.",
        "company.outbound_mail.mailbox_label": "Send system-e-post fra delt postkasse",
        "company.outbound_mail.promang_default": "Promang standard (ikke Microsoft)",
        "company.outbound_mail.case_email_hint": "Saks-e-post til ansatte sendes fra den ansattes egen Microsoft-konto når den er koblet under brukerinnstillinger — ikke fra denne delte postkassen.",
        "company.inbound_email.title": "Innkommende post / kundeservice",
        "company.inbound_email.description":
          "Når post@ eller kundeservice mottar e-post, kan Promang opprette sak, kunde og sende takk med saksnummer. Per postkasse kan du finjustere under Microsoft-innbokser.",
        "company.inbound_email.enabled": "Behandle innkommende e-post",
        "company.inbound_email.auto_create_case": "Opprett sak automatisk",
        "company.inbound_email.auto_create_customer": "Opprett kunde hvis ingen treff",
        "company.inbound_email.auto_reply": "Send autosvar med saksnummer",
        "company.inbound_email.reuse_open_case": "Gjenbruk åpen sak på samme kunde",
        "company.inbound_email.match_phone": "Søk kunde på mobilnummer",
        "company.inbound_email.match_name": "Søk kunde på navn (kun unikt treff)",
        "company.inbound_email.ignore_own_domain": "Hopp over e-post fra eget firmadomene",
        "company.inbound_email.from_domains_ignore": "Ignorer avsenderdomener (kommaseparert)",
        "company.inbound_email.subject_contains_ignore": "Ignorer emneord (kommaseparert)",
        "company.inbound_email.mailbox_hint": "Koble delte postkasser og slå på bakgrunnsbehandling her:",
        "company.inbound_email.mailbox_link": "Delte innbokser",
        "company.inbound_email.fallback_heading": "Når e-posten ikke kan behandles automatisk",
        "company.inbound_email.fallback_description":
          "Velg hvor uklassifisert innkommende post skal sendes, og hva som skjer med kopier av e-post Promang selv har sendt til kunden (for eksempel bekreftelse av oppdrag).",
        "company.inbound_email.unknown_fallback_to": "Videresend ukjent post til",
        "company.inbound_email.unknown_fallback_placeholder": "saksbehandler@firma.no",
        "company.inbound_email.unknown_fallback_hint":
          "Brukes når Promang ikke kan klassifisere, knytte til sak eller ellers behandle meldingen. Tomt felt: meldingen blir liggende i innboksen (ingenting slettes).",
        "company.inbound_email.system_copy_action": "E-post Promang har sendt (kopi i postkassen)",
        "company.inbound_email.system_copy_action_none": "Ikke gjør noe (ikke ny sak)",
        "company.inbound_email.system_copy_action_archive": "Arkiver direkte",
        "company.inbound_email.system_copy_action_forward": "Videresend til valgt adresse",
        "company.inbound_email.system_copy_hint":
          "Gjenkjennes som Promang-utsending (header, avsender og kjente maler). Autosvar sendes ikke. Standard er å ikke opprette sak.",
        "company.inbound_email.system_copy_forward_to": "Videresend Promang-kopi til",
        "company.inbound_email.system_copy_forward_placeholder": "leder@firma.no",
  "case.mail_thread.missing_thread_title": "Finner ikke den tidligere e-posttråden",
  "case.mail_thread.missing_thread_choice": "E-posten er ikke sendt. Vil du sende til {{to}} som en ny tråd? Den gamle tråden blir fortsatt liggende på saken.",
  "case.mail_thread.send_new_thread": "Send som ny tråd",
  "case.mail_thread.thread_number": "Tråd {{number}}",
  "case.mail_thread.active_thread": "Aktiv tråd",
  "case.mail_thread.previous_send_confirmed": "En tidligere e-post er bekreftet sendt. Dette utkastet er ikke sendt.",
  "case.mail_thread.send_blocked": "En annen sending fra denne saken er ikke avklart. Denne e-posten er ikke sendt. Sjekk status før du prøver igjen.",
  "case.mail_thread.send_storage_failed": "Kan ikke lagre sendestatus i nettleseren. Tillat lokal lagring før du sender.",
  "case.mail_thread.send_unknown": "Det er ikke avklart om e-posten ble sendt. Sjekk status. Ikke send på nytt før utfallet er avklart. Hvis status ikke kan avklares, kontroller Sendte elementer i Outlook og kontakt administrator.",
  "case.mail_thread.check_send_status": "Sjekk sendestatus",
  "case.mail_thread.sent_refresh_failed": "E-posten er sendt, men visningen kunne ikke oppdateres. Last inn saken på nytt.",
        "case.mail_thread.open": "Mailtråd",
        "case.mail_thread.dialog_title": "Mailtråd",
        "case.mail_thread.empty": "Ingen e-poster i tråden ennå.",
        "case.mail_thread.load_failed": "Kunne ikke hente e-posttråden.",
        "case.mail_thread.candidates_failed": "Kunne ikke hente e-poster fra innboksen.",
        "case.mail_thread.link_title": "Knytt e-posttråd",
        "case.mail_thread.link_action": "Knytt til saken",
        "case.mail_thread.linked": "E-posttråden er knyttet til saken.",
        "case.mail_thread.link_failed": "Kunne ikke knytte e-posttråden.",
        "case.mail_thread.no_candidates": "Fant ingen e-poster i den delte innboksen.",
        "case.mail_thread.reply_title": "Svar kunde på e-post",
        "case.mail_thread.compose_title": "Ny e-post til kunde",
        "case.mail_thread.to": "Til",
        "case.mail_thread.subject": "Emne",
        "case.mail_thread.body_placeholder": "Skriv e-posten her. Maler og formatering kan brukes.",
        "case.mail_thread.pick_template": "Velg mal",
        "case.mail_thread.format_ai": "Formater tekst",
        "case.mail_thread.ai_working": "Formaterer …",
        "case.mail_thread.ai_needs_text": "Skriv litt tekst før du formaterer.",
        "case.mail_thread.ai_failed": "Kunne ikke formatere teksten.",
        "case.mail_thread.send": "Send",
        "case.mail_thread.sending": "Sender …",
        "case.mail_thread.sent": "E-posten er sendt.",
        "case.mail_thread.send_failed": "Kunne ikke sende e-posten.",
        "case.mail_thread.send_failed_http": "Kunne ikke sende e-posten ({{status}}).",
        "case.mail_thread.open_message": "Åpne e-post",
        "case.mail_thread.html_iframe_title": "E-postinnhold",
        "case.mail_thread.latest_first": "Nyeste e-post øverst",
        "case.mail_thread.body_loading": "Henter e-postinnhold …",
        "case.quick_tools.title": "Hurtig verktøy",
        "case.mail_thread.missing_recipient": "Legg inn kundens e-postadresse.",
        "case.mail_thread.missing_body": "Skriv e-posten før du sender.",
        "case.mail_thread.default_subject": "Henvendelse",
        "case.mail_thread.signature_hint":
          "Signaturen din legges til når du trykker Send, ikke i utkastet.",
        "case.mail_thread.signature_banner_title": "Legg til e-postsignatur",
        "case.mail_thread.signature_banner_body":
          "Du må legge inn signatur under Profil → E-post før kundemailen ser ferdig ut.",
        "case.mail_thread.signature_banner_cta": "Åpne E-post-fanen",
        "case.unread_mail.tag": "Ulest svar fra kunde",
        "case.labels.clear_all": "Fjern alle",
        "case.labels.add": "Legg til",
        "case.labels.add_label": "Legg til etikett",
        "case.labels.remove": "Fjern {{name}}",
        "case.labels.search_or_create": "Søk eller opprett etikett…",
        "case.labels.search": "Søk etter etikett…",
        "case.labels.create": "Opprett «{{name}}»",
        "case.labels.create_failed": "Kunne ikke opprette etiketten",
        "case.labels.no_matches": "Ingen treff",
        "case.labels.selected_count": "{{count}} valgt",
        "case.labels.none_selected": "Ingen valgt",
        "case.labels.keyboard_hint": "↑↓ velg · Enter · Esc",
        "case.unread_mail.item_label": "Ny e-post",
        "case.unread_mail.glow_aria": "Nyeste innkommende e-post",
        "company.userRoles.helpLabel.scope": "Dette inkluderer:",
        "company.userRoles.helpLabel.admin": "Admin bør tenke på:",
        "company.userRoles.sections.actions": "Handlinger",
        "company.userRoles.sections.submodules": "Undermoduler",
        "company.userRoles.accessIntro":
          "Hjelpeteksten under hver rolle forklarer tilgangen og hva du bør vurdere før du tildeler rettigheter.",
        "company.userRoles.tab": "Roller",
        "company.userRoles.searchPlaceholder": "Søk i moduler og roller …",
        "company.userRoles.templates.title": "Rollemaler",
        "company.userRoles.templates.intro":
          "Velg en mal for å raskt tildele et sett med roller til en ny ansatt. Du kan finjustere etterpå.",
        "company.userRoles.templates.applied": "Mal tatt i bruk. Husk å lagre.",
        "company.userRoles.projectsAccess.title": "Prosjekttilgang",
        "company.userRoles.projectsAccess.intro":
          "Styr om brukeren har full tilgang til alle prosjekter, eller kun til utvalgte prosjekter.",
        "company.userRoles.projectsAccess.adminToggle":
          "Prosjektadministrator – alle prosjekter",
        "company.userRoles.projectsAccess.adminHelp":
          "Full tilgang til alle prosjekter i firmaet, inkludert arbeidsordrer og planlegging. Gir ikke firmaadministrasjon, brukere eller roller.",
        "company.userRoles.projectsAccess.selectedLabel":
          "Full tilgang på valgte prosjekter",
        "company.userRoles.projectsAccess.selectedHelp":
          "Brukeren får full tilgang kun på prosjektene du velger her (i tillegg til prosjekter der brukeren er deltaker).",
        "company.userRoles.projectsAccess.searchPlaceholder":
          "Søk etter prosjekt eller prosjektnummer …",
        "company.userRoles.projectsAccess.noProjects": "Ingen prosjekter funnet.",
        "company.userRoles.projectsAccess.saveMissingRole":
          "Kunne ikke lagre prosjektadministrator-tilgang fordi rollekatalogen ikke er klar. Prøv igjen om litt.",
        "company.userRoles.noMatches": "Ingen moduler eller roller passer til søket.",
        "company.userRoles.summary.none": "Ingen tilgang",
        "company.userRoles.summary.on": "Aktivert",
        "company.userRoles.summary.selected": "{{count}} valgt",
        "company.userRoles.categories.admin": "Administrasjon",
        "company.userRoles.categories.projects": "Prosjekt og arbeidsordre",
        "company.userRoles.categories.time": "Timer, fravær, kalender og lønn",
        "company.userRoles.categories.service": "Service",
        "company.userRoles.categories.quality": "Kvalitet og HMS",
        "company.userRoles.categories.fleet": "Kjøretøy og kjøring",
        "company.userRoles.categories.drawings": "Tegninger og BIM",
        "company.userRoles.categories.customers": "Kunder og kommunikasjon",
        "company.userRoles.categories.sales": "Salg, lager og produkter",
        "company.userRoles.categories.other": "Andre moduler",
        "company.users.page_title": "Brukere",
        "company.users.subtitle_selected": "{{count}} valgt",
        "company.users.hero.kicker": "Selskap",
        "company.users.hero.title": "Brukere og tilgang",
        "company.users.hero.subtitle":
          "Administrer folk, roller, invitasjoner og filtre på ett sted — i tråd med dashboardoversikten.",
        "company.users.stats.total": "Totalt",
        "company.users.stats.on_page": "På denne siden",
        "company.users.stats.selected": "Valgt",
        "company.users.section.kicker": "Oversikt",
        "company.users.section.title": "Brukerliste",
        "company.users.section.subtitle":
          "Søk, filtrer og åpne en profil for å redigere detaljer.",
        "company.users.section.meta_line": "{{total}} brukere · side {{page}}",
        "company.users.search_placeholder": "Søk etter brukere…",
        "company.users.filters_heading": "Filtre",
        "company.users.filters_description":
          "Søk og avgrens listen med valgene under.",
        "company.users.filter_title": "Filtrer brukere",
        "company.users.filter.active": "Aktive brukere",
        "company.users.filter.employee": "Ansatte",
        "company.users.filter.show_in_dropdown": "Vis i nedtrekk",
        "company.users.new_user": "Ny bruker",
        "company.users.calendar": "Kalender",
        "company.users.loading": "Laster brukere…",
        "company.users.table.status_inactive": "Inaktiv",
        "company.users.table.status_pending": "Venter",
        "company.users.table.status_active": "Aktiv",
        "company.users.table.empty_title": "Ingen brukere funnet",
        "company.users.table.empty_hint":
          "Prøv å endre søk eller filtre for å se flere treff.",
        "company.users.table.row_kicker": "Bruker",
        "company.users.table.unnamed": "Uten navn",
        "company.users.table.calendar": "Kalender",
        "company.users.profile.read_only_title": "Brukerinformasjon er skrivebeskyttet",
        "company.users.profile.read_only_multi_company":
          "Denne brukeren er knyttet til flere selskaper. Profilen (navn, bilde, kontakt osv.) kan bare redigeres fra vedkommendes primære selskap for å unngå motstridende endringer. Bytt til det selskapet i arbeidsområdet, eller sett riktig primærselskap på brukeren.",
        "company.users.table.edit": "Rediger",
        "company.users.table.settings": "Profil",
        "company.users.table.view": "Åpne",
        "company.users.table.selected_of_total":
          "{{selected}} av {{total}} valgt",
        "company.users.table.user_count": "{{count}} brukere",
        "company.users.table.n_selected": "{{count}} valgt",
        "company.users.invitation.expired":
          "Denne brukeren har en utløpt invitasjonslenke.",
        "company.users.invitation.resend_button": "Send invitasjon på nytt",
        "company.users.invitation.resending": "Sender invitasjon...",
        "company.users.invitation.resend_success":
          "Invitasjonen ble sendt på nytt.",
        "company.users.invitation.resend_error":
          "Kunne ikke sende invitasjonen på nytt.",
        "company.users.password.section_title": "Passord og invitasjon",
        "company.users.password.section_subtitle":
          "Send lenke for å sette passord, eller sett passord direkte. Historikk vises nedenfor.",
        "company.users.password.send_link": "Send lenke for å sette passord",
        "company.users.password.sending": "Sender lenke…",
        "company.users.password.send_success": "Lenke for å sette passord er sendt.",
        "company.users.password.send_error": "Kunne ikke sende lenke for å sette passord.",
        "company.users.password.set_password": "Sett passord",
        "company.users.password.set_subtitle":
          "Sett et midlertidig passord for brukeren. Del det sikkert utenom Promang.",
        "company.users.password.new_password": "Nytt passord",
        "company.users.password.confirm_password": "Bekreft passord",
        "company.users.password.cancel": "Avbryt",
        "company.users.password.save": "Lagre passord",
        "company.users.password.saving": "Lagrer…",
        "company.users.password.set_success": "Passordet er oppdatert.",
        "company.users.password.set_error": "Kunne ikke oppdatere passordet.",
        "company.users.password.too_short": "Passordet må være minst 8 tegn.",
        "company.users.password.mismatch": "Passordene er ikke like.",
        "company.users.password.last_sent": "Siste e-post sendt: {{at}}",
        "company.users.password.never_sent": "Ingen passord- eller invitasjons-e-post er logget ennå.",
        "company.users.password.history_title": "Historikk",
        "company.users.password.history_empty": "Ingen hendelser registrert.",
        "company.users.password.source_create": "Invitasjon ved opprettelse",
        "company.users.password.source_resend": "Invitasjon sendt på nytt",
        "company.users.password.source_admin_send": "Passordlenke sendt av admin",
        "company.users.password.source_tripletex_sync": "Passordlenke fra Tripletex-synk",
        "company.users.password.source_admin_password_set": "Passord satt av admin",
        "company.users.password.source_unknown": "Ukjent hendelse",
        "driving": "Kjøring (full flåte)",
        "driving_trips": "Turer og innlogget kjøretøy",
        "driving_drivers": "Sjåfører",
        "driving_vehicles": "Kjøretøy (kjøremodul)",
        "vehicles": "Kjøretøy",
        "Postal Address": "Postadresse",
        "Physical Address": "Besøksadresse",
        "Edit": "Rediger",
        "Back": "Tilbake",
        "webpage.editor.open_live": "Gå til live",
        "webpage.editor.open_live_title": "Åpne siden i nettbutikken (ny fane)",
        "webpage.editor.open_live_title_unpublished":
          "Åpne URL i nettbutikken. Siden må være publisert for at kunder skal se innholdet.",
        "webpage.editor.import_blocks": "JSON / AI",
        "webpage.editor.import_tooltip": "Lim inn JSON-blokker eller kopier AI-instruks",
        "webpage.editor.import_dialog_title": "Importer blokker eller AI-guide",
        "webpage.editor.import_tab_paste": "Lim inn JSON",
        "webpage.editor.import_tab_guide": "AI-instruks (kopier)",
        "webpage.editor.import_hint":
          "Lim inn JSON: enten { \"blocks\": [ ... ] }, eller rå array, eller eksportformat med content.blocks. Du kan pakke inn i ```json ... ```.",
        "webpage.editor.import_replace": "Erstatt alle blokker",
        "webpage.editor.import_append": "Legg til nederst",
        "webpage.editor.import_sample": "Lim inn eksempel",
        "webpage.editor.import_apply": "Bygg blokker",
        "webpage.editor.import_success": "Importerte {{count}} blokk(er). Husk å lagre siden.",
        "webpage.editor.import_error_empty": "Ingen tekst å lese.",
        "webpage.editor.import_error_invalid_json": "Ugyldig JSON. Sjekk anførselstegn og komma.",
        "webpage.editor.import_error_no_blocks_array": "Forventet \"blocks\"-array, rå array eller content.blocks.",
        "webpage.editor.import_error_no_valid_blocks": "Ingen gyldige blokker (type må være text, image, header, section, button eller columns).",
        "webpage.editor.import_error_unknown": "Kunne ikke importere.",
        "webpage.editor.ai_guide_intro":
          "Kopier teksten under og lim den inn som system-/instruks i en AI som skal generere layout. Modellen skal svare med ren JSON uten markdown.",
        "webpage.editor.copy_ai_guide": "Kopier AI-instruks",
        "webpage.editor.ai_guide_copied": "AI-instruks kopiert til utklippstavlen",
        "webpage.editor.ai_guide_copy_failed": "Klarte ikke å kopiere (nettleserrettigheter)",
        "webpage.editor.generate_with_ai": "Generer med ChatGPT",
        "webpage.editor.ai_apply_success": "AI la inn {{count}} blokk(er) i editoren. Husk å lagre siden.",
        "webpage.editor.ai_parse_error": "AI ga ikke gyldig side-JSON. Prøv igjen, eller lim inn JSON under «Lim inn JSON».",
        "Customer Number": "Kundenummer",
        "Name": "Navn",
        "Email": "E-post",
        "pmField.email.invalid": "Oppgi en gyldig e-postadresse.",
        "pmField.email.sameAsName": "E-post og navn kan ikke være like. Bruk navnefeltet for navn og e-postfeltet for e-post.",
        "pmField.email.nameLooksLikeEmail": "Dette ser ut som en e-postadresse. Bruk e-postfeltet for e-post.",
        "Mobile": "Mobil",
        "Inactive": "Inaktiv",
        "All": "Alle",
        "Contact": "Kontakt",
        "Kontakter": "Kontakter",
        "Contact info": "Kontaktinfo",
        "Sync": "Synk",
        "Date": "Dato",
        "Confirmed": "Bekreftet",
        "Confirmed date": "Bekreftet dato",
        "Via SMS": "Via SMS",
        "Manually": "Manuelt",
        "Ikke avtalt": "Ikke avtalt",
        "Products": "Produkter",
        "Purchase Price": "Innkjøpspris",
        "Sales Price": "Salgspris",
        "Leverandør": "Leverandør",
        "Lager status": "Lagerstatus",
        "Org. Nummer": "Org. Nummer",
        "Short Description": "Kort beskrivelse",
        "Address 2": "Adresse 2",
        "Postal": "Postnummer",
        "Place": "Sted",
        "Active": "Aktiv",
        "Yes": "Ja",
        "No": "Nei",
        "Copied to clipboard": "Kopiert til utklippstavle",
        "Agreement Start Date": "Avtalens startdato",
        "Agreement Type": "Avtaletype",
        "Checklist created successfully": "Sjekkliste opprettet",
        "Choose who should own this deviation": "Velg hvem som skal eie dette avviket",
        "Consequence": "Konsekvens",
        "Could not save": "Kunne ikke lagre",
        "Create Deviation": "Opprett avvik",
        "Deleted": "Slettet",
        "Deviation Type": "Avvikstype",
        "Edit Deviation": "Rediger avvik",
        "Edit Mode": "Redigeringsmodus",
        "Edit Vehicle": "Rediger kjøretøy",
        "Failed to create checklist": "Kunne ikke opprette sjekkliste",
        "Interval": "Intervall",
        "Interval is required": "Intervall er påkrevd",
        "service.agreement.validation.interval_required": "Intervall er påkrevd",
        "Last Ride": "Siste tur",
        "No email": "Ingen e-post",
        "Norwegian": "Norsk",
        "Print Label": "Skriv ut etikett",
        "Report Type": "Rapporttype",
        "Responsible User": "Ansvarlig bruker",
        "Responsible for follow-up": "Ansvarlig for oppfølging",
        "Search employees": "Søk ansatte",
        "Select Deviation Type": "Velg avvikstype",
        "Select Responsible User": "Velg ansvarlig bruker",
        "Select Severity": "Velg alvorlighetsgrad",
        "Selected": "Valgt",
        "Title is required": "Tittel er påkrevd",
        "View Mode": "Visningsmodus",
        "meeting_minutes.view_mode": "Visningsmodus",
        "meeting_minutes.edit_mode": "Redigeringsmodus",
        "Work Order": "Arbeidsordre",
        "Failed to copy": "Kunne ikke kopiere",
        "Copy to clipboard": "Kopier til utklippstavle",
        "RESPONSIBLE": "Ansvarlig",
        "RESPONSIBLE_EXECUTOR": "Ansvarlig utførende",
        "EXECUTOR": "Utfører",
        "OBSERVER": "Observatør",
        "note": "Notat",
        "work_order": "Arbeidsordre",
        "Work Orders": "Arbeidsordrer",
        "Work Order List": "Arbeidsordrer - Liste",
        "New Work Order": "Ny Arbeidsordre",
        "Search work orders...": "Søk i arbeidsordrer...",
        "Filter Work Orders by Status": "Filtrer arbeidsordrer etter status",
        "Finished": "Ferdig",
        "Order Date": "Bestillingsdato",
        "Due Date": "Forfallsdato",
        "Event Period": "Hendelsesperiode",
        "Responsible": "Ansvarlig",
        "Executor": "Utfører",
        "Work Order #": "Arbeidsordre #",
        "work_orders.pagination_summary":
          "Side {{page}} av {{totalPages}} ({{total}} totalt)",
        "work_orders.delete_confirm":
          "Dette sletter arbeidsordren permanent. Timer som er knyttet til den, blir frakoblet arbeidsordren. Dette kan ikke angres.",
        "work_orders.delete_success": "Arbeidsordre slettet",
        "work_orders.delete_failed": "Kunne ikke slette arbeidsordren",
        "work_orders.back_to_view": "Tilbake til visning",
        "work_orders.calendar_filter": "Arbeidsordrer",
        "work_orders.project_activity.section_title": "Prosjektaktivitet",
        "work_orders.project_activity.help":
          "Knytt til en prosjektaktivitet som ikke allerede er brukt et annet sted, eller opprett en ny på dette prosjektet. Når du lagrer arbeidsordren, kobles aktiviteten til denne ordren.",
        "work_orders.project_activity.new_title_label": "Tittel på ny aktivitet",
        "work_orders.project_activity.copy_from_title": "Kopier fra tittel",
        "work_orders.project_activity.new_title_placeholder":
          "f.eks. Montering fase 2",
        "work_orders.project_activity.create_button": "Opprett og velg",
        "work_orders.project_activity.creating": "Oppretter…",
        "work_orders.project_activity.created_toast": "Prosjektaktivitet opprettet",
        "work_orders.project_activity.create_error":
          "Kunne ikke opprette prosjektaktivitet",
        "work_orders.project_activity.linked_label": "Prosjektaktivitet",
        "work_orders.billing_ready.action": "Klar til fakturering",
        "work_orders.billing_ready.eyebrow": "Fakturagrunnlag",
        "work_orders.billing_ready.title": "Klargjør fakturainfo",
        "work_orders.billing_ready.title_edit": "Oppdater fakturagrunnlag",
        "work_orders.billing_ready.intro":
          "Lagre fakturatekst og hva som skal faktureres (timer og forbruk). Du kan bare merke arbeidsordren klar til fakturering, eller opprette salgsordre med én gang for å gå videre til fakturering.",
        "work_orders.billing_ready.section_invoice": "Fakturautkast",
        "work_orders.billing_ready.section_hours": "Timer til fakturering",
        "work_orders.billing_ready.section_hours_subtitle":
          "Valgt {{selected}} t av {{total}} t",
        "work_orders.billing_ready.section_items": "Varelinjer (forbruk)",
        "work_orders.billing_ready.section_items_subtitle":
          "{{selected}} av {{total}} linjer valgt",
        "work_orders.billing_ready.section_group": "Ordregruppering (senere)",
        "work_orders.billing_ready.add_tilleggsarbeider_hint":
          "Når ordre senere opprettes fra arbeidsordren, kan timer og varer samles i egen gruppe på salgsordren.",
        "work_orders.billing_ready.toggle_hours_aria": "Ta med timer i fakturagrunnlaget",
        "work_orders.billing_ready.toggle_items_aria": "Ta med varelinjer i fakturagrunnlaget",
        "work_orders.billing_ready.no_billable_hours": "Ingen timer er knyttet til arbeidsordren.",
        "work_orders.billing_ready.no_usage_items": "Ingen forbrukslinjer med brukt antall.",
        "work_orders.billing_ready.submit": "Lagre og merk klar til fakturering",
        "work_orders.billing_ready.success": "Merket klar til fakturering og påminnelse sendt der det fantes utførere",
        "work_orders.billing_ready.failed": "Kunne ikke lagre fakturagrunnlag",
        "work_orders.billing_ready.submit_create_order": "Opprett salgsordre",
        "work_orders.billing_ready.success_order": "Salgsordre opprettet",
        "work_orders.billing_ready.failed_order": "Kunne ikke opprette salgsordre",
        "work_orders.billing_ready.open_order": "Åpne salgsordre",
        "work_orders.billing_ready.sales_income_in_project_notice_title":
          "Ikke fakturerbar som egen salgsordre",
        "work_orders.billing_ready.sales_income_in_project_notice":
          "Arbeidsordren er merket med at omsetning inngår i prosjektet. Bruk prosjektfakturering; «Klar til fakturering» og opprett salgsordre fra denne arbeidsordren er ikke tilgjengelig.",
        "work_orders.filter_executor": "Utførende",
        "work_orders.bulk_create.toolbar": "{{count}} valgt",
        "work_orders.bulk_create.open": "Opprett salgsordrer…",
        "work_orders.bulk_create.clear": "Nullstill valg",
        "work_orders.bulk_create.title": "Opprett salgsordrer fra arbeidsordrer",
        "work_orders.bulk_create.summary": "Du er i ferd med å opprette én eller flere salgsordrer fra {{count}} arbeidsordre(r).",
        "work_orders.bulk_create.hint":
          "Standard regler gjelder: alle timer og forbrukslinjer som kan faktureres tas med per arbeidsordre. For full kontroll (avrunding, manuelle timer, linjevalg), bruk fakturadialogen på hver arbeidsordre.",
        "work_orders.bulk_create.strategy_label": "Hvordan skal ordrene grupperes?",
        "work_orders.bulk_create.strategy_per_wo": "Én salgsordre per arbeidsordre",
        "work_orders.bulk_create.strategy_customer": "Slå sammen per kunde (én ordre per kunde)",
        "work_orders.bulk_create.strategy_project": "Slå sammen per prosjekt (én ordre per prosjekt)",
        "work_orders.bulk_create.submit": "Opprett ordre",
        "work_orders.bulk_create.success": "Opprettet {{count}} salgsordre(r)",
        "work_orders.bulk_create.failed": "Kunne ikke opprette salgsordrer",
        "work_orders.bulk_create.select_row": "Velg arbeidsordre for massefakturering",
        "work_orders.bulk_create.select_page": "Velg alle arbeidsordrer på siden som kan faktureres",
        "work_orders.checklist.enable_switch": "Bruk sjekkliste på denne arbeidsordren",
        "work_orders.checklist.section_title": "Sjekkliste",
        "work_orders.checklist.save_to_enable_title": "Lagre arbeidsordren",
        "work_orders.checklist.save_to_enable_body":
          "Lagre endringene dine for å aktivere sjekklistefeltet og opprette eller redigere linjer.",
        "work_orders.checklist.missing_title": "Ingen sjekkliste ennå",
        "work_orders.checklist.missing_body":
          "Opprett en sjekkliste ved å velge mal eller starte tom.",
        "work_orders.checklist.choose": "Velg sjekkliste",
        "work_orders.checklist.delete": "Slett sjekkliste",
        "work_orders.checklist.delete_confirm_title": "Slette sjekkliste?",
        "work_orders.checklist.delete_confirm_body":
          "Dette kan ikke angres. Sjekklisten og svarene fjernes.",
        "work_orders.checklist.loading": "Laster sjekkliste…",
        "work_orders.checklist.load_error": "Kunne ikke laste sjekklisten.",
        "work_orders.checklist.load_error_title": "Sjekklisten kunne ikke lastes",
        "work_orders.checklist.load_error_hint":
          "Prøv igjen eller åpne arbeidsordren fra prosjektoversikten.",
        "work_orders.checklist.created": "Sjekkliste opprettet",
        "work_orders.checklist.create_error": "Kunne ikke opprette sjekkliste",
        "work_orders.checklist.deleted": "Sjekkliste fjernet",
        "work_orders.checklist.delete_error": "Kunne ikke slette sjekkliste",
        "work_orders.checklist.save_error": "Kunne ikke lagre sjekkliste",
        "work_orders.checklist.read_only_hint":
          "Du kan se sjekklisten i skrivebeskyttet modus på sjekklistesiden.",
        "work_orders.checklist.page_subtitle": "Sjekkliste",
        "work_orders.checklist.page_heading": "Arbeidsordre sjekkliste",
        "work_orders.checklist.back_to_work_order": "Tilbake til arbeidsordre",
        "work_orders.checklist.disabled_title": "Sjekkliste er ikke aktivert",
        "work_orders.checklist.disabled_body":
          "Aktiver «Bruk sjekkliste» på redigeringssiden for å bruke dette feltet.",
        "work_orders.checklist.read_only_banner":
          "Kun visning: du har ikke tilgang til å redigere denne sjekklisten.",
        "work_orders.checklist.create_from_edit":
          "Opprett en sjekkliste fra redigeringssiden til arbeidsordren.",
        "work_orders.checklist.load_work_order_error": "Kunne ikke laste arbeidsordre",

        "Sjekklistetyper": "Sjekklistetyper",
        "Søk sjekklistetyper...": "Søk sjekklistetyper...",
        "Inaktive sjekklistetyper": "Inaktive sjekklistetyper",
        "Kunne ikke laste sjekklistetyper": "Kunne ikke laste sjekklistetyper",
        "Ingen sjekklistetyper funnet": "Ingen sjekklistetyper funnet",
        "Ny sjekklistetype": "Ny sjekklistetype",
        "Opprettet": "Opprettet",

        "work_orders.checklist.card_title": "Sjekkliste",
        "work_orders.checklist.card_desc_with_checklist":
          "Se og fyll ut sjekklisten på sjekklistesiden.",
        "work_orders.checklist.card_desc_no_checklist":
          "Opprett sjekkliste på redigeringssiden (velg mal eller start tom).",
        "work_orders.checklist.unit": "punkter",
        "work_orders.checklist.mobile_nav": "Sjekkliste",
        "work_orders.list_meta_total": "Totalt: {{count}}",
        "work_orders.table_no_title": "Uten tittel",
        "work_order.view.mobileNav.ariaLabel":
          "Hurtigvalg for timeregistrering og vareforbruk på arbeidsordre",
        "work_order.admin.title": "Admin",
        "work_order.admin.edit": "Rediger arbeidsordre",
        "work_order.admin.edit_desc": "Åpne fullt redigerskjema",
        "work_order.admin.approve": "Godkjenn arbeidsordre",
        "work_order.admin.approve_desc": "Godkjenn eller avslå (koordinator)",
        "work_order.admin.open_project": "Åpne prosjekt",
        "work_order.admin.open_customer": "Åpne kunde",
        "work_order.admin.item_consumption": "Vareforbruk",
        "work_order.admin.item_consumption_desc":
          "Registrer materialer og forbrukt antall",
        "work_order.admin.billing_desc":
          "Forbered fakturagrunnlag eller opprett salgsordre",
        "work_order.admin.finish": "Ferdigstill arbeidsordre",
        "work_order.admin.finish_desc":
          "Gå gjennom sjekkliste og marker som ferdigstilt",
        "work_order.admin.mentions": "@Omtaler",
        "work_order.admin.mentions_desc":
          "Notater og ressurser som refererer til denne arbeidsordren",
        "work_order.admin.mentions_dialog_title": "Omtaler av arbeidsordren",
        "work_order.admin.no_mentions": "Ingen omtaler funnet.",
        "work_order.admin.set_status": "Sett status (admin)",
        "work_order.admin.set_status_desc":
          "Rett opp status for eldre tilfeller, for eksempel allerede fakturert utenfor Promang.",
        "work_order.admin_set_status.title": "Sett status på arbeidsordre",
        "work_order.admin_set_status.intro":
          "Bruk når ordren ble fakturert eller fullført uten vanlig flyt. Oppretter ikke salgsordre.",
        "work_order.admin_set_status.status_label": "Status",
        "work_order.admin_set_status.mark_completed": "Marker som ferdigstilt",
        "work_order.admin_set_status.submit": "Lagre",
        "work_order.admin_set_status.success": "Status oppdatert.",
        "work_order.admin_set_status.error": "Kunne ikke oppdatere status.",
        "work_order.status.draft": "Utkast",
        "work_order.status.ongoing": "Pågår",
        "work_order.status.finished": "Ferdigstilt",
        "work_order.status.processing": "Under behandling",
        "work_order.status.processed": "Behandlet",
        "work_order.status.cancelled": "Kansellert",
        "work_order.status.ready_invoice": "Klar til fakturering",
        "work_order.status.invoiced": "Fakturert",
        "work_order.status.rejected": "Avvist",
        "work_order.status.approved": "Godkjent",
        "work_order.status.updated": "Oppdatert",
        "work_order.redesign.status.draft": "Utkast",
        "work_order.redesign.status.scheduled": "Planlagt",
        "work_order.redesign.status.progress": "Pågår",
        "work_order.redesign.status.done": "Ferdigstilt",
        "work_order.completion.check_participant_notes":
          "Oppdatering / notater fra deltakere",
        "work_order.completion.title": "Ferdigstilling",
        "work_order.completion.status_not_applicable":
          "Ferdigstilling er ikke tilgjengelig for denne statusen.",
        "work_order.completion.heading_done": "Arbeidsordre ferdigstilt",
        "work_order.completion.heading_pending": "Ferdigstill arbeidsordre",
        "work_order.completion.sub_done":
          "Arbeidsordren er markert som ferdigstilt.",
        "work_order.completion.sub_blocked":
          "Noen krav må være oppfylt før du kan ferdigstille.",
        "work_order.completion.sub_ready":
          "Alle obligatoriske krav er oppfylt; du kan ferdigstille når du er klar.",
        "work_order.completion.label_status": "Status",
        "work_order.completion.label_progress": "Klarhet",
        "work_order.completion.value_done": "Ferdigstilt",
        "work_order.completion.no_checks": "—",
        "work_order.completion.cta_view": "Vis ferdigstillingsdetaljer",
        "work_order.completion.cta_finish": "Ferdigstill",
        "work_order.event.dialog_create": "Opprett hendelse",
        "work_order.event.dialog_edit": "Rediger hendelse",
        "work_order.event.toast_created": "Hendelse opprettet",
        "work_order.event.toast_updated": "Hendelse oppdatert",
        "work_order.event.toast_deleted": "Hendelse slettet",
        "work_order.event.delete_failed": "Kunne ikke slette hendelse",
        "work_order.event.delete_event": "Slett",
        "work_order.event.saving": "Lagrer…",
        "work_order.event.submit_create": "Opprett",
        "work_order.event.submit_update": "Oppdater",
        "work_order.event.field_title": "Tittel",
        "work_order.event.field_title_placeholder": "Hendelsestittel",
        "work_order.event.field_description": "Beskrivelse",
        "work_order.event.field_description_placeholder": "Beskriv hendelsen…",
        "work_order.event.field_start": "Starttid",
        "work_order.event.field_end": "Sluttid",
        "work_order.event.field_location": "Lokasjon",
        "work_order.event.field_location_placeholder": "Hvor skal hendelsen finne sted?",
        "work_order.event.location_prefilled":
          "Leveringsadresse fra arbeidsordre er forhåndsutfylt (kan redigeres).",
        "work_order.event.all_day": "Hele dagen",
        "work_order.event.attendees_title": "Deltakere på hendelsen",
        "work_order.event.attendees_hint":
          "Alle deltakere på arbeidsordren er foreslått. Fjern kryss for dem som ikke skal være med. Du kan legge til flere under.",
        "work_order.event.add_attendee": "Legg til deltaker",
        "work_order.event.add_confirm": "Legg til",
        "work_order.event.select_user": "Velg bruker",
        "work_order.event.loading_users": "Laster brukere…",
        "work_order.event.no_attendees_from_wo":
          "Ingen deltakere på arbeidsordren. Bruk «Legg til deltaker» for å invitere noen.",
        "work_order.event.from_work_order": "Fra arbeidsordre",
        "work_order.event.remove_attendee": "Fjern",
        "work_order.event.role_participant": "Deltaker",
        "work_order.event.error_need_event_owner":
          "Arbeidsordren må ha en bruker som kan eie kalenderhendelsen (ansvarlig utførende, ordreansvarlig eller oppretter) før du kan opprette en hendelse.",
        "work_order.event.notice_no_event_owner_title": "Mangler eier for hendelsen",
        "work_order.event.notice_no_event_owner_description":
          "Legg til ansvarlig utførende eller ordreansvarlig på arbeidsordren, eller sørg for at den har en oppretter, slik at hendelsen kan knyttes til en bruker. Du kan fortsatt redigere en eksisterende hendelse.",
        "work_order.participants.title": "Deltakere",
        "work_order.participants.description":
          "Hvem som er med på arbeidsordren (roller og status).",
        "work_order.participants.draft_hint":
          "Lagre arbeidsordren først for å administrere deltakere som på prosjekt (egne dialoger).",
        "work_order.participants.add": "Legg til deltaker",
        "work_order.participants.add_first": "Legg til første deltaker",
        "work_order.participants.none": "Ingen deltakere ennå.",
        "work_order.participants.user": "Bruker",
        "work_order.participants.role": "Rolle",
        "work_order.participants.status": "Status",
        "work_order.participants.edit": "Rediger",
        "work_order.participants.delete": "Slett",
        "work_order.participants.delete_confirm":
          "Fjerne denne deltakeren fra arbeidsordren?",
        "work_order.participants.delete_error": "Kunne ikke fjerne deltaker",
        "work_order.participants.error_loading":
          "Kunne ikke laste deltakere",
        "work_order.participants.save_error": "Kunne ikke lagre deltaker",
        "work_order.participants.created": "Deltaker lagt til",
        "work_order.participants.updated": "Deltaker oppdatert",
        "work_order.participants.updating": "Oppdaterer…",
        "work_order.participants.adding": "Legger til…",
        "work_order.plan_modal.section_title": "Planlegging",
        "work_order.plan_modal.section_subtitle":
          "Planlegg utførende og tidspunkter for arbeidsordren i prosjektplanen.",
        "work_order.plan_modal.schedule_new": "Planlegg",
        "work_order.plan_modal.schedule_edit": "Rediger planlegging",
        "work_order.plan_modal.empty": "Ingen planlegging ennå. Opprett en plan med utførende og tidspunkt.",
        "work_order.plan_modal.title_create": "Planlegg arbeidsordre",
        "work_order.plan_modal.title_edit": "Rediger planlegging",
        "work_order.plan_modal.work_order": "Arbeidsordre",
        "work_order.plan_modal.plan_title": "Plantittel",
        "work_order.plan_modal.plan_title_placeholder": "Tittel på oppgaven i planen",
        "work_order.plan_modal.planning_type_section": "Planleggingstype",
        "work_order.plan_modal.planning_type_resources": "Knytt ressurser",
        "work_order.plan_modal.planning_type_dates_only": "Kun dato",
        "work_order.plan_modal.planning_type_resources_help":
          "Velg utførende og tid per dag. Ressursene vises i ressursplanen.",
        "work_order.plan_modal.planning_type_dates_only_help":
          "Sett kun start- og sluttdato nå – ressurser kan knyttes til planen senere.",
        "work_order.plan_modal.dates_only_remove_warning":
          "Planen har allerede ressurser. Lagrer du som «Kun dato», fjernes ressursene fra planen.",
        "work_order.plan_modal.validation_missing_dates": "Velg minst én dag for planen",
        "work_order.plan_modal.pick_days_hint": "Velg dager for planen",
        "work_order.plan_modal.executing_section": "Utførende",
        "work_order.plan_modal.executing_help":
          "Velg hvem som skal utføre arbeidet.",
        "work_order.plan_modal.executing_help_multi":
          "Velg én eller flere utførende. Hver får oppdrag på valgte dager.",
        "work_order.plan_modal.select_all_participants": "Velg alle deltakere på AO",
        "work_order.plan_modal.select_all_employees": "Gjelder alle ansatte",
        "work_order.plan_modal.clear_employees": "Fjern alle",
        "work_order.plan_modal.tab_all": "Alle",
        "work_order.plan_modal.mode_shared": "Samme plan for alle",
        "work_order.plan_modal.mode_per_user": "Plan per bruker",
        "work_order.plan_modal.apply_days_to_all": "Bruk valgte dager for alle",
        "work_order.plan_modal.apply_days_to_all_help":
          "Kopierer de synlige valgte dagene til alle valgte ressurser og bytter til «Samme plan for alle».",
        "work_order.plan_modal.apply_days_to_all_toast":
          "Valgte dager gjelder nå for alle ressurser",
        "work_order.plan_modal.all_employees_hint":
          "«Samme plan for alle» brukes bare når ressursene har like dager — eller når du aktivt velger det / «Bruk valgte dager for alle». Ved ulike dager per ressurs starter nye personer tomme.",
        "work_order.plan_modal.selected_employees_count": "{{count}} utførende valgt",
        "work_order.plan_modal.new_resource_pick_days":
          "Ny ressurs lagt til – velg dager for denne personen",
        "work_order.plan_modal.new_resources_pick_days":
          "Nye ressurser lagt til – velg dager for disse personene",
        "work_order.plan_modal.conflicts_title": "Ressurskonflikter ({{count}})",
        "work_order.plan_modal.conflicts_help":
          "Klikk en konflikt for å gå til datoen og justere eller fjerne dagen.",
        "work_order.plan_modal.conflicts_jump": "Gå til dato",
        "work_order.plan_modal.days_section": "Dager",
        "work_order.plan_modal.days_help":
          "Velg dager i ukevisningen. Eksisterende planlagte dager beholdes når du bytter uke — du kan legge til flere dager i en annen uke.",
        "work_order.plan_modal.multi_week_nav_hint":
          "Bruk pilene i kalenderen for å legge til dager i andre uker. Tid per dag viser alle valgte datoer.",
        "work_order.plan_modal.per_day_other_weeks": "Andre uker ({{count}})",
        "work_order.plan_modal.per_day_this_week": "Denne uken",
        "work_order.plan_modal.other_week_badge": "annen uke",
        "work_order.plan_modal.selected_days_count": "{{count}} dag(er) valgt",
        "work_order.plan_modal.per_day_section": "Tid per dag",
        "work_order.plan_modal.per_day_help": "Sett fra/til og antall timer for hver valgte dag.",
        "work_order.plan_modal.time_from": "Fra",
        "work_order.plan_modal.time_to": "Til",
        "work_order.plan_modal.hours_short": "t",
        "work_order.plan_modal.default_hours_label": "Standard timer (nye dager)",
        "work_order.plan_modal.apply_hours_all_days": "Bruk standard timer på alle valgte dager",
        "work_order.plan_modal.schedule_help_calendar":
          "Du kan også dra tidsrom i kalenderen — da oppdateres kun den dagen du drar på.",
        "work_order.plan_modal.schedule_help_multi":
          "Dra et tidsrom i kalenderen, eller juster fra/til per dag nedenfor.",
        "work_order.plan_modal.drag_days_hint": "på en dag i kalenderen for å sette tid den dagen.",
        "work_order.plan_modal.clear_days": "Fjern dager",
        "work_order.plan_modal.remove_day": "Fjern dag fra planen",
        "work_order.plan_modal.clear_time": "Fjern tid",
        "work_order.plan_modal.same_time_all_days": "samme tid alle dager",
        "work_order.plan_modal.varied_times": "Ulike tider per dag",
        "work_order.plan_modal.assignment_count": "{{count}} oppdrag",
        "work_order.plan_modal.days_short": "dager",
        "work_order.plan_modal.participant": "Deltaker på AO",
        "work_order.plan_modal.estimated_hours_section": "Estimert tid",
        "work_order.plan_modal.estimated_hours_help":
          "Brukes som standard varighet når du legger til nye dager.",
        "work_order.plan_modal.estimated_hours_from_wo":
          "Forslag fra arbeidsordre: {{hours}} timer",
        "work_order.plan_modal.schedule_section": "Kalender",
        "work_order.plan_modal.schedule_help":
          "Dra i kalenderen for å velge tidspunkt.",
        "work_order.plan_modal.pick_time_hint": "Velg dager og sett fra/til per dag",
        "work_order.plan_modal.validation_missing":
          "Velg utførende, minst én dag, og fra/til for hver dag",
        "work_order.plan_modal.validation_missing_user_days":
          "Alle valgte utførende må ha minst én dag — eller bruk «Bruk valgte dager for alle»",
        "work_order.plan_modal.toast_created": "Planlegging opprettet",
        "work_order.plan_modal.toast_updated": "Planlegging oppdatert",
        "work_order.plan_modal.saving": "Laster…",
        "work_order.project_plan.open_project_plan": "Åpne prosjektplan",
        "work_order.project_plan.untitled": "Uten tittel",
        "work_order.project_plan.badge_draft": "Utkast",
        "work_order.project_plan.status_draft": "Utkast",
        "report.participants.title": "Tilknyttede utførende",
        "report.participants.subtitle":
          "Ekstra mannskap og observatører (alle vises i kalenderen). Ansvarlig utførende fra avtalen settes under Utførende på avtalen.",
        "report.participants.add": "Legg til",
        "report.participants.add_first": "Legg til første",
        "report.participants.none": "Ingen tilknyttede utførende utover avtalen.",
        "report.participants.user": "Bruker",
        "report.participants.role": "Rolle",
        "report.participants.status": "Status",
        "report.participants.choose_role": "Velg rolle",
        "report.participants.choose_status": "Velg status",
        "report.participants.edit": "Rediger",
        "report.participants.delete": "Fjern",
        "report.participants.delete_confirm":
          "Fjerne denne personen fra rapporten?",
        "report.participants.delete_error": "Kunne ikke fjerne",
        "report.participants.save_error": "Kunne ikke lagre",
        "report.participants.created": "Lagt til",
        "report.participants.updated": "Oppdatert",
        "report.participants.updating": "Oppdaterer…",
        "report.participants.adding": "Legger til…",
        "report.participants.error_is_executing_employee":
          "Denne brukeren er allerede satt som ansvarlig utførende på avtalen. Velg en annen, eller endre utførende på avtalen først.",
        "Use card view": "Bruk kortvisning",
        "Switch to card overview layout": "Bytt til kortoversikt",
        "Switch to compact table layout": "Bytt til tabellvisning",
        "contact": "Kontakt",
        "service_agreement": "Serviceavtale",
        "order": "Ordre",
        "product": "Produkt",
        "folder": "Mappe",
  
        // Control Panel / Sentralbord translations
        "answered": "Besvart",
        "missed": "Ikke besvart",
        "Ended": "Avsluttet",
        "Agent": "Agent",
        "Abandoned": "Avbrutt",
        "Answered": "Besvart",
        "Missed": "Ikke besvart",
        "Error": "Feil",
        "Unknown": "Ukjent",
        "No communication found": "Ingen kommunikasjon funnet",
        "No possible customers found": "Ingen mulige kunder funnet",
        "Queue": "Kø",
        "control.panel": "Sentralbord",
        "control.panel.overview":
          "Dashboard for systemintegrasjoner og overvåking",
        "overview": "Oversikt",
        "queues": "Køer",
        "calls": "Samtalehistorikk",
        "persons": "Personer",
        "settings": "Innstillinger",
        "control.panel.overview.title": "Sentralbord Oversikt",
        "control.panel.overview.description":
          "Dashboard for alle integrasjoner og systemer",
        "current.phone.status": "Nåværende Telefonstatus",
        "phone.status": "Telefonstatus",
        "phone.details.status": "Telefonstatus detaljer",
        "connected.to.phonero": "Tilkoblet Phonero",
        "not.connected.to.phonero": "Ikke tilkoblet Phonero-system",
        "change.status": "Endre Status",
        "not.connected.to.phone.system": "Ikke tilkoblet telefonsystem",
        "phonero.status": "Phonero Status",
        "active": "Aktiv",
        "not.configured": "Ikke konfigurert",
        "view.details": "Se detaljer",
        "system.status": "Systemstatus",
        "all.systems.operational": "Alle systemer operative",
        "last.updated": "Sist oppdatert",
        "quick.actions": "Hurtigvalg",
        "configure": "Konfigurer",
        "phonero.queues": "Phonero Køer",
        "monitor.manage.queues": "Overvåk og administrer samtalekøer",
        "call.log": "Samtalehistorikk",
        "view.call.history": "Se samtalehistorikk og detaljer",
        "phonero.persons": "Phonero Personer",
        "manage.persons.phone":
          "Administrer personer og deres telefoninnstillinger",
        "control.panel.settings": "Sentralbord Innstillinger",
        "configure.control.panel": "Konfigurer sentralbord og integrasjoner",
        "integrations": "Integrasjoner",
        "manage.all.integrations": "Administrer alle systemintegrasjoner",
        "phone.integration": "Telefonintegrasjon",
  
        // Phonero presence statuses
        "presence.available": "Tilgjengelig",
        "presence.busy": "Opptatt",
        "presence.away": "Borte",
        "presence.unknown": "Ukjent",
        "presence.connected": "Tilkoblet Phonero",
        "presence.not.available": "Tilgjengelighetsstatus ikke tilgjengelig",
        "presence.failed.to.load": "Kunne ikke laste tilgjengelighetsdata",
        "presence.updated.successfully": "Tilgjengelighet oppdatert",
        "presence.failed.to.update": "Kunne ikke oppdatere tilgjengelighet",
        "presence.cannot.update":
          "Kan ikke oppdatere tilgjengelighet - bruker ikke funnet i Phonero",
  
        // Cases list - new view (nn)
        "Use list view": "Bruk listevisning",
        "Use new view": "Bruk ny visning",
        "Last update": "Siste oppdatering",
        "No updates yet": "Ingen oppdateringer ennå",
        "Add update": "Legg til oppdatering",
        "Write an update...": "Skriv en oppdatering...",
        "Gå til bruker": "Gå til bruker",
        "Bruker": "Bruker",
        "Ansatt": "Ansatt",
        "Update added": "Oppdatering lagt til",
        "Could not add update": "Kunne ikke legge til oppdatering",
        "Title (optional)": "Tittel (valgfritt)",
        "Add title": "Legg til tittel",
        "Link": "Lenke",
        "Add link": "Legg til lenke",
        "Link text (optional)": "Lenketekst (valgfritt)",
        "URL": "URL",
        "Send": "Send",
        "Open case": "Åpne sak",
        "View full": "Vis fullstendig",
        "No employees found": "Ingen ansatte funnet",
  
        // Phonero presence descriptions
        "Free": "Ledig",
        "Meeting": "Møte",
        "Lunch": "Lunsj",
        "Vacation": "Ferie",
        "Busy": "Opptatt",
        "Way": "På vei",
        "Gone for the day": "Ferdig for dagen",
  
        // Live Calls translations
        "Live Calls (Not synched yet)": "Live Samtaler (Ikke synkronisert ennå)",
        "Latest calls from Phonero API (not yet synced to database)":
          "Siste samtaler fra Phonero API (ikke synkronisert til database ennå)",
        "Refreshing...": "Oppdaterer...",
        "Refresh": "Oppdater",
        "Loading live calls...": "Laster live samtaler...",
        "No unsynced live calls found":
          "Ingen usynkroniserte live samtaler funnet",
  
        // Manual Call translations
        "Add Manual Call": "Legg til manuell samtale",
        "From Number (Customer)": "Fra nummer (Kunde)",
        "Date & Time": "Dato & Tid",
        "Duration (seconds)": "Varighet (sekunder)",
        "Note": "Notat",
        "Cancel": "Avbryt",
        "Create Call": "Opprett samtale",
        "Creating...": "Oppretter...",
        "Manual call created successfully": "Manuell samtale opprettet",
        "Manual call added successfully": "Manuell samtale lagt til",
        "Manual": "Manuell",
        "Select Date": "Velg dato",
        "Choose date": "Velg dato",
        "Report": "Rapport",
        "report": "Rapport",
        "report.create": "Opprett rapport",
        "report.update": "Oppdater rapport",
        "report.type": "Rapporttype",
        "report.date": "Rapportdato",
        "report.description": "Rapportbeskrivelse",
        "report.agreement.update": "Oppdater rapportavtale",
        "report.agreement.new": "Ny rapportavtale",
        "report.agreement.modal_intro":
          "Fyll inn når arbeidet er planlagt, og om kunden skal få melding.",
        "report.agreement.title": "Avtale / oppdrag",
        "report.agreement.subtitle": "Tidspunkt, utførende og varsling til kunde",
        "report.agreement.setup_title": "Ingen avtale er lagret ennå",
        "report.agreement.setup_body": "Legg inn dato, tid, hvem som utfører arbeidet, og eventuelt send SMS eller e-post til kunden.",
        "report.agreement.setup_cta": "Legg til avtale",
        "report.agreement.section.schedule": "Tid og utførende",
        "report.agreement.section.schedule_help":
          "Hvem som utfører arbeidet, avtaledato og tidsrom.",
        "report.agreement.section.notify": "Varsling til kunde",
        "report.agreement.section.notify_help":
          "Velg om kunden skal ha melding på SMS eller e-post, og hvem som mottar den.",
        "report.agreement.send_to_customer": "Send avtale til kunde",
        "report.agreement.send_to_customer_hint_on": "Du kan bruke SMS og/eller e-post når det er slått på under.",
        "report.agreement.send_to_customer_hint_off": "Avtalen lagres bare i Promang; kunden får ikke melding.",
        "report.agreement.executing_you": "Deg (innlogget bruker)",
        "report.agreement.select_executing": "Velg ansatt",
        "report.agreement.change_executing": "Bytt…",
        "report.agreement.confirm_hint_required":
          "Avtale sendes til kunde, som må bekreftes via SMS eller e-post.",
        "report.agreement.confirm_hint_optional":
          "Informasjon om avtale sendes kunde, men bekreftelse er ikke påkrevd. Avtalen blir bekreftet automatisk.",
        "report.agreement.validation.date_required": "Dato er påkrevd",
        "report.agreement.validation.executing_required": "Utførende er påkrevd",
        "report.agreement.validation.phone_for_sms": "Mobilnummer er påkrevd når SMS er på",
        "report.agreement.validation.email_for_email": "Gyldig e-post er påkrevd når e-post er på",
        "report.agreement.status.confirmed": "Avtalen er bekreftet",
        "report.agreement.status.not_confirmed": "Avtalen er ikke bekreftet",
        "report.agreement.status.sms_sent": "SMS er sendt",
        "report.agreement.status.sms_not_sent": "SMS er ikke sendt",
        "report.agreement.status.sms_confirmed": "Bekreftet via SMS",
        "report.agreement.status.email_sent": "E-post er sendt",
        "report.agreement.status.email_not_sent": "E-post er ikke sendt",
        "report.agreement.status.none": "Ingen avtale",
        "report.admin.title": "Admin",
        "report.admin.status": "Rapportstatus",
        "report.admin.status_desc": "Under behandling, behandlet, fakturert",
        "report.admin.reset": "Reset",
        "report.admin.reset_desc": "Nullstill rapportmoduler",
        "report.admin.view_main_report": "Vis hovedrapport",
        "report.admin.view_sequel": "Gå til oppfølger",
        "report.admin.view_case": "Vis sak",
        "report.admin.create_case": "Opprett sak",
        "report.admin.create_case_desc": "Opprett eller knytt sak for oppfølging av rapport",
        "report.admin.case_dialog_title": "Oppfølging av rapport",
        "report.admin.create_sequel": "Opprett oppfølger",
        "report.admin.create_sequel_desc": "Opprett ny rapport som oppfølger",
        "report.admin.create_order": "Opprett ordre",
        "report.admin.create_order_desc": "Opprett ordre fra denne rapporten (timer, km, linjer)",
        "report.admin.open_mentions": "Åpne sak hvor rapport er nevnt",
        "report.admin.open_mentions_desc": "Se saker og notater som nevner rapporten",
        "report.admin.mentions_dialog_title": "Rapport nevnt i",
        "report.admin.mentioned_at": "Nevnt",
        "report.admin.no_mentions": "Rapporten er ikke nevnt andre steder",
        "report.view.mobileNav.ariaLabel": "Hurtigvalg for rapportseksjoner",
        "report.view.backToReport": "Tilbake til rapport",
        "report.view.mobileNav.details": "Detaljer",
        "report.view.mobileNav.items": "Vareforbruk",
        "report.view.mobileNav.variables": "Variabler",
        "report.view.mobileNav.checklist": "Sjekkliste",
        "report.view.mobileNav.report": "Rapport",
        "report.view.mobileNav.timeRegistration": "Timeregistrering",
        "generalNavMenu.ariaLabel": "Hovudnavigasjon",
        "generalNavMenu.home": "Heim",
        "generalNavMenu.timesheet": "Timeliste",
        "generalNavMenu.calendar": "Min kalender",
        "generalNavMenu.handbook": "Personalhåndbok",
        "generalNavMenu.newEvent": "Ny hendelse",
        "generalNavMenu.newHour": "Ny time",
        "generalNavMenu.newAbsence": "Legg til fravær",
        "generalNavMenu.actionsTitle": "Hurtigval",
        "generalNavMenu.openActions": "Opne hurtigval",
        "generalNavMenu.closeActions": "Lukk hurtigval",
        "pmLinkCard.actionsTitle": "Handlingar",
        "report.edit.menu_title": "Rediger informasjon",
        "report.edit.unsaved": "Ulagrede endringer",
        "report.edit.all_saved": "Alt er lagret",
        "report.edit.autosaved": "Endringer lagres automatisk",
        "report.edit.section.info": "Informasjon",
        "report.edit.section.info_desc": "Tittel, type, beskrivelse",
        "report.edit.section.checklist": "Sjekkliste",
        "report.edit.section.checklist_desc": "Punkter, rekkefølge, type",
        "report.edit.section.price": "Prislinjer",
        "report.edit.section.price_desc": "Varer, timer og priser",
        "report.edit.section.team": "Ansvarlige",
        "report.edit.section.team_desc": "Utførende og roller",
        "report.edit.section.status": "Rapportstatus & innstillinger",
        "report.edit.section.status_desc": "Status, varsling, synlighet",
        "report.edit.info.heading": "Grunnleggende informasjon",
        "report.edit.info.subheading": "Type og beskrivelser styrer hva tekniker og kunde ser.",
        "report.edit.info.type": "Rapporttype",
        "report.edit.info.executor": "Hovedutfører",
        "report.edit.info.order_date": "Ordredato",
        "report.edit.info.address": "Adresse",
        "report.edit.info.site": "Kundens anlegg",
        "report.edit.info.description": "Oppdragsbeskrivelse",
        "report.edit.info.description_hint": "synlig for kunde · støtter formatering",
        "report.edit.info.internal": "Intern beskrivelse",
        "report.edit.info.internal_hint": "kun internt",
        "report.edit.info.customer": "Kunde",
        "report.edit.info.contact": "Kontaktperson",
        "report.edit.info.project": "Prosjekt",
        "report.edit.info.folder": "Prosjektmappe",
        "report.edit.info.report_number": "Rapportnummer",
        "report.edit.info.use_customer_address": "Bruk kundens adresse",
        "report.edit.info.documents": "Dokumenter",
        "report.edit.info.view_documents": "Vis dokumenter",
        "report.edit.info.economy": "Økonomi og fakturering",
        "report.edit.info.invoice_to_project_customer": "Fakturer til prosjektkunde",
        "report.edit.info.invoice_to_project_customer_desc": "Faktura sendes til prosjektets kunde",
        "report.edit.info.other_invoice_customer": "Annen fakturakunde",
        "report.edit.info.other_invoice_customer_desc": "Velg en annen kunde for faktura",
        "report.edit.info.invoice_customer": "Fakturakunde",
        "report.edit.info.cost_included_in_project": "Kostnad inkludert i prosjekt",
        "report.edit.info.cost_included_in_project_desc": "Kostnader regnes inn i prosjektet",
        "report.edit.info.sales_income_included_in_project": "Salgsinntekt inkludert i prosjekt",
        "report.edit.info.sales_income_included_in_project_desc": "Inntekt regnes inn i prosjektet",
        "report.edit.info.do_not_expect_income": "Forventer ikke inntekt",
        "report.edit.info.do_not_expect_income_desc": "Marker rapporten som uten forventet inntekt",
        "report.edit.confirm_close.title": "Lagre endringer?",
        "report.edit.confirm_close.text": "Du har ulagrede endringer. Vil du lagre før du lukker?",
        "report.edit.confirm_close.keep_editing": "Fortsett redigering",
        "report.edit.confirm_close.discard": "Forkast",
        "report.edit.confirm_close.save": "Lagre",
        "report.edit.checklist.hint": "Dra i håndtaket for å endre rekkefølge. Sett type og marker hva som er påkrevd.",
        "report.edit.checklist.none": "Rapporten er ikke knyttet til en sjekkliste enda.",
        "report.edit.checklist.open": "Åpne sjekkliste",
        "report.edit.checklist.select": "Velg sjekkliste",
        "report.edit.checklist.created": "Sjekkliste opprettet",
        "report.edit.checklist.create_error": "Kunne ikke opprette sjekkliste",
        "report.edit.checklist.delete": "Slett sjekkliste",
        "report.edit.checklist.delete_confirm":
          "Dette kan ikke reverseres. Er du sikker på at du vil slette sjekklisten?",
        "report.edit.checklist.deleted": "Sjekkliste slettet",
        "report.edit.checklist.delete_error": "Kunne ikke slette sjekkliste",
        "report.edit.price.hint": "Varer, timer og tjenester som faktureres kunde. Totaler oppdateres automatisk.",
        "report.edit.team.hint": "Hvem som er ansvarlig og hvem som utfører oppdraget. Roller styrer tilgang.",
        "report.edit.status.heading": "Rapportstatus",
        "report.edit.status.subheading": "Styr fremdriften på oppdraget.",
        "report.edit.status.under_process": "Under behandling",
        "report.edit.status.processed": "Behandlet",
        "report.edit.status.closed": "Lukket",
        "report.edit.status.finished": "Ferdigstilt",
        "report.edit.status.finished_desc": "Rapporten ferdigstilles ved lagring.",
        "report.edit.status.finished_date": "Ferdigstilt dato",
        "report.edit.status.invoiced": "Fakturert",
        "report.edit.status.invoiced_desc": "Marker rapporten som fakturert.",
        "report.edit.status.settings": "Innstillinger",
        "report.view.summary.customer": "Kunde",
        "report.view.sectionReport.title": "Rapport",
        "report.view.sectionReport.description": "Alle servicerapporter skal inneholde en beskrivelse som kan benyttes som grunnlag for fakturatekst.",
        "report.view.sectionReport.cardSubtitle": "fakturatekst",
        "report.view.sectionReport.unit": "rapport",
        "report.view.sectionReport.statusFinished": "Ferdig",
        "report.view.sectionReport.statusNotRequired": "Ikke påkrevd",
        "report.view.sectionReport.statusMissing": "Mangler",
        "report.view.sectionGuide.title": "Guider",
        "report.view.sectionGuide.description": "Strukturerte guider og historikk for denne rapporten",
        "report.view.sectionGuide.unitRuns": "kjøringer",
        "report.view.sectionGuide.statusNone": "Ikke startet",
        "report.view.sectionGuide.statusHasRuns": "{{count}} fullført",
        "report.view.guideHistory.title": "Guidehistorikk",
        "report.view.guideHistory.empty": "Ingen guider er fullført på denne rapporten ennå.",
        "report.view.guideHistory.startGuide": "Start guide",
        "report.view.guideHistory.close": "Lukk",
        "report.view.guideHistory.completedAt": "Fullført",
        "report.view.guideHistory.by": "Av",
        "report.view.guideHistory.unknownUser": "Ukjent bruker",
        "report.view.guideHistory.answers": "Svar",
        "report.view.guideHistory.tagsApplied": "Etiketter lagt til ({{count}})",
        "report.view.mobileNav.guide": "Guide",
        "report.view.priceCalculated.title": "Det er beregnet en pris for denne jobben",
        "report.view.priceCalculated.subtitle": "Sist lagret kalkyle viser hva kunden skal betale for hele jobben (fastpris + tillegg).",
        "report.view.priceCalculated.open": "Åpne kalkyle",
        "report.view.priceCalculated.exVat": "Eks. mva",
        "report.view.priceCalculated.incVat": "Inkl. mva",
        "report.redesign.project": "Prosjekt",
        "report.redesign.active": "Aktivt",
        "report.redesign.executor": "Utførende",
        "report.redesign.technician": "Servicetekniker",
        "report.redesign.report_type": "Rapporttype",
        "report.redesign.oppdrag": "Oppdrag",
        "report.redesign.edit": "Rediger",
        "report.redesign.description": "Oppdragsbeskrivelse",
        "report.redesign.no_description": "Ingen beskrivelse lagt til",
        "report.redesign.internal": "Intern beskrivelse",
        "report.redesign.internal_hint": "ikke synlig for kunde",
        "report.redesign.no_internal": "Ingen intern beskrivelse",
        "report.redesign.appointment.title": "Avtale med kunde",
        "report.redesign.appointment.confirmed": "Avtalt",
        "report.redesign.appointment.not_confirmed": "Ikke avtalt",
        "report.redesign.appointment.empty": "Sett tidspunkt, utfører og varsling til kunde",
        "report.redesign.appointment.set": "Avtal tidspunkt",
        "report.redesign.finalize.title": "Ferdigstill rapport",
        "report.redesign.finalize.done_title": "Rapport ferdigstilt",
        "report.redesign.finalize.desc": "Fullfør alle påkrevde steg, så kan rapporten sendes til kunde.",
        "report.redesign.finalize.done_desc": "Rapporten er ferdigstilt og sendt til kunde.",
        "report.redesign.finalize.progress": "Fremdrift",
        "report.redesign.finalize.done_short": "Ferdigstilt",
        "report.redesign.finalize.view": "Se ferdigstilt rapport",
        "report.redesign.price.title": "Beregnet pris for oppdraget",
        "report.redesign.price.ex_vat": "Eks. mva",
        "report.redesign.price.inc_vat": "Inkl. mva",
        "report.redesign.price.open": "Åpne priskalkulator",
        "report.redesign.address.title": "Leveranseadresse",
        "report.redesign.address.none": "Ingen adresse registrert",
        "report.redesign.address.open_maps": "Vis leveranseadresse i kart",
        "report.redesign.module.optional": "Valgfri",
        "report.redesign.module.items_sub": "materiell",
        "report.redesign.module.variables_sub": "registrert",
        "report.redesign.module.checklist_sub": "punkter",
        "report.redesign.module.guide_sub": "fullført",
        "report.redesign.module.report_sub": "vedlegg",
        "report.redesign.badge.confirmed": "Bekreftet",
        "report.redesign.badge.not_confirmed": "Ikke bekreftet",
        "report.redesign.badge.not_agreed": "Ikke avtalt",
        "report.redesign.badge.must_rectify": "Må utbedres",
        "report.redesign.badge.invoiced": "Fakturert",
        "report.redesign.economy.title": "Økonomisk oversikt",
        "report.redesign.economy.sub_expected": "Kostnader og forventet inntekt for oppdraget",
        "report.redesign.economy.sub_actual": "Kostnader og faktisk inntekt for oppdraget",
        "report.redesign.economy.costs": "Kostnader",
        "report.redesign.economy.income_expected": "Forventet inntekt",
        "report.redesign.economy.income_actual": "Faktisk inntekt",
        "report.redesign.economy.order_items_cost": "Ordrelinjer (kostpris)",
        "report.redesign.economy.order_items_income": "Ordrelinjer (salgspris)",
        "report.redesign.economy.item_consumption": "Vareforbruk",
        "report.redesign.economy.item_sales": "Salgspris varer (eks. rabatt)",
        "report.redesign.economy.hours_cost": "Timekost",
        "report.redesign.economy.hours_income": "Ordinær timespris",
        "report.redesign.economy.car_allowance": "Bilgodtgjørelse",
        "report.redesign.economy.agreed_price": "Avtalt pris",
        "report.redesign.economy.additional_hours": "Tilleggsarbeid (timer)",
        "report.redesign.economy.total_cost": "Sum kostnader",
        "report.redesign.economy.total_income": "Sum inntekt",
        "report.redesign.economy.profit": "Fortjeneste",
        "report.redesign.economy.margin": "Fortjenestemargin",
        "report.redesign.economy.hours": "Totalt timer",
        "report.redesign.economy.distance": "Kjørelengde",
        "report.redesign.economy.items_count": "Antall varer",
        "report.redesign.economy.in_project_title": "Kostnader og inntekter er inkludert i prosjekt",
        "report.redesign.economy.in_project_body": "Denne rapportens kostnader og inntekter er inkludert i prosjektsummeringen og vises ikke separat her.",
        "report.additional_work_calculator.sectionTitle": "Beregn tilleggsarbeider",
        "report.additional_work_calculator.sectionSubtitle": "Kalkyle for tillegg utover fastpris — enkel oversikt for kunden",
        "report.additional_work_calculator.sectionBody": "Åpne kalkylen for å justere timer, vareforbruk og nytt oppmøte. Hovedtallene viser hva kunden skal betale med og uten mva.",
        "report.additional_work_calculator.open": "Åpne kalkyle",
        "report.additional_work_calculator.dialogTitle": "Kalkyle — hva skal kunden betale?",
        "report.additional_work_calculator.loading": "Henter priseestimat…",
        "report.additional_work_calculator.heroLabel": "Hva skal kunden betale (hele jobben)",
        "report.additional_work_calculator.exVat": "Uten mva (eks.)",
        "report.additional_work_calculator.incVat": "Med mva (inkl.)",
        "report.additional_work_calculator.exVatShort": "eks.",
        "report.additional_work_calculator.incVatShort": "inkl.",
        "report.additional_work_calculator.extraHours": "Tilleggstimer",
        "report.additional_work_calculator.hoursLabel": "Antall timer",
        "report.additional_work_calculator.newVisit": "Nytt oppmøte / kjøring",
        "report.additional_work_calculator.newVisitHelp": "Avstand og priser hentes fra samme grunnlag som priseestimatet (leveringsadresse m.m.). Du kan bruke systemets km, egne km eller fast minimumstakst.",
        "report.additional_work_calculator.includeVisit": "Ta med kostnad for nytt oppmøte",
        "report.additional_work_calculator.estimateKm": "Avstand fra priseestimat: {{km}} km (ca.)",
        "report.additional_work_calculator.estimateKmPrice": "Kilometerpris kunde: {{price}} kr/km eks. mva",
        "report.additional_work_calculator.estimateMin": "Minstebeløp kjøring: {{min}} kr — ved lav km brukes fast takst {{fixed}} kr",
        "report.additional_work_calculator.underMinHint": "Ved systemavstand under minstebeløp brukes fast takst i beregningen.",
        "report.additional_work_calculator.modeSystem": "Bruk km fra system",
        "report.additional_work_calculator.modeCustom": "Egne km",
        "report.additional_work_calculator.modeMinimum": "Kun minimum / fast takst",
        "report.additional_work_calculator.customKm": "Antall kilometer",
        "report.additional_work_calculator.productsTitle": "Vareforbruk (ikke fastprislinjer)",
        "report.additional_work_calculator.noProducts": "Ingen varelinjer utenfor fastpris er registrert på rapporten.",
        "report.additional_work_calculator.lineHint": "Endringer her påvirker kun kalkylen — ikke rapportlinjene.",
        "report.additional_work_calculator.qty": "Antall",
        "report.additional_work_calculator.unitPrice": "Pris/stk (eks.)",
        "report.additional_work_calculator.exclude": "Utelat fra beregning",
        "report.additional_work_calculator.includeAgain": "Ta med igjen",
        "report.additional_work_calculator.detailsToggle": "Mer for firma (kostpris, margin, fastpris)",
        "report.additional_work_calculator.hourlyCustomer": "Timepris kunde (kr eks.)",
        "report.additional_work_calculator.hourlyCustomerHelp": "Timepris som kunden faktureres. Standard hentes fra firmaets timeprodukt.",
        "report.additional_work_calculator.hourlyCost": "Timepris kostpris (kr eks.)",
        "report.additional_work_calculator.hourlyCostHelp": "Kostpris per time for firmaet.",
        "report.additional_work_calculator.fallbackHourly": "Standardpris brukt — faktisk kundepris ikke funnet.",
        "report.additional_work_calculator.fallbackCost": "Standardpris brukt — faktisk kostpris ikke funnet.",
        "report.additional_work_calculator.rowLaborCust": "Arbeid (kunde)",
        "report.additional_work_calculator.rowLaborCost": "Arbeid (kostpris)",
        "report.additional_work_calculator.rowMaterialCust": "Varer (kunde)",
        "report.additional_work_calculator.rowMaterialCost": "Varer (kostpris)",
        "report.additional_work_calculator.rowVisitCust": "Oppmøte (kunde)",
        "report.additional_work_calculator.rowVisitCost": "Oppmøte (kostpris)",
        "report.additional_work_calculator.rowFixed": "Fastprislinjer (kunde, eks.)",
        "report.additional_work_calculator.rowTotalCost": "Sum kostpris firma (eks.)",
        "report.additional_work_calculator.rowMargin": "Margin (eks.)",
        "report.additional_work_calculator.historyToggle": "Lagrede kalkyler ({{count}})",
        "report.additional_work_calculator.restore": "Gjenopprett",
        "report.additional_work_calculator.close": "Lukk",
        "report.additional_work_calculator.save": "Lagre kalkyle",
        "report.additional_work_calculator.saveAsNew": "Lagre som ny beregning",
        "report.additional_work_calculator.saveOverwrite": "Lagre over siste",
        "report.additional_work_calculator.saveOverwriteHint": "Erstatter den nyeste lagrede kalkylen. Eldre historikk beholdes.",
        "report.additional_work_calculator.newCalculation": "Ny beregning",
        "report.additional_work_calculator.newCalculationHint": "Nullstiller skjema ut fra rapport og priseestimat (siste lagring påvirker ikke).",
        "report.additional_work_calculator.saving": "Lagrer…",
        "report.additional_work_calculator.toastSaved": "Kalkyle lagret",
        "report.additional_work_calculator.toastSavedNew": "Ny beregning lagret",
        "report.additional_work_calculator.toastSavedOverwrite": "Siste beregning er oppdatert",
        "report.additional_work_calculator.toastSaveError": "Kunne ikke lagre kalkyle",
        "report.additional_work_calculator.toastRestored": "Verdier fra lagret kalkyle er lastet inn",
        "report.additional_work_calculator.addFromCatalog": "Legg til produkt",
        "report.additional_work_calculator.addManualLine": "Tom linje",
        "report.additional_work_calculator.addProductsTitle": "Velg produkter til kalkylen",
        "report.additional_work_calculator.addSelectedProducts": "Legg til i kalkyle",
        "report.additional_work_calculator.toastProductsAdded": "{{count}} produkt(er) lagt til i kalkylen",
        "report.additional_work_calculator.lineTitle": "Beskrivelse / vare",
        "report.additional_work_calculator.lineHintCustom": "Kun i kalkylen — oppretter ikke rapportlinje.",
        "report.additional_work_calculator.unitCost": "Kost/stk (eks.)",
        "report.additional_work_calculator.removeLine": "Fjern linje",
        "report.additional_work_calculator.loadFromReport": "Last kalkyle fra rapport",
        "report.additional_work_calculator.loadFromReportHint":
          "Listen viser bare rapporter med lagret priskalkyle. Velg rapport — siste lagrede kalkyle brukes. Varelinjer fra kilderapporten kobles ikke til denne rapporten.",
        "report.additional_work_calculator.reportSelectorLabel": "Rapport med priskalkyle",
        "report.additional_work_calculator.selectorCalcSummary": "Sist lagra: {{ex}} eks. / {{inc}} inkl.",
        "report.additional_work_calculator.loadFromReportDialogTitle": "Last inn kalkyle fra annen rapport",
        "report.additional_work_calculator.loadFromReportBody":
          "Oppgi rapport-ID (samme som i URL eller rapportkort). Varelinjer fra den rapporten kobles ikke til denne — de blir kun med i kalkylen her.",
        "report.additional_work_calculator.reportIdLabel": "Rapport-ID",
        "report.additional_work_calculator.loadFromReportApply": "Last inn",
        "report.additional_work_calculator.loadFromReportCancel": "Avbryt",
        "report.additional_work_calculator.loadFromReportLoading": "Henter…",
        "report.additional_work_calculator.loadFromReportIdRequired": "Oppgi rapport-ID",
        "report.additional_work_calculator.loadFromReportIdInvalid": "Ugyldig rapport-ID",
        "report.additional_work_calculator.loadFromReportSame": "Velg en annen rapport enn denne",
        "report.additional_work_calculator.toastLoadedFromReport": "Kalkyle lastet fra rapport {{number}}",
        "report.additional_work_calculator.toastNoCalculatorOnReport": "Den rapporten har ingen lagret kalkyle",
        "report.additional_work_calculator.toastLoadReportError": "Kunne ikke hente rapport eller kalkyle",
        "report.additional_work_calculator.addToConsumption": "Legg til i vareforbruk",
        "report.additional_work_calculator.addToConsumptionWorking": "Legger til…",
        "report.additional_work_calculator.addToConsumptionHint":
          "Oppretter eller oppdaterer en varelinje på rapporten (samme som vareforbruk). Priser fra kalkylen synkroniseres til linjen når de avviker.",
        "report.additional_work_calculator.toastAddedToConsumption": "Lagt til i vareforbruk",
        "report.additional_work_calculator.toastAddToConsumptionNeedQty": "Angi antall større enn 0",
        "report.additional_work_calculator.toastAddToConsumptionNeedTitle": "Angi beskrivelse for manuell linje",
        "report.additional_work_calculator.toastAddToConsumptionUnlinked":
          "Varen ble lagt til, men kalkylen kunne ikke kobles til linjen automatisk — oppdater eller legg til på nytt fra vareforbruk.",
        "report.additional_work_calculator.toastAddToConsumptionPriceSyncError":
          "Varelinje opprettet, men prisene fra kalkylen kunne ikke oppdateres",
        "report.additional_work_calculator.toastAddToConsumptionError": "Kunne ikke legge til i vareforbruk",
        "report.additional_work_calculator.discountLabel": "Rabatt timer / kjøring",
        "report.additional_work_calculator.discountHint":
          "Beløp i kroner eks. mva som trekkes fra tilleggstimer og nytt oppmøte/kjøring (ikke fra varer eller fastpris). Kan ikke overstige summen av disse.",
        "report.additional_work_calculator.discountFieldLabel": "Rabatt timer/kjøring (kr eks. mva)",
        "report.additional_work_calculator.lineDiscountLabel": "Rabatt linje (eks.)",
        "report.additional_work_calculator.lineDiscountHint":
          "Rabatt i kroner eks. mva på denne varelinjen. Kan ikke overstige linjens beløp (antall × pris/stk).",
        "report.additional_work_calculator.rowSubtotal": "Sum før rabatter (eks.)",
        "report.additional_work_calculator.rowDiscount": "Rabatt (eks.)",
        "report.additional_work_calculator.rowDiscountMaterials": "Rabatt varer (eks.)",
        "report.additional_work_calculator.rowDiscountHoursVisit": "Rabatt timer/kjøring (eks.)",
        "report.additional_work_calculator.rowMaterialCustGross": "Varer før rabatt (kunde, eks.)",
        "report.additional_work_calculator.detailsToggleCustomer": "Prisdetaljer (kunde, eks.)",
        "report.additional_work_calculator.rowTotalCustomerExVat": "Sum kunde (eks.)",
        "report.additional_work_calculator.excludeShort": "Utelat",
        "report.additional_work_calculator.includeShort": "Ta med",
        "report.additional_work_calculator.addToConsumptionShort": "Vareforbruk",
        "report.additional_work_calculator.addPriceLines": "Legg til prislinje",
        "report.additional_work_calculator.addPriceLinesHint":
          "Oppretter én avtalt prislinje «Avtalt arbeid inkl. oppmøte»: summen av tilleggstimer og oppmøte/kjøring (eks. mva, før rabatt på timer/kjøring). Kobler første prosjektaktivitet som har aktivitetselement, ellers første aktivitet på prosjektet. Juster under Prislinjer.",
        "report.additional_work_calculator.priceLineWorkIncludingVisitTitle":
          "Avtalt arbeid inkl. oppmøte (kalkyle)",
        "report.additional_work_calculator.toastPriceLinesNothing":
          "Legg inn tilleggstimer og/eller slå på nytt oppmøte med beløp over null.",
        "report.additional_work_calculator.toastPriceLinesAdded": "{{count}} prislinje(r) lagt til",
        "report.additional_work_calculator.toastPriceLinesError": "Kunne ikke opprette prislinje",
        "report.sectionCard.viewOnlyHint": "Kun visning (klikk for å se)",
        "report.sectionCard.progress": "Fremgang",
        "report.sectionDialog.reportTitle": "Rapportinnhold",
        "report.sectionDialog.reportDescription": "Skriv rapportinnhold",
        "report.sectionDialog.reportContentLabel": "Rapport",
        "report.sectionDialog.reportContentHint": "Alle servicerapporter skal inneholde en beskrivelse som kan benyttes som grunnlag for fakturatekst.",
        "report.sectionDialog.internalReportLabel": "Intern rapport",
        "report.sectionDialog.internalReportHint": "Kun synlig for ansatte internt — deles ikke med kunden.",
        "report.sectionDialog.placeholderReport": "Skriv rapportinnhold her…",
        "report.sectionDialog.placeholderInternal": "Skriv intern rapport her…",
        "report.sectionDialog.formatting": "Formaterer…",
        "report.sectionDialog.formatWithAi": "Formater med ChatGPT",
        "report.sectionDialog.autoSaveHint": "Endringer lagres automatisk.",
        "report.sectionDialog.saving": "Lagrer…",
        "report.sectionDialog.saved": "Lagret",
        "report.sectionDialog.autoSaveError": "Kunne ikke lagre rapporttekst",
        "report.sectionDialog.close": "Lukk",
        "report.agreement.section.followup": "Oppfølging til kunde",
        "report.agreement.section.followup_help":
          "Send påminnelse, send avtalen på nytt (SMS), eller send oppdatert avtale etter at den er bekreftet.",
        "report.agreement.section.manual_confirm": "Bekreft avtale manuelt",
        "report.agreement.section.manual_confirm_help":
          "Bruk når kunden allerede har bekreftet utenfor Promang. Du blir spurt om å bekrefte før det lagres.",
        "report.agreement.section.cancel_agreement": "Avbryt avtale",
        "report.agreement.section.cancel_agreement_help":
          "Velg type avbestilling eller årsak. «Oppdrag kansellert» avslutter uten begrunnelse og uten melding om ny tid. SMS til kunden kan slås av/på under før du bekrefter.",
        "report.agreement.cancel_sms_hint":
          "Hvis dette er på, kan det sendes SMS når avbestillingen sendes (avhengig av oppsett).",
        "report.agreement.prompt.reminder_title": "Send bekreftelsespåminnelse?",
        "report.agreement.prompt.reminder_body":
          "Sjekk at du ikke allerede har sendt en påminnelse for denne avtalen.",
        "report.agreement.prompt.resend_title": "Send avtale på nytt?",
        "report.agreement.prompt.resend_body":
          "Sjekk at du ikke allerede har sendt ny melding til kunden.",
        "report.agreement.prompt.updated_appointment_title":
          "Send oppdatert avtale?",
        "report.agreement.prompt.updated_appointment_body":
          "Det sendes samme dato og tid som før; beskrivelse og annet kan være oppdatert.",
        "report.agreement.prompt.confirm_manual_title":
          "Registrere manuell bekreftelse?",
        "report.agreement.prompt.confirm_manual_body":
          "Avtalen merkes som bekreftet ({{method}}). Vil du fortsette?",
        "report.agreement.prompt.cancel_agreement_title": "Avbryte avtalen?",
        "report.agreement.prompt.cancel_agreement_body":
          "Årsak: {{reason}}. Dette avbestiller avtalen i Promang. Vil du fortsette?",
        "send-sms.customer": "Send SMS til kunde",
        "cancel.reason": "Årsak til avbestilling",
        "cancel.reason.required": "Årsak til avbestilling er påkrevd",
        "cancel.reason.employee_sickness": "Servicetekniker syk",
        "cancel.reason.customer_sickness": "Kunde syk",
        "cancel.reason.not_confirmed": "Ikke bekreftet av kunde",
        "cancel.reason.not_suited": "Tidspunkt passet ikke for kunden",
        "cancel.reason.assignment_cancelled": "Oppdrag kansellert",
        "cancel.reason.not_chosen": "Ikke valgt",
        "report.agreement.edit": "Rediger avtale",
        "report.agreement.time_range": "Tidsrom",
        "report.agreement.redesign.executing_section": "Utførende",
        "report.agreement.redesign.executing_help": "Velg hvem som skal utføre jobben.",
        "report.agreement.redesign.search_employee": "Søk etter person…",
        "report.agreement.redesign.avail_free": "Ledig",
        "report.agreement.redesign.avail_partial": "Delvis",
        "report.agreement.redesign.avail_busy": "Opptatt",
        "report.agreement.redesign.avail_absence": "Fravær",
        "report.agreement.redesign.no_employees": "Ingen treff.",
        "report.agreement.redesign.executing_locked_hint": "Du er satt som utførende for denne avtalen.",
        "report.agreement.redesign.schedule_section": "Avtaledato og tidsrom",
        "report.agreement.redesign.schedule_help": "Dra et tidsrom i kalenderen til høyre, eller juster ved å dra avtalen.",
        "report.agreement.redesign.drag_hint": "Dra i kalenderen til høyre for å sette tidsrom.",
        "report.agreement.redesign.drag_hint_bold": "Dra og slipp",
        "report.agreement.redesign.drag_hint_suffix": "for å opprette avtalen.",
        "report.agreement.redesign.drag_tip": "Tips: Dra avtalen for å flytte den, eller dra nederst for å endre lengde.",
        "report.agreement.redesign.settings_section": "Innstillinger",
        "report.agreement.redesign.fixed_time_on_hint": "På: oppmøte skjer ved valgt tidspunkt.",
        "report.agreement.redesign.fixed_time_off_hint": "Av: oppmøte skjer innenfor valgt tidsrom.",
        "report.agreement.redesign.clear_time": "Fjern",
        "report.agreement.redesign.jobs_this_week": "{{count}} jobber denne uken",
        "report.agreement.redesign.prev_week": "Forrige uke",
        "report.agreement.redesign.next_week": "Neste uke",
        "report.agreement.redesign.today": "I dag",
        "report.agreement.redesign.legend_existing": "Eksisterende",
        "report.agreement.redesign.legend_absence": "Fravær",
        "report.agreement.redesign.legend_new": "Ny avtale",
        "report.agreement.redesign.absence_short": "Fravær",
        "report.agreement.redesign.channels": "Kanaler",
        "report.agreement.redesign.preview": "Forhåndsvisning",
        "report.agreement.redesign.preview_empty": "Kunne ikke hente forhåndsvisning.",
        "report.agreement.redesign.skip_notify": "Lagre uten varsling",
        "report.agreement.redesign.send_agreement": "Send avtale",
        "report.agreement.redesign.pick_time_hint": "Velg tidsrom i kalenderen →",
        "report.agreement.redesign.conflict_hint": "Konflikt med eksisterende avtale — du kan fortsette likevel.",
        "report.agreement.redesign.next_notify": "Neste: Varsling",
        "report.agreement.redesign.step_schedule": "Tid og utførende",
        "report.agreement.redesign.step_notify": "Varsling til kunde",
        "report.variables.update": "Oppdater variabler",
        "report.price_lines.title": "Prislinjer",
        "report.price_lines.description": "Administrer prislinjer og avtalte priser",
        "report.price_lines.add": "Legg til prislinje",
        "report.price_lines.empty": "Ingen prislinjer lagt til",
        "report.price_lines.line": "Prislinje",
        "report.price_lines.title_field": "Tittel",
        "report.price_lines.activity_item": "Aktivitet",
        "report.price_lines.no_activity": "Ingen aktivitet",
        "report.price_lines.description_field": "Beskrivelse",
        "report.price_lines.is_agreed_price": "Avtalt prislinje",
        "report.price_lines.agreed_price": "Avtalt pris",
        "report.price_lines.agreed_price_excl_vat": "Avtalt pris (eks. mva)",
        "report.price_lines.agreed_price_incl_vat": "Avtalt pris (inkl. mva)",
        "report.price_lines.vat_type": "MVA Type",
        "report.price_lines.no_vat_type": "Ingen MVA Type",
        "report.price_lines.select_vat_type": "Velg MVA Type",
        "report.price_lines.select_vat_type_description": "Velg en MVA type for denne prislinjen",
        "report.price_lines.search_vat_types": "Søk etter MVA typer...",
        "report.price_lines.no_vat_types_found": "Ingen MVA typer funnet",
        "report.price_lines.no_vat_types_available": "Ingen MVA typer tilgjengelig",
        "report.price_lines.select_activity": "Velg Aktivitet",
        "report.price_lines.project_activity": "Prosjektaktivitet",
        "report.price_lines.select_project_activity": "Velg prosjektaktivitet",
        "report.price_lines.select_project_first": "Velg et prosjekt først",
        "report.price_lines.remove_activity": "Fjern Aktivitet",
        "report.price_lines.agreed_hours": "Avtalte timer",
        "project_activity.label": "Prosjektaktivitet",
        "project_activity.select": "Velg prosjektaktivitet",
        "project_activity.dialog_title": "Velg prosjektaktivitet",
        "project_activity.search_placeholder": "Søk i prosjektaktiviteter…",
        "project_activity.empty": "Ingen prosjektaktiviteter funnet",
        "project_activity.select_project_first": "Velg prosjekt først",
        "project_activity.load_error": "Kunne ikke laste prosjektaktiviteter",
        "project_activity.clear_selection": "Fjern valg",
        "project_activity.none": "Ingen prosjektaktivitet",
        "project_activity.missing": "Ingen prosjektlinje",
        "hours.period_table.project_and_line": "Prosjekt / prosjektlinje",
        "Loading": "Laster",
        "hours.registration_warning.title": "Advarsel: Timer overstiger beregnet",
        "hours.registration_warning.message": "Du er i ferd med å registrere {newHours} timer på aktiviteten \"{activityTitle}\". Dette vil bringe totalt registrerte timer til {totalAfterRegistration} timer, som overstiger de beregnede {estimatedHours} timene. Nå registrert: {registeredHours} timer.",
        "hours.registration_warning.question": "Er du sikker på at du vil registrere disse timene på denne aktiviteten?",
        "hours.registration_warning.confirm": "Ja, jeg er sikker",
        "hours.registration_warning.cancel": "Nei, korriger",
        "hours.registration_warning.this_activity": "denne aktiviteten",
        "hours.form_tab_details": "Detaljer",
        "hours.form.public_holiday_title": "Rød dag",
        "hours.form.public_holiday_body": "{{name}} er en offentlig helligdag. Normal arbeidstid er 0 timer denne dagen, men du kan likevel registrere timer ved behov.",
        "absence.form.public_holiday_title": "Rød dag",
        "absence.form.public_holiday_body": "Fravær kan ikke registreres på røde dager. Perioden inkluderer: {{names}}.",
        "absence.form.public_holiday_blocked": "Fravær kan ikke registreres på røde dager ({{names}}).",
        "absence.edit.title_new": "Nytt fravær",
        "absence.edit.title_edit": "Rediger fravær",
        "absence.edit.close": "Lukk",
        "absence.edit.employee": "Ansatt",
        "absence.edit.select_employee": "Velg ansatt",
        "absence.edit.employee_admin_only": "Synlig kun for administratorer",
        "absence.edit.absence_type": "Fraværstype",
        "absence.edit.select_absence_type": "Velg fraværstype",
        "absence.edit.type_search": "Søk fraværstype",
        "absence.edit.type_empty": "Ingen fraværstyper funnet",
        "absence.edit.loading": "Laster …",
        "absence.edit.type_balance": "Brukt {{used}} · Gjenstående {{remaining}} dager",
        "absence.edit.type_hours_left": "Gjenstående {{hours}} timer",
        "absence.edit.select_employee_first": "Velg ansatt først",
        "absence.edit.select_absence_type_first": "Velg fraværstype først",
        "absence.edit.period": "Periode",
        "absence.edit.description": "Beskrivelse",
        "absence.edit.max_days_hint_one": "Maksimalt 1 dag for denne fraværstypen",
        "absence.edit.max_days_hint_other": "Maksimalt {{count}} dager for denne fraværstypen",
        "absence.edit.comp_time_hint": "Avspasering baserer seg på faktiske innstående timer, ikke maks antall dager",
        "absence.edit.sick_leave_hint": "Sykemelding er basert på legeerklæring og har ingen begrensning på antall dager",
        "absence.edit.read_only_title": "Godkjent fravær",
        "absence.edit.read_only_body": "Dette fraværet er godkjent og kan ikke redigeres.",
        "absence.edit.documents_title": "Vedlegg",
        "absence.edit.documents_subtitle": "Kun PDF-filer er tillatt",
        "absence.edit.documents_add": "Legg til fil",
        "absence.edit.documents_remove": "Fjern fil",
        "absence.edit.documents_uploaded": "Vedlegg lastet opp",
        "absence.edit.documents_upload_failed": "Kunne ikke laste opp vedlegg",
        "absence.edit.export_pdf": "Eksporter PDF",
        "absence.edit.exporting": "Eksporterer …",
        "absence.edit.approve": "Godkjenn",
        "absence.edit.delete": "Slett",
        "absence.edit.cancel": "Avbryt",
        "absence.edit.save": "Lagre",
        "absence.edit.saving": "Lagrer …",
        "absence.edit.create": "Opprett fravær",
        "absence.edit.update": "Lagre endringer",
        "absence.edit.error_title": "Feil ved lagring av fravær",
        "absence.edit.saved": "Fravær ble lagret",
        "absence.edit.saved_title": "Fravær registrert",
        "absence.edit.saved_body": "Fraværet er registrert og sendes til behandling.",
        "absence.edit.saved_body_with_documents": "Fraværet er registrert og sendes til behandling. Vedlegg er lastet opp.",
        "absence.edit.register_new": "Registrer nytt fravær",
        "absence.edit.status": "Status",
        "absence.edit.pending_approval": "Sendes til behandling",
        "absence.edit.load_failed": "Kunne ikke laste inn fravær",
        "absence.edit.load_error": "Noe gikk galt ved lasting av fravær",
        "absence.edit.user_required": "Ansatt må velges",
        "absence.edit.user_required_save": "Du må velge en ansatt før du kan lagre fraværet",
        "absence.edit.user_id_required": "user_id er påkrevd for å opprette/oppdatere fravær",
        "absence.edit.unknown_save_error": "Ukjent feil ved lagring av fravær",
        "absence.edit.pdf_must_save": "Fraværet må være lagret før PDF kan eksporteres",
        "absence.edit.pdf_must_approve": "Fraværet må være godkjent før PDF kan eksporteres",
        "absence.edit.pdf_invalid": "PDF-filen er for liten eller ugyldig",
        "absence.edit.pdf_exported": "PDF ble eksportert",
        "absence.edit.pdf_failed": "Kunne ikke eksportere PDF",
        "absence.edit.delete_failed": "Noe gikk galt under sletting av fraværet",
        "absence.edit.delete_confirm": "Er du sikker på at du vil slette fraværet?",
        "absence.edit.approve_title": "Godkjenn fravær",
        "absence.edit.approved_label": "Godkjent",
        "absence.edit.denied_label": "Ikke godkjent",
        "absence.edit.note": "Notat",
        "absence.edit.approved_by": "Godkjent av {{name}}",
        "hours.approved_edit_notice_title": "Godkjent time",
        "hours.approved_edit_notice_body":
          "Denne timen er godkjent. Som bedriftsadministrator kan du likevel redigere den; godkjenningsstatus beholdes. Lønn eller Tripletex bør kontrolleres manuelt etter endringer.",
        "hours.bulk_reassign.project_field": "Prosjekt",
        "hours.bulk_reassign.title": "Flytt timer til annet prosjekt / aktivitet",
        "hours.bulk_reassign.intro": "Du redigerer {{count}} time(r). Velg målprosjekt og prosjektaktivitet (linje).",
        "hours.bulk_reassign.project_required": "Prosjekt er påkrevd",
        "hours.bulk_reassign.activity_required": "Prosjektaktivitet er påkrevd",
        "hours.bulk_reassign.submit": "Bruk på valgte timer",
        "hours.bulk_reassign.saving": "Lagrer…",
        "hours.bulk_reassign.success": "Oppdaterte {{count}} time(r).",
        "hours.bulk_reassign.partial": "Oppdaterte {{updated}}; {{failed}} feilet — se listen.",
        "hours.bulk_reassign.error": "Kunne ikke flytte timer",
        "hours.bulk_reassign.open": "Flytt valgte…",
        "hours.split.open": "Del opp timer",
        "hours.split.open_hint": "Fordel denne registreringen på flere prosjektaktiviteter. Summen må stemme med totalt.",
        "hours.split.title": "Del opp timer",
        "hours.split.intro": "Fordel timene på flere aktiviteter. Summen av radene må være lik totalt antall timer.",
        "hours.split.total_label": "Totalt",
        "hours.split.unit": "t",
        "hours.split.sum_live": "Fordelt {{allocated}} / Totalt {{total}}",
        "hours.split.remaining": "{{hours}} t gjenstår",
        "hours.split.over_allocated": "{{hours}} t for mye",
        "hours.split.mismatch_hint": "Summen må være lik totalt før du kan lagre.",
        "hours.split.col_project": "Prosjekt",
        "hours.split.col_activity": "Aktivitet",
        "hours.split.col_time": "Timer",
        "hours.split.col_description": "Beskrivelse",
        "hours.split.description_placeholder": "Valgfritt",
        "hours.split.add_row": "Legg til rad",
        "hours.split.remove_row": "Fjern rad",
        "hours.split.row_n": "Rad {{n}}",
        "hours.split.submit": "Lagre fordeling",
        "hours.split.saving": "Lagrer…",
        "hours.split.success": "Timene ble fordelt på {{count}} rader.",
        "hours.split.error": "Kunne ikke dele opp timer",
        "hours.approval.filter_project": "Prosjekt",
        "hours.approval.all_projects": "Alle prosjekter",
        "hours.approval.clear_project_filter": "Fjern prosjekt",
        "hours.approval.selection_summary.title": "Oppsummering av valg",
        "hours.approval.selection_summary.subtitle":
          "«Registrert» og periode-tall er fra listen for valgt datointervall og filter (samme utvalg som tabellen).",
        "hours.approval.selection_summary.total_selected": "Valgt: {{hours}} t · {{entries}} poster",
        "hours.approval.selection_summary.period_totals": "I perioden (lastet): {{hours}} t · {{entries}} poster",
        "hours.approval.selection_summary.by_date": "Per dato",
        "hours.approval.selection_summary.day_row": "{{date}}: {{selected}} t valgt av {{registered}} t registrert",
        "hours.approval.selection_summary.other_days": "Andre dager med registreringer: {{days}} dager · {{hours}} t",
        "hours.approval.selection_summary.clear": "Fjern valg",
        "hours.approval.selection_summary.unknown_user": "Ukjent bruker",
        "hours.approval.bulk.select_required": "Velg timer å behandle",
        "hours.approval.bulk.approve_note": "Bulk godkjent",
        "hours.approval.bulk.reject_note": "Bulk ikke godkjent",
        "hours.approval.bulk.success_approved": "{{count}} time(r) godkjent",
        "hours.approval.bulk.success_rejected": "{{count}} time(r) ikke godkjent",
        "hours.approval.bulk.partial": "{{done}} bekreftet behandlet. {{remaining}} gjenstår — kontroller status før nytt forsøk.",
        "hours.approval.bulk_unapprove.action": "Avgodkjenn valgte",
        "hours.approval.bulk_unapprove.no_approved": "Ingen av de valgte timene er godkjent.",
        "hours.approval.bulk_unapprove.success": "Godkjenning fjernet for {{count}} time(r).",
        "hours.approval.bulk_unapprove.error": "Kunne ikke avgodkjenne alle valgte timer",
        "hours.approval.bulk_unapprove.partial": "{{done}} avgodkjent. {{remaining}} gjenstår — kontroller status før nytt forsøk.",
        "hours.approval.bulk_unapprove.process_note": "Bulk avgodkjent",
        "project.time_registration.bulk_reassign": "Flytt valgte timer…",
        "project.time_registration.select_hour": "Velg time for masseflytting",
        "hours.sheet.add_hour": "Legg til time",
        "hours.sheet.edit_hour": "Rediger time",
        "hours.sheet.new_hour": "Ny time",
        "hours.sheet.stats_title": "Statistikk",
        "hours.sheet.stats_selected_period": "Valgt periode (listen)",
        "hours.sheet.stats_calendar_month": "Kalendermåned",
        "hours.sheet.stats_weeks_heading": "Uker",
        "hours.sheet.stats_this_week": "Denne uken",
        "hours.sheet.stats_prev_week": "Forrige uke",
        "hours.sheet.stats_normal_suffix": "normal (tidsskjema)",
        "hours.sheet.stats_no_schedule": "Ingen arbeidstidsplan er knyttet til ansettelsen — normaltimer og prosent vises ikke.",
        "hours.sheet.stats_loading_extra": "Henter måned- og uketotaler…",
        "hours.sheet.stats_compact_month": "Mnd.",
        "hours.sheet.stats_show_more": "Mer",
        "hours.sheet.stats_show_less": "Mindre",
        "hours.sheet.stats_overview_title": "Oversikt",
        "hours.sheet.stats_close": "Lukk",
        "hours.sheet.eyebrow": "Timeføring",
        "hours.sheet.scope_aria": "Velg visning",
        "hours.sheet.employee_search": "Søk ansatt …",
        "hours.sheet.employee_empty": "Ingen treff",
        "hours.sheet.employee_none": "Ingen valgt",
        "hours.sheet.employee_role_fallback": "Ansatt",
        "hours.sheet.week_label": "Uke {{week}}",
        "hours.sheet.day_none": "ingen timer",
        "hours.sheet.day_partial": "delvis",
        "hours.sheet.day_complete": "fullført",
        "hours.sheet.entry_count": "{{count}} oppføringer · {{projects}} prosjekter",
        "hours.sheet.export_aria": "Eksporter timeliste",
        "hours.sheet.export_pdf": "PDF",
        "hours.sheet.export_excel": "Excel",
        "hours.sheet.export_pdf_loading": "Lager PDF…",
        "hours.sheet.export_excel_loading": "Lager Excel…",
        "hours.sheet.export_pdf_success": "Timeliste lastet ned som PDF",
        "hours.sheet.export_excel_success": "Timeliste lastet ned som Excel",
        "hours.sheet.export_error": "Kunne ikke eksportere timelisten",
        "outbound_communications.title": "E-postlogg",
        "outbound_communications.search": "Søk",
        "outbound_communications.search_placeholder": "Søk i emne, mottaker eller innhold",
        "outbound_communications.load_error": "Kunne ikke laste e-postloggen",
        "outbound_communications.not_found": "Fant ikke e-posten",
        "outbound_communications.no_subject": "(ingen tittel)",
        "outbound_communications.system": "System",
        "outbound_communications.col_sent": "Sendt",
        "outbound_communications.col_subject": "Emne",
        "outbound_communications.col_from": "Fra",
        "outbound_communications.col_to": "Til",
        "outbound_communications.col_sent_by": "Sendt av",
        "outbound_communications.col_type": "Type",
        "outbound_communications.col_customer": "Kunde",
        "outbound_communications.export_pdf": "Eksporter PDF",
        "outbound_communications.pdf_loading": "Lager PDF…",
        "outbound_communications.pdf_failed": "Kunne ikke eksportere PDF",
        "outbound_communications.export_success": "PDF åpnet",
        "outbound_communications.select_all": "Velg alle",
        "outbound_communications.back": "Tilbake til e-postlogg",
        "outbound_communications.attachments": "Vedlegg",
        "hours.sheet.of_normal": "av {{hours}}t normal",
        "hours.sheet.of_normal_short": "av {{hours}}t",
        "hours.sheet.new_entry_day": "Ny føring på denne dagen",
        "hours.sheet.week_matrix_sub": "{{projects}} prosjekter · {{activities}} aktiviteter",
        "hours.sheet.sum_day": "Sum dag",
        "hours.sheet.period_sub": "{{entries}} oppføringer · {{days}} dager med timer",
        "hours.sheet.period_avg": "snitt {{hours}}t per aktiv dag",
        "hours.sheet.preset_this_month": "Denne måneden",
        "hours.sheet.preset_last_month": "Forrige måned",
        "hours.sheet.preset_quarter": "Kvartal",
        "hours.sheet.period_meta": "{{days}} dager · {{count}} med føringer",
        "hours.sheet.hours_left": "{{hours}}t igjen",
        "hours.sheet.prev_week_short": "Forrige uke {{hours}}t",
        "hours.sheet.stats_list_hint": "Listen under",
        "hours.sheet.project_split": "Fordeling på prosjekt",
        "hours.sheet.unsynced_title": "{{count}} føringer ikke synkronisert",
        "hours.sheet.unsynced_body": "Noen timer er ikke sendt til lønn. Prosesser dem før uken lukkes.",
        "hours.sheet.unsynced_see": "Se føring",
        "hours.sheet.unsynced_process": "Prosesser nå",
        "hours.sheet.week_progress_title": "Uke {{week}} — fremdrift mot normaltid",
        "hours.sheet.week_progress_body": "{{hours}} timer gjenstår før normaltid er nådd.",
        "hours.sheet.hide_banner": "Skjul",
        "hours.quick.title": "Hurtigregistrering",
        "hours.quick.week_subtitle": "Uke {{week}} · {{range}}",
        "hours.quick.mode_aria": "Velg timeføringsmodus",
        "hours.quick.mode_form": "Skjema",
        "hours.quick.mode_quick": "Rask",
        "hours.quick.prev_week": "Forrige uke",
        "hours.quick.next_week": "Neste uke",
        "hours.quick.copy_last_week": "Kopier forrige uke",
        "hours.quick.saving": "Lagrer…",
        "hours.quick.saved": "✓ Lagret",
        "hours.quick.save_idle": "Klar",
        "hours.quick.save_error": "Kunne ikke lagre timer",
        "quality.checklist.type.fieldResponseRules": "Feltets oppførsel ved valgt svar",
        "quality.checklist.type.fieldMode.hidden": "Skjult, ingen krav",
        "quality.checklist.type.fieldMode.optional": "Synlig, valgfritt",
        "quality.checklist.type.fieldMode.required": "Synlig, påkrevd",
        "quality.checklist.gaps.fields": "Mangler påkrevde felt",
        "project.billing_plan.retention_completed_explanation": "Innestående beregnes av utført beløp på raden i faktureringsplanen.",
        "project.billing_plan.retention_enable": "Bruk prosentvis innestående",
        "project.billing_plan.retention_percentage": "Prosentandel (%)",
        "project.billing_plan.retention_percentage_hint": "Angi en prosentandel fra 0 til 100.",
        "hours.quick.outcome_unknown": "Lagringen kunne ikke bekreftes. Last inn lagrede timer før du prøver igjen. Dette erstatter utkastet i rutenettet.",
        "hours.quick.reload_saved": "Last inn lagrede timer",
        "hours.quick.save_error_short": "Feil ved lagring",
        "hours.quick.batch_fallback": "Batch-lagring er midlertidig utilgjengelig — lagrer celler enkeltvis.",
        "hours.quick.loading": "Laster uke…",
        "hours.quick.col_project": "Prosjekt",
        "hours.quick.col_activity": "Aktivitet",
        "hours.quick.col_sum": "Sum",
        "hours.quick.no_project": "Velg prosjekt",
        "hours.quick.pick_activity": "Velg aktivitet",
        "hours.quick.description": "Beskrivelse",
        "hours.quick.description_placeholder": "Hva jobbet du med?",
        "hours.quick.description_done": "Ferdig",
        "hours.quick.fill_handle": "Dra for å fylle",
        "hours.quick.remove_row": "Fjern rad",
        "hours.quick.new_row": "Ny rad",
        "hours.quick.search_placeholder": "Søk prosjekt eller aktivitet…",
        "hours.quick.suggestions_hits": "Treff",
        "hours.quick.suggestions_recent": "Favoritter og nylig brukt",
        "hours.quick.no_suggestions": "Ingen forslag",
        "hours.quick.add_via_selectors": "Eller velg prosjekt",
        "hours.quick.browse_projects": "Bla gjennom prosjekter",
        "hours.quick.pick_project": "Velg prosjekt",
        "hours.quick.pick_activity_for_project": "Velg aktivitet…",
        "hours.quick.search_projects": "Søk prosjekt…",
        "hours.quick.search_activities": "Søk aktivitet…",
        "hours.quick.picker_search": "Søk…",
        "hours.quick.no_projects": "Ingen prosjekter",
        "hours.quick.no_activities": "Ingen aktiviteter",
        "hours.quick.tag_in_grid": "I gridet",
        "hours.quick.row_already_exists": "Raden finnes allerede — fokuserte den i gridet",
        "hours.quick.add_row_hint": "Samme prosjekt med annen aktivitet blir en ny rad.",
        "hours.quick.tag_recent": "Nylig",
        "hours.quick.tag_project": "Prosjekt",
        "hours.quick.norm_title": "Uke mot normtid",
        "hours.quick.norm_of": "av {{hours}} t",
        "hours.quick.norm_unknown": "uten normtid",
        "hours.quick.norm_on_target": "På normtid",
        "hours.quick.norm_over": "+{{hours}} t over",
        "hours.quick.norm_left": "{{hours}} t igjen",
        "hours.quick.keyboard_hint": "Tab / Shift+Tab: neste / forrige felt · F2: notat · Piltaster for å flytte · Enter ned · Shift+PageUp/Down bytter uke · dra hjørnet for å fylle",
        "hours.quick.flush_now": "Lagre nå",
        "hours.quick.cancel": "Avbryt",
        "hours.quick.conflict_hint": "Flere timer samme dag — dobbeltklikk for å åpne skjema",
        "hours.mobile.add": "Ny time",
        "hours.mobile.stats": "Statistikk",
        "hours.mobile.navAriaLabel": "Timenavigasjon",
        "report.price_lines.updated": "Prislinje oppdatert",
        "report.price_lines.created": "Prislinje opprettet",
        "report.price_lines.deleted": "Prislinje slettet",
        "report.price_lines.save_error": "Kunne ikke lagre prislinje",
        "report.price_lines.delete_error": "Kunne ikke slette prislinje",
        "report.price_lines.edit": "Rediger prislinje",
        "report.copy.price_lines_option": "Prislinjer",
        "report.copy.variables_option": "Variabler",
        "report.sequel.copy_variables_switch": "Kopier fra hovedrapport",
        "report.sequel.copy_variables_hint_on":
          "Variabler kopieres fra hovedrapporten, inkl. grupper, type-grupper, verdier og målinger.",
        "report.sequel.copy_variables_hint_off": "Ingen variabler kopieres.",
        "report.sequel.copy_variables_none_available":
          "Ingen variabelrader eller grupper på hovedrapporten — ingenting å kopiere.",
        "report.sequel.copy_price_lines_switch": "Kopier fra hovedrapport",
        "report.sequel.copy_price_lines_hint_on":
          "Prislinjer kopieres fra hovedrapporten ({{count}} linjer).",
        "report.sequel.copy_price_lines_hint_off": "Ingen prislinjer kopieres.",
        "report.sequel.copy_price_lines_none_available": "Ingen prislinjer på hovedrapporten.",
        "report.price_lines.updating": "Oppdaterer...",
        "report.price_lines.adding": "Legger til...",
        "report.price_lines.delete_confirm": "Er du sikker på at du vil slette denne prislinjen?",
        "report.price_lines.delete": "Slett prislinje",
        "report.price_lines.error_loading": "Feil ved lasting av prislinjer",
        "report.price_lines.add_first": "Legg til første prislinje",
        "report.price_lines.title_required": "Tittel er påkrevd",
        "report.price_lines.validation.agreed_price_or_hours":
            "Oppgi avtalt pris (eks. eller inkl. mva) eller avtalte timer, eller slå av «Avtalt prislinje».",
        "report.price_lines.server_errors_title": "Kunne ikke lagre — se meldingene under",
        "report.price_lines.field_errors_hint": "Felt med feil er markert.",
        "report.details.description": "Grunnleggende rapportinformasjon",
        "report.items.description": "Administrer varer og forbruk",
        "report.activities.description": "Administrer aktiviteter og timer",
        "report.checklist.description": "Fullfør sjekklistepunkter",
        "report.checklist.loading": "Laster sjekkliste…",
        "report.checklist.load_error": "Kunne ikke laste sjekkliste",
        "report.checklist.load_error_title": "Sjekklisten kunne ikke lastes",
        "report.checklist.load_error_hint":
          "Gå til et annet steg og tilbake, eller lukk og åpne dialogen på nytt. Hvis problemet vedvarer, prøv igjen senere.",
        "quality.checklist.view.completionTitle": "Fullfør sjekkliste",
        "quality.checklist.field.house": "Hus",
        "quality.checklist.field.apartment": "Leilighetsnummer",
        "quality.checklist.view.completionDescription":
          "Når alle punkter er godkjent eller registrert som avvik, kan du ferdigstille sjekklisten. Ulagrede endringer lagres når du fortsetter.",
        "quality.checklist.view.completionButton": "Ferdigstill sjekkliste",
        "quality.checklist.view.completionSaving": "Lagrer…",
        "quality.checklist.view.completionDoneTitle": "Sjekklisten er ferdigstilt",
        "quality.checklist.view.completionDoneDescription":
          "Sjekklisten er markert som ferdig.",
        "quality.checklist.type.titleLabel": "Tittel",
        "quality.checklist.type.activeLabel": "Aktiv",
        "quality.checklist.type.introLabel": "Introduksjon til denne sjekklistetypen",
        "quality.checklist.type.defaultActions": "Tilgjengelige svar",
        "quality.checklist.type.defaultActionsHint":
          "Velg hvilke utfall som skal vises som knapper på sjekklistepunkter. Enkeltpunkter kan begrense listen videre.",
        "quality.checklist.type.pointsHeading": "Sjekklistepunkter",
        "quality.checklist.type.pointsSubheading":
          "Legg inn tittel, veiledning til oppdragsgiver/bruker, og hvilke svar som gjelder for hvert punkt.",
        "quality.checklist.type.documentsRequired": "Dokumentasjon påkrevd",
        "quality.checklist.type.pointLabel": "Punkt {{n}}",
        "quality.checklist.type.pointTitle": "Punktet sitt navn",
        "quality.checklist.type.guidanceLabel": "Veiledning",
        "quality.checklist.type.guidanceHint":
          "Vises den som fyller ut sjekklisten, slik at de forstår hva som skal bekreftes. Fritekstsvaret skrives i feltet under ved utfylling.",
        "quality.checklist.type.pointActions": "Svar for dette punktet",
        "quality.checklist.type.pointActionsHint":
          "Skru av svar som ikke skal vises bare for dette punktet. Standard følger sjekklistetypen.",
        "quality.checklist.type.addRow": "Nytt punkt",
        "quality.checklist.type.deleteRowConfirm": "Slette dette punktet?",
        "quality.checklist.type.customFieldsTitle": "Egendefinerte felt",
        "quality.checklist.type.customFieldsHint":
            "Legg til inndatafelt som må fylles ut ved utføring av dette punktet (f.eks. målt strøm, gjenvinningstall).",
        "quality.checklist.type.customFieldLabel": "Etikett",
        "quality.checklist.type.customFieldType": "Type",
        "quality.checklist.type.customFieldUnit": "Enhet",
        "quality.checklist.type.customFieldPlaceholder": "Plassholdertekst",
        "quality.checklist.type.customFieldRequired": "Påkrevd",
        "quality.checklist.type.customFieldAdd": "Legg til felt",
        "quality.checklist.type.customFieldTypes.text": "Tekst",
        "quality.checklist.type.customFieldTypes.number": "Tall",
        "quality.checklist.type.customFieldTypes.textarea": "Lang tekst",
        "quality.checklist.type.print": "Skriv ut mal (PDF)",
        "quality.checklist.type.print_failed": "Kunne ikke generere PDF",
        "quality.checklist.type.json.open_dialog": "JSON / AI",
        "quality.checklist.type.json.dialog_title": "JSON og AI for sjekklistetype",
        "quality.checklist.type.json.tab_json": "Lim inn JSON",
        "quality.checklist.type.json.tab_ai_guide": "AI-instruksjoner",
        "quality.checklist.type.json.hint": "Lim inn JSON fra ChatGPT eller annen AI, eller rediger eksisterende type. Støtter { \"items\": [...] } eller full type med title, description og default_response_actions.",
        "quality.checklist.type.json.replace_items": "Erstatt alle punkter",
        "quality.checklist.type.json.append_items": "Legg til nederst",
        "quality.checklist.type.json.copy_json": "Kopier JSON",
        "quality.checklist.type.json.reload_from_editor": "Last inn fra editor",
        "quality.checklist.type.json.insert_sample": "Sett inn eksempel",
        "quality.checklist.type.json.apply": "Bruk JSON",
        "quality.checklist.type.json.applied": "{{count}} punkter importert",
        "quality.checklist.type.json.copy_success": "JSON kopiert",
        "quality.checklist.type.json.reload_success": "JSON lastet inn fra editor",
        "quality.checklist.type.json.clipboard_failed": "Kunne ikke kopiere til utklippstavle",
        "quality.checklist.type.json.ai_guide_intro": "Kopier instruksjonene nedenfor til ChatGPT, Claude eller annen AI. Lim deretter JSON-svaret inn i fanen «Lim inn JSON».",
        "quality.checklist.type.json.copy_ai_guide": "Kopier AI-instruksjoner",
        "quality.checklist.type.json.ai_guide_copied": "AI-instruksjoner kopiert",
        "quality.checklist.type.json.generate_with_ai": "Generer med AI",
        "quality.checklist.type.json.ai_parse_error": "Kunne ikke lese AI-svar som JSON",
        "quality.checklist.type.json.ai_apply_success": "{{count}} punkter lagt inn fra AI",
        "quality.checklist.type.json.error_empty": "JSON-feltet er tomt",
        "quality.checklist.type.json.error_invalid_json": "Ugyldig JSON — sjekk syntaks",
        "quality.checklist.type.json.error_no_items_array": "Fant ingen items-array i JSON",
        "quality.checklist.type.json.error_no_valid_items": "Ingen gyldige punkter etter import",
        "quality.checklist.type.hse.title": "HMS-dokumentregister",
        "quality.checklist.type.hse.description":
          "Registrer sjekklistetypen som styrt skjema (SKJ) i HMS-dokumenter under valgt kapittel og bransje.",
        "quality.checklist.type.hse.register": "Legg til som HMS-dokument",
        "quality.checklist.type.hse.registered": "Registrert i HMS-dokumenter",
        "quality.checklist.type.hse.update_placement": "Oppdater plassering",
        "quality.checklist.type.hse.open_document": "Åpne HMS-dokument",
        "quality.checklist.type.hse.save_type_first": "Lagre sjekklistetypen først",
        "quality.checklist.type.hse.category_required": "Kategori er påkrevd",
        "quality.checklist.type.hse.register_failed": "Kunne ikke registrere i HMS-dokumenter",
        "quality.checklist.type.hse.settings_hint":
          "Registrer sjekklistetyper som HMS-dokumenter og velg plassering i dokumentstrukturen. Bruk dokumentikonet i listen for å konfigurere plassering.",
        "quality.checklist.type.hse.column": "HMS-dokument",
        "quality.checklist.type.hse.configure": "Konfigurer HMS-dokumentplassering",
        "quality.checklist.type.hse.configure_short": "HMS-plassering",
        "quality.checklist.type.hse.registered_short": "Registrert",
        "quality.checklist.type.hse.not_registered": "Ikke registrert",
        "quality.checklist.type.hse.create_checklist": "Opprett sjekkliste",
        "quality.checklist.type.hse.checklist_template_title": "Sjekklistemal",
        "quality.checklist.type.hse.checklist_template_description": "Dette dokumentet er koblet til en sjekklistetype. Opprett og fyll ut en ny sjekkliste basert på malen.",
        "quality.checklist.type.hse.checklist_created": "Sjekkliste opprettet",
        "quality.checklist.type.hse.create_failed": "Kunne ikke opprette sjekkliste",
        "quality.checklist.type.hse.preview_label": "Sjekklistemal (forhåndsvisning)",
        "quality.checklist.type.hse.preview_draft_version": "Forhåndsvisning av kladd revisjon {{version}}",
        "quality.checklist.type.hse.preview_empty": "Ingen sjekkpunkter i malen",
        "quality.checklist.type.hse.source_hse": "HMS-sjekkliste",
        "quality.checklist.type.hse.updated_checklist_available": "Oppdatert sjekkliste tilgjengelig",
        "quality.checklist.type.hse.updated_checklist_available_hint": "Sjekklistetypen er endret siden siste godkjente revisjon. Opprett en ny revisjon for å publisere endringene i HMS-dokumentet.",
        "quality.checklist.type.hse.create_revision": "Opprett revisjon",
        "quality.checklist.type.hse.document_needs_update": "Dokument må oppdateres",
        "quality.checklist.type.hse.document_needs_update_hint": "Endringer i sjekklistetypen vises ikke i HMS-dokumentet før du oppretter en ny revisjon.",
        "quality.checklist.type.hse.document_needs_update_create_hint": "Opprett revisjon for å ta med endringene i HMS-dokumentet. Du kan redigere sjekklisten her etterpå.",
        "quality.checklist.type.hse.document_needs_update_open_hint": "Sjekklisten er endret siden siste godkjente HMS-revisjon. Gå til dokumentet for å oppdatere kladdrevisjonen og sende til godkjenning.",
        "quality.checklist.type.hse.edit_checklist": "Rediger sjekkliste",
        "quality.checklist.type.hse.create_revision_and_edit_checklist": "Opprett revisjon og rediger sjekkliste",
        "quality.checklist.type.hse.revision_in_progress_title": "Revisjon under arbeid",
        "quality.checklist.type.hse.revision_in_progress_hint": "Rediger sjekklisten og send revisjonen til godkjenning når du er ferdig.",
        "quality.checklist.type.hse.revision_in_progress_stale_hint": "Sjekklisten er endret siden revisjonen ble opprettet. Oppdater revisjonen for å ta med endringene.",
        "quality.checklist.type.hse.revision_in_progress_edit_hint": "Rediger sjekklisten nedenfor. Gå tilbake til HMS-dokumentet for å sende revisjonen til godkjenning.",
        "quality.checklist.type.hse.view_draft_revision": "Vis kladd revisjon",
        "quality.checklist.type.hse.refresh_draft_revision": "Oppdater revisjon",
        "quality.checklist.type.hse.back_to_document": "Tilbake til HMS-dokument",
        "quality.checklist.type.hse.revision_created": "Revisjon opprettet",
        "quality.checklist.type.hse.revision_create_failed": "Kunne ikke opprette revisjon",
        "quality.checklist.type.hse.draft_snapshot_refreshed": "Kladdrevisjon oppdatert med gjeldende sjekkliste",
        "quality.checklist.type.hse.draft_snapshot_refresh_failed": "Kunne ikke oppdatere kladdrevisjon",
        "quality.checklist.type.hse.checklist_revision_summary": "Oppdatert sjekklistemal",
        "quality.checklist.gaps.complete": "{{resolved}} av {{total}} punkter utfylt",
        "quality.checklist.gaps.remaining": "{{count}} punkter gjenstår",
        "quality.checklist.gaps.toggle": "Vis gjenstående punkter",
        "quality.checklist.gaps.untitled": "Uten tittel",
        "quality.checklist.gaps.unanswered": "Ikke besvart",
        "quality.checklist.gaps.documents": "Mangler dokumentasjon",
        "quality.checklist.gaps.missing": "Mangler",
        "quality.checklist.gaps.statusDone": "Ferdig",
        "quality.checklist.gaps.statusOpen": "Åpen",
        "quality.checklist.selector.title": "Velg sjekkliste",
        "quality.checklist.selector.confirm": "Bekreft",
        "quality.checklist.selector.mode_heading": "Velg sjekkliste type",
        "quality.checklist.selector.mode_empty": "Ny tom sjekkliste",
        "quality.checklist.selector.mode_empty_hint": "Opprett en helt ny og tom sjekkliste",
        "quality.checklist.selector.mode_copy": "Kopier fra eksisterende",
        "quality.checklist.selector.mode_copy_hint": "Kopier punkter fra {{source}}",
        "quality.checklist.selector.mode_type": "Fra sjekklistetype",
        "quality.checklist.selector.mode_type_hint": "Velg en sjekklistetype og hvilke punkter som skal inkluderes",
        "quality.checklist.selector.title_label": "Tittel på sjekkliste",
        "quality.checklist.selector.title_placeholder": "Tittel settes automatisk hvis du velger type",
        "quality.checklist.selector.copy_from": "Kopierer fra: {{source}}",
        "quality.checklist.selector.copy_source": "kilde",
        "quality.checklist.selector.copy_all": "Alle punkter ({{count}})",
        "quality.checklist.selector.copy_non_approved": "Kun ikke-godkjente punkter ({{count}})",
        "quality.checklist.selector.type_guidance": "Anbefalt: sjekklistetyper som er knyttet til godkjent HMS-dokument. Andre typer kan fortsatt brukes, men er ikke en del av godkjent revisjon.",
        "quality.checklist.selector.search_placeholder": "Søk etter sjekklistetype…",
        "quality.checklist.selector.choose_type": "Velg sjekklistetype",
        "quality.checklist.selector.choose_type_first": "Velg sjekklistetype til venstre",
        "quality.checklist.selector.choose_type_first_hint": "Sjekklistepunktene vises her og kan krysses av.",
        "quality.checklist.selector.choose_items": "Velg punkter fra «{{title}}»",
        "quality.checklist.selector.no_types": "Ingen sjekklistetyper tilgjengelig",
        "quality.checklist.selector.no_search_results": "Ingen treff på søket",
        "quality.checklist.selector.no_items_in_type": "Ingen punkter i denne sjekklistetypen",
        "quality.checklist.selector.points": "punkter",
        "quality.checklist.selector.select_all": "Velg alle",
        "quality.checklist.selector.deselect_all": "Fjern alle",
        "quality.checklist.selector.items_selected": "{{selected}} av {{total}} punkter valgt",
        "quality.checklist.selector.status_unlinked": "Ikke HMS-dokument",
        "quality.checklist.selector.status_hse_linked": "HMS-dokument",
        "quality.checklist.selector.status_hse_approved": "Godkjent – rev. {{version}}",
        "quality.checklist.selector.status_hse_pending": "HMS venter godkjenning (rev. {{version}})",
        "quality.checklist.selector.status_hse_pending_short": "HMS venter godkjenning",
        "quality.checklist.selector.status_hse_draft": "HMS kladd (rev. {{version}})",
        "quality.checklist.selector.status_hse_draft_short": "HMS kladd",
        "quality.checklist.selector.load_error": "Kunne ikke laste sjekklistetyper",
        "quality.checklist.selector.items_load_error": "Kunne ikke laste sjekklistepunkter",
        "quality.checklist.selector.select_one_item": "Velg minst ett sjekklistepunkt",
        "quality.checklist.selector.copy_no_items": "Ingen punkter å kopiere",
        "quality.checklist.selector.context_heading": "Sjekklistedetaljer",
        "quality.checklist.selector.context_date_required": "Dato må fylles ut",
        "quality.checklist.selector.context_customer_required": "Kunde må velges",
        "quality.checklist.selector.context_project_required": "Prosjekt må velges",
        "quality.checklist.selector.context_responsible_required": "Ansvarlig må velges",
        "quality.checklist.actions.performed": "Utført",
        "quality.checklist.actions.approved": "Godkjent",
        "quality.checklist.actions.na": "Ikke aktuelt",
        "quality.checklist.actions.deviation": "Avvik",
        "quality.checklist.item.title": "Tittel",
        "quality.checklist.item.guidanceTitle": "Veiledning",
        "quality.checklist.item.completionNote": "Notater / observert",
        "quality.checklist.item.deviationNoteRequired": "Legg inn en kort forklaring på avviket.",
        "quality.checklist.item.responseLabel": "Utfall",
        "quality.checklist.item.customFieldsTitle": "Målinger / data",
        "quality.checklist.item.customFieldRequired": "Dette feltet er påkrevd",
        "quality.checklist.item.customFieldsRequiredBeforeOutcome":
            "Fyll ut påkrevde felt før du velger utfall.",
        "quality.checklist.item.saving": "Lagrer…",
        "quality.checklist.item.savePending": "Endringer venter…",
        "quality.checklist.item.saved": "Lagret",
        "quality.checklist.item.saveError": "Lagring feilet",
        "quality.checklist.item.saveFailed": "Kunne ikke lagre endring",
        "quality.checklist.item.close": "Lukk",
        "quality.checklist.item.savingClose": "Lagrer…",
        "report.type.required": "Rapporttype er påkrevd",

        "report.dev.title": "Dev",
        "report.dev.variables_v2": "Variabler V2",
        "report.dev.variables_v2_desc": "Rediger rapportvariabler (gruppert editor)",

        "report.variables.legacy.headingOnly": "Variabler",
        "report.variables.legacy.headingTagged": "Variabler (Legacy)",
        "report.variables.legacy.saving": "Lagrer...",
        "report.variables.legacy.save": "Lagre variabler",
        "report.variables.orphaned.title": "Ufullstendige hovedvariabler",
        "report.variables.orphaned.body":
          "Disse variablene er markert som hovedvariabler men mangler type gruppe. De bør knyttes til en type gruppe eller slettes.",
        "report.variables.ungrouped.heading": "Variabler uten gruppe",
        "report.variables.groups.heading": "Grupper",
        "report.variables.newSystem.title": "Variabler",
        "report.variables.createTypeGroup": "Opprett type gruppe",
        "report.variables.createGroup": "Opprett gruppe",
        "report.variables.sketch.tablist": "Variabler (skisse)",
        "report.variables.sketch.groupTablist": "Grupper og hovedoversikt",
        "report.variables.sketch.navGroupLabel": "Gruppe",
        "report.variables.sketch.navVariableTypeLabel": "Variabeltype",
        "report.variables.sketch.typeTablist": "Variabeltyper",
        "report.variables.sketch.noTypesInGroup": "Ingen variabeltyper her ennå.",
        "report.variables.sketch.ungroupedTab": "Uten gruppe",
        "report.variables.sketch.ungroupedTabSub": "{{count}} variabeltyper",
        "report.variables.sketch.pickVariableType": "Velg en variabeltype i fanen over.",
        "report.variables.sketch.addGroup": "Legg til gruppe",
        "report.variables.sketch.groupNoTypes": "Ingen typegrupper",
        "report.variables.sketch.unitsNotSet": "Måleenhet ikke satt",
        "report.variables.sketch.untitledGroup": "Uten navn",
        "report.variables.sketch.measureLabel": "Mål",
        "report.variables.sketch.projectedShort": "Prosj.",
        "report.variables.sketch.variableTypeFallback": "Variabeltype",
        "report.variables.sketch.tabOrphaned": "Ufullstendige",
        "report.variables.sketch.tabOrphanedSub": "{{count}} hovedvariabler",
        "report.variables.sketch.tabLegacySub": "Eldre format",
        "report.variables.sketchTab.legacy": "Eldre",
        "report.variables.sketch.emptyAll":
          "Ingen grupper eller løse variabeltyper ennå. Bruk knappene over for å opprette.",
        "report.variables.sketch.groupTabEmpty":
          "Ingen typegrupper i denne fanen ennå. Legg til hovedvariabel.",
        "report.variables.sketch.editGroup": "Rediger gruppe",
        "report.variables.sketch.addMainVariable": "Hovedvariabel",
        "report.variables.sketch.addAnotherMainVariable": "Legg til ny hovedvariabel i gruppen",
        "report.variables.sketch.typeGroupUngrouped": "Type-gruppe (uten gruppe)",
        "report.variables.sketch.deleteGroupAria": "Slett gruppe",
        "report.variables.sketch.structureMenuTrigger": "Gruppe og struktur",
        "report.variables.sketch.structureMenuAria": "Gruppe og struktur — flere handlinger",
        "report.variables.sketch.deleteGroupMenu": "Slett gruppe",
        "report.variables.sketch.addVariable": "Legg til variabel",
        "report.variables.sketch.addBulkVariables": "Legg til bulk variabel",
        "report.variables.sketch.editTypeGroupAria": "Rediger variabeltype",
        "report.variables.sketch.deleteTypeGroupAria": "Slett variabeltype",
        "report.variables.sketch.typeGroupMoreAria": "Flere handlinger for variabeltype",
        "report.variables.sketch.editTypeGroupMenu": "Rediger variabeltype",
        "report.variables.sketch.deleteTypeGroupMenu": "Slett variabeltype",
        "report.variables.sketch.measurements": "Målinger",
        "report.variables.sketch.editVariable": "Rediger",
        "report.variables.sketch.editVariableAria": "Rediger variabel",
        "report.variables.sketch.deleteVariable": "Slett",
        "report.variables.sketch.deleteVariableAria": "Slett variabel",
        "report.variables.sketch.variableRowMenuAria": "Handlinger for variabel",
        "report.variables.sketch.noSubvariablesYet": "Ingen variabler ennå",
        "report.variables.sketch.actionSheetClose": "Lukk",
        "report.variables.sketch.openVariableActionsAria": "Vis handlinger for variabel",
        "report.variables.sketch.variableActionsTitle": "Variabel",
        "report.variables.sketch.variableActionsHint": "Velg en handling under.",
        "report.variables.sketch.rowProjected": "Prosjektert:",
        "report.variables.sketch.rowPreMeasurement": "Før-måling:",
        "report.variables.sketch.rowMeasured": "Målt:",
        "report.variables.sketch.globalTotalsHeading": "Total pr. variabeltype (alle grupper)",
        "report.variables.sketch.globalStatTotalLabel": "Total",
        "report.variables.sketch.globalSumPre": "Før-mål (total)",
        "report.variables.sketch.globalSumMeasured": "Målt (total)",
        "report.variables.sketch.tabSumProjected": "Σ Prosj.",
        "report.variables.sketch.tabSumPre": "Σ Før",
        "report.variables.sketch.tabSumMeasured": "Σ Målt",
        "report.variables.sketch.cardTotalPrefix": "TOTAL",
        "report.variables.sketch.totalsProjRow": "Proj. total",
        "report.variables.sketch.totalsPreRow": "Pre total",
        "report.variables.sketch.totalsMeasRow": "Målt total",
        "report.variables.sketch.newGroup": "Ny gruppe",
        "report.variables.sketch.typeGroupShort": "Type-gruppe",
        "report.variables.sketch.tableColVariable": "Variabel",
        "report.variables.sketch.tableColProj": "Proj.",
        "report.variables.sketch.tableColPre": "Pre",
        "report.variables.sketch.tableColMeas": "Målt",
        "report.variables.sketch.tableColLsSuffix": "(l/s)",
        "report.variables.sketch.bulkAddShort": "Bulk-add",
        "report.variables.sketch.fabNoType": "Opprett en type-gruppe før du legger til variabler.",
        "report.variables.sketch.statusMeasuredOnly": "Målt",
        "report.variables.sketch.statusGood": "God",
        "report.variables.sketch.statusCheck": "Sjekk",
        "report.variables.sketchEditor.statusMeasured": "Målt",
        "report.variables.sketchEditor.statusGood": "God match",
        "report.variables.sketchEditor.statusGoodSub": "Målt verdi er innenfor akseptabelt område",
        "report.variables.sketchEditor.statusCheck": "Sjekk avvik",
        "report.variables.sketchEditor.statusCheckSub": "Målt avviker mer enn 15 % fra prosjektert",
        "report.variables.sketchEditor.refRequired": "Referanse er påkrevd",
        "report.variables.sketchEditor.saveError": "Kunne ikke lagre",
        "report.variables.sketchEditor.measureError": "Kunne ikke lagre måling",
        "report.variables.sketchEditor.saved": "Lagret",
        "report.variables.sketchEditor.noGroup": "Uten gruppe",
        "report.variables.sketchEditor.measuredActual": "Målt (faktisk)",
        "report.variables.sketchEditor.cancel": "Avbryt",
        "report.variables.sketchEditor.saving": "Lagrer…",
        "report.variables.sketchEditor.saveChanges": "Lagre endringer",
        "report.variables.sketchEditor.deleteSubvariable": "Slett undervariabel",
        "report.variables.sketchEditor.deleteSubvariableHint":
          "Sletting gjelder kun denne undervariabelen. Hovedvariabel og type-gruppe beholdes.",
        "report.variables.sketchEditor.deleteSubvariableConfirm":
          "Er du sikker på at du vil slette undervariabelen «{{reference}}»? Målinger og verdier slettes permanent.",
        "report.variables.sketchEditor.subvariableDeleted": "Undervariabel slettet",
        "report.variables.sketchEditor.subvariableDeleteError": "Kunne ikke slette variabel",
        "report.variables.sketchEditor.deleteSubvariableCancel": "Avbryt",
        "report.variables.sketchEditor.deleteSubvariableWorking": "Sletter…",
        "report.variables.sketchEditor.deleteSubvariableConfirmAction": "Slett permanent",
        "report.variables.sketchEditor.measuredHint":
          "Oppdaterer siste måling ved lagring. Bruk «Legg til måling» under for å registrere flere målepunkter.",
        "report.variables.sketchEditor.addMeasurementHeading": "Legg til ny måling",
        "report.variables.sketchEditor.addMeasurementValue": "Målingsverdi",
        "report.variables.sketchEditor.addMeasurementButton": "Legg til",
        "report.variables.sketchEditor.addingMeasurement": "Legger til…",
        "report.variables.sketchEditor.measurementAdded": "Måling lagt til",
        "report.variables.sketchEditor.measurementInvalid": "Oppgi en gyldig målingsverdi",
        "report.variables.sketchEditor.historyHeading": "Målingshistorikk ({{count}})",
        "report.variables.sketchEditor.historyLoading": "Laster målinger…",
        "report.variables.sketchEditor.historyEmpty": "Ingen målinger registrert",
        "report.variables.sketchEditor.historyLoadError": "Kunne ikke laste målinger",
        "report.variables.sketchEditor.historyColValue": "Verdi",
        "report.variables.sketchEditor.historyColDate": "Dato/tid",
        "report.variables.sketchEditor.tabMeasurements": "Målinger",
        "report.variables.sketchEditor.tabDetails": "Verdier",
        "report.variables.sketchEditor.tabsAria": "Rediger variabel — faner",
        "report.variables.sketchEditor.measurementsIntro": "Registrer ny måling eller se historikk.",
        "report.variables.sketchEditor.detailsIntro": "Referanse og felt som lagres sammen.",
        "report.variables.sketchEditor.goToDetails": "Rediger referanse og øvrige verdier →",
        "report.variables.sketchEditor.close": "Lukk",
        "report.variables.sketchEditor.addMeasurementPlaceholder": "Verdi",
        "report.variables.sketchEditor.measuredHintDetails":
          "Oppdaterer siste måling hvis du lagrer en ny verdi her. Nye målepunkter legger du til under Målinger.",
        "report.variables.measurementDialog.title": "Målinger",
        "report.variables.measurementDialog.variableFallback": "Variabel",
        "report.variables.measurementDialog.contextHeading": "Grunnlag",
        "report.variables.measurementDialog.reference": "Referanse",
        "report.variables.measurementDialog.measurementUnit": "Måleenhet",
        "report.variables.measurementDialog.projectedUnit": "Prosjektert enhet",
        "report.variables.measurementDialog.projectedLabel": "Prosjektert",
        "report.variables.measurementDialog.preMeasurementLabel": "Før-måling",
        "report.variables.measurementDialog.latestHeading": "Siste måling",
        "service Agreement": "Serviceavtale",
        "project": "Prosjekt",
        "project_plan": "Prosjektplan",
        "projects_plan": "Prosjektplan",
        "projects_accounting": "Prosjektregnskap",
        "project.details": "Prosjektdetaljer",
        "project.manager": "Prosjektleder",
        "project.view.customer": "Kunde",
        "project.view.copy_title": "Kopier til utklippstavle",
        "project.view.mobileActions.ariaLabel": "Hurtigvalg for prosjekt",
        "project.view.mobileNav.ariaLabel": "Prosjektnavigasjon",
        "project.view.mobileNav.project": "Prosjekt",
        "project.view.mobileNav.tabs": "Faner",
        "project.view.mobileNav.workOrders": "Arbeidsordre",
        "project.view.mobileNav.drawings": "Tegninger",
        "project.view.mobileNav.folders": "Mapper",
        "project.view.mobileNav.takePhoto": "Ta bilde",
        "project.view.mobileNav.contactsTitle": "Prosjektkontakter",
        "project.view.mobileNav.more": "Mer",
        "project.view.quickActions.title": "Hurtighandlinger",
        "project.view.quickActions.ariaLabel": "Prosjekthurtighandlinger",
        "project.view.mobileActions.openActions": "Åpne hurtigvalg",
        "project.view.mobileActions.closeActions": "Lukk hurtigvalg",
        "project.view.mobileActions.actionsTitle": "Hurtigvalg",
        "project.view.mobileActions.tabsTitle": "Prosjektfaner",
        "project.actions.new_deviation": "Nytt avvik",
        "project.actions.new_deviation_short": "Avvik",
        "project.actions.new_deviation_description": "Opprett et nytt avvik for dette prosjektet",
        "project.actions.new_checklist_short": "Sjekkliste",
        "project.actions.print_label": "Skriv ut etikett",
        "project.actions.service_report": "Servicerapport",
        "project.actions.service_report_short": "Rapport",
        "project.actions.service_report_description": "Opprett servicerapport",
        "project.checklist.create": "Opprett sjekkliste",
        "project.checklist.create_description":
          "Opprett en ny sjekkliste for dette prosjektet",
        "project.checklist.default_title":
          "Prosjektsjekkliste #{{number}}{{suffix}}",
        "project.checklist.generic_title": "Sjekkliste #{{number}} ({{date}})",
        "project.checklist.title_required": "Tittel er påkrevd",
        "project.checklist.create_failed": "Kunne ikke opprette sjekkliste",
        "project.checklist.create_success": "Sjekkliste opprettet",
        "project.checklist.id_missing": "Fant ikke sjekkliste-ID",
        "project.tabs.updates": "Oppdatering",
        "project.actions.work_order": "Arbeidsordre",
        "project.actions.work_order_short": "Arbeidsordre",
        "project.actions.work_order_description": "Opprett ny arbeidsordre",
        "project.actions.new_folder": "Ny mappe",
        "project.actions.new_folder_short": "Mappe",
        "project.actions.new_folder_description": "Opprett ny mappe for prosjektet",
        "project.actions.register_hours": "Registrer timer",
        "project.actions.register_hours_short": "Timer",
        "project.actions.register_hours_description": "Gå til timeregistrering for prosjektet",
        "documentUpload.direct.buttonShort": "Kamera",
        "documentUpload.direct.tooltip": "Last opp bilder",
        "documentUpload.direct.imagesOnly": "Bare bildefiler kan lastes opp her.",
        "document_archive.tab": "Arkiv",
        "document_archive.brand": "Arkiv",
        "document_archive.project": "Prosjekt",
        "document_archive.project_archive": "Prosjektarkiv",
        "document_archive.all_files": "Alle filer",
        "document_archive.recent": "Nylig",
        "document_archive.folders": "Mapper",
        "document_archive.files": "Filer",
        "document_archive.upload": "Last opp",
        "document_archive.new_folder": "Ny mappe",
        "document_archive.search_placeholder": "Søk i filer og mapper",
        "document_archive.modified": "Endret",
        "document_archive.grid": "Rutenett",
        "document_archive.list": "Liste",
        "document_archive.col_name": "Navn",
        "document_archive.col_modified": "Endret",
        "document_archive.col_size": "Størrelse",
        "document_archive.open": "Åpne",
        "document_archive.share": "Del",
        "document_archive.location": "Plassering",
        "document_archive.status": "Status",
        "document_archive.select_file": "Velg en fil for å se detaljer",
        "document_archive.file_details": "Fildetaljer",
        "document_archive.empty_files": "Ingen filer i denne mappen ennå.",
        "document_archive.no_folders": "Ingen mapper ennå",
        "document_archive.files_count": "{{count}} filer",
        "document_archive.result_line": "{{files}} filer · {{folders}} mapper",
        "document_archive.storage_hint": "{{files}} filer i {{folders}} mapper",
        "document_archive.load_error": "Kunne ikke laste dokumenter",
        "document_archive.missing_file": "Denne filen har ingen nedlastingslenke",
        "document_archive.link_copied": "Lenke kopiert",
        "document_archive.copy_failed": "Kunne ikke kopiere lenken",
        "document_archive.download": "Last ned",
        "document_archive.download_failed": "Kunne ikke laste ned filen",
        "document_archive.delete": "Slett",
        "document_archive.delete_title": "Slette fil?",
        "document_archive.delete_confirm": "Slette «{{name}}»? Dette kan ikke angres.",
        "document_archive.deleted": "Fil slettet",
        "document_archive.delete_failed": "Kunne ikke slette filen",
        "document_archive.deleting": "Sletter…",
        "document_archive.share_unavailable": "Deling er ikke implementert ennå",
        "document_archive.edit_title": "Rediger tittel",
        "document_archive.title_required": "Tittel er påkrevd",
        "document_archive.title_saved": "Tittel lagret",
        "document_archive.title_save_failed": "Kunne ikke lagre tittelen",
        "document_archive.save": "Lagre",
        "document_archive.saving": "Lagrer…",
        "document_archive.cancel": "Avbryt",
        "document_archive.folder_title": "Navn",
        "document_archive.folder_title_placeholder": "Mappenavn",
        "document_archive.folder_title_required": "Navn er påkrevd",
        "document_archive.folder_description": "Beskrivelse",
        "document_archive.folder_description_placeholder": "Valgfritt",
        "document_archive.folder_create_root": "Oppretter en mappe i prosjektarkivet",
        "document_archive.folder_create_subfolder": "Oppretter en undermappe i gjeldende mappe",
        "document_archive.create_folder": "Opprett mappe",
        "document_archive.creating": "Oppretter…",
        "document_archive.folder_create_error": "Kunne ikke opprette mappen",
        "document_archive.folder_menu": "Mappehandlinger",
        "document_archive.rename_folder": "Endre navn",
        "document_archive.folder_access": "Tilgang",
        "document_archive.folder_renamed": "Mappenavn lagret",
        "document_archive.folder_rename_failed": "Kunne ikke endre mappenavn",
        "document_archive.delete_folder": "Slett mappe",
        "document_archive.delete_folder_title": "Slette mappe?",
        "document_archive.delete_folder_confirm": "Slette «{{name}}»? Filene flyttes til {{destination}} og slettes ikke.",
        "document_archive.delete_folder_confirm_children": "Slette «{{name}}» og {{count}} undermapper? Filene flyttes til {{destination}} og slettes ikke.",
        "document_archive.folder_delete_root": "prosjektets rot",
        "document_archive.folder_deleted": "Mappe slettet",
        "document_archive.folder_delete_failed": "Kunne ikke slette mappen",
        "document_archive.access": "Tilgang",
        "document_archive.access_project": "Alle med tilgang til prosjektet",
        "document_archive.access_project_hint": "Alle som kan åpne prosjektet kan se mappen og filene.",
        "document_archive.access_admins": "Kun prosjektadmin og systemadmin",
        "document_archive.access_admins_hint": "Bare prosjektadmin og systemadmin kan se mappen og filene.",
        "document_archive.access_inherited": "Undermapper arver tilgang fra en låst overordnet mappe.",
        "document_archive.access_saved": "Mappe-tilgang lagret",
        "document_archive.access_save_failed": "Kunne ikke lagre mappe-tilgang",
        "document_archive.page_kicker": "Arkiv",
        "document_archive.page_title": "Arkiv",
        "document_archive.back_to_project": "Tilbake til prosjektet",
        "document_archive.no_access": "Du har ikke tilgang til dette arkivet",
        "document_archive.not_found": "Kunne ikke laste prosjektet",
        "document_archive.upload_dialog_title": "Opplasting",
        "document_archive.upload_add_more": "Legg til flere filer",
        "document_archive.upload_remove": "Fjern",
        "document_archive.upload_title_placeholder": "Tittel (valgfritt)",
        "document_archive.upload_overall": "Totalt",
        "document_archive.upload_status": "Laster opp {{current}} av {{total}}",
        "document_archive.upload_done": "Opplasting fullført",
        "document_archive.upload_start": "Last opp",
        "document_archive.upload_uploading": "Laster opp…",
        "document_archive.upload_close": "Lukk",
        "project.edit": "Rediger prosjekt",
        "project.switcher.search": "Søk på navn, nummer eller kunde",
        "project.switcher.recent": "Nylige",
        "project.switcher.all": "Alle prosjekter",
        "project.switcher.projects": "Prosjekter",
        "project.switcher.results": "{{count}} treff",
        "project.switcher.empty": "Ingen prosjekter matcher «{{query}}»",
        "project.switcher.current": "Nåværende",
        "project.switcher.navigate": "↑↓ naviger",
        "project.switcher.open_key": "↵ åpne",
        "project.switcher.all_projects": "Alle prosjekter →",
        "project.switcher.switch": "Bytt prosjekt",
        "project.switcher.loading": "Laster prosjekter…",
        "project.create_guide.title": "Opprett prosjekt",
        "project.create_guide.subtitle": "Følg stegene for å sette opp et nytt prosjekt med de viktigste detaljene.",
        "project.create_guide.badge": "Guidet prosjekt-opprettelse",
        "project.create_guide.progress.step_label": "Steg",
        "project.create_guide.summary.step_label": "Oppsummering",
        "project.create_guide.step.basics": "Grunninfo",
        "project.create_guide.step.customer": "Kunde og org.",
        "project.create_guide.step.schedule": "Tidsplan og team",
        "project.create_guide.step.description": "Beskrivelse",
        "project.create_guide.basics.title": "Hva skal prosjektet hete?",
        "project.create_guide.basics.help": "Gi prosjektet et tydelig navn. Prosjektnummer kan tildeles automatisk.",
        "project.create_guide.customer.title": "Hvem gjelder prosjektet?",
        "project.create_guide.customer.help": "Knytt kunde, avdeling og leveringsadresse når det er relevant.",
        "project.create_guide.schedule.title": "Når og hvem leder prosjektet?",
        "project.create_guide.schedule.help": "Velg prosjektleder og sett startdato. Sluttdato er valgfri.",
        "project.create_guide.description.title": "Legg til en kort beskrivelse",
        "project.create_guide.description.help": "Valgfri kontekst for teamet. Du kan alltid redigere dette senere.",
        "project.create_guide.field.name": "Prosjektnavn",
        "project.create_guide.field.use_next_number": "Bruk neste ledige prosjektnummer",
        "project.create_guide.field.project_number": "Prosjektnummer",
        "project.create_guide.field.customer": "Kunde",
        "project.create_guide.field.department": "Avdeling",
        "project.create_guide.field.delivery_address": "Leveringsadresse",
        "project.create_guide.field.project_manager": "Prosjektleder",
        "project.create_guide.field.start_date": "Startdato",
        "project.create_guide.field.end_date": "Sluttdato",
        "project.create_guide.field.description": "Beskrivelse",
        "project.create_guide.validation.name_required": "Prosjektnavn må fylles ut",
        "project.create_guide.validation.start_date_required": "Startdato må fylles ut",
        "project.create_guide.validation.project_manager_required": "Prosjektleder må velges",
        "project.create_guide.validation.end_before_start": "Sluttdato må være på eller etter startdato",
        "project.create_guide.summary.title": "Se over og opprett",
        "project.create_guide.summary.help": "Kontroller detaljene under før du oppretter prosjektet.",
        "project.create_guide.summary.auto_number": "Tildeles automatisk",
        "project.create_guide.summary.not_set": "Ikke satt",
        "project.create_guide.summary.selected": "Valgt",
        "project.create_guide.cancel": "Avbryt",
        "project.create_guide.back": "Tilbake",
        "project.create_guide.next": "Neste",
        "project.create_guide.review": "Oppsummering",
        "project.create_guide.create": "Opprett prosjekt",
        "project.create_guide.creating": "Oppretter…",
        "project.create_guide.success": "Prosjekt opprettet",
        "project.create_guide.error": "Kunne ikke opprette prosjekt",
        "project.overview.export_pdf": "Eksporter PDF",
        "project.overview.export_pdf_loading": "Eksporterer…",
        "project.overview.export_pdf_success": "PDF eksportert",
        "project.overview.export_pdf_error": "Kunne ikke eksportere PDF",
        "project.overview.details_subtitle": "Fakta og spesifikasjoner",
        "project.overview.fact.start": "Start",
        "project.overview.fact.end": "Slutt",
        "project.overview.fact.department": "Avdeling",
        "project.overview.fact.category": "Kategori",
        "project.overview.fact.description": "Beskrivelse",
        "project.overview.fact.number": "Prosjektnr.",
        "project.overview.fact.customer": "Kunde",
        "project.overview.fact.manager": "Prosjektleder",
        "project.overview.facts.title": "Prosjektdetaljer",
        "project.overview.start_missing": "Startdato mangler",
        "project.overview.end_unset": "Ikke satt",
        "project.overview.hours_progress": "Timeforbruk",
        "project.overview.hours_unit": "timer",
        "project.overview.no_budget_hours": "Ingen budsjettimer satt",
        "project.overview.stats.hours": "Timer",
        "project.overview.stats.view_time_overview": "Se timeoversikt",
        "project.overview.stats.load_error": "Nøkkeltallene kunne ikke hentes.",
        "project.overview.stats.deviations": "Avvik",
        "project.overview.stats.open_deviations": "Åpne avvik",
        "project.overview.stats.work_orders": "Arbeidsordre",
        "project.overview.stats.checklists": "Sjekklister",
        "project.overview.stats.note.critical": "{{count}} kritiske",
        "project.overview.stats.note.ongoing": "{{count}} pågår",
        "project.overview.stats.note.checklist_pct": "{{pct}} % fullført",
        "project.overview.stats.note.budget_pct": "{{pct}} % av budsjett",
        "project.overview.stats.note.no_budget": "Ingen budsjett",
        "project.overview.stats.note.none": "Ingen registrert",
        "project.overview.activity.title": "Siste aktivitet",
        "project.overview.activity.see_all": "Se alt →",
        "project.overview.activity.empty": "Ingen aktivitet ennå",
        "project.overview.activity.fallback": "Oppdatering",
        "project.overview.address.title": "Leveringsadresse",
        "project.overview.address.subtitle": "Prosjektets leveringssted",
        "project.overview.address.view_map": "Åpne i kart",
        "project.overview.address.map": "Kart",
        "project.overview.address.edit": "Rediger adresse",
        "project.overview.address.address": "Adresse",
        "project.overview.address.city": "Sted",
        "project.overview.address.postal": "Postnummer",
        "project.overview.address.country": "Land",
        "project.overview.address.contact": "Kontaktperson",
        "project.overview.address.missing": "Adresse ikke satt",
        "project.overview.address.missing_city": "Sted ikke satt",
        "project.overview.team.title": "Team",
        "project.overview.team.manage": "Administrer",
        "project.overview.team.project_manager": "Prosjektleder",
        "project.overview.team.empty": "Ingen deltakere ennå",
        "project.palette.trigger": "Søk",
        "project.palette.placeholder": "Søk i prosjektet eller kjør en handling…",
        "project.palette.actions_heading": "Handlinger",
        "project.palette.searching": "Søker…",
        "project.palette.no_results": "Ingen treff for «{{query}}»",
        "project.palette.module.document": "Dokumenter",
        "project.palette.module.folder": "Mapper",
        "project.palette.module.deviation": "Avvik",
        "project.palette.module.checklist": "Sjekklister",
        "project.palette.module.report": "Rapporter",
        "project.palette.module.work_order": "Arbeidsordre",
        "project.palette.module.action": "Handlinger",
        "project.fab.open": "Nytt",
        "project.fab.close": "Lukk",
        "absence": "Fravær",
        "Week": "Uke",
        "Day": "Dag",
        "Period": "Periode",
        "Filters": "Filtre",
        "Project Filter": "Prosjektfilter",
        "Activity Filter": "Aktivitetsfilter",
        "All Projects": "Alle prosjekter",
        "All Activities": "Alle aktiviteter",
        "Clear Filters": "Tøm filtre",
        "No hours recorded for this day":
          "Ingen timer registrert for denne dagen",
        "entries": "oppføringer",
        "Loading hours...": "Laster timer...",
        "already_registered_hours_for_event": "Allerede registrert timer på dette event",
        "dashboard_report.status.planned": "Planlagt",
        "dashboard.stats.eyebrow": "Dashboard",
        "dashboard.stats.title": "Statusoversikt",
        "dashboard.stats.tap_hint": "Trykk for å se alle tall og detaljer",
        "dashboard.stats.detail_title": "Statusoversikt",
        "dashboard.stats.detail_intro": "Oversikt over åpne oppgaver og nøkkeltall. Trykk på et kort for å gå til modulen.",
        "dashboard.stats.reports": "Rapporter",
        "dashboard.stats.report_agreements": "Rapportavtaler",
        "dashboard.stats.cases": "Saker",
        "dashboard.stats.deviations": "Avvik",
        "dashboard.stats.projects": "Prosjekter",
        "dashboard.stats.kilometers": "Kilometer",
        "dashboard.stats.reports_not_finished": "Ikke ferdigstilt",
        "dashboard.stats.reports_finished": "Ferdigstilt",
        "dashboard.stats.reports_agreement_not_confirmed": "Ikke bekreftet",
        "dashboard.stats.reports_not_approved": "Ikke godkjent",
        "dashboard.stats.cases_open": "Åpne",
        "dashboard.stats.deviations_open": "Venter behandling",
        "dashboard.stats.deviations_assigned": "Tildelt deg",
        "dashboard.stats.projects_open": "Under utførelse",
        "dashboard.stats.this_month": "Denne måneden",

        "company_guide.badge": "Bedriftsguide",
        "company_guide.hours.title": "Timeregistrering, fravær og arbeidsplan",
        "company_guide.hours.subtitle":
          "Sjekkliste for administratorer med Timer-modulen (vises på brukerguiden for timer).",
        "company_guide.hours.progress_label": "Status",
        "company_guide.hours.progress_loading": "Laster…",
        "company_guide.hours.progress_error": "Kunne ikke hente status. Prøv å oppdatere siden.",
        "company_guide.hours.progress_summary_ok": "{{done}} av {{total}} anbefalte steg er på plass.",
        "company_guide.hours.progress_summary_warnings":
          "{{done}} av {{total}} anbefalte steg er på plass. {{warnings}} punkt(er) trenger fortsatt oppmerksomhet.",
        "company_guide.hours.footer_hint":
          "Legacy Activity/ActivityItem brukes i hovedsak mot Tripletex-synk, ikke som primær timeføring i Promang.",
        "company_guide.hours.footer_link_settings": "Åpne Timer → Innstillinger",
        "company_guide.hours.link.scroll_to_explanation": "Les forklaringen under",
        "company_guide.hours.link.settings_section": "Åpne i innstillinger",
        "company_guide.hours.link.work_schedule": "Åpne tidsplan",
        "company_guide.hours.task.registration_model.title": "Timeregistrering og prosjektlinjer",
        "company_guide.hours.task.registration_model.info":
          "Timer på prosjekt krever project_activity på prosjektet. Activity/ActivityItem er utdatert som valg i UI og brukes ved synk mot Tripletex.",
        "company_guide.hours.task.absence_types.title": "Fraværstyper",
        "company_guide.hours.task.absence_types.ok": "{{count}} fraværstype(r) er definert.",
        "company_guide.hours.task.absence_types.warn":
          "Opprett fraværstyper som matcher bedriftens behov (ferie, syk, avspasering …).",
        "company_guide.hours.task.absence_types.unknown": "Kunne ikke verifisere fraværstyper automatisk.",
        "company_guide.hours.task.handlers.title": "Ansvar for timer og fravær",
        "company_guide.hours.task.handlers.ok": "Timer- og fraværsansvarlig er satt.",
        "company_guide.hours.task.handlers.warn":
          "Sett hvem som behandler timelister og egenmeldinger, så ansatte vet hvem som følger opp.",
        "company_guide.hours.task.work_schedule.title": "Arbeidsplan og stillingsbrøk",
        "company_guide.hours.task.work_schedule.info":
          "Sørg for at ansatte har arbeidsplan som stemmer med stilling; det påvirker planlagte timer og fravær.",
        "company_guide.hours.task.work_schedule.ok": "Arbeidsplaner er opprettet og ansatte er koblet til.",
        "company_guide.hours.task.work_schedule.warn_none": "Opprett minst én arbeidsplan for firmaet.",
        "company_guide.hours.task.work_schedule.warn_unassigned":
          "{{count}} aktiv(e) ansatt(e) mangler arbeidsplan (tidsplan).",
        "company_guide.hours.link.work_schedule_admin": "Administrer arbeidsplaner",

        "company_guide.company.badge": "Bedriftsguide",
        "company_guide.company.heading": "Grunnleggende firmainnstillinger",
        "company_guide.company.subtitle":
          "Logo, kontakt, adresser og salgsbetingelser gir trygghet i kundedialog, tilbud og netthandel.",
        "company_guide.company.progress_label": "Status",
        "company_guide.company.progress_loading": "Laster…",
        "company_guide.company.progress_error": "Kunne ikke hente firmadata. Prøv å oppdatere siden.",
        "company_guide.company.progress_ok": "{{done}} av {{total}} anbefalte punkt er på plass.",
        "company_guide.company.progress_warnings":
          "{{done}} av {{total}} anbefalte punkt er på plass. {{warnings}} trenger oppmerksomhet.",
        "company_guide.company.footer_hint":
          "Endringer gjør du under Firma → Innstillinger. Sjekklisten oppdateres når du lagrer.",
        "company_guide.company.link.settings": "Åpne firmainnstillinger",
        "company_guide.company.task.name.title": "Firmanavn og organisasjon",
        "company_guide.company.task.name.warn": "Firmanavn eller organisasjonsnummer mangler eller er ufullstendig.",
        "company_guide.company.task.name.ok": "Navn og org.nr ser ut til å være registrert.",
        "company_guide.company.task.logo.title": "Logo",
        "company_guide.company.task.logo.warn": "Legg inn logo for dokumenter, tilbud og kundevisning.",
        "company_guide.company.task.logo.ok": "Logo er registrert.",
        "company_guide.company.task.contact.title": "Kontaktinformasjon",
        "company_guide.company.task.contact.warn": "Oppgi minst én av e-post, telefon eller mobil.",
        "company_guide.company.task.contact.ok": "Minst én kontaktkanal er satt.",
        "company_guide.company.task.address.title": "Adresse",
        "company_guide.company.task.address.warn": "Legg inn forretningsadresse eller postadresse.",
        "company_guide.company.task.address.ok": "Adresse er registrert.",
        "company_guide.company.task.sales_conditions_url.title": "Salgsbetingelser (URL)",
        "company_guide.company.task.sales_conditions_url.warn": "Lenke til salgsbetingelser mangler — viktig for tilbud og netthandel.",
        "company_guide.company.task.sales_conditions_url.ok": "Lenke til salgsbetingelser er satt.",
        "company_guide.company.task.vat.title": "MVA / org.nr",
        "company_guide.company.task.vat.warn": "Organisasjonsnummer / MVA-felt bør være utfylt.",
        "company_guide.company.task.vat.ok": "Org.nr / MVA er registrert.",

        "dashboard.company_guide.alert_company_title": "Firmaprofil trenger oppmerksomhet",
        "dashboard.company_guide.alert_company_subtitle":
          "{{count}} punkt i firmaguiden bør ryddes opp i.",
        "dashboard.company_guide.alert_hours_title": "Timer-oppsett trenger oppmerksomhet",
        "dashboard.company_guide.alert_hours_subtitle":
          "{{count}} punkt i timer-guiden bør ryddes opp i.",
        "dashboard.company_guide.alert_hse_title": "HMS-oppsett trenger oppmerksomhet",
        "dashboard.company_guide.alert_hse_subtitle":
          "{{count}} punkt i HMS-guiden bør ryddes opp i.",
        "dashboard.company_guide.alert_offers_title": "Tilbudsoppsett trenger oppmerksomhet",
        "dashboard.company_guide.alert_offers_subtitle":
          "{{count}} anbefalt funksjon i tilbudsmodulen er slått av.",
        "dashboard.company_guide.alert_cta": "Åpne guide og sjekkliste",

        "user_guide.hub.card.company.title": "Firma og innstillinger",
        "user_guide.hub.card.company.description":
          "Logo, kontakt, adresser, salgsbetingelser og annet som bør være på plass.",

        "user_guide.company.back_to_hub": "Tilbake til brukerguiden",
        "user_guide.company.badge": "Firma",
        "user_guide.company.title": "Firmainnstillinger og profil",
        "user_guide.company.intro":
          "Riktig firmainformasjon gir trygghet mot kunder, i tilbud og i integrasjoner. Som administrator bør du gjennomføre sjekklisten under og oppdatere det som mangler.",
        "user_guide.company.section.why.title": "Hvorfor dette er viktig",
        "user_guide.company.section.why.p1":
          "Logo og kontaktdetaljer vises der kunder og leverandører forventer et profesjonelt uttrykk.",
        "user_guide.company.section.why.p2":
          "Adresse og salgsbetingelser er ofte påkrevd i avtaler, netthandel og ved eksport av dokumenter.",
        "user_guide.company.section.where.title": "Hvor du gjør endringene",
        "user_guide.company.section.where.p1":
          "Gå til Firma → Innstillinger. Bruk lenkene i sjekklisten for å hoppe rett til riktig seksjon.",

        "user_guide.hub.card.profile.title": "Min profil og personopplysninger",
        "user_guide.hub.card.profile.description":
          "Mobilnummer, pårørende, fødselsnummer, kontonummer og barn — det som bør være på plass.",

        "user_guide.profile.back_to_hub": "Tilbake til brukerguiden",
        "user_guide.profile.badge": "Min profil",
        "user_guide.profile.title": "Personopplysninger og profil",
        "user_guide.profile.intro":
          "Noen funksjoner krever at du legger inn personopplysninger. Riktig mobilnummer, pårørende, fødselsnummer og kontonummer sørger for at lønn, fravær, HMS og kontakt fungerer som det skal. Gå gjennom sjekklisten under og fyll ut det som mangler.",
        "user_guide.profile.heading": "Dine personopplysninger",
        "user_guide.profile.subtitle":
          "Gjelder både ansatte og innleide. Fyll ut feltene under så fungerer Promang optimalt for deg.",
        "user_guide.profile.progress_label": "Status",
        "user_guide.profile.progress_loading": "Laster…",
        "user_guide.profile.progress_error": "Kunne ikke hente profildata. Prøv å oppdatere siden.",
        "user_guide.profile.progress_ok": "{{done}} av {{total}} påkrevde punkt er på plass.",
        "user_guide.profile.progress_warnings":
          "{{done}} av {{total}} påkrevde punkt er på plass. {{warnings}} trenger oppmerksomhet.",
        "user_guide.profile.footer_hint":
          "Endringer gjør du under Min profil. Sjekklisten oppdateres når du lagrer.",
        "user_guide.profile.link.profile": "Åpne min profil",
        "user_guide.profile.task.mobile.title": "Mobilnummer",
        "user_guide.profile.task.mobile.warn": "Legg inn mobilnummer så kollegaer og system når deg.",
        "user_guide.profile.task.mobile.ok": "Mobilnummer er registrert.",
        "user_guide.profile.task.next_of_kin.title": "Pårørende",
        "user_guide.profile.task.next_of_kin.warn":
          "Legg inn minst én pårørende — viktig ved hendelser og nødsituasjoner.",
        "user_guide.profile.task.next_of_kin.ok": "Pårørende er registrert.",
        "user_guide.profile.task.social_security.title": "Fødselsnummer",
        "user_guide.profile.task.social_security.warn":
          "Fødselsnummer kreves for arbeidsavtale, lønn og rapportering.",
        "user_guide.profile.task.social_security.ok": "Fødselsnummer er registrert.",
        "user_guide.profile.task.account_number.title": "Kontonummer",
        "user_guide.profile.task.account_number.warn":
          "Legg inn kontonummer for utbetaling av lønn og utlegg.",
        "user_guide.profile.task.account_number.ok": "Kontonummer er registrert.",
        "user_guide.profile.task.email_signature.title": "E-postsignatur",
        "user_guide.profile.task.email_signature.warn":
          "Legg inn signatur under Profil → E-post. Den settes inn når du sender e-post til kunden.",
        "user_guide.profile.task.email_signature.ok": "E-postsignatur er registrert.",
        "user_guide.profile.task.children.title": "Barn (valgfritt)",
        "user_guide.profile.task.children.info":
          "Valgfritt. Legg inn barn hvis du vil at det skal være registrert (f.eks. for omsorgsdager).",
        "user_guide.profile.task.children.ok": "Barn er registrert.",
        "user_guide.profile.section.why.title": "Hvorfor dette er viktig",
        "user_guide.profile.section.why.p1":
          "Mobilnummer og pårørende gjør at vi når deg eller dine nærmeste raskt hvis noe skjer på jobb.",
        "user_guide.profile.section.why.p2":
          "Fødselsnummer og kontonummer er nødvendig for arbeidsavtale, lønn og utbetalinger.",
        "user_guide.profile.section.where.title": "Hvor du gjør endringene",
        "user_guide.profile.section.where.p1":
          "Gå til Min profil. Bruk lenkene i sjekklisten for å hoppe rett til riktig sted.",

        "dashboard.user_guide.alert_profile_title": "Profilen din mangler opplysninger",
        "dashboard.user_guide.alert_profile_subtitle":
          "{{count}} punkt i profilen bør fylles ut.",
        "dashboard.user_guide.alert_cta": "Åpne guide og sjekkliste",

        "user_employment.work_schedule_label": "Arbeidsplan (timer)",
        "user_employment.work_schedule_hint":
          "Knyttes til timeregistrering, planlagt tid og fravær. Opprett planer under Timer → Arbeidsplaner.",
        "user_employment.work_schedule_none": "Ingen valgt",

        "work_schedules_admin.title": "Arbeidsplaner",
        "work_schedules_admin.intro":
          "Her oppretter og vedlikeholder du arbeidsplaner (timer per ukedag). Nye ansatte får siste opprettede plan som standard hvis du ikke velger annet.",
        "work_schedules_admin.summary_title": "Oversikt",
        "work_schedules_admin.summary_plans": "{{count}} arbeidsplan(er) i firmaet.",
        "work_schedules_admin.summary_unassigned_ok": "Alle aktive ansatte har arbeidsplan.",
        "work_schedules_admin.summary_unassigned_warn":
          "{{count}} aktiv(e) ansatt(e) mangler arbeidsplan — tildel under bruker/ansatt.",
        "work_schedules_admin.assign_hint": "Tildel plan på ansatt:",
        "work_schedules_admin.assign_link": "Brukere / ansatte",
        "work_schedules_admin.new": "Ny arbeidsplan",
        "work_schedules_admin.edit": "Rediger",
        "work_schedules_admin.delete": "Slett",
        "work_schedules_admin.save": "Lagre",
        "work_schedules_admin.saving": "Lagrer…",
        "work_schedules_admin.cancel": "Avbryt",
        "work_schedules_admin.field_name": "Navn (valgfritt)",
        "work_schedules_admin.field_name_placeholder": "F.eks. Kontor 7,5t",
        "work_schedules_admin.empty": "Ingen arbeidsplaner ennå — opprett én for å komme i gang.",
        "work_schedules_admin.unnamed": "Uten navn",
        "work_schedules_admin.confirm_delete": "Slette «{{name}}»? Kan ikke slettes hvis den er i bruk.",
        "work_schedules_admin.created": "Arbeidsplan opprettet",
        "work_schedules_admin.saved": "Arbeidsplan lagret",
        "work_schedules_admin.deleted": "Arbeidsplan slettet",
        "work_schedules_admin.load_error": "Kunne ikke hente arbeidsplaner",
        "work_schedules_admin.save_error": "Kunne ikke lagre",
        "work_schedules_admin.delete_error": "Kunne ikke slette",
        "work_schedules_admin.back_guide": "Tilbake til brukerguide (timer)",
        "work_schedules_admin.day.monday": "Mandag",
        "work_schedules_admin.day.tuesday": "Tirsdag",
        "work_schedules_admin.day.wednesday": "Onsdag",
        "work_schedules_admin.day.thursday": "Torsdag",
        "work_schedules_admin.day.friday": "Fredag",
        "work_schedules_admin.day.saturday": "Lørdag",
        "work_schedules_admin.day.sunday": "Søndag",

        "work_schedule_view.page_title": "Tidsplan",
        "work_schedule_view.fallback_title": "Arbeidsplan",
        "work_schedule_view.subtitle": "Timer per ukedag justert for stillingsprosent",
        "work_schedule_view.empty": "Ingen arbeidsplan er knyttet til deg som ansatt ennå.",
        "work_schedule_view.empty_hint": "Be en administrator opprette en plan og tildele den under din bruker/ansatt.",
        "work_schedule_view.link_users": "Gå til brukeroversikt",
        "work_schedule_view.day_off": "Fri",
        "work_schedule_view.hours_value": "{{hours}} timer",
        "work_schedule_view.day.monday": "Mandag",
        "work_schedule_view.day.tuesday": "Tirsdag",
        "work_schedule_view.day.wednesday": "Onsdag",
        "work_schedule_view.day.thursday": "Torsdag",
        "work_schedule_view.day.friday": "Fredag",
        "work_schedule_view.day.saturday": "Lørdag",
        "work_schedule_view.day.sunday": "Søndag",
        "work_schedule_view.holidays_title": "Røde dager",
        "work_schedule_view.holidays_subtitle": "Offentlige helligdager i Norge som gir fridag fra normal arbeidstid",
        "work_schedule_view.holidays_empty": "Ingen røde dager i valgt periode.",
        "hours.monthly_overview.gross_normal": "Brutto normaltid",
        "hours.monthly_overview.holiday_deduction": "Fratrekk røde dager",
        "hours.monthly_overview.absence_deduction": "Fratrekk fravær",
        "Lønnsgrunnlag": "Lønnsgrunnlag",
        "hours.payroll_basis.title": "Lønnsgrunnlag",
        "hours.payroll_basis.subtitle":
          "Grunnlag for lønn per ansatt i valgt måned. Kun godkjente timer inngår i summer og eksport.",
        "hours.payroll_basis.period": "Periode",
        "hours.payroll_basis.export_pdf": "Eksporter PDF",
        "hours.payroll_basis.export_zip": "Eksporter ZIP",
        "hours.payroll_basis.export_redownload": "Last ned på nytt",
        "hours.payroll_basis.export_coming_soon": "Eksport kommer i neste steg",
        "hours.payroll_basis.export_started": "Eksport startet — venter på ZIP…",
        "hours.payroll_basis.export_running": "Eksporterer…",
        "hours.payroll_basis.export_status": "Eksportstatus: {{status}}",
        "hours.payroll_basis.export_ready": "ZIP er klar og lastes ned.",
        "hours.payroll_basis.export_done_no_url": "Eksport ferdig, men nedlastingslenke mangler.",
        "hours.payroll_basis.export_failed": "Kunne ikke eksportere lønnsgrunnlag.",
        "hours.payroll_basis.export_timeout": "Eksport tok for lang tid. Prøv igjen.",
        "hours.payroll_basis.export_dialog_title": "Eksporter lønnsgrunnlag",
        "hours.payroll_basis.export_dialog_body":
          "Dette er et utkast. Velg om du vil ferdigstille før eksport, eller laste ned ZIP uten å låse perioden.",
        "hours.payroll_basis.export_dialog_finalize": "Finaliser og eksporter",
        "hours.payroll_basis.export_dialog_finalize_hint":
          "Setter status til ferdigstilt, deretter eksportert når ZIP er klar. Notater og summer låses.",
        "hours.payroll_basis.export_dialog_draft": "Eksporter utkast",
        "hours.payroll_basis.export_dialog_draft_hint":
          "Laster ned ZIP merket UTKAST. Status forblir utkast — du kan fortsette å redigere.",
        "hours.payroll_basis.export_dialog_cancel": "Avbryt",
        "hours.payroll_basis.action_create": "Opprett utkast",
        "hours.payroll_basis.action_refresh": "Oppdater utkast",
        "hours.payroll_basis.action_finalize": "Ferdigstill",
        "hours.payroll_basis.action_reopen": "Gjenåpne for redigering",
        "hours.payroll_basis.reopen_dialog_title": "Angre ferdigstilling?",
        "hours.payroll_basis.reopen_dialog_body":
          "Perioden blir utkast igjen og kan endres. Du kan oppdatere notater, hente nye tall og ferdigstille på nytt når du er klar.",
        "hours.payroll_basis.reopen_dialog_confirm": "Gjenåpne for redigering",
        "hours.payroll_basis.reopen_dialog_cancel": "Avbryt",
        "hours.payroll_basis.reopen_running": "Gjenåpner…",
        "hours.payroll_basis.status.draft": "Utkast",
        "hours.payroll_basis.status.finalized": "Ferdigstilt",
        "hours.payroll_basis.status.exported": "Eksportert",
        "hours.payroll_basis.read_only_title": "Skrivebeskyttet",
        "hours.payroll_basis.read_only_body":
          "Grunnlaget er ferdigstilt eller eksportert. Du kan se summer, ansatte og notater, og laste ned ZIP på nytt. For å legge til mer info: gjenåpne for redigering.",
        "hours.payroll_basis.history_title": "Tidligere perioder",
        "hours.payroll_basis.toast_created": "Lønnsgrunnlag opprettet.",
        "hours.payroll_basis.toast_refreshed": "Lønnsgrunnlag oppdatert.",
        "hours.payroll_basis.toast_note_saved": "Merknad lagret.",
        "hours.payroll_basis.toast_general_notes_saved": "Generelle notater lagret.",
        "hours.payroll_basis.toast_finalized": "Lønnsgrunnlag er ferdigstilt.",
        "hours.payroll_basis.toast_reopened":
          "Lønnsgrunnlaget er gjenåpnet som utkast og kan redigeres.",
        "hours.payroll_basis.error_title": "Noe gikk galt",
        "hours.payroll_basis.error_generic":
          "En uventet feil oppstod. Prøv igjen, eller kontakt support hvis problemet vedvarer.",
        "hours.payroll_basis.error_load": "Kunne ikke laste lønnsgrunnlag.",
        "hours.payroll_basis.error_load_title": "Kunne ikke laste lønnsgrunnlag",
        "hours.payroll_basis.error_refresh": "Kunne ikke opprette/oppdatere utkast.",
        "hours.payroll_basis.error_refresh_locked":
          "Perioden er låst eller kan ikke oppdateres.",
        "hours.payroll_basis.error_note": "Kunne ikke lagre merknad.",
        "hours.payroll_basis.error_general_notes": "Kunne ikke lagre generelle notater.",
        "hours.payroll_basis.error_finalize": "Kunne ikke ferdigstille.",
        "hours.payroll_basis.error_reopen": "Kunne ikke gjenåpne lønnsgrunnlaget.",
        "hours.payroll_basis.error_forbidden": "Du har ikke tilgang til lønnsgrunnlag.",
        "hours.payroll_basis.error_dismiss": "Lukk feilmelding",
        "hours.payroll_basis.error_retry": "Prøv igjen",
        "hours.payroll_basis.api_unavailable_title": "API er ikke tilgjengelig",
        "hours.payroll_basis.api_unavailable_body":
          "Lønnsgrunnlag-endepunktet er ikke tilgjengelig (404/501). Siden er klar — prøv igjen når API er ute.",
        "hours.payroll_basis.api_unavailable_toast":
          "Lønnsgrunnlag-API er ikke tilgjengelig.",
        "hours.payroll_basis.empty_draft_title": "Ingen utkast for perioden",
        "hours.payroll_basis.empty_draft_body":
          "Velg år og måned, og trykk «Opprett utkast» for å hente godkjente timer, overtid og fravær per ansatt.",
        "hours.payroll_basis.scaffold_title": "Under oppbygging",
        "hours.payroll_basis.scaffold_body":
          "Denne siden er klar for videre utvikling av lønnsgrunnlag (ansattabell, summer og eksport). Periodevelgeren er aktiv; full funksjon kommer snart.",
        "hours.payroll_basis.table_title": "Ansatte",
        "hours.payroll_basis.table_subtitle": "Periode: {{period}}",
        "hours.payroll_basis.table_subtitle_empty": "Velg år og måned",
        "hours.payroll_basis.empty_title": "Ingen ansatte i utkastet",
        "hours.payroll_basis.empty_body":
          "Opprett eller oppdater utkast for å fylle tabellen med timer for perioden.",
        "hours.payroll_basis.col_employee": "Ansatt",
        "hours.payroll_basis.col_department": "Avdeling",
        "hours.payroll_basis.col_normal": "Normaltid",
        "hours.payroll_basis.col_registered": "Registrert",
        "hours.payroll_basis.col_approved": "Godkjent",
        "hours.payroll_basis.col_unapproved": "Ikke godkjent",
        "hours.payroll_basis.col_absence": "Fravær",
        "hours.payroll_basis.col_overtime": "Overtid",
        "hours.payroll_basis.col_docs": "Dokumentasjon",
        "hours.payroll_basis.col_note": "Merknad",
        "hours.payroll_basis.note_placeholder":
          "F.eks. Endring av timesats fra … · Feriepenger utbetales for uke …",
        "hours.payroll_basis.note_empty_preview": "Ingen merknad ennå",
        "hours.payroll_basis.note_add": "Skriv merknad",
        "hours.payroll_basis.note_edit": "Rediger merknad",
        "hours.payroll_basis.note_save": "Lagre merknad",
        "hours.payroll_basis.note_saving": "Lagrer…",
        "hours.payroll_basis.note_cancel": "Avbryt",
        "hours.payroll_basis.note_dialog_title": "Merknad for ansatt",
        "hours.payroll_basis.note_dialog_employee": "Ansatt: {{name}}",
        "hours.payroll_basis.general_notes_title": "Generelle notater",
        "hours.payroll_basis.general_notes_subtitle":
          "Notater for hele perioden / alle ansatte / lønn generelt. Støtter formatering (fet, lister, overskrifter).",
        "hours.payroll_basis.general_notes_placeholder":
          "F.eks. Endring av timesats fra … · Feriepenger utbetales for uke … · Generelle lønnsjusteringer for perioden…",
        "hours.payroll_basis.general_notes_empty": "Ingen generelle notater for perioden.",
        "hours.payroll_basis.general_notes_save": "Lagre notater",
        "hours.payroll_basis.docs_yes": "Ja",
        "hours.payroll_basis.docs_no": "Nei",
        "hours.payroll_basis.unapproved_badge": "{{count}} ikke godkjent",
        "hours.payroll_basis.summary_approved": "Godkjente timer",
        "hours.payroll_basis.summary_overtime": "Bekreftet OT",
        "hours.payroll_basis.summary_absence": "Fravær",
        "hours.payroll_basis.summary_unapproved": "Ikke godkjent",
        "hours.payroll_basis.summary_unapproved_hint":
          "Synlig for oppfølging — inngår ikke i lønnssummer.",
        "hours.payroll_basis.footer_totals": "Sum (kun godkjente i lønn)",
        "hours.payroll_basis.footer_docs": "{{count}} med dokumentasjon",
        "hours.payroll_basis.legend":
          "Røde rader har ikke-godkjente timer. Disse vises, men summeres ikke i lønnsgrunnlag eller ZIP-eksport.",
        "project.plan.holidays.title": "Røde dager",

        "hours.resource_plan.title": "Ressursplan og tilgjengelighet",
        "hours.resource_plan.subtitle": "Se hvem som er planlagt, tilgjengelig, fraværende eller stemplet inn på faktiske dager.",
        "hours.resource_plan.date_from": "Fra dato",
        "hours.resource_plan.date_to": "Til dato",
        "hours.resource_plan.access_title": "Tilgang for ansatte",
        "hours.resource_plan.access_body": "Brukere med Timer-tilgang kan se operativ status for kollegaer uten adminrettigheter.",
        "hours.resource_plan.load_error": "Kunne ikke laste ressursplan",
        "hours.resource_plan.stats.employees": "Ansatte",
        "hours.resource_plan.stats.available_days": "Tilgjengelige dagsrader",
        "hours.resource_plan.stats.clocked_in": "Stemplet inn",
        "hours.resource_plan.stats.scheduled_hours": "Planlagte timer",
        "hours.resource_plan.days_title": "Dager i perioden",
        "hours.resource_plan.days_subtitle": "Velg en dag for detaljert oversikt over medarbeidere.",
        "hours.resource_plan.day_stats": "{{available}} av {{employees}} tilgjengelige",
        "hours.resource_plan.no_day": "Ingen dag valgt",
        "hours.resource_plan.employee_overview": "Medarbeidere, planlagt tid og status for valgt dag.",
        "hours.resource_plan.empty": "Ingen ansatte funnet for valgt periode.",
        "hours.resource_plan.unknown_employee": "Ukjent medarbeider",
        "hours.resource_plan.table.employee": "Medarbeider",
        "hours.resource_plan.table.status": "Status",
        "hours.resource_plan.table.department": "Avdeling",
        "hours.resource_plan.table.scheduled": "Arbeidsplan",
        "hours.resource_plan.table.shift": "Vakt",
        "hours.resource_plan.table.note": "Notat",
        "hours.resource_plan.status.clocked_in": "På jobb nå",
        "hours.resource_plan.status.available": "Tilgjengelig",
        "hours.resource_plan.status.planned": "Planlagt",
        "hours.resource_plan.status.absent": "Fravær",
        "hours.resource_plan.status.unavailable": "Ikke tilgjengelig",
        "hours.resource_plan.status.off": "Fri",

        "hour_settings.page.subtitle":
          "Fravær, godkjenningsflyt, lønnslåsing og øvrige valg for timeregistrering (prosjekttimer bygger på project_activity på prosjekt).",
        "hour_settings.guide.title": "Slik kommer dere i gang med timer",
        "hour_settings.guide.intro":
          "Under finner du de samme steg som på dashbordet. Timeregistrering bygger på prosjekt og project_activity; listen over generelle aktiviteter i innstillinger er valgfri administrasjon og ikke et oppstartskrav.",
        "hour_settings.guide.step.project_activity":
          "Prosjekttimer: sørg for project_activity (og prosjekt) der ansatte skal føre timer — det er dette nye Promang krever for prosjektregistrering.",
        "hour_settings.guide.step.absence_types": "Fraværstyper: opprett og vedlikehold typer dere bruker.",
        "hour_settings.guide.step.handlers":
          "Sett administrator for timer og for egenmeldinger (fravær).",
        "hour_settings.guide.step.payroll_lock":
          "Vurder låsing av lønnsperiode og utbetalingsdato når dere har rutiner på plass.",
        "hour_settings.guide.step.time_documents":
          "Valgfritt — dokumentasjon på frittstående timer uten rapport eller arbeidsordre.",
        "hour_settings.guide.step.work_schedule":
          "Opprett arbeidsplaner under Timer → Arbeidsplaner og knytt dem til ansatte (brukerprofiler).",
        "hour_settings.guide.back_dashboard": "Tilbake til forsiden",
        "hour_settings.guide.open_user_guide": "Brukerguide: timer og fravær",
        "hour_settings.time_documents.section_title": "Dokumentasjon på timer",
        "hour_settings.time_documents.section_description":
          "Tillat å legge ved bilder/filer på frittstående timer når timen ikke er knyttet til service­rapport eller arbeidsordre.",
        "hour_settings.time_documents.enabled": "Tillat dokumentasjon (bilder/filer) via timeregistrering",

        "hour_settings.agreed_overtime.section_title": "Avtalt overtid",
        "hour_settings.agreed_overtime.section_description":
          "La ansatte be om avtalt overtid ved registrering. Admin eller bruker som håndterer timer må bekrefte før det teller som OT.",
        "hour_settings.agreed_overtime.enabled": "Tillat avtalt overtid",
        "hour_settings.agreed_overtime.enabled_help":
          "Når dette er aktivt, kan ansatte krysse av for avtalt overtid og angi antall OT-timer (hele eller delbeløp).",

        "hours.agreed_overtime.section_title": "Avtalt overtid",
        "hours.agreed_overtime.checkbox_label": "Avtalt overtid",
        "hours.agreed_overtime.checkbox_help":
          "Kryss av hvis hele eller deler av denne registreringen er avtalt overtid. Bekreftelse kreves før det teller.",
        "hours.agreed_overtime.hours_label": "Antall OT-timer",
        "hours.agreed_overtime.hours_hint": "Kan være hele beløpet eller et delbeløp (maks lik registrert tid).",
        "hours.agreed_overtime.hours_required": "Oppgi antall OT-timer",
        "hours.agreed_overtime.hours_invalid": "OT-timer må være større enn 0 og ikke mer enn registrert tid",
        "hours.agreed_overtime.badge_pending": "Avtalt OT — venter",
        "hours.agreed_overtime.badge_confirmed": "Avtalt OT — bekreftet",
        "hours.agreed_overtime.process_dialog_title": "Behandle time",
        "hours.agreed_overtime.process_help": "Forespurt OT: {{hours}} t av {{time}} t registrert.",
        "hours.agreed_overtime.note_label": "Notat til OT-behandling",
        "hours.agreed_overtime.note_placeholder": "Valgfritt notat…",
        "hours.agreed_overtime.confirm": "Bekreft OT",
        "hours.agreed_overtime.reject": "Avvis OT",
        "hours.agreed_overtime.confirm_success": "Avtalt overtid er bekreftet",
        "hours.agreed_overtime.confirm_failed": "Kunne ikke bekrefte avtalt overtid",
        "hours.agreed_overtime.reject_success": "Avtalt overtid er avvist",
        "hours.agreed_overtime.reject_failed": "Kunne ikke avvise avtalt overtid",
        "hours.agreed_overtime.waiting_for_handler":
          "Venter på bekreftelse fra administrator eller bruker som håndterer timer.",

        "hour.time_documents.title": "Dokumentasjon",
        "hour.time_documents.subtitle": "Bilder og filer knyttet til denne timen.",
        "hour.time_documents.help_save_first": "Lagre timen før du kan legge ved filer.",
        "hour.time_documents.pending_hint":
          "Legg til filer her. De lastes opp automatisk med en gang du har lagret timen (du trenger ikke et ekstra opplastingssteg).",
        "hour.time_documents.pending_add": "Legg til filer",
        "hour.time_documents.pending_count": "{{count}} fil(er) står i kø for opplasting",
        "hour.time_documents.pending_remove": "Fjern",
        "hour.time_documents.pending_file_type_denied": "Denne filtypen er ikke tillatt.",
        "hour.time_documents.pending_upload_done": "Vedlegg er lastet opp",
        "hour.time_documents.pending_upload_failed":
          "Timen ble lagret, men opplasting av vedlegg feilet. Lukk og åpne timen på nytt for å prøve igjen.",
        "hour.time_documents.blocked_linked":
          "Dokumentasjon er ikke tilgjengelig når timen er knyttet til rapport eller arbeidsordre.",
        "hour.time_documents.blocked_lock": "Perioden er låst; vedlegg kan ikke endres.",

        "documentUpload.bar.ariaLabel": "Fremdrift for dokumentopplasting",
        "documentUpload.bar.uploading": "Laster opp dokumenter",
        "documentUpload.bar.failed": "Opplasting feilet",
        "documentUpload.bar.destination": "Til",
        "documentUpload.bar.fileOf": "{{current}} av {{total}}",
        "documentUpload.bar.dismiss": "Skjul opplastingsstatus",
        "documentUpload.bar.minimize": "Minimer",
        "documentUpload.bar.expand": "Vis opplastingsstatus",
        "documentUpload.bar.close": "Lukk",
        "documentUpload.bar.uploadingShort": "Laster opp",
        "documentUpload.bar.jobSingular": "opplasting",
        "documentUpload.bar.jobPlural": "opplastinger",
        "documentUpload.viewer.showing": "Viser {{from}}–{{to}} av {{total}}",
        "documentUpload.bar.continueHint":
          "Opplastingen fortsetter øverst på siden — du kan lukke dette vinduet og jobbe videre.",
        "documentUpload.preview.title": "Forhåndsvisning og opplasting",
        "documentUpload.preview.addMore": "Legg til flere bilder",
        "documentUpload.preview.close": "Lukk",
        "documentUpload.preview.confirm": "Last opp",
        "documentUpload.preview.uploading": "Laster opp…",
        "documentUpload.preview.removeFile": "Fjern fil",
        "documentUpload.preview.folderLabel": "Mappe",
        "documentUpload.preview.folderSelectedHint": "Dokumenter lastes opp til valgt mappe.",
        "documentUpload.preview.drawingLabel": "Tegning (valgfritt)",
        "documentUpload.preview.linkedDrawing": "Knyttet tegning #{{id}}",
        "documentUpload.preview.linkedDrawingHint": "Sjekklisten er knyttet til denne tegningen — plasser bare pin.",
        "documentUpload.preview.enableSketch": "Markering / skisse på tegning",
        "documentUpload.preview.enableSketchHint": "Valgfritt: tegn markering på tegningen etter at pin er plassert.",
        "documentUpload.preview.enableSketchHintFullCanvas": "Valgfritt: etter at du klikker på tegningen åpnes skisse i egen dialog.",
        "documentUpload.preview.fullCanvasPlacementHint": "Pin plasseres på den faktiske tegningen (full Tegninger-viewer).",
        "documentUpload.preview.selectDrawingFirst": "Velg tegning før du plasserer pin.",
        "documentUpload.preview.positionPlacedOnDrawing": "Posisjon satt på tegningen",
        "documentUpload.preview.sketchAttached": "Skisse lagt til",
        "documentUpload.preview.sketchCaptureFailed": "Kunne ikke starte skisse — pin lagres uten markering.",
        "documentUpload.preview.drawingPlaceholder": "Velg tegning…",
        "documentUpload.preview.drawingPositionLabel": "Posisjon på tegning",
        "documentUpload.preview.drawingPosition": "Posisjon: X: {{x}}, Y: {{y}}",
        "documentUpload.preview.pickDrawingPosition": "Velg posisjon på tegning",
        "documentUpload.preview.changeDrawingPosition": "Endre posisjon",
        "documentUpload.preview.drawingPositionDialogTitle": "Velg posisjon på tegning",
        "documentUpload.preview.drawingClickHint": "Klikk på tegningen for å velge posisjon",
        "documentUpload.preview.drawingLoading": "Laster tegning…",
        "documentUpload.preview.drawingLoadFailed": "Kunne ikke laste tegning",
        "documentUpload.preview.confirmDrawingPosition": "Bekreft posisjon",
        "documentUpload.preview.drawingDialogTitle": "Velg tegning",
        "documentUpload.preview.drawingSearchPlaceholder": "Søk etter tegninger…",
        "documentUpload.preview.drawingEmpty": "Ingen tegninger funnet",
        "documentUpload.destination.checklist_item": "Sjekklistepunkt",
        "documentUpload.destination.report": "Servicerapport",
        "documentUpload.destination.project": "Prosjekt",
        "documentUpload.destination.hour": "Timeføring",
        "documentUpload.destination.meeting_minute": "Møtereferat",
        "documentUpload.destination.vehicle_service": "Kjøretøyservice",

        "user_guide.hub.badge": "Brukerguide",
        "user_guide.hub.title": "Slik bruker du Promang",
        "user_guide.hub.subtitle":
          "Trinnvise guider for administratorer og ansatte. Innholdet oppdateres her i appen — teknisk utviklerdokumentasjon ligger utenfor denne visningen.",
        "user_guide.hub.card.hours.title": "Timer, fravær og arbeidsplan",
        "user_guide.hub.card.hours.description":
          "Oppstart for bedrifter: fraværstyper, ansvarlige, lønnslås, påminnelser og arbeidsplan.",
        "user_guide.hub.card.hse.title": "HMS, mål og verneombud",
        "user_guide.hub.card.hse.description":
          "Sett HMS-ansvarlig, verneombud, risikohåndtering og årets målsetting.",
        "user_guide.hse.title": "HMS-oppsett",
        "user_guide.hse.badge": "Firma",
        "user_guide.hse.back_to_hub": "Tilbake til guider",
        "user_guide.hse.purpose": "Sjekk at firmaet har verneombud, HMS-ansvarlig og mål for året. Da virker varsler og godkjenning som de skal.",
        "user_guide.hse.section.roles.title": "Roller",
        "user_guide.hse.section.roles.p1": "HMS-ansvarlig eier tiltak og gjennomgang. Verneombud er lovpålagt kontakt for arbeidsmiljøet.",
        "user_guide.hse.section.roles.p2": "Sett begge under HMS og KS → Innstillinger. Vara er valgfritt.",
        "user_guide.hse.section.goals.title": "Målsetting",
        "user_guide.hse.section.goals.p1": "Bruk maler og brikker i stedet for lange tabeller. Godkjenn når ledelsen er enig.",
        "user_guide.hse.section.goals.p2": "Tiltak kan knyttes til et fokusområde, men det er valgfritt.",
        "user_guide.hse.section.risk.title": "Risiko",
        "user_guide.hse.section.risk.p1": "Start med en overordnet risikovurdering for året. Deretter vurderer dere hver risiko og knytter tiltak. Registeret viser alle risikoer på tvers.",
        "user_guide.hse.section.related.title": "Relaterte sider",
        "user_guide.hse.section.related.settings": "HMS-innstillinger",
        "user_guide.hse.section.related.goals": "Målsetting",
        "user_guide.hse.section.related.risk": "Risikovurderinger",
        "company_guide.hse.title": "HMS-status",
        "company_guide.hse.subtitle": "Anbefalte steg før modulen brukes fullt ut.",
        "company_guide.hse.progress_error": "Kunne ikke hente HMS-status. Prøv å oppdatere siden.",
        "company_guide.hse.link.settings": "Åpne innstillinger",
        "company_guide.hse.link.goals": "Åpne målsetting",
        "company_guide.hse.task.responsible.title": "HMS-ansvarlig",
        "company_guide.hse.task.responsible.warn": "Sett hvem som eier HMS i firmaet.",
        "company_guide.hse.task.responsible.ok": "HMS-ansvarlig er satt.",
        "company_guide.hse.task.safety_rep.title": "Verneombud",
        "company_guide.hse.task.safety_rep.warn": "Sett verneombud (vara er valgfritt).",
        "company_guide.hse.task.safety_rep.ok": "Verneombud er satt.",
        "company_guide.hse.task.verneombud.title": "Verneombud",
        "company_guide.hse.task.verneombud.warn": "Sett verneombud (vara er valgfritt).",
        "company_guide.hse.task.verneombud.ok": "Verneombud er satt.",
        "company_guide.hse.task.risk.title": "Risikoansvar",
        "company_guide.hse.task.risk.warn": "Sett hvem som eier risiko, eller bruk HMS-ansvarlig.",
        "company_guide.hse.task.risk.ok": "Risikoansvar er på plass.",
        "company_guide.hse.task.categories.title": "Risikokategorier",
        "company_guide.hse.task.categories.info": "Aktiver minst én risikokategori.",
        "company_guide.hse.task.categories.ok": "Risikokategorier er klare.",
        "company_guide.hse.task.goals.title": "Årets målsetting",
        "company_guide.hse.task.goals.warn": "Legg inn minst ett mål for inneværende år.",
        "company_guide.hse.task.goals.ok": "Årets mål er lagt inn.",
        "company_guide.hse.task.goals.info": "Opprett og godkjenn mål for året når dere er klare.",
        "company_guide.hse.task.ai.title": "AI-forslag",
        "company_guide.hse.task.ai.info": "Valgfritt: slå på forslag når nøkkel er satt.",
        "company_guide.hse.task.ai.warn": "AI er på, men nøkkel mangler.",
        "user_guide.hub.card.offers.title": "Tilbud og kalkyle",
        "user_guide.hub.card.offers.description":
          "Slå på sjekkliste, godkjenning, kalkyle og dokumentbygger for firmaet.",

        "user_guide.offers.back_to_hub": "Tilbake til brukerguiden",
        "user_guide.offers.badge": "Tilbud",
        "user_guide.offers.title": "Tilbud, kalkyle og dokument",
        "user_guide.offers.purpose":
          "Slik setter du opp tilbudsmodulen for firmaet: hvilke faner som vises, hvordan kalkylen summeres, og hvordan tilbudsdokumentet bygges. Anbefalte valg er merket i innstillingene.",
        "user_guide.offers.checklist.badge": "Oppstart",
        "user_guide.offers.checklist.heading": "Status for oppsett (tilbud)",
        "user_guide.offers.checklist.subtitle":
          "Anbefalte funksjoner som bør slås på for at sjekkliste, godkjenning og kalkyle skal vises i tilbudet.",
        "user_guide.offers.checklist.open_settings": "Åpne innstillinger",
        "user_guide.offers.checklist.flag_on": "På",
        "user_guide.offers.checklist.flag_off": "Av — anbefales å slå på",
        "user_guide.offers.checklist.all_ok": "Anbefalte tilbudsinnstillinger er på plass.",
        "user_guide.offers.checklist.load_error.title": "Kunne ikke laste innstillinger",
        "user_guide.offers.checklist.load_error.description": "Prøv igjen fra tilbudsinnstillinger.",
        "user_guide.offers.section.workflow.title": "Arbeidsflyt",
        "user_guide.offers.section.workflow.p1":
          "Revisjoner gir intern kontroll og godkjenning før sending. Sjekkliste er en egen fane for kvalitetssikring.",
        "user_guide.offers.section.workflow.p2":
          "«Krev sjekkliste før sending» bør først slås på når sjekklisten faktisk er i bruk, ellers blokkeres sending.",
        "user_guide.offers.section.calculation.title": "Kalkyle",
        "user_guide.offers.section.calculation.p1":
          "Kalkylen er intern estimering (kost, timer, påslag og dekningsbidrag). Tilbudslinjer er det kunden ser.",
        "user_guide.offers.section.calculation.li1":
          "Kalkyle v2 gir nøyaktigere summer i oversikt og toppheader.",
        "user_guide.offers.section.calculation.li2":
          "Timelinjer: fyll inn timer og timesats (ikke bare antall) for at sum timer og timekost skal stemme.",
        "user_guide.offers.section.calculation.li3":
          "Strukturgrupper til venstre er fagkapitler. Hold musepekeren over et navn for å se hele tittelen.",
        "user_guide.offers.section.document.title": "Dokument og forbehold",
        "user_guide.offers.section.document.p1":
          "Dokumentbyggeren brukes til tekstblokker i selve tilbudet. Forbehold plasseres som en tekstblokk under Dokument — det er den anbefalte plasseringen mot kunde.",
        "user_guide.offers.section.related.title": "Nyttige snarveier",
        "user_guide.offers.section.related.link_list": "Tilbudsliste",
        "user_guide.offers.section.related.link_settings": "Innstillinger for tilbud",
        "user_guide.hub.card.drawings.title": "Tegninger, hus og etasjer",
        "user_guide.hub.card.drawings.description":
          "Velg prosjekt, opprett hus og etasjer, og last opp PDF-tegninger.",
        "user_guide.hub.footer_note": "Mangler du svar? Prøv også ressurssenteret under FAQ.",


        "ai_skills.badge": "AI",
        "ai_skills.page_title": "AI-skills",
        "ai_skills.subtitle":
          "Opplæring og retningslinjer for AI i Promang — tilgjengelig for alle innloggede brukere.",
        "ai_skills.back_to_user_guide": "Tilbake til brukerguiden",
        "ai_skills.nav_label": "AI-skills",
        "ai_skills.skill_badge": "Skill",
        "ai_skills.skill_badge_hint": "Strukturert spillbok for AI og mennesker",
        "ai_skills.loading": "Laster…",
        "ai_skills.load_error": "Kunne ikke laste dokumentet",
        "ai_skills.nav.overview": "Oversikt",
        "ai_skills.nav.prompting_basics": "Prompting-grunnlag",
        "ai_skills.nav.promang_ai_generator": "AI-generator i appen",
        "ai_skills.nav.microsoft_mail_ai": "Microsoft e-post-AI",
        "ai_skills.nav.guide_flow_ai": "Guideflyt og AI",
        "ai_skills.nav.cursor_for_promang": "Cursor for utviklere",
        "ai_skills.hub_card.title": "AI-skills — opplæring",
        "ai_skills.hub_card.description":
          "Slik bruker du AI trygt i Promang: prompting, generator, e-post og guider.",
        "ai_skills.nav.agent_integrations": "Agent — datamodeller (oversikt)",
        "ai_skills.nav.agent_product": "Agent — produkt",
        "ai_skills.nav.agent_customer": "Agent — kunde",
        "ai_skills.nav.agent_project": "Agent — prosjekt",
        "ai_skills.nav.agent_case": "Agent — sak og tidslinje",
        "ai_skills.nav.agent_tasks": "Agent — oppgaver (todos)",
        "ai_skills.nav.agent_hse_document": "Agent — HMS-dokument",
        "ai_skills.nav.agent_meeting_minutes": "Møtereferat — AI",

        "user_guide.drawings.back_to_hub": "Tilbake til brukerguiden",
        "user_guide.drawings.badge": "Tegninger",
        "user_guide.drawings.title": "Tegninger, hus og etasjer",
        "user_guide.drawings.purpose":
          "Slik setter du opp hus og etasjer i et prosjekt og laster opp PDF-tegninger. Tegninger tilhører alltid et prosjekt. Én tegning er én PDF-side.",
        "user_guide.drawings.open_module": "Åpne Tegninger",
        "user_guide.drawings.section.project.title": "1. Åpne Tegninger og velg prosjekt",
        "user_guide.drawings.section.project.li1": "Gå til Tegninger i menyen til venstre.",
        "user_guide.drawings.section.project.li2":
          "Velg prosjektet du skal jobbe med (søk på nummer, navn eller kunde om listen er lang).",
        "user_guide.drawings.section.project.li3":
          "Valgt prosjekt huskes ut økten. Bytt med Bytt i headeren når du trenger et annet prosjekt.",
        "user_guide.drawings.section.project.shot": "Velg prosjekt før du jobber med tegninger",
        "user_guide.drawings.section.list.title": "2. Tegningslisten",
        "user_guide.drawings.section.list.p1":
          "Når prosjektet er valgt, ser du strukturen til venstre (hus og etasjer) og tegningene til høyre.",
        "user_guide.drawings.section.list.li1": "Administrer struktur — vis slett- og legg-til-kontroller i treet",
        "user_guide.drawings.section.list.li2": "+ Ny tegning — åpne skuffen for opplasting",
        "user_guide.drawings.section.list.li3": "+ Hus i strukturpanelet — opprett hus",
        "user_guide.drawings.section.list.shot": "Tegningsliste med strukturpanel",
        "user_guide.drawings.section.house.title": "3. Legg til hus",
        "user_guide.drawings.section.house.li1": "Klikk + Hus øverst i strukturpanelet.",
        "user_guide.drawings.section.house.li2": "Skriv husnavn, for eksempel Hus A eller Bygg 2.",
        "user_guide.drawings.section.house.li3": "Klikk Legg til.",
        "user_guide.drawings.section.house.shot": "Felt for å legge til hus",
        "user_guide.drawings.section.floor.title": "4. Legg til etasjer",
        "user_guide.drawings.section.floor.li1": "Klikk på huset i treet slik at det foldes ut.",
        "user_guide.drawings.section.floor.li2": "Klikk + Etasje under huset.",
        "user_guide.drawings.section.floor.li3": "Skriv etasjenavn, for eksempel 1. etasje eller 2.",
        "user_guide.drawings.section.floor.li4": "Klikk Legg til.",
        "user_guide.drawings.section.floor.li5": "Gjenta for flere etasjer.",
        "user_guide.drawings.section.floor.p1":
          "Fargeprikker i treet viser tegningstype (arkitektur, ventilasjon, kjøkken, annet).",
        "user_guide.drawings.section.floor.shot": "Felt for å legge til etasje under et hus",
        "user_guide.drawings.section.floor.shot_tree": "Struktur med hus og etasjer",
        "user_guide.drawings.section.upload.title": "5. Last opp tegning",
        "user_guide.drawings.section.upload.li1": "Velg etasjen i strukturen (da forhåndsvelges hus og etasje).",
        "user_guide.drawings.section.upload.li2": "Klikk + Ny tegning (eller Legg til tegning her).",
        "user_guide.drawings.section.upload.li3": "Slipp PDF-filen i feltet, eller klikk Velg fil.",
        "user_guide.drawings.section.upload.li4":
          "Har PDF-en flere sider: bla til riktig side og bekreft Bruk side N. Promang lagrer én side per tegning.",
        "user_guide.drawings.section.upload.li5": "Sjekk Tittel (kan leses fra filnavnet).",
        "user_guide.drawings.section.upload.li6":
          "Velg Tegningstype (arkitektur, ventilasjon, kjøkken eller annet).",
        "user_guide.drawings.section.upload.li7":
          "Kontroller Plassering (hus og etasje). Bruk Andre hvis tegningen ikke hører til en etasje.",
        "user_guide.drawings.section.upload.li8": "Klikk Opprett tegning.",
        "user_guide.drawings.section.upload.shot_empty": "Skuff for ny tegning før opplasting",
        "user_guide.drawings.section.upload.shot_filled": "Ny tegning med PDF, type og etasje utfylt",
        "user_guide.drawings.section.done.title": "6. Ferdig",
        "user_guide.drawings.section.done.p1":
          "Tegningen vises som kort i listen, knyttet til hus og etasje. Klikk på kortet for å åpne tegningsviseren (mål, merking, avvik og sjekklister).",
        "user_guide.drawings.section.done.shot": "Tegningsliste med opplastet tegning",
        "user_guide.drawings.section.rules.title": "Regler å huske",
        "user_guide.drawings.section.rules.li1": "Tegninger ligger alltid i et prosjekt.",
        "user_guide.drawings.section.rules.li2": "Én tegning = én PDF-side.",
        "user_guide.drawings.section.rules.li3":
          "Samme etasje og samme type kan bare ha én tegning. Opplasting av duplikat ber om bekreftelse før erstatning.",
        "user_guide.drawings.section.rules.li4": "Tegninger uten etasje legges under Andre.",

        "dashboard.company_guide.hours_teaser_title": "Timer og fravær",
        "dashboard.company_guide.hours_teaser_subtitle":
          "Oppstartsstatus og detaljert guide finner du på brukerguiden — ikke på forsiden.",
        "dashboard.company_guide.hours_teaser_cta": "Åpne status og guide",

        "user_guide.hours.back_to_hub": "Tilbake til brukerguiden",
        "user_guide.hours.checklist.badge": "Oppstart",
        "user_guide.hours.checklist.heading": "Status for oppsett (timer-modulen)",
        "user_guide.hours.checklist.subtitle":
          "Kun synlig for administratorer. Hvert punkt lenker til innstillinger eller mer forklaring lenger ned på siden.",
        "user_guide.hours.badge": "Timer og fravær",
        "user_guide.hours.title": "Timer, fravær og arbeidsplan",
        "user_guide.hours.purpose":
          "Denne guiden hjelper nye bedrifter og administratorer med å sette opp fravær, ansvarlige og arbeidsplan. Sjekklisten på dashbordet (kun admin) peker hit for detaljer.",

        "user_guide.hours.section.registration.title": "Timeregistrering i Promang",
        "user_guide.hours.section.registration.p1":
          "Timer på prosjekt skal knyttes til et prosjekt og en prosjektlinje (project activity). Det er dette som styrer timeregistrering i arbeidsflaten.",
        "user_guide.hours.section.registration.p2":
          "Eldre begreper Activity og ActivityItem brukes i bakgrunnen mot regnskapssystemer (for eksempel Tripletex-synk). De er ikke det du normalt velger når du fører timer i grensesnittet.",
        "user_guide.hours.section.registration.p3":
          "Lister over «generelle aktiviteter» under Timer → Innstillinger kan brukes til administrasjon, men er ikke et eget krav i oppstartsjekken på dashbordet.",

        "user_guide.hours.section.visibility.title": "Hvem ser hva?",
        "user_guide.hours.section.visibility.li1":
          "På forsiden vises bare en kort lenke for administratorer når Timer er aktiv. Full status og sjekkliste ligger her på brukerguiden.",
        "user_guide.hours.section.visibility.li2":
          "Alle som har tilgang til Timer → Innstillinger ser det korte hjelpekortet øverst på innstillingssiden.",

        "user_guide.hours.section.steps.title": "Anbefalt rekkefølge",
        "user_guide.hours.section.steps.s1.title": "1. Fraværstyper",
        "user_guide.hours.section.steps.s1.where": "Gå til Timer → Innstillinger → Fraværstyper.",
        "user_guide.hours.section.steps.s1.b1":
          "Opprett typer som passer bedriften: ferie, syk, egenmelding, avspasering, permisjon og lignende.",
        "user_guide.hours.section.steps.s1.b2":
          "Fravær registreres mot disse typene. Hvem som godkjenner egenmeldinger avhenger av roller og hvem dere setter som fraværsansvarlig.",

        "user_guide.hours.section.steps.s2.title": "2. Ansvar for timer og fravær",
        "user_guide.hours.section.steps.s2.where": "Gå til Timer → Innstillinger → Håndtering av timer og fravær.",
        "user_guide.hours.section.steps.s2.b1":
          "Timer: velg gjerne den som skal godkjenne timelister og følge opp avvik.",
        "user_guide.hours.section.steps.s2.b2":
          "Egenmelding / fravær: velg den som skal behandle egenmeldinger (ofte HR eller nærmeste leder).",
        "user_guide.hours.section.steps.s2.b3": "Begge bør settes tidlig, så ansatte vet hvem som følger opp.",

        "user_guide.hours.section.steps.s3.title": "3. Låsing av lønnsperiode (valgfritt)",
        "user_guide.hours.section.steps.s3.where": "Gå til Timer → Innstillinger → Låsing av lønnsperiode.",
        "user_guide.hours.section.steps.s3.b1":
          "Når rutinene er på plass kan dere låse måned ved periodeslutt og sette utbetalingsdato i tråd med lønn.",
        "user_guide.hours.section.steps.s3.b2":
          "Låste perioder begrenser endringer bakover i tid; unntak håndteres av dem som har rettigheter til opplåsing der det er aktivert.",

        "user_guide.hours.section.steps.s4.title": "4. Påminnelser om timer (valgfritt)",
        "user_guide.hours.section.steps.s4.where": "Gå til Timer → Innstillinger → Påminnelse om timer.",
        "user_guide.hours.section.steps.s4.b1": "Slå på daglig påminnelse og sett tidspunkter om dere vil minne folk på å føre timer.",
        "user_guide.hours.section.steps.s4.b2":
          "E-post som sendes ut må være satt opp i drift (planlagte jobber) — spør administrator eller leverandør om dette er aktivt.",

        "user_guide.hours.section.steps.s5.title": "5. Arbeidsplan og stillingsbrøk",
        "user_guide.hours.section.steps.s5.where": "Bruk Tidsplan og brukerprofiler under Brukere.",
        "user_guide.hours.section.steps.s5.b1":
          "Hver ansatt bør ha arbeidsplan som stemmer med stillingen — det påvirker forventet tid og planlegging.",
        "user_guide.hours.section.steps.s5.b2": "Kalender og oppfølging av fravær forutsetter at dette er på plass.",

        "user_guide.hours.section.public_holidays.title": "Røde dager og normaltid",
        "user_guide.hours.section.public_holidays.p1":
          "Promang kjenner norske offentlige helligdager (1. mai, 17. mai, påske med mer) automatisk. På slike dager er forventet arbeidstid normalt 0 timer for ansatte med arbeidsplan mandag–fredag.",
        "user_guide.hours.section.public_holidays.p2":
          "Du kan likevel registrere timer på en rød dag når det faktisk er jobbet — skjemaet viser da en informasjonsmelding, men stopper ikke lagring.",
        "user_guide.hours.section.public_holidays.li1":
          "Timeregistrering: blå melding med helligdagsnavn når datoen er rød dag.",
        "user_guide.hours.section.public_holidays.li2":
          "Månedsoversikt: normaltid vises netto (fratrekk for røde dager og registrert fravær).",
        "user_guide.hours.section.public_holidays.li3":
          "Fravær: kan ikke registreres på røde dager (skjemaet blokkerer slike datoer).",
        "user_guide.hours.section.public_holidays.li4":
          "Tidsplan og kalender viser hvilke dager som er røde dager i året.",

        "user_guide.hours.section.related.title": "Nyttige snarveier",
        "user_guide.hours.section.related.link_hours": "Timeliste",
        "user_guide.hours.section.related.link_approval": "Timegodkjenning",
        "user_guide.hours.section.related.link_absence": "Fraværsoversikt",
        "user_guide.hours.section.related.link_monthly": "Månedsoversikt timer",
        "user_guide.hours.section.related.link_work_schedule": "Min tidsplan (røde dager)",
        "user_guide.hours.section.related.link_settings": "Innstillinger for timer",

        "user_guide.hours.section.more_help.title": "Mer hjelp",
        "user_guide.hours.section.more_help.p1":
          "Har du spørsmål som ikke står her, kan ressurssenteret (FAQ) eller kundestøtte hjelpe videre.",
        "user_guide.hours.section.more_help.faq_link": "Gå til FAQ i ressurssenteret",

        "Time Registration": "Timeregistrering",
        "Registered hours": "Registrerte timer",
        "Close": "Lukk",
        "Hours Overview": "Timer Oversikt",
        "hours.company_overview": "Timeoversikt",
        "hours.company_overview.subtitle":
          "Alle timer i valgt måned. Filtrer på prosjekt, aktivitet, ansatte og avdeling. Estimat for kostnad og salg.",
        "Track and manage work hours": "Spor og administrer arbeidstimer",
        "Select Employee": "Velg Ansatt",
        "Set Date": "Sett dato",
        "Today": "Idag",
        "Calendar": "Kalender",
  
        // Work Statistics translations
        "Work Statistics": "Arbeidsstatistikk",
        "Overview of your work hours and performance":
          "Oversikt over dine arbeidstimer og ytelse",
        "Something went wrong while loading work stats":
          "Noe gikk galt ved lasting av arbeidsstatistikk",
        "Could not load work statistics": "Kunne ikke laste arbeidsstatistikk",
        "No data available": "Ingen data tilgjengelig",
        "No work statistics found for this user.":
          "Ingen arbeidsstatistikk funnet for denne brukeren.",
        "Expected This Week": "Forventet denne uken",
        "Worked This Week": "Arbeidet denne uken",
        "Worked This Month": "Arbeidet denne måneden",
        "Earned Time Off": "Opptjent fritid",
        "Weekly Progress": "Ukentlig fremgang",
        "Hours worked this week": "Timer arbeidet denne uken",
        "Remaining": "Gjenstående",
        "Overtime": "Overtid",
        "Weekly Goal": "Ukentlig mål",
        "Completed": "Fullført",
        "In Progress": "Under arbeid",
        "Status": "Status",
        "Under Target": "Under mål",
        "On Track": "På sporet",
        "Efficiency": "Effektivitet",
  
        // Vehicle translations
        "Vehicle handbook": "Kjøretøyhåndbok",
        "Check in to a vehicle to open its handbook from this menu.":
          "Sjekk inn på et kjøretøy for å åpne håndboken fra denne menyen.",
        "Vehicle handbook could not be opened. Try again or contact an administrator.":
          "Kunne ikke åpne kjøretøyhåndbok. Prøv igjen eller kontakt administrator.",
        "Go to trips": "Gå til turer",
        "Vehicle handbook entry subtitle":
          "Sjekk inn, så åpnes håndboken for kjøretøyet du er innlogget på.",
        "Vehicle handbook check in": "Sjekk inn på kjøretøy",
        "Vehicle handbook check in hint":
          "Velg et kjøretøy for innsjekk; du sendes deretter til håndboken.",
        "Vehicle handbook not a driver":
          "Du er ikke registrert som sjåfør i selskapet. Kontakt administrator hvis du trenger tilgang til kjøring.",
        "Vehicle handbook no vehicles permission":
          "Du trenger tilgang til kjøretøylisten for å sjekke inn her. Du kan fortsatt sjekke inn fra Turer eller dashbordet hvis det er tilgjengelig.",
        "Vehicle Information": "Fordoninformasjon",
        "Number Plate": "Registreringsnummer",
        "VIN (Chassis Number)": "VIN (Chassisnummer)",
        "Make": "Merke",
        "Model": "Modell",
        "Model Year": "Årsmodell",
        "Body Style": "Karosstype",
        "Nickname": "Kallenavn",
        "Current Odometer (km)": "Nåværende kilometerstand (km)",
        "Description": "Beskrivelse",
        "Statens Vegvesen Information": "Statens Vegvesen Informasjon",
        "Norwegian Vehicle Authority Information": "Norsk Vegvesen Informasjon",
        "Registration Date": "Registreringsdato",
        "First Registration": "Første registrering",
        "Vehicle Type": "Fordonstype",
        "Fuel Type": "Drivstofftype",
        "Engine Size (cc)": "Motoreffekt (cc)",
        "Power (kW)": "Effekt (kW)",
        "Inspection Information": "Besiktningsinformasjon",
        "EU-kontroll / Periodic Vehicle Inspection":
          "EU-kontroll / Periodisk fordonbesiktning",
        "Last Inspection Date": "Siste besiktningsdato",
        "Next Inspection Date": "Neste besiktningsdato",
        "Inspection Result": "Besiktningsresultat",
        "Inspection Station": "Besiktningsstasjon",
        "Insurance Information": "Forsikringsinformasjon",
        "Vehicle Insurance Details": "Fordonforsikring Detaljer",
        "Insurance Company": "Forsikringsselskap",
        "Policy Number": "Policenummer",
        "Insurance Start Date": "Forsikring startdato",
        "Insurance End Date": "Forsikring sluttdato",
        "Insurance Type": "Forsikringstype",
        "Annual Premium (NOK)": "Årlig premie (NOK)",
        "Service Information": "Serviceinformasjon",
        "Maintenance and Service Details": "Vedlikehold og Service Detaljer",
        "Last Service Date": "Siste servicedato",
        "Next Service Date": "Neste servicedato",
        "Service Interval (km)": "Serviceintervall (km)",
        "Service Provider": "Serviceleverandør",
        "Warranty End Date": "Garanti sluttdato",
        "Warranty Type": "Garantitype",
        "Damage Reports": "Skaderapporter",
        "Vehicle Damage History": "Fordon Skadehistorikk",
        "Damage reports will be implemented in the future":
          "Skaderapporter vil bli implementert i fremtiden",
        "Internal Controls": "Interne kontroller",
        "Company Internal Vehicle Controls":
          "Bedriftens Interne Fordonskontroller",
        "Last Internal Check": "Siste interne kontroll",
        "Next Internal Check": "Neste interne kontroll",
        "Safety Equipment Status": "Sikkerhetsutstyr Status",
        "Vehicle Status": "Fordonstatus",
        "Trips": "Turer",
        "Service": "Service",
        "Documents": "Dokumenter",
        "Vehicle": "Kjøretøy",
        "Vehicle Documents": "Fordon Dokumenter",
        "Manage vehicle documents and files":
          "Administrer fordon dokumenter og filer",
        "Vehicle Trips": "Fordon Turer",
        "vehicle.trips_stats.title": "Tur- og kjørelengdestatistikk",
        "vehicle.trips_stats.subtitle": "Kjørelengde basert på registrerte turer for dette kjøretøyet",
        "vehicle.trips_stats.trip_count": "Antall turer",
        "vehicle.trips_stats.total_distance": "Total kjørelengde",
        "vehicle.trips_stats.this_month": "Kjørelengde denne måneden",
        "vehicle.trips_stats.this_year": "Kjørelengde i år",
        "vehicle.trips_stats.last_year": "Kjørelengde forrige år",
        "vehicle.trips_stats.estimated_this_year": "Estimert kjørelengde i år",
        "vehicle.trips_stats.today": "I dag",
        "vehicle.trips_stats.this_week": "Denne uken",
        "trips found": "turer funnet",
        "No trips found for this vehicle":
          "Ingen turer funnet for dette fordonet",
        "Vehicle safety and maintenance checklists":
          "Fordon sikkerhet og vedlikehold sjekklister",
        "Create Checklist": "Opprett sjekkliste",
        "Last Internal Control": "Siste interne kontroll",
        "Checklist Number": "Sjekkliste nummer",
        "Items Approved": "Godkjente punkter",
        "Checklist Items": "Sjekkliste punkter",
        "Approved": "Godkjent",
        "Not Approved": "Ikke godkjent",
        "No checklists found": "Ingen sjekklister funnet",
        "Get started by creating a new checklist":
          "Start med å opprette en ny sjekkliste",
        "Select Checklist Type": "Velg sjekkliste type",
        "Choose the type of checklist you want to create for this vehicle":
          "Velg type sjekkliste du vil opprette for dette fordonet",
        "Create a new checklist for this project":
          "Opprett en ny sjekkliste for dette prosjektet",
        "Choose the type of checklist you want to create for this project":
          "Velg type sjekkliste du vil opprette for dette prosjektet",
        "Project checklist title": "Prosjektsjekkliste #{{number}}{{suffix}}",
        "Customer checklist title": "Kundesjekkliste #{{number}}{{suffix}}",
        "Folder checklist title": "Mappe-sjekkliste #{{number}}{{suffix}}",
        "Generic new checklist title": "Sjekkliste #{{number}} ({{date}})",
        "Report checklist default title": "Rapport {{number}} - {{address}}",
        "Choose the type of checklist you want to create for this report":
          "Velg type sjekkliste du vil opprette for denne rapporten",
        "Choose the type of checklist you want to create for this folder":
          "Velg type sjekkliste du vil opprette for denne mappen",
        "Choose the type of checklist you want to create for this customer":
          "Velg type sjekkliste du vil opprette for denne kunden",
        "Choose the type of checklist you want to create":
          "Velg type sjekkliste du vil opprette",
        "Checklist title placeholder": "Skriv inn tittel for sjekklisten",
        "Checklist title edit hint":
          "Foreslått automatisk — du kan endre tittelen før du velger type.",
        "Title": "Tittel",
        "Enter checklist title": "Skriv inn sjekkliste tittel",
        "No checklist types available": "Ingen sjekkliste typer tilgjengelig",
        "items": "punkter",
  
        // Journal translations
        "journal": "Journal",
        "journal.title": "Journal Tittel",
        "journal.description": "Journal Beskrivelse",
        "journal.date": "Journal Dato",
        "journal.next_follow_up": "Neste Oppfølgingsdato",
        "journal.status": "Journal Status",
        "journal.create": "Opprett Journal Oppføring",
        "journal.update": "Oppdater Journal Oppføring",
        "journal.delete": "Slett Journal Oppføring",
        "journal.entries": "Journal Oppføringer",
        "journal.no_entries": "Ingen journal oppføringer funnet",
        "journal.add_entry": "Legg til Journal Oppføring",
        "journal.edit_entry": "Rediger Journal Oppføring",
        "journal.entry_created": "Journal oppføring opprettet",
        "journal.entry_updated": "Journal oppføring oppdatert",
        "journal.entry_deleted": "Journal oppføring slettet",
        "journal.follow_up_reminder": "Oppfølgingspåminnelse",
        "journal.service_documentation": "Service Dokumentasjon",
        "journal.calibration_record": "Kalibreringsjournal",
        "journal.repair_record": "Reparasjonsjournal",
        "journal.maintenance_record": "Vedlikeholdsjournal",
  
        // Tool translations
        "tool": "Verktøy",
        "tools": "Verktøy",
        "tool.title": "Verktøy Tittel",
        "tool.number": "Verktøy Nummer",
        "tool.description": "Verktøy Beskrivelse",
        "tool.status": "Verktøy Status",
        "tool.category": "Verktøy Kategori",
        "tool.brand": "Verktøy Merke",
        "tool.model": "Verktøy Modell",
        "tool.serial_number": "Serienummer",
        "tool.purchase_date": "Kjøpsdato",
        "tool.purchase_price": "Kjøpspris",
        "tool.supplier.label": "Kjøpt fra (leverandør)",
        "tool.supplier.placeholder": "Velg leverandør",
        "tool.supplier.select_one": "Velg leverandør",
        "tool.supplier.select_multiple": "Velg leverandører",
        "tool.supplier.search_placeholder": "Søk etter leverandører…",
        "tool.supplier.empty": "Ingen leverandører funnet. Prøv et annet søk.",
        "tool.supplier.load_more": "Last flere",
        "tool.supplier.clear": "Fjern valg",
        "tool.supplier.load_error": "Kunne ikke laste leverandører",
        "tool.supplier.selected_count": "{{count}} valgt",
        "tool.service_interval": "Service Intervall (dager)",
        "tool.last_service": "Siste Service",
        "tool.next_service": "Neste Service",
        "tool.service_overdue": "Service Forfalt",
        "tool.service_due_soon": "Service Snart Forfaller",
        "tool.create": "Opprett Verktøy",
        "tool.update": "Oppdater Verktøy",
        "tool.delete": "Slett Verktøy",
        "tool.overview": "Verktøy Oversikt",
        "tool.manage_tools": "Administrer Verktøy",
        "tool.no_tools": "Ingen verktøy funnet",
        "tool.add_tool": "Legg til Verktøy",
        "tool.edit_tool": "Rediger Verktøy",
        "tool.tool_created": "Verktøy opprettet",
        "tool.tool_updated": "Verktøy oppdatert",
        "tool.tool_deleted": "Verktøy slettet",
        "tool.service_overview": "Service Oversikt",
        "tool.upcoming_services": "Kommende Service",
        "tool.overdue_services": "Forfalte Service",
        "tool.total_tools": "Totalt Verktøy",
        "tool.active_tools": "Aktive Verktøy",
        "tool.quick_row_label": "—",
        "tool.quick_new": "Ny",
        "tool.quick_add_placeholder": "Tittel — trykk Tab eller Enter for å lagre",
        "tool.next_number_hint_title": "Foreslått neste verktøynummer",
        "tool.quick_add_tab_hint": "Tab / Enter",
        "tool.active_column": "Aktiv",
        "tool.assign_short": "Tildel",
        "tool.duplicate": "Kopier",
        "tool.duplicate_created": "Verktøy kopiert",
        "tool.number_auto_placeholder": "Neste: {{next}} (tom = auto)",
  
        // Tool Category translations
        "tool.categories": "Verktøy Kategorier",
        "tool.category.name": "Kategori Navn",
        "tool.category.description": "Kategori Beskrivelse",
        "tool.category.create": "Opprett Verktøy Kategori",
        "tool.category.update": "Oppdater Verktøy Kategori",
        "tool.category.delete": "Slett Verktøy Kategori",
        "tool.category.no_categories": "Ingen verktøy kategorier funnet",
        "tool.category.add_category": "Legg til Verktøy Kategori",
        "tool.category.edit_category": "Rediger Verktøy Kategori",
        "tool.category.created": "Verktøy kategori opprettet",
        "tool.category.updated": "Verktøy kategori oppdatert",
        "tool.category.deleted": "Verktøy kategori slettet",
        "tool.category.manage_title": "Verktøykategorier",
        "tool.category.all_categories": "Alle kategorier",
        "tool.category.new_category": "Ny",
        "tool.category.delete_confirm": "Slette denne kategorien?",
        "tool.category.delete_confirm_with_tools":
          "Kategorien er knyttet til {{count}} verktøy. Slette likevel?",
        "tool.category.delete_failed": "Kunne ikke slette kategorien",
        "tool.category.tools_count": "{{count}} verktøy",
  
        // Tool Brand translations
        "tool.brands": "Verktøy Merker",
        "tool.brand.name": "Merke Navn",
        "tool.brand.description": "Merke Beskrivelse",
        "tool.brand.create": "Opprett Verktøy Merke",
        "tool.brand.update": "Oppdater Verktøy Merke",
        "tool.brand.delete": "Slett Verktøy Merke",
        "tool.brand.no_brands": "Ingen verktøy merker funnet",
        "tool.brand.add_brand": "Legg til Verktøy Merke",
        "tool.brand.edit_brand": "Rediger Verktøy Merke",
        "tool.brand.created": "Verktøy merke opprettet",
        "tool.brand.updated": "Verktøy merke oppdatert",
        "tool.brand.deleted": "Verktøy merke slettet",
        "tool.brand.manage_title": "Verktøymerker",
        "tool.brand.all_brands": "Alle merker",
        "tool.brand.new_brand": "Nytt",
        "tool.brand.delete_confirm": "Slette dette merket?",
        "tool.brand.delete_confirm_with_tools":
          "Merke er knyttet til {{count}} verktøy. Slette likevel?",
        "tool.brand.delete_failed": "Kunne ikke slette merket",
        "tool.brand.tools_count": "{{count}} verktøy",
        "tool.open": "Åpne",
        "tool.back_to_overview": "Tilbake til verktøy",
        "tool.assigned_user_column": "Tildelt",
        "tool.assignment_heading": "Tildeling",
        "tool.assignment_hint":
          "Knytt verktøyet til en ansatt, eller fjern tildeling (retur til lager).",
        "tool.assigned_to": "Tildelt",
        "tool.not_assigned": "Ikke tildelt",
        "tool.assign_user": "Tildel bruker",
        "tool.reassign_user": "Bytt bruker",
        "tool.return_from_user": "Fjern tildeling (retur)",
        "tool.assign_saved": "Tildeling oppdatert",
        "tool.return_saved": "Verktøy returnert",
        "tool.notes_heading": "Verktøynotater",
        "tool.notes_hint":
          "Interne notater om verktøyet (vises ikke som journal/service).",
        "tool.notes_placeholder": "Skriv notater…",
        "tool.save_notes": "Lagre notater",
        "tool.notes_saved": "Notater lagret",
        "tool.completed_service_intervals": "Utførte serviceintervaller",
        "tool.completed_service_intervals_hint":
          "Journalposter med status fullført og «service» i tittel (samme regel som neste service).",
        "tool.no_completed_service_intervals":
          "Ingen utførte serviceintervaller er registrert ennå.",
        "tool.journal_other_hint":
          "Andre journalposter (aktive, oppfølging, ikke-service osv.).",
        "tool.journal_empty_hint": "Opprett en journalpost for service eller notater.",
        "tool.journal_no_other_entries": "Ingen andre journalposter.",
        "tool.print_label": "Skriv ut skilt / etikett",
        "tool.usage_history_heading": "Brukshistorikk (tildeling)",
        "tool.usage_history_hint":
          "Hvem som har hatt verktøyet, hvor mange dager (kalenderdager, inkludert første og siste dag), og om perioden ble avsluttet med retur eller overlevering til ny bruker.",
        "tool.usage_history_empty":
          "Ingen historikk ennå. Historikk registreres når du tildeler, bytter bruker eller returnerer verktøyet.",
        "tool.usage_user": "Bruker",
        "tool.usage_from": "Fra",
        "tool.usage_to": "Til",
        "tool.usage_days": "Dager",
        "tool.usage_outcome": "Avslutning",
        "tool.usage_status": "Status",
        "tool.usage_status_active": "Aktiv utlån",
        "tool.usage_status_ended": "Avsluttet",
        "tool.usage_reason.return": "Returnert (ikke tildelt)",
        "tool.usage_reason.reassign": "Byttet til annen bruker",
        "tool.employee_tools_title": "Verktøy",
        "tool.employee_tools_intro_title": "Dine tildelte verktøy",
        "tool.employee_tools_intro":
          "En enkel oversikt over verktøy som er registrert på deg, med tildelingsdato og nøkkelinformasjon.",
        "tool.employee_tools_short": "Dine tildelte verktøy.",
        "tool.employee_tools_loading": "Laster verktøy...",
        "tool.employee_tools_load_error": "Kunne ikke laste verktøy.",
        "tool.employee_tools_empty_title": "Ingen verktøy tildelt",
        "tool.employee_tools_empty": "Det er ikke registrert noen verktøy på deg.",
        "tool.employee_tools_assigned_on": "Tatt i bruk",
        "tool.employee_tools_unknown_date": "Ukjent dato",
        "tool.employee_tools_no_service": "Ingen planlagt service",
        "tool.employee_tools_days_held": "{{count}} dager i bruk",
  
        // Tool Status translations
        "tool.status.active": "Aktiv",
        "tool.status.inactive": "Inaktiv",
        "tool.status.maintenance": "Under Vedlikehold",
        "tool.status.retired": "Pensjonert",
  
        // Journal Status translations
        "journal.status.active": "Aktiv",
        "journal.status.completed": "Fullført",
        "journal.status.archived": "Arkivert",

        // Standalone documentation journals
        "journal.page_title": "Journaler",
        "journal.journals": "Journaler",
        "journal.hero_subtitle":
          "Opprett flere journaler for dokumentasjon på ansatte, kunder, prosjekter eller frittstående.",
        "journal.all_journals": "Alle journaler",
        "journal.all_journals_subtitle": "Alle journaler i selskapet.",
        "journal.section_subtitle": "Dokumentasjon med tekst og bilder.",
        "journal.new_journal": "Ny journal",
        "journal.no_journals": "Ingen journaler ennå",
        "journal.no_journals_hint": "Opprett en journal for å begynne å dokumentere.",
        "journal.color": "Farge",
        "journal.new_entry": "Ny oppføring",
        "journal.entry_placeholder": "Skriv en oppføring… (tekst og bilder)",
        "journal.entry_added": "Oppføring lagt til",
        "journal.entry_save_failed": "Kunne ikke lagre oppføringen",
        "journal.entry_delete_confirm": "Slette denne oppføringen?",
        "journal.unknown_author": "Ukjent",
        "journal.pin": "Fest",
        "journal.unpin": "Løsne",
        "journal.save_failed": "Kunne ikke lagre journalen",
        "journal.print": "Skriv ut",
        "journal.printing": "Genererer…",
        "journal.print_failed": "Kunne ikke generere PDF",
        "journal.search_placeholder": "Søk i journaler…",
        "journal.documentation.no_entries": "Ingen oppføringer.",

        // Text documents (letters / agreements)
        "textDocuments.title": "Dokumenter",
        "textDocuments.new": "Nytt dokument",
        "textDocuments.create": "Opprett",
        "textDocuments.edit": "Rediger dokument",
        "textDocuments.untitled": "Uten tittel",
        "textDocuments.title_placeholder": "F.eks. Oppsigelse, Avtale, Informasjonsbrev…",
        "textDocuments.template": "Mal",
        "textDocuments.template_hint": "Velg en eksisterende mal som utgangspunkt (valgfritt).",
        "textDocuments.choose_template": "Velg mal",
        "textDocuments.change_template": "Endre",
        "textDocuments.remove_template": "Fjern mal",
        "textDocuments.hero_subtitle":
          "Opprett brev, avtaler og oppsigelser. Skriv ut med eller uten signaturfelt, og send til digital signering.",
        "textDocuments.search_placeholder": "Søk i dokumenter…",
        "textDocuments.empty": "Ingen dokumenter ennå.",
        "textDocuments.standalone": "Frittstående",
        "textDocuments.section_subtitle": "Brev, avtaler og andre dokumenter.",
        "textDocuments.status.draft": "Utkast",
        "textDocuments.status.final": "Ferdig",
        "textDocuments.include_signature": "Inkluder signaturfelt ved utskrift",
        "textDocuments.editor_placeholder": "Skriv dokumentet her…",
        "textDocuments.print": "Skriv ut",
        "textDocuments.save_failed": "Kunne ikke lagre dokumentet",
        "textDocuments.save_before_print": "Lagre dokumentet før utskrift",
        "textDocuments.print_failed": "Kunne ikke generere PDF",
        "textDocuments.signing": "Digital signering",
        "textDocuments.signature.signers": "Signaturer",
        "textDocuments.signature.signers_hint":
          "Legg til hvem som skal signere. Velg ansatt for å hente navn, stilling og personnummer automatisk til Posten-signering. Uten ansatt må du fylle inn personnummer eller e-post og mobil.",
        "textDocuments.signature.select_employee": "Velg ansatt",
        "textDocuments.signature.manual_entry": "Fyll inn manuelt",
        "textDocuments.signature.loading_employee": "Henter ansattinformasjon…",
        "textDocuments.signature.employee_posten_hint":
          "Personnummer, e-post og mobil hentes fra ansettelsen ved sending til Posten Signering.",
        "textDocuments.signature.employee_linked": "Ansatt valgt – identitet hentes fra ansettelsen",
        "textDocuments.signature.signing_requires_signers":
          "Aktiver «Inkluder signaturfelt ved utskrift» og legg til minst én signerer for å sende til Posten.",
        "textDocuments.signature.signing_uses_configured_signers":
          "Følgende signaturer fra dokumentet sendes til Posten Signering:",
        "textDocuments.signature.signing_missing_identity":
          "Hver signerer må enten være en valgt ansatt, ha personnummer, eller ha både e-post og mobil.",
        "textDocuments.signature.name": "Navn",
        "textDocuments.signature.name_placeholder": "F.eks. Ola Nordmann",
        "textDocuments.signature.job_title": "Stilling",
        "textDocuments.signature.job_title_placeholder": "F.eks. Daglig leder",
        "textDocuments.signature.field_label": "Feltnavn",
        "textDocuments.signature.field_label_placeholder": "F.eks. Signatur / Sted og dato",
        "textDocuments.signature.national_identity_number": "Personnummer / D-nummer",
        "textDocuments.signature.national_identity_number_placeholder": "11 siffer",
        "textDocuments.signature.email": "E-post",
        "textDocuments.signature.email_placeholder": "navn@firma.no",
        "textDocuments.signature.mobile": "Mobil",
        "textDocuments.signature.mobile_placeholder": "+47 900 00 000",
        "textDocuments.signature.add_signer": "Legg til signerer",
        "textDocuments.signature.remove_signer": "Fjern signerer",

        // Subject link filters (journals + text documents)
        "subjectLinkFilter.module": "Modul",
        "subjectLinkFilter.all_modules": "Alle moduler",
        "subjectLinkFilter.all_statuses": "Alle statuser",
        "subjectLinkFilter.clear_entity": "Fjern valg",
        "subjectLinkFilter.search_placeholder": "Søk…",
        "subjectLinkFilter.select_user": "Velg ansatt",
        "subjectLinkFilter.select_customer": "Velg kunde",
        "subjectLinkFilter.select_project": "Velg prosjekt",
        "subjectLinkFilter.types.standalone": "Frittstående",
        "subjectLinkFilter.types.user": "Ansatte",
        "subjectLinkFilter.types.customer": "Kunder",
        "subjectLinkFilter.types.project": "Prosjekter",
        "subjectLinkFilter.types.vehicle": "Kjøretøy",
        "subjectLinkFilter.types.tool": "Verktøy",

        // Documentation send (text documents + journals)
        "documentationSend.send_document": "Send dokument",
        "documentationSend.send_journal": "Send journal",
        "documentationSend.intro": "Send «{{title}}» som PDF på e-post.",
        "documentationSend.send_to": "Send til",
        "documentationSend.message": "Melding",
        "documentationSend.message_placeholder": "Valgfri melding til mottaker…",
        "documentationSend.email_required": "E-post er påkrevd",
        "documentationSend.invalid_email": "Ugyldig e-postadresse",
        "documentationSend.success_document": "Dokumentet ble sendt",
        "documentationSend.success_journal": "Journalen ble sendt",
        "documentationSend.failed": "Kunne ikke sende",
        "documentationSend.history_persist_failed":
          "E-posten ble sendt, men sendeloggen kunne ikke lagres. Oppdater siden og sjekk historikken før du sender på nytt.",
        "documentationSend.sent_badge": "Sendt {{date}}",
        "documentationSend.sent_short": "Sendt",
        "documentationSend.not_sent_yet": "Ikke sendt ennå.",
        "documentationSend.history_title": "Sendingslogg",
        "documentationSend.export_title": "Eksporter PDF",
        "documentationSend.export_intro": "Velg hva som skal være med når du eksporterer «{{title}}».",
        "documentationSend.export_include_signature": "Inkluder signaturfelt",
        "documentationSend.export_include_send_log": "Inkluder sendelogg",
        "documentationSend.export_download": "Last ned PDF",
        "documentationSend.export_send_log_only": "Eksporter kun sendelogg",
        "documentationSend.export_send_log": "Eksporter sendelogg",
        "documentationSend.export_failed": "Kunne ikke eksportere PDF",
        "documentationSend.export_empty_log": "Ingen utsendinger å eksportere ennå.",
        "documentationSend.exporting": "Lager PDF…",
        "documentationSend.view_email": "Åpne i e-postlogg",

        "documentForms.templates.title": "Dokumentmaler",
        "documentForms.templates.subtitle": "Bygg utfyllbare dokumentmaler med felter, sjekklister og tabeller",
        "documentForms.templates.new": "Ny mal",
        "documentForms.templates.edit": "Rediger mal",
        "documentForms.templates.empty": "Ingen maler funnet",
        "documentForms.templates.meta": "Maldetaljer",
        "documentForms.templates.number_prefix": "Arkivprefiks",
        "documentForms.templates.number_prefix_placeholder": "f.eks. SJA",
        "documentForms.templates.number_prefix_hint": "Brukes for nummerering i arkivet: SJA #1, SJA #2 … Tomt = første ord i tittelen.",
        "documentForms.created_with_reference": "Opprettet {{reference}}",
        "documentForms.templates.editor_hint": "Legg til blokker og konfigurer utfyllbare felter",
        "documentForms.templates.print": "Skriv ut mal",
        "documentForms.templates.save_before_print": "Lagre malen før utskrift",
        "documentForms.forms.title": "Utfylte dokumenter",
        "documentForms.forms.subtitle": "Dokumenter opprettet fra maler",
        "documentForms.forms.empty": "Ingen dokumenter funnet",
        "documentForms.new": "Nytt dokument",
        "documentForms.edit": "Rediger dokument",
        "documentForms.create": "Opprett",
        "documentForms.created": "Dokument opprettet",
        "documentForms.save_failed": "Kunne ikke lagre dokument",
        "documentForms.template": "Mal",
        "documentForms.choose_template": "Velg mal",
        "documentForms.form_title": "Dokumenttittel",
        "documentForms.search_placeholder": "Søk...",
        "documentForms.include_signature": "Inkluder signaturblokk i PDF",
        "documentForms.mark_final": "Marker som ferdig",
        "documentForms.print": "Skriv ut / PDF",
        "documentForms.save_before_print": "Lagre dokumentet før utskrift",
        "documentForms.print_failed": "Kunne ikke generere PDF",
        "documentForms.status.draft": "Utkast",
        "documentForms.status.final": "Ferdig",
        "documentForms.table.add_row": "Legg til rad",
        "documentForms.categories.all": "Alle kategorier",
        "documentForms.categories.new": "Ny kategori",
        "documentForms.categories.name": "Kategorinavn",
        "documentForms.categories.description": "Beskrivelse",
        "documentForms.categories.label": "Kategori",
        "documentForms.categories.uncategorized": "Ukategorisert",
        "documentForms.builder.blocks": "Blokker",
        "documentForms.builder.empty": "Ingen blokker ennå",
        "documentForms.builder.empty_hint": "Legg til blokker fra paletten til venstre",
        "documentForms.builder.select_block": "Velg en blokk for å redigere egenskaper",
        "documentForms.blocks.heading": "Overskrift",
        "documentForms.blocks.paragraph": "Avsnitt",
        "documentForms.blocks.callout": "Infoboks",
        "documentForms.blocks.divider": "Skillelinje",
        "documentForms.blocks.text_field": "Tekstfelt",
        "documentForms.blocks.textarea": "Lang tekst",
        "documentForms.blocks.number": "Tall",
        "documentForms.blocks.date": "Dato",
        "documentForms.blocks.checkbox": "Avkryssing",
        "documentForms.blocks.select": "Nedtrekksliste",
        "documentForms.blocks.checklist": "Sjekkliste",
        "documentForms.blocks.table": "Tabell",
        "documentForms.blocks.signature": "Signatur",
        "documentForms.props.level": "Nivå",
        "documentForms.props.label": "Etikett",
        "documentForms.props.placeholder": "Plassholder",
        "documentForms.props.required": "Påkrevd",
        "documentForms.props.variant": "Variant",
        "documentForms.props.info": "Info",
        "documentForms.props.warning": "Advarsel",
        "documentForms.props.options": "Alternativer (ett per linje)",
        "documentForms.props.items": "Sjekklistepunkter",
        "documentForms.props.add_item": "Legg til punkt",
        "documentForms.props.column_label": "Kolonnetittel",
        "documentForms.props.add_column": "Legg til kolonne",
        "documentForms.props.allow_add_rows": "Tillat å legge til rader ved utfylling",

        "documentForms.archive.title": "Dokumentarkiv",
        "documentForms.archive.subtitle": "Innsendte og utkast — gruppert etter mal",
        "documentForms.archive.empty": "Ingen utfylte dokumenter i arkivet ennå",
        "documentForms.archive.stats": "{{forms}} dokumenter i {{templates}} maler",
        "documentForms.archive.count": "{{count}} dokumenter",
        "documentForms.archive.view_for_template": "Se arkiv ({{count}})",
        "documentForms.archive.hse_link": "HMS-dokument",
        "documentForms.archive.clear_filter": "Vis alle maler",
        "documentForms.archive.unknown_template": "Ukjent mal",
        "documentForms.hse.title": "HMS-dokumentregister",
        "documentForms.hse.description": "Registrer malen som styrt skjema (SKJ) i HMS-dokumenter. Utfylte instanser ligger i dokumentarkivet.",
        "documentForms.hse.register": "Registrer i HMS-dokumenter",
        "documentForms.hse.registered": "Registrert i HMS-dokumenter",
        "documentForms.hse.register_failed": "Kunne ikke registrere i HMS",
        "documentForms.hse.save_template_first": "Lagre malen før registrering i HMS",
        "documentForms.hse.open_document": "Åpne HMS-dokument",
        "documentForms.hse.system_category": "Systemkategori (HMS/KS/REG …)",
        "documentForms.hse.category_required": "Velg kategori og kapittel for HMS-plassering",
        "documentForms.hse.update_placement": "Oppdater plassering i HMS",
        "documentForms.hse.fill_form": "Fyll ut skjema",
        "documentForms.hse.fillable_template_title": "Utfyllbar skjemamal",
        "documentForms.hse.fillable_template_description": "Dette dokumentet er koblet til en mal. Opprett og fyll ut et nytt skjema — det lagres i dokumentarkivet.",
        "documentForms.hse.fillable_badge": "Utfyllbart skjema",
        "documentForms.json.open_dialog": "JSON / AI",
        "documentForms.json.dialog_title": "JSON og AI for dokumentmal",
        "documentForms.json.tab_json": "Lim inn JSON",
        "documentForms.json.tab_ai_guide": "AI-instruksjoner",
        "documentForms.json.hint": "Lim inn JSON fra ChatGPT eller annen AI, eller rediger eksisterende mal. Støtter { \"blocks\": [...] } eller full mal med title og description.",
        "documentForms.json.replace_blocks": "Erstatt alle blokker",
        "documentForms.json.append_blocks": "Legg til nederst",
        "documentForms.json.copy_json": "Kopier JSON",
        "documentForms.json.reload_from_builder": "Last inn fra malbygger",
        "documentForms.json.insert_sample": "Sett inn eksempel",
        "documentForms.json.apply": "Bruk JSON",
        "documentForms.json.applied": "{{count}} blokker importert",
        "documentForms.json.copy_success": "JSON kopiert",
        "documentForms.json.reload_success": "JSON lastet inn fra malbygger",
        "documentForms.json.clipboard_failed": "Kunne ikke kopiere til utklippstavle",
        "documentForms.json.ai_guide_intro": "Kopier instruksjonene nedenfor til ChatGPT, Claude eller annen AI. Lim deretter JSON-svaret inn i fanen «Lim inn JSON».",
        "documentForms.json.copy_ai_guide": "Kopier AI-instruksjoner",
        "documentForms.json.ai_guide_copied": "AI-instruksjoner kopiert",
        "documentForms.json.generate_with_ai": "Generer med AI",
        "documentForms.json.ai_parse_error": "Kunne ikke lese AI-svar som JSON",
        "documentForms.json.ai_apply_success": "{{count}} blokker lagt inn fra AI",
        "documentForms.json.error_empty": "JSON-feltet er tomt",
        "documentForms.json.error_invalid_json": "Ugyldig JSON — sjekk syntaks",
        "documentForms.json.error_no_blocks_array": "Fant ingen blocks-array i JSON",
        "documentForms.json.error_no_valid_blocks": "Ingen gyldige blokker etter import",
  
        // Personalhåndbok translations
        "Personalhåndbok": "Personalhåndbok",
        "personalhåndbok.description":
          "Tilgang til bedriftens retningslinjer, sikkerhetsprosedyrer og ansattinformasjon",
        "Open": "Åpne",
        "HMS Guidelines": "Rutiner",
        "Safety procedures and guidelines": "Sikkerhetsprosedyrer og rutiner",
        "Instructions": "Retningslinjer",
        "Company policies and procedures":
          "Bedriftens retningslinjer og prosedyrer",
        "Instruction Chapters": "Retningslinjer - Kapitler",
        "Chapter": "Kapittel",
        "Create Chapter": "Opprett kapittel",
        "Update Chapter": "Oppdater kapittel",
        "Chapter Number": "Kapittel nummer",
        "Parent Chapter": "Overordnet kapittel",
        "Sub Chapters": "Underkapitler",
        "No chapter number": "Ingen kapittel nummer",
        "Colleagues": "Kollegaer",
        "colleague_dialog.subtitle": "Kollega",
        "colleague_dialog.contact_title": "Kontaktinformasjon",
        "colleague_dialog.contact_missing": "Ingen mobil eller e-post er registrert.",
        "colleague_dialog.mobile_work": "Arbeidsmobil",
        "colleague_dialog.mobile": "Privat mobil",
        "colleague_dialog.email": "E-post",
        "colleague_dialog.call": "Ring",
        "colleague_dialog.send_email": "Send e-post",
        "colleague_dialog.department": "Avdeling",
        "colleague_dialog.next_of_kin": "Neste pårørende",
        "colleague_dialog.employee_number": "Ansattnummer",
        "colleague_dialog.close": "Lukk",
        "colleague_dialog.relationship.spouse": "Ektefelle",
        "colleague_dialog.relationship.partner": "Partner",
        "colleague_dialog.relationship.parent": "Forelder",
        "colleague_dialog.relationship.child": "Barn",
        "colleague_dialog.relationship.sibling": "Søsken",
        "Hei": "Hei",
        "Team overview and contacts": "Team oversikt og kontakter",
        "Recent HMS Guidelines": "Siste rutiner",
        "Recent Instructions": "Siste retningslinjer",
        "Recent KS/HMS Documents": "Siste KS/HMS dokumenter",
        "KS/HMS Documents": "KS/HMS Dokumenter",
        "employee_handbook.pending_read_ack_title":
          "KS/HMS: dokumenter som mangler bekreftelse",
        "employee_handbook.pending_read_ack_body":
          "Du har {count} dokument(er) som ikke er bekreftet som lest og forstått. Åpne hvert dokument og bekreft, eller gå til full visning under HMS/KS.",
        "employee_handbook.all_documents_acknowledged":
          "Du har bekreftet alle KS/HMS-dokumentene du har tilgang til (lest og forstått).",
        "employee_handbook.read_status_acknowledged": "Lest og bekreftet",
        "employee_handbook.read_status_pending": "Mangler bekreftelse",
        "employee_handbook.read_status_creator_exempt": "Forfatter (ikke pliktig)",
        "employee_handbook.go_to_documents_tab": "Gå til KS/HMS-dokumenter",
        "employee_handbook.forms_tab": "Skjema og maler",
        "employee_handbook.forms_tab_mobile": "Skjema",
        "employee_handbook.forms_tab_subtitle": "Utfyllbare HMS-skjema — opprett og fyll ut direkte uten å lete i dokumenttreet.",
        "employee_handbook.forms_tab_search": "Søk etter skjema eller mal…",
        "employee_handbook.forms_tab_empty": "Ingen utfyllbare skjema er registrert i personalhåndboken ennå.",
        "employee_handbook.forms_tab_no_results": "Ingen skjema matcher søket.",
        "employee_handbook.forms_tab_info": "Mer info",
        "employee_handbook.forms_tab_overview_hint": "Trykk for rask tilgang",
        "employee_handbook.open_full_document": "Åpne full side (HMS/KS)",
        "employee_handbook.other_chapter_documents": "Andre dokumenter i kapittel",
        "employee_handbook.other_chapter_documents_hint":
          "Tilhørende rutine, informasjon til kunde eller andre vedlegg i samme kapittel.",
        "dashboard_report.handbook_read_incomplete":
          "{pending} av {total} KS/HMS-dokumenter mangler bekreftelse som lest/forstått.",
        "dashboard_report.handbook_register_absence_subtitle":
          "Registrer fravær og send til behandling.",
        "employee_handbook.stat_line_pending":
          "{count} dokument(er) mangler bekreftelse som lest og forstått.",
        "Kapitler": "Kapitler",
        "Dokumenter uten kapittel": "Dokumenter uten kapittel",
        "Dokumenter som ikke er tilknyttet noe kapittel": "Dokumenter som ikke er tilknyttet noe kapittel",
        "Søk etter dokumenter...": "Søk etter dokumenter...",
        "Fant {count} dokumenter": "Fant {count} dokumenter",
        "Ingen dokumenter funnet": "Ingen dokumenter funnet",
        "Prøv å endre søkeordene dine": "Prøv å endre søkeordene dine",
        "Laster dokument...": "Laster dokument...",
        "Ingen innhold tilgjengelig": "Ingen innhold tilgjengelig",
        "Dokumenter uten bransje": "Dokumenter uten bransje",
        "Dokumenter uten kategori": "Dokumenter uten kategori",
        "Dokumenter uten bransje og kategori": "Dokumenter uten bransje og kategori",
        "No chapter": "Ingen kapitel",
        "Employee Handbook": "Personalhåndbok",
  
        // Deviation Template translations
        "deviation.template": "Avvik mal",
        "deviation.template.select": "Velg mal",
        "deviation.template.select.description":
          "Velg en mal for å gjøre det enklere å registrere avviket",
        "deviation.template.standard": "Standard avvik",
        "deviation.template.standard.description": "Vanlig avviksregistrering",
        "deviation.form.type_category_hint":
          "Velg kategorien som best beskriver dette avviket.",
        "deviation.form.search_types": "Søk i avvikstyper…",
        "deviation.form.no_matching_types": "Ingen treff i avvikstyper",
        "deviation.template.incident_injury": "Uønsket hendelse - Skade",
        "deviation.template.incident_injury.description":
          "Strukturert skjema for registrering av uønsket hendelse med skade",
        "deviation.template.back": "← Tilbake til maler",
  
        // Event description translations
        "deviation.event.description": "Hendelsesbeskrivelse",
        "deviation.event.description.title": "Hendelsesbeskrivelse",
        "deviation.event.description.subtitle": "Beskriv hendelsen som skjedde",
        "deviation.event.date": "Dato for hendelse",
        "deviation.event.time": "Tidspunkt",
        "deviation.event.description.field": "Beskrivelse av hendelsen",
        "deviation.event.description.placeholder":
          "Beskriv detaljert hva som skjedde...",
        "deviation.event.involved_persons": "Involverte personer",
        "deviation.event.witnesses": "Vitner",
  
        // Location translations
        "deviation.location": "Hvor skjedde hendelsen",
        "deviation.location.title": "Hvor skjedde hendelsen",
        "deviation.location.subtitle": "Angi sted og avdeling",
        "deviation.location.place": "Sted",
        "deviation.location.department": "Avdeling",
        "deviation.location.building": "Bygg/Område",
        "deviation.location.room_area": "Rom/Område",
        "deviation.location.details": "Mer detaljert beskrivelse av stedet",
        "deviation.location.details.placeholder":
          "Beskriv stedet mer detaljert...",
  
        // Categorization translations
        "deviation.categorization": "Kategorisering",
        "deviation.categorization.title": "Kategorisering av hendelsen",
        "deviation.categorization.subtitle":
          "Kategoriser hendelsen for å gjøre det enklere å analysere og følge opp",
        "deviation.categorization.category": "Kategori",
        "deviation.categorization.severity": "Alvorlighetsgrad",
        "deviation.categorization.immediate_cause": "Umiddelbar årsak",
        "deviation.categorization.underlying_cause": "Underliggende årsak",
        "deviation.categorization.details": "Mer detaljert kategorisering",
        "deviation.categorization.details.placeholder":
          "Beskriv kategoriseringen mer detaljert...",
  
        // Event categories
        "deviation.category.law_violation": "Avvik lov",
        "deviation.category.regulation_violation": "Avvik forskrift",
        "deviation.category.procedure_violation": "Brudd på rutine",
        "deviation.category.process_violation": "Brudd på prosedyre",
        "deviation.category.training_violation": "Brudd på opplæring",
        "deviation.category.information": "Informasjon",
        "deviation.category.other": "Annet",
  
        // Treatment translations
        "deviation.treatment": "Behandling",
        "deviation.treatment.title": "Behandling av hendelsen",
        "deviation.treatment.subtitle":
          "Vurder om årsakanalyse og strakstiltak er nødvendig",
        "deviation.treatment.root_cause_analysis": "Årsakanalyse",
        "deviation.treatment.immediate_actions": "Strakstiltak",
        "deviation.treatment.root_cause_analysis.details": "Årsakanalyse",
        "deviation.treatment.root_cause_analysis.placeholder":
          "Beskriv årsakanalysen...",
        "deviation.treatment.immediate_actions.details": "Strakstiltak",
        "deviation.treatment.immediate_actions.placeholder":
          "Beskriv strakstiltakene...",
        "deviation.treatment.suggested_actions": "Forslag til tiltak",
        "deviation.treatment.suggested_actions.placeholder":
          "Beskriv forslag til tiltak...",
  
        // Action translations
        "deviation.action": "Tiltak",
        "deviation.action.title": "Opprett tiltak",
        "deviation.action.subtitle":
          "Opprett og planlegg konkrete tiltak basert på analysen",
        "deviation.action.title.field": "Tiltak tittel",
        "deviation.action.deadline": "Frist",
        "deviation.action.responsible": "Ansvarlig person",
        "deviation.action.department": "Avdeling",
        "deviation.action.location": "Sted",
        "deviation.action.category": "Kategori",
        "deviation.action.description": "Beskrivelse av tiltak",
        "deviation.action.description.placeholder":
          "Beskriv tiltaket detaljert...",
        "deviation.action.health_service_cooperation":
          "Samarbeid med bedrifthelsetjenesten",
        "deviation.action.cost": "Kostnad (NOK)",
        "deviation.action.documents": "Dokumenter",
        "deviation.action.related_elements": "Tilknyttede elementer",
  
        // Action categories
        "deviation.action.category.safety": "Sikkerhet",
        "deviation.action.category.quality": "Kvalitet",
        "deviation.action.category.environment": "Miljø",
        "deviation.action.category.procedure": "Prosedyre",
        "deviation.action.category.training": "Opplæring",
        "deviation.action.category.maintenance": "Vedlikehold",
        "deviation.action.category.equipment": "Utstyr",
        "deviation.action.category.communication": "Kommunikasjon",
        "deviation.action.category.other": "Annet",
  
        // Action statuses
        "deviation.action.status.planned": "Planlagt",
        "deviation.action.status.started": "Påbegynt",
        "deviation.action.status.in_progress": "Under arbeid",
        "deviation.action.status.completed": "Fullført",
        "deviation.action.status.cancelled": "Kansellert",
        "deviation.action.status.on_hold": "På vent",
  
        // Action priorities
        "deviation.action.priority.low": "Lav",
        "deviation.action.priority.medium": "Medium",
        "deviation.action.priority.high": "Høy",
        "deviation.action.priority.critical": "Kritisk",
  
        // Form validation messages
        "deviation.event.description.required": "Hendelsesbeskrivelse er påkrevd",
        "deviation.location.required": "Sted er påkrevd",
        "deviation.category.required": "Kategori er påkrevd",
        "deviation.action.title.required": "Tiltak tittel er påkrevd",
        "deviation.action.description.required": "Beskrivelse er påkrevd",
        "deviation.action.category.required": "Kategori er påkrevd",
        "deviation.action.deadline.required": "Frist er påkrevd",
        "deviation.action.responsible.required": "Ansvarlig person er påkrevd",
  
        // Success/Error messages
        "deviation.template.saved": "Data ble lagret!",
        "deviation.action.created": "Tiltak ble opprettet!",
        "deviation.template.save_error": "Noe gikk galt. Kunne ikke lagre data!",
        "deviation.action.create_error":
          "Noe gikk galt. Kunne ikke opprette tiltak!",
  
        // Navigation
        "deviation.previous": "Forrige",
        "deviation.next": "Neste",
        "deviation.complete": "Fullfør",
        "deviation.reset": "Nullstill",
        "deviation.create_action": "Opprett tiltak",
        "deviation.saving": "Lagrer...",
  
        // Action creation dialog
        "deviation.action.create.question": "Ønsker du å opprette tiltak?",
        "deviation.action.create.description":
          "Du kan opprette konkrete tiltak med frist, ansvarlig person og beskrivelse.",
        "deviation.action.create.yes": "Ja, opprett tiltak",
        "deviation.action.create.no": "Nei, ikke nå",
        "deviation.action.notes": "Notater om tiltak (valgfritt)",
        "deviation.action.notes.placeholder":
          "Legg til notater om tiltak hvis nødvendig...",
  
        // Chemical Inventory (Stoffkartotek) translations
        "chemical.inventory": "Stoffkartotek",
        "chemical.inventory.description":
          "Administrer kjemiske stoffer og sikkerhetsdatablader",
        "chemical.inventory.new": "Nytt stoff",
        "chemical.inventory.create_with_ai": "Opprett med AI",
        "chemical.inventory.create_manual": "Fyll ut manuelt",
        "chemical.inventory.create_manual_lead": "Skriv inn navn, CAS og øvrige felt selv.",
        "chemical.inventory.ai_choose_lead": "Last opp FDV eller datablad, så fyller AI ut stoffkartoteket. Du godkjenner før det lagres.",
        "chemical.inventory.ai_upload_lead": "Dra inn eller velg PDF (sikkerhetsdatablad, FDV eller produktdatablad). Analysen starter automatisk.",
        "chemical.inventory.ai_drop_title": "Slipp filen her, eller klikk for å velge",
        "chemical.inventory.ai_file_too_large": "Filen er for stor. Maksimal størrelse er 20 MB.",
        "chemical.inventory.ai_file_invalid": "Ugyldig filtype. Velg PDF eller bilde (JPG, PNG).",
        "chemical.inventory.ai_analyzing": "Analyserer dokumentet…",
        "chemical.inventory.ai_ready": "Utkast fra databladet er klart. Kontroller feltene før du oppretter.",
        "chemical.inventory.ai_ready_partial": "Analysen gikk gjennom, men navn eller CAS mangler. Fyll ut manuelt og kontroller før du lagrer.",
        "chemical.inventory.ai_empty": "Analysen gikk gjennom, men kunne ikke utlede skjemadata fra dokumentet. Fyll ut manuelt, eller prøv et datablad med lesbar tekst.",
        "chemical.inventory.ai_empty_unreadable": "Analysen gikk gjennom, men dokumentteksten var for kort eller uleselig (ofte skannet PDF uten OCR). Fyll ut manuelt, eller last opp et datablad med lesbar tekst.",
        "chemical.inventory.ai_failed": "Kunne ikke analysere dokumentet. Prøv en annen PDF eller fyll ut manuelt.",
        "chemical.inventory.ai_back": "Tilbake",
        "chemical.inventory.ai_review_hint": "Feltene er fylt fra opplastet datablad. Kontroller og lagre.",
        "chemical.inventory.edit": "Rediger stoff",
        "chemical.inventory.delete": "Slett stoff",
        "chemical.inventory.create": "Opprett stoffkartotek",
        "chemical.inventory.update": "Oppdater stoffkartotek",
        "chemical.inventory.search": "Søk i stoffkartotek...",
        "chemical.inventory.no_results": "Ingen stoffer funnet",
        "chemical.inventory.add_from_product": "Legg til fra produkt",
        "chemical.inventory.basic_info": "Grunnleggende informasjon",
        "chemical.inventory.safety_info": "Sikkerhetsinformasjon",
        "chemical.inventory.supplier_info": "Leverandørinformasjon",
        "chemical.inventory.risk_assessment": "Risikovurdering",
        "chemical.inventory.documents": "Dokumenter",
        "chemical.inventory.notes": "Notater",
        "chemical.inventory.history": "Historikk",
        "chemical.inventory.safety_sheet": "Verneblad",
        "chemical.inventory.hazard_symbols": "Faresymboler",
        "chemical.inventory.hms_level": "HMS-nivå",
        "chemical.inventory.cas_number": "CAS-nummer",
        "chemical.inventory.chemical_formula": "Kjemisk formel",
        "chemical.inventory.molecular_weight": "Molekylvekt",
        "chemical.inventory.purity": "Renhet",
        "chemical.inventory.physical_state": "Fysisk tilstand",
        "chemical.inventory.color": "Farge",
        "chemical.inventory.odor": "Lukt",
        "chemical.inventory.hazard_statements": "Farepåstander",
        "chemical.inventory.precautionary_statements": "Advarselspåstander",
        "chemical.inventory.signal_word": "Signalord",
        "chemical.inventory.hazard_classification": "Fareklassifisering",
        "chemical.inventory.general_use": "Generell bruk",
        "chemical.inventory.fire_measures": "Brannslokkingstiltak",
        "chemical.inventory.spill_measures": "Tiltak ved utslipp",
        "chemical.inventory.first_aid": "Førstehjelp",
        "chemical.inventory.storage_conditions": "Lagringsforhold",
        "chemical.inventory.personal_protection": "Personlig verneutstyr",
        "chemical.inventory.exposure_limits": "Eksponeringsgrenser",
        "chemical.inventory.stability_reactivity": "Stabilitet og reaktivitet",
        "chemical.inventory.toxicological_info": "Toksikologisk informasjon",
        "chemical.inventory.ecological_info": "Økologisk informasjon",
        "chemical.inventory.disposal_considerations": "Avfallshåndtering",
        "chemical.inventory.transport_info": "Transportinformasjon",
        "chemical.inventory.supplier_name": "Leverandørnavn",
        "chemical.inventory.supplier_address": "Leverandøradresse",
        "chemical.inventory.supplier_country": "Leverandørland",
        "chemical.inventory.supplier_phone": "Leverandørtelefon",
        "chemical.inventory.emergency_phone": "Nødtelefon",
        "chemical.inventory.supplier_email": "Leverandør e-post",
        "chemical.inventory.general_use_risk": "Risikovurdering - generell bruk",
        "chemical.inventory.per_operation_risk":
          "Risikovurdering - per arbeidsoperasjon",
        "chemical.inventory.risk_assessment_documents":
          "Dokumenter til risikovurdering",
        "chemical.inventory.location_specific_risk":
          "Lokasjonspesifikk risikovurdering",
        "chemical.inventory.storage_location": "Lagringsplass",
        "chemical.inventory.usage_instructions": "Bruksanvisning",
        "chemical.inventory.version": "Versjon",
        "chemical.inventory.status": "Status",
        "chemical.inventory.last_review_date": "Siste gjennomgangsdato",
        "chemical.inventory.next_review_date": "Neste gjennomgangsdato",
        "chemical.inventory.notes_field": "Notater",
        "chemical.inventory.safety_instructions": "Sikkerhetsinstruksjoner",
        "chemical.inventory.verneblad": "Verneblad",
        "chemical.inventory.verneblad.description":
          "Lag enkle instruksjoner for dine ansatte om produktets farer, førstehjelp og brannslokkingstiltak. Heng det opp i nærheten av lagringsplassen.",
        "chemical.inventory.verneblad.danger_info": "Informasjon om fare",
        "chemical.inventory.verneblad.location_risk":
          "Lokasjonspesifikk risikovudering",
        "chemical.inventory.verneblad.location": "Lokasjon",
        "chemical.inventory.verneblad.files_documents": "Filer og dokumenter",
        "chemical.inventory.verneblad.comments": "Kommentarer",
        "chemical.inventory.verneblad.log_history": "Logg og historikk",
        "chemical.inventory.verneblad.remove_product":
          "Kunne fjerne 'produktet' fra stoffkartoteket",
        "chemical.inventory.verneblad.full_risk_assessment":
          "Full risikovurdering av produktet",
        "chemical.inventory.verneblad.general_use": "Generell bruk",
        "chemical.inventory.verneblad.per_operation": "Bruk per arbeidsoperasjon",
        "chemical.inventory.verneblad.risk_documents":
          "Dokumenter til risikovurdering",
        "Nytt system": "Nytt system",
        // Events sidebar and scheduling
        "Events": "Hendelser",
        "Your schedule for the selected day": "Din plan for valgt dag",
        "Loading events...": "Laster hendelser...",
        "No events to show": "Ingen hendelser å vise",
        "Event": "Hendelse",
        "Conflict": "Konflikt",
        "item_list_handling.pick_progress_short": "{{picked}}/{{total}} plukket",
        "item_list_handling.pick_progress_tooltip": "Varehåndtering: {{picked}} av {{total}} linjer plukket. Listestatus: {{status}}.",
        "Planned time": "Planlagt tid",
        "Start": "Start",
        "End": "Slutt",
        "Location": "Sted",
        "Assumed 60 min duration for conflict check": "Antatt varighet 60 min for konfliktkontroll",
        "Executing Employee": "Utførende",
        "Agreement date": "Avtaledato",
        "Fixed time": "Fast tidspunkt",
        "Timeframe from": "Tidsrom fra",
        "Timeframe to": "Tidsrom til",
        "Appointment confirmation required": "Bekreftelse på avtale påkrevd",
        "Send email to customer": "Send e-post til kunde",
        "Phone number": "Telefonnummer",
        "Email address": "E-postadresse",
        "Manually confirm agreement": "Bekreft avtale manuelt",
        "Send confirmation reminder": "Send påminnelse om bekreftelse",
  
        // Customer Handler translations
        "customer.handler": "Kundebehandleren",
        "customer.handler.description": "Søk etter kunder, opprett samtaler og administrer kundekommunikasjon",
        "customer.handler.selected.section": "Valgt kunde",
        "customer.handler.related.information": "Relatert informasjon",
        "customer.handler.open.customer.profile": "Åpne kundeprofil",
        "customer.handler.open.customer.profile.hint": "Åpner kundeprofilen i ny fane",
        "customer.handler.no.contact.info": "Ingen adresse, e-post eller mobil registrert",
        "customer.handler.edit.customer": "Rediger kunde",
        "customer.handler.edit.communication": "Rediger",
        "customer.handler.communication.subject": "Emne",
        "customer.handler.communication.body": "Innhold",
        "customer.handler.communication.update.success": "Kommunikasjon oppdatert",
        "search.customer": "Søk kunde",
        "search.by.mobile.or.address": "Søk etter mobilnummer eller adresse",
        "search.by.mobile.or.address.hint": "Skriv inn mobilnummer eller adresse for å søke",
        "searching": "Søker...",
        "search": "Søk",
        "search.results": "Søkeresultater",
        "search.failed": "Søket feilet",
        "search.failed.server.error": "Serverfeil oppstod",
        "search.failed.server.error.message": "En feil oppstod under søket. Vennligst prøv igjen. Ikke opprett ny kunde hvis du tror kunden allerede eksisterer.",
        "search.failed.unexpected.response": "Uventet respons fra server",
        "search.error.title": "Søkefeil",
        "search.error.hint": "Vennligst prøv å søke igjen. Hvis problemet vedvarer, kontakt support. Ikke opprett duplikat kunde.",
        "create.conversation": "Opprett samtale",
        "name.or.mobile.required": "Navn eller mobilnummer er påkrevd",
        "unknown.customer": "Ukjent kunde",
        "conversation.saved": "Samtale lagret",
        "conversation.saved.and.handled": "Samtale lagret og behandlet",
        "failed.to.create.customer": "Kunne ikke opprette kunde",
        "communication.added": "Kommunikasjon lagt til",
        "failed.to.add.communication": "Kunne ikke legge til kommunikasjon",
        "communication.marked.processed": "Kommunikasjon markert som behandlet",
        "communication.marked.unprocessed": "Kommunikasjon markert som ubehandlet",
        "failed.to.update.communication": "Kunne ikke oppdatere kommunikasjon",
        "no.communications.selected": "Ingen kommunikasjoner valgt",
        "communications.linked.to.case": "Kommunikasjoner knyttet til sak",
        "failed.to.link.communications": "Kunne ikke knytte kommunikasjoner",
        "selected.communications": "Valgte kommunikasjoner",
        "link.to.case": "Knytt til sak",
        "see.more": "Se mer",
        "mark.as.processed": "Merk som behandlet",
        "channel": "Kanal",
        "direction": "Retning",
        "sent.at": "Sendt",
        "start.time": "Starttid",
        "end.time": "Sluttid",
        "related": "Relatert",
        "processed": "Behandlet",
        "unprocessed": "Ubehandlet",
        "created.by": "Opprettet av",
        "street.address": "Gateadresse",
        "postal.code": "Postnummer",
        "city": "By",
        "conversation.date": "Samtaledato",
        "conversation.time": "Samtaletid",
        "conversation.note.placeholder": "Legg til notat om samtalen...",
        "save": "Lagre",
        "handle": "Behandle",
        "selected.customer": "Valgt kunde",
        "loading": "Laster...",
        "loading.customer": "Laster kunde...",
        "communications": "Kommunikasjoner",
        "inbound": "Innkommende",
        "outbound": "Utgående",
        "no.communications": "Ingen kommunikasjoner funnet",
        "no.cases": "Ingen saker funnet",
        "upcoming.events": "Kommende hendelser",
        "no.events": "Ingen hendelser funnet",
        "add.communication": "Legg til kommunikasjon",
        "pending": "Venter",
        "handled": "Behandlet",
        "Communication": "Kommunikasjon",
        "Message": "Melding",
        "Channel": "Kanal",
        "Direction": "Retning",
        "Customer": "Kunde",
        "link.to.case.choice.description": "Ønsker du å knytte til en eksisterende sak eller opprette en ny?",
        "link.to.existing.case": "Knytt til eksisterende sak",
        "link.to.existing.case.description": "Søk og velg en eksisterende sak",
        "create.new.case": "Opprett ny sak",
        "create.new.case.description": "Opprett en ny sak og knytt kommunikasjoner",
        "search.case": "Søk sak",
        "search.case.placeholder": "Søk etter saksnummer, tittel eller kunde...",
        "no.cases.found": "Ingen saker funnet",
        "cases": "Saker",
        "customer.cases": "Kundens saker",
        "linking.communications": "Knytter kommunikasjoner...",
        "treatment.section": "Behandlingsseksjon",
        "treatment.section.description": "Alle kommunikasjoner som krever behandling",
        "search.communications": "Søk kommunikasjoner...",
        "all.statuses": "Alle statuser",
        "all.channels": "Alle kanaler",
        "phone": "Telefon",
        "email": "E-post",
        "sms": "SMS",
        "showing": "Viser",
        "of": "av",
        "customer.lock.badge": "Låst",
        "customer.lock.banner_title": "Kunden {{name}} er låst",
        "customer.lock.banner_reason": "Årsak: {{reason}}",
        "customer.lock.banner_meta": "Låst av {{who}} {{when}}",
        "customer.lock.no_reason": "Ingen årsak oppgitt",
        "customer.lock.unknown_user": "Ukjent",
        "customer.lock.open_profile": "Åpne kundeprofil",
        "customer.lock.lock_title": "Lås kunde",
        "customer.lock.unlock_title": "Lås opp kunde",
        "customer.lock.lock_action": "Lås kunde",
        "customer.lock.unlock_action": "Lås opp",
        "customer.lock.reason_label": "Hvorfor låses kunden?",
        "customer.lock.reason_required": "Du må oppgi en årsak",
        "customer.lock.unlock_help": "Kunden kan brukes til nye rapporter, prosjekter og ordre igjen.",
        "customer.lock.unlock_note": "Merknad (valgfritt)",
        "customer.lock.current_reason": "Nåværende årsak: {{reason}}",
        "customer.lock.lock_success": "Kunden er låst",
        "customer.lock.unlock_success": "Kunden er låst opp",
        "customer.lock.save_failed": "Kunne ikke oppdatere lås",
        "customer.lock.create_blocked": "Kunden er låst. Du kan ikke opprette nye poster eller flytte eksisterende hit.",
        "customer.lock.reason_too_long": "Årsaken kan ikke være lenger enn {{max}} tegn",
        "customer.lock.note_too_long": "Merknaden kan ikke være lenger enn {{max}} tegn",
        "customer.communication.export_pdf": "Eksporter PDF",
        "customer.communication.pdf_loading": "Lager PDF…",
        "customer.communication.pdf_failed": "Kunne ikke lage PDF",
        "customer.loaded": "Kunde lastet inn",
        "customer.not.found": "Kunde ikke funnet",
        "failed.to.load.communications": "Kunne ikke laste kommunikasjoner",
        "failed.to.load.customer": "Kunne ikke laste kunde",
  
        // Inventory Count translations (Norwegian)
        "inventory.counts.title": "Lageropptellinger",
        "inventory.counts.description": "Administrer lageropptellinger og lagerkontroll",
        "inventory.count.title": "Lageropptelling",
        "inventory.count.create": "Ny opptelling",
        "inventory.count.count_number": "Opptellingsnummer",
        "inventory.count.date": "Dato",
        "inventory.count.status": "Status",
        "inventory.count.status.draft": "Kladd",
        "inventory.count.status.pending_approval": "Venter på godkjenning",
        "inventory.count.status.approved": "Godkjent",
        "inventory.count.status.completed": "Fullført",
        "inventory.count.add_item": "Legg til linje",
        "inventory.count.select_product": "Velg produkt",
        "inventory.count.scan_qr": "Skann QR-kode",
        "inventory.count.import_csv": "Importer CSV/Excel",
        "inventory.count.selected_products": "Valgte produkter",
        "inventory.count.item_number": "Artikelnr",
        "inventory.count.remove": "Fjern",
        "inventory.count.note_optional": "Notat (valgfritt)",
        "inventory.count.note_placeholder": "Legg til notat...",
        "inventory.count.reset": "Nullstill",
        "inventory.count.add_products": "Legg til produkter",
        "inventory.count.add_product": "Legg til produkt",
        "inventory.count.add_scanned_product": "Legg til skannet produkt",
        "inventory.count.scan_another": "Skann et annet",
        "inventory.count.select_products": "Velg produkter",
        "inventory.count.products_selected": "{{count}} produkt(er) valgt",
        "inventory.count.qr.required": "Skriv inn eller skann en QR-kode",
        "inventory.count.qr.placeholder": "Skriv produktnummer eller skann QR-kode",
        "inventory.count.product.already_selected": "Produktet er allerede valgt",
        "inventory.count.product.added": "Produkt lagt til",
        "inventory.count.product.not_found": "Produkt ikke funnet. Prøv manuell søk.",
        "inventory.count.product.search_error": "Kunne ikke søke etter produkt",
        "inventory.count.product.select_required": "Velg minst ett produkt",
        "inventory.count.items": "Linjer",
        "inventory.count.product": "Produkt",
        "inventory.count.quantity": "Mengde",
        "inventory.count.purchase_price": "Innkjøpspris",
        "inventory.count.total": "Total",
        "inventory.count.note": "Notat",
        "inventory.count.total_items": "Antall linjer",
        "inventory.count.total_quantity": "Total mengde",
        "inventory.count.no_items": "Ingen linjer",
        "inventory.count.no_items_description": "Legg til linjer for å starte opptellingen",
        "inventory.count.item.added": "Linje lagt til",
        "inventory.count.item.add_error": "Kunne ikke legge til linje",
        "inventory.count.item.updated": "Linje oppdatert",
        "inventory.count.item.update_error": "Kunne ikke oppdatere linje",
        "inventory.count.item.deleted": "Linje fjernet",
        "inventory.count.item.delete_error": "Kunne ikke fjerne linje",
        "inventory.count.item.delete_confirm": "Er du sikker på at du vil fjerne denne linjen?",
        "inventory.count.quantity_required": "Mengde må være større enn 0",
        "inventory.count.csv.import_title": "Importer linjer fra CSV/Excel",
        "inventory.count.csv.drop_here": "Slipp fil her",
        "inventory.count.csv.drop_or_select": "Dra og slipp en fil her, eller klikk for å velge",
        "inventory.count.csv.supported_formats": "CSV, XLS, XLSX",
        "inventory.count.csv.file_selected": "Fil valgt",
        "inventory.count.csv.change_file": "Bytt fil",
        "inventory.count.csv.column_mapping": "Kolonnemapping",
        "inventory.count.csv.field.product_id": "Produkt ID",
        "inventory.count.csv.field.item_number": "Artikelnr",
        "inventory.count.csv.field.title": "Tittel",
        "inventory.count.csv.field.quantity": "Mengde",
        "inventory.count.csv.field.purchase_price": "Innkjøpspris",
        "inventory.count.csv.field.note": "Notat",
        "inventory.count.csv.not_mapped": "Ikke mappet",
        "inventory.count.csv.preview": "Forhåndsvisning",
        "inventory.count.csv.first_rows": "første rader",
        "inventory.count.csv.import": "Importer",
        "inventory.count.csv.importing": "Importerer...",
        "inventory.count.csv.import_success": "Importerte {{count}} linjer",
        "inventory.count.csv.import_error": "Kunne ikke importere linjer",
        "inventory.count.csv.bulk_create_error": "Kunne ikke opprette produkter i bulk",
        "inventory.count.csv.mapping_required": "Vennligst map minst Produkt ID eller Artikelnr",
        "inventory.count.csv.no_headers": "Kunne ikke oppdage CSV-overskrifter",
        "inventory.count.csv.read_error": "Feil ved lesing av fil",
        "inventory.count.csv.processing_error": "Feil ved behandling av fil",
        "inventory.count.csv.product_not_found": "Produkt ikke funnet",
        "inventory.count.csv.product_search_error": "Feil ved søk etter produkt",
        "inventory.count.csv.product_id_required": "Produkt ID eller Artikelnr påkrevd",
        "inventory.count.csv.no_valid_items": "Ingen gyldige linjer funnet i filen",
        "inventory.count.csv.missing_products_title": "Produkter ikke funnet",
        "inventory.count.csv.missing_products_message": "{{count}} produkt(er) ble ikke funnet i systemet. Velg handling for hver:",
        "inventory.count.csv.action": "Handling",
        "inventory.count.csv.add_as_new": "Legg til som nytt produkt",
        "inventory.count.csv.skip": "Hopp over",
        "inventory.count.csv.continue_import": "Fortsett import",
        "inventory.count.csv.processing_items": "Behandler {{current}} av {{total}} produkter",
        "inventory.count.csv.processing": "Behandler...",
        "inventory.count.csv.partial_import_success": "Importerte {{imported}} linjer, {{missing}} produkter ikke funnet",
        "inventory.count.csv.no_items_to_import": "Ingen linjer å importere",
        "inventory.count.duplicate.title": "Produkt finnes allerede i listen",
        "inventory.count.duplicate.message": "Dette produktet ligger allerede i opptellingslisten. Ønsker du å legge til ytterligere en linje?",
        "inventory.count.duplicate.added_at": "Lagt til",
        "inventory.count.duplicate.confirm": "Legg til linje",
        "inventory.counts.search_placeholder": "Søk i lageropptellinger...",
        "inventory.counts.filter_title": "Filtrer på status",
        "inventory.count.new_title": "Ny lageropptelling",
        "inventory.count.title_required": "Tittel er påkrevd",
        "inventory.count.date_required": "Dato er påkrevd",
        "inventory.count.storage_required": "Lager er påkrevd",
        "inventory.count.storage": "Lager",
        "inventory.count.coverage": "Dekning",
        "inventory.count.coverage_full": "Full telling av lageret",
        "inventory.count.coverage_partial": "Delvis telling",
        "inventory.count.coverage_help": "Full telling kreves for inngående lagerverdi. Nye tellinger med valgt lager lagres som full. Godkjente delvise tellinger kan settes til full her.",
        "inventory.count.mark_coverage_full": "Sett som full telling",
        "inventory.count.mark_coverage_partial": "Sett som delvis",
        "inventory.count.coverage_set_full": "Tellingen er merket som full dekning",
        "inventory.count.coverage_set_partial": "Tellingen er merket som delvis",
        "inventory.count.coverage_update_error": "Kunne ikke oppdatere dekning",
        "inventory.count.missing_cost_warning_title": "Kostpris mangler på tellingen",
        "inventory.count.missing_cost_warning_body": "{{count}} linje(r) med antall mangler kostpris. Fyll inn innkjøpspris eller velg fra prishistorikk før godkjenning av lagerverdi.",
        "inventory.count.missing_cost_line": "Kostpris mangler",
        "inventory.count.load_price_history": "Hent prishistorikk",
        "inventory.count.retry_price_history": "Prøv prishistorikk på nytt",
        "inventory.count.price_history": "Historisk kostpris",
        "inventory.count.use_history_for_count_date": "Bruk pris for telledato",
        "inventory.count.price_history_load_error": "Kunne ikke hente prishistorikk",
        "inventory.count.price_history_empty": "Fant ingen historisk kostpris for telledatoen",
        "inventory.count.select_storage": "Velg lager",
        "inventory.count.create_success": "Lageropptelling opprettet",
        "inventory.count.create_error": "Kunne ikke opprette lageropptelling",
        "inventory.count.approve": "Godkjenn",
        "inventory.count.unapprove": "Avgodkjenn",
        "inventory.count.approve_all": "Godkjenn alle",
        "inventory.count.unapprove_all": "Avgodkjenn alle",
        "inventory.count.approve_all_success": "{{count}} linjer godkjent",
        "inventory.count.approve_all_error": "Kunne ikke godkjenne alle linjer",
        "inventory.count.all_items_already_approved": "Alle linjer er allerede godkjent",
        "inventory.count.approved": "Godkjent",
        "inventory.count.approved_at": "Godkjent",
        "inventory.count.approved_by": "Godkjent av",
        "inventory.count.approve_success": "Opptelling godkjent",
        "inventory.count.approve_error": "Kunne ikke godkjenne opptelling",
        "inventory.count.unapprove_success": "Opptelling avgodkjent",
        "inventory.count.unapprove_error": "Kunne ikke avgodkjenne opptelling",
        "inventory.count.copy": "Kopier opptelling",
        "inventory.count.no_title": "Ingen tittel",
        "inventory.count.could_not_load": "Kunne ikke laste lageropptellinger",
        "inventory.count.no_counts_found": "Ingen lageropptellinger funnet",
        "inventory.count.create_new": "Opprett en ny lageropptelling",
        "selected": "valgt",
        "Select": "Velg",
        "Select all": "Velg alle",
        "Updated": "Oppdatert",
        "Created": "Opprettet",
        "inventory.count.copy_from_previous": "Kopier fra tidligere opptelling",
        "inventory.count.copy_all_products": "Kopier alle produkter fra lager",
        "inventory.count.select_count_to_copy": "Velg opptelling å kopiere",
        "inventory.count.copy_success": "Opptelling kopiert",
        "inventory.count.copy_error": "Kunne ikke kopiere opptelling",
        "inventory.count.copy_products_success": "Produkter kopiert",
        "inventory.count.copy_products_error": "Kunne ikke kopiere produkter",
        "inventory.count.approved_items": "Godkjente linjer",
        "inventory.count.approve_count": "Godkjenn opptelling",
        "inventory.count.date_updated": "Dato oppdatert",
        "inventory.count.date_update_error": "Kunne ikke oppdatere dato",
        "inventory.count.storage_updated": "Lager oppdatert",
        "inventory.count.storage_update_error": "Kunne ikke oppdatere lager",
        "inventory.count.no_storage": "Ingen lager",
        "inventory.count.export_pdf": "Eksporter PDF",
        "inventory.count.export_csv": "Eksporter CSV/Excel",
        "inventory.count.export_pdf_success": "PDF eksportert",
        "inventory.count.export_pdf_error": "Kunne ikke eksportere PDF",
        "inventory.count.export_csv_success": "CSV eksportert",
        "inventory.count.export_csv_error": "Kunne ikke eksportere CSV",
        "product.stock_report.title": "Lagerrapport",
        "product.stock_report.description": "Komplett oversikt over alle lagerbevegelser (inn/ut) og hvor produktet er registrert (varetelling, korreksjon, ordre, rapport, etc.)",
        "product.stock_report.count_sets_hint": "Godkjent varetelling setter ny saldo for produktet på lageret. Telte antall summeres ikke oppå forrige saldo.",
        "product.stock_report.quantity_set": "Sett til {{quantity}}",
        "product.stock_report.quantity_set_delta": "Justering {{quantity}}",
        "product.stock_report.quantity_not_counted": "Ikke telt",
        "product.stock_report.date": "Dato",
        "product.stock_report.type": "Type",
        "product.stock_report.transaction_title": "Tittel",
        "product.stock_report.quantity": "Antall",
        "product.stock_report.storage": "Lager",
        "product.stock_report.status": "Status",
        "product.stock_report.approved": "Godkjent",
        "product.stock_report.pending": "Venter",
        "product.stock_report.no_transactions": "Ingen transaksjoner",
        "product.stock_report.no_transactions_description": "Ingen lagerbevegelser funnet for dette produktet",
        "inventory.count.product_stock": "Produktbeholdning",
        "inventory.count.tracked_quantity": "Lagerført antall",
        "inventory.count.available_quantity": "Tilgjengelig antall",
        "inventory.count.incoming_quantity": "Inngående antall",
        "inventory.count.outgoing_quantity": "Utgående antall",
        "inventory.count.sales_price": "Salgspris",

        "inventory.settings.title": "Lagerinnstillinger",
        "inventory.settings.subtitle": "Administrer lagre og plukkeliste",
        "inventory.settings.new_storage": "Nytt lager",
        "inventory.settings.storages": "Lagre",

        "inventory.picking.title": "Plukkliste",
        "inventory.picking.subtitle": "Ordre, arbeidsordre og servicerapporter — linjer som skal plukkes",
        "inventory.picking.hero_kicker": "Lager",
        "inventory.picking.filters_heading": "Filter og søk",
        "inventory.picking.filters_description": "Avgrens hvilke dokumenttyper og linjer som vises. Ordre er av som standard — velg Ordre for å ta dem med.",
        "inventory.picking.list_kicker": "Plukk",
        "inventory.picking.list_title": "Dokumenter og linjer",
        "inventory.picking.list_description": "Utvid hvert dokument for å se produktlinjer, velge lager og registrere plukk.",
        "inventory.picking.loading": "Laster…",
        "inventory.picking.empty_title": "Ingen linjer å vise",
        "inventory.picking.picked_label": "Plukket",
        "inventory.picking.meta.groups": "Grupper",
        "inventory.picking.meta.lines": "Linjer",
        "inventory.picking.search_placeholder": "Søk ordre, produkt, varenummer…",
        "inventory.picking.filter.unpicked_only": "Kun ikke plukket / delvis",
        "inventory.picking.filter.warehouse_only": "Kun lagerprodukter",
        "inventory.picking.filter.warehouse_only_help": "Når på, vises kun linjer der produktet er merket som lagerstyrt. Er alle produktene det, ser listen lik ut med og uten filter. Når av, vises alle linjer; produkter uten lagerstyring får amber-rad og merket «Ikke lagerstyrt».",
        "inventory.picking.filter.include_skipped": "Vis «skal ikke plukkes»",
        "inventory.picking.filter.include_skipped_help": "Linjer markert som skal ikke plukkes er skjult som standard. Slå på for å se dem igjen (f.eks. for å fjerne merket).",
        "inventory.picking.non_warehouse_badge": "Ikke lagerstyrt",
        "inventory.picking.non_warehouse_hint": "Produktet er ikke merket for lagerstyring. Du kan likevel plukke og velge lager ved behov.",
        "inventory.picking.refresh": "Oppdater",
        "inventory.picking.empty": "Ingenting å plukke med gjeldende filtre.",
        "inventory.picking.load_error": "Kunne ikke hente plukkliste",
        "inventory.picking.open_source": "Åpne dokument",
        "inventory.picking.open_document_short": "Åpne",
        "inventory.picking.open_item_list": "Vareliste",
        "inventory.picking.qty": "Antall",
        "inventory.picking.qty_picked": "Plukket",
        "inventory.picking.storage": "Lager",
        "inventory.picking.pick_storage": "Lager",
        "inventory.picking.storage_placeholder": "Velg lager…",
        "inventory.picking.storage_required": "Velg lager før du merker som plukket",
        "inventory.picking.toggle_picked": "Merk plukket",
        "inventory.picking.marked_picked": "Merket som plukket",
        "inventory.picking.marked_unpicked": "Plukk fjernet",
        "inventory.picking.toggle_error": "Kunne ikke oppdatere linje",
        "inventory.picking.skip.label": "Skal ikke plukkes",
        "inventory.picking.skip.badge": "Skal ikke plukkes",
        "inventory.picking.skip.row_hint": "Denne linjen er utenfor plukk på lager. Fjern «Skal ikke plukkes» hvis den skal plukkes.",
        "inventory.picking.skip.blocks_pick": "Fjern «Skal ikke plukkes» før du merker som plukket.",
        "inventory.picking.skip.on": "Merket som skal ikke plukkes",
        "inventory.picking.skip.off": "Linjen kan plukkes igjen",
        "inventory.picking.skip.error": "Kunne ikke oppdatere «skal ikke plukkes»",
        "inventory.picking.send_reminder": "Send påminnelse",
        "inventory.picking.reminder_sent": "Påminnelse lagt i kø",
        "inventory.picking.reminder_error": "Kunne ikke sende påminnelse",
        "inventory.picking.delivery_note.tooltip": "Skriv ut følgeseddel (PDF)",
        "inventory.picking.delivery_note.opened": "Følgeseddel åpnet i ny fane",
        "inventory.picking.delivery_note.failed": "Kunne ikke lage følgeseddel-PDF",
        "inventory.picking.delivery_note.missing_id": "Mangler dokument-id",
        "inventory.picking.delivery_note.unsupported": "Følgeseddel er ikke tilgjengelig for denne dokumenttypen ennå",
        "inventory.picking.module.order": "Ordre",
        "inventory.picking.module.work_order": "Arbeidsordre",
        "inventory.picking.module.report": "Rapport",
        "inventory.picking.execution_on": "Utførelsesdato",
        "inventory.picking.status.invoiced": "Fakturert",
        "inventory.picking.status.used_job": "Brukt på oppdrag",
        "inventory.picking.status.in_vehicle": "Tatt med i bil",
        "inventory.picking.status.not_used": "Ikke brukt",
        "inventory.picking.status.returned": "Lagt tilbake på lager",
        "inventory.picking.status.left_vehicle": "Ligger i bil",
        "inventory.picking.status.picked": "Plukket",
        "inventory.picking.status.not_picked": "Ikke plukket",
        "inventory.picking.settings.title": "Påminnelser for plukkliste",
        "inventory.picking.settings.description": "Brukere som får e-post når du bruker «Send påminnelse» på plukkelista.",
        "inventory.picking.settings.recipients": "Mottakere",
        "inventory.picking.settings.recipients_placeholder": "Velg brukere…",
        "inventory.picking.settings.save": "Lagre",
        "inventory.picking.settings.saving": "Lagrer…",
        "inventory.picking.settings.saved": "Innstillinger lagret",
        "inventory.picking.settings.save_error": "Kunne ikke lagre innstillinger",
        "inventory.picking.settings.load_error": "Kunne ikke hente plukkeinnstillinger",

        "Exporting...": "Eksporterer...",
        "Processing...": "Behandler...",
        
        // Offer Calculation translations (Norwegian)
        "offer.calculation.title": "Kalkyler / Tilbudsposter",
        "offer.calculation.subtitle": "Administrer kalkyler og tilbudsposter",
        "offer.calculation.new": "Ny kalkyle",
        "offer.calculation.create.dialog_title": "Ny kalkyle",
        "offer.calculation.create.dialog_hint": "Velg kalkyleoppsett og fyll inn tittel før du åpner byggeren. Oppsettet låses etter opprettelse.",
        "offer.calculation.create.mode_subtitle": "Velg om kalkylen skal bruke linjer eller modulbygger.",
        "offer.calculation.create.title_label": "Tittel",
        "offer.calculation.create.title_required": "Tittel er påkrevd",
        "offer.calculation.create.description_label": "Beskrivelse",
        "offer.calculation.create.cancel": "Avbryt",
        "offer.calculation.create.submit": "Opprett og åpne",
        "offer.calculation.create.use_template": "Bruk eksisterende mal",
        "offer.calculation.create.use_template_hint": "Kopier innholdet fra en firmamal til en ny kalkyle. Valgfri TPL-veiviser kjører når malen krever det.",
        "offer.calculation.search_placeholder": "Søk i kalkyler...",
        "offer.calculation.name": "Navn",
        "offer.calculation.type": "Type",
        "offer.calculation.status": "Status",
        "offer.calculation.total": "Total",
        "offer.calculation.actions": "Handlinger",
        "offer.calculation.view": "Vis",
        "offer.calculation.edit": "Rediger",
        "offer.calculation.delete": "Slett",
        "offer.calculation.delete_confirm": "Er du sikker på at du vil slette denne kalkylen?",
        "offer.calculation.no_results": "Ingen kalkyler funnet",
        "offer.calculation.active": "Aktiv",
        "offer.calculation.inactive": "Inaktiv",
        "offer.calculation.type.standard": "Standard",
        "offer.calculation.type.product": "Produkt",
        "offer.calculation.type.hours": "Timer",
        "offer.calculation.type.car_allowance": "Bilgodtgjørelse",
        "offer.calculation.type.nested": "Nestet",
        "offer.calculation.line": "linje",
        "offer.calculation.lines": "linjer",
        "offer.calculation.delete_success": "Kalkyle ble slettet",
        "offer.calculation.delete_error": "Kunne ikke slette kalkyle",
        "offer.calculation.untitled": "Uten tittel",
        "offer.calculation.mode.title": "Velg kalkyleoppsett",
        "offer.calculation.mode.subtitle": "Velg om denne kalkylen skal bygges som vanlige linjer eller med modulbygger. Dette låses etter at kalkylen er lagret.",
        "offer.calculation.mode.lines_title": "Kalkyle pr. linje",
        "offer.calculation.mode.lines_hint": "Bruk dagens linjebaserte kalkyle med produkter, timer og manuelle rader.",
        "offer.calculation.mode.modules_title": "Modulbygger",
        "offer.calculation.mode.modules_hint": "Bygg en visuell flyt med produkter, timer, formler og piler.",
        "offer.calculation.mode.locked_hint": "Kalkyleoppsett er låst etter opprettelse for å unngå at linjer og modulbygger blandes.",
        "offer.calculation.settings.open": "Innstillinger",
        "offer.calculation.settings.title": "Kalkyleinnstillinger",
        "offer.calculation.settings.subtitle": "Tittel, kalkyleoppsett og visning.",
        "offer.calculation.settings.done": "Ferdig",
        "offer.calculation.settings.unsaved": "Ulagrede endringer",
        "offer.calculation.settings.save_hint": "Lagre med lagre-linjen nederst på siden.",
        "offer.calculation.builder.section_title": "Kalkylebygger",
        "offer.calculation.builder.section_hint": "Behold dagens linjer, eller bygg en visuell modulbasert kalkyle som kan kobles til backend senere.",
        "offer.calculation.builder.section_hint_lines": "Denne kalkylen er linjebasert. Bruk linjer, produkter, timer og manuelle rader.",
        "offer.calculation.builder.section_hint_modules": "Denne kalkylen bruker modulbygger. Bygg flyten visuelt og test den i brukervisning.",
        "offer.calculation.builder.tab_lines": "Linjer",
        "offer.calculation.builder.tab_modules": "Modulbygger",
        "offer.calculation.builder.tab_insert": "Innsettingsvisning",
        "offer.calculation.builder.tab_history": "Historikk",
        "offer.calculation.builder.history_hint": "Åpne malversjoner for å se tidligere lagrede utgaver og gjenopprette ved behov.",
        "offer.calculation.page.kicker": "Tilbudskalkyle",
        "offer.calculation.page.subtitle": "Bygg, test og bruk kalkyler i full bredde med linjer, moduler og en egen innlimingsvisning.",
        "offer.calculation.insert.title": "Innsettingsvisning",
        "offer.calculation.insert.subtitle": "Slik ser kalkylen ut for den som setter den inn i et tilbud.",
        "offer.calculation.insert.inputs_title": "Justerbare felt",
        "offer.calculation.insert.inputs_hint": "Kun felt som ikke er låst kan endres her, for eksempel antall kilometer, prosent og fordeling.",
        "offer.calculation.insert.flow_title": "Slik henger kalkylen sammen",
        "offer.calculation.insert.flow_hint": "Bokser og koblinger vises som et readonly kart, mens tallene oppdateres live.",
        "offer.calculation.insert.fields_tab": "Juster felt",
        "offer.calculation.insert.map_tab": "Kart",
        "offer.calculation.insert.offer_dialog_title": "Tilpass kalkyle før den legges til tilbudet",
        "offer.calculation.insert.offer_cancel": "Avbryt",
        "offer.calculation.insert.offer_add": "Legg til i tilbud",
        "offer.calculation.insert.adjust_fields": "Juster felter",
        "offer.calculation.insert.edit_lines": "Rediger kalkyle",
        "offer.calculation.insert.adjustable_fields": "Justerbare felter",
        "offer.calculation.insert.adjustable_fields_hint": "Denne kalkylen bruker modulbygger. Åpne justering for å endre antall, kilometer, prosent og andre åpne felter.",
        "offer.calculation.module.palette_title": "Moduler",
        "offer.calculation.module.globals.title": "Globale parametre",
        "offer.calculation.module.globals.hint": "Verdier for hele modulen. Kryss av «Spør ved bruk» for mal-veiviseren.",
        "offer.calculation.module.globals.ask_on_use": "Spør ved bruk",
        "offer.calculation.module.globals.value": "Verdi",
        "offer.calculation.module.globals.add": "Legg til parameter",
        "offer.calculation.module.globals.remove": "Fjern",
        "offer.calculation.module.globals.key_placeholder": "nøkkel (f.eks. unit_count)",
        "offer.calculation.module.globals.label_placeholder": "Visningsnavn",
        "offer.calculation.module.tabs.label": "Modulbygger-faner",
        "offer.calculation.module.tabs.content": "Innhold",
        "offer.calculation.module.tabs.questions": "Spørsmål",
        "offer.calculation.module.tabs.rules": "Regler",
        "offer.calculation.module.tabs.offer_text": "Tilbudstekst",
        "offer.calculation.module.tabs.test": "Test",
        "offer.calculation.module.offer_text.hint": "Tekst som følger malen. Kundetekst kan også styres av presentasjonsregler.",
        "offer.calculation.module.offer_text.customer_note": "Kundetekst (modul)",
        "offer.calculation.module.offer_text.title_field": "Kalkyltittel",
        "offer.calculation.module.offer_text.description_field": "Kalkylebeskrivelse",
        "offer.calculation.module.rules.title": "Regler",
        "offer.calculation.module.rules.hint": "Enkle hvis/så-regler: når en global har en verdi, slå noder av/på.",
        "offer.calculation.module.rules.add": "Legg til regel",
        "offer.calculation.module.rules.pick_global": "Velg parameter…",
        "offer.calculation.module.rules.pick_node": "Velg node…",
        "offer.calculation.module.rules.equals_placeholder": "er lik…",
        "offer.calculation.module.rules.disable_node": "Slå av node",
        "offer.calculation.module.rules.enable_node": "Slå på node",
        "offer.calculation.module.rules.summary": "Hvis {{global}} = «{{equals}}» → {{action}} ({{node}})",
        "offer.calculation.module.palette_hint": "Klikk for å legge til på lerretet.",
        "offer.calculation.module.add": "Legg til",
        "offer.calculation.module.canvas_title": "Modulkart",
        "offer.calculation.module.canvas_hint": "Dra på kartet. Dobbeltklikk et kort for å åpne innstillinger.",
        "offer.calculation.module.connecting_hint": "Velg neste boks for å lage en kobling.",
        "offer.calculation.module.reset_example": "Nullstill til eksempel",
        "offer.calculation.module.zoom_out": "Zoom ut",
        "offer.calculation.module.zoom_in": "Zoom inn",
        "offer.calculation.module.reset_view": "Nullstill visning",
        "offer.calculation.module.json.open_dialog": "JSON / AI",
        "offer.calculation.module.json.dialog_title": "JSON og AI for modulbygger",
        "offer.calculation.module.json.tab_json": "Lim inn JSON",
        "offer.calculation.module.json.tab_ai_guide": "AI-instruksjoner",
        "offer.calculation.module.json.hint": "Lim inn JSON fra ChatGPT eller annen AI, eller rediger eksisterende modulgraf. Støtter full module_graph eller { \"nodes\": [...], \"edges\": [...] }. Bruk JSON oppdaterer bare editoren — du må fortsatt lagre kalkylen.",
        "offer.calculation.module.json.replace": "Erstatt hele grafen",
        "offer.calculation.module.json.append": "Legg til på lerretet",
        "offer.calculation.module.json.copy_json": "Kopier JSON",
        "offer.calculation.module.json.reload_from_editor": "Last inn fra editor",
        "offer.calculation.module.json.insert_sample": "Sett inn eksempel",
        "offer.calculation.module.json.apply": "Bruk JSON",
        "offer.calculation.module.json.applied": "{{count}} noder importert",
        "offer.calculation.module.json.copy_success": "JSON kopiert",
        "offer.calculation.module.json.reload_success": "JSON lastet inn fra editor",
        "offer.calculation.module.json.clipboard_failed": "Kunne ikke kopiere til utklippstavle",
        "offer.calculation.module.json.ai_guide_intro": "Kopier instruksjonene nedenfor til ChatGPT, Claude eller annen AI. Lim deretter JSON-svaret inn i fanen «Lim inn JSON».",
        "offer.calculation.module.json.copy_ai_guide": "Kopier AI-instruksjoner",
        "offer.calculation.module.json.ai_guide_copied": "AI-instruksjoner kopiert",
        "offer.calculation.module.json.generate_with_ai": "Generer med AI",
        "offer.calculation.module.json.ai_parse_error": "Kunne ikke lese AI-svar som modulgraf-JSON",
        "offer.calculation.module.json.ai_apply_success": "{{count}} noder lagt inn fra AI",
        "offer.calculation.module.json.error_empty": "JSON-feltet er tomt",
        "offer.calculation.module.json.error_invalid_json": "Ugyldig JSON — sjekk syntaks",
        "offer.calculation.module.json.error_invalid_graph": "Fant ingen gyldig modulgraf i JSON",
        "offer.calculation.module.json.error_no_nodes": "Fant ingen noder i JSON",
        "offer.calculation.module.json.error_missing_id": "En eller flere noder mangler id",
        "offer.calculation.module.json.error_unknown_type": "Ukjent nodetype i JSON",
        "offer.calculation.module.json.error_missing_edge_target": "En pil peker på en node som ikke finnes",
        "offer.calculation.module.json.error_unsafe_formula": "Formelen er ugyldig eller bruker funksjoner som ikke støttes",
        "offer.calculation.module.json.error_circular": "Grafen har en sirkulær referanse",
        "offer.calculation.module.result_title": "Resultat",
        "offer.calculation.module.result_hint": "Sum eks. mva. Forhåndsvisning oppdateres mens du redigerer; lagre for server-total.",
        "offer.calculation.module.editor_title": "Rediger valgt modul",
        "offer.calculation.module.selected_title": "Valgt modul",
        "offer.calculation.module.settings.values": "Verdier",
        "offer.calculation.module.selected_empty": "Klikk en modul på kartet for å redigere tittel, beløp og koblinger.",
        "offer.calculation.module.editor_hint_computed": "Beregnes automatisk fra modulene som peker inn.",
        "offer.calculation.module.editor_hint_editable": "Endringer oppdaterer delsum og total umiddelbart.",
        "offer.calculation.module.editor_mode.simple": "Enkel",
        "offer.calculation.module.editor_mode.advanced": "Avansert",
        "offer.calculation.module.duplicate": "Dupliser",
        "offer.calculation.module.copy_suffix": "(kopi)",
        "offer.calculation.module.auto": "auto",
        "offer.calculation.module.meta.percent": "Påslag {{percent}} %",
        "offer.calculation.module.meta.divisor": "Fordeles på {{divisor}}",
        "offer.calculation.module.meta.fixed": "Fast beløp",
        "offer.calculation.module.meta.service_hours": "Fast beløp · {{hours}} t × {{rate}}",
        "offer.calculation.module.meta.product_lines": "{{count}} linjer",
        "offer.calculation.module.meta.formula": "Egendefinert",
        "offer.calculation.module.meta.subtotal": "Delsum",
        "offer.calculation.module.meta.total": "Sluttpunkt",
        "offer.calculation.module.meta.note": "Uten beløp",
        "offer.calculation.module.edge_title": "Rediger pil",
        "offer.calculation.module.breakdown_title": "Fordeling",
        "offer.calculation.module.connect": "Koble",
        "offer.calculation.module.connect_here": "Koble hit",
        "offer.calculation.module.remove": "Fjern",
        "offer.calculation.module.remove_edge": "Fjern pil",
        "offer.calculation.module.locked": "Låst",
        "offer.calculation.module.unlocked": "Åpen",
        "offer.calculation.module.enabled": "Aktiv",
        "offer.calculation.module.disabled": "Inaktiv",
        "offer.calculation.module.operation.add": "Legg til",
        "offer.calculation.module.operation.subtract": "Trekk fra",
        "offer.calculation.module.scope.all": "Hele jobben",
        "offer.calculation.module.scope.work": "Kun jobb",
        "offer.calculation.module.scope.driving": "Kun kjøring",
        "offer.calculation.module.scope.selected": "Valgte moduler",
        "offer.calculation.module.field.title": "Tittel",
        "offer.calculation.module.field.insert_order": "Rekkefølge i tilpass-mal",
        "offer.calculation.module.field.insert_order_hint": "La stå tom for automatisk rekkefølge (hierarki øverst → ned). Lavere tall vises først.",
        "offer.calculation.module.field.amount": "Beløp",
        "offer.calculation.module.field.enabled": "Status",
        "offer.calculation.module.field.quantity": "Antall",
        "offer.calculation.module.field.unit_price": "Enhetspris",
        "offer.calculation.module.field.product_name": "Produktnavn",
        "offer.calculation.module.field.hours": "Timer",
        "offer.calculation.module.field.estimated_hours": "Estimert timeforbruk",
        "offer.calculation.module.field.hourly_rate": "Timesats",
        "offer.calculation.module.field.cost_hourly_rate": "Kost-timesats",
        "offer.calculation.module.field.percent": "Prosent",
        "offer.calculation.module.field.percent_mode": "Type",
        "offer.calculation.module.percent_mode.markup": "Påslag",
        "offer.calculation.module.percent_mode.discount": "Rabatt",
        "offer.calculation.module.field.scope": "Gjelder",
        "offer.calculation.module.field.divisor": "Fordeles på",
        "offer.calculation.module.field.expression": "Formel",
        "offer.calculation.module.field.note": "Notat",
        "offer.calculation.module.field.operation": "Operasjon",
        "offer.calculation.module.formula.assistant_title": "Formelhjelp",
        "offer.calculation.module.formula.assistant_subtitle": "Velg en ferdig mal, eller trykk på variabler og funksjoner. Du trenger ikke huske Excel-syntaks.",
        "offer.calculation.module.formula.templates": "Ferdige maler",
        "offer.calculation.module.formula.variables": "Sett inn verdi",
        "offer.calculation.module.formula.functions": "Smarte funksjoner",
        "offer.calculation.module.formula.example_title": "Tips",
        "offer.calculation.module.formula.example_text": "`input` er summen fra pilene inn til {{title}}. Start med en mal og juster tallene.",
        "offer.calculation.module.formula.variable.input": "Sum fra piler inn",
        "offer.calculation.module.formula.variable.quantity": "Eget antall",
        "offer.calculation.module.formula.variable.price": "Egen pris",
        "offer.calculation.module.formula.variable.percent": "Egen prosent",
        "offer.calculation.module.formula.function.sum": "Summer flere tall",
        "offer.calculation.module.formula.function.round": "Rund av til heltall",
        "offer.calculation.module.formula.function.min": "Makspris-tak",
        "offer.calculation.module.formula.function.max": "Minimumspris",
        "offer.calculation.module.formula.function.if": "Hvis-så-ellers",
        "offer.calculation.module.formula.template.same": "Bruk summen som den er",
        "offer.calculation.module.formula.template.fixed_add": "Legg til fast beløp",
        "offer.calculation.module.formula.template.fixed_subtract": "Trekk fra fast beløp",
        "offer.calculation.module.formula.template.ten_percent": "Legg på 10 %",
        "offer.calculation.module.formula.template.custom_percent": "Legg på egen %",
        "offer.calculation.module.formula.template.input_times_quantity": "Gange inngående med antall",
        "offer.calculation.module.formula.template.quantity_price": "Antall ganger pris",
        "offer.calculation.module.formula.template.split_two": "Del på 2",
        "offer.calculation.module.formula.template.round": "Rund av totalen",
        "offer.calculation.module.formula.template.if": "Hvis beløp er over 0",
        "offer.calculation.module.formula.node_refs": "Andre moduler",
        "offer.calculation.module.formula.globals": "Globale verdier",
        "offer.calculation.module.node.service": "Tjeneste",
        "offer.calculation.module.node.service_hint": "Fast beløp som kan låses, f.eks. leilighet. Estimert timeforbruk og timesats telles i timer totalt.",
        "offer.calculation.module.node.quantity": "Antall x pris",
        "offer.calculation.module.node.quantity_hint": "Antall ganger enhetspris, f.eks. kilometer.",
        "offer.calculation.module.node.product_price": "Produktpris",
        "offer.calculation.module.node.product_price_hint": "Produktnavn, antall og pris i én modul.",
        "offer.calculation.module.node.product_catalog": "Produktliste",
        "offer.calculation.module.node.product_catalog_hint": "Legg til produkter fra produktregisteret eller manuelle produktlinjer.",
        "offer.calculation.module.node.labor_hours": "Timefelt",
        "offer.calculation.module.node.labor_hours_hint": "Timer ganger timesats, f.eks. tilleggsarbeid eller servicearbeid.",
        "offer.calculation.module.node.percentage": "Prosent",
        "offer.calculation.module.node.percentage_hint": "Påslag eller rabatt på inngående moduler.",
        "offer.calculation.module.node.distribution": "Fordeling",
        "offer.calculation.module.node.distribution_hint": "Fordel inngående beløp på X.",
        "offer.calculation.module.node.formula": "Spesialformel",
        "offer.calculation.module.node.formula_hint": "F.eks. gange delsummering med antall: koble inn → sett antall. Formel: input × quantity.",
        "offer.calculation.module.node.subtotal": "Delsummering",
        "offer.calculation.module.node.subtotal_hint": "Samler flere inngående moduler til en delsum.",
        "offer.calculation.module.node.total": "Total",
        "offer.calculation.module.node.total_hint": "Sluttpunkt for kalkylen.",
        "offer.calculation.module.node.note": "Notat",
        "offer.calculation.module.node.note_hint": "Forklarende boks uten beløp.",
        "offer.calculation.module.product.title": "Produkter",
        "offer.calculation.module.product.hint": "Velg produkter fra registeret eller legg inn egne produktlinjer.",
        "offer.calculation.module.product.add_from_catalog": "Legg til fra produktregister",
        "offer.calculation.module.product.add_manual": "Manuell linje",
        "offer.calculation.module.product.empty": "Ingen produkter lagt til ennå.",
        "offer.calculation.module.product.manual_title": "Manuelt produkt",
        "offer.calculation.module.product.include": "Ta med",
        "offer.calculation.module.product.exclude": "Utelat",
        "offer.calculation.module.product.total": "Produkttotal",
        "offer.calculation.module.product.cancel": "Avbryt",
        "offer.calculation.module.product.add_selected": "Legg til valgte",
        "offer.calculation.product_list.title": "Produktliste",
        "offer.calculation.product_list.hint": "Legg til produkter fra registeret, eller manuelle linjer som du knytter til et produkt. Ved bruk av malen velger brukeren hvilke som skal med.",
        "offer.calculation.product_list.label": "Listenavn",
        "offer.calculation.product_list.mode_single": "Velg ett (f.eks. aggregat)",
        "offer.calculation.product_list.mode_multi": "Velg flere (f.eks. tilbehør)",
        "offer.calculation.product_list.ask_on_use": "Spør ved bruk av mal",
        "offer.calculation.product_list.module_ask_hint": "Når aktivert, spør mal-veiviseren hvilke produkter fra katalogen som skal tas med.",
        "offer.calculation.product_list.add_products": "Legg til produkter",
        "offer.calculation.product_list.add_manual": "Manuell linje",
        "offer.calculation.product_list.manual_title": "Ny produktlinje",
        "offer.calculation.product_list.line_title": "Linjetittel",
        "offer.calculation.product_list.unlinked": "Ikke knyttet til produkt — bruk «Knytt til produkt» for å hente pris.",
        "offer.calculation.product_list.link_product": "Knytt til produkt",
        "offer.calculation.product_list.relink_product": "Bytt knyttet produkt",
        "offer.calculation.product_list.relink_product_short": "Bytt produkt",
        "offer.calculation.product_list.link_confirm": "Knytt",
        "offer.calculation.product_list.update_prices": "Oppdater priser fra produkt",
        "offer.calculation.product_list.update_price": "Oppdater pris fra produkt",
        "offer.calculation.product_list.price_dated": "Pris hentet",
        "offer.calculation.product_list.empty": "Ingen produkter i listen ennå. Legg til fra registeret eller som manuell linje.",
        "offer.calculation.product_list.default_selected": "Standard",
        "offer.calculation.product_list.required": "Påkrevd",
        "offer.calculation.product_list.remove": "Fjern",
        "offer.calculation.product_list.wizard_single_hint": "Velg ett produkt som skal brukes på linjen.",
        "offer.calculation.product_list.wizard_multi_hint": "Huk av produktene som skal tas med.",
        
        // Accounting Summary translations (Norwegian)
        "accounting.summary.title": "Regnskapssummering",
        "accounting.summary.eyebrow": "Regnskap",
        "accounting.summary.tap_hint": "Trykk for å se flere tall og velge periode",
        "accounting.summary.profit_explanation": "Fortjeneste = inntekter − kostnader. Marginen viser fortjenesten som andel av inntektene.",
        "accounting.summary.income_explanation": "Inntekter er fakturert omsetning fra kundefakturaer i valgt periode.",
        "accounting.summary.costs": "Kostnader",
        "accounting.summary.income": "Inntekter",
        "accounting.summary.profit": "Fortjeneste",
        "accounting.summary.profit_margin": "margin",
        "accounting.summary.projects": "Prosjekter",
        "accounting.summary.labor": "Lønnskostnader",
        "accounting.summary.labor_source_voucher": "Bokført lønn (lønnsbilag)",
        "accounting.summary.labor_source_hours": "Estimert fra timer",
        "accounting.summary.labor_paid_via_voucher": "Lønnet via lønnsbilag",
        "accounting.summary.labor_estimated_unpaid": "Estimert fra timer (ikke lønnet ennå)",
        "accounting.summary.labor_unpaid_badge": "{{hours}} timer — estimert {{amount}} (ikke lønnet ennå)",
        "accounting.summary.labor_paid_badge": "Bokført lønn — {{amount}}",
        "accounting.summary.labor_source_label": "Lønn i totalen: {{source}}",
        "accounting.summary.costs_detail_title": "Kostnadsdetaljer",
        "accounting.summary.costs_detail_hint": "Trykk for å se kostnadsfordeling og beregning",
        "accounting.summary.costs_detail_intro": "Kostnadsfordeling for {{year}} med grunnlag for hver post.",
        "accounting.summary.calculation_method_title": "Slik er det beregnet",
        "accounting.summary.labor_voucher_explanation": "Lønnsbilag = bokført lønn i hovedbok (konto 5000–5999). Timeestimat brukes når bilag ikke finnes ennå.",
        "accounting.summary.labor_methodology_voucher": "Summen kommer fra synkroniserte lønnsbilag i Tripletex (konto 5000–5999).",
        "accounting.summary.labor_methodology_hours": "Summen er et estimat basert på registrerte timer og timesatser, fordi lønnsbilag ikke er bokført ennå.",
        "accounting.summary.supplier_invoices_methodology": "Bokførte leverandørfakturaer på driftskostnadskontoer (4000–4999 og 6000–7999) i valgt periode. Hoppes over når hovedbokbilag allerede finnes for året (unngår dobbelttelling).",
        "accounting.summary.item_lists_methodology": "Materiell og vareforbruk fra godkjente varelister med «inkluder i beregning» i valgt år. Vises på selskapsnivå, men telles ikke inn i kostnadstotalen (lagerkjøp ligger allerede i leverandørfaktura / hovedbok).",
        "accounting.summary.item_lists_excluded_hint": "Varelister er ikke med i kostnadstotalen på selskapsnivå — unngår dobbelttelling mot leverandørfaktura/hovedbok. På prosjektnivå telles de fortsatt med.",
        "accounting.summary.voucher_expenses_methodology": "Tripletex-bilag på driftskostnadskontoer 4000–4999 og 6000–7999 (eks. mva). Balansekontoer, inntekter og lønn (5000–5999) er ikke med.",
        "accounting.summary.labor_hours_count": "Registrerte timer: {{hours}}",
        "accounting.summary.labor_hours_estimate": "Timeestimat",
        "accounting.summary.labor_voucher": "Lønnsbilag",
        "accounting.summary.voucher_expenses": "Tripletex-kostnader (driftskost)",
        "accounting.summary.calc_guide.json.download": "Last ned JSON-guide",
        "accounting.summary.calc_guide.json.copy": "Kopier JSON-guide",
        "accounting.summary.calc_guide.json.downloaded": "Beregningsguide lastet ned.",
        "accounting.summary.calc_guide.json.copied": "Beregningsguide kopiert til utklippstavlen.",
        "accounting.summary.calc_guide.json.error": "Kunne ikke hente beregningsguide.",
        "accounting.summary.calc_guide.profit.title": "Slik beregnes fortjeneste",
        "accounting.summary.calc_guide.profit.body": "Fortjeneste = inntekter totalt − kostnader totalt.\n\nMarginen er fortjeneste som prosent av inntektene.\n\nInntekter kommer fra kundefakturaer (eks. mva). Kostnader er lønn + Tripletex driftskostnader + eventuelle leverandørfakturaer (når hovedbok ikke er synket). Varelister er ikke med i kostnadstotalen på selskapsnivå.",
        "accounting.summary.calc_guide.profit.info_aria": "Informasjon om fortjeneste",
        "accounting.summary.calc_guide.income.title": "Slik beregnes inntekter",
        "accounting.summary.calc_guide.income.body": "Inntekter totalt = sum av kundefakturaer i valgt år, beløp eks. mva (amount − vat).\n\nDato: invoice_date hvis satt, ellers created_at.\n\nMerk: Resultatrapporten kan i stedet bruke Tripletex-konto 3000–3999 når hovedbok er synket. Regnskapsoversikten bruker fortsatt kundefakturaer.",
        "accounting.summary.calc_guide.income.info_aria": "Informasjon om inntekter",
        "accounting.summary.calc_guide.costs.title": "Slik beregnes kostnader totalt",
        "accounting.summary.calc_guide.costs.body": "Kostnader totalt =\n• Lønn (konto 5000–5999, eller timeestimat)\n• Tripletex-kostnader (konto 4000–4999 + 6000–7999)\n• Leverandørfakturaer (kun måneder uten driftskostnadsbilag i hovedbok)\n\nGodkjente varelister vises separat og telles ikke inn her — lagerkjøp er allerede dekket av leverandørfaktura/hovedbok.\n\nBalansekontoer (f.eks. 1xxx/2xxx) telles ikke med. Det er derfor oversikten skal stemme med driftskostnadene i resultatrapporten, ikke med hele hovedboken.",
        "accounting.summary.calc_guide.costs.info_aria": "Informasjon om kostnader",
        "accounting.summary.calc_guide.labor.title": "Slik beregnes lønn",
        "accounting.summary.calc_guide.labor.body": "Når lønnsbilag er synket fra Tripletex, summeres posteringer på konto 5000–5999 i valgt år (eks. mva).\n\nFinnes ingen slike bilag, brukes estimat: godkjente og behandlede timer × effektiv timesats / firmasats.",
        "accounting.summary.calc_guide.labor.info_aria": "Informasjon om lønn",
        "accounting.summary.calc_guide.supplier_invoices.title": "Slik beregnes leverandørfakturaer",
        "accounting.summary.calc_guide.supplier_invoices.body": "Sum av leverandørfaktura-posteringer på driftskostnadskontoer (4000–4999 og 6000–7999) i valgt år.\n\nNår Tripletex-hovedbok allerede er synket for perioden, settes denne linjen til 0 — kostnadene ligger da i «Tripletex-kostnader» (leverandørbilag i hovedboken).",
        "accounting.summary.calc_guide.supplier_invoices.info_aria": "Informasjon om leverandørfakturaer",
        "accounting.summary.calc_guide.item_lists.title": "Slik beregnes varelister",
        "accounting.summary.calc_guide.item_lists.body": "Sum av antall × innkjøpspris for godkjente varelister med «inkluder i beregning», godkjent i valgt år.\n\nForbrukslister øker beløpet; retur/håndtering reduserer det.\n\nPå selskapsnivå telles ikke varelister inn i kostnadstotalen (dobbelttelling mot lagerkjøp). På prosjektnivå telles de fortsatt med i materiellkostnad.",
        "accounting.summary.calc_guide.item_lists.info_aria": "Informasjon om varelister",
        "accounting.summary.calc_guide.voucher_expenses.title": "Slik beregnes Tripletex-kostnader",
        "accounting.summary.calc_guide.voucher_expenses.body": "Sum av synkroniserte bilagsposteringer i valgt år på konto:\n• 4000–4999 (varekost)\n• 6000–7999 (andre driftskostnader)\n\nBeløp er eks. mva. Krediteringer (negative beløp) reduserer summen.\n\nIkke med: lønn (5000–5999), inntekter (3000–3999), mva (27*), bank/leverandørgjeld (1920*/2400) eller balansekontoer. Feilaktig summering av hele hovedboken ga tidligere altfor høye tall.",
        "accounting.summary.calc_guide.voucher_expenses.info_aria": "Informasjon om Tripletex-kostnader",
        "accounting.summary.calc_guide.expected_report_income.title": "Slik beregnes forventet oppdragsinntekt",
        "accounting.summary.calc_guide.expected_report_income.body": "Forventet inntekt/kostnad fra servicerapporter og arbeidsordrer som ikke er behandlet eller fakturert i valgt år.\n\nDette er ikke del av hovedresultatet (fortjeneste), men vises separat som potensial.",
        "accounting.summary.calc_guide.expected_report_income.info_aria": "Informasjon om forventet oppdragsinntekt",
        "accounting.summary.material": "Materialkostnader",
        "accounting.summary.supplier_invoices": "Leverandørfakturaer",
        "accounting.summary.item_lists": "Varelister",
        "accounting.summary.customer_invoices": "Kundefakturaer",
        "accounting.summary.reports": "Rapporter",
        "accounting.summary.total": "Totalt",
        "accounting.summary.calculated_at": "Beregnet",
        "accounting.summary.cached": "Cachet",
        "accounting.summary.load_error": "Kunne ikke laste regnskapssummering",
        "accounting.summary.monthly_overview": "Månedlig oversikt",
        "accounting.summary.chart_description": "Stolper: inntekter & kostnader · Linje: månedlig resultat (inntekter − kostnader)",
        "accounting.summary.no_monthly_data": "Ingen månedlige data tilgjengelig",
        "accounting.summary.months.january": "Jan",
        "accounting.summary.months.february": "Feb",
        "accounting.summary.months.march": "Mar",
        "accounting.summary.months.april": "Apr",
        "accounting.summary.months.may": "Mai",
        "accounting.summary.months.june": "Jun",
        "accounting.summary.months.july": "Jul",
        "accounting.summary.months.august": "Aug",
        "accounting.summary.months.september": "Sep",
        "accounting.summary.months.october": "Okt",
        "accounting.summary.months.november": "Nov",
        "accounting.summary.months.december": "Des",
        "accounting.summary.expected_report_income": "Oppdrag forventet inntekt",
        "accounting.summary.expected_report_income_hint": "Fra ubehandlede og ufakturerte rapporter (samme grunnlag som regnskapsoversikten)",
        "accounting.summary.expected_income": "Forventet inntekt",
        "accounting.summary.expected_costs": "Forventet kostnad",
        "accounting.summary.expected_profit": "Forventet fortjeneste",
        "accounting.summary.view_projects": "Se per prosjekt →",
        "accounting.menu.projects_expected": "Oppdrag forventet inntekt",

        "accounting.menu.overview": "Regnskapsoversikt",
        "accounting.menu.ledger": "Hovedbok og bilag",
        "accounting.menu.result_report": "Resultatrapport",
        "accounting.menu.result_report_hint": "Driftsinntekter og kostnader gruppert etter kontoplan fra synkroniserte bilag",
        "accounting.menu.tripletex_import": "Importer timer fra Tripletex",
        "accounting.menu.title": "Regnskap",
        "accounting.menu.subtitle": "Finansiell oversikt og Tripletex-integrasjon",
        "accounting.menu.sections": "Seksjoner",
        "accounting.menu.supplier_invoices": "Leverandørfakturaer",
        "accounting.menu.supplier_invoices_hint": "Bokførte leverandørkostnader med bilagsposteringer",
        "accounting.menu.customer_invoices": "Kundefakturaer",
        "accounting.menu.customer_invoices_hint": "Utgående salg og fakturert omsetning",
        "accounting.menu.ledger_hint": "Hovedboktyper, bilagstyper og lønnsberegninger fra Tripletex",
        "accounting.menu.tripletex_import_hint": "Engangsimport av historiske timelister fra Tripletex",
        "accounting.menu.project_summary": "Prosjektregnskap",
        "accounting.menu.project_summary_hint": "Full økonomisk oversikt per prosjekt med kontraktsum, lønn og kostnader",
        "accounting.project_summary.title": "Prosjektregnskap",
        "accounting.project_summary.subtitle": "Komplett økonomisk oversikt for ett prosjekt",
        "accounting.project_summary.description": "Velg et prosjekt for å se kontraktsum, inntekter, lønnskostnader (lønnsbilag eller timer), materiell, leverandørfakturaer og resultat.",
        "accounting.project_summary.select_project": "Prosjekt",
        "accounting.project_summary.select_project_placeholder": "Velg prosjekt…",
        "accounting.project_summary.select_project_hint": "Velg et prosjekt for å se regnskapssummeringen",
        "accounting.project_summary.load_error": "Kunne ikke laste prosjektregnskap",
        "accounting.project_summary.last_updated": "Sist oppdatert",
        "accounting.project_summary.open_project": "Åpne prosjekt",
        "accounting.project_summary.contract_sum": "Kontraktsum",
        "accounting.project_summary.contract_agreement_price": "Avtalt pris",
        "accounting.project_summary.contract_sum_source_lines": "Fra kontraktslinjer i Promang",
        "accounting.project_summary.contract_sum_source_agreement": "Fra avtalt pris",
        "accounting.project_summary.contract_sum_source_both": "Kontraktslinjer + avtalt pris",
        "accounting.project_summary.contract_sum_source_none": "Ingen kontraktsum registrert",
        "accounting.project_summary.invoiced": "Fakturert",
        "accounting.project_summary.not_invoiced": "Ikke fakturert",
        "accounting.project_summary.invoiced_ex_vat": "Sum kundefakturaer, eks. mva",
        "accounting.project_summary.profit": "Resultat",
        "accounting.project_summary.profit_vs_contract": "Resultat mot kontraktsum",
        "accounting.project_summary.profit_vs_invoiced": "Resultat mot fakturert",
        "accounting.project_summary.margin": "Margin",
        "accounting.project_summary.margin_vs_contract": "Margin mot kontraktsum",
        "accounting.project_summary.margin_vs_invoiced": "Margin mot fakturert",
        "accounting.project_summary.income_section": "Inntekter",
        "accounting.project_summary.expected_module_income": "Forventet inntekt fra moduler",
        "accounting.project_summary.income_total": "Fakturert + forventet",
        "accounting.project_summary.costs_section": "Kostnader",
        "accounting.project_summary.labor_costs": "Lønn",
        "accounting.project_summary.labor_source_voucher": "Basert på lønnsbilag",
        "accounting.project_summary.labor_source_hours": "Estimert fra registrerte timer",
        "accounting.project_summary.labor_hours_estimate": "Timer-estimat",
        "accounting.project_summary.labor_voucher": "Lønnsbilag",
        "accounting.project_summary.labor_unpaid_badge": "{{hours}} timer — estimert {{amount}} (ikke lønnet ennå)",
        "accounting.project_summary.labor_paid_badge": "Bokført lønn — {{amount}}",
        "accounting.project_summary.labor_source_label": "Lønn i totalen: {{source}}",
        "accounting.project_summary.labor_hours_count": "Registrerte timer: {{hours}}",
        "accounting.project_summary.material_costs": "Materiell / varelister",
        "accounting.project_summary.supplier_invoices": "Leverandørfakturaer",
        "accounting.project_summary.voucher_expenses": "Andre bilagskostnader",
        "accounting.project_summary.total_costs": "Totale kostnader",
        "accounting.project_summary.modules_section": "Moduler",
        "accounting.project_summary.print.button": "Skriv ut",
        "accounting.project_summary.debug_export.button": "Eksporter debug-data",
        "accounting.project_summary.debug_export.loading": "Eksporterer…",
        "accounting.project_summary.debug_export.error": "Kunne ikke eksportere debug-data",
        "accounting.project_summary.print.document_title": "Prosjektregnskap",
        "accounting.project_summary.print.project_number": "Prosjektnummer",
        "accounting.project_summary.print.customer": "Kunde",
        "accounting.project_summary.print.year": "År",
        "accounting.project_summary.print.printed_at": "Utskriftsdato",
        "accounting.project_summary.print.result_section": "Resultat",
        "accounting.project_summary.print.margin_on_contract": "Margin mot kontraktsum",
        "accounting.project_summary.print.margin_on_invoiced": "Margin mot fakturert beløp",
        "accounting.project_summary.print.minus_total_costs": "Minus totale kostnader",
        "accounting.project_summary.print.methodology_title": "Slik er summeringene beregnet",
        "accounting.project_summary.print.methodology_intro": "Hver post under viser hvilke data som ligger til grunn for beløpene over.",
        "accounting.project_summary.methodology.contract_sum_lines": "Kontraktsum er summen av kontraktslinjer (total_contract_price) i prosjektet.",
        "accounting.project_summary.methodology.contract_sum_agreement": "Kontraktsum er avtalt pris (contract_agreement_price) synkronisert fra regnskapsintegrasjon.",
        "accounting.project_summary.methodology.contract_sum_lines_primary": "Kontraktsum bruker kontraktslinjer når disse finnes; avtalt pris vises som tilleggsinformasjon.",
        "accounting.project_summary.methodology.contract_sum_none": "Ingen kontraktsum er registrert — resultat mot kontraktsum blir 0, mens resultat mot fakturert brukes som hovedresultat.",
        "accounting.project_summary.methodology.contract_agreement_price": "Avtalt pris hentes fra prosjektet (contract_agreement_price) og kan synkroniseres med eksternt regnskap.",
        "accounting.project_summary.methodology.income_invoiced": "Fakturert inntekt er sum kundefakturaer på prosjektet, ekskl. MVA.",
        "accounting.project_summary.methodology.income_expected": "Forventet inntekt er sum ubehandlede rapporter og arbeidsordrer via Service::Report::Summary og Service::WorkOrder::Summary (ikke fakturert, uten ordre).",
        "accounting.project_summary.methodology.labor_primary_hours": "Lønn i totalen er timer-estimat fordi det ikke finnes lønnsbilag på prosjektet. Verdien brukes i total kostnad.",
        "accounting.project_summary.methodology.labor_primary_voucher": "Lønn i totalen er fra lønnsbilag fordi synkroniserte bilag finnes på prosjektet. Verdien brukes i total kostnad.",
        "accounting.project_summary.methodology.labor_hours": "Timer-estimat: godkjente og behandlede prosjekttimer × effektiv kostpris (effective_hour_cost_rate eller selskapets timepris).",
        "accounting.project_summary.methodology.labor_voucher": "Lønnsbilag: poster på konto 5000–5999 fra synkroniserte bilag tilknyttet prosjektet (PostingRules).",
        "accounting.project_summary.methodology.material_costs": "Materiell (vareforbruk) summerer flere kilder: godkjente varelister, øvrige ordrelinjer på fakturerte ordrer, lageruttak (plukket/brukt), rapportvarer og arbeidsordrevarer (ikke fakturert). Fakturakopier fra vareliste→ordre (inventory_billing_copy) telles ikke på nytt når listen allerede er med. Sammenlign derfor ikke tallet direkte med innkjøpssum på én vareliste alene.",
        "accounting.project_summary.methodology.supplier_invoices": "Leverandørfakturaer: kostposter fra leverandørfakturaer på prosjektet, ekskl. betalinger og MVA-konti.",
        "accounting.project_summary.methodology.voucher_expenses": "Andre bilagskostnader: utgiftsbilag på prosjektet som ikke er lønn (PostingRules.expense_posting, ikke salary).",
        "accounting.project_summary.methodology.total_costs": "Totale kostnader = lønn + materiell + leverandørfakturaer + andre bilagskostnader.",
        "accounting.project_summary.methodology.profit_contract": "Resultat mot kontraktsum = kontraktsum minus totale kostnader.",
        "accounting.project_summary.methodology.profit_invoiced": "Resultat mot fakturert = sum kundefakturaer (eks. mva) minus totale kostnader. Uavhengig av kontraktsum.",
        "accounting.project_summary.methodology.margin_contract": "Margin mot kontraktsum = resultat mot kontraktsum delt på kontraktsum × 100.",
        "accounting.project_summary.methodology.margin_invoiced": "Margin mot fakturert = resultat mot fakturert delt på fakturert beløp × 100.",
        "project.summary.labor_source_voucher": "Basert på lønnsbilag",
        "project.summary.labor_source_hours": "Estimert fra registrerte timer",
        "project.summary.labor_hours_estimate": "Timer-estimat",
        "project.summary.labor_voucher": "Lønnsbilag",
        "project.summary.labor_unpaid_badge": "{{hours}} timer — estimert {{amount}} (ikke lønnet ennå)",
        "project.summary.labor_paid_badge": "Bokført lønn — {{amount}}",
        "project.summary.labor_source_label": "Lønn i totalen: {{source}}",
        "project.summary.labor_hours_count": "Registrerte timer: {{hours}}",
        "project.summary.contract_agreement_price": "Avtalt pris",
        "project.summary.voucher_expenses": "Andre bilagskostnader",
        "accounting.ledger.load_error": "Kunne ikke laste hovedbokdata",
        "accounting.ledger.loading": "Laster hovedbokdata…",
        "accounting.ledger.search_placeholder": "Søk bilagsnummer eller beskrivelse…",
        "accounting.ledger.last_synced": "Sist synkronisert {{date}}",
        "accounting.ledger.vouchers_truncated":
          "Siste hovedbok-synk stoppet ved sidetaket. Tallene kan være ufullstendige til synken kjøres på nytt med kortere periode.",
        "accounting.ledger.source_local": "Lagret lokalt (ikke live Tripletex)",
        "accounting.ledger.sync_required_hint": "Hovedbokdata er ikke synkronisert ennå. Be en administrator kjøre Tripletex hovedbok-synk.",
        "accounting.ledger.vouchers_table": "Bilag",
        "accounting.ledger.no_vouchers": "Ingen bilag samsvarer med filtrene.",
        "accounting.ledger.page_of": "Side {{page}} av {{total}}",
        "accounting.ledger.prev_page": "Forrige",
        "accounting.ledger.next_page": "Neste",
        "accounting.ledger.calculations": "Beregninger",
        "accounting.ledger.tripletex_expenses": "Tripletex-kostnader (eks. mva)",
        "accounting.ledger.tripletex_salary": "Tripletex-lønn (eks. mva)",
        "accounting.ledger.promang_supplier_invoices": "Promang leverandørfakturaer",
        "accounting.ledger.ledger_types": "Hovedboktyper",
        "accounting.ledger.voucher_types": "Bilagstyper",
        "accounting.ledger.count": "{{count}} rader",
        "accounting.ledger.recent_vouchers": "Siste bilag",
        "accounting.ledger.voucher_number": "Bilagsnr.",
        "accounting.ledger.voucher_date": "Dato",
        "accounting.ledger.voucher_type": "Type",
        "accounting.ledger.postings": "Posteringer",
        "accounting.ledger.expense_total": "Kostnad totalt",
        "accounting.ledger.salary_total": "Lønn totalt",
        "accounting.ledger.last_sync_attempt": "Siste synk-forsøk: {{date}}",
        "accounting.ledger.sync_via_integrations": "Aktiver «Hovedbok og bilag» i Firmainnstillinger → Integrasjoner → Synkroniser med Tripletex, eller kjør rake api:jobs:run_company_ledger_sync[company_id,year].",
        "accounting.result_report.load_error": "Kunne ikke laste resultatrapport",
        "accounting.result_report.loading": "Laster resultatrapport…",
        "accounting.result_report.total_income": "Driftsinntekter totalt",
        "accounting.result_report.total_costs": "Driftskostnader totalt",
        "accounting.result_report.operating_result": "Driftsresultat",
        "accounting.result_report.result_before_tax": "Resultat før skatt",
        "accounting.result_report.table_title": "Resultatrapport {{year}}",
        "accounting.result_report.debug_export.button": "Eksporter debug-data",
        "accounting.result_report.debug_export.loading": "Eksporterer…",
        "accounting.result_report.debug_export.error": "Kunne ikke eksportere debug-data",
        "accounting.result_report.account_number": "Konto",
        "accounting.result_report.account_name": "Navn",
        "accounting.result_report.amount": "Beløp",
        "accounting.result_report.no_rows": "Ingen kontoposteringer i valgt periode.",
        "accounting.result_report.methodology_link": "Les metode og kontokartlegging",
        "accounting.result_report.account_detail.title": "{{account}} ({{number}})",
        "accounting.result_report.account_detail.click_hint": "Klikk for å se bilag og posteringer bak beløpet",
        "accounting.result_report.account_detail.load_error": "Kunne ikke laste kontodetaljer",
        "accounting.result_report.account_detail.no_rows": "Ingen posteringer eller fakturaer for denne kontoen i perioden.",
        "accounting.result_report.account_detail.posting_count": "{{count}} posteringer",
        "accounting.result_report.account_detail.voucher_number": "Bilagsnr.",
        "accounting.result_report.account_detail.date": "Dato",
        "accounting.result_report.account_detail.description": "Beskrivelse",
        "accounting.result_report.account_detail.project": "Prosjekt",
        "accounting.result_report.account_detail.source": "Kilde",
        "accounting.result_report.account_detail.source_voucher": "Bilag",
        "accounting.result_report.account_detail.source_supplier": "Leverandørfaktura",
        "accounting.result_report.account_detail.source_customer_invoice": "Kundefaktura",
        "accounting.result_report.account_detail.reconciliation_title": "Moglege årsaker til avvik mot Tripletex",
        "accounting.projects_expected.title": "Oppdrag forventet inntekt",
        "accounting.projects_expected.subtitle": "Forventet inntekt fra ubehandlede rapporter og arbeidsordrer, gruppert etter prosjekt eller oppdrag",
        "accounting.projects_expected.description": "Forventet inntekt og kostnad kommer fra rapporter og arbeidsordrer som ikke er behandlet eller fakturert. Materiell telles bare for plukkede varelinjer (eller linjer med hopp over plukk). Velg visning per prosjekt eller per enkelt rapport/arbeidsordre. Lønns- og leverandørkostnader er faktiske kostnader registrert på prosjektet (bare i prosjektvisning).",
        "accounting.projects_expected.search_placeholder": "Søk prosjektnavn eller nummer…",
        "accounting.projects_expected.search_placeholder_assignment": "Søk rapport, arbeidsordre, prosjekt…",
        "accounting.projects_expected.view_by_project": "Per prosjekt",
        "accounting.projects_expected.view_by_assignment": "Per rapport/oppdrag",
        "accounting.projects_expected.table_title_assignment": "Per rapport og arbeidsordre",
        "accounting.projects_expected.assignment": "Rapport / arbeidsordre",
        "accounting.projects_expected.type_report": "Rapport",
        "accounting.projects_expected.type_work_order": "Arbeidsordre",
        "accounting.projects_expected.expected_income_short": "Inntekt",
        "accounting.projects_expected.expected_costs_short": "Kostnad",
        "accounting.projects_expected.date": "Dato",
        "accounting.projects_expected.no_assignments": "Ingen ubehandlede rapporter eller arbeidsordrer samsvarer med filtrene.",
        "accounting.projects_expected.loading": "Laster oversikt…",
        "accounting.projects_expected.load_error": "Kunne ikke laste oversikt",
        "accounting.projects_expected.table_title": "Per prosjekt",
        "accounting.projects_expected.project": "Prosjekt",
        "accounting.projects_expected.assignments": "Oppdrag",
        "accounting.projects_expected.reports_count": "{{count}} rapport",
        "accounting.projects_expected.reports_count_plural": "{{count}} rapporter",
        "accounting.projects_expected.work_orders_count": "{{count}} arbeidsordre",
        "accounting.projects_expected.work_orders_count_plural": "{{count}} arbeidsordrer",
        "accounting.projects_expected.expected_income": "Forventet inntekt (rapport/arbeidsordre)",
        "accounting.projects_expected.expected_income_hint": "Sum fra ubehandlede rapporter og arbeidsordrer på prosjektet. Materiell kun for plukkede varer (ikke uplukket lager).",
        "accounting.projects_expected.expected_costs": "Forventet kostnad (rapport/arbeidsordre)",
        "accounting.projects_expected.expected_profit": "Forventet resultat",
        "accounting.projects_expected.labor_costs": "Lønnskostnader (faktisk)",
        "accounting.projects_expected.supplier_costs": "Leverandørkostnader (faktisk)",
        "accounting.projects_expected.hours": "Timer",
        "accounting.projects_expected.net": "Netto",
        "accounting.projects_expected.no_projects": "Ingen prosjekt med ubehandlede rapporter eller arbeidsordrer samsvarer med filtrene.",
        "accounting.projects_expected.totals_reports": "Rapporter",
        "accounting.projects_expected.totals_work_orders": "Arbeidsordrer",
        "integrations.sync.ledger": "Hovedbok og bilag",
        "integrations.sync.ledger_hint": "Synkroniser hovedboktyper, bilagstyper og bilag for inneværende år fra Tripletex",
        "accounting.import.description": "Engangsimport av timeregistreringer fra Tripletex til Promang. Løpende eksport Promang → Tripletex er uendret.",
        "accounting.import.from_date": "Fra dato",
        "accounting.import.to_date": "Til dato",
        "accounting.import.run": "Kjør import",
        "accounting.import.running": "Importerer…",
        "accounting.import.success": "Import fullført",
        "accounting.import.error": "Import feilet",
        "accounting.import.found": "Funnet i Tripletex",
        "accounting.import.created": "Opprettet",
        "accounting.import.updated": "Oppdatert",
        "accounting.import.skipped": "Hoppet over",

        "integrations.sync.hours": "Timer",
        "integrations.sync.hours_hint": "Importer timeregistreringer fra Tripletex (siste 30 dager). For eget datointervall, bruk Regnskap → Importer timer fra Tripletex.",

        "chemical.inventory.verneblad.contact_info":
          "Kontaktinformasjon for 'leverandøren av produktet' tas fra produkt som er tilknyttet brand - jeg tror kanskje vi må legge til adresse, land, telefon - nødtelefon må legges på pr. produkt.",
        "chemical.inventory.verneblad.protective_equipment":
          "verneutstyr + symboler, tiltak ved brann, tiltak ved utslipp, førstehjelstiltak etc.",
        "chemical.inventory.hms_level.1": "Lav risiko",
        "chemical.inventory.hms_level.2": "Medium risiko",
        "chemical.inventory.hms_level.3": "Høy risiko",
        "chemical.inventory.hms_level.4": "Kritisk risiko",
        "chemical.inventory.status.active": "Aktiv",
        "chemical.inventory.status.inactive": "Inaktiv",
        "chemical.inventory.status.archived": "Arkivert",
        "chemical.inventory.document_type.safety_data_sheet":
          "Sikkerhetsdatablad",
        "chemical.inventory.document_type.risk_assessment": "Risikovurdering",
        "chemical.inventory.document_type.safety_instruction":
          "Sikkerhetsinstruksjon",
        "chemical.inventory.document_type.certificate": "Sertifikat",
        "chemical.inventory.document_type.other": "Annet",
        "chemical.inventory.note_type.general": "Generell",
        "chemical.inventory.note_type.safety": "Sikkerhet",
        "chemical.inventory.note_type.risk": "Risiko",
        "chemical.inventory.note_type.operation": "Operasjon",
        "chemical.inventory.note_type.other": "Annet",
        "Ingen kjemisk informasjon registrert for dette produktet":
          "Ingen kjemisk informasjon registrert for dette produktet",
        "Produkt ble lagt til i stoffkartotek":
          "Produktet ble lagt til i stoffkartoteket",
        "Kunne ikke legge til i stoffkartotek":
          "Kunne ikke legge til i stoffkartoteket",
        "Legger til...": "Legger til…",
        "Vis detaljer": "Vis detaljer",
        "Navn er påkrevd": "Navn er påkrevd",
        "CAS-nummer er påkrevd": "CAS-nummer er påkrevd",
        "Ugyldig e-post": "Ugyldig e-post",
        "Kunne ikke lagre stoffkartotek": "Kunne ikke lagre stoffkartotek",
        "Lagrer...": "Lagrer…",
        "Oppdater": "Oppdater",
        "Opprett": "Opprett",
        "Avbryt": "Avbryt",
        "Produkt er påkrevd": "Produkt er påkrevd",
        "Notater kan kun legges til etter at stoffet er opprettet":
          "Notater kan kun legges til etter at stoffet er opprettet",
        "chemical.inventory.load_error": "Kunne ikke laste stoffkartotek",
        "chemical.inventory.sds_attach_error": "Stoffet ble opprettet, men sikkerhetsdatabladet ble ikke knyttet. Åpne stoffet og last opp SDS.",
        "chemical.inventory.deleted": "Stoffkartoteket ble slettet",
        "chemical.inventory.delete_error": "Kunne ikke slette stoffkartotek",
        "chemical.inventory.delete_confirm": "Er du sikker på at du vil slette dette stoffet?",
        "chemical.inventory.list_subtitle": "Oversikt over kjemikalier og stoffer (ISO 14001, ISO 45001)",
        "chemical.inventory.filters": "Filtre",
        "chemical.inventory.filter_by_status": "Filtrer etter status",
        "chemical.inventory.no_brand": "Ingen merke",
        "chemical.inventory.view": "Vis",
        "chemical.inventory.showing": "Viser",
        "chemical.inventory.of": "av",
        "chemical.inventory.results": "resultater",
        "chemical.inventory.previous": "Forrige",
        "chemical.inventory.next": "Neste",
        "chemical.inventory.not_specified": "Ikke spesifisert",
        "chemical.inventory.review_state.overdue": "Forfalt",
        "chemical.inventory.review_state.due_soon": "Snart",
        "chemical.inventory.review_state.ok": "I rute",
        "chemical.inventory.reviewed_by": "Gjennomgått av",
        "chemical.inventory.open": "Åpne",
        "chemical.inventory.actions": "Handlinger",
        "chemical.inventory.pdf": "Last ned PDF",
        "chemical.inventory.pdf_ready": "PDF lastet ned",
        "chemical.inventory.pdf_failed": "Kunne ikke laste ned PDF",
        "chemical.inventory.revisions": "Revisjoner",
        "chemical.inventory.new_revision": "Ny revisjon",
        "chemical.inventory.publish_review": "Publiser gjennomgang",
        "chemical.inventory.change_summary": "Sammendrag av endring",
        "chemical.inventory.change_summary_required": "Sammendrag av endring er påkrevd",
        "chemical.inventory.revision_created": "Ny revisjon ble opprettet",
        "chemical.inventory.revision_create_error": "Kunne ikke opprette revisjon",
        "chemical.inventory.review_published": "Gjennomgang ble publisert",
        "chemical.inventory.review_publish_error": "Kunne ikke publisere gjennomgang",
        "chemical.inventory.history_empty": "Ingen historikk ennå",
        "chemical.inventory.revision": "Revisjon",
        "chemical.inventory.revision_line": "Revisjon {{version}} · neste gjennomgang {{date}}",
        "chemical.inventory.next_review_missing": "ikke satt",
        "chemical.inventory.added_from_product": "Produktet ble lagt til i stoffkartoteket",
        "chemical.inventory.add_from_product_error": "Kunne ikke legge til i stoffkartoteket",
        "chemical.inventory.adding": "Legger til…",
        "chemical.inventory.created_for_product": "Stoffkartotek opprettet",
        "chemical.inventory.view_details": "Vis detaljer",
        "chemical.inventory.handbook_card": "Kjemikalier, faresymboler og SDS",
        "chemical.inventory.sds_download": "Last ned sikkerhetsdatablad",
        "chemical.inventory.sds_missing": "Ingen SDS tilgjengelig",
        "chemical.inventory.risk_tab.register": "Risikoregister",
        "chemical.inventory.risk_tab.matrix": "Risikomatrise",
        "chemical.inventory.risk_tab.sja": "SJA",
        "chemical.inventory.risk_tab.climate": "Klimarisiko",
        "chemical.inventory.risk_tab.protective": "Vernerunder",
        "chemical.inventory.hazard.category.physical": "Fysiske farer",
        "chemical.inventory.hazard.category.health": "Helsefarer",
        "chemical.inventory.hazard.category.environmental": "Miljøfarer",
        "chemical.inventory.hazard.explosive": "Eksplosiv",
        "chemical.inventory.hazard.explosive_desc": "Kan eksplodere ved varme, støt, friksjon eller kontakt med andre stoffer",
        "chemical.inventory.hazard.flammable": "Brannfarlig",
        "chemical.inventory.hazard.flammable_desc": "Kan antenne ved kontakt med flamme, gnist, varme eller annen tenning",
        "chemical.inventory.hazard.oxidizing": "Oksiderende",
        "chemical.inventory.hazard.oxidizing_desc": "Kan forårsake eller intensivere brann ved kontakt med brennbare materialer",
        "chemical.inventory.hazard.corrosive": "Etsende",
        "chemical.inventory.hazard.corrosive_desc": "Kan forårsake alvorlige brannskader på hud og øyne",
        "chemical.inventory.hazard.toxic": "Giftig",
        "chemical.inventory.hazard.toxic_desc": "Kan forårsake alvorlig helseskade eller død ved inntak, innånding eller hudkontakt",
        "chemical.inventory.hazard.harmful": "Skadelig",
        "chemical.inventory.hazard.harmful_desc": "Kan forårsake helseskade ved inntak, innånding eller hudkontakt",
        "chemical.inventory.hazard.irritant": "Irriterende",
        "chemical.inventory.hazard.irritant_desc": "Kan forårsake hudirritasjon eller øyeskade",
        "chemical.inventory.hazard.environmental": "Miljøfarlig",
        "chemical.inventory.hazard.environmental_desc": "Kan forårsake skade på vannmiljø eller andre miljøer",
        "chemical.inventory.settings.title": "Stoffkartotek-innstillinger",
        "chemical.inventory.settings.intro": "Styr hvem som ser stoffkartoteket, hvem som er ansvarlig, og revisjonsintervall.",
        "chemical.inventory.settings.visibility": "Synlighet for ansatte",
        "chemical.inventory.settings.visibility_choose": "Velg synlighet",
        "chemical.inventory.settings.visibility_all_active": "Alle aktive ansatte",
        "chemical.inventory.settings.visibility_hse_roles_only": "Kun HMS-roller",
        "chemical.inventory.settings.responsible": "Ansvarlige",
        "chemical.inventory.settings.responsible_empty": "Ingen ansvarlig valgt",
        "chemical.inventory.settings.choose_responsible": "Velg ansvarlige",
        "chemical.inventory.settings.review_interval": "Standard revisjonsintervall (måneder)",
        "chemical.inventory.settings.sds_stale": "SDS utgår etter (måneder)",
        "chemical.inventory.settings.require_sds": "Krev sikkerhetsdatablad",
        "chemical.inventory.settings.auto_create": "Opprett automatisk fra produkter",
        "chemical.inventory.settings.review_reminder": "Påminnelse om gjennomgang",
        "chemical.inventory.settings.saved": "Stoffkartotek-innstillinger lagret",
        "chemical.inventory.settings.save_error": "Kunne ikke lagre stoffkartotek-innstillinger",
        "chemical.inventory.settings.load_error": "Kunne ikke laste stoffkartotek-innstillinger",
        "company_guide.chemical_inventory.heading": "Stoffkartotek-oppsett",
        "company_guide.chemical_inventory.subtitle": "Sett ansvarlig, synlighet og revisjonsintervall før dere tar i bruk stoffkartoteket.",
        "company_guide.chemical_inventory.loading": "Laster…",
        "company_guide.chemical_inventory.load_error": "Kunne ikke laste stoffkartotek-innstillinger.",
        "company_guide.chemical_inventory.link.settings": "Åpne innstillinger",
        "company_guide.chemical_inventory.task.responsible.title": "Ansvarlig",
        "company_guide.chemical_inventory.task.responsible.warn": "Ingen ansvarlig er valgt",
        "company_guide.chemical_inventory.task.responsible.ok": "Ansvarlig er satt",
        "company_guide.chemical_inventory.task.visibility.title": "Synlighet",
        "company_guide.chemical_inventory.task.visibility.warn": "Synlighet for ansatte er ikke valgt",
        "company_guide.chemical_inventory.task.visibility.ok": "Synlighet er satt",
        "company_guide.chemical_inventory.task.interval.title": "Revisjonsintervall",
        "company_guide.chemical_inventory.task.interval.warn": "Revisjonsintervall mangler",
        "company_guide.chemical_inventory.task.interval.ok": "Revisjonsintervall er satt",
        "dashboard.company_guide.alert_chemical_title": "Stoffkartoteket mangler oppsett",
        "dashboard.company_guide.alert_chemical_subtitle": "{{count}} oppgaver gjenstår",
        "user_guide.chemical_inventory.title": "Stoffkartotek",
        "user_guide.chemical_inventory.badge": "Firmaoppsett",
        "user_guide.chemical_inventory.back_to_hub": "Tilbake til brukerguide",
        "user_guide.chemical_inventory.purpose": "Sjekkliste for ansvarlig, synlighet og revisjon av kjemikalier.",
        "user_guide.chemical_inventory.section.why.title": "Hvorfor dette er viktig",
        "user_guide.chemical_inventory.section.why.p1": "Stoffkartoteket gir ansatte tilgang til faresymboler, førstehjelp og sikkerhetsdatablad. Sett ansvarlig og synlighet slik at listen holdes oppdatert.",
        "user_guide.hub.card.chemical_inventory.title": "Stoffkartotek",
        "user_guide.hub.card.chemical_inventory.description": "Ansvarlig, synlighet og revisjonsintervall for kjemikalier.",
  
        // Project Management translations
        "project.time_overview.tab": "Timeoversikt",
        "project.time_overview.list_title": "Timeoversikt — {{title}}",
        "project.time_overview.loading": "Laster timeoversikt…",
        "project.time_overview.load_error": "Kunne ikke hente timene for perioden.",
        "project.time_overview.ui.search_filter": "Søk {{label}}",
        "project.time_overview.ui.no_matches": "Ingen treff",
        "project.time_overview.ui.reset": "Nullstill",
        "project.time_overview.ui.search_chip": "Søk: {{query}}",
        "project.time_overview.ui.status_pending": "Til godkjenning",
        "project.time_overview.ui.status_approved": "Godkjent",
        "project.time_overview.ui.status_rejected": "Avvist",
        "project.time_overview.ui.status_processed": "Behandlet",
        "project.time_overview.ui.supplier": "Underleverandør",
        "project.time_overview.ui.employees": "Egne ansatte",
        "project.time_overview.ui.project": "Prosjekt",
        "project.time_overview.ui.department": "Avdeling",
        "project.time_overview.ui.without_project": "Uten prosjekt",
        "project.time_overview.ui.without_department": "Uten avdeling",
        "project.time_overview.ui.estimated_sales": "Estimert salg",
        "project.time_overview.ui.estimated_cost": "Estimert kostnad",
        "project.time_overview.ui.unknown_user": "Ukjent bruker",
        "project.time_overview.ui.show_calculation": "Vis beregning",
        "project.time_overview.ui.hide_calculation": "Skjul beregning",
        "project.time_overview.ui.total_hours": "Totalt timer",
        "project.time_overview.ui.missing_hour_cost_count": "Mangler timekostnad",
        "project.time_overview.ui.detailed_per_employee": "Detaljert beregning per ansatt",
        "project.time_overview.ui.estimated_cost_upper": "ESTIMERT KOSTNAD",
        "project.time_overview.ui.estimated_sales_upper": "ESTIMERT SALG",
        "project.time_overview.ui.estimated_from_rates": "Timekostnad × timer i utvalget",
        "project.time_overview.ui.estimated_from_sales_rates": "Timepris × timer i utvalget",
        "project.time_overview.ui.with_order": "Med ordre",
        "project.time_overview.ui.without_order": "Uten ordre",
        "project.time_overview.ui.with_invoice": "Med leverandørfaktura",
        "project.time_overview.ui.without_full_invoice": "Uten full fakturadekning",
        "project.time_overview.ui.eyebrow": "// PROSJEKT · TIMEKONTROLL",
        "project.time_overview.ui.description": "Godkjenn timer, koble dem til ordre og leverandørfaktura, og se forbruket i prosjektet.",
        "project.time_overview.ui.switch_project": "Bytt prosjekt",
        "project.time_overview.ui.export_csv": "Eksporter CSV",
        "project.time_overview.ui.export_pdf": "Eksporter PDF",
        "project.time_overview.ui.export_pdf_busy": "Lager PDF…",
        "project.time_overview.ui.pdf_selection_changed": "Timelisten er endret siden den ble lastet. Oppdater listen og prøv igjen.",
        "project.time_overview.ui.pdf_refresh_list": "Oppdater listen",
        "project.time_overview.ui.pdf_too_many": "Utvalget er for stort for PDF (maks {{max}} føringer). Velg et mindre utvalg.",
        "project.time_overview.ui.pdf_invalid": "Serveren returnerte ikke en gyldig PDF. Prøv igjen.",
        "project.time_overview.ui.pdf_forbidden": "Du har ikke tilgang til å eksportere timene i dette prosjektet.",
        "project.time_overview.ui.pdf_failed": "Kunne ikke lage PDF. Prøv igjen.",
        "project.time_overview.ui.pdf_empty": "Ingen timer å eksportere i utvalget.",
        "project.time_overview.ui.pdf_filename_prefix": "timeoversikt",
        "project.time_overview.ui.new_entry": "Ny føring",
        "project.time_overview.ui.time_budget": "TIMEBUDSJETT",
        "project.time_overview.ui.budget_used": "Timebudsjett brukt",
        "project.time_overview.ui.percent_used": "{{percent}} % brukt",
        "project.time_overview.ui.budget_remaining": "GJENSTÅR AV BUDSJETT",
        "project.time_overview.ui.over_budget": "{{hours}} t over budsjett",
        "project.time_overview.ui.available_budget": "Tilgjengelige budsjetttimer",
        "project.time_overview.ui.registered_selected": "REGISTRERT I UTVALGET",
        "project.time_overview.ui.entry_people_count": "{{entries}} føringer · {{people}} personer",
        "project.time_overview.ui.team": "TEAM",
        "project.time_overview.ui.active_members": "aktive prosjektdeltakere",
        "project.time_overview.ui.awaiting_approval": "TIL GODKJENNING",
        "project.time_overview.ui.entries_waiting": "{{count}} føringer venter",
        "project.time_overview.ui.without_order_upper": "UTEN ORDRE",
        "project.time_overview.ui.entries_count": "{{count}} føringer",
        "project.time_overview.ui.supplier_upper": "UNDERLEVERANDØR",
        "project.time_overview.ui.hours_without_full_invoice": "{{hours}} t uten full fakturadekning",
        "project.time_overview.ui.hours_per_order": "TIMER PER ORDRE · VALGT PERIODE",
        "project.time_overview.ui.select_order_hint": "Velg en ordre for å filtrere føringene",
        "project.time_overview.ui.in_period": "i perioden",
        "project.time_overview.ui.hours_waiting": "{{hours}} t venter",
        "project.time_overview.ui.order_budget_used": "Budsjett brukt for {{order}}",
        "project.time_overview.ui.order_budget_total": "{{used}} av {{budget}} t totalt · {{percent}} %",
        "project.time_overview.ui.search_hours": "Søk i timer",
        "project.time_overview.ui.search_placeholder": "Søk kommentar, ordre, ansatt",
        "project.time_overview.ui.filters": "Filtre",
        "project.time_overview.ui.activity": "Aktivitet",
        "project.time_overview.ui.order": "Ordre",
        "project.time_overview.ui.employee": "Ansatt",
        "project.time_overview.ui.status": "Status",
        "project.time_overview.ui.type": "Type",
        "project.time_overview.ui.link": "Kobling",
        "project.time_overview.ui.remove_filter": "Fjern filter: {{label}}",
        "project.time_overview.ui.reset_all": "Nullstill alle · {{filtered}} av {{total}} føringer",
        "project.time_overview.ui.unknown_employee": "Ukjent ansatt",
        "project.time_overview.ui.without_activity": "Uten aktivitet",
        "project.time_overview.ui.without_date": "Uten dato",
        "project.time_overview.ui.not_linked": "Ikke koblet",
        "project.time_overview.ui.select_group": "Velg gruppe {{title}}",
        "project.time_overview.ui.show_more": "Vis {{count}} flere føringer",
        "project.time_overview.ui.time_view": "Timevisning",
        "project.time_overview.ui.entries": "Føringer",
        "project.time_overview.ui.matrix": "Matrise",
        "project.time_overview.ui.supplier_invoice": "Leverandørfaktura",
        "project.time_overview.ui.groups": "GRUPPER",
        "project.time_overview.ui.date": "Dato",
        "project.time_overview.ui.none": "Ingen",
        "project.time_overview.ui.expand_all": "Utvid alle",
        "project.time_overview.ui.collapse_all": "Slå sammen alle",
        "project.time_overview.ui.normal_rows": "Normale rader",
        "project.time_overview.ui.compact_rows": "Kompakte rader",
        "project.time_overview.ui.selected_hours": "{{count}} valgt · {{hours}} t",
        "project.time_overview.ui.select_for_bulk": "Velg føringer for massehandlinger",
        "project.time_overview.ui.approve_selected": "Godkjenn valgte ({{count}})",
        "project.time_overview.ui.reject_selected": "Avvis valgte ({{count}})",
        "project.time_overview.ui.select_all": "Velg alle føringer i utvalget",
        "project.time_overview.ui.date_upper": "DATO",
        "project.time_overview.ui.employee_upper": "ANSATT",
        "project.time_overview.ui.project_upper": "PROSJEKT",
        "project.time_overview.ui.activity_upper": "AKTIVITET",
        "project.time_overview.ui.order_upper": "ORDRE",
        "project.time_overview.ui.invoice_upper": "LEV.FAKTURA",
        "project.time_overview.ui.hours_upper": "TIMER",
        "project.time_overview.ui.status_upper": "STATUS",
        "project.time_overview.ui.actions_upper": "HANDLINGER",
        "project.time_overview.ui.sum_entries": "SUM · {{count}} FØRINGER",
        "project.time_overview.ui.rows": "RADER",
        "project.time_overview.ui.hide_weekends": "Skjul helger",
        "project.time_overview.ui.show_weekends": "Vis helger",
        "project.time_overview.ui.weeks": "Uker",
        "project.time_overview.ui.days": "Dager",
        "project.time_overview.ui.matrix_hint": "{{period}} · klikk en celle for å se føringene",
        "project.time_overview.ui.sum": "SUM",
        "project.time_overview.ui.no_hours_period": "Ingen timer i perioden.",
        "project.time_overview.ui.invoice_intro": "Prosjektets registrerte leverandørfakturaer og fakturadekning for timene i valgt periode. Velg timer i «Føringer» for å koble eller avstemme.",
        "project.time_overview.ui.invoice_intro_readonly": "Prosjektets registrerte leverandørfakturaer. Timekoblinger krever tilgang til timeavstemming.",
        "project.time_overview.ui.project_invoice_amount": "Prosjektbeløp ekskl. mva.: {{amount}}",
        "project.time_overview.ui.no_linked_hours_period": "Ingen koblede timer i valgt periode",
        "project.time_overview.ui.hour_links_restricted": "Timekoblinger krever tilgang til timeavstemming",
        "project.time_overview.ui.no_supplier_invoices": "Ingen leverandørfakturaer eller underleverandørtimer i utvalget.",
        "project.time_overview.ui.no_supplier_invoices_readonly": "Ingen leverandørfakturaer registrert for prosjektet.",
        "project.time_overview.ui.invoice_readonly_error": "Leverandørfakturaene kunne ikke hentes. Prøv igjen.",
        "project.time_overview.ui.costs_load_error": "Timekostnadene kunne ikke beregnes. Prøv igjen i timeoversikten.",
        "project.time_overview.ui.loading_invoices": "Henter prosjektets leverandørfakturaer…",
        "project.time_overview.ui.invoice_approved_local": "Godkjent i Promang",
        "project.time_overview.ui.invoice_rejected_local": "Avvist i Promang",
        "project.time_overview.ui.invoice_no_local_approval": "Ingen intern godkjenning registrert",
        "project.time_overview.ui.invoice_details_error": "Fakturadetaljene kunne ikke hentes. Timekoblinger og fakturadekning vises fortsatt.",
        "project.time_overview.ui.not_linked_invoice": "Ikke koblet til leverandørfaktura",
        "project.time_overview.ui.invoice_number": "Faktura {{number}}",
        "project.time_overview.ui.supplier_invoice_number": "Leverandørfaktura #{{number}}",
        "project.time_overview.ui.invoice_date": "Dato {{date}}",
        "project.time_overview.ui.hours_logged": "{{hours}} t ført",
        "project.time_overview.ui.hours_covered": "{{hours}} t dekket av faktura",
        "project.time_overview.ui.hours_uncovered": "{{hours}} t uten fakturadekning",
        "project.time_overview.ui.show_hours_by_employee_order": "Vis timer per ansatt og ordre",
        "project.time_overview.ui.logged_upper": "FØRT",
        "project.time_overview.ui.covered_upper": "DEKKET",
        "project.time_overview.ui.view_invoice": "Se faktura",
        "project.time_overview.ui.no_supplier_hours": "Ingen underleverandørtimer i perioden.",
        "project.time_overview.ui.bulk_unknown_outcome": "Utfallet av siste føring er ukjent. Kontroller status før du prøver igjen.",
        "project.time_overview.ui.bulk_remaining": "{{done}} bekreftet behandlet. {{remaining}} gjenstår. {{error}}",
        "project.time_overview.ui.bulk_approved": "{{count}} føringer godkjent.",
        "project.time_overview.ui.bulk_rejected": "{{count}} føringer avvist.",
        "project.time_overview.ui.approve_selected_hours": "Godkjenn valgte timer",
        "project.time_overview.ui.reject_selected_hours": "Avvis valgte timer",
        "project.time_overview.ui.bulk_processing": "{{count}} føringer behandles. Godkjente eller avviste føringer er ikke med.",
        "project.time_overview.ui.rejection_reason": "Begrunnelse for avvisning",
        "project.time_overview.ui.close": "Lukk",
        "project.time_overview.ui.cancel": "Avbryt",
        "project.time_overview.ui.processing": "Behandler…",
        "project.time_overview.ui.reject_hours": "Avvis timer",
        "project.time_overview.ui.approve_hours": "Godkjenn timer",
        "project.time_overview.ui.week_number": "Uke {{number}}",
        "project.time_overview.ui.filter_dialog": "{{label}}-filter",
        "project.time_overview.ui.hour_unit": "t",
        "project.time_overview.ui.hours": "Timer",
        "project.time_overview.ui.description_column": "Beskrivelse",
        "project.time_overview.empty": "Ingen timer funnet for dette prosjektet",
        "project.time_overview.total_hours": "Totalt",
        "project.time_overview.summary_total": "Totalt",
        "project.time_overview.ungrouped": "Uten gruppe",
        "project.time_overview.unapproved_secondary":
          "{{count}} ikke godkjent ({{hours}} t)",
        "project.time_registration": "Timeregistrering",
        "project.time_registration.sync": "Synkroniser med Tripletex",
        "project.time_registration.sync_to_tripletex":
          "Synkroniser til Tripletex",
        "project.time_registration.sync_from_tripletex":
          "Synkroniser fra Tripletex",
        "project.time_registration.sync_success": "Timeregistrering synkronisert",
        "project.time_registration.sync_error":
          "Kunne ikke synkronisere timeregistrering",
        "project.time_registration.loading": "Laster timeregistrering…",
        "project.time_registration.list_title": "Timeregistrering — {{title}}",
        "project.time_registration.filter": "Filtrer",
        "project.time_registration.all_hours": "Alle timer",
        "project.time_registration.date_from": "Fra dato",
        "project.time_registration.date_to": "Til dato",
        "project.time_registration.empty":
          "Ingen timeregistrering funnet for dette prosjektet",
        "project.time_registration.registrations": "registreringer",
        "project.time_registration.no_activity": "Ingen aktivitet",
        "project.time_registration.approved_section": "Godkjente timer",
        "project.time_registration.approved_section_hint":
          "Disse timene er godkjent og inngår i summering og timekostnader over.",
        "project.time_registration.excluded_section":
          "Ikke godkjente eller avventer godkjenning",
        "project.time_registration.excluded_section_hint":
          "Timer som ikke er godkjent, inngår ikke i totaler eller timekostnader.",
        "project.time_registration.no_approved_in_range":
          "Ingen godkjente timer i valgt periode.",
        "project.time_registration.total_approved_hours": "Godkjente timer (sum)",
        "project.time_registration.total_excluded_hours": "Utenfor sum",
        "project.time_registration.summary_approved_label":
          "Totalt godkjente timer (summering)",
        "project.time_registration.summary_excluded_note":
          "{{hours}} timer er ikke godkjent og telles ikke med.",
        "project.time_registration.badge_approved": "Godkjent",
        "project.time_registration.badge_rejected": "Ikke godkjent",
        "project.time_registration.badge_pending": "Avventer godkjenning",
        "project.time_registration.approve": "Godkjenn",
        "project.time_registration.reject": "Ikke godkjenn",
        "project.time_registration.open_hour": "Rediger time",
        "project.time_registration.process_dialog": "Behandle time",
  
        "project.hourly_costs": "Timekostnader",
        "project.hourly_costs.calculation": "Beregning av timekostnader",
        "project.hourly_costs.social_expenses": "Sosiale utgifter (28%)",
        "project.hourly_costs.total_cost": "Total timekostnad",
        "project.hourly_costs.missing_rate_warning":
          "Mangler gyldig timekostnad for denne ansatte",
        "project.hourly_costs.warning_title": "Advarsel: Manglende timekostnad",
  
        "project.item_list": "Vareliste",
        "project.item_list.create": "Opprett vareliste",
        "project.item_list.edit": "Rediger vareliste",
        "project.item_list.delete": "Slett vareliste",
        "project.item_list.type": "Type vareliste",
        "project.item_list.type.consumption": "Forbruk",
        "project.item_list.type.return": "Retur",
        "project.item_list.warehouse": "Varelager",
        "project.item_list.select_warehouse": "Velg varelager",
        "project.item_list.save": "Lagre vareliste",
        "project.item_list.deliver": "Levere vareliste",
        "project.item_list.approve": "Godkjenn vareliste",
        "project.item_list.reject": "Avslå vareliste",
        "project.item_list.submit_for_approval": "Send til godkjenning",
        "project.item_list.status": "Status",
        "project.item_list.status.label": "Status",
        "project.item_list.status.draft": "Kladd",
        "project.item_list.status.pending_approval": "Venter på godkjenning",
        "project.item_list.status.delivered": "Levert",
        "project.item_list.status.approved": "Godkjent",
        "project.item_list.status.rejected": "Avslått",
        "project.item_list.status.invoiced_manually": "Fakturert, manuelt",
        "project.item_list.mark_invoiced_manually": "Merk som fakturert (manuelt)",
        "project.item_list.print": "Skriv ut",
        "project.item_list.total_purchase": "Totalt innkjøp",
        "project.item_list.merge.select": "Velg",
        "project.item_list.merge.select_list": "Velg liste {{title}}",
        "project.item_list.merge.select_all_eligible": "Velg alle",
        "project.item_list.merge.deselect_all": "Nullstill utvalg",
        "project.item_list.merge.create_order": "Opprett ordre fra lister",
        "project.item_list.merge.dialog_title": "Opprett ordre fra varelister",
        "project.item_list.merge.dialog_hint": "{{count}} liste(r) valgt. Velg hvordan ordrelinjer bygges og eventuelle pristilpasninger.",
        "project.item_list.merge.mode_label": "Linjeoppsett",
        "project.item_list.merge.mode.grouped_by_list": "Én gruppe per vareliste (navn = gruppetittel), alle produktlinjer",
        "project.item_list.merge.mode.one_line_per_list": "Én samlet linje per vareliste (vektet enhetspris)",
        "project.item_list.merge.mode.flat_by_product": "Samlet oversikt: én linje per produkt (samlet mengde)",
        "project.item_list.merge.purchase_markup": "Innkjøp + %",
        "project.item_list.merge.sales_discount": "Rabatt på salgspris (%)",
        "project.item_list.merge.sales_surcharge": "Påslag på salgspris (%)",
        "project.item_list.merge.mark_invoiced_after": "Merk valgte varelister som fakturert manuelt etter at ordren er opprettet",
        "project.item_list.merge.submit": "Opprett ordre",
        "project.item_list.merge.submitting": "Oppretter ordre…",
        "project.item_list.merge.error_generic": "Kunne ikke opprette ordre. Sjekk tilgang og at listene har varer.",
        "project.item_list.add_product": "Legg til produkt",
        "project.item_list.products": "Varer",
        "project.item_list.product": "Produkt",
        "project.item_list.quantity": "Mengde",
        "project.item_list.price": "Pris",
        "project.item_list.total": "Total",
        "project.item_list.actions": "Handlinger",
        "project.item_list.remove": "Fjern",
        "project.item_list.no_items": "Ingen varer",
        "project.item_list.no_items_description": "Denne varelisten har ingen varer ennå.",
        "project.item_list.scan_qr": "Skann QR-kode",
        "project.item_list.manual_search": "Søk manuelt",
        "project.item_list.scan_or_enter": "Skann QR-kode eller skriv inn produktnummer",
        "project.item_list.selected_product": "Valgt produkt",
        "project.item_list.add": "Legg til",
        "project.item_list.back": "Tilbake",
        "project.item_list.cancel": "Avbryt",
        "project.item_list.created_by": "Opprettet av",
        "project.item_list.approved_by": "Godkjent av",
        "project.item_list.approval_comment": "Godkjenningskommentar",
        "project.item_list.total_items": "Antall varer",
        "project.item_list.total_quantity": "Total mengde",
        "project.item_list.total_value": "Total verdi",
        "project.item_list.summary_title": "Varelister — oppsummering",
        "project.item_list.summary_total_quantity": "Total mengde (netto)",
        "project.item_list.summary_total_purchase": "Totalt innkjøp",
        "project.item_list.summary_total_sales": "Totalt salg",
        "project.item_list.view_items_summary": "Se vareoppsummering",
        "project.item_list.items_summary_page_title": "Varelister — oppsummering",
        "project.item_list.items_summary_subtitle": "Mengder og priser på tvers av alle lister i prosjektet",
        "project.item_list.items_summary_intro":
          "Rader slås sammen etter produktets varenummer (produkter uten nummer grupperes per produkt). Returlister reduserer netto mengde og beløp.",
        "project.item_list.items_summary_table_item_number": "Varenr.",
  
        "project.invoices": "Fakturaer",
        "project.invoices.overview": "Oversikt over fakturaer",
        "project.invoices.create": "Opprett faktura",
        "project.invoices.edit": "Rediger faktura",
        "project.invoices.delete": "Slett faktura",
        "project.invoices.status": "Fakturastatus",
        "project.invoices.status.paid": "Betalt",
        "project.invoices.status.pending": "Venter",
        "project.invoices.status.overdue": "Forfalt",
        "project.invoices.amount": "Beløp",
        "project.invoices.due_date": "Forfallsdato",
        "project.invoices.totals.invoiced_ex_vat": "Totalt fakturert (eks. mva)",
        "project.invoices.pagination.showing": "Viser {{from}}–{{to}} av {{total}}",
        "project.invoices.pagination.load_more": "Last inn flere fakturaer",
        "project.invoices.pagination.loading_more": "Laster…",
        "project.invoices.pagination.loaded_of_total": "{{loaded}} av {{total}} fakturaer vist",
        "project.invoices.pagination.all_loaded": "Alle {{total}} fakturaer er innlastet",
        "project.invoices.create_disabled_hint": "Opprett faktura er ikke tilgjengelig her ennå",
        "project.invoices.pagination.prev": "Forrige",
        "project.invoices.pagination.next": "Neste",
        "project.invoices.error.title": "Feil ved lasting",
        "project.invoices.no_invoices.title": "Ingen fakturaer",
        "project.invoices.no_invoices.description": "Ingen fakturaer er opprettet for dette prosjektet ennå",
  
        "project.supplier_invoices": "Leverandørfakturaer",
        "project.supplier_invoices.overview": "Oversikt over leverandørfakturaer",
        "project.supplier_invoices.create": "Opprett leverandørfaktura",
        "project.supplier_invoices.edit": "Rediger leverandørfaktura",
        "project.supplier_invoices.delete": "Slett leverandørfaktura",
  
        "project.billing_plan": "Faktureringsplan",
        "project.billing_plan.overview": "Oversikt levert/utført",
        "project.billing_plan.create_invoice": "Opprett A-konto faktura",
        "project.billing_plan.final_invoice": "Sluttfaktura",
        "project.billing_plan.progress": "Fremdrift",
        "project.billing_plan.completed": "Utført",
        "project.billing_plan.remaining": "Innestående",
        "project.billing_plan.contract_sum": "Kontraktsum",
        "project.billing_plan.completed_amount": "Utført beløp",
        "project.billing_plan.billed_amount": "Fakturert beløp",
        "project.billing_plan.remaining_amount": "Innestående beløp",
        "project.billing_plan.completed_sum": "Utført beløp",
        "project.billing_plan.billable_sum": "Fakturerbart beløp",
        "project.billing_plan.items.title": "Faktureringsplan",
        "project.billing_plan.items.empty": "Ingen faktureringsplaner opprettet ennå",
        "project.billing_plan.type": "Type",
        "project.billing_plan.planned_date": "Planlagt dato",
        "project.billing_plan.amount": "Beløp",
        "project.billing_plan.status.title": "Status",
        "project.billing_plan.status.planned": "Planlagt",
        "project.billing_plan.status.billed": "Fakturert",
        "project.billing_plan.status.cancelled": "Avbrutt",
        "project.billing_plan.actions": "Handlinger",
        "project.billing_plan.edit": "Rediger",
        "project.billing_plan.delete": "Slett",
        "project.billing_plan.edit_item": "Rediger faktureringsplan",
        "project.billing_plan.no_description": "Ingen beskrivelse",
        "project.billing_plan.deleting": "Sletter faktureringsplan...",
        "project.billing_plan.updating": "Oppdaterer faktureringsplan...",
        "project.billing_plan.creating": "Oppretter faktureringsplan...",
        "project.billing_plan.delete_confirmation": "Er du sikker på at du vil slette denne faktureringsplanen?",
        "project.billing_plan.invoice_selected": "Fakturer valgte",
        "project.billing_plan.invoicing": "Fakturerer...",
        "project.billing_plan.a_account": "A-konto",
        "project.billing_plan.invoice_number": "Fakturanr",
        "project.billing_plan.settings": "Innstillinger",
        "project.billing_plan.remaining_settings_title": "Innstillinger for innestående beløp",
        "project.billing_plan.amount_to_invoice": "Beløp til fakturering",
        "project.billing_plan.amount_to_invoice_hint": "Forslag: utført for denne raden/periode minus innestående når dette er aktivert på prosjektet. Samme som utført når innestående ikke er aktivert. Tidligere fakturaer påvirker ikke beløpet. Oppdateres automatisk.",
        "project.billing_plan.retention_helper_disabled": "Innestående er 0 når prosjektinnstilling for withhold ikke er aktivert.",
        "project.billing_plan.retention_helper_enabled": "Innestående beregnes som {{pct}} % av {{base}}.",
        "project.billing_plan.retention_base_contract": "kontraktsum",
        "project.billing_plan.retention_base_completed": "utført beløp",
        "project.billing_plan.completed_helper": "Utført for denne perioden eller denne faktureringsraden (f.eks. faktureringsutkast). Sum fra kontraktslinjer, kun referanse: {{suggested}}.",
        "project.billing_plan.footer_suggested_line": "Foreslått beløp til fakturering: {{amount}} kr. Aktiv innestående: {{pct}} % av {{base}}. Tidligere fakturaer reduserer ikke forslaget.",
        "project.billing_plan.summary_title": "Beløpsoversikt",
        "project.billing_plan.summary_contract_lines_completed": "Sum kontraktslinjer (kun referanse)",
        "project.billing_plan.summary_billed_to_date": "Fakturert via plan til nå",
        "project.billing_plan.summary_retention_for_period": "Innestående (forslag for utført i skjema)",
        "project.billing_plan.invoice_edit_hint": "Endringer må gjøres i faktureringsplan før fakturering.",
        "project.billing_plan.invoice_type_label": "Faktureringstype",
        "project.billing_plan.invoice_auto": "Automatisk fakturering (opprett ny faktura og ordre for synk)",
        "project.billing_plan.invoice_manual": "Manuell/ekstern fakturering",
        "project.billing_plan.external_invoice_checkbox": "Ekstern faktura (fakturert utenfor systemet)",
        "project.billing_plan.link_invoice": "Knytt til eksisterende faktura (valgfritt)",
        "project.billing_plan.link_invoice_none": "Ingen knytning",
        "project.billing_plan.invoice_a_account_title": "Fakturer A-konto",
        "project.billing_plan.invoice_confirm": "Fakturer",
        "project.billing_plan.invoice_loading": "Fakturerer...",
        "project.billing_plan.invoice_created": "Faktura opprettet",
        "project.billing_plan.invoice_created_tripletex_ok": "Faktura opprettet og ordre bekreftet mot Tripletex.",
        "project.billing_plan.tripletex_queued_hint": "Tripletex-sesjon ikke tilgjengelig — ordre er satt i kø for synk (sjekk integrasjon og jobber om noe mangler).",
        "project.billing_plan.invoice_failed": "Kunne ikke fakturere",

        "project.contract_line": "Kontraktslinje",
        "project.contract_line.title": "Tittel",
        "project.contract_line.description": "Beskrivelse",
        "project.contract_line.contract_quantity": "Kontraktsmengde",
        "project.contract_line.completed_quantity": "Utført mengde",
        "project.contract_line.remaining_quantity": "Gjenstående mengde",
        "project.contract_line.unit_price": "Enhetspris",
        "project.contract_line.total_price": "Totalpris",
        "project.contract_line.create": "Ny kontraktslinje",
        "project.contract_line.edit": "Rediger kontraktslinje",
        "project.contract_line.delete": "Slett kontraktslinje",
  
        "project.contract_line_group": "Kontraktslinjegruppe",
        "project.contract_line_group.create": "Ny gruppe",
        "project.contract_line_group.edit": "Rediger gruppe",
  
        "project.delivery_progress": "Leveransefremdrift",
        "project.delivery_progress.register": "Registrer utført mengde",
        "project.delivery_progress.completed": "Utført",
        "project.delivery_progress.remaining": "Gjenstående",
  
        "project.settings": "Prosjektinnstillinger",
        "project.settings.retention_percentage": "Innestående (%)",
        "project.settings.final_invoice_due_days":
          "Sluttfaktura innestående forfallsdato (dager)",
        "project.settings.default_due_days": "Standard 60 dager",
  
        "project.website_settings": "Website innstillinger",
        "project.show_on_website": "Vis prosjekt på hjemmesiden",
        "project.show_on_website_description": "Aktiver for å vise prosjektet offentlig på hjemmesiden",
        "project.public_title": "Synlig tittel",
        "project.public_title_placeholder": "Tittel som vises på hjemmesiden",
        "project.public_description": "Synlig beskrivelse",
        "project.public_description_placeholder": "Beskrivelse som vises på hjemmesiden",
        "project.public_contract_sum": "Offentlig kontraktsum",
        "project.public_contract_sum_placeholder": "F.eks. 2 500 000 NOK",
        "project.public_contract_sum_description": "Kontraktsum som vises offentlig på hjemmesiden",
        "project.public_main_image": "Offentlig hovedbilde",
        "project.public_main_image_description": "Bilde som vises på hjemmesiden",
        "project.select_image": "Velg bilde",
        "project.change_image": "Bytt bilde",
        "project.search_images": "Søk etter bilder...",
        "project.searching": "Søker...",
        "project.search": "Søk",
        "project.no_images_found": "Ingen bilder funnet",
        "project.website_content_lines": "Innhold (statistikk/info)",
        "project.content_line_title": "Tittel",
        "project.content_line_value": "Verdi",
        "project.line_type_info": "Info",
        "project.line_type_statistics": "Statistikk",
        "project.add_line": "Legg til",
        "project.update_line": "Oppdater",
        "project.cancel": "Avbryt",
        "project.no_content_lines": "Ingen innholdslinjer lagt til",
        "project.saving": "Lagrer...",
        "project.save_settings": "Lagre innstillinger",
  
        "project.summary": "Prosjektsummering",
        "project.summary.overview": "Oversiktlig regnskap",
        "project.summary.labor_costs": "Lønnskostnader",
        "project.summary.material_costs": "Vareforbruk",
        "project.summary.material_costs_hint": "Ikke bare varelistens innkjøpssum — se info for kilder.",
        "project.summary.material_costs_info_aria": "Slik beregnes vareforbruk",
        "project.summary.invoiced_amount": "Fakturert beløp",
        "project.summary.supplier_invoices": "Leverandørfakturaer",
        "project.summary.total_costs": "Totale kostnader",
        "project.summary.profit": "Resultat",
        "project.summary.margin": "Margin",
        "project.summary.provisional_result": "Foreløpig resultat",
        "project.summary.profit_vs_contract": "Resultat mot kontraktsum",
        "project.summary.profit_vs_invoiced": "Resultat mot fakturert",
        "project.summary.margin_vs_contract": "Margin mot kontraktsum",
        "project.summary.margin_vs_invoiced": "Margin mot fakturert",
        "project.summary.not_invoiced": "Ikke fakturert",
        "project.summary.invoiced_ex_vat": "Sum kundefakturaer, eks. mva",
        "project.summary.margin_on_contract_hint": "Beregnet av kontraktsum",
        "project.summary.module_breakdown": "Moduloversikt",
        "project.summary.module_breakdown_description": "Oversikt over alle moduler som påvirker prosjektsummeringen",
        "project.summary.module_type.report": "Rapport",
        "project.summary.module_type.work_order": "Arbeidsordre",
        "project.summary.module_type.item_list": "Vareliste",
        "project.summary.invoiced": "Fakturert",
        "project.summary.has_order": "Har ordre",
        "project.summary.costs": "Kostnader",
        "project.summary.income": "Inntekter",
        "project.summary.hours": "Timer",
        "project.summary.hours_short": "t",
        "project.summary.material": "Materialer",
        "project.summary.agreed_price": "Avtalt pris",
        "project.summary.price_lines": "prislinjer",
        "project.summary.expected_module_income": "Forventet inntekt fra moduler",
        "project.summary.expected_module_costs": "Forventet modulkostnader",
        "project.summary.not_included_in_total": "ikke inkludert i total",
        "project.summary.invoiced_ex_vat_basis": "fakturert (eks. mva)",
        "project.summary.margin_on_invoiced_hint": "Beregnet av fakturert beløp eks. mva",
        "project.summary.of": "av",
        "project.summary.invoicing_rate_no_contract": "Ikke definert uten kontraktsum",
        "project.summary.cost_rate_on_invoiced_hint": "mot fakturert eks. mva",
        "project.summary.invoicing_rate": "Faktureringsgrad",
        "project.summary.cost_rate": "Kostnadsgrad",
        "project.summary.contract_sum": "Kontraktsum",
        "project.summary.remaining": "Gjenstående",
        "project.summary.cost_breakdown": "Kostnadsfordeling",
        "project.summary.no_costs": "Ingen kostnader registrert ennå",
        "project.summary.last_updated": "Sist oppdatert",
        "project.summary.export_pdf": "Eksporter PDF",
        "project.summary.error.title": "Feil ved lasting",
        "project.summary.no_data.title": "Ingen data tilgjengelig",
        "project.summary.no_data.description": "Prosjektsummering vil bli generert når data er tilgjengelig",
  
        "project.order_line": "Ordrelinje",
        "project.order_line.a_account": "A-konto",
        "project.order_line.description": "Beskrivelse",
        "project.order_line.completed_amount": "Utført beløp",
        "project.order_line.remaining_amount": "Innestående beløp",
        "project.order_line.final_invoice": "Sluttfaktura",
  
        "project.tripletex_sync": "Tripletex synkronisering",
        "project.tripletex_sync.disabled":
          "Synkronisering deaktivert for prosjekter med flere fakturaer",
        "project.tripletex_sync.reason":
          "Prosjektet har flere enn 1 faktura og er synkronisert med Tripletex",
  
        // Project Participants translations
        "project.participants.title": "Deltagere",
        "project.participants.description": "Prosjektdeltagere og deres roller",
        "project.participants.add": "Legg til deltager",
        "project.participants.add_first": "Legg til første deltager",
        "project.participants.edit": "Rediger deltager",
        "project.participants.delete": "Slett deltager",
        "project.participants.delete_confirm": "Er du sikker på at du vil fjerne denne deltageren?",
        "project.participants.none": "Ingen deltagere lagt til ennå.",
        "project.participants.user": "Bruker",
        "project.participants.role": "Rolle",
        "project.participants.status": "Status",
        "project.participants.admin": "Admin",
        "project.participants.error_loading": "Feil ved lasting av deltagere",

        // Project tasks (Prosjektoppgaver)
        "project.tasks.tab_title": "Oppgaver",
        "project.tasks.title": "Prosjektoppgaver",
        "project.tasks.subtitle":
          "Oppgaver knyttet til dette prosjektet. Vises også i din Todo-innboks.",
        "project.tasks.new_task": "Ny oppgave",
        "project.tasks.load_template": "Last inn mal",
        "project.tasks.show_finished": "Vis fullførte",
        "project.tasks.empty": "Ingen oppgaver på dette prosjektet ennå.",
        "project.tasks.no_open": "Ingen åpne oppgaver.",
        "project.tasks.finished_heading": "Fullført",
        "project.tasks.filter_by_due": "Filtrer på frist",
        "project.tasks.bucket_all": "Alle",
        "project.tasks.bucket_overdue": "Forfalt",
        "project.tasks.bucket_today": "I dag",
        "project.tasks.bucket_soon": "Kommende",
        "project.tasks.bucket_later": "Lengre frem",
        "project.tasks.bucket_no_due": "Uten frist",
        "project.tasks.due": "Frist",
        "project.tasks.shared": "Delt",
        "project.tasks.blocked": "Blokkert",
        "project.tasks.blocked_hint":
          "Tilknyttet sjekkliste må ferdigstilles før oppgaven kan fullføres.",
        "project.tasks.finish": "Fullfør",
        "project.tasks.finished": "Fullført",
        "project.tasks.mark_finished": "Marker som fullført",
        "project.tasks.reopen": "Gjenåpne",
        "project.tasks.finish_failed": "Kunne ikke endre status på oppgaven.",
        "project.tasks.bulk_apply": "Oppdater valgte",
        "project.tasks.bulk_need_change": "Velg ny frist eller ansvarlig før du oppdaterer.",
        "project.tasks.bulk_done": "Oppgavene er oppdatert.",
        "project.tasks.bulk_failed": "Kunne ikke oppdatere oppgavene.",
        "project.tasks.selected_count": "{{count}} valgt",
        "project.tasks.load_failed": "Kunne ikke laste oppgaver.",
        "project.tasks.created": "Oppgave opprettet.",
        "project.tasks.create_failed": "Kunne ikke opprette oppgave.",
        "project.tasks.title_required": "Tittel er påkrevd.",
        "project.tasks.create": "Opprett",
        "project.tasks.edit": "Rediger",
        "project.tasks.edit_task": "Rediger oppgave",
        "project.tasks.save": "Lagre",
        "project.tasks.updated": "Oppgave oppdatert.",
        "project.tasks.update_failed": "Kunne ikke oppdatere oppgave.",
        "project.tasks.field_recurrence": "Gjentakelse",
        "project.tasks.field_title": "Tittel",
        "project.tasks.field_description": "Beskrivelse",
        "project.tasks.field_due_date": "Frist",
        "project.tasks.field_priority": "Prioritet",
        "project.tasks.priority_none": "Ingen",
        "project.tasks.priority_low": "Lav",
        "project.tasks.priority_medium": "Middels",
        "project.tasks.priority_high": "Høy",
        "project.tasks.field_checklist": "Knytt til sjekkliste",
        "project.tasks.checklist_none": "Ingen sjekkliste",
        "project.tasks.checklist_gate_hint":
          "Oppgaven kan først fullføres når sjekklisten er ferdigstilt eller godkjent.",
        "project.tasks.field_assignees": "Mottakere",
        "project.tasks.add_assignees": "Legg til mottakere",
        "project.tasks.on_today_plan": "Legg til i dagens plan",
        "project.tasks.no_templates": "Ingen aktive oppgavemaler.",
        "project.tasks.apply": "Last inn",
        "project.tasks.template_applied": "La inn {{count}} oppgave(r) fra mal.",
        "project.tasks.template_failed": "Kunne ikke laste inn mal.",
        "project.tasks.template_item_count": "{{count}} oppgaver",
        "task.referenceBlocked.checklist":
          "Oppgaven kan ikke fullføres før den tilknyttede sjekklisten er ferdigstilt eller godkjent.",
        "projectTaskTemplate.title": "Prosjektoppgavemaler",
        "projectTaskTemplate.subtitle":
          "Gjenbrukbare sett med oppgaver som kan lastes inn på prosjekter.",
        "projectTaskTemplate.new_set": "Nytt malsett",
        "projectTaskTemplate.set_title": "Tittel",
        "projectTaskTemplate.set_description": "Beskrivelse",
        "projectTaskTemplate.set_category": "Kategori",
        "projectTaskTemplate.set_active": "Aktiv",
        "projectTaskTemplate.items": "Oppgaver i settet",
        "projectTaskTemplate.add_item": "Legg til oppgave",
        "projectTaskTemplate.item_title": "Tittel",
        "projectTaskTemplate.item_due_offset": "Frist (dager fra prosjektstart)",
        "projectTaskTemplate.item_recurrence": "Gjentakelse",
        "projectTaskTemplate.item_shared": "Delt",
        "projectTaskTemplate.spawn_checklist": "Opprett sjekkliste",
        "projectTaskTemplate.select_checklist_type": "Velg sjekklistetype",
        "projectTaskTemplate.edit": "Rediger",
        "projectTaskTemplate.edit_set": "Rediger malsett",
        "projectTaskTemplate.save": "Lagre",
        "projectTaskTemplate.saved": "Malsett lagret.",
        "projectTaskTemplate.save_failed": "Kunne ikke lagre malsett.",
        "projectTaskTemplate.delete": "Slett",
        "projectTaskTemplate.delete_confirm": "Slette dette malsettet?",
        "projectTaskTemplate.deleted": "Malsett slettet.",
        "projectTaskTemplate.empty": "Ingen malsett ennå.",
        "projectTaskTemplate.load_failed": "Kunne ikke laste malsett.",
        "projectTaskTemplate.json.open_dialog": "JSON / AI",
        "projectTaskTemplate.json.dialog_title": "Malsett JSON og AI-instruksjoner",
        "projectTaskTemplate.json.tab_json": "Lim inn JSON",
        "projectTaskTemplate.json.tab_ai_guide": "AI-instruksjoner",
        "projectTaskTemplate.json.hint": "Lim inn JSON fra AI eller kopier gjeldende malsett. Bruk Erstatt eller Legg til.",
        "projectTaskTemplate.json.copy_json": "Kopier JSON",
        "projectTaskTemplate.json.copy_success": "JSON kopiert",
        "projectTaskTemplate.json.reload_from_editor": "Last fra editor",
        "projectTaskTemplate.json.reload_success": "JSON lastet fra editor",
        "projectTaskTemplate.json.insert_sample": "Sett inn eksempel",
        "projectTaskTemplate.json.apply": "Bruk i editor",
        "projectTaskTemplate.json.applied": "{{count}} oppgaver lagt inn",
        "projectTaskTemplate.json.replace_items": "Erstatt alle oppgaver",
        "projectTaskTemplate.json.append_items": "Legg til nederst",
        "projectTaskTemplate.json.clipboard_failed": "Kunne ikke kopiere til utklippstavlen",
        "projectTaskTemplate.json.ai_guide_intro": "Kopier instruksjonene under til ChatGPT, Claude eller annen AI. Lim deretter JSON-svaret inn under fanen Lim inn JSON.",
        "projectTaskTemplate.json.copy_ai_guide": "Kopier AI-instruksjoner",
        "projectTaskTemplate.json.ai_guide_copied": "AI-instruksjoner kopiert",
        "projectTaskTemplate.json.generate_with_ai": "Generer med AI",
        "projectTaskTemplate.json.ai_parse_error": "Kunne ikke lese AI-svar som JSON",
        "projectTaskTemplate.json.ai_apply_success": "{{count}} oppgaver lagt inn fra AI",
        "projectTaskTemplate.json.error_empty": "JSON er tom",
        "projectTaskTemplate.json.error_invalid_json": "Ugyldig JSON",
        "projectTaskTemplate.json.error_no_items_array": "JSON mangler items-array",
        "projectTaskTemplate.json.error_no_valid_items": "Ingen gyldige oppgaver i JSON",

        // Project HSE handbook (HMS Håndbok for prosjekt)
        "project.hse_handbook.tab_title": "HMS Håndbok",
        "project.hse_handbook.title": "HMS Håndbok for prosjekt",
        "project.hse_handbook.subtitle":
          "Hent inn HMS-dokumenter, sjekklister og skjemaer for dette prosjektet.",
        "project.hse_handbook.section_documents": "Dokumenter",
        "project.hse_handbook.section_checklists": "Sjekklister",
        "project.hse_handbook.section_forms": "Skjemaer",
        "project.hse_handbook.section_crew": "Mannskapsliste",
        "project.hse_handbook.add_document": "Legg til dokument",
        "project.hse_handbook.import_template": "Importer mal",
        "project.hse_handbook.print": "Skriv ut håndbok",
        "project.hse_handbook.printing": "Håndboken skrives ut …",
        "project.hse_handbook.print_failed": "Kunne ikke skrive ut håndboken",
        "project.hse_handbook.open_personal_handbook": "Personalhåndbok",
        "project.hse_handbook.view": "Vis",
        "project.hse_handbook.remove": "Fjern",
        "project.hse_handbook.remove_confirm": "Fjerne dette dokumentet fra håndboken?",
        "project.hse_handbook.removed": "Dokument fjernet fra håndboken",
        "project.hse_handbook.remove_failed": "Kunne ikke fjerne dokumentet",
        "project.hse_handbook.create_copy": "Lag prosjektkopi",
        "project.hse_handbook.create_checklist": "Lag sjekkliste",
        "project.hse_handbook.checklist_created": "Sjekkliste opprettet",
        "project.hse_handbook.checklist_failed": "Kunne ikke opprette sjekkliste",
        "project.hse_handbook.fill_form": "Fyll ut skjema",
        "project.hse_handbook.form_created": "Skjema opprettet",
        "project.hse_handbook.form_failed": "Kunne ikke opprette skjema",
        "project.hse_handbook.override_created": "Prosjektkopi opprettet",
        "project.hse_handbook.override_failed": "Kunne ikke opprette prosjektkopi",
        "project.hse_handbook.project_copy": "Prosjektkopi",
        "project.hse_handbook.added": "{{count}} dokument(er) lagt til",
        "project.hse_handbook.add_failed": "Kunne ikke legge til dokumenter",
        "project.hse_handbook.add_selected": "Legg til ({{count}})",
        "project.hse_handbook.imported": "{{count}} dokument(er) importert",
        "project.hse_handbook.import_failed": "Kunne ikke importere dokumenter",
        "project.hse_handbook.import_all_confirm":
          "Importere alle godkjente HMS-dokumenter, sjekklister og skjemaer til prosjektet?",
        "project.hse_handbook.load_failed": "Kunne ikke laste håndboken",
        "project.hse_handbook.empty_section": "Ingen dokumenter i denne seksjonen ennå.",
        "project.hse_handbook.no_content": "Ingen innhold registrert.",
        "project.hse_handbook.no_available_documents": "Ingen tilgjengelige dokumenter.",
        "project.hse_handbook.already_added": "Allerede lagt til",
        "project.hse_handbook.no_crew": "Ingen mannskap registrert på prosjektet.",
        "project.hse_handbook.crew_name": "Navn",
        "project.hse_handbook.crew_role": "Rolle",
        "project.hse_handbook.crew_email": "E-post",
        "project.hse_handbook.crew_status": "Status",
        "project.hse_handbook.crew_on_site": "På plass",
        "project.hse_handbook.crew_planned": "Planlagt",
        "project.hse_handbook.crew_scheduled": "Planlagt",
        "project.hse_handbook.crew_assigned": "Tildelt",

        // Project Activities translations
        "project.activities.tab_title": "Aktiviteter",
        "project.activities.tab_hint":
          "Når du forlater tittelfeltet (Tab eller klikk utenfor), lagres en ny linje. Neste nummer settes automatisk; Tripletex-linjer håndteres i bakgrunnen.",
        "project.activities.search_label": "Søk",
        "project.activities.search_placeholder": "Søk i tittel, nummer, beskrivelse …",
        "project.activities.filter_label": "Filter",
        "project.activities.filter_all": "Alle",
        "project.activities.filter_standard": "Kun standard",
        "project.activities.filter_additional": "Kun tilleggsarbeid",
        "project.activities.add_quick": "Ny rad",
        "project.activities.draft_title_placeholder": "Tittel — Tab for å lagre og neste rad",
        "project.activities.deleted": "Aktivitet slettet",
        "project.activities.title": "Aktiviteter",
        "project.activities.description":
          "Linjer som brukes for timer og pristilbud. Administrer dem under fanen Aktiviteter på prosjektet.",
        "project.activities.description_field": "Beskrivelse",
        "project.activities.activity_line": "Tripletex-aktivitetslinje",
        "project.activities.activity_line_hint":
          "Valgfritt. Kobler raden til en prosjektaktivitetslinje for Tripletex.",
        "project.activities.is_additional": "Tillegg",
        "project.activities.title_required": "Tittel er påkrevd",
        "project.activities.delete_error": "Kunne ikke slette aktivitet",
        "project.activities.add": "Legg til aktivitet",
        "project.activities.add_first": "Legg til første aktivitet",
        "project.activities.edit": "Rediger aktivitet",
        "project.activities.delete": "Slett aktivitet",
        "project.activities.delete_confirm": "Er du sikker på at du vil fjerne denne aktiviteten?",
        "project.activities.none": "Ingen aktiviteter lagt til ennå.",
        "project.activities.activity": "Aktivitet",
        "project.activities.number": "Nummer",
        "project.activities.budget_hours": "Budsjetterte timer",
        "project.activities.budget_fee": "Budsjettert avgift",
        "project.activities.invoiceable": "Fakturerbar",
        "project.activities.error_loading": "Feil ved lasting av aktiviteter",
  
        // Project sync status
        "project.synced": "Synkronisert",
        "project.not_synced": "Ikke synkronisert",
        
        // Additional project translations
        "project.participants.updated": "Deltager oppdatert",
        "project.participants.created": "Deltager lagt til",
        "project.participants.save_error": "Kunne ikke lagre deltager",
        "project.participants.delete_error": "Kunne ikke fjerne deltager",
        "project.participants.user_required": "Bruker er påkrevd",
        "project.participants.role_required": "Rolle er påkrevd",
        "project.participants.admin_access": "Admin-tilgang",
        "project.participants.updating": "Oppdaterer...",
        "project.participants.adding": "Legger til...",

        "project.required.banner_title": "Prosjektet mangler påkrevde felter",
        "project.required.banner_description": "Disse feltene må fylles ut før du kan lagre endringer eller legge til deltagere:",
        "project.required.edit_here": "Rediger her",
        "project.required.field.name": "Prosjektnavn",
        "project.required.field.project_manager": "Prosjektleder",
        "project.required.field.start_date": "Startdato",
        
        "project.activities.updated": "Aktivitet oppdatert",
        "project.activities.created": "Aktivitet lagt til",
        "project.activities.save_error": "Kunne ikke lagre aktivitet",
        "project.activities.activity_required": "Aktivitet er påkrevd",
        "project.activities.title_field": "Tittel",
        "project.activities.start_date": "Startdato",
        "project.activities.end_date": "Sluttdato",
        "project.activities.budget_fee_rate": "Budsjettert timepris",
        "project.activities.inactive": "Inaktiv",
        "project.activities.updating": "Oppdaterer...",
        "project.activities.adding": "Legger til...",
        "project.activities.summary_title": "Oversikt",
        "project.activities.summary_hours": "Timer (ført / budsjett)",
        "project.activities.summary_activities_done": "Fullførte aktiviteter",
        "project.activities.summary_budget_fee": "Sum budsjettert avgift",
        "project.activities.summary_budget_fee_hint": "Sum av budsjettert avgift på alle aktiviteter (referanse).",
        "project.activities.hours_unit": "t",
        "project.activities.hours_unit_short": "t",
        "project.activities.of_total_budget_hours": "av budsjetterte timer (prosjekt)",
        "project.activities.completed_label": "fullført",
        "project.activities.currency_nok": "kr",
        "project.activities.mode_view": "Lesemodus",
        "project.activities.mode_edit": "Redigeringsmodus",
        "project.activities.status_label": "Status",
        "project.activities.status.open": "Åpen",
        "project.activities.status.in_progress": "Pågår",
        "project.activities.status.completed": "Fullført",
        "project.activities.status.on_hold": "På vent",
        "project.activities.edit_dialog_title": "Aktivitet",
        "project.activities.progress_section": "Fremdrift",
        "project.activities.logged_vs_budget": "{{logged}} t ført · {{budget}} t budsjett",
        "project.activities.of_budget_hours": "av aktivitetens budsjettimer",
        "project.activities.linked_work_orders": "{{count}} tilknyttet(e) arbeidsordre(r)",
        "project.activities.linked_work_orders_label": "Arbeidsordrer på aktiviteten",
        "project.activities.no_description": "Ingen beskrivelse.",
        "project.activities.period": "Periode",
        "project.activities.new_work_order": "Ny arbeidsordre",
        "project.activities.open_work_orders_tab": "Åpne fanen Arbeidsordre",
        "project.activities.open_time_tab": "Åpne timeregistrering",
        "project.activities.logged_short": "Ført",
        "project.activities.status_progress_title": "Status og fremdrift",
        "project.activities.save": "Lagre",
        "project.activities.saving": "Lagrer…",
        "project.activities.actions": "Handlinger",
        "project.activities.deleted_toast": "Slettet",
        
        // Project Plan translations (Norwegian)
        "project.plan.title": "Prosjektplan",
        "project.plan.subtitle": "Planlegg og administrer prosjekthendelser",
        "project.plan.select_project": "Velg Prosjekt",
        "project.plan.select_project_first": "Vennligst velg et prosjekt først",
        "project.plan.pick_project_title": "Velg prosjekt",
        "project.plan.pick_project_hint": "Velg et prosjekt for å fortsette",
        "project.plan.project": "Prosjekt",
        "project.plan.no_events": "Ingen hendelser i denne perioden",
        "project.plan.drop_lane_hint": "Slipp plan her",
        "project.plan.total": "Totalt",
        "project.plan.loading": "Laster hendelser...",
        "project.plan.week": "Uke",
        "project.plan.resource_capacity": "Ressurskapasitet",
        "project.plan.resource_capacity_subtitle":
          "Sammenligner ressursplanen fra Timer med planlagte prosjekt-eventer og arbeidsordre i valgt periode.",
        "project.plan.loading_resource_plan": "Laster ressursplan...",
        "project.plan.capacity.events": "Eventer",
        "project.plan.capacity.available": "Tilgjengelige",
        "project.plan.capacity.assigned": "Allokert",
        "project.plan.capacity.scheduled_hours": "Arbeidsplantimer",
        "project.plan.capacity.free_hours": "Ledige timer",
        "project.plan.capacity.assigned_of_available": "{{assigned}} av {{available}} ressurser brukt",
        "project.plan.capacity.free_hours_value": "{{hours}} t ledig",
        "project.plan.capacity.events_value": "{{count}} event(er)",
        "No project": "Ingen prosjekt",
        "No activity": "Ingen aktivitet",
        
        // Project Plan Preview translations (Norwegian)
        "project.plan.preview.title": "Prosjektplan",
        "project.plan.preview.subtitle": "Kommende hendelser",
        "project.plan.preview.go_to_full_plan": "Full plan →",
        "project.plan.preview.time_prefix": "Kl.",
        "project.plan.preview.loading": "Laster hendelser...",
        "project.plan.preview.error": "Feil ved lasting av hendelser",
        "project.plan.preview.no_events": "Ingen kommende hendelser",
        "project.plan.preview.untitled_event": "Hendelse uten tittel",
        "project.plan.preview.resource": "ressurs",
        "project.plan.preview.resources": "ressurser",
        "project.plan.preview.view_all": "Vis alle {{count}} hendelser",

        "crew.panel.title": "Mannskap og vakt",
        "crew.panel.subtitle": "Dagens plan, fravær og stempling (krever modul «Mannskap og vaktplan» i firmaet)",
        "crew.panel.loading": "Laster mannskap…",
        "crew.panel.error": "Kunne ikke laste mannskap",
        "crew.panel.no_project": "Velg prosjekt for å se mannskap",
        "crew.panel.shifts": "Vakter",
        "crew.panel.absences": "Fravær i dag",
        "crew.panel.open_punches": "Stempling pågår",
        "crew.panel.clock_in": "Stemple inn",
        "crew.panel.clock_out": "Stemple ut",
        "crew.panel.checklists": "Sjekklister",
        "crew.panel.seed_checklists": "Opprett standard sjekklistetyper",
        "crew.panel.hours": "Timeliste",
        "crew.panel.open_full": "Åpne modul",
        "crew.page.kicker": "Planlegging",
        "crew.page.title": "Mannskap og vaktplan",
        "crew.page.subtitle": "Planlegg vakter, håndter tilgjengelighet, stempling, kiosk og lederoversikt",
        "crew.tabs.shifts": "Vaktplan",
        "crew.tabs.mine": "Mine vakter",
        "crew.tabs.availability": "Tilgjengelighet",
        "crew.tabs.punch": "Stempling",
        "crew.tabs.kiosk": "Kiosk",
        "crew.tabs.leader": "Leder",
        "crew.tabs.leader_alerts": "Etterlevelse og varsler",
        "crew.tabs.payroll": "Lønnsgrunnlag",
        "crew.stats.shifts": "Vakter",
        "crew.stats.assignments": "Oppdrag",
        "crew.stats.open_punches": "Åpne stemplinger",
        "crew.stats.alerts": "Varsler",
        "crew.filters.title": "Planfilter",
        "crew.filters.subtitle": "Velg prosjekt, periode og aktiv dag for ukevisningen.",
        "crew.filters.project": "Prosjekt",
        "crew.filters.date": "Dato",
        "crew.filters.period": "Periode",
        "crew.filters.period_from": "Periode fra",
        "crew.filters.period_to": "Periode til",
        "crew.filters.active_day": "Aktiv dag",
        "crew.filters.density": "Visning",
        "crew.filters.days": "dager",
        "crew.filters.this_week": "Denne uken",
        "crew.filters.next_week": "Neste uke",
        "crew.filters.this_month": "Denne måneden",
        "crew.density.cozy": "Luftig",
        "crew.density.compact": "Kompakt",
        "crew.shift.new": "Ny vakt",
        "crew.shift.edit": "Rediger vakt",
        "crew.shift.copy": "Kopier vakt",
        "crew.shift.copy_short": "Kopier",
        "crew.shift.new_short": "Ny vakt",
        "crew.shift.step_info": "Info",
        "crew.shift.step_days_time": "Dager og tid",
        "crew.shift.next_days_time": "Neste: dager og tid",
        "crew.shift.back_info": "Tilbake til info",
        "crew.shift.title": "Tittel",
        "crew.shift.title_hint": "Kort navn som gjør vakten lett å kjenne igjen, f.eks. «Lørdag kveld foodtruck».",
        "crew.shift.title_placeholder": "F.eks. Lørdag kveld foodtruck",
        "crew.shift.role": "Rolle",
        "crew.shift.role_hint": "Hva personen skal gjøre på vakten, f.eks. vaktleder, kjøkken, kasse, servering eller opprydding. Bruk «vaktleder» når personen også skal følge opp sjekklister ved start/slutt.",
        "crew.shift.role_placeholder": "F.eks. Vaktleder",
        "crew.shift.role_suggestions": "Velg rolleforslag eller skriv manuelt",
        "crew.shift.roles.shift_lead": "Vaktleder",
        "crew.shift.roles.cashier": "Kasse",
        "crew.shift.roles.kitchen": "Kjøkken",
        "crew.shift.roles.service": "Servering",
        "crew.shift.roles.runner": "Runner",
        "crew.shift.roles.cleanup": "Opprydding",
        "crew.shift.roles.closing": "Stenging",
        "crew.shift.starts_at": "Start",
        "crew.shift.ends_at": "Slutt",
        "crew.shift.project": "Prosjekt",
        "crew.shift.project_hint": "Knytter vakten til riktig prosjekt. Dette brukes videre ved stempling og timeregistrering slik at timer havner på riktig prosjekt.",
        "crew.shift.location": "Sted",
        "crew.shift.location_hint": "Hvor vakten utføres, f.eks. foodtruck-navn, adresse, arrangement eller avdeling.",
        "crew.shift.location_placeholder": "F.eks. Foodtruck Sentrum",
        "crew.shift.break_minutes": "Pause (min)",
        "crew.shift.break_minutes_hint": "Planlagt pause som trekkes fra planlagte timer.",
        "crew.shift.slots": "Plasser",
        "crew.shift.slots_hint": "Hvor mange personer som trengs på denne vakten.",
        "crew.shift.assignment_mode": "Tildeling",
        "crew.shift.assignment_mode_hint": "Direkte tildeling gir vakten til valgt ansatt. Åpent vakttilbud lar ansatte svare på tilbud.",
        "crew.shift.assignment_direct": "Direkte tildeling",
        "crew.shift.assignment_open": "Åpent vakttilbud",
        "crew.shift.response_deadline": "Svarfrist",
        "crew.shift.response_deadline_hint": "Valgfritt. Etter fristen skjules ubesvarte tilbud for ansatte.",
        "crew.shift.leader_checklist_required": "Krev leder-sjekklister",
        "crew.shift.leader_checklist_required_hint": "Oppretter påkrevde oppstarts- og avslutningssjekklister for vakten. Nyttig for vaktleder i foodtruck, serveringsenhet og serviceteam.",
        "crew.shift.handover_note": "Overleveringsnotat",
        "crew.shift.handover_note_hint": "Viktig informasjon neste leder eller vakt bør se.",
        "crew.shift.assigned_employee": "Ansatt på vakten",
        "crew.shift.assigned_employee_hint": "Valgfritt. Velg ansatt her for å legge personen direkte på alle valgte dager.",
        "crew.shift.month": "Måned",
        "crew.shift.month_hint": "Velg måneden du vil planlegge. Kryss av dagene i kalenderen under.",
        "crew.shift.from_time": "Fra kl.",
        "crew.shift.from_time_hint": "Starttid som brukes på alle valgte dager.",
        "crew.shift.to_time": "Til kl.",
        "crew.shift.to_time_hint": "Sluttid som brukes på alle valgte dager. Hvis slutt er før start, regnes det som nattvakt til neste dag.",
        "crew.shift.single_day": "Én dag",
        "crew.shift.period_days": "Flere dager",
        "crew.shift.period_from": "Periode fra",
        "crew.shift.period_to": "Periode til",
        "crew.shift.weekdays": "Velg ukedager",
        "crew.shift.create_plan": "Opprett vaktplan",
        "crew.shift.copy_plan": "Kopier vaktplan",
        "crew.shift.copy_assignments_hint": "{{count}} mannskap kopieres fra originalvakten hvis du ikke velger en annen ansatt.",
        "crew.shift.overview_month": "Måned",
        "crew.shift.overview_period": "Periode",
        "crew.shift.days_with_shifts": "Dager med vakter",
        "crew.shift.missing_days": "Dager uten plan",
        "crew.shift.planned_hours": "Planlagte timer",
        "crew.shift.month_overview": "Månedsoversikt",
        "crew.shift.month_overview_hint": "Grønne dager har vaktplan. Lyse dager mangler plan.",
        "crew.shift.day_has_shifts": "{{count}} vakt(er)",
        "crew.shift.day_missing": "Mangler plan",
        "crew.shift.day_by_day": "Dag for dag",
        "crew.shift.day_shift_count": "{{count}} vakt(er)",
        "crew.shift.selected_day_timeline": "Tidslinje for valgt dag",
        "crew.shift.no_shifts_selected_day": "Ingen vakter på valgt dag.",
        "crew.shift.add_shift_hint": "Velg en dag i uken eller opprett ny vakt for å fylle planen.",
        "crew.shift.no_role": "Ingen rolle",
        "crew.shift.no_days_selected": "Ingen dager valgt i perioden",
        "crew.shift.ends_after_start": "Slutt må være etter start",
        "crew.shift.no_crew_added": "Ingen mannskap lagt til / sendt vakttilbud",
        "crew.shift.publish": "Publiser",
        "crew.shift.cancel": "Kanseller",
        "crew.shift.cancel_reason": "Årsak til kansellering",
        "crew.assignment.add": "Legg til mannskap",
        "crew.assignment.add_short": "Legg til mannskap",
        "crew.assignment.accept": "Aksepter",
        "crew.assignment.decline": "Avslå",
        "crew.availability.starts_at": "Fra",
        "crew.availability.ends_at": "Til",
        "crew.availability.add_day": "Velg dag",
        "crew.availability.add_day_button": "Legg til dag",
        "crew.availability.add_weekdays": "Legg til ukedager",
        "crew.availability.month": "Måned",
        "crew.availability.remove_day": "Fjern dag",
        "crew.availability.no_days_selected": "Ingen dager valgt",
        "crew.availability.selected_days": "Valgte dager",
        "crew.availability.selected_short": "Valgt",
        "crew.availability.saved_short": "Lagret",
        "crew.availability.from_time": "Fra kl.",
        "crew.availability.to_time": "Til kl.",
        "crew.availability.status": "Status",
        "crew.availability.available": "Tilgjengelig",
        "crew.availability.unavailable": "Ikke tilgjengelig",
        "crew.availability.monthly_overview": "Tilgjengelighet per måned",
        "crew.availability.month_stats": "{{days}} dager · {{hours}} timer tilgjengelig",
        "crew.availability.loading": "Laster…",
        "crew.availability.no_entries": "Ingen tilgjengelighet lagret for valgt periode.",
        "crew.punch.clocked_in": "Du er stemplet inn",
        "crew.punch.choose_shift": "Velg vakt for innstempling, eller stemple inn uten vakt.",
        "crew.punch.clock_in_without_shift": "Stemple inn uten vakt",
        "crew.punch.history": "Stemplingshistorikk",
        "crew.punch.history_date": "Dato",
        "crew.punch.history_in": "Inn",
        "crew.punch.history_out": "Ut",
        "crew.punch.history_hours": "Timer",
        "crew.punch.history_status": "Status",
        "crew.punch.deviation_note": "Avvik / notat",
        "crew.punch.deviation_note_placeholder": "Avvik, manglende sjekklistepunkt eller notat til neste leder...",
        "crew.punch.open": "Åpen",
        "crew.punch.closed": "Lukket",
        "crew.punch.no_history": "Ingen stemplinger i perioden.",
        "crew.kiosk.title": "Kiosk / PIN",
        "crew.kiosk.help": "Bruk felles innlogget enhet og personlig PIN for ansatte.",
        "crew.kiosk.open": "Åpne PIN-verifisering",
        "crew.kiosk.employee_number": "Ansattnummer",
        "crew.kiosk.pin": "PIN",
        "crew.kiosk.verify": "Verifiser",
        "crew.kiosk.verify_title": "Verifiser PIN",
        "crew.kiosk.pin_admin_title": "Administrer ansatt-PIN",
        "crew.kiosk.save_pin": "Lagre PIN",
        "crew.kiosk.clear_pin": "Slett PIN",
        "crew.payroll.planned": "Planlagt",
        "crew.payroll.actual": "Faktisk",
        "crew.empty.shifts": "Ingen vakter i valgt periode.",
        "crew.empty.assignments": "Ingen vakttilbud eller tildelinger.",
        "crew.empty.alerts": "Ingen varsler.",
        "crew.empty.payroll": "Ingen lønnsgrunnlag i perioden.",
        "crew.checklists.handover_title": "Sjekkliste-overlevering",
        "crew.checklists.mark_completed": "Marker fullført",
        "crew.checklists.no_runs": "Ingen påkrevde vaktsjekklister i perioden.",
        "crew.checklists.kind.start": "Oppstart",
        "crew.checklists.kind.end": "Avslutning",
        "crew.checklists.status.pending": "Venter",
        "crew.checklists.status.in_progress": "Pågår",
        "crew.checklists.status.completed": "Fullført",
        "crew.alerts.time_punch_deviation_note": "Avvik/notat fra stempling",
        "crew.alerts.required_shift_checklist_pending": "Påkrevd sjekkliste er ikke fullført",
        "crew.alerts.long_open_punch": "Lang åpen stempling",
        "crew.alerts.planned_shift_missing_break": "Planlagt vakt mangler pause",
        "crew.alerts.high_hours_last_12_months": "Høye faktiske timer siste 12 måneder",
        "crew.toast.saved": "Lagret",
        "crew.toast.assignment_saved": "Mannskap lagt til",
        "crew.toast.pin_verified": "PIN verifisert",
        "crew.toast.pin_saved": "PIN lagret",
        "crew.toast.pin_cleared": "PIN slettet",
        "crew.toast.published": "Vakt publisert",
        "crew.toast.cancelled": "Vakt kansellert",
        "crew.toast.accepted": "Vakt akseptert",
        "crew.toast.declined": "Vakt avslått",
        "crew.toast.availability_saved": "Tilgjengelighet lagret",
        "crew.toast.clocked_in": "Stemplet inn",
        "crew.toast.clocked_out": "Stemplet ut",
        "crew.toast.checklists_seeded": "Sjekklistetyper opprettet",
        "crew.toast.checklist_completed": "Sjekkliste markert fullført",
        "crew.weekdays.monday": "Man",
        "crew.weekdays.tuesday": "Tir",
        "crew.weekdays.wednesday": "Ons",
        "crew.weekdays.thursday": "Tor",
        "crew.weekdays.friday": "Fre",
        "crew.weekdays.saturday": "Lør",
        "crew.weekdays.sunday": "Søn",
        
        // Project Event translations (Norwegian)
        "project.event.create": "Opprett Hendelse",
        "project.event.edit": "Rediger Hendelse",
        "project.event.title": "Tittel",
        "project.event.title_required": "Tittel er påkrevd",
        "project.event.title_placeholder": "Angi hendelsestittel",
        "project.event.description": "Beskrivelse",
        "project.event.description_placeholder": "Angi hendelsesbeskrivelse",
        "project.event.start_date": "Startdato",
        "project.event.start_date_required": "Startdato er påkrevd",
        "project.event.end_date": "Sluttdato",
        "project.event.end_date_invalid": "Sluttdato må være etter startdato",
        "project.event.days": "Dager",
        "project.event.days_placeholder": "Antall dager",
        "project.event.project": "Prosjekt",
        "project.event.work_order": "Arbeidsordre",
        "project.event.resources": "Ressurser (Ansatte)",
        "project.event.add_resource": "Legg til ressurs",
        "project.event.add_resource_one_day": "Legg til ansatt (startdato)",
        "project.event.no_resources": "Ingen ressurser lagt til. Legg til ansatte som skal jobbe med denne hendelsen.",
        "project.event.resource": "Ressurs",
        "project.event.resource_employee": "Ansatt",
        "project.event.resource_start_time": "Starttid",
        "project.event.resource_end_time": "Sluttid",
        "project.event.save_error": "En feil oppstod ved lagring av hendelsen. Vennligst prøv igjen.",
        "project.event.work_orders_linked": "Koblede arbeidsordrer",
        "project.event.select_work_orders": "Velg arbeidsordrer",
        "project.event.activities_linked": "Koblede aktiviteter",
        "project.event.select_activities": "Velg aktiviteter",
        "project.event.sync_resource_dates": "Synkroniser ressursdatoer med hendelsen",
        "project.event.conflict_warning": "Ressurskonflikt — sjekk tider",
        "project.event.conflict_plan": "Plan: {{title}} ({{time}})",
        "project.event.conflict_calendar": "Kalender: {{title}} ({{time}})",
        "project.event.resource_hours": "Timer",
        "project.event.resource_hours_unit": "t",
        "project.event.resource_hours_manual": "Manuelt antall timer",
        "project.event.resource_hours_pick_start": "Velg starttid for å beregne timer",

        "project.plan.crew.title": "Ressurser",
        "project.plan.crew.subtitle": "{{count}} personer i perioden",
        "project.plan.crew.empty": "Ingen ressurser i valgt periode",
        "project.plan.crew.absent_days": "Fravær {{days}} dag(er)",
        "project.plan.crew.absent_with_type": "{{type}} · {{days}} dag(er)",
        "project.plan.crew.not_counted_summary": "Ikke medregnet i planlagte timer: {{names}}",
        "project.plan.crew.not_counted_badge": "Ikke medregnet",
        "project.plan.crew.not_counted_no_schedule": "0 t — mangler arbeidstid, ikke medregnet",
        "project.plan.crew.not_counted_sick": "0 t — sykemelding er ikke medregnet",
        "project.plan.crew.open_user_short": "Åpne bruker",
        "project.plan.crew.open_user": "Åpne {{name}} i ny fane",
        "project.plan.crew.open_user": "Åpne {{name}} i ny fane",
        "project.plan.absences.title": "Fravær",
        "project.plan.resource_bar.clear_selection": "Fjern filter",
        "project.plan.create_plan": "Ny plan",
        "project.plan.edit_plan": "Rediger plan",
        "project.plan.schedule_plan": "Legg på kalender",
        "project.plan.draft_drop_missing":
          "Fant ikke utkastet. Oppdater siden og prøv igjen.",
        "project.plan.toolbar.breadcrumb": "Prosjektplan",
        "project.plan.toolbar.new_task": "Ny oppgave",
        "project.plan.toolbar.new_absence": "+ Fravær",
        "project.plan.toolbar.schedule_activity": "Planlegg aktivitet",
        "project.plan.day_action.title": "Legg til",
        "project.plan.day_action.subtitle": "{{date}}",
        "project.plan.day_action.add_aria": "Legg til på {{date}}",
        "project.plan.day_action.new_plan": "Ny plan",
        "project.plan.day_action.activity": "Aktivitet",
        "project.plan.day_action.task": "Oppgave",
        "project.plan.day_action.absence": "Fravær",
        "project.plan.absence.title": "Registrer fravær",
        "project.plan.absence.help":
          "Velg ansatt, fraværstype og periode. Kun administrator kan registrere fravær herfra.",
        "project.plan.absence.employee": "Ansatt",
        "project.plan.absence.pick_employee": "Velg ansatt",
        "project.plan.absence.type": "Fraværstype",
        "project.plan.absence.pick_type": "Velg fraværstype",
        "project.plan.absence.date_from": "Fra dato",
        "project.plan.absence.date_to": "Til dato",
        "project.plan.absence.approve_now": "Godkjenn fraværet med en gang",
        "project.plan.absence.approve_now_help":
          "Fraværet markeres som godkjent umiddelbart etter lagring.",
        "project.plan.absence.save": "Registrer fravær",
        "project.plan.absence.date_order_error": "Til-dato kan ikke være før fra-dato",
        "project.plan.absence.save_error": "Kunne ikke registrere fravær",
        "project.plan.absence.approve_error": "Fraværet ble lagret, men godkjenning feilet",
        "project.plan.absence.toast_created": "Fravær er registrert",
        "project.plan.absence.toast_created_approved": "Fravær er registrert og godkjent",
        "project.plan.resource_day.title": "Ressurs",
        "project.plan.resource_day.untitled": "Uten tittel",
        "project.plan.resource_day.employee": "Ansatt",
        "project.plan.resource_day.edit": "Rediger",
        "project.plan.resource_day.delete": "Slett denne dagen",
        "project.plan.resource_day.delete_confirm":
          "Fjerne {{name}} fra {{date}}? Kun denne dagen slettes.",
        "project.plan.resource_day.delete_toast": "Ressursdagen er fjernet",
        "project.plan.resource_day.delete_error": "Kunne ikke slette ressursdagen",
        "project.plan.resource_row.add_day_hint": "Klikk for å legge til denne dagen for ressursen",
        "project.plan.schedule_confirm": "Legg på kalender",
        "project.plan.schedule_activity.pick_title": "Velg prosjektaktivitet",
        "project.plan.schedule_activity.pick_help":
          "Velg aktiviteten du skal planlegge. Beskrivelse er valgfritt — tittel hentes fra aktiviteten.",
        "project.plan.schedule_activity.pick_required": "Velg en aktivitet",
        "project.plan.schedule_activity.continue": "Fortsett til planlegging",
        "project.plan.schedule_activity.crew_section": "Ansatte",
        "project.plan.schedule_activity.days_section": "Dager",
        "project.plan.schedule_activity.budget_hours_hint": "Budsjett: {{hours}} t (standard)",
        "project.plan.schedule_activity.save": "Lagre plan",
        "project.plan.schedule_activity.toast_created": "Aktivitet er lagt på kalenderen",
        "project.plan.schedule_activity.toast_updated": "Planlegging er oppdatert",
        "project.plan.toolbar.week": "Uke",
        "project.plan.toolbar.fortnight": "2 uker",
        "project.plan.toolbar.month": "Måned",
        "project.plan.toolbar.today": "I dag",
        "project.plan.toolbar.density": "Tetthet",
        "project.plan.toolbar.density_compact": "Kompakt",
        "project.plan.toolbar.density_comfortable": "Normal",
        "project.plan.toolbar.density_spacious": "Romslig",
        "project.plan.stats.events": "Hendelser",
        "project.plan.stats.scheduled_hours": "Planlagte timer",
        "project.plan.stats.crew": "Mannskap",
        "project.plan.stats.unscheduled": "Uplanlagt",
        "project.plan.schedule.title_create": "Legg plan på kalender",
        "project.plan.schedule.title_edit": "Rediger kalenderplan",
        "project.plan.schedule.open_work_order_edit": "Åpne arbeidsordre (rediger)",
        "project.plan.schedule.open_project_activity": "Åpne prosjektaktivitet",
        "project.plan.schedule.create_work_order_later": "Opprett arbeidsordre senere",
        "project.plan.schedule.edit_project_event": "Rediger planhendelse",
        "project.plan.schedule.edit_project_event_hint":
          "Tittel, beskrivelse, lenker og ressurser utenfor ukeplanleggeren.",
        "project.plan.schedule.activity_title_create": "Planlegg prosjektaktivitet",
        "project.plan.schedule.activity_title_edit": "Rediger planlegging (aktivitet)",
        "project.plan.schedule.activity_plan_hint":
          "Enklere planlegging uten arbeidsordre. Du kan opprette AO når det trengs.",
        "project.plan.toolbar.project_task": "Oppgave / prosjekt",
        "project.plan.toolbar.prev": "Forrige periode",
        "project.plan.toolbar.next": "Neste periode",
        "project.plan.toolbar.week_range": "Uke {{week}} · {{range}}",
        "project.plan.toolbar.fortnight_range": "Uke {{weekFrom}}–{{weekTo}} · {{range}}",
        "project.plan.schedule.week_short": "Uke {{week}}",
        "project.plan.sidebar.title": "Prosjekter",
        "project.plan.sidebar.active": "aktive",
        "project.plan.sidebar.search_placeholder": "Søk prosjekt, kunde eller kode…",
        "project.plan.sidebar.all_projects": "Alle prosjekter",
        "project.plan.unscheduled.title": "Uplanlagt",
        "project.plan.no_draft_plans": "Ingen utkast å planlegge",
        "project.plan.unscheduled.drag_hint": "Dra til kalenderen for å planlegge",
        "project.plan.multi_link_hint": "Du kan koble flere. Én markeres som primær.",
        "project.plan.primary_link": "Primær",
        "project.plan.set_primary": "Sett som primær",
        "project.plan.no_work_orders_yet": "Ingen arbeidsordrer koblet ennå",
        "project.plan.include_work_order_description": "Ta med beskrivelse fra arbeidsordre",
        "project.plan.no_activities_yet": "Ingen aktiviteter koblet ennå",
        "project.plan.save_plan": "Lagre plan",
        "project.plan.multi_select_selected": "{{count}} valgt",
        "project.plan.add_selected": "Legg til valgte ({{count}})",
        "project.plan.view_period": "Periodevisning",
        "project.plan.view_day": "Dagsvisning",
        "project.plan.settings.display": "Visning",
        "project.plan.settings.display_subtitle": "Velg hvordan prosjektplanen vises",
        "project.plan.settings.resource_plan": "Ressursplan",
        "project.plan.settings.resource_plan_subtitle": "Åpne ressursplan og kapasitet for valgt prosjekt",
        "project.plan.settings.open_resource_plan": "Åpne ressursplan",
        "project.plan.settings.select_project": "Velg et prosjekt for å åpne ressursplanen",
        "project.plan.resource_bar.title": "Ressurser denne dagen",
        "project.plan.resource_bar.subtitle": "Klikk for å filtrere kalenderen",
        "project.plan.resource_bar.subtitle_date": "{{date}} — klikk for å filtrere",
        "project.plan.resource_bar.empty": "Ingen ressurser denne dagen",
        "project.plan.resource_bar.planned_hours": "{{hours}} t planlagt",
        "project.plan.day_view.employee": "Ansatt",
        "project.plan.day_view.empty": "Ingen planlagte oppgaver denne dagen",
        "project.plan.day_view.hint": "Dra ressurser fra mannskapslisten for å tildele",
        "nav.documentation": "Dokumentasjon",
        "calendar.quick_views.aria": "Hurtigvisninger",
        "calendar.quick_views.calendar": "Kalender",
        "calendar.quick_views.project_plan": "Prosjektplan",
        "calendar.quick_views.crew": "Mannskap",
        "calendar.quick_views.resource_plan": "Ressursplan",
        "calendar.search_placeholder": "Søk i hendelser…",
        "calendar.filter": "Filter",
        "calendar.filter_title": "Filtrer kalender",
        "calendar.outlook_view": "Outlook-visning",
        "calendar.nav.previous_day": "Forrige dag",
        "calendar.nav.next_day": "Neste dag",
        "calendar.plan_event.title": "Planoppgave",
        "calendar.plan_event.status_completed": "Fullført",
        "calendar.plan_event.status_assigned": "Planlagt",
        "calendar.plan_event.project_context_title": "Prosjekt",
        "calendar.plan_event.project_no_description": "Ingen prosjektbeskrivelse",
        "calendar.plan_event.task_description": "Oppgave / aktivitet",
        "calendar.plan_event.open_project": "Åpne prosjekt",
        "calendar.plan_event.open_work_order": "Åpne arbeidsordre",
        "calendar.plan_event.open_project_activity": "Åpne aktivitet i prosjekt",
        "calendar.plan_event.related_report": "Relatert rapport",
        "calendar.plan_event.mark_my_task_complete": "Merk min oppgave som fullført",
        "calendar.plan_event.register_hours": "Registrer timer",
        "calendar.plan_event.open_project_plan": "Åpne prosjektplan",
        "calendar.plan_event.load_error": "Kunne ikke laste planhendelser",
        "calendar.plan_event.complete_validation.activity_status": "Velg status for alle aktiviteter",
        "calendar.plan_event.complete_validation.description": "Beskrivelse er påkrevd",
        "calendar.plan_event.complete_validation.photos": "Last opp minst ett bilde per arbeidsordre",
        "calendar.plan_event.completed": "Oppgaven er markert som fullført",
        "calendar.plan_event.complete_error": "Kunne ikke fullføre oppgaven",
        "calendar.plan_event.complete_dialog.title": "Fullfør planoppgave",
        "calendar.plan_event.complete_dialog.simple_confirm": "Bekreft at du har fullført din del av oppgaven.",
        "calendar.plan_event.complete_dialog.intro": "Oppdater status, beskrivelse og dokumentasjon før du fullfører.",
        "calendar.plan_event.complete_dialog.activities": "Aktiviteter",
        "calendar.plan_event.complete_dialog.work_orders": "Arbeidsordrer",
        "calendar.plan_event.complete_dialog.work_order_outcome.ongoing": "Pågår",
        "calendar.plan_event.complete_dialog.work_order_outcome.finished": "Ferdig",
        "calendar.plan_event.photos": "Bilder",
        "calendar.plan_event.complete_dialog.photos_count": "bilder",
        "calendar.plan_event.complete_dialog.work_description": "Arbeidsbeskrivelse",
        "calendar.plan_event.complete_dialog.work_description_placeholder": "Beskriv utført arbeid…",
        "calendar.plan_event.complete_dialog.work_description_hint": "Beskriv hva som er gjort — synlig i rapport og historikk.",
        "calendar.plan_event.complete_dialog.submit": "Fullfør og lagre",

        // Meeting Minutes translations (Norwegian)
        "meeting_minutes": "Møtereferat",
        "meeting_minutes.list": "Møtereferat",
        "meeting_minutes.hero_subtitle": "Referat for medarbeidersamtaler, prosjektmøter og andre møter. Bruk maler, send til deltakere og eksporter PDF.",
        "meeting_minutes.editor_subtitle": "Velg type, deltakere og eventuelt en mal. Første møte opprettes automatisk.",
        "meeting_minutes.filter.all_types": "Alle typer",
        "meeting_minutes.copy_suffix": "Kopi",
        "meeting_minutes.status.draft": "Pågår",
        "meeting_minutes.date.today": "I dag",
        "meeting_minutes.send_to_participants": "Send til ansatte og deltakere",
        "meeting_minutes.export_pdf": "Eksporter PDF",
        "meeting_minutes.new": "Nytt møtereferat",
        "meeting_minutes.edit": "Rediger Møtereferat",
        "meeting_minutes.create": "Opprett Møtereferat",
        "meeting_minutes.update": "Oppdater Møtereferat",
        "meeting_minutes.delete": "Slett Møtereferat",
        "meeting_minutes.search": "Søk i møtereferat...",
        "meeting_minutes.no_results": "Ingen møtereferat funnet",
        "meeting_minutes.meeting_date": "Møtedato",
        "meeting_minutes.meeting_type": "Møtetype",
        "meeting_minutes.select_type": "Velg møtetype",
        "meeting_minutes.type.employee_interview": "Medarbeidersamtale",
        "meeting_minutes.type.project_meeting": "Prosjektmøte",
        "meeting_minutes.type.other": "Annet møte",
        "meeting_minutes.employee": "Ansatt",
        "meeting_minutes.select_employee": "Velg ansatt",
        "meeting_minutes.participants": "Deltakere",
        "meeting_minutes.select_participants": "Velg deltakere",
        "meeting_minutes.manual_participants": "Manuelle deltakere",
        "meeting_minutes.manual_participants.description": "Legg inn deltakere manuelt (kommaseparert)",
        "meeting_minutes.project": "Prosjekt",
        "meeting_minutes.select_project": "Velg prosjekt",
        "meeting_minutes.title": "Tittel",
        "meeting_minutes.title.required": "Tittel er påkrevd",
        "meeting_minutes.description": "Beskrivelse",
        "meeting_minutes.groups": "Grupper",
        "meeting_minutes.add_group": "Legg til Gruppe",
        "meeting_minutes.group.title": "Gruppetittel",
        "meeting_minutes.group.title.required": "Gruppetittel er påkrevd",
        "meeting_minutes.group.description": "Gruppebeskrivelse",
        "meeting_minutes.group.entries": "Innlegg",
        "meeting_minutes.group.add_entry": "Legg til Innlegg",
        "meeting_minutes.entry.description": "Beskrivelse",
        "meeting_minutes.entry.description.required": "Beskrivelse er påkrevd",
        "meeting_minutes.entry.deadline": "Frist",
        "meeting_minutes.entry.responsible": "Ansvarlig",
        "meeting_minutes.entry.select_responsible": "Velg ansvarlig person",
        "meeting_minutes.meeting_number": "Møte #",
        "meeting_minutes.continue_meeting": "Fortsett Møte",
        "meeting_minutes.continue_meeting.description": "Fortsett på samme møtereferat (oppretter nytt møte-innlegg)",
        "meeting_minutes.continue_success": "Møte fortsatt vellykket",
        "meeting_minutes.continue_error": "Kunne ikke fortsette møte",
        "meeting_minutes.basic_info": "Grunnleggende informasjon",
        "meeting_minutes.templates": "Maler",
        "meeting_minutes.templates.list": "Maler",
        "meeting_minutes.templates.hero_subtitle": "Gjenbruk agenda for medarbeidersamtale, prosjektmøte og tavlemøte.",
        "meeting_minutes.templates.editor_subtitle": "Lag punkter og innlegg som lastes inn når du oppretter et nytt møte.",
        "meeting_minutes.templates.empty_start": "Start med tom agenda",
        "meeting_minutes.templates.no_points": "Ingen punkter i malen",
        "meeting_minutes.templates.will_load": "Laster inn {{count}} punkter fra malen",
        "meeting_minutes.templates.agenda": "Agenda i malen",
        "meeting_minutes.templates.save_from_meeting": "Lagre som mal",
        "meeting_minutes.templates.saved_from_meeting": "Møtet ble lagret som mal",
        "meeting_minutes.templates.save_from_meeting_error": "Kunne ikke lagre mal",
        "meeting_minutes.templates.new": "Ny mal",
        "meeting_minutes.templates.edit": "Rediger mal",
        "meeting_minutes.templates.create": "Opprett Mal",
        "meeting_minutes.templates.update": "Oppdater Mal",
        "meeting_minutes.templates.delete": "Slett Mal",
        "meeting_minutes.templates.search": "Søk i maler...",
        "meeting_minutes.templates.no_results": "Ingen maler funnet",
        "meeting_minutes.templates.use_template": "Bruk Mal",
        "meeting_minutes.templates.copy_from": "Kopier fra tidligere møte",
        "meeting_minutes.templates.select_template": "Velg Mal",
        "meeting_minutes.created": "Møtereferat opprettet",
        "meeting_minutes.updated": "Møtereferat oppdatert",
        "meeting_minutes.deleted": "Møtereferat slettet",
        "meeting_minutes.delete_confirm": "Er du sikker på at du vil slette dette møtereferatet?",
        "meeting_minutes.meetings": "Møter",
        "meeting_minutes.create_error": "Kunne ikke opprette møtereferat",
        "meeting_minutes.update_error": "Kunne ikke oppdatere møtereferat",
        "meeting_minutes.delete_error": "Kunne ikke slette møtereferat",
        "meeting_minutes.load_error": "Kunne ikke laste møtereferat",
        "meeting_minutes.template.created": "Mal opprettet",
        "meeting_minutes.template.updated": "Mal oppdatert",
        "meeting_minutes.template.deleted": "Mal slettet",
        "meeting_minutes.template.create_error": "Kunne ikke opprette mal",
        "meeting_minutes.template.update_error": "Kunne ikke oppdatere mal",
        "meeting_minutes.template.delete_error": "Kunne ikke slette mal",
        "meeting_minutes.template.delete_confirm": "Er du sikker på at du vil slette denne malen?",
        "meeting_minutes.template.load_error": "Kunne ikke laste mal",
        "meeting_minutes.json.open_dialog": "JSON / AI-instruks",
        "meeting_minutes.json.generate_with_ai": "Generer agenda med AI",
        "meeting_minutes.json.dialog_title": "Møtereferat JSON",
        "meeting_minutes.json.tab_json": "JSON",
        "meeting_minutes.json.tab_ai_guide": "AI-instruks",
        "meeting_minutes.json.hint": "Lim inn eller rediger agenda-JSON. Bruk erstatt eller legg til.",
        "meeting_minutes.json.replace_groups": "Erstatt alle punkter",
        "meeting_minutes.json.append_groups": "Legg til nederst",
        "meeting_minutes.json.copy_json": "Kopier JSON",
        "meeting_minutes.json.reload_from_editor": "Last fra editor",
        "meeting_minutes.json.insert_sample": "Sett inn eksempel",
        "meeting_minutes.json.apply": "Bruk i editor",
        "meeting_minutes.json.copy_success": "JSON kopiert",
        "meeting_minutes.json.reload_success": "JSON lastet fra editor",
        "meeting_minutes.json.clipboard_failed": "Kunne ikke kopiere",
        "meeting_minutes.json.applied": "La inn {{count}} punkter",
        "meeting_minutes.json.ai_guide_intro": "Kopier instruksen og lim inn i ChatGPT, Cursor eller annen modell.",
        "meeting_minutes.json.copy_ai_guide": "Kopier AI-instruks",
        "meeting_minutes.json.ai_guide_copied": "AI-instruks kopiert",
        "meeting_minutes.json.ai_parse_error": "Kunne ikke lese AI-JSON",
        "meeting_minutes.json.ai_apply_success": "La inn {{count}} AI-punkter",
        "meeting_minutes.json.error_empty": "Tom JSON",
        "meeting_minutes.json.error_invalid_json": "Ugyldig JSON",
        "meeting_minutes.json.error_no_groups_array": "Mangler groups-array",
        "meeting_minutes.json.error_no_valid_groups": "Ingen gyldige punkter i JSON",
        "meeting_minutes.json.error_create_group_failed": "Kunne ikke opprette punkt fra JSON",
        "meeting_minutes.json.error_create_entry_failed": "Kunne ikke opprette innlegg fra JSON",
        "meeting_minutes.add_meeting": "Legg til Møte",
        "meeting_minutes.add_first_meeting": "Legg til Første Møte",
        "meeting_minutes.no_meetings": "Ingen møter ennå",
        "meeting_minutes.points": "punkter",
        "meeting_minutes.add_point": "Legg til Punkt",
        "meeting_minutes.point.title": "Punktittel",
        "meeting_minutes.point.description": "Punktbeskrivelse",
        "meeting_minutes.point.untitled": "Uten tittel",
        "meeting_minutes.point.create_error": "Kunne ikke opprette punkt",
        "meeting_minutes.errors.stale": "Møtet er endret av en annen bruker. Kladden din er beholdt. Hent siste versjon før du lagrer på nytt.",
        "meeting_minutes.point.update_error": "Kunne ikke oppdatere punkt",
        "meeting_minutes.point.delete_error": "Kunne ikke slette punkt",
        "meeting_minutes.point.delete_confirm": "Er du sikker på at du vil slette dette punktet?",
        "meeting_minutes.entry.add": "Legg til Innlegg",
        "meeting_minutes.entry.remove": "Fjern",
        "meeting_minutes.entry.create_error": "Kunne ikke opprette innlegg",
        "meeting_minutes.entry.update_error": "Kunne ikke oppdatere innlegg",
        "meeting_minutes.entry.delete_error": "Kunne ikke slette innlegg",
        "meeting_minutes.entry.delete_confirm": "Er du sikker på at du vil slette dette innlegget?",
        "meeting_minutes.meeting.created": "Møte opprettet",
        "meeting_minutes.meeting.create_error": "Kunne ikke opprette møte",
        "meeting_minutes.meeting.load_error": "Kunne ikke laste møte",
        "meeting_minutes.meeting.finished": "Ferdig",
        "meeting_minutes.meeting.mark_finished": "Merk som Ferdig",
        "meeting_minutes.meeting.marked_finished": "Møte merket som ferdig",
        "meeting_minutes.meeting.mark_finished_error": "Kunne ikke merke møte som ferdig",
        "meeting_minutes.meeting.mark_finished_title": "Merk møtet som ferdig?",
        "meeting_minutes.meeting.mark_finished_body": "Møtet merkes som ferdig og kan ikke lenger redigeres. Redigeringsmodus slås av, og punkter og innlegg kan ikke endres på denne siden etterpå.",
        "meeting_minutes.actions.open": "Handlinger",
        "meeting_minutes.meeting.no_points": "Ingen punkter lagt til ennå",
        "meeting_minutes.meeting.no_points_add_first": "Ingen punkter lagt til ennå. Legg til ditt første punkt for å komme i gang.",
        "meeting_minutes.meeting.copy_options": "Kopieringsalternativer",
        "meeting_minutes.meeting.copy_from_previous": "Kopier fra Forrige Møte",
        "meeting_minutes.meeting.no_copy": "Ikke kopier",
        "meeting_minutes.meeting.or": "ELLER",
        "meeting_minutes.meeting.no_template": "Ikke bruk mal",
        "meeting_minutes.employee.add_manual": "Legg til Manuell Deltaker",
        "meeting_minutes.employee.manual_name": "Navn",
        "meeting_minutes.employee.manual_email": "E-post",
        "meeting_minutes.employee.manual_mobile": "Mobil",
        "meeting_minutes.employee.remove": "Fjern",
        "meeting_minutes.meetings_created_separately": "Møter opprettes separat. Gå til møtelisten for å legge til nye møter.",
        "meeting_minutes.group.update_error": "Kunne ikke oppdatere gruppe",
        "meeting_minutes.group.delete_confirm": "Er du sikker på at du vil slette denne gruppen?",
        "meeting_minutes.group.deleted": "Gruppe slettet",
        "meeting_minutes.group.delete_error": "Kunne ikke slette gruppe",
        "meeting_minutes.group.delete": "Slett Gruppe",
        "meeting_minutes.group.documents": "Gruppedokumenter",
        "meeting_minutes.entry.documents": "Innleggsdokumenter",
        "meeting_minutes.changes_saved": "Endringer lagret",
        "meeting_minutes.print": "Skriv ut",
        "meeting_minutes.printing": "Skriver ut…",
        "meeting_minutes.print_failed": "Kunne ikke generere PDF",
        "meeting_minutes.send": "Send referat",
        "meeting_minutes.send_success": "Referatet ble sendt",
        "meeting_minutes.send_partial": "Sendt til {{sent}} mottaker(e). {{failed}} feilet.",
        "meeting_minutes.from_previous_meeting": "Fra Forrige Møte",
        "meeting_minutes.read_only_reference": "Skrivebeskyttet referanse",
        "meeting_minutes.collapse": "Skjul",
        "meeting_minutes.expand": "Vis",
        "meeting_minutes.entry.singular": "punkt",
        "meeting_minutes.entry.plural": "punkter",
        "meeting_minutes.image.uploaded": "{{count}} bilde(r) lastet opp",
        "meeting_minutes.others_editing": "Andre redigerer dette møtet. Endringer kan bli overskrevet.",
        "meeting_minutes.point.edit": "Rediger Punkt",
        "meeting_minutes.group.created": "Gruppe opprettet",
        "meeting_minutes.group.updated": "Gruppe oppdatert",
        "Saving...": "Lagrer...",
        "Update": "Oppdater",
        "Create": "Opprett",
        
        // Drawings translations (Norwegian)
        "drawings": "Tegninger",
        "drawings_edit": "Tegninger – redigering",
        "drawings.list": "Tegninger",
        "drawings.list.projects": "Prosjekter",
        "drawings.list_ui.add": "Legg til",
        "drawings.list_ui.all_drawings": "Alle tegninger",
        "drawings.list_ui.legend": "Forklaring",
        "drawings.list_ui.pick_project_title": "Hvilket prosjekt jobber du med?",
        "drawings.list_ui.pick_project_help": "Tegninger tilhører alltid et prosjekt. Velg ett én gang — det huskes resten av økten.",
        "drawings.list_ui.pick_project_search": "Søk prosjekt på nummer, navn eller kunde",
        "drawings.list_ui.pick_project_empty": "Ingen prosjekter funnet",
        "drawings.list_ui.pick_project_footer": "Nylig brukte prosjekter vises først. Du kan bytte prosjekt når som helst fra headeren.",
        "drawings.list_ui.cancel_switch": "Avbryt bytte",
        "drawings.list_ui.switch_project": "Bytt",
        "drawings.list_ui.go_to_project": "Gå til prosjekt",
        "drawings.list_ui.summary": "{{count}} tegninger i prosjektet",
        "drawings.list_ui.manage_structure": "Administrer struktur",
        "drawings.list_ui.open_user_guide": "Brukerguide",
        "drawings.list_ui.open_structure": "Hus og etasjer",
        "drawings.list_ui.tab_all": "Alle tegninger",
        "drawings.list_ui.tab_needs_review": "Trenger gjennomgang",
        "drawings.list_ui.tab_revisions": "Revisjoner",
        "drawings.list_ui.tab_archive": "Arkiv",
        "drawings.list_ui.tab_coming_soon": "Kommer snart",
        "drawings.list_ui.search_placeholder": "Søk tegninger, hus, etasjer",
        "drawings.list_ui.filter_all_types": "Alle",
        "drawings.list_ui.scope_floor": "Valgt etasje",
        "drawings.list_ui.scope_house": "Valgt hus",
        "drawings.list_ui.result_count": "{{count}} treff",
        "drawings.list_ui.empty_title": "Ingen tegninger her ennå",
        "drawings.list_ui.empty_hint": "Legg til en tegning for dette filteret, eller velg en annen etasje.",
        "drawings.list_ui.empty_cta": "Legg til tegning her",
        "drawings.list_ui.updated_unknown": "Oppdatert ukjent",
        "drawings.list_ui.updated_today": "Oppdatert i dag",
        "drawings.list_ui.updated_yesterday": "Oppdatert i går",
        "drawings.list_ui.updated_days": "Oppdatert for {{count}} dager siden",
        "drawings.create_drawer.create": "Opprett tegning",
        "drawings.create_drawer.create_another": "Opprett og legg til flere",
        "drawings.create_drawer.context_fallback": "Ny tegning",
        "drawings.create_drawer.pdf_hint": "Tittel, hus og etasje kan leses fra filnavnet når det er mulig",
        "drawings.create_drawer.title_placeholder": "f.eks. Hus 1 — Etasje 2 ventilasjon",
        "drawings.create_drawer.location": "Plassering",
        "drawings.create_drawer.location_hint": "Forhåndsvalgt fra filteret ditt",
        "drawings.create_drawer.floor_required": "Velg etasje, eller bruk Andre for tegninger uten etasje",
        "drawings.structure.new_house_placeholder_short": "Husnavn",
        "drawings.structure.new_floor_placeholder_short": "Etasjenavn",
        "drawings.new": "Ny tegning",
        "drawings.edit": "Rediger Tegning",
        "drawings.create": "Opprett Tegning",
        "drawings.update": "Oppdater Tegning",
        "drawings.delete": "Slett Tegning",
        "drawings.search": "Søk i tegninger...",
        "drawings.no_results": "Ingen tegninger funnet",
        "drawings.title": "Tittel",
        "drawings.title.required": "Tittel er påkrevd",
        "drawings.description": "Beskrivelse",
        "drawings.project": "Prosjekt",
        "drawings.select_project": "Velg prosjekt",
        "drawings.floor": "Etasje",
        "drawings.floor.placeholder": "Angi etasjenummer eller navn",
        "drawings.house": "Hus",
        "drawings.house.placeholder": "Angi husnummer eller identifikator",
        "drawings.document": "Tegningsdokument",
        "drawings.document.required": "Tegningsdokument er påkrevd",
        "drawings.document.replace": "Erstatt PDF",
        "drawings.document.upload_pdf": "Last opp PDF-tegning",
        "drawings.document.pdf_only_hint": "Slipp fil her eller velg PDF",
        "drawings.document.choose_file": "Velg fil",
        "drawings.document.pdf_required": "Kun PDF-filer kan brukes som tegning",
        "drawings.document.pdf_read_error": "Kunne ikke lese PDF-en. Prøv en annen fil.",
        "drawings.document.checking_pages": "Sjekker antall sider…",
        "drawings.document.multi_page_warning":
          "Denne PDF-en har {{count}} sider. Kun 1 side per tegning støttes — velg hvilken side som skal brukes.",
        "drawings.document.use_this_page": "Bruk side {{page}}",
        "drawings.document.single_page_hint":
          "Kun den valgte siden lastes opp. De andre sidene i den opprinnelige PDF-en brukes ikke.",
        "drawings.document.extracting_page": "Trekker ut side…",
        "drawings.document.extract_error": "Kunne ikke trekke ut siden fra PDF-en",
        "drawings.document.uploading": "Laster opp…",
        "drawings.document.uploaded": "PDF lastet opp",
        "drawings.document.upload_error": "Kunne ikke laste opp PDF",
        "drawings.created": "Tegning opprettet",
        "drawings.replaced": "Tegningen ble erstattet",
        "drawings.floor_replace_hint":
          "Samme etasje og type kan bare ha én tegning. Du må bekrefte før en eksisterende tegning erstattes.",
        "drawings.floor_kind_hint":
          "Samme etasje kan ha flere tegninger (f.eks. arkitekt og ventilasjon). Samme etasje + samme type krever bekreftelse før erstatning.",
        "drawings.andre_hint":
          "«Andre» er tegninger uten etasje (f.eks. kjøkken). De vises i en egen gruppe i strukturen.",
        "drawings.floor_kind_conflict":
          "Det finnes allerede en tegning for denne etasjen og typen. Velg en annen type, eller åpne den eksisterende tegningen.",
        "drawings.kind": "Tegningstype",
        "drawings.kind_hint": "Velg type for tegningen. Typen brukes sammen med etasje for å unngå duplikater.",
        "drawings.kind.arkitekt": "Arkitekt",
        "drawings.kind.ventilasjon": "Ventilasjon",
        "drawings.kind.kjokken": "Kjøkken",
        "drawings.kind.annet": "Annet",
        "drawings.replace_confirm.title": "Erstatt eksisterende tegning?",
        "drawings.replace_confirm.message":
          "Du er i ferd med å erstatte «{{title}}» ({{house}} · etasje {{floor}} · {{kind}}).\n\nPDF/dokumentet blir erstattet. Dette kan ikke enkelt angres.",
        "drawings.replace_confirm.confirm": "Erstatt tegning",
        "drawings.replace_confirm.cancel": "Avbryt",
        "drawings.replace_confirm.invalid_target":
          "Kunne ikke erstatte tegning fordi referansen til eksisterende tegning mangler.",
        "drawings.updated": "Tegning oppdatert",
        "drawings.save_changes": "Lagre endringer",
        "drawings.no_changes": "Ingen endringer å lagre",
        "drawings.deleted": "Tegning slettet",
        "drawings.delete_confirm": "Er du sikker på at du vil slette denne tegningen?",
        "drawings.create_error": "Kunne ikke opprette tegning",
        "drawings.update_error": "Kunne ikke oppdatere tegning",
        "drawings.update_partial": "{{done}} lagret. {{remaining}} gjenstår — kontroller før nytt forsøk.",
        "drawings.delete_error": "Kunne ikke slette tegning",
        "drawings.load_error": "Kunne ikke laste tegning",
        "drawings.module.add": "Legg til Modul",
        "drawings.module.arrow": "Pil",
        "drawings.module.circle": "Sirkel",
        "drawings.module.rectangular": "Rektangel",
        "drawings.module.pen": "Frihånd",
        "drawings.module.measure": "Mål",
        "drawings.module.photo": "Foto",
        "drawings.module.note": "Notat",
        "drawings.module.delete": "Slett Modul",
        "drawings.module.delete_confirm": "Er du sikker på at du vil slette denne modulen?",
        "drawings.module.color": "Farge",
        "drawings.module.filled": "Fylt",
        "drawings.module.not_filled": "Ikke fylt",
        "drawings.module.move": "Flytt Modul",
        "drawings.viewer.details": "Tegningsdetaljer",
        "drawings.viewer.details_short": "Detaljer",
        "drawings.viewer.modules": "Moduler",
        "drawings.viewer.modules_short": "Moduler",
        "drawings.viewer.deviations_short": "Avvik",
        "drawings.viewer.checklists_short": "Sjekk",
        "drawings.viewer.structure_short": "Struktur",
        "drawings.viewer.no_modules": "Ingen moduler ennå. Høyreklikk på tegningen for å legge til.",
        "drawings.viewer.context_hint": "Høyreklikk på tegningen for å legge til piler, sirkler eller rektangler.",
        "drawings.viewer.unsaved": "Ulagret",
        "drawings.viewer.toggle_sidebar": "Vis/skjul sidepanel",
        "drawings.viewer.zoom_in": "Zoom inn",
        "drawings.viewer.zoom_out": "Zoom ut",
        "drawings.viewer.reset_zoom": "Tilbakestill zoom",
        "drawings.viewer.fit_to_screen": "Tilpass til skjerm",
        "drawings.viewer.loading_pdf": "Laster tegning...",
        "drawings.viewer.pdf_error": "Kunne ikke laste tegnings-PDF",
        "drawings.viewer.tool.select": "Velg",
        "drawings.viewer.tool.pan": "Panorer",
        "drawings.viewer.tool.pen": "Penn",
        "drawings.viewer.tool.measure": "Mål",
        "drawings.viewer.tool_hint": "Bruk Velg (V) for å flytte moduler. Velg Penn (P) for frihånd, Mål (M) for dimensjon, eller formverktøy for markører.",
        "drawings.viewer.no_description": "Ingen beskrivelse.",
        "drawings.viewer.location": "Plassering",
        "drawings.viewer.prev_page": "Forrige side",
        "drawings.viewer.next_page": "Neste side",
        "drawings.viewer.deviations": "Avvik",
        "drawings.viewer.checklists": "Sjekklister",
        "drawings.viewer.no_project_linked": "Koble tegningen til et prosjekt for å vise avvik og sjekklister.",
        "drawings.viewer.no_deviations": "Ingen avvik funnet for dette prosjektet.",
        "drawings.viewer.no_checklists": "Ingen sjekklister funnet for dette prosjektet.",
        "drawings.viewer.pin_deviation": "Fest på tegning",
        "drawings.viewer.repin_deviation": "Flytt markør",
        "drawings.viewer.pin_deviation_hint": "Klikk på tegningen for å plassere avvikmarkøren.",
        "drawings.viewer.show_on_drawing": "Vis på tegning",
        "drawings.viewer.checklist_items": "punkter",
        "drawings.viewer.open_checklist": "Åpne sjekkliste",
        "drawings.viewer.checklist_fill": "Fyll ut",
        "drawings.viewer.checklist_attach_photo": "Legg ved foto",
        "drawings.viewer.checklist_upload_new_photo": "Last opp nytt foto",
        "drawings.viewer.checklist_attach_existing": "Knytt foto",
        "drawings.viewer.checklist_existing_photos": "Eksisterende foto",
        "drawings.viewer.checklist_existing_photos_empty": "Ingen foto på tegningen eller prosjektet ennå.",
        "drawings.viewer.checklist_photo_linked": "Fotoet er knyttet til sjekklisten",
        "drawings.viewer.checklist_fill_subtitle": "Fyll ut punkter direkte fra tegningen",
        "drawings.viewer.checklist_fill_load_error": "Kunne ikke laste sjekklisten",
        "drawings.viewer.checklist_item_docs": "Dokument / pin",
        "drawings.viewer.checklist_item_doc": "Dokument",
        "drawings.viewer.checklist_item_docs_empty": "Ingen dokumenter ennå — bruk kamera for å legge til pin på tegningen.",
        "drawings.viewer.checklist_item_pinned": "Pin på tegning",
        "drawings.viewer.checklist_pin_group": "Pin {{n}}",
        "drawings.viewer.checklist_unpinned_docs": "Uten pin",
        "drawings.viewer.checklist_pin_completed": "Fullført",
        "drawings.viewer.checklist_pin_approved_count": "{{count}} godkjent",
        "drawings.viewer.checklist_pin_deviation_count": "{{count}} avvik",
        "drawings.viewer.checklist_pin_item_label": "Sjekklistepunkt",
        "drawings.viewer.checklist_pin_checklist_label": "Sjekkliste",
        "drawings.viewer.deviation_pin_label": "Avvik",
        "drawings.viewer.deviation_pin_short": "Avvik",
        "drawings.viewer.deviation_pin_number": "Avvik {{number}}",
        "drawings.viewer.checklist_item_fallback": "Sjekklistepunkt",
        "drawings.viewer.checklist_status.approved": "Godkjent",
        "drawings.viewer.checklist_status.deviation": "Avvik",
        "drawings.viewer.checklist_status.na": "Ikke aktuelt",
        "drawings.viewer.checklist_status.pending": "Venter",
        "drawings.viewer.checklist_status.not_approved": "Ikke godkjent",
        "drawings.viewer.reopen_checklist": "Åpne sjekkliste igjen",
        "drawings.viewer.reopen_deviation": "Åpne avvik igjen",
        "drawings.viewer.dismiss_pin_focus": "Lukk",
        "drawings.viewer.show_pin_on_drawing": "Se på tegning",
        "drawings.viewer.deviation_status.open": "Åpen",
        "drawings.viewer.deviation_status.in_progress": "Under arbeid",
        "drawings.viewer.deviation_status.closed": "Lukket",
        "drawings.viewer.deviation_status.unknown": "Ukjent",
        "drawings.viewer.measure_scale": "Målestokk",
        "drawings.viewer.calibrate": "Kalibrer",
        "drawings.viewer.calibrate_title": "Kalibrer måling",
        "drawings.viewer.calibrate_help": "Tegn en referanselinje på tegningen med kjent lengde, og skriv inn lengden i millimeter. Har du allerede målt, brukes siste målelinje automatisk.",
        "drawings.viewer.calibrate_draw_line": "Tegn en referanselinje på tegningen med måleverktøyet.",
        "drawings.viewer.calibrate_using_existing": "Bruker eksisterende målelinje som referanse.",
        "drawings.viewer.calibrate_line_length": "Referanselinje",
        "drawings.viewer.calibrate_known_mm": "Kjent lengde (mm)",
        "drawings.viewer.calibrate_current_scale": "Nåværende skala",
        "drawings.viewer.calibrate_new_scale": "Ny skala",
        "drawings.viewer.calibrate_save": "Lagre kalibrering",
        "drawings.viewer.calibrate_saved": "Målestokk lagret",
        "drawings.viewer.calibrate_error_no_line": "Tegn en referanselinje med måleverktøyet før du lagrer.",
        "drawings.viewer.calibrate_error_no_length": "Skriv inn den kjente lengden i millimeter.",
        "drawings.viewer.calibrate_error_invalid": "Ugyldig kalibrering. Sjekk linje og lengde.",
        "drawings.viewer.versions": "Tegningsversjoner",
        "drawings.viewer.live_drawing": "Live",
        "drawings.viewer.revision": "Rev. {{name}}",
        "drawings.viewer.updated_on": "oppdatert {{date}}",
        "drawings.viewer.create_version": "Ny markeringversjon",
        "drawings.viewer.version_name_prompt": "Navn på markeringversjonen",
        "drawings.viewer.version_created": "Markeringversjon opprettet",
        "drawings.viewer.editing_version": "Redigerer versjon",
        "drawings.viewer.save_location": "Lagre plassering",
        "drawings.viewer.location_saved": "Hus og etasje lagret",
        "drawings.viewer.location_hint": "Velg hus og etasje i Struktur-fanen, eller administrer prosjektstrukturen der.",
        "drawings.viewer.all_houses": "Alle hus",
        "drawings.viewer.all_floors": "Alle etasjer",
        "drawings.viewer.mobile.nav_aria": "Tegningsmeny",
        "drawings.viewer.mobile.tools": "Verktøy",
        "drawings.viewer.mobile.more": "Mer",
        "drawings.viewer.mobile.switch_drawing": "Bytt tegning",
        "drawings.viewer.mobile.no_sibling_drawings": "Ingen andre tegninger i dette prosjektet.",
        "drawings.viewer.mobile.no_project_drawings": "Denne tegningen er ikke knyttet til et prosjekt, og ingen andre tegninger ble funnet. Gå til tegningslisten for å bytte.",
        "drawings.viewer.mobile.no_project_switch_hint": "Tegningen er ikke knyttet til et prosjekt. Velg en annen tilgjengelig tegning, eller åpne tegningslisten.",
        "drawings.viewer.mobile.to_drawings_list": "Til tegningsliste",
        "drawings.viewer.mobile.select_pan_toggle": "Bytt mellom Velg og Panorer",
        "drawings.viewer.mobile.close": "Lukk",
        "drawings.viewer.mobile.zoom": "Zoom",
        "drawings.viewer.mobile.pinch_hint": "Bruk knipebevegelser på tegningen for å zoome, eller knappene − / +.",
        "drawings.viewer.mobile.menu": "Tegninger",
        "drawings.viewer.mobile.search_placeholder": "Søk tegning, hus eller etasje",
        "drawings.viewer.mobile.no_search_results": "Ingen tegninger matcher søket.",
        "drawings.viewer.mobile.select_short": "Velg",
        "drawings.viewer.mobile.pan_short": "Pan",
        "drawings.viewer.mobile.add_short": "Ny",
        "drawings.structure.title": "Struktur",
        "drawings.structure.andre": "Andre",
        "drawings.structure.andre_hint_short": "Uten etasje",
        "drawings.structure.filter_andre": "Filtrert på Andre (uten etasje)",
        "drawings.structure.help": "Opprett hus og etasjer for prosjektet. Tildel tegninger til etasje, eller bruk «Andre» for tegninger uten etasje.",
        "drawings.structure.add_house": "Legg til hus",
        "drawings.structure.add_floor": "Legg til etasje",
        "drawings.structure.new_house_placeholder": "Husnavn (f.eks. Hus A)",
        "drawings.structure.new_floor_placeholder": "Etasjenavn (f.eks. 1)",
        "drawings.structure.empty": "Ingen hus ennå. Legg til et hus, deretter etasjer under det.",
        "drawings.structure.project_required": "Velg et prosjekt for å administrere hus og etasjer.",
        "drawings.structure.assign_hint": "Klikk en etasje for å tildele tegningen. Lagre når valget endres.",
        "drawings.structure.house_created": "Hus opprettet",
        "drawings.structure.floor_created": "Etasje opprettet",
        "drawings.structure.house_deleted": "Hus slettet",
        "drawings.structure.floor_deleted": "Etasje slettet",
        "drawings.structure.delete_house": "Slett hus",
        "drawings.structure.delete_floor": "Slett etasje",
        "drawings.structure.delete_house_confirm": "Slette dette huset og alle etasjene? Tegninger fjernes fra etasjene.",
        "drawings.structure.delete_floor_confirm": "Slette denne etasjen? Tegninger på etasjen fjernes fra tilknytningen.",
        "drawings.structure.load_error": "Kunne ikke laste tegningsstruktur",
        "drawings.structure.save_error": "Kunne ikke lagre tegningsstruktur",
        "drawings.structure.delete_error": "Kunne ikke slette",
        "drawings.structure.filter_active": "Filtrert på hus eller etasje",
        "drawings.structure.clear_filter": "Fjern filter",

        "drawings.viewer.see_3d": "Se 3D",
        "drawings.viewer.see_3d_short": "3D",
        "drawings.viewer.see_3d_no_project": "Tegningen må være koblet til et prosjekt for å åpne 3D.",
        "drawings.viewer.open_place_in_3d": "Åpne sted i 3D",
        "drawings.viewer.open_place_in_3d_error": "Kunne ikke åpne stedet i 3D.",
        "drawings.viewer.open_place_in_3d_no_alignment": "Tegningen er ikke innrettet mot modellen ennå. Bruk «Line opp 3D» først.",
        "drawings.viewer.align_3d": "Koble tegning",
        "drawings.viewer.align_3d_title": "Koble tegning til modell",
        "drawings.viewer.align_3d_help": "Velg to punkter på tegningen som du kjenner IFC-koordinatene til. Promang regner ut skala, rotasjon og forskyvning fra disse to punktene.",
        "drawings.viewer.align_3d_pick_hint": "Åpner 3D-visningen. Velg etasje, klikk på tegningen og deretter samme sted i modellen.",
        "drawings.viewer.align_3d_pick_second": "Klikk punkt 2 på tegningen.",
        "drawings.viewer.align_3d_point": "Punkt {{number}}",
        "drawings.viewer.align_3d_ifc_x": "IFC X",
        "drawings.viewer.align_3d_ifc_y": "IFC Y",
        "drawings.viewer.align_3d_z_offset": "Z-forskyvning",
        "drawings.viewer.align_3d_storey": "Etasjenavn i modellen",
        "drawings.viewer.align_3d_save": "Lagre innretting",
        "drawings.viewer.align_3d_saved": "Innretting mot 3D er lagret",
        "drawings.viewer.align_3d_error": "Kunne ikke lagre innretting mot 3D.",

        "ifc_viewer.models": "Modeller",
        "ifc_viewer.upload": "Last opp IFC",
        "ifc_viewer.uploading": "Laster opp …",
        "ifc_viewer.no_models": "Ingen IFC-modeller ennå. Last opp en .ifc-fil for å komme i gang.",
        "ifc_viewer.toggle_visibility": "Vis eller skjul {{name}} i denne visningen",
        "ifc_viewer.visible_for_everyone": "Synlig for alle",
        "ifc_viewer.hidden_badge": "Skjult",
        "ifc_viewer.show_for_everyone": "Vis {{name}} for alle",
        "ifc_viewer.hide_for_everyone": "Skjul {{name}} for andre",
        "ifc_viewer.model_shown": "Modellen er synlig for alle.",
        "ifc_viewer.model_hidden": "Modellen er skjult for andre.",
        "ifc_viewer.model_hide_error": "Kunne ikke lagre synlighet.",
        "ifc_viewer.link_drawing": "Koble tegning",
        "ifc_viewer.link_drawing_hint": "Velg tegning og etasje. Tegningen vises i 3D — dra den over planet.",
        "ifc_viewer.link_drawing_title": "Koble tegning til modell",
        "ifc_viewer.link_drawing_pick_help": "Velg tegning og en etasje med geometri fra huset (ARK). Tomme etasjer vises ikke. Deretter vises arket i 3D-vieweren — dra, roter og skaler det over planet.",
        "ifc_viewer.link_drawing_drawing": "Tegning",
        "ifc_viewer.link_drawing_pick_drawing": "Velg tegning …",
        "ifc_viewer.link_drawing_storey": "Etasje i ARK",
        "ifc_viewer.link_drawing_no_storeys": "Ingen etasjer med geometri i huset ennå. Last modellene først.",
        "ifc_viewer.link_drawing_continue": "Vis tegning i 3D",
        "ifc_viewer.link_drawing_overlay_help": "Dra tegningen over planet. Blå hjørner endrer skala, oransje håndtak roterer. Modellen står stille.",
        "ifc_viewer.link_drawing_overlay_note": "Kameraet er i fugleperspektiv på etasjen. Høyre mus / hjul flytter og zoomer kameraet. Lagring bruker samme likhets-transform som Se 3D.",
        "ifc_viewer.link_drawing_opacity": "Gjennomsiktighet",
        "ifc_viewer.link_drawing_rotate_left": "Roter 90° venstre",
        "ifc_viewer.link_drawing_rotate_right": "Roter 90° høyre",
        "ifc_viewer.link_drawing_reset": "Nullstill plassering",
        "ifc_viewer.link_drawing_advanced": "Avansert: to klikk-par i stedet",
        "ifc_viewer.link_drawing_back_overlay": "Tilbake til å dra tegningen i 3D",
        "ifc_viewer.link_drawing_click_pdf": "Klikk punkt {{number}} på tegningen.",
        "ifc_viewer.link_drawing_click_ifc": "Klikk samme sted i 3D-modellen (punkt {{number}}).",
        "ifc_viewer.link_drawing_v1_note": "Avansert: to klikk-par (PDF + 3D). Standardflyten er å dra arket i vieweren.",
        "ifc_viewer.link_drawing_pdf_error": "Kunne ikke laste tegningen.",
        "ifc_viewer.link_drawing_pdf_missing": "Tegningen har ingen PDF. Last opp en PDF på tegningen først.",
        "ifc_viewer.link_drawing_pdf_fetch_error": "Kunne ikke hente PDF-filen. Sjekk at tegningen har en fil og at du er innlogget.",
        "ifc_viewer.link_drawing_pdf_raster_error": "Kunne ikke lese PDF-siden. Prøv en annen tegning eller last opp PDF-en på nytt.",
        "ifc_viewer.link_drawing_pair": "Punkt {{number}}: PDF {{pdfX}}/{{pdfY}} → IFC {{ifcX}} / {{ifcY}}",
        "ifc_viewer.link_drawing_pdf_pending": "Punkt {{number}} på tegningen ({{x}}/{{y}}) — klikk i 3D.",
        "ifc_viewer.link_drawing_save": "Lagre kobling",
        "ifc_viewer.link_drawing_saved": "Tegningen er koblet til modellen.",
        "ifc_viewer.link_drawing_error": "Kunne ikke lagre koblingen.",
        "ifc_viewer.delete_model": "Slett {{name}}",
        "ifc_viewer.axis.x": "X",
        "ifc_viewer.axis.y": "Y",
        "ifc_viewer.axis.z": "Z",
        "ifc_viewer.axis.rotX": "Rot X",
        "ifc_viewer.axis.rotY": "Rot Y",
        "ifc_viewer.axis.rotZ": "Rot Z",
        "ifc_viewer.transform_aria": "Juster {{axis}} for {{name}}",
        "ifc_viewer.fit_view": "Sentrer visning",
        "ifc_viewer.iframe_title": "Promang IFC Viewer",
        "ifc_viewer.back_to_drawing": "Tilbake til tegning",
        "ifc_viewer.loading": "Laster …",
        "ifc_viewer.empty_viewer": "Last opp minst én IFC-modell for å vise 3D.",
        "ifc_viewer.selected_element": "Valgt element",
        "ifc_viewer.close_selection": "Lukk",
        "ifc_viewer.selection.name": "Navn",
        "ifc_viewer.selection.type": "Type",
        "ifc_viewer.selection.global_id": "GlobalId",
        "ifc_viewer.discipline_label": "Fag",
        "ifc_viewer.discipline.ARK": "ARK – arkitekt",
        "ifc_viewer.discipline.RIB": "RIB – bygg",
        "ifc_viewer.discipline.RIV": "RIV – VVS",
        "ifc_viewer.discipline.RIE": "RIE – elektro",
        "ifc_viewer.discipline.LAND": "LAND – landskap",
        "ifc_viewer.discipline.OTHER": "Annet",
        "ifc_viewer.house_label": "Hus",
        "ifc_viewer.no_house": "Uten hus",
        "ifc_viewer.filter_house": "Filtrer på hus",
        "ifc_viewer.all_houses": "Alle hus",
        "ifc_viewer.focus_from_drawing": "Sted fra tegning",
        "ifc_viewer.no_access": "Du har ikke tilgang til IFC Viewer.",
        "ifc_viewer.error_viewer_unavailable": "IFC Viewer-tjenesten er ikke tilgjengelig akkurat nå.",
        "ifc_viewer.error_no_ready_models": "Ingen av de opplastede IFC-modellene kunne åpnes. Sjekk at opplastingen er ferdig behandlet, eller prøv å laste opp på nytt.",
        "ifc_viewer.error_session": "Kunne ikke starte 3D-visningen.",
        "ifc_viewer.error_load": "Kunne ikke laste IFC-modeller.",
        "ifc_viewer.error_viewer_generic": "Feil i 3D-visningen.",
        "ifc_viewer.error_viewer_down": "IFC Viewer er nede. Kunne ikke nå visningen.",
        "ifc_viewer.error_viewer_timeout": "Kunne ikke starte 3D-visningen. Prøv igjen.",
        "ifc_viewer.error_model_failed": "IFC-filen kunne ikke lastes. Sjekk filen, eller last opp på nytt.",
        "ifc_viewer.retry": "Prøv igjen",
        "ifc_viewer.error_upload": "Opplasting av IFC-fil feilet.",
        "ifc_viewer.error_delete": "Kunne ikke slette modell.",
        "ifc_viewer.tools": "Verktøy",
        "ifc_viewer.tools_open": "Åpne verktøy",
        "ifc_viewer.tools_close": "Lukk verktøy",
        "ifc_viewer.upload_dialog_title": "Last opp IFC-modell",
        "ifc_viewer.upload_drop_hint": "Dra og slipp .ifc-filer her",
        "ifc_viewer.upload_choose_files": "Velg filer",
        "ifc_viewer.upload_selected": "Valgte filer ({{count}})",
        "ifc_viewer.upload_remove_file": "Fjern {{name}}",
        "ifc_viewer.upload_name_label": "Visningsnavn (valgfritt)",
        "ifc_viewer.upload_confirm": "Last opp",
        "ifc_viewer.confirm_replace_model": "Det finnes allerede en modell \"{{name}}\" for dette huset og denne disiplinen. Erstatte den med den nye opplastingen?",
        "ifc_viewer.model_replaced": "Modellen ble erstattet.",
        "ifc_viewer.placement_kept": "Plasseringen fra forrige {{discipline}} er beholdt.",
        "ifc_viewer.discipline_required": "Velg fag …",
        "ifc_viewer.house_optional": "valgfritt",
        "ifc_viewer.house_whole_project": "Uten hus / hele prosjektet",
        "ifc_viewer.auto_align": "Auto-innretting",
        "ifc_viewer.auto_align_hint":
          "Flytter senere modeller i X/Y slik at de legger seg på ARK (eller første modell hvis ARK mangler).",
        "ifc_viewer.auto_align_done": "{{count}} modeller ble innrettet mot den første",
        "ifc_viewer.auto_align_unavailable":
          "Auto-innretting krever minst to modeller i visningen.",
        "ifc_viewer.auto_align_on_upload":
          "{{count}} nye modeller ble lagt på den første modellen",
        "ifc_viewer.remerge": "Slå sammen på nytt",
        "ifc_viewer.remerge_hint":
          "Leser IFC-koordinater og legger alle modeller på ARK (eller første modell hvis ARK mangler).",
        "ifc_viewer.remerge_done":
          "{{count}} modeller ble slått sammen mot den første",
        "ifc_viewer.remerge_saved": "Sammenslåing lagret",
        "ifc_viewer.remerge_save_failed":
          "Kunne ikke lagre sammenslåingen. Prøv igjen før du laster siden på nytt.",
        "ifc_viewer.remerge_house": "Slå sammen mot huset",
        "ifc_viewer.remerge_house_hint":
          "Flytter RIV og andre fag slik at fotavtrykket treffer huset (ARK). Ingen koordinater å taste.",
        "ifc_viewer.place_model": "Plasser modell",
        "ifc_viewer.place_model_hint":
          "Klikk et punkt på den feilplasserte modellen, deretter samme sted på huset.",
        "ifc_viewer.place_include_z": "Ta med høyde",
        "ifc_viewer.place_unavailable":
          "Plassering krever minst to modeller i visningen.",
        "ifc_viewer.place_done": "Modellen er plassert",
        "ifc_viewer.reload_models": "Last inn modeller på nytt",
        "ifc_viewer.reload_models_done": "Modellene er lastet inn på nytt",
        "ifc_viewer.open_models": "Åpne modelliste",
        "ifc_viewer.close_models": "Lukk modelliste",
        "ifc_viewer.confirm_delete_model": "Slette {{name}}? Dette kan ikke angres.",
        "ifc_viewer.nudge_minus": "Flytt {{axis}} negativt",
        "ifc_viewer.nudge_plus": "Flytt {{axis}} positivt",
        "ifc_viewer.rotate_left": "Roter −90°",
        "ifc_viewer.rotate_right": "Roter +90°",
        "ifc_viewer.reset_transform": "Nullstill",
        "ifc_viewer.reset_transform_hint":
          "Tilbake til modellens egne koordinater",
        "ifc_viewer.save_transforms": "Lagre justeringer",
        "ifc_viewer.saving_transforms": "Lagrer …",
        "ifc_viewer.transforms_saved": "Justeringene er lagret",
        "ifc_viewer.error_save_transforms": "Kunne ikke lagre justeringene.",
        "ifc_viewer.storey_filter": "Etasje",
        "ifc_viewer.all_storeys": "Alle etasjer",
        "ifc_viewer.empty_storey": "tom",
        "ifc_viewer.link_storeys": "Koble etasjer",
        "ifc_viewer.link_storeys_title": "Koble etasjer til {{name}}",
        "ifc_viewer.link_storeys_hint":
          "Systemet foreslår kobling mot husets etasjer (samme navn, ellers nærmeste høyde). Du kan endre hver rad. 3D-visningen viser et snitt i valgt etasje — skyv med sliderne eller skriv meter.",
        "ifc_viewer.link_storeys_col_model": "Etasje i {{name}}",
        "ifc_viewer.link_storeys_col_proposal": "Forslag",
        "ifc_viewer.link_storeys_col_datum": "Velg {{name}}-etasje",
        "ifc_viewer.link_storeys_unlink": "Ikke lenk",
        "ifc_viewer.link_storeys_save": "Lagre",
        "ifc_viewer.link_storeys_skip": "Hopp over",
        "ifc_viewer.link_storeys_saved": "Etasjekoblingen er lagret",
        "ifc_viewer.link_storeys_proposal_name": "Samme navn",
        "ifc_viewer.link_storeys_proposal_elevation": "Nærmeste høyde",
        "ifc_viewer.link_storeys_proposal_none": "Ingen treff",
        "ifc_viewer.link_storeys_empty_target": "{{name}} (tom)",
        "ifc_viewer.link_storeys_align": "Skyv mot huset",
        "ifc_viewer.link_storeys_align_hint":
          "Hovedvisningen viser huset og denne modellen ovenfra, med horisontalt snitt i valgt etasje. Dra sliderne eller skriv meter (f.eks. 12,4) — ikke millimeter. Høyde er ±80 m.",
        "ifc_viewer.link_storeys_nudge_x": "Sideveis",
        "ifc_viewer.link_storeys_nudge_y": "Dybde",
        "ifc_viewer.link_storeys_nudge_z": "Høyde",
        "ifc_viewer.link_storeys_nudge_meters": "{{axis}} i meter",
        "ifc_viewer.link_storeys_reset_nudge": "Nullstill",
        "ifc_viewer.link_storeys_unavailable": "Last inn modellene først",
        "ifc_viewer.apply_upright": "Rett opp",
        "ifc_viewer.upright_saved": "Oppretting lagret",
        "ifc_viewer.upright_save_failed":
          "Kunne ikke lagre opprettingen. Prøv igjen før du laster siden på nytt.",
        "ifc_viewer.nav_hint":
          "Venstre: roter · Høyre: panorer · Hjul: zoom · G: gå · M: mål · L: laser · B: boks · X: røntgen · Ctrl+Z: angre",
        "ifc_viewer.undo": "Angre",
        "ifc_viewer.redo": "Gjør om",
        "ifc_viewer.undo_hint": "Angre skjul / isoler (Ctrl+Z)",
        "ifc_viewer.redo_hint": "Gjør om skjul / isoler (Ctrl+Y)",
        "ifc_viewer.view_iso": "Iso",
        "ifc_viewer.view_top": "Topp",
        "ifc_viewer.view_front": "Front",
        "ifc_viewer.view_side": "Side",
        "ifc_viewer.section": "Snitt",
        "ifc_viewer.section_on": "På",
        "ifc_viewer.section_off": "Av",
        "ifc_viewer.section_invert": "Snu side",
        "ifc_viewer.section_axis.x": "X",
        "ifc_viewer.section_axis.y": "Y",
        "ifc_viewer.section_axis.z": "Høyde",
        "ifc_viewer.isolate_model": "Isoler {{name}}",
        "ifc_viewer.isolate_model_hint":
          "Vis {{name}} i full farge; andre modeller blir gjennomsiktige",
        "ifc_viewer.isolate_model_action": "Isoler modell",
        "ifc_viewer.isolate_model_action_hint":
          "Full farge; andre modeller blir ~20 % gjennomsiktige",
        "ifc_viewer.isolated": "Isolert",
        "ifc_viewer.section_model": "Utsnitt / snitt",
        "ifc_viewer.section_model_hint": "Aktiver snitt gjennom denne modellen",
        "ifc_viewer.hide_model": "Skjul modell",
        "ifc_viewer.show_model": "Vis modell",
        "ifc_viewer.fit_this_model": "Sentrer denne",
        "ifc_viewer.clear_isolate": "Fjern isolat",
        "ifc_viewer.menu_isolate": "Isoler",
        "ifc_viewer.menu_section": "Utsnitt",
        "ifc_viewer.menu_section_hint": "Snitt gjennom denne modellens midt-høyde",
        "ifc_viewer.menu_hide": "Skjul",
        "ifc_viewer.menu_show": "Vis",
        "ifc_viewer.menu_fit": "Sentrer",
        "ifc_viewer.menu_clear_isolate": "Fjern isolat",
        "ifc_viewer.menu_close": "Lukk",
        "ifc_viewer.menu_close_hint": "Lukk menyen",
        "ifc_viewer.show_all_models": "Vis alle modeller",
        "ifc_viewer.isolate_element": "Isoler",
        "ifc_viewer.hide_element": "Skjul",
        "ifc_viewer.show_all_elements": "Vis alle",
        "ifc_viewer.walk": "Gå",
        "ifc_viewer.walk_hint": "Førsteperson: WASD, mus for å se, Q/E opp og ned",
        "ifc_viewer.measure": "Mål",
        "ifc_viewer.measure_point": "Punkt til punkt",
        "ifc_viewer.measure_point_hint": "Avstand mellom to klikk",
        "ifc_viewer.measure_planar": "2D-utsnitt",
        "ifc_viewer.measure_planar_hint": "Mål i horisontalplan eller aktivt snitt",
        "ifc_viewer.laser": "Laser",
        "ifc_viewer.laser_hint": "Laser med 3 akser (X/Y/Z) fra ett punkt",
        "ifc_viewer.clear_measures": "Fjern mål",
        "ifc_viewer.clear_measures_title": "Fjern alle mål og lasere",
        "ifc_viewer.clear_last_measure": "Fjern siste",
        "ifc_viewer.cut_box": "Boks",
        "ifc_viewer.xray": "Røntgen",
        "ifc_viewer.isolate_type": "Isoler type",
        "ifc_viewer.hide_type": "Skjul type",
        "ifc_viewer.selection.object_type": "ObjectType",
        "ifc_viewer.selection.tag": "Tag",

        "drawings.observation.add": "Legg til",
        "drawings.observation.dialog_title": "Legg til observasjon",
        "drawings.observation.place_on_drawing": "Plasser på tegning",
        "drawings.observation.place_hint": "Klikk på tegningen for å plassere nålen",
        "drawings.observation.placement_banner": "Klikk på tegningen for å plassere",
        "drawings.observation.page": "Side",
        "drawings.observation.optional": "valgfritt",
        "drawings.observation.photo_default_title": "Bildefoto",
        "drawings.observation.photo_drop": "Slipp et bilde her eller klikk for å bla",
        "drawings.observation.photo_drop_hint": "JPG, PNG, WEBP",
        "drawings.observation.photo_caption_placeholder": "Kort bildetekst",
        "drawings.observation.note_placeholder": "Skriv notatet ditt…",
        "drawings.observation.deviation_title_placeholder": "Kort beskrivelse av avviket",
        "drawings.observation.deviation_desc_placeholder": "Ytterligere detaljer, plassering på byggeplass, osv.",
        "drawings.observation.deviation_explanation_placeholder":
          "Forklaring på avviket – hva skjedde, hvor og når.",
        "drawings.observation.deviation_consequence_placeholder":
          "Eventuelle konsekvenser eller risiko hvis avviket ikke utbedres.",
        "drawings.observation.project_required": "Koble et prosjekt til tegningen for å opprette avvik.",
        "drawings.observation.create_error": "Kunne ikke opprette observasjon",
        "drawings.observation.capture_bind_error":
          "Kunne ikke knytte snapshot til avviket. Observasjonen ble ikke plassert.",
        "drawings.observation.deviation_placed": "Avvik plassert på tegning",
        "drawings.observation.photo_placed": "Foto plassert på tegning",
        "drawings.observation.note_placed": "Notat plassert på tegning",
        "drawings.observation.deviation_docs": "Dokumenter på tegning",
        "drawings.observation.deviation_docs_empty":
          "Ingen dokumenter ennå. Bruk kamera for å legge til bilde med pin og snapshot.",
        "drawings.observation.field.title": "Tittel",
        "drawings.observation.field.category": "Kategori",
        "drawings.observation.field.severity": "Alvorlighetsgrad",
        "drawings.observation.field.description": "Beskrivelse",
        "drawings.observation.field.explanation": "Forklaring",
        "drawings.observation.field.consequence": "Eventuelle konsekvenser",
        "drawings.observation.field.status": "Status",
        "drawings.observation.field.project": "Prosjekt",
        "drawings.observation.field.place": "Sted",
        "drawings.observation.field.created_by": "Opprettet av",
        "drawings.observation.field.created_at": "Dato",
        "drawings.observation.field.photo": "Foto",
        "drawings.observation.field.caption": "Bildetekst",
        "drawings.observation.field.note": "Notat",
        "drawings.observation.field.pin_color": "Nålfarge",
        "drawings.observation.field.drawing": "Tegningsark",
        "drawings.observation.type.photo": "Foto",
        "drawings.observation.type.photo_desc": "Legg ved et bildefoto",
        "drawings.observation.type.deviation": "Avvik",
        "drawings.observation.type.deviation_desc": "Registrer et avvik",
        "drawings.observation.type.note": "Notat",
        "drawings.observation.type.note_desc": "Fest et fritekstnotat",
        "drawings.observation.type.checklist": "Sjekkliste",
        "drawings.observation.type.checklist_desc": "Ny fra mal eller knytt eksisterende",
        "drawings.observation.checklist_project_required": "Koble et prosjekt til tegningen for å legge til sjekkliste.",
        "drawings.observation.checklist_project_copy": "Sjekklister tilhører prosjektet. Du kan knytte dem til denne tegningen med en pin, eller la dem stå som prosjekt-sjekklister uten pin.",
        "drawings.observation.checklist_placed": "Sjekkliste plassert på tegning",
        "drawings.observation.checklist_mode.new": "Ny fra mal",
        "drawings.observation.checklist_mode.link": "Knytt eksisterende",
        "drawings.observation.checklist_type_placeholder": "Velg sjekklistetype",
        "drawings.observation.checklist_types_loading": "Laster typer…",
        "drawings.observation.checklist_items_selected": "{{count}} punkter valgt",
        "drawings.observation.checklist_title_placeholder": "Valgfri tittel for sjekklisten",
        "drawings.observation.checklist_search_placeholder": "Søk i prosjektsjekklister",
        "drawings.observation.checklist_link_empty": "Ingen tilgjengelige sjekklister å knytte (alle er allerede pinnet, eller listen er tom).",
        "drawings.observation.field.checklist_type": "Sjekklistetype",
        "drawings.observation.field.house": "Hus",
        "drawings.observation.field.apartment": "Leilighetsnummer",
        "drawings.observation.checklist_house_placeholder": "F.eks. Hus A",
        "drawings.observation.checklist_apartment_placeholder": "F.eks. H0101",
        "drawings.observation.field.existing_checklist": "Eksisterende sjekkliste",
        "drawings.observation.field.link_checklist": "Knytt til sjekkliste",
        "drawings.observation.checklist_none": "Ingen sjekkliste",
        "drawings.observation.field.search": "Søk",
        "drawings.observation.field.marker_shape": "Markørform",
        "drawings.observation.marker.arrow": "Pil",
        "drawings.observation.marker.circle": "Sirkel",
        "drawings.observation.marker.rectangular": "Firkant",
        "drawings.observation.current_drawing_hint": "Plasseres på gjeldende tegning: {{title}} (side {{page}})",
        "drawings.observation.sketch.toggle": "Markering / skisse på snapshot",
        "drawings.observation.sketch.toggle_hint": "Etter at du klikker på tegningen kan du tegne frihånd, pil, sirkel, rektangel eller tekst på snapshot-området.",
        "drawings.observation.sketch.title": "Skisse på snapshot",
        "drawings.observation.sketch.help": "Tegn markeringer på utsnittet. Velg tekst for å flytte eller dobbeltklikk for å redigere. Markeringene blir værende til du trykker Ferdig, Hopp over eller Avbryt.",
        "drawings.observation.sketch.pen": "Frihånd",
        "drawings.observation.sketch.arrow": "Pil",
        "drawings.observation.sketch.circle": "Sirkel",
        "drawings.observation.sketch.rectangular": "Rektangel",
        "drawings.observation.sketch.text": "Tekst",
        "drawings.observation.sketch.text_prompt": "Skriv tekstmarkering",
        "drawings.observation.sketch.undo": "Angre",
        "drawings.observation.sketch.redo": "Gjør om",
        "drawings.observation.sketch.clear": "Tøm",
        "drawings.observation.sketch.skip": "Hopp over",
        "drawings.observation.sketch.done": "Bruk skisse",
        "drawings.observation.relocate": "Flytt",
        "drawings.observation.relocate_hint": "Klikk på tegningen for å sette ny posisjon.",
        "drawings.observation.relocate_saved": "Ny posisjon satt — husk å lagre endringer.",
        "drawings.observation.sync_pending_badge": "Lagrer",
        "drawings.observation.sync_error_badge": "Ikke lagret",
        "drawings.observation.retry_save": "Lagre på nytt",
        "drawings.observation.retry_needs_photo": "Bildet mangler lokalt. Legg til foto på nytt for å lagre.",
        "drawings.viewer.checklist_add": "Legg til sjekkliste",
        "drawings.viewer.checklist_link": "Knytt til tegning",
        "drawings.viewer.checklists_project_copy": "Sjekklister tilhører prosjektet. Knytt dem til tegningen med en pin når du trenger det — eller opprett en ny.",
        "drawings.module.checklist": "Sjekkliste",
        "drawings.observation.severity.minor": "Mindre",
        "drawings.observation.severity.major": "Alvorlig",
        "drawings.observation.severity.critical": "Kritisk",
        "drawings.observation.view_details": "Vis detaljer",
        "drawings.observation.snapshot_title": "Tegningssnapshot",
        "drawings.observation.include_snapshot_in_print": "Ta med tegningssnapshot ved utskrift av sjekklister",
        "drawings.observation.snapshot_print_saved": "Utskriftsinnstilling lagret",
        "drawings.observation.open_deviation": "Åpne avvik",
        "drawings.observation.go_to_deviation": "Gå til avvik",
        "drawings.observation.open_deviation_page": "Åpne avviksside",
        "drawings.observation.tab.details": "Detaljer",
        "drawings.observation.tab.comments": "Kommentarer",
        "drawings.observation.field.consequence_type": "Konsekvenstype",
        "drawings.observation.consequence_type_placeholder": "Velg konsekvenstype",
        "drawings.observation.consequence_type.Economic": "Økonomisk",
        "drawings.observation.consequence_type.Progress": "Fremdrift",
        "drawings.observation.consequence_type.Safety": "Sikkerhet",
        "drawings.observation.consequence_type.Environment": "Miljø",
        "drawings.observation.consequence_type.Quality": "Kvalitet",
        "drawings.observation.consequence_type.Authority": "Myndighet",
        "drawings.observation.consequence_type.Other": "Annet",
        "drawings.observation.sketch.select": "Velg",
        "drawings.viewer.open_deviation_dialog": "Vis detaljer",
        "drawings.observation.document_missing": "Fotodokumentet kunne ikke lastes",
        "drawings.observation.note_empty": "Ingen notattekst",
        "Bruker som håndterer egenmelding": "Bruker som håndterer fravær",
        "Velg administrator": "Velg administrator",
        "Velg en administrator som skal håndtere egenmeldinger": "Velg en administrator som skal håndtere fravær",

        // Microsoft / Outlook
        "microsoft.explain.title": "Hva betyr tilkoblingen?",
        "microsoft.explain.company.1":
          "Kobler firmas hoved e-post (f.eks. post@firma.no) til Microsoft slik at Promang kan lese og håndtere innkommende e-post for saker.",
        "microsoft.explain.company.2": "Gir grunnlag for å opprette og oppdatere saker fra e-posttråder.",
        "microsoft.explain.company.3":
          "Krever admin-rettigheter og samtykke i Microsoft for den valgte postkassen.",
        "microsoft.explain.company.4":
          "Hemmeligheter og token-utveksling skjer kun i Promang API — ikke i nettleseren.",
        "microsoft.explain.company.5":
          "Sende e-post og AI-funksjoner mot firmamail kommer når lagring av tokens er ferdig på server.",
        "microsoft.explain.user.1":
          "Kobler din egen Microsoft / Outlook-konto til Promang-brukeren du er innlogget som.",
        "microsoft.explain.user.2":
          "Gjør det mulig å sende e-post fra din adresse der det er aktivert i Promang, og å bruke AI/kontekst fra din mail.",
        "microsoft.explain.user.3": "Du må være innlogget i Promang før du trykker «Koble til Microsoft».",
        "microsoft.explain.user.4": "E-postadressen i Microsoft bør samsvare med brukeren din der det er praktisk mulig.",
        "microsoft.explain.user.5":
          "Du kan når som helst koble fra under Innstillinger eller på siden Microsoft / Outlook.",
        "microsoft.company.page_title": "Microsoft — firmamail",
        "microsoft.company.page_subtitle": "Koble hoved e-post for selskapet (admin).",
        "microsoft.company.card_title": "Firmamail (Microsoft 365)",
        "microsoft.company.subtitle": "For felles innboks og saker på vegne av bedriften.",
        "microsoft.user.page_title": "Microsoft / Outlook",
        "microsoft.user.page_subtitle": "Koble din Microsoft-konto til denne Promang-brukeren.",
        "microsoft.user.card_title": "Din Outlook-konto",
        "microsoft.user.subtitle":
          "E-post sendes fra din konto når dette er støttet; gir også kontekst til AI og saker.",
        "user.settings.calendar.section_title": "Kalender",
        "user.settings.calendar.show_week_numbers": "Vis ukenummer",
        "user.settings.signature.section_title": "Signatur",
        "user.settings.signature.section_hint":
          "Brukes når du signerer tilbud, avtaler og andre dokumenter.",
        "user.settings.signature.empty": "Ingen signatur lastet opp",
        "user.settings.signature.preview_alt": "Din signatur",
        "user.settings.signature.remove": "Fjern signatur",
        "user.settings.signature.saved": "Signatur lagret",
        "user.settings.signature.save_error": "Kunne ikke lagre signatur",
        "offers.setup_prompt.dismiss": "Gjør senere",
        "offers.setup_prompt.signature.title": "Last opp signaturen din",
        "offers.setup_prompt.signature.body":
          "Anbefalt for tilbud: last opp signatur under brukerinnstillinger, så den kan brukes på dokument og PDF.",
        "offers.setup_prompt.signature.body_force":
          "Signatur mangler. Last den opp før du signerer eller eksporterer PDF.",
        "offers.setup_prompt.signature.cta": "Åpne innstillinger",
        "offers.setup_prompt.admin.title": "Firmaets tilbudsinnstillinger",
        "offers.setup_prompt.admin.body":
          "{{count}} anbefalte tilbudsinnstillinger mangler eller er avslått.",
        "offers.setup_prompt.admin.cta": "Åpne tilbudsinnstillinger",
        "microsoft.user.settings_section_title": "Microsoft / Outlook",
        "microsoft.user.settings_section_intro":
          "Koble Microsoft til kontoen du er innlogget med. Dette er ikke det samme som «Logg inn med Microsoft» på innloggingssiden — her forblir du i Promang og gir tilgang til e-post for funksjoner i dashbordet.",
        "microsoft.user.open_full_page": "Åpne egen side for tilkobling",
        "microsoft.user.calendar_heading": "Kalender for hendelser",
        "microsoft.user.calendar_intro":
          "Alle kalendere du har tilgang til i Outlook for denne kontoen vises (egne og delte). Velg hvor Promang skal opprette hendelser. Bruk søk hvis du har mange kalendere.",
        "microsoft.user.calendar_refresh": "Hent kalendere",
        "microsoft.user.calendar_need_refresh":
          "Koble til Microsoft med refresh-token (full tilkobling) for å hente kalendere.",
        "microsoft.user.calendar_select_label": "Kalender",
        "microsoft.user.calendar_none": "Ingen valgt",
        "microsoft.user.calendar_choose": "Søk …",
        "microsoft.user.calendar_modal_title": "Velg kalender",
        "microsoft.user.calendar_modal_close": "Lukk",
        "microsoft.user.calendar_modal_hint":
          "Søk på navn eller eiers e-post. Delte kalendere merkes; skrivebeskyttede kan ikke lagres for hendelsessynk.",
        "microsoft.user.calendar_search_placeholder": "Søk i kalendere …",
        "microsoft.user.calendar_search_empty": "Ingen kalendere matcher søket.",
        "microsoft.user.calendar_modal_empty": "Microsoft returnerte ingen kalendere.",
        "microsoft.user.calendar_badge_own": "Din",
        "microsoft.user.calendar_badge_shared": "Delt",
        "microsoft.user.calendar_badge_readonly": "Skrivebeskyttet",
        "microsoft.user.calendar_readonly_hint":
          "Denne kalenderen er skrivebeskyttet i Microsoft. Velg en du kan redigere for å synke hendelser.",
        "microsoft.user.calendar_readonly_save":
          "Kan ikke lagre en skrivebeskyttet kalender for hendelser. Velg en kalender du kan redigere.",
        "microsoft.user.calendar_current": "Tidligere valgt: {{name}}{{email}}",
        "microsoft.user.calendar_save": "Lagre kalender",
        "microsoft.user.calendar_saved": "Kalender lagret.",
        "microsoft.user.calendar_save_failed": "Kunne ikke lagre kalender.",
        "microsoft.user.calendar_load_failed": "Kunne ikke hente kalendere.",
        "microsoft.user.personal_mail_ai.title": "Din postkasse — AI-regler og behandling",
        "microsoft.user.personal_mail_ai.intro":
          "Sett sortering, manuelle regler, AI-ruting og kjør behandling på den koblede Microsoft-postkassen din — samme valg som delte firmainnbokser. Saker og kunder opprettes i gjeldende firma.",
        "microsoft.user.personal_mail_ai.no_permission":
          "Rollen din inkluderer ikke personleg innboks-AI. Be administrator tildele rollen «microsoft_personal_mail_ai» for dette firmaet eller gi deg admin-tilgang.",
        "microsoft.user.personal_mail_ai.forbidden_toast": "Du har ikke tilgang til disse innstillingene.",
        "microsoft.user.personal_mail_ai.load_failed": "Kunne ikke hente innstillinger for e-post-AI.",
        "microsoft.user.personal_mail_ai.no_refresh":
          "Koble Microsoft med refresh-token (full e-posttilkobling) for å hente meldinger og kjøre behandling.",
        "microsoft.user.personal_mail_ai.connect_first":
          "Koble Microsoft over for å sette opp regler, AI-ruting og behandling for din egen postkasse.",
        "microsoft.status.loading": "Laster status…",
        "microsoft.status.api_pending":
          "API for lagring av tokens er under utrulling. Du kan fortsatt fullføre innlogging hos Microsoft; kontakt admin hvis noe feiler.",
        "microsoft.status.connected": "Tilkoblet",
        "microsoft.action.disconnect": "Koble fra",
        "microsoft.action.connect_microsoft": "Koble til Microsoft",
        "microsoft.action.redirect_hint":
          "Du sendes til Microsoft for å godkjenne tilgang, deretter tilbake til Promang.",
        "microsoft.toast.login_required": "Du må være innlogget i Promang for å koble til.",
        "microsoft.toast.missing_env": "Microsoft er ikke konfigurert på serveren.",
        "microsoft.toast.start_failed": "Kunne ikke starte Microsoft-tilkobling.",
        "microsoft.toast.disconnected": "Frakoblet.",
        "microsoft.toast.disconnect_failed": "Kunne ikke koble fra.",
        "microsoft.callback.working": "Fullfører tilkobling…",
        "microsoft.callback.error_microsoft": "Microsoft avbrøt eller feilet.",
        "microsoft.callback.missing_params": "Mangler code eller state fra Microsoft.",
        "microsoft.callback.success_login": "Innlogget med Microsoft.",
        "microsoft.callback.success_link": "Microsoft-konto er koblet.",
        "microsoft.callback.api_not_ready": "API er ikke klar for dette steget ennå.",
        "microsoft.callback.exchange_failed": "Kunne ikke fullføre tilkoblingen.",
        "microsoft.callback.unknown_intent": "Ukjent tilkoblingstype.",
        "microsoft.callback.title": "Microsoft og Promang",
        "microsoft.callback.subtitle_loading":
          "Fullfører sikker tilkobling. Dette tar vanligvis noen sekunder.",
        "microsoft.callback.success_title": "Tilkobling fullført",
        "microsoft.callback.error_title": "Noe gikk galt",
        "microsoft.callback.redirecting_note": "Sender deg tilbake til Promang …",
        "microsoft.callback.continue_now": "Gå til Promang nå",
        "microsoft.callback.back_to_promang": "Tilbake til Promang",
        "microsoft.callback.back_to_login": "Tilbake til innlogging",
        "microsoft.callback.debug_heading": "Teknisk detalj (feilsøking)",
        "microsoft.callback.wait_hint": "Lukk ikke denne fanen mens vi fullfører.",
        "microsoft.login.or": "eller",
        "microsoft.login.redirecting": "Omdirigerer…",
        "microsoft.login.with_microsoft": "Logg inn med Microsoft",
        // Login page (split-screen design + loading system)
        "auth.login.title": "Logg inn",
        "auth.login.subtitle": "Bruk din arbeidskonto for å fortsette.",
        "auth.login.email_label": "E-post",
        "auth.login.email_placeholder": "navn@firma.no",
        "auth.login.password_label": "Passord",
        "auth.login.show_password": "Vis passord",
        "auth.login.hide_password": "Skjul passord",
        "auth.login.remember_me": "Husk meg",
        "auth.login.forgot_password": "Glemt passord?",
        "auth.login.submit": "Logg inn",
        "auth.login.submitting": "Logger inn …",
        "auth.login.success": "Innlogget",
        "auth.login.email_required": "E-post er påkrevd",
        "auth.login.email_invalid": "Må være en gyldig e-post",
        "auth.login.password_required": "Passord er påkrevd",
        "auth.login.brand_heading": "Prosjekter, planer og team — samlet.",
        "auth.login.brand_subtitle": "Plattformen som holder hele organisasjonen i takt.",
        "auth.login.brought_by": "Brought to you by",
        "auth.boot.initializing": "Klargjør arbeidsområdet",
        "auth.boot.syncing": "Synkroniserer modulene dine",
        "auth.boot.securing": "Etablerer sikker tilkobling",
        "auth.boot.finalizing": "Fullfører — nesten klar",
        "auth.boot.secure_session": "sikker økt",
        "auth.session_expired.title": "Økt utløpt",
        "auth.session_expired.message":
          "Av sikkerhetshensyn ble du logget ut. Logg inn på nytt for å fortsette der du slapp.",
        "auth.session_expired.login": "Logg inn på nytt",
        "auth.session_expired.cancel": "Avbryt",
        "auth.login.invalid_credentials":
          "Kunne ikke logge inn. Sjekk e-post og passord, eller bruk «Logg inn med Microsoft».",
        "auth.login.network_error":
          "Kunne ikke nå innloggingstjenesten. Sjekk nettverket og prøv igjen.",
        "auth.login.server_error":
          "Innlogging feilet på serveren. Prøv igjen om litt.",
        "auth.login.bootstrap_failed":
          "Innlogging lyktes, men profilen din kunne ikke lastes. Prøv igjen eller kontakt support.",
        "auth.login.token_missing":
          "Kunne ikke logge inn. Serveren returnerte ikke et tilgangstoken. Prøv igjen eller kontakt support.",
        "auth.login.not_approved":
          "Kontoen din er ikke godkjent ennå. Kontakt selskapsadministrator.",
        "auth.login.inactive":
          "Kontoen din er deaktivert. Kontakt selskapsadministrator.",
        "auth.login.company_required":
          "Ingen bedrift er knytt til kontoen din. Kontakt selskapsadministrator.",
        "users.login.no_password_use_microsoft":
          "Denne kontoen har ikke Promang-passord. Logg inn med Microsoft, eller be administrator sende lenke for å sette passord.",
        "microsoft.test_mail.button": "Send test-e-post til meg selv",
        "microsoft.test_mail.hint":
          "Sender én melding fra den koblede postkassen til samme adresse, for å verifisere Mail.Send og token.",
        "microsoft.test_mail.success": "Test-e-post er sendt. Sjekk innboksen.",
        "microsoft.test_mail.failed": "Kunne ikke sende test-e-post.",
        "microsoft.callback.promang_session_required": "Promang-økten kunne ikke bekreftes. Logg inn i Promang og start Microsoft-tilkoblingen på nytt.",
    "microsoft.ai_mailboxes.connection.checking": "Kontrollerer Microsoft-tilgang …",
    "microsoft.ai_mailboxes.connection.available": "Microsoft-tilgang kontrollert. Senderettigheter kontrolleres ved sending.",
    "microsoft.ai_mailboxes.connection.reauth_required": "Microsoft-tilgangen er utløpt eller tilbakekalt. Koble til på nytt.",
    "microsoft.ai_mailboxes.connection.access_denied": "Ingen tilgang til postkassen. Kontroller rettighetene i Microsoft 365 og koble til med riktig konto.",
    "microsoft.ai_mailboxes.connection.unavailable": "Kunne ikke kontrollere tilgangen. Prøv igjen senere.",
    "microsoft.ai_mailboxes.connection.disconnected": "Microsoft er ikke tilkoblet.",
    "microsoft.ai_mailboxes.connection.reconnect": "Koble til på nytt",
    "microsoft.ai_mailboxes.connection.check": "Kontroller tilgang",
    "microsoft.ai_mailboxes.connection.test_accepted": "Microsoft har akseptert testmeldingen for sending. Levering er ikke bekreftet.",
    "microsoft.ai_mailboxes.connection.unknown": "Resultatet er uavklart. Kontroller postkassen før du sender en ny test. Ingen automatisk ny sending blir gjort.",
    "microsoft.ai_mailboxes.title": "Delte innbokser for AI",
        "microsoft.ai_mailboxes.admin_page_title": "Delte innbokser (Microsoft 365)",
        "microsoft.ai_mailboxes.admin_page_subtitle":
          "Registrer delte adresser, koble Microsoft, vis innboks og sett hvordan e-post skal behandles (sortering, saker, arkiv, autosvar, signatur og regler). Behandling og valgfri arkivering til Archive/Arkiv kjører når du slår på jobben eller «Kjør behandling» (ikke simulering).",
        "microsoft.ai_mailboxes.intro":
          "Registrer delte adresser (f.eks. post@, service@). Hver postkasse må kobles mot Microsoft slik at Promang kan lese innboks og sende test via Graph.",
        "microsoft.ai_mailboxes.how_link_works":
          "Du logger inn som deg selv (f.eks. cs@airon.no) — ikke som den delte adressen. Delt postkasse (f.eks. post@airon.no) har vanligvis ikke eget passord. Bruk en konto som allerede kan åpne post@ i Outlook (full tilgang / delegat). Promang lagrer refresh-token for innloggingen; Graph henter/sender for adressen du registrerte på raden.",
        "microsoft.ai_mailboxes.mail_safety_dev_notice":
          "Med **Arkiver etter behandling** på flytter Promang behandlede meldinger til mappen **Archive** eller **Arkiv** (Graph), også i utvikling — bare når behandling kjøres med ekte handlinger (ikke simulering). Ellers leser vi innboks til visning. «Kjør behandling», planlagt jobb og test kan sende e-post (f.eks. videresending) via Graph — bruk «Simuler jobb» for å teste uten sending og uten flytting.",
        "microsoft.ai_mailboxes.linked_as": "Microsoft koblet som {{email}}",
        "microsoft.ai_mailboxes.not_linked": "Ikke koblet til Microsoft — koble til for å laste innboks og sende test.",
        "microsoft.ai_mailboxes.connect_microsoft": "Koble Microsoft",
        "microsoft.ai_mailboxes.disconnect_microsoft": "Koble fra Microsoft",
        "microsoft.ai_mailboxes.send_test": "Send test-e-post",
        "microsoft.ai_mailboxes.go_to_mailbox": "Gå til postkasse",
        "microsoft.ai_mailboxes.go_to_mailbox_hint":
          "Åpner Outlook på nett for denne adressen i ny fane (mapper: innboks, arkiv, osv.). Du må være innlogget i Microsoft i nettleseren med en konto som har tilgang til postkassen.",
        "microsoft.ai_mailboxes.go_to_mailbox_missing_email": "Ingen postadresse å åpne.",
        "microsoft.ai_mailboxes.multi_inbox_hint":
          "Du kan ha flere innbokser utvidet samtidig. Åpne en melding i Promang for å lese innhold og se behandlingslogg i faner.",
        "microsoft.ai_mailboxes.reader.title": "Melding (Promang)",
        "microsoft.ai_mailboxes.reader.close": "Lukk",
        "microsoft.ai_mailboxes.reader.tab_message": "Innhold",
        "microsoft.ai_mailboxes.reader.tab_reply_draft": "AI svarutkast",
        "microsoft.ai_mailboxes.reader.tab_logs": "Behandlingslogg",
        "microsoft.ai_mailboxes.reader.reply_draft_hint":
          "Redigerer utkastet i Outlook (HTML). Når du sender derfra, blir tråden under teksten din bevart.",
        "microsoft.ai_mailboxes.reader.reply_draft_load_failed": "Kunne ikke laste svarutkast.",
        "microsoft.ai_mailboxes.reader.reply_draft_saved": "Utkast lagret.",
        "microsoft.ai_mailboxes.reader.reply_draft_save": "Lagre utkast",
        "microsoft.ai_mailboxes.reader.reply_draft_saving": "Lagrar…",
        "microsoft.ai_mailboxes.reader.reply_draft_none": "Ingen AI svarutkast for denne meldinga.",
        "microsoft.ai_mailboxes.reader.field_from": "Fra",
        "microsoft.ai_mailboxes.reader.field_to": "Til",
        "microsoft.ai_mailboxes.reader.field_cc": "Kopi",
        "microsoft.ai_mailboxes.reader.field_date": "Mottatt",
        "microsoft.ai_mailboxes.reader.attachments_notice":
          "Meldingen har vedlegg. Filer vises ikke her — bruk Outlook på nett hvis du må laste ned.",
        "microsoft.ai_mailboxes.reader.body_iframe_title": "E-postinnhold",
        "microsoft.ai_mailboxes.reader.no_body": "Ingen brødtekst.",
        "microsoft.ai_mailboxes.reader.load_failed": "Kunne ikke laste melding.",
        "microsoft.ai_mailboxes.reader.inbox_only_hint":
          "Listen over viser bare innboks. For arkiv, søppelpost og andre mapper, bruk Outlook på nett (lenke under) ved behov.",
        "microsoft.ai_mailboxes.reader.folder_hint":
          "Du kan velge Arkiv, Sendt og andre mapper i postkasselisten over. Bruk Outlook på nett (lenke under) for full mappehåndtering ved behov.",
        "microsoft.ai_mailboxes.reader.open_in_owa": "Åpne postkasse i Outlook på nett…",
        "microsoft.ai_mailboxes.reader.open_short": "Åpne",
        "microsoft.ai_mailboxes.reader.open_tooltip":
          "Åpne i Promang: les e-post og se behandlingslogg (faner).",
        "microsoft.ai_mailboxes.show_inbox": "E-postmapper",
        "microsoft.ai_mailboxes.inbox_requires_link": "Koble Microsoft for denne adressen først.",
        "microsoft.ai_mailboxes.no_messages": "Ingen meldinger i denne mappen (eller mappen er tom).",
        "microsoft.ai_mailboxes.messages_failed": "Kunne ikke laste meldinger for denne mappen.",
        "microsoft.ai_mailboxes.process_folder_hint":
          "Velg meldinger under, og simuler eller kjør behandling. Den planlagte jobben behandler fortsatt bare innboksen med mindre det endres separat.",
        "microsoft.ai_mailboxes.folder.select_label": "Mappe",
        "microsoft.ai_mailboxes.folder.group_shortcuts": "Snarveier",
        "microsoft.ai_mailboxes.folder.group_tree": "Alle mapper",
        "microsoft.ai_mailboxes.folder.loading_tree": "Laster mappeliste…",
        "microsoft.ai_mailboxes.folder.folders_failed": "Kunne ikke laste mappeliste.",
        "microsoft.ai_mailboxes.folder.seg_inbox": "Innboks",
        "microsoft.ai_mailboxes.folder.seg_archive": "Arkiv",
        "microsoft.ai_mailboxes.folder.seg_sentitems": "Sendt",
        "microsoft.ai_mailboxes.folder.seg_deleteditems": "Slettet",
        "microsoft.ai_mailboxes.folder.seg_junkemail": "Søppelpost",
        "microsoft.ai_mailboxes.folder.seg_drafts": "Kladd",
        "microsoft.ai_mailboxes.folder.seg_outbox": "Utboks",
        "microsoft.ai_mailboxes.col.received": "Mottatt",
        "microsoft.ai_mailboxes.col.from": "Fra",
        "microsoft.ai_mailboxes.col.subject": "Emne",
        "microsoft.ai_mailboxes.microsoft_disconnected": "Microsoft er frakoblet for denne postkassen.",
        "microsoft.ai_mailboxes.microsoft_disconnect_failed": "Kunne ikke koble fra Microsoft.",
        "microsoft.ai_mailboxes.shared_test_ok": "Test-e-post er sendt.",
        "microsoft.ai_mailboxes.shared_test_failed": "Kunne ikke sende test-e-post.",
        "microsoft.ai_mailboxes.email_label": "E-postadresse",
        "microsoft.ai_mailboxes.email_placeholder": "post@firma.no",
        "microsoft.ai_mailboxes.add": "Legg til",
        "microsoft.ai_mailboxes.empty": "Ingen adresser er lagt til ennå.",
        "microsoft.ai_mailboxes.remove": "Fjern",
        "microsoft.ai_mailboxes.added": "Adressen er lagt til.",
        "microsoft.ai_mailboxes.add_failed": "Kunne ikke legge til adressen.",
        "microsoft.ai_mailboxes.removed": "Adressen er fjernet.",
        "microsoft.ai_mailboxes.remove_failed": "Kunne ikke fjerne adressen.",
        "microsoft.ai_mailboxes.load_failed": "Kunne ikke laste adresser.",
        "microsoft.ai_mailboxes.email_required": "Skriv inn en e-postadresse.",
        "microsoft.ai_mailboxes.settings.toggle": "Innstillinger",
        "microsoft.ai_mailboxes.settings.heading": "Behandling av e-post",
        "microsoft.ai_mailboxes.settings.intro":
          "Disse valgene gjelder kun denne postkassen. Innbokslisten bruker sortering fra Graph med én gang.",
        "microsoft.ai_mailboxes.settings.processing_job_title": "Jobb: behandle innboks",
        "microsoft.ai_mailboxes.settings.processing_job_hint":
          "Når «På» er valgt og lagret, kan planlagt jobb (f.eks. Heroku Scheduler + `rake microsoft:enqueue_ai_mailbox_processing`) behandle opptil 50 siste meldinger og kjøre regler (inkl. videresending som tekstvarsel). Test uten risiko med «Simuler jobb» i innbokslisten.",
        "microsoft.ai_mailboxes.settings.processing_job_off": "Av",
        "microsoft.ai_mailboxes.settings.processing_job_on": "På",
        "microsoft.ai_mailboxes.settings.mail_sort": "Sortering i innboks",
        "microsoft.ai_mailboxes.settings.sort_received_desc": "Nyeste først",
        "microsoft.ai_mailboxes.settings.sort_received_asc": "Eldste først",
        "microsoft.ai_mailboxes.settings.sort_subject_asc": "Emne A–Å",
        "microsoft.ai_mailboxes.settings.auto_create_case": "Opprett sak for nye e-poster (når aktivert i Promang)",
        "microsoft.ai_mailboxes.settings.auto_create_case_hint":
          "Når funksjonen rulleres ut, brukes unntakene under for å unngå saker fra reklame, nyhetsbrev osv.",
        "microsoft.ai_mailboxes.settings.skip_promotional_hint": "Marker e-poster som sannsynlig reklame/nyhetsbrev som ikke skal bli sak (anbefalt)",
        "microsoft.ai_mailboxes.settings.ignore_subject_keywords": "Ikke opprett sak hvis emne inneholder (komma eller ny linje)",
        "microsoft.ai_mailboxes.settings.ignore_subject_placeholder": "f.eks. reklame, unsubscribe, newsletter",
        "microsoft.ai_mailboxes.settings.ignore_from_domains": "Ikke opprett sak hvis avsenderdomene er (komma eller ny linje)",
        "microsoft.ai_mailboxes.settings.ignore_domains_placeholder": "f.eks. mailchimp.com, sendgrid.net",
        "microsoft.ai_mailboxes.settings.archive_after_processing": "Arkiver etter behandling",
        "microsoft.ai_mailboxes.settings.archive_hint":
          "Flytter behandlet e-post fra innboks til **Archive** eller **Arkiv** via Microsoft Graph etter vellykket behandling (manuell regel eller AI). Gjelder også utvikling — krever at du kjører behandling med ekte handlinger, ikke «Simuler jobb».",
        "microsoft.ai_mailboxes.settings.auto_reply_enabled": "Automatisk svar etter ny sak (kundehenvendelse)",
        "microsoft.ai_mailboxes.settings.auto_reply_body_ph":
          "HTML-innhold (valgfritt). Plassholdere: %{case_number}, %{sak}. Tomt felt gir standardtekst med saksnummer.",
        "microsoft.ai_mailboxes.settings.auto_reply_note":
          "Når autosvar er på, svarer Promang i samme e-posttråd (Graph reply), ikke som ny melding. Emnelinjen på svaret får [SAK-<nummer>]. Signatur HTML legges ved om satt.",
        "microsoft.ai_mailboxes.settings.signature_html": "Signatur (HTML)",
        "microsoft.ai_mailboxes.settings.signature_ph": "<p>Med vennlig hilsen<br/>…</p>",
        "microsoft.ai_mailboxes.settings.rules_heading": "Regler",
        "microsoft.ai_mailboxes.settings.rules_intro":
          "Match på emne eller e-postadresse, og velg handling: Arkiver eller Videresendt (til valgt adresse). Reglene kjøres før AI-ruting og sak-oppretting. Eldre match-typer (inneholder / domene) er fortsatt tilgjengelige.",
        "microsoft.ai_mailboxes.settings.rules_forward_hint":
          "Videresendt sender meldingen til den angitte adressen (samme mønster som «Videresend ukjent post»).",
        "microsoft.ai_mailboxes.settings.add_rule": "Legg til regel",
        "microsoft.ai_mailboxes.settings.no_rules": "Ingen egendefinerte regler ennå.",
        "microsoft.ai_mailboxes.settings.rule_name": "Navn",
        "microsoft.ai_mailboxes.settings.rule_match": "Match",
        "microsoft.ai_mailboxes.settings.rule_value": "Verdi",
        "microsoft.ai_mailboxes.settings.rule_action": "Handling",
        "microsoft.ai_mailboxes.settings.rule_on": "På",
        "microsoft.ai_mailboxes.settings.remove_rule": "Fjern regel",
        "microsoft.ai_mailboxes.settings.match_subject": "Emne (inneholder)",
        "microsoft.ai_mailboxes.settings.match_email": "E-post (fra-adresse)",
        "microsoft.ai_mailboxes.settings.match_subject_contains": "Emne inneholder",
        "microsoft.ai_mailboxes.settings.match_subject_equals": "Emne er lik (eksakt)",
        "microsoft.ai_mailboxes.settings.match_from_domain": "Fra-domene",
        "microsoft.ai_mailboxes.settings.match_from_contains": "Fra-adresse inneholder",
        "microsoft.ai_mailboxes.settings.action_archive": "Arkiver",
        "microsoft.ai_mailboxes.settings.action_skip_case": "Ikke opprett sak",
        "microsoft.ai_mailboxes.settings.action_forward_to": "Videresendt",
        "microsoft.ai_mailboxes.settings.rule_forward_to_email": "Videresend til (e-post)",
        "microsoft.ai_mailboxes.settings.rule_forward_to_placeholder": "f.eks. 123@airon.no",
        "microsoft.ai_mailboxes.settings.save": "Lagre innstillinger",
        "microsoft.ai_mailboxes.settings.saved": "Innstillinger lagret.",
        "microsoft.ai_mailboxes.settings.save_failed": "Kunne ikke lagre innstillinger.",
        "microsoft.ai_mailboxes.settings.ai_routing_heading": "AI-ruting",
        "microsoft.ai_mailboxes.settings.ai_routing_hint":
          "Velg hva som skal skje per type e-post. Innstillingene lagres som JSON i bakgrunnen. Når ruting er på, brukes OpenAI/Grok (miljøvariabler) til klassifisering om tilgjengelig — ellers heuristikk. Manuelle regler overstyrrer AI-handlinger.",
        "microsoft.ai_mailboxes.settings.ai_routing_invalid_json": "Ugyldig JSON i AI-ruting.",
        "microsoft.ai_mailboxes.settings.ai_routing_raw_json": "Rediger som rå JSON (avansert)",
        "microsoft.ai_mailboxes.settings.ai_routing_raw_json_hint":
          "Skjema og JSON er det samme. Slår du av rå JSON igjen, leses teksten inn i skjemaet (må være gyldig JSON).",
        "microsoft.ai_mailboxes.ai_routing.master_enable": "Aktiver AI-ruting og automatiske handlinger",
        "microsoft.ai_mailboxes.ai_routing.master_hint":
          "Når av: meldinger klassifiseres fortsatt for visning, men ingen automatiske AI-handlinger kjøres.",
        "microsoft.ai_mailboxes.ai_routing.reply_draft_title": "AI-utkast for svar (Outlook)",
        "microsoft.ai_mailboxes.ai_routing.reply_draft_desc":
          "Etter vellykket kundehenvendelse eller sakssvar opprettes et svarutkast i postkassen din i Microsoft. Du sender selv når du er fornøyd.",
        "microsoft.ai_mailboxes.ai_routing.reply_draft_enable": "Opprett AI-generert svarutkast ved behandling",
        "microsoft.ai_mailboxes.ai_routing.reply_draft_requires_ai":
          "Slå på «Aktiver AI-ruting» over for å bruke denne funksjonen (klassifisering og sak må kjøre først).",
        "microsoft.ai_mailboxes.ai_routing.provider_label": "Klassifiseringsmotor",
        "microsoft.ai_mailboxes.ai_routing.provider_chatgpt": "ChatGPT (OpenAI)",
        "microsoft.ai_mailboxes.ai_routing.provider_grok": "Grok (xAI)",
        "microsoft.ai_mailboxes.ai_routing.model_label": "Modell (valgfritt)",
        "microsoft.ai_mailboxes.ai_routing.model_placeholder": "f.eks. gpt-4o-mini",
        "microsoft.ai_mailboxes.ai_routing.model_hint": "Tom = standard fra server/miljø.",
        "microsoft.ai_mailboxes.ai_routing.action_label": "Handling",
        "microsoft.ai_mailboxes.ai_routing.action_none": "Ingenting (kun klassifiser)",
        "microsoft.ai_mailboxes.ai_routing.action_forward": "Videresend til e-post",
        "microsoft.ai_mailboxes.ai_routing.action_move_archive": "Flytt til arkivmappe",
        "microsoft.ai_mailboxes.ai_routing.action_move_junk": "Flytt til søppelpost",
        "microsoft.ai_mailboxes.ai_routing.action_delete_graph": "Slett i Microsoft (Graph)",
        "microsoft.ai_mailboxes.ai_routing.action_move_folder": "Flytt til valgt mappe",
        "microsoft.ai_mailboxes.ai_routing.action_create_case": "Opprett sak i Promang",
        "microsoft.ai_mailboxes.ai_routing.action_append_case_note": "Legg inn som sakslinje (CAS / saksnummer)",
        "microsoft.ai_mailboxes.ai_routing.action_customer_communication": "Registrer som kundekommunikasjon på sak",
        "microsoft.ai_mailboxes.ai_routing.action_reply_draft_only": "Kun registrer kommunikasjon (og AI svarutkast om aktivert)",
        "microsoft.ai_mailboxes.ai_routing.forward_to_label": "Videresend til (e-post)",
        "microsoft.ai_mailboxes.ai_routing.folder_optional_label": "Mappenavn (valgfritt)",
        "microsoft.ai_mailboxes.ai_routing.folder_optional_hint": "Tomt bruker standard (Archive / Junk Email).",
        "microsoft.ai_mailboxes.ai_routing.folder_placeholder_archive": "Archive",
        "microsoft.ai_mailboxes.ai_routing.folder_placeholder_junk": "Junk Email",
        "microsoft.ai_mailboxes.ai_routing.folder_name_label": "Mappenavn i postkassen",
        "microsoft.ai_mailboxes.ai_routing.folder_placeholder_order": "Ordre",
        "microsoft.ai_mailboxes.ai_routing.folder_order_hint": "Mappen må finnes i Microsoft-postkassen (visningsnavn).",
        "microsoft.ai_mailboxes.ai_routing.cat_promotional_title": "Reklame / nyhetsbrev",
        "microsoft.ai_mailboxes.ai_routing.cat_promotional_desc": "Typisk masseutsendt innhold.",
        "microsoft.ai_mailboxes.ai_routing.cat_order_title": "Ordrebekreftelse",
        "microsoft.ai_mailboxes.ai_routing.cat_order_desc": "Bestillinger og ordredokumenter.",
        "microsoft.ai_mailboxes.ai_routing.cat_inquiry_title": "Ny kundehenvendelse",
        "microsoft.ai_mailboxes.ai_routing.cat_inquiry_desc": "Generell forespørsel uten eksisterende saksnummer i tråden.",
        "microsoft.ai_mailboxes.ai_routing.cat_inquiry_auto_reply_note":
          "Autosvar og signatur stilles inn lenger opp på siden (seksjonene over).",
        "microsoft.ai_mailboxes.ai_routing.cat_supplier_cas_title": "Leverandør (CAS-referanse)",
        "microsoft.ai_mailboxes.ai_routing.cat_supplier_cas_desc":
          "Matcher sak via CAS-token eller Promang saksnummer i innhold. Anbefalt å fylle «ved ingen treff».",
        "microsoft.ai_mailboxes.ai_routing.forward_unmatched_label": "Ved ingen treff — videresend til (e-post)",
        "microsoft.ai_mailboxes.ai_routing.forward_unmatched_hint": "Anbefales så melding ikke blir liggende uten sak.",
        "microsoft.ai_mailboxes.ai_routing.cas_reference_label": "Fast CAS-referanse (valgfritt)",
        "microsoft.ai_mailboxes.ai_routing.cas_reference_hint": "Bare om referansen ikke står i e-posten.",
        "microsoft.ai_mailboxes.ai_routing.case_number_fallback_label": "Fast saksnummer (valgfritt)",
        "microsoft.ai_mailboxes.ai_routing.case_number_fallback_hint": "Talldel av saken, f.eks. 1234, hvis ikke funnet i tekst.",
        "microsoft.ai_mailboxes.ai_routing.cat_case_reply_title": "Svar på eksisterende sak",
        "microsoft.ai_mailboxes.ai_routing.cat_case_reply_desc": "E-post som ser ut til å gjelde en åpen sak (SAK-nummer i tråden).",
        "microsoft.ai_mailboxes.ai_routing.cat_project_title": "Prosjektkorrespondanse",
        "microsoft.ai_mailboxes.ai_routing.cat_project_desc": "E-post fra kjent kunde/part om fremdrift, avvik, byggeledelse osv. — ikke ny generell kundehenvendelse.",
        "microsoft.ai_mailboxes.ai_routing.cat_project_reply_draft_note": "Krever at avsender matcher en kunde i Promang. Aktiver «AI svarutkast» over for utkast i Outlook.",
        "microsoft.ai_mailboxes.ai_routing.json_preview_toggle": "Vis JSON som lagres (kun visning)",
        "microsoft.ai_mailboxes.process_inbox_hint":
          "Velg én eller flere meldinger og kjør behandling (simulering sender ingen e-post; «Kjør» sender videresending når en regel treffer).",
        "microsoft.ai_mailboxes.process_select_all": "Velg alle",
        "microsoft.ai_mailboxes.process_clear_selection": "Fjern valg",
        "microsoft.ai_mailboxes.process_select_column": "Velg",
        "microsoft.ai_mailboxes.process_select_row": "Velg melding",
        "microsoft.ai_mailboxes.process_simulate": "Simuler jobb",
        "microsoft.ai_mailboxes.process_run": "Kjør behandling",
        "microsoft.ai_mailboxes.process_need_selection": "Velg minst én melding i listen.",
        "microsoft.ai_mailboxes.process_run_confirm":
          "Dette kan sende ekte e-post (videresending) for treffende regler. Fortsette?",
        "microsoft.ai_mailboxes.process_ok_simulated":
          "Simulering fullført for {{count}} melding(er). Videresend-regler som ville trigget: {{sim}}. «Ikke sak»-treff: {{skips}}.",
        "microsoft.ai_mailboxes.process_ok_executed":
          "Behandling fullført for {{count}} melding(er). Videresending sendt: {{sent}}. «Ikke sak»-treff: {{skips}}.",
        "microsoft.ai_mailboxes.process_failed": "Kunne ikke behandle valgte meldinger.",
        "microsoft.ai_mailboxes.processing_log.open_tooltip": "Vis behandlingslogg (utvikling)",
        "microsoft.ai_mailboxes.processing_log.title": "Behandlingslogg",
        "microsoft.ai_mailboxes.processing_log.close": "Lukk",
        "microsoft.ai_mailboxes.processing_log.load_failed": "Kunne ikke laste behandlingslogg.",
        "microsoft.ai_mailboxes.processing_log.empty":
          "Ingen lagrede kjøringer for denne meldingen ennå. Bruk Simuler / Kjør behandling, eller vent på planlagt jobb.",
        "microsoft.ai_mailboxes.processing_log.dry_run": "Simulering",
        "microsoft.ai_mailboxes.processing_log.live_run": "Ekte kjøring",
        "microsoft.ai_mailboxes.processing_log.failed": "Feilet",
        "microsoft.ai_mailboxes.processing_log.ok": "OK",
        "microsoft.ai_mailboxes.processing_log.ai_category": "Klassifisering",
        "microsoft.ai_mailboxes.processing_log.confidence": "sikkerhet",
        "microsoft.ai_mailboxes.processing_log.actions": "Handlinger",
        "microsoft.ai_mailboxes.processing_log.raw_json": "Rå data (JSON)",
        "microsoft.ai_mailboxes.processing_log.col_dev": "Logg",
        "microsoft.ai_mailboxes.processing_log.sum.ai_classification":
          "AI: {{category}} ({{source}}, sikkerhet {{confidence}})",
        "microsoft.ai_mailboxes.processing_log.sum.forward_dry": "Videresending (simulert) → {{to}}",
        "microsoft.ai_mailboxes.processing_log.sum.forward_sent": "Videresendt → {{to}}",
        "microsoft.ai_mailboxes.processing_log.sum.forward_failed": "Videresending feilet → {{to}}: {{error}}",
        "microsoft.ai_mailboxes.processing_log.sum.move_dry": "Flytt (simulert){{target}}",
        "microsoft.ai_mailboxes.processing_log.sum.move_ok": "Flyttet → {{folder}}",
        "microsoft.ai_mailboxes.processing_log.sum.move_failed": "Flytt feilet: {{error}}",
        "microsoft.ai_mailboxes.processing_log.sum.skip_case": "Regel: ikke opprett sak",
        "microsoft.ai_mailboxes.processing_log.sum.skip_case_unused": "skip_case (ikke brukt)",
        "microsoft.ai_mailboxes.processing_log.sum.archive_dry": "Regel: arkiver (simulert)",
        "microsoft.ai_mailboxes.processing_log.sum.archive_ok": "Regel: arkivert{{folder}}",
        "microsoft.ai_mailboxes.processing_log.sum.archive_failed": "Regel: arkivering feilet: {{error}}",
        "microsoft.ai_mailboxes.processing_log.sum.ai_routing_skipped": "AI-ruting hoppet over: {{reason}}",
        "microsoft.ai_mailboxes.processing_log.sum.unknown_fallback_sent": "Ukjent post videresendt → {{to}}",
        "microsoft.ai_mailboxes.processing_log.sum.unknown_fallback_dry": "Ukjent post videresending (simulert) → {{to}}",
        "microsoft.ai_mailboxes.processing_log.sum.unknown_fallback_failed": "Ukjent post: videresending feilet ({{error}})",
        "microsoft.ai_mailboxes.processing_log.sum.system_copy_forward": "Promang-kopi videresendt → {{to}}",
        "microsoft.ai_mailboxes.processing_log.sum.system_copy_archive": "Promang-kopi arkivert{{folder}}",
        "microsoft.ai_mailboxes.processing_log.sum.system_copy_none": "Promang-kopi: ingen handling (ikke ny sak)",
        "microsoft.ai_mailboxes.processing_log.sum.system_copy_already": "Promang-kopi: allerede behandlet",
        "microsoft.ai_mailboxes.processing_log.sum.generic_error": "{{type}}: {{error}}",
        "microsoft.ai_mailboxes.processing_log.sum.generic_not_applied": "{{type}}: ikke utført",
        "subscription.ai_usage.loading": "Laster…",
        "subscription.ai_usage.title": "AI-bruk og estimat",
        "subscription.ai_usage.subtitle":
          "Tokenforbruk, veiledende kostnad og estimert spart tid for selskapet (bare vellykkede AI-kall).",
        "subscription.ai_usage.period.this_month": "Denne måneden",
        "subscription.ai_usage.period.this_year": "Dette året",
        "subscription.ai_usage.period.last_30_days": "Siste 30 dager",
        "subscription.ai_usage.period.last_12_months": "Siste 12 måneder",
        "subscription.ai_usage.load_failed": "Kunne ikke hente AI-bruksstatistikk.",
        "subscription.ai_usage.forbidden": "Du har ikke tilgang til AI-bruk for dette selskapet.",
        "subscription.ai_usage.empty": "Ingen AI-bruk registrert i denne perioden.",
        "subscription.ai_usage.tokens": "Token (totalt)",
        "subscription.ai_usage.calls_ok": "Vellykkede kall",
        "subscription.ai_usage.calls_fail": "Feilede kall",
        "subscription.ai_usage.estimated_cost": "Estimert kostnad (NOK)",
        "subscription.ai_usage.cost_hint":
          "Internt estimat: {{rate}} NOK per 1M token. Ikke faktura — faktisk pris fra leverandør kan avvike.",
        "subscription.ai_usage.time_saved": "Estimert spart tid",
        "subscription.ai_usage.time_hint":
          "Omtrentlige manuelle minutter per vellykket kall, etter funksjonstype. Bare for oversikt.",
        "subscription.ai_usage.minutes_only": "{{minutes}} min",
        "subscription.ai_usage.hours_minutes": "{{hours}} t {{minutes}} min",
        "subscription.ai_usage.by_feature": "Per funksjon",
        "subscription.ai_usage.col_feature": "Funksjon",
        "subscription.ai_usage.col_calls": "Kall",
        "subscription.ai_usage.col_tokens": "Token",
        "subscription.ai_usage.col_cost": "Est. NOK",
        "subscription.ai_usage.col_time": "Est. spart tid",
        "subscription.ai_usage.monthly_overview": "Per måned (i perioden)",
        "subscription.ai_usage.feature.microsoft_ai_mailbox_classify": "AI-innboks — klassifisering",
        "subscription.ai_usage.feature.microsoft_ai_mailbox_case_title": "AI-innboks — sakstittel",
        "subscription.ai_usage.feature.service_report_invoice_description_generate":
          "Servicerapport — fakturapunkt",
        "subscription.ai_usage.feature.service_report_invoice_description_format_report":
          "Servicerapport — HTML-format",
        "subscription.ai_usage.feature.ai_generator_todo": "Oppgaver — AI-assistent",
        "subscription.ai_usage.feature.ai_generator_hse_document": "HMS/KS — AI-felt i dokument",
        "subscription.ai_usage.feature.ai_generator_meeting_minutes": "Møtereferat — AI-agenda",
        "subscription.ai_usage.feature.other": "{{feature}}",

        "Cases": "Saker",
        "Projects": "Prosjekter",
        "Customers": "Kunder",
        "Customer List": "Kundeliste",
        "Tasks": "Oppgaver",
        "All modules": "Alle moduler",
        "Label administration": "Etikettadministrasjon",
        "Add label": "Legg til etikett",
        "Scope module": "Modul",
        "Sort order": "Sortering",
        "Statistics": "Statistikk",
        "Cases by label": "Saker per etikett",
        "No labels with cases yet": "Ingen etiketter med saker ennå",
        "No labels defined": "Ingen etiketter definert",
        "Labels": "Etiketter",
        "Are you sure you want to delete this label?":
          "Er du sikker på at du vil slette denne etiketten?",
        "todo.pageTitle": "Oppgaver",
        "todo.sidebarTitle": "Todo",
        "todo.settingsTitle": "Oppgaveinnstillinger",
        "todo.backToTasks": "Tilbake til oppgaver",
        "todo.settingsTemplatesTitle": "Mal for delte firmoppgaver",
        "todo.settingsTemplatesHelp": "Opprett gjentagende oppgaver for stillinger eller utvalgte brukere. Når én mottaker markerer oppgaven som ferdig, avsluttes den for alle. Valgfri kobling til HMS/KS-dokument for rutiner.",
        "todo.settingsTemplatesHelpCompact": "Opprett maler med tittel og HMS-dokument. Utvid for stillinger, mottakere og gjentakelse.",
        "todo.settingsManagePositions": "Administrer firmastillinger",
        "todo.settingsTitlePlaceholder": "F.eks. Gjennomgå vernerunde",
        "todo.settingsAddDescription": "Legg til beskrivelse",
        "todo.settingsShowDetails": "Vis detaljer",
        "todo.settingsHideDetails": "Skjul detaljer",
        "todo.settingsListHint": "Klikk en mal for å redigere. Sortert etter kategori og stilling.",
        "todo.settingsUntitled": "Uten tittel",
        "todo.settingsNoSummary": "Ingen detaljer satt ennå",
        "todo.settingsEditTemplate": "Rediger mal",
        "todo.settingsNewTemplate": "Ny mal",
        "todo.settingsCompactSummary": "Oppsummering",
        "todo.settingsNotSet": "Ikke satt",
        "todo.settingsAssigneeCount": "{{count}} mottaker(e)",
        "todo.settingsDueOffsetSummary": "+{{days}} dager forfall",
        "todo.settingsNoPositionsHint": "Ingen firmastillinger ennå. Legg dem til under Firmainnstillinger.",
        "todo.settingsDueOffsetDays": "Forfall (dager etter opprettelse)",
        "todo.settingsWorkingPositions": "Stillinger",
        "todo.settingsAssignees": "Mottakere",
        "todo.settingsAddAssignees": "Legg til brukere",
        "todo.settingsHseDocument": "HMS/KS-dokument (valgfritt)",
        "todo.settingsTemplateActive": "Mal aktiv",
        "todo.settingsTemplateInactive": "Inaktiv",
        "todo.settingsTemplateInactiveHint": "Denne malen oppretter ikke nye oppgaver lenger.",
        "todo.settingsSpawnNow": "Opprett oppgaver nå",
        "todo.settingsSpawning": "Oppretter…",
        "todo.settingsRemoveTemplate": "Fjern mal",
        "todo.settingsAddTemplate": "Legg til mal",
        "todo.settingsSave": "Lagre innstillinger",
        "todo.settingsSaving": "Lagrer…",
        "todo.settingsSaved": "Oppgaveinnstillinger lagret",
        "todo.settingsLoadError": "Kunne ikke laste oppgaveinnstillinger",
        "todo.settingsSaveError": "Kunne ikke lagre oppgaveinnstillinger",
        "todo.confirmClose.title": "Lagre endringer?",
        "todo.confirmClose.text": "Du har ulagrede endringer. Vil du lagre før du lukker?",
        "todo.confirmClose.keepEditing": "Fortsett redigering",
        "todo.confirmClose.closeWithoutSaving": "Lukk uten å lagre",
        "todo.confirmClose.saveAndClose": "Lagre og lukk",
        "todo.settingsSpawnSuccess": "Delte oppgaver opprettet",
        "todo.settingsSpawnError": "Kunne ikke opprette oppgaver fra mal",
        "todo.sharedTaskLabel": "Delt firmoppgave",
        "todo.sharedTaskBadge": "Delt",
        "todo.sharedTaskEnabled": "Delt oppgave",
        "todo.sharedTaskDisabled": "Personlig oppgave",
        "todo.sharedTaskActiveBadge": "Delt modus på",
        "todo.sharedTaskActiveHint": "Delt modus er aktivert. Oppgaven tildeles valgte brukere og lagres som firmamal.",
        "todo.sharedFromTemplateInfo": "Delt firmoppgave fra mal. Status settes automatisk og kan ikke endres manuelt.",
        "todo.sharedFromAssigneesInfo": "Delt firmoppgave fordi oppgaven har flere mottakere (minst to). Status settes automatisk.",
        "todo.taskAssigneesLabel": "Mottakere",
        "todo.taskAssigneesHint": "Legg til ansatte som skal se oppgaven i sin inbox. Med to eller flere mottakere blir oppgaven automatisk delt firmoppgave (admin).",
        "todo.propertyInfoAria": "Mer informasjon om {{label}}",
        "todo.createAddAssignees": "Legg til mottakere",
        "todo.moduleTagsLabel": "Moduler",
        "todo.moduleTagsAdd": "Legg til modul",
        "todo.systemLinksLabel": "Systemkoblinger",
        "todo.mobileNav.ariaLabel": "Oppgave-meny",
        "todo.mobileNav.todo": "Todo",
        "todo.mobileNav.today": "Dagens",
        "todo.mobileNav.priority": "Prioritet",
        "todo.mobileNav.newTask": "Ny oppgave",
        "todo.mobileNav.mine": "Mine",
        "todo.mobileNav.journal": "Journal",
        "todo.mobileNav.settings": "Innstillinger",
        "todo.sharedTaskDuplicateError": "En tilsvarende delt firmoppgave finnes allerede. Endre tittel, HMS-dokument eller mottakere.",
        "todo.sharedTaskDeleteAdminOnly": "Kun firmaadministrator kan slette delte firmoppgaver.",
        "todo.sharedCompletionAny": "Ferdig når én mottaker fullfører",
        "todo.sharedAssigneeCount": "{{count}} mottakere",
        "todo.settingsPositionsTitle": "Stillinger og mottakere",
        "todo.settingsPositionsHelp": "Lagre stillinger (f.eks. Administrator) og velg én bruker som skal få alle oppgaver for den stillingen. Uten valgt bruker matches alle ansatte med stillingen.",
        "todo.settingsPositionNamePlaceholder": "Stillingsnavn, f.eks. Administrator",
        "todo.settingsCategoryPlaceholder": "Kategori, f.eks. HMS",
        "todo.settingsAddPosition": "Lagre stilling",
        "todo.settingsPositionExists": "Stillingen finnes allerede",
        "todo.settingsRouteAllTasks": "Alle oppgaver → velg bruker",
        "todo.settingsRouteToUser": "Alle oppgaver → {{name}}",
        "todo.settingsClearRoute": "Fjern routing",
        "todo.settingsCategory": "Kategori",
        "todo.settingsCopyCategoryPositions": "Hent stillinger fra kategori",
        "todo.settingsCopyCategoryPositionsHint": "Velg kategori…",
        "todo.employeePositionsTitle": "Firmastillinger",
        "todo.employeePositionsHelp": "Administrer firmastillinger under Firmainnstillinger. De brukes i oppgavemaler og arbeidsavtaler.",
        "todo.employeePositionName": "Stilling",
        "todo.employeePositionAdd": "Legg til stilling",
        "todo.employeePositionRemove": "Fjern stilling",
        "todo.employeePositionCount": "{{count}} ansatte med stillingen",
        "todo.tabTasks": "Oppgaver",
        "todo.filterTodayPlan": "Dagens plan",
        "todo.loadingMoreTodos": "Laster inn flere oppgaver…",
        "todo.loadMoreError": "Kunne ikke laste flere oppgaver.",
        "todo.filterAll": "Alle",
        "todo.filterActive": "Aktive",
        "todo.filterFinished": "Ferdige",
        "todo.filterMine": "Mine oppgaver",
        "todo.newTask": "Ny oppgave",
        "todo.emptyState": "Ingen oppgaver ennå. Trykk",
        "todo.loadError": "Kunne ikke laste oppgaver.",
        "todo.loadingTasks": "Laster oppgaver…",
        "todo.groupBy": "Grupper etter",
        "todo.taskCountOne": "oppgave",
        "todo.taskCountOther": "oppgaver",
        "todo.due": "Forfall",
        "todo.todayPlanBadge": "Dagens plan",
        "todo.taskDetails": "Oppgavedetaljer",
        "todo.createTitle": "Ny oppgave",
        "todo.createTitlePlaceholder": "Tittel",
        "todo.titleMaxLength": "Maks {{max}} tegn (2 linjer i listen)",
        "todo.createSubmit": "Opprett oppgave",
        "todo.createSubmitHint": "for å opprette",
        "todo.descriptionLabel": "Beskrivelse",
        "todo.addDescription": "Legg til beskrivelse",
        "todo.descriptionAdded": "Beskrivelse lagt til",
        "todo.hideDescription": "Skjul",
        "todo.descriptionPlaceholder": "Legg til beskrivelse…",
        "todo.propertiesLabel": "Egenskaper",
        "todo.statusLabel": "Status",
        "todo.priorityLabel": "Prioritet",
        "todo.moduleLabel": "Modul",
        "todo.moduleKind.project": "Prosjekt",
        "todo.moduleKind.customer": "Kunde",
        "todo.moduleKind.tag": "Etikett",
        "todo.moduleKind.shared": "Delt",
        "todo.peopleLabel": "Personer",
        "todo.linksLabel": "Koblinger",
        "todo.statusTimeline": "Status-tidslinje",
        "todo.activityLabel": "Aktivitet",
        "todo.deleteTask": "Slett oppgave",
        "todo.priorityUrgent": "Haster",
        "todo.priorityHigh": "Høy",
        "todo.priorityMed": "Medium",
        "todo.priorityLow": "Lav",
        "todo.statusDoing": "Pågår",
        "todo.statusTodo": "Skal gjøres",
        "todo.statusDone": "Ferdig",
        "todo.reopen": "Gjenåpne",
        "todo.markDone": "Marker som ferdig",
        "todo.setDate": "Velg dato",
        "todo.remindMe": "Påminn meg",
        "todo.toggleOn": "På",
        "todo.toggleOff": "Av",
        "todo.untitledTask": "Oppgave uten tittel",
        "todo.hasDescription": "Har beskrivelse",
        "todo.hasReminder": "Har påminnelse",
        "todo.lockedAbsence": "Oppgaven er knyttet til fravær som må godkjennes eller avslås først.",
        "todo.lockedItemList": "Denne varelisteoppgaven må fullføres i varehåndtering.",
        "todo.customerLink": "Kunde",
        "todo.projectLink": "Prosjekt",
        "todo.absenceLink": "Fravær",
        "todo.itemListLink": "Vareliste",
        "todo.activityWhoUser": "Bruker",
        "todo.activityEmpty": "Ingen aktivitet ennå.",
        "todo.activityCreated": "opprettet oppgaven",
        "todo.activityFinished": "fullførte oppgaven",
        "todo.activityUpdated": "oppdaterte oppgaven",
        "todo.toastCreated": "Oppgave opprettet",
        "todo.toastCreateFailed": "Kunne ikke opprette oppgave",
        "todo.toastUpdateFailed": "Kunne ikke lagre endringer",
        "todo.toastDeleted": "Oppgave slettet",
        "todo.toastDeleteFailed": "Kunne ikke slette oppgave",
        "todo.toastStatusFailed": "Kunne ikke oppdatere status",
        "todo.nextDueTitle": "Oppgaven er forsinket",
        "todo.nextDueHint": "Neste frist regnes fra i dag, ikke fra den gamle forfalte datoen. Juster datoen om du vil.",
        "todo.nextDueLabel": "Neste frist",
        "todo.nextDueConfirm": "Fullfør og sett frist",
        "todo.confirmDelete": "Slette denne oppgaven?",
        "todo.dateToday": "I dag",
        "todo.dateTomorrow": "I morgen",
        "todo.dateNextWeek": "Neste uke",
        "todo.dateInThreeDays": "Om 3 dager",
        "todo.reminderInOneHour": "Om 1 time",
        "todo.reminderThisEvening": "I kveld",
        "todo.reminderTomorrowMorning": "I morgen tidlig",
        "todo.reminderNextWeekMorning": "Neste uke (man 09:00)",
        "todo.dateCustom": "Egendefinert",
        "todo.clear": "Fjern",
        "todo.dateTimeToday": "I dag, {{time}}",
        "todo.dateTimeDaysAgo": "for {{count}} d siden",
        "todo.dueDate": "Forfallsdato",
        "todo.reminder": "Påminnelse",
        "todo.onTodayPlan": "På dagens plan",
        "todo.recurrence": "Gjentakelse ved fullføring",
        "todo.recurrenceNone": "Ingen",
        "todo.recurrenceDaily": "Daglig",
        "todo.recurrenceWeekdays": "Hverdager",
        "todo.recurrenceWeekly": "Ukentlig",
        "todo.recurrenceMonthly": "Månedlig",
        "todo.estimatedHours": "Estimerte timer",
        "todo.labels": "Etiketter",
        "todo.aiAssistant": "AI-assistent",
        "todo.hoursAvailable": "Timer til rådighet i dag (for dagsplan)",
        "todo.aiSuggestions": "Forslag",
        "todo.aiEstimate": "Tidsestimat",
        "todo.aiPlan": "Dagsplan",
        "todo.aiResultTitle": "AI-resultat",
        "todo.aiLoading": "Genererer…",
        "todo.aiError": "Kunne ikke hente forslag fra AI.",
        "todo.hseDocumentTaskManualFinish":
          "HMS/KS-dokumentoppgaver fullføres ved å bekrefte at dokumentet er lest og forstått.",
        "todo.hseDocumentTaskComplete":
          "Fullfør her for å bekrefte at du har lest og forstått dokumentet.",
        "todo.hseDocumentTaskCannotReopen":
          "HMS/KS-dokumentoppgaver kan ikke gjenåpnes fra oppgavelisten.",
        "todo.hseDocumentOpenLink": "Åpne HMS/KS-dokument",
        "hse.document.acknowledge_read": "Jeg bekrefter at jeg har lest og forstått",
        "hse.document.acknowledge_read_submitting": "Registrerer…",
        "hse.document.acknowledge_read_success": "Registrert som lest/forstått",
        "hse.document.acknowledge_read_error": "Kunne ikke registrere lest/forstått",
        "hse.document.acknowledge_read_hint":
          "Når du har gått gjennom innholdet, bekreft her. Oppgaven i oppgavelisten ferdigstilles automatisk.",
        "hse.document.acknowledge_read_done": "Du er registrert som å ha lest og forstått denne versjonen.",
        "hse.document.approval_stuck_retry_hint":
          "Godkjenningen ser ut til å ha stoppet før versjonen ble publisert. Trykk «Godkjenn versjon» på nytt for å fullføre.",
        "hse.document.file_missing": "Vedlagt fil ble ikke funnet.",
        "hse.document.file_processing": "Filen behandles fortsatt. Prøv igjen om litt.",
        "hse.document.file_failed": "Filopplastingen feilet. Last opp dokumentet på nytt.",
        "hse.document.open_file": "Åpne fil",
        "hse.document.download_file": "Last ned fil",
        "hse.document.attached_file": "Vedlagt fil",
        "hse.upload.save_first": "Lagre først for å laste opp dokumenter.",
        "hse.documents.json.open_dialog": "JSON / AI",
        "hse.documents.json.dialog_title": "HMS/KS-dokumenter — JSON og AI",
        "hse.documents.json.tab_json": "Lim inn JSON",
        "hse.documents.json.tab_ai_guide": "AI-instruksjoner",
        "hse.documents.json.hint":
          "Lim inn JSON fra AI eller rediger manuelt. Oppretter dokumenter som kladd, og kan opprette ny Fag/Bransje, Kategori og Kapittel ved behov.",
        "hse.documents.json.current_structure": "Nåværende Fag / Kategori / Kapittel",
        "hse.documents.json.existing_documents": "Eksisterende dokumenter (ikke dupliser)",
        "hse.documents.json.loading_documents": "laster…",
        "hse.documents.json.copy_json": "Kopier JSON",
        "hse.documents.json.copy_success": "JSON kopiert",
        "hse.documents.json.reload_blank": "Tøm mal",
        "hse.documents.json.reload_success": "Tom mal lastet",
        "hse.documents.json.insert_sample": "Sett inn eksempel",
        "hse.documents.json.apply": "Importer til Promang",
        "hse.documents.json.importing": "Importerer…",
        "hse.documents.json.imported":
          "Importert: {{documents}} dokument(er), {{chapters}} kapittel, {{categories}} kategori(er), {{disciplines}} bransje(r)",
        "hse.documents.json.import_failed": "Import feilet",
        "hse.documents.json.clipboard_failed": "Kunne ikke kopiere til utklippstavlen",
        "hse.documents.json.ai_guide_intro":
          "Kopier instruksjonene under til ChatGPT, Claude eller annen AI. Lim deretter JSON-svaret inn under fanen Lim inn JSON. Instruksen viser nåværende kapitler i selskapet.",
        "hse.documents.json.copy_ai_guide": "Kopier AI-instruksjoner",
        "hse.documents.json.ai_guide_copied": "AI-instruksjoner kopiert",
        "hse.documents.json.generate_with_ai": "Generer med AI",
        "hse.documents.json.ai_parse_error": "Kunne ikke lese AI-svar som JSON",
        "hse.documents.json.ai_apply_success": "{{count}} dokument(er) lagt inn fra AI — kontroller og importer",
        "hse.documents.json.error_empty": "JSON er tom",
        "hse.documents.json.error_invalid_json": "Ugyldig JSON",
        "hse.documents.json.error_invalid_shape": "Ugyldig JSON-struktur",
        "hse.documents.json.error_no_valid_items": "Ingen gyldige dokumenter eller struktur i JSON",
        "hse.documents.json.error_too_many_documents": "For mange dokumenter (maks 50)",
        "hse.documents.json.create_missing": "Opprett manglende Fag/Kategori/Kapittel",
        "hse.documents.json.create_missing_hint":
          "Av som standard — bruk eksisterende struktur. Slå på bare når du trenger ny bransje/kategori/kapittel.",
        "hse.documents.json.atomic": "Atomisk import (stopp/rull tilbake ved feil)",
        "hse.documents.json.dropped_rows":
          "{{count}} rad(er) hoppet over før import: {{detail}}",
        "hse.documents.json.result_title": "Importresultat",
        "hse.documents.json.result_hint":
          "Kladder synes ikke alltid i listen for ikke-admin — åpne via lenkene under.",
        "hse.documents.json.result_no_docs": "Ingen dokumenter ble opprettet (kun struktur eller feil).",
        "hse.digest.hub_tab": "Ukentlig HMS-e-post",
        "hse.digest.title": "Ukentlig HMS-e-post",
        "hse.digest.hub_intro":
          "Send en ukentlig oversikt over nye hendelser, nye HMS/KS-dokumenter og uleste dokumenter. Av som standard.",
        "hse.digest.load_failed": "Kunne ikke laste innstillinger for HMS-e-post",
        "hse.digest.saved": "Innstillinger lagret",
        "hse.digest.save_failed": "Kunne ikke lagre innstillinger for HMS-e-post",
        "hse.digest.enabled.title": "Ukentlig utsendelse",
        "hse.digest.enabled.description":
          "Når dette er på, får aktuelle brukere en e-post på valgt ukedag og klokkeslett (Europe/Oslo).",
        "hse.digest.enabled.toggle": "Send ukentlig HMS-e-post",
        "hse.digest.schedule.title": "Tidspunkt",
        "hse.digest.schedule.description": "E-posten sendes én gang per uke på valgt dag og time.",
        "hse.digest.weekday": "Ukedag",
        "hse.digest.weekday.sunday": "Søndag",
        "hse.digest.weekday.monday": "Mandag",
        "hse.digest.weekday.tuesday": "Tirsdag",
        "hse.digest.weekday.wednesday": "Onsdag",
        "hse.digest.weekday.thursday": "Torsdag",
        "hse.digest.weekday.friday": "Fredag",
        "hse.digest.weekday.saturday": "Lørdag",
        "hse.digest.hour": "Klokkeslett",
        "hse.digest.timezone": "Tidssone",
        "hse.digest.timezone_value": "Europe/Oslo",
        "hse.digest.last_sent": "Sist sendt {{date}}",
        "hse.digest.last_sent_never": "Ikke sendt ennå",
        "hse.digest.content.title": "Innhold",
        "hse.digest.content.intro": "E-posten kan inneholde disse seksjonene. Tomme seksjoner utelates.",
        "hse.digest.content.events": "Nye hendelser",
        "hse.digest.content.documents": "Nye dokumenter",
        "hse.digest.content.unread": "Dokumenter du ikke har lest",
        "hse.document_read_overview.title": "Lest / forstått",
        "hse.document_read_overview.subtitle":
          "Oversikt over hvem som har bekreftet at de har lest og forstått HMS/KS-dokumenter.",
        "hse.document_read_overview.back_to_documents": "Tilbake til dokumenter",
        "hse.document_read_overview.summary_pending": "Mangler bekreftelse",
        "hse.document_read_overview.summary_acknowledged": "Lest og bekreftet",
        "hse.document_read_overview.summary_documents": "Dokumenter",
        "hse.document_read_overview.summary_employees": "Ansatte",
        "hse.document_read_overview.search": "Søk",
        "hse.document_read_overview.search_placeholder": "Søk etter ansatt, e-post eller dokument…",
        "hse.document_read_overview.filter_document": "Dokument",
        "hse.document_read_overview.all_documents": "Alle dokumenter",
        "hse.document_read_overview.filter_all": "Alle",
        "hse.document_read_overview.filter_pending": "Mangler bekreftelse",
        "hse.document_read_overview.filter_acknowledged": "Lest og bekreftet",
        "hse.document_read_overview.filter_exempt": "Unntatt",
        "hse.document_read_overview.view_employees": "Ansatte",
        "hse.document_read_overview.view_documents": "Dokumenter",
        "hse.document_read_overview.empty": "Ingen treff",
        "hse.document_read_overview.col_employee": "Ansatt",
        "hse.document_read_overview.col_pending": "Mangler",
        "hse.document_read_overview.col_acknowledged": "Bekreftet",
        "hse.document_read_overview.unknown_user": "Ukjent bruker",
        "hse.document_read_overview.former_employee": "Tidligere ansatt",
        "hse.document_read_overview.unknown_document": "Ukjent dokument",
        "hse.document_read_overview.col_document": "Dokument",
        "hse.document_read_overview.status_acknowledged": "Lest og bekreftet",
        "hse.document_read_overview.status_exempt": "Forfatter (ikke pliktig)",
        "hse.document_read_overview.status_pending": "Mangler bekreftelse",
        "hse.document_read_overview.filter_employee": "Ansatt",
        "hse.document_read_overview.filter_status": "Status",
        "hse.document_read_overview.filter_acknowledged_from": "Bekreftet fra",
        "hse.document_read_overview.filter_acknowledged_to": "Bekreftet til",
        "hse.document_read_overview.print_action": "Eksporter PDF",
        "hse.document_read_overview.print_title": "Lest / forstått per bruker",
        "hse.document_read_overview.print_dialog_title": "Eksporter oversikt per bruker",
        "hse.document_read_overview.print_dialog_intro":
          "Velg hvilke rader som skal med. Listen grupperes per ansatt og lastes ned som PDF.",
        "hse.document_read_overview.print_scope": "Omfang",
        "hse.document_read_overview.print_scope_pending": "Kun ikke lest/forstått",
        "hse.document_read_overview.print_scope_acknowledged": "Kun lest/bekreftet",
        "hse.document_read_overview.print_scope_all": "Alle",
        "hse.document_read_overview.print_submit": "Last ned PDF",
        "hse.document_read_overview.print_cancel": "Avbryt",
        "hse.document_read_overview.print_empty": "Ingen rader å eksportere med valgt filter.",
        "hse.document_read_overview.print_generated_at": "Generert {{date}}",
        "hse.document_read_overview.print_col_date": "Dato",
        "hse.dashboard.title": "HMS & KS",
        "hse.dashboard.subtitle": "Oversikt over KPI, oppgaver, varsler og nylige hendelser",
        "hse.dashboard.kpi.title": "KPI-oversikt",
        "hse.dashboard.kpi.events": "Hendelser",
        "hse.dashboard.kpi.deviations": "Avvik",
        "hse.dashboard.kpi.unread_docs": "Uleste dokumenter",
        "hse.dashboard.kpi.unread_docs.info":
          "Godkjente HMS/KS-dokumenter du ikke har bekreftet lest og forstått. Forfattere er unntatt.",
        "hse.dashboard.kpi.unread_docs.info_aria": "Slik telles uleste dokumenter",
        "hse.dashboard.kpi.open_actions": "Åpne tiltak",
        "hse.dashboard.kpi.open_actions.info":
          "Tiltak som ikke er fullført eller kansellert. Åpne hendelsen for å følge opp.",
        "hse.dashboard.kpi.open_actions.info_aria": "Slik telles åpne tiltak",
        "hse.dashboard.kpi.overdue": "Forfalt",
        "hse.dashboard.kpi.overdue.info":
          "Tiltak med frist før i dag som ikke er fullført.",
        "hse.dashboard.kpi.overdue.info_aria": "Slik telles forfalte tiltak",
        "hse.dashboard.tasks.title": "Mine oppgaver",
        "hse.dashboard.tasks.empty": "Ingen åpne oppgaver akkurat nå.",
        "hse.dashboard.tasks.kind.action": "Tiltak",
        "hse.dashboard.tasks.kind.acknowledgement": "Lesebekreftelse",
        "hse.dashboard.tasks.kind.task": "Oppgave",
        "hse.dashboard.tasks.overdue": "Forfalt",
        "hse.dashboard.tasks.due": "Frist {{date}}",
        "hse.dashboard.alerts.title": "Varsler",
        "hse.dashboard.alerts.empty": "Ingen varsler.",
        "hse.dashboard.alerts.overdue_actions": "{{count}} forfalte tiltak",
        "hse.dashboard.alerts.unread_docs": "{{count}} dokumenter venter på lesebekreftelse",
        "hse.dashboard.alerts.due_soon": "{{count}} tiltak forfaller snart",
        "hse.dashboard.alerts.critical_events": "{{count}} kritiske hendelser",
        "hse.dashboard.events.title": "Nylige hendelser",
        "hse.dashboard.events.empty": "Ingen hendelser å vise.",
        "hse.dashboard.events.view_all": "Se alle",
        "hse.dashboard.org_charts.title": "Organisasjonskart",
        "hse.dashboard.org_charts.view_all": "Se alle",
        "hse.dashboard.org_charts.empty": "Ingen organisasjonskart funnet",
        "hse.dashboard.org_charts.revision": "Revisjon {{number}}",
        "hse.dashboard.org_charts.approved": "Godkjent {{date}}",
        "hse.dashboard.org_charts.view": "Vis",
        "hse.dashboard.org_charts.pdf": "PDF",
        "hse.dashboard.org_charts.pdf_success": "PDF eksportert",
        "hse.dashboard.org_charts.pdf_error": "Kunne ikke eksportere PDF",
        "hse.dashboard.error": "Kunne ikke laste HMS-oversikten.",
        "hse.dashboard.error_toast": "Noe gikk galt da HMS-oversikten ble lastet.",
        "hse.dashboard.retry": "Prøv igjen",
        "hse.dashboard.see_all": "Se alle",
        "hse.document_read_overview.export_loading": "Lager PDF…",
        "hse.document_read_overview.export_error": "Kunne ikke lage PDF. Prøv igjen.",
        "hse.tiltak.title": "Tiltak",
        "hse.tiltak.subtitle": "Oppfølging, nye rutiner og dokumenttiltak i HMS",
        "hse.tiltak.form_subtitle": "Tittel, ansvarlig og frist er det viktigste. Resten kan fylles ut etterpå.",
        "hse.tiltak.view_subtitle": "Oppfølgingstiltak i HMS",
        "hse.tiltak.new": "Nytt tiltak",
        "hse.tiltak.open": "Åpne",
        "hse.tiltak.edit": "Rediger tiltak",
        "hse.tiltak.export_pdf": "Last ned PDF",
        "hse.tiltak.col_actions": "Handlinger",
        "hse.tiltak.create": "Opprett tiltak",
        "hse.tiltak.save": "Lagre tiltak",
        "hse.tiltak.cancel": "Avbryt",
        "hse.tiltak.start": "Start",
        "hse.tiltak.complete": "Fullfør",
        "hse.tiltak.created": "Tiltak opprettet",
        "hse.tiltak.updated": "Tiltak oppdatert",
        "hse.tiltak.started": "Tiltak startet",
        "hse.tiltak.completed": "Tiltak fullført",
        "hse.tiltak.save_failed": "Kunne ikke lagre tiltak",
        "hse.tiltak.load_failed": "Kunne ikke laste tiltak",
        "hse.tiltak.empty": "Ingen tiltak ennå. Opprett det første.",
        "hse.tiltak.search": "Søk",
        "hse.tiltak.search_placeholder": "Søk etter tittel eller beskrivelse…",
        "hse.tiltak.filter_all": "Alle",
        "hse.tiltak.col_title": "Tittel",
        "hse.tiltak.col_type": "Type",
        "hse.tiltak.col_assignee": "Ansvarlig",
        "hse.tiltak.col_deadline": "Frist",
        "hse.tiltak.col_status": "Status",
        "hse.tiltak.status_overdue": "Forfalt",
        "hse.tiltak.field.title": "Tittel",
        "hse.tiltak.field.description": "Beskrivelse",
        "hse.tiltak.field.action_type": "Type tiltak",
        "hse.tiltak.field.category": "Kategori",
        "hse.tiltak.field.priority": "Prioritet",
        "hse.tiltak.field.status": "Status",
        "hse.tiltak.field.deadline": "Frist",
        "hse.tiltak.field.assignee": "Ansvarlig",
        "hse.tiltak.field.event": "Knyttet hendelse",
        "hse.tiltak.field.document": "Tilknyttet dokument",
        "hse.tiltak.event_none": "Ingen hendelse",
        "hse.tiltak.linked_event": "Åpne hendelsen",
        "hse.tiltak.linked_document": "Åpne dokumentet",
        "hse.tiltak.view_for_event": "Se tiltak for hendelsen",
        "hse.tiltak.error_title": "Skriv en kort tittel",
        "hse.tiltak.error_deadline": "Velg en frist",
        "hse.tiltak.error_assignee": "Velg hvem som eier tiltaket",
        "hse.tiltak.error_document": "Velg dokumentet tiltaket gjelder",
        "hse.tiltak.type.generic": "Oppfølging",
        "hse.tiltak.type.new_routine": "Ny rutine",
        "hse.tiltak.type.linked_document": "Dokumenttiltak",
        "hse.tiltak.category.safety": "Sikkerhet",
        "hse.tiltak.category.quality": "Kvalitet",
        "hse.tiltak.category.environment": "Miljø",
        "hse.tiltak.category.procedure": "Rutine / prosedyre",
        "hse.tiltak.category.training": "Opplæring",
        "hse.tiltak.category.maintenance": "Vedlikehold",
        "hse.tiltak.category.equipment": "Utstyr",
        "hse.tiltak.category.communication": "Kommunikasjon",
        "hse.tiltak.category.other": "Annet",
        "hse.tiltak.priority.low": "Lav",
        "hse.tiltak.priority.medium": "Middels",
        "hse.tiltak.priority.high": "Høy",
        "hse.tiltak.priority.critical": "Kritisk",
        "hse.tiltak.status.planned": "Planlagt",
        "hse.tiltak.status.started": "Påbegynt",
        "hse.tiltak.status.in_progress": "Under arbeid",
        "hse.tiltak.status.completed": "Fullført",
        "hse.tiltak.status.cancelled": "Kansellert",
        "hse.tiltak.status.on_hold": "På vent",
        "hse.tiltak.info.title.title": "Tittel",
        "hse.tiltak.info.title.body": "En kort setning som beskriver hva som skal gjøres, for eksempel «Oppdater brannrutine» eller «Følg opp nestenulykke i lager».",
        "hse.tiltak.info.description.title": "Beskrivelse",
        "hse.tiltak.info.description.body": "Hva skal gjøres, hvorfor, og når det er ferdig. Hold det konkret så den ansvarlige vet neste steg.",
        "hse.tiltak.info.action_type.title": "Type tiltak",
        "hse.tiltak.info.action_type.body": "Oppfølging er et vanlig tiltak etter hendelse. Ny rutine oppretter eller endrer en fast arbeidsmåte. Dokumenttiltak knytter arbeidet til et HMS-dokument.",
        "hse.tiltak.info.category.title": "Kategori",
        "hse.tiltak.info.category.body": "Hjelper dere å sortere tiltak etter tema (sikkerhet, kvalitet, miljø, rutine, opplæring).",
        "hse.tiltak.info.priority.title": "Prioritet",
        "hse.tiltak.info.priority.body": "Kritisk og høy bør ha kort frist. Middels og lav kan vente hvis mer alvorlige tiltak står åpne.",
        "hse.tiltak.info.status.title": "Status",
        "hse.tiltak.info.status.body": "Planlagt = ikke startet. Påbegynt/under arbeid = noen jobber med det. Fullført = ferdig. På vent = midlertidig stoppet.",
        "hse.tiltak.info.deadline.title": "Frist",
        "hse.tiltak.info.deadline.body": "Datoen tiltaket skal være ferdig. Forfalte tiltak vises tydelig i listen.",
        "hse.tiltak.info.assignee.title": "Ansvarlig",
        "hse.tiltak.info.assignee.body": "Personen som eier tiltaket og skal sørge for at det blir gjort. Firmaet kan sette en standardansvarlig under HMS-innstillinger.",
        "hse.tiltak.info.event.title": "Knyttet hendelse",
        "hse.tiltak.info.event.body": "Valgfritt. Brukes når tiltaket kommer fra en ulykke, nestenulykke, avvik eller observasjon.",
        "hse.tiltak.info.document.title": "Tilknyttet dokument",
        "hse.tiltak.info.document.body": "Valgfritt, men påkrevd for dokumenttiltak. Velg rutinen eller dokumentet som skal opprettes eller oppdateres.",
        "hse.tiltak.print_action": "Skriv ut",
        "hse.tiltak.print_title": "Tiltaksliste",
        "hse.tiltak.print_dialog_title": "Skriv ut tiltak",
        "hse.tiltak.print_dialog_intro": "Velg hvilke tiltak som skal med. Listen følger filtrene du allerede har satt.",
        "hse.tiltak.print_scope": "Omfang",
        "hse.tiltak.print_scope_open": "Åpne tiltak",
        "hse.tiltak.print_scope_overdue": "Forfalte tiltak",
        "hse.tiltak.print_scope_completed": "Fullførte tiltak",
        "hse.tiltak.print_scope_all": "Alle tiltak i listen",
        "hse.tiltak.print_submit": "Skriv ut",
        "hse.tiltak.print_cancel": "Avbryt",
        "hse.tiltak.print_empty": "Ingen tiltak å skrive ut med valgt filter.",
        "hse.tiltak.print_generated_at": "Generert {{date}}",
        "hse.tiltak.pdf_failed": "Kunne ikke laste ned PDF for tiltaket",
        "hse.settings.hub_tab": "HMS-modul",
        "hse.settings.title": "Firma-innstillinger for HMS",
        "hse.settings.hub_intro": "Tilpass hvilke deler av HMS firmaet bruker, hvem som er ansvarlig, og hvor ofte systemet skal gjennomgås.",
        "hse.settings.load_failed": "Kunne ikke laste HMS-innstillinger",
        "hse.settings.saved": "HMS-innstillinger lagret",
        "hse.settings.save_failed": "Kunne ikke lagre HMS-innstillinger",
        "hse.settings.print_action": "Skriv ut / PDF",
        "hse.settings.modules.title": "Moduler i bruk",
        "hse.settings.modules.description": "Slå av det firmaet ikke bruker. Innholdet blir værende, men dere markerer hva som er aktivt.",
        "hse.settings.modules.tiltak": "Tiltak",
        "hse.settings.modules.tiltak_help": "Oppfølging, nye rutiner og dokumenttiltak.",
        "hse.settings.modules.events": "Hendelser",
        "hse.settings.modules.events_help": "Avvik, nestenulykker, ulykker og observasjoner.",
        "hse.settings.modules.documents": "Dokumenter",
        "hse.settings.modules.documents_help": "Håndbok, rutiner og lest/forstått.",
        "hse.settings.modules.competency": "Kompetanse",
        "hse.settings.modules.competency_help": "Krav, kurs og opplæringsplan.",
        "hse.settings.modules.evaluation": "Evaluering",
        "hse.settings.modules.evaluation_help": "Internrevisjon og ledelsens gjennomgang.",
        "hse.settings.modules.risk": "Risiko og SJA",
        "hse.settings.modules.risk_help": "Risikoregister, SJA og stoffkartotek.",
        "hse.settings.modules.sja": "SJA",
        "hse.settings.modules.sja_help": "Sikker jobb-analyse før arbeid starter.",
        "hse.settings.modules.goals": "Målsetting",
        "hse.settings.modules.goals_help": "Årlige HMS-mål, fokusområder og godkjenning.",
        "hse.settings.responsible.title": "HMS-ansvarlig",
        "hse.settings.responsible.description": "Standard person som foreslås på nye tiltak.",
        "hse.settings.responsible.info_title": "HMS-ansvarlig",
        "hse.settings.responsible.info_body": "Dette er firmaets faste HMS-kontakt. Ved nye tiltak foreslås personen som ansvarlig, men dere kan bytte per tiltak.",
        "hse.settings.cadence.title": "Gjennomgangsintervall",
        "hse.settings.cadence.description": "Hvor ofte ledelsen skal gjennomgå HMS-systemet.",
        "hse.settings.cadence.info_title": "Gjennomgangsintervall",
        "hse.settings.cadence.info_body": "ISO 9001/45001 forventer jevnlig gjennomgang. 12 måneder er vanlig. Velg 3 eller 6 måneder hvis dere har høy risiko eller mange endringer.",
        "hse.settings.cadence.3": "Hver 3. måned",
        "hse.settings.cadence.6": "Hver 6. måned",
        "hse.settings.cadence.12": "Hver 12. måned",
        "hse.settings.tiltak_defaults.title": "Standard for tiltak",
        "hse.settings.tiltak_defaults.description": "Brukes når noen oppretter et nytt tiltak uten å velge alt selv.",
        "hse.settings.tiltak_defaults.info_title": "Standard for tiltak",
        "hse.settings.tiltak_defaults.info_body": "Standard frist teller dager fra i dag. Godkjenning betyr at noen må bekrefte tiltaket før det lukkes.",
        "hse.settings.tiltak_defaults.due_days": "Standard frist (dager)",
        "hse.settings.tiltak_defaults.require_approval": "Krev godkjenning før tiltak lukkes",
        "hse.settings.pdf_failed": "Kunne ikke laste ned PDF",
        "hse.settings.safety_rep.hub_tab": "Verneombud",
        "hse.settings.safety_rep.title": "Verneombud",
        "hse.settings.safety_rep.hub_intro": "Hvem som er verneombud og eventuelle vara. Kreves for internkontroll.",
        "hse.settings.safety_rep.description": "Velg firmaets verneombud. Personen får varsel når HMS-oppsett mangler.",
        "hse.settings.safety_rep.who": "Verneombud",
        "hse.settings.safety_rep.info_title": "Verneombud",
        "hse.settings.safety_rep.info_body": "Arbeidsmiljøloven krever verneombud. Sett hovedpersonen her, og legg til vara ved behov.",
        "hse.settings.safety_rep.deputies_title": "Vara",
        "hse.settings.safety_rep.deputies_description": "Vara kan tre inn når verneombudet er borte.",
        "hse.settings.safety_rep.deputies_empty": "Ingen vara er satt.",
        "hse.settings.safety_rep.add_deputy": "Legg til vara",
        "hse.settings.safety_rep.remove_deputy": "Fjern vara",
        "hse.settings.risk.hub_tab": "Risiko",
        "hse.settings.risk.title": "Risikohåndtering",
        "hse.settings.risk.hub_intro": "Hvordan firmaet behandler risiko, standardkategorier og hvem som er ansvarlig.",
        "hse.settings.risk.handling_title": "Hvordan risiko håndteres",
        "hse.settings.risk.handling_description": "Velg arbeidsmåten. Det styrer hva som foreslås i risikoregister og SJA.",
        "hse.settings.risk.handling_info_title": "Risikohåndtering",
        "hse.settings.risk.handling_info_body": "Register + SJA er vanlig. Velg SJA først ved kortvarig arbeid, eller bare register for overordnede risikoer.",
        "hse.settings.risk.handling.register_and_sja": "Register og SJA",
        "hse.settings.risk.handling.sja_first": "SJA først",
        "hse.settings.risk.handling.register_only": "Bare register",
        "hse.settings.risk.handling.custom": "Egen beskrivelse",
        "hse.settings.risk.handling_notes_placeholder": "Beskriv hvordan dere vurderer og følger opp risiko…",
        "hse.settings.risk.categories_title": "Risikokategorier",
        "hse.settings.risk.categories_description": "Standardkategorier kommer fra API. Slå av de dere ikke bruker, eller legg til egne.",
        "hse.settings.risk.categories_loading": "Laster kategorier…",
        "hse.settings.risk.categories_load_failed": "Kunne ikke laste risikokategorier",
        "hse.settings.risk.categories_save_failed": "Kunne ikke lagre risikokategori",
        "hse.settings.risk.category_add": "Legg til",
        "hse.settings.risk.category_name": "Nytt kategorinavn",
        "hse.settings.risk.category_system": "Standard",
        "hse.settings.risk.category_delete": "Slett kategori",
        "hse.settings.risk.category_added": "Kategori lagt til",
        "hse.settings.risk.category_deleted": "Kategori slettet",
        "hse.settings.risk.assessors_title": "Risikovurderere",
        "hse.settings.risk.assessors_description": "Personer som kan vurdere risiko i tillegg til HMS-ansvarlig.",
        "hse.settings.risk.assessors_empty": "Ingen vurderere er satt.",
        "hse.settings.risk.add_assessor": "Legg til vurderer",
        "hse.settings.risk.remove_assessor": "Fjern vurderer",
        "hse.settings.risk.category.health_safety": "Helse og sikkerhet",
        "hse.settings.risk.category.environmental": "Ytre miljø",
        "hse.settings.risk.category.quality": "Kvalitet",
        "hse.settings.risk.category.financial": "Økonomi",
        "hse.settings.risk.category.operational": "Drift",
        "hse.settings.risk.category.reputational": "Omdømme",
        "hse.settings.risk.category.legal_compliance": "Regelverk",
        "hse.settings.risk.category.climate_related": "Klima",
        "hse.settings.risk.skip_requires_reason": "Krev begrunnelse når risiko hoppes over",
        "hse.settings.risk.skip_requires_reason_help": "Gjelder SJA og risikovurdering når noen velger å ikke fylle ut.",
        "hse.settings.risk.responsible_title": "Ansvarlig for risiko",
        "hse.settings.risk.responsible_description": "Personen som eier risikoregister og SJA-oppfølging.",
        "hse.settings.ai.hub_tab": "AI",
        "hse.settings.ai.title": "AI-forslag",
        "hse.settings.ai.hub_intro": "Slå på forslag og velg standard fag for HMS-innhold.",
        "hse.settings.ai.description": "Forslag kan hjelpe med mål, dokumenter og tiltak. Ingenting sendes uten at noen ber om det.",
        "hse.settings.ai.info_title": "AI i HMS",
        "hse.settings.ai.info_body": "Når forslaget er på, kan Promang foreslå tekst ut fra valgt fag. Firmaet styrer om det brukes.",
        "hse.settings.ai.enable": "Tillat AI-forslag i HMS",
        "hse.settings.ai.enable_help": "Gjelder mål, dokumentutkast og lignende hjelp.",
        "hse.settings.ai.discipline_title": "Standard fag",
        "hse.settings.ai.discipline_description": "Brukes som utgangspunkt når AI foreslår HMS-innhold.",
        "hse.settings.ai.discipline_none": "Ingen standard",
        "hse.settings.ai.configured_ok": "AI-nøkkel er satt.",
        "hse.settings.ai.configured_missing": "AI er på, men nøkkel mangler i miljøet.",
        "hse.setup.banner.title": "HMS-oppsett mangler",
        "hse.setup.banner.subtitle": "{{count}} punkt bør fylles ut (ansvarlig eller verneombud).",
        "hse.setup.banner.settings": "Åpne innstillinger",
        "hse.setup.banner.guide": "Åpne guide",
        "hse.goals.title": "Målsetting",
        "hse.goals.subtitle": "Målsetting for {{year}}",
        "hse.goals.filter.year": "År",
        "hse.goals.load_failed": "Kunne ikke laste målsetting",
        "hse.goals.saved": "Mål lagret",
        "hse.goals.save_failed": "Kunne ikke lagre mål",
        "hse.goals.created": "Mål opprettet",
        "hse.goals.deleted": "Mål slettet",
        "hse.goals.delete_failed": "Kunne ikke slette mål",
        "hse.goals.title_required": "Målet må ha en tittel.",
        "hse.goals.print": "Skriv ut",
        "hse.goals.open": "Åpne",
        "hse.goals.export_pdf": "Last ned PDF",
        "hse.goals.exporting": "Laster ned PDF…",
        "hse.goals.export_failed": "Kunne ikke laste ned PDF",
        "hse.goals.status.draft": "Utkast",
        "hse.goals.status.proposed": "Foreslått",
        "hse.goals.status.approved": "Godkjent",
        "hse.goals.status.active": "Aktiv",
        "hse.goals.status.completed": "Fullført",
        "hse.goals.status.cancelled": "Avbrutt",
        "hse.goals.purpose.title": "Hensikt med målsetting",
        "hse.goals.purpose.help": "Trykk på en brikke for å opprette et mål. Rediger på stedet etterpå.",
        "hse.goals.purpose.placeholder": "Valgfri utfylling…",
        "hse.goals.purpose.chips.health_safety": "Sikre helse og sikkerhet",
        "hse.goals.purpose.chips.prevent_harm": "Forebygge skade og miljøskade",
        "hse.goals.purpose.chips.systematic": "Systematisk forbedring",
        "hse.goals.purpose.chips.training": "Opplæring og medvirkning",
        "hse.goals.purpose.chips.environment": "Ta vare på ytre miljø",
        "hse.goals.focus.title": "Fokusområder",
        "hse.goals.focus.help": "Bli enige om målene for året. Bruk malene, og rediger på stedet.",
        "hse.goals.focus.add": "Eget mål",
        "hse.goals.focus.empty": "Ingen fokusområder ennå. Trykk på en mal for å starte.",
        "hse.goals.focus.untitled": "Uten tittel",
        "hse.goals.focus.title_placeholder": "Tittel",
        "hse.goals.focus.description_placeholder": "Hva skal oppnås?",
        "hse.goals.focus.tiltak": "Knytt tiltak (valgfritt)",
        "hse.goals.focus.tiltak_none": "Ingen tiltak",
        "hse.goals.focus.tiltak_link": "Åpne tiltak",
        "hse.goals.focus.done": "Lagre",
        "hse.goals.focus.cancel": "Avbryt",
        "hse.goals.focus.edit": "Rediger",
        "hse.goals.focus.remove": "Fjern",
        "hse.goals.focus.templates.physical.title": "Fysisk arbeidsmiljø",
        "hse.goals.focus.templates.physical.description": "Ingen personskader eller materiell skade. Ryddige og trygge arbeidsplasser.",
        "hse.goals.focus.templates.hse_work.title": "HMS-arbeidet",
        "hse.goals.focus.templates.hse_work.description": "Følge internkontroll, opplæring og systematisk forbedring.",
        "hse.goals.focus.templates.absence.title": "Sykefravær og nærvær",
        "hse.goals.focus.templates.absence.description": "Holde sykefravær under avtalt nivå og følge opp tidlig.",
        "hse.goals.focus.templates.vision.title": "Overordnede visjoner",
        "hse.goals.focus.templates.vision.description": "Knytte avdelingsmål til risikovurdering og daglig drift.",
        "hse.goals.focus.templates.psychosocial.title": "Psykososialt miljø",
        "hse.goals.focus.templates.psychosocial.description": "Trygt ytringsklima, tydelig ledelse og nulltoleranse for trakassering.",
        "hse.goals.focus.templates.environment.title": "Ytre miljø",
        "hse.goals.focus.templates.environment.description": "Redusere avfall, utslipp og unødig ressursbruk.",
        "hse.goals.focus.templates.competency.title": "Kompetanse",
        "hse.goals.focus.templates.competency.description": "Riktig kompetanse på plass før arbeid starter.",
        "hse.goals.approve.title": "Godkjenn og signer",
        "hse.goals.approve.help": "Godkjenn og signer hvert mål når ledelsen er enig.",
        "hse.goals.approve.place": "Sted",
        "hse.goals.approve.place_placeholder": "F.eks. Oslo",
        "hse.goals.approve.place_required": "Fyll inn sted før godkjenning.",
        "hse.goals.approve.status": "Status",
        "hse.goals.approve.draft": "Ikke godkjent ennå",
        "hse.goals.approve.approved_on": "Godkjent {{date}}",
        "hse.goals.approve.action": "Godkjenn",
        "hse.goals.approve.saved": "Mål godkjent",
        "hse.goals.sign.action": "Signer",
        "hse.goals.sign.saved": "Mål signert",
        "hse.goals.sign.signed_on": "Signert {{date}}",
        "hse.risk.title": "Risiko og SJA",
        "hse.risk.subtitle": "Register, matrise, SJA og klimarisiko — korte felt, ikke ISO-essay.",
        "hse.risk.new": "Ny risiko",
        "hse.risk.more": "Flere valg",
        "hse.risk.more_header": "Velg handling",
        "hse.risk.delete": "Slett risiko",
        "hse.risk.deleted": "Risiko slettet",
        "hse.risk.delete_confirm": "Slette «{{title}}»?",
        "hse.risk.nav.campaigns": "Risikovurderinger",
        "hse.risk.campaigns.title": "Risikovurderinger",
        "hse.risk.campaigns.subtitle": "Overordnet per år — deretter risikoene.",
        "hse.risk.campaigns.search": "Søk i risikovurderinger…",
        "hse.risk.campaigns.empty": "Ingen risikovurderinger ennå. Opprett 2027 eller et eget navn.",
        "hse.risk.campaigns.col.name": "Risikovurdering",
        "hse.risk.campaigns.col.year": "År",
        "hse.risk.campaigns.col.updated": "Sist endret",
        "hse.risk.campaigns.col.progress": "Risikoer vurdert",
        "hse.risk.campaigns.col.department": "Avdeling",
        "hse.risk.campaigns.unspecified": "Uspesifisert",
        "hse.risk.campaign.new": "Ny risikovurdering",
        "hse.risk.campaign.year": "År",
        "hse.risk.campaign.title_optional": "Tittel (valgfritt)",
        "hse.risk.campaign.title_placeholder": "Overordnet risikovurdering {{year}}",
        "hse.risk.campaign.created": "Risikovurdering opprettet",
        "hse.risk.campaign.deleted": "Risikovurdering slettet",
        "hse.risk.campaign.delete": "Slett risikovurdering",
        "hse.risk.campaign.delete_confirm": "Slette «{{title}}»? Risikoene blir liggende i registeret.",
        "hse.risk.campaign.save_failed": "Kunne ikke lagre risikovurderingen",
        "hse.risk.campaign.load_failed": "Kunne ikke laste risikovurderinger",
        "hse.risk.campaign.add_risk": "Legg til risiko",
        "hse.risk.campaign.risks_title": "Risiko og utfordringer",
        "hse.risk.campaign.progress_label": "{{done}}/{{total}} vurdert",
        "hse.risk.fields.description_placeholder": "Hva gjør at dette kan være en utfordring hos dere?",
        "hse.risk.suggest.campaign_hint": "Forslagene lagres som kladder i denne risikovurderingen.",
        "hse.risk.suggest.created": "{{count}} kladder lagt til",
        "hse.guide.see": "Se veiledning",
        "hse.guide.badge": "Veiledning",
        "hse.guide.open_full": "Åpne full HMS-guide",
        "hse.guide.risk.title": "Risikovurdering",
        "hse.guide.risk.lead": "Start med en overordnet vurdering for året. Legg deretter til risikoer og tiltak.",
        "hse.guide.risk.step1": "Opprett risikovurdering for året, for eksempel 2027.",
        "hse.guide.risk.step2": "Vurder hver risiko: tittel, konsekvens og nivå.",
        "hse.guide.risk.step3": "Ved moderat eller høyere: knytt eller opprett tiltak.",
        "hse.guide.sja.title": "SJA",
        "hse.guide.sja.lead": "Sikker jobb-analyse for en konkret oppgave — kort og før arbeidet starter.",
        "hse.guide.sja.step1": "Opprett SJA med tittel og arbeidssted.",
        "hse.guide.sja.step2": "Legg inn steg og farer, eller bruk en mal.",
        "hse.guide.sja.step3": "Send inn og få godkjenning før jobben.",
        "hse.guide.chemical.title": "Stoffkartotek",
        "hse.guide.chemical.lead": "Hold oversikt over kjemikalier, datablad og gjennomgang.",
        "hse.guide.chemical.step1": "Registrer stoff og last opp datablad.",
        "hse.guide.chemical.step2": "Knytt til lokasjon og verneutstyr.",
        "hse.guide.chemical.step3": "Gå gjennom og publiser når noe endres.",
        "hse.guide.protective.title": "Vernerunder",
        "hse.guide.protective.lead": "Planlegg runder, noter funn og følg opp tiltak.",
        "hse.guide.protective.step1": "Opprett runde med område og deltakere.",
        "hse.guide.protective.step2": "Gå gjennom sjekkpunkter på stedet.",
        "hse.guide.protective.step3": "Lag tiltak på avvik og last ned PDF.",
        "hse.guide.evaluation.title": "Evaluering",
        "hse.guide.evaluation.lead": "Revisjon, ledelsens gjennomgang og KPI — kort status, ikke rapport-essay.",
        "hse.guide.evaluation.step1": "Velg type: internrevisjon eller ledelsens gjennomgang.",
        "hse.guide.evaluation.step2": "Registrer funn og knytt tiltak.",
        "hse.guide.evaluation.step3": "Følg KPI og lukk når ledelsen er enig.",
        "hse.guide.tiltak.title": "Tiltak",
        "hse.guide.tiltak.lead": "Ett tiltak, én ansvarlig, én frist. Knytt til risiko, hendelse eller evaluering.",
        "hse.guide.tiltak.step1": "Skriv hva som skal gjøres og hvem som eier det.",
        "hse.guide.tiltak.step2": "Sett frist og start når arbeidet begynner.",
        "hse.guide.tiltak.step3": "Marker fullført når risikoen er redusert.",
        "hse.guide.goals.title": "Målsetting",
        "hse.guide.goals.lead": "Årets HMS-mål. Korte formuleringer, godkjenning og valgfri tiltak-lenke.",
        "hse.guide.goals.step1": "Velg år og bruk maler eller egne mål.",
        "hse.guide.goals.step2": "Godkjenn når ledelsen er enig.",
        "hse.guide.goals.step3": "Knytt tiltak der det trengs.",
        "hse.risk.edit": "Rediger risiko",
        "hse.risk.save": "Lagre",
        "hse.risk.saving": "Lagrer…",
        "hse.risk.cancel": "Avbryt",
        "hse.risk.exclude": "Skal ikke vurderes",
        "hse.risk.created": "Risiko lagret",
        "hse.risk.updated": "Risiko oppdatert",
        "hse.risk.excluded_saved": "Markert som skal ikke vurderes",
        "hse.risk.save_failed": "Kunne ikke lagre risiko",
        "hse.risk.load_failed": "Kunne ikke laste risiko",
        "hse.risk.empty": "Ingen risikoer ennå. Start med vanlige utfordringer eller en egendefinert.",
        "hse.risk.search": "Søk i risikoer…",
        "hse.risk.error_title": "Skriv en kort tittel",
        "hse.risk.error_level": "Velg risikonivå",
        "hse.risk.form_subtitle": "Tittel, konsekvens og nivå. Utvidet vurdering og filer er valgfritt.",
        "hse.risk.pdf": "Last ned PDF",
        "hse.risk.pdf_loading": "Lager PDF…",
        "hse.risk.pdf_ready": "PDF lastet ned",
        "hse.risk.pdf_failed": "Kunne ikke laste ned PDF",
        "hse.risk.pdf_empty": "Ingen risiko å eksportere",
        "hse.risk.open": "Åpne",
        "hse.risk.actions": "Handlinger",
        "hse.risk.nav.aria": "Risiko-sider",
        "hse.risk.nav.register": "Register",
        "hse.risk.nav.matrix": "Matrise",
        "hse.risk.nav.sja": "SJA",
        "hse.risk.nav.climate": "Klimarisiko",
        "hse.risk.nav.chemical": "Stoffkartotek",
        "hse.risk.nav.protective": "Vernerunder",
        "hse.risk.hub.register": "Risikoregister",
        "hse.risk.hub.register_hint": "Vurderte og ekskluderte risikoer.",
        "hse.risk.hub.matrix": "Risikomatrise",
        "hse.risk.hub.matrix_hint": "5×5 oversikt over sannsynlighet og konsekvens.",
        "hse.risk.hub.sja": "SJA",
        "hse.risk.hub.sja_hint": "{{count}} SJA-er i listen.",
        "hse.risk.hub.climate": "Klimarisiko",
        "hse.risk.hub.climate_hint": "Fysiske og overgangsrisikoer.",
        "hse.risk.hub.chemical": "Stoffkartotek",
        "hse.risk.hub.chemical_hint": "Kjemikalier og datablad.",
        "hse.risk.hub.protective": "Vernerunder",
        "hse.risk.hub.protective_hint": "Runder og verneutstyr.",
        "hse.risk.hub.recent": "Sist oppdatert",
        "hse.risk.hub.see_all": "Se register",
        "hse.risk.register.title": "Risikoregister",
        "hse.risk.register.subtitle": "Alle vurderte risikoer. «Skal ikke vurderes» ligger nederst.",
        "hse.risk.excluded.title": "Skal ikke vurderes",
        "hse.risk.excluded.hint": "Utfordringer dere har valgt å ikke vurdere nå.",
        "hse.risk.view.title": "Risiko",
        "hse.risk.view.subtitle": "Kort vurdering og tilknyttede tiltak",
        "hse.risk.view.updated": "Sist endret {{date}}",
        "hse.risk.add.common": "Vanlige utfordringer",
        "hse.risk.add.common_hint": "Velg tema og en relevant utfordring, deretter vurder i dialog.",
        "hse.risk.add.custom": "Egendefinert",
        "hse.risk.add.custom_hint": "Velg kategori og skriv tittel selv.",
        "hse.risk.add.pick_theme": "Velg tema",
        "hse.risk.add.pick_category": "Velg kategori",
        "hse.risk.assess.title": "Vurder risiko",
        "hse.risk.assess.required_hint": "Felt merket med * må fylles ut",
        "hse.risk.assess.how_to": "Lav = sjelden og liten skade. Moderat = kan skje og gi fravær. Høy = sannsynlig eller alvorlig.",
        "hse.risk.assess.tiltak_prompt": "Ved moderat eller høyere risiko bør dere legge til et risikoreduserende tiltak.",
        "hse.risk.assess.extended": "Utvidet vurdering",
        "hse.risk.assess.files": "Filer",
        "hse.risk.assess.files_empty": "Ingen filer lagt ved.",
        "hse.risk.fields.title": "Tittel",
        "hse.risk.fields.category": "Kategori",
        "hse.risk.fields.description": "Beskrivelse",
        "hse.risk.fields.consequence": "Konsekvens",
        "hse.risk.fields.consequence_placeholder": "Hva kan dette føre til hos dere?",
        "hse.risk.fields.level": "Hvor stor er risikoen?",
        "hse.risk.fields.level_placeholder": "Velg nivå",
        "hse.risk.fields.status": "Status",
        "hse.risk.fields.work_task": "Arbeidsoppgave",
        "hse.risk.fields.cause": "Utløsende årsak",
        "hse.risk.fields.existing": "Eksisterende tiltak",
        "hse.risk.fields.history": "Historikk",
        "hse.risk.fields.likelihood": "Sannsynlighet",
        "hse.risk.fields.consequence_score": "Konsekvens (1–5)",
        "hse.risk.fields.choose": "Velg",
        "hse.risk.level.unset": "Ikke vurdert",
        "hse.risk.level.very_low": "Svært lav",
        "hse.risk.level.low": "Lav",
        "hse.risk.level.moderate": "Moderat",
        "hse.risk.level.high": "Høy",
        "hse.risk.level.very_high": "Svært høy",
        "hse.risk.status.draft": "Kladd",
        "hse.risk.status.assessed": "Vurdert",
        "hse.risk.status.excluded": "Skal ikke vurderes",
        "hse.risk.status.closed": "Lukket",
        "hse.risk.category.safety": "Sikkerhet",
        "hse.risk.category.physical": "Fysisk",
        "hse.risk.category.psychosocial": "Psykososialt",
        "hse.risk.category.organizational": "Organisatorisk",
        "hse.risk.category.environmental": "Miljø",
        "hse.risk.category.chemical": "Kjemisk",
        "hse.risk.category.climate": "Klima",
        "hse.risk.theme.electrical": "Elektrisk",
        "hse.risk.theme.fire": "Brann",
        "hse.risk.theme.fall": "Fall",
        "hse.risk.theme.tools": "Verktøy",
        "hse.risk.theme.chemical": "Kjemikalier",
        "hse.risk.theme.psychosocial": "Psykososialt",
        "hse.risk.theme.organizational": "Organisasjon",
        "hse.risk.theme.climate": "Klima",
        "hse.risk.catalog.electric_shock": "Elektrisk støt og strømgjennomgang",
        "hse.risk.catalog.electric_shock_consequence": "Brannskade, hjertestans eller fravær etter arbeid på anlegg.",
        "hse.risk.catalog.live_work": "Arbeid nær spenning",
        "hse.risk.catalog.live_work_consequence": "Støt eller lysbue hvis avstand og sikring svikter.",
        "hse.risk.catalog.fire_hot_work": "Brann og varmearbeid",
        "hse.risk.catalog.fire_hot_work_consequence": "Brann i bygg eller materiell, røykskade.",
        "hse.risk.catalog.flammable": "Brennbare væsker og gass",
        "hse.risk.catalog.flammable_consequence": "Eksplosjon eller brann ved lekkasje og tennkilde.",
        "hse.risk.catalog.fall_from_height": "Fall fra høyde",
        "hse.risk.catalog.fall_from_height_consequence": "Alvorlig personskade ved arbeid i høyden.",
        "hse.risk.catalog.slip_trip": "Fall, snubling og glatt underlag",
        "hse.risk.catalog.slip_trip_consequence": "Brudd, forstuing eller fravær.",
        "hse.risk.catalog.cuts": "Kutt og stikk",
        "hse.risk.catalog.cuts_consequence": "Kutt, infeksjon eller tap av funksjon.",
        "hse.risk.catalog.machinery": "Maskiner og bevegelige deler",
        "hse.risk.catalog.machinery_consequence": "Klemming, kutt eller amputasjon.",
        "hse.risk.catalog.chemical_exposure": "Kjemikalieeksponering",
        "hse.risk.catalog.chemical_exposure_consequence": "Etsing, allergi eller langtidsskade.",
        "hse.risk.catalog.dust_fume": "Støv og røyk",
        "hse.risk.catalog.dust_fume_consequence": "Luftveisplager og nedsatt arbeidsevne.",
        "hse.risk.catalog.conflicts": "Konflikter",
        "hse.risk.catalog.conflicts_consequence": "Sykefravær, dårlig samarbeid og feil i arbeidet.",
        "hse.risk.catalog.workload": "Høy arbeidsbelastning",
        "hse.risk.catalog.workload_consequence": "Utmattelse og flere feil.",
        "hse.risk.catalog.human_error": "Menneskelig svikt",
        "hse.risk.catalog.human_error_consequence": "Feilhandling som gir skade eller avvik.",
        "hse.risk.catalog.communication": "Kommunikasjon",
        "hse.risk.catalog.communication_consequence": "Misforståelser som gir ulykke eller kvalitetsfeil.",
        "hse.risk.catalog.competence": "Manglende kompetanse",
        "hse.risk.catalog.competence_consequence": "Feil utførelse fordi opplæring mangler.",
        "hse.risk.catalog.extreme_weather": "Ekstremvær",
        "hse.risk.catalog.extreme_weather_consequence": "Stopp i arbeid, skade på materiell eller person.",
        "hse.risk.catalog.heat_cold": "Varme og kulde",
        "hse.risk.catalog.heat_cold_consequence": "Heteslag, forfrysning eller nedsatt evne.",
        "hse.risk.scale.likelihood.1": "Svært sjelden",
        "hse.risk.scale.likelihood.2": "Sjelden",
        "hse.risk.scale.likelihood.3": "Mulig",
        "hse.risk.scale.likelihood.4": "Sannsynlig",
        "hse.risk.scale.likelihood.5": "Nesten sikkert",
        "hse.risk.scale.consequence.1": "Ubetydelig",
        "hse.risk.scale.consequence.2": "Liten",
        "hse.risk.scale.consequence.3": "Moderat",
        "hse.risk.scale.consequence.4": "Alvorlig",
        "hse.risk.scale.consequence.5": "Katastrofal",
        "hse.risk.info.title.title": "Tittel",
        "hse.risk.info.title.body": "Kort navn på utfordringen, for eksempel «Elektrisk støt».",
        "hse.risk.info.description.title": "Beskrivelse",
        "hse.risk.info.description.body": "Hva gjør at dette kan være en utfordring hos dere?",
        "hse.risk.info.category.title": "Kategori",
        "hse.risk.info.category.body": "Hjelper dere å sortere. Sikkerhet, fysisk, psykososialt, organisatorisk, miljø, kjemisk eller klima.",
        "hse.risk.info.consequence.title": "Konsekvens",
        "hse.risk.info.consequence.body": "Hva kan skje hos dere — skade, fravær, brann eller stopp. Hold det kort.",
        "hse.risk.info.level.title": "Risikonivå",
        "hse.risk.info.level.body": "Helhetsvurdering. Moderat og høyere bør ha tiltak. Bruk utvidet vurdering for 1–5-tall til matrisen.",
        "hse.risk.info.matrix.title": "Sannsynlighet og konsekvens",
        "hse.risk.info.matrix.body": "Valgfritt. 1–5 for hver. Produktet plasserer risikoen i 5×5-matrisen.",
        "hse.risk.info.tiltak.title": "Tiltak",
        "hse.risk.info.tiltak.body": "Knytt eksisterende tiltak eller opprett nytt. Nytt tiltak sendes til /hse/tiltak med risiko som kilde.",
        "hse.risk.info.climate.title": "Klimarisiko",
        "hse.risk.info.climate.body": "Kort tittel på en fysisk eller overgangsrisiko, for eksempel ekstremvær på anlegg.",
        "hse.risk.info.sja.title": "SJA",
        "hse.risk.info.sja.body": "Sikker jobb-analyse for en konkret jobb. Steg og farer kan fylles ut etter tittel.",
        "hse.risk.tiltak.how": "Hvordan jobber dere med dette?",
        "hse.risk.tiltak.new": "Nytt tiltak",
        "hse.risk.tiltak.create": "Opprett tiltak",
        "hse.risk.tiltak.link_existing": "Legg til eksisterende tiltak",
        "hse.risk.tiltak.link": "Knytt",
        "hse.risk.tiltak.linked": "Tiltak knyttet",
        "hse.risk.tiltak.empty": "Ingen tiltak knyttet ennå.",
        "hse.risk.tiltak.count": "{{count}} tiltak",
        "hse.risk.tiltak.save_first": "Lagre risikoen før du knytter tiltak.",
        "hse.risk.tiltak.choose_assignee": "Velg ansvarlig",
        "hse.risk.tiltak.title_from_risk": "Reduser risiko: {{title}}",
        "hse.risk.matrix.title": "Risikomatrise",
        "hse.risk.matrix.subtitle": "Sannsynlighet (rad) × konsekvens (kolonne).",
        "hse.risk.matrix.likelihood": "Sannsynlighet",
        "hse.risk.matrix.legend": "Grønt = lav, gult = moderat, oransje/rødt = høy. Klikk tittel for detaljer.",
        "hse.risk.sja.title": "Sikker jobb-analyse",
        "hse.risk.sja.subtitle": "Opprett, list og vis SJA.",
        "hse.risk.sja.new": "Ny SJA",
        "hse.risk.sja.edit": "Rediger SJA",
        "hse.risk.sja.form_subtitle": "Tittel og jobbtype først. Steg og farer kan fylles ut etterpå.",
        "hse.risk.sja.view_title": "SJA",
        "hse.risk.sja.view_subtitle": "Steg og farer for jobben",
        "hse.risk.sja.empty": "Ingen SJA ennå.",
        "hse.risk.sja.load_failed": "Kunne ikke laste SJA",
        "hse.risk.sja.created": "SJA opprettet",
        "hse.risk.sja.updated": "SJA oppdatert",
        "hse.risk.sja.work_type": "Jobbtype",
        "hse.risk.sja.work_type.routine": "Rutinearbeid",
        "hse.risk.sja.work_type.non_routine": "Ikke-rutine",
        "hse.risk.sja.work_type.maintenance": "Vedlikehold",
        "hse.risk.sja.work_type.construction": "Bygg / anlegg",
        "hse.risk.sja.work_type.emergency": "Nød",
        "hse.risk.sja.work_type.special": "Spesial",
        "hse.risk.sja.status.draft": "Kladd",
        "hse.risk.sja.status.pending_approval": "Venter godkjenning",
        "hse.risk.sja.status.approved": "Godkjent",
        "hse.risk.sja.status.in_use": "I bruk",
        "hse.risk.sja.status.archived": "Arkivert",
        "hse.risk.sja.location": "Sted",
        "hse.risk.sja.steps": "Steg",
        "hse.risk.sja.add_step": "Legg til steg",
        "hse.risk.sja.step_n": "Steg {{n}}",
        "hse.risk.sja.step_placeholder": "Hva gjøres i dette steget?",
        "hse.risk.sja.hazards_placeholder": "Farer, én per linje",
        "hse.risk.sja.hazards": "Farer",
        "hse.risk.climate.title": "Klimarisiko",
        "hse.risk.climate.subtitle": "Korte vurderinger av klima og overgang.",
        "hse.risk.climate.new": "Ny klimarisiko",
        "hse.risk.climate.empty": "Ingen klimarisikoer ennå.",
        "hse.risk.climate.load_failed": "Kunne ikke laste klimarisiko",
        "hse.risk.climate.created": "Klimarisiko opprettet",
        "hse.risk.climate.updated": "Klimarisiko oppdatert",
        "hse.risk.climate.edit": "Rediger klimarisiko",
        "hse.risk.climate.horizon_label": "Tidshorisont",
        "hse.risk.climate.category.physical_risks": "Fysiske risikoer",
        "hse.risk.climate.category.transition_risks": "Overgangsrisikoer",
        "hse.risk.climate.category.regulatory_risks": "Regulatorisk",
        "hse.risk.climate.category.market_risks": "Marked",
        "hse.risk.climate.category.reputational_risks": "Omdømme",
        "hse.risk.climate.horizon.short_term": "Kort sikt (0–2 år)",
        "hse.risk.climate.horizon.medium_term": "Mellomlang (3–5 år)",
        "hse.risk.climate.horizon.long_term": "Lang sikt (6–10 år)",
        "hse.risk.climate.horizon.very_long_term": "Svært lang (10+ år)",
        "hse.risk.level.lav": "Lav",
        "hse.risk.level.moderat": "Moderat",
        "hse.risk.level.hoy": "Høy",
        "hse.risk.level.kritisk": "Kritisk",
        "hse.risk.status.suggested": "Foreslått",
        "hse.risk.status.in_progress": "Under arbeid",
        "hse.risk.status.skipped": "Skal ikke vurderes",
        "hse.risk.category.sikkerhet": "Sikkerhet",
        "hse.risk.category.organisatorisk": "Organisatorisk",
        "hse.risk.category.psykososialt": "Psykososialt",
        "hse.risk.category.fysisk": "Fysisk",
        "hse.risk.category.kjemisk": "Kjemisk",
        "hse.risk.category.ergonomisk": "Ergonomisk",
        "hse.risk.category.miljo": "Miljø",
        "hse.risk.add.suggest": "Foreslå fra bransje",
        "hse.risk.add.suggest_hint": "AI foreslår vanlige utfordringer for bransje eller fag.",
        "hse.risk.suggest.hint": "Skriv bransje og/eller fag. Forslagene lagres som kladder dere kan vurdere.",
        "hse.risk.suggest.industry": "Bransje",
        "hse.risk.suggest.fag": "Fag",
        "hse.risk.suggest.run": "Foreslå risikoer",
        "hse.risk.suggest.working": "Foreslår…",
        "hse.risk.suggest.error_industry": "Skriv bransje eller fag",
        "hse.risk.suggest.empty": "Ingen forslag denne gangen",
        "hse.risk.suggest.failed": "Kunne ikke foreslå risikoer",
        "hse.risk.setup.title": "HMS-oppsett mangler",
        "hse.risk.setup.responsible": "HMS-ansvarlig er ikke satt",
        "hse.risk.setup.verneombud": "Verneombud er ikke satt",
        "hse.risk.setup.categories": "Risikokategorier mangler",
        "hse.risk.setup.ai_key": "AI er slått på, men nøkkel mangler",
        "hse.risk.sja.submit": "Send til godkjenning",
        "hse.risk.sja.approve": "Godkjenn",
        "hse.risk.sja.submitted": "SJA sendt til godkjenning",
        "hse.risk.sja.approved": "SJA godkjent",
        "hse.sja.submit": "Send til godkjenning",
        "hse.sja.approve": "Godkjenn",
        "hse.sja.approve_verneombud": "Godkjenn som verneombud",
        "hse.sja.approve_leader": "Godkjenn som leder",
        "hse.sja.submitted": "SJA sendt til godkjenning",
        "hse.sja.approved": "SJA godkjent",
        "hse.sja.status_follows_approval": "Status settes når verneombud eller leder godkjenner. Den kan ikke velges fritt.",
        "hse.sja.template.pick": "Steg-mal",
        "hse.sja.template.hint": "Velg en ferdig mal eller en eksisterende SJA i stedet for å skrive alle steg selv.",
        "hse.sja.template.placeholder": "Velg steg-mal",
        "hse.sja.template.apply": "Bruk mal",
        "hse.sja.template.applying": "Legger inn…",
        "hse.sja.template.applied": "Steg fra malen er lagt inn",
        "hse.sja.template.loading": "Laster maler…",
        "hse.sja.template.empty": "Ingen steg-maler ennå. Skriv stegene, eller bruk en tidligere SJA når den finnes.",
        "hse.sja.template.empty_steps": "Malen har ingen steg å legge inn.",
        "hse.sja.template.load_failed": "Kunne ikke laste steg-mal",
        "hse.sja.template.untitled": "Uten tittel",
        "hse.sja.approve_daglig_leder": "Godkjenn som daglig leder",
        "hse.sja.approve_annen_leder": "Godkjenn som annen leder",
        "hse.sja.role.verneombud": "Verneombud",
        "hse.sja.role.daglig_leder": "Daglig leder",
        "hse.sja.role.annen_leder": "Annen leder",
        "hse.sja.approval.title": "Godkjenning",
        "hse.sja.approval.pending": "Venter på",
        "hse.sja.approval.empty": "Ingen godkjenninger venter.",
        "hse.sja.not_editable": "SJA kan bare redigeres mens den er kladd.",
        "hse.settings.other_manager.title": "Annen leder",
        "hse.settings.other_manager.description": "Personen som godkjenner SJA som annen leder. Tomt = HMS-ansvarlig brukes.",
        "todo.journalTitle": "Dagbok / journal",
        "todo.journalDate": "Dato",
        "todo.journalHint": "Notater for valgt dag (HTML). Lagres automatisk.",
        "todo.journalHintRich":
          "Marker tekst for å formatere (som i Notion). Du kan lime inn HTML fra nett og OneNote — uønsket kode fjernes ved lagring.",
        "todo.journalPlaceholder": "Skriv notater for denne dagen…",
        "todo.journalFullscreen": "Fullskjerm",
        "todo.journalExitFullscreen": "Lukk fullskjerm",
        "todo.journalOpenInFullscreen": "Redigering skjer i fullskjermvinduet. Lukk der når du er ferdig.",
        "todo.journalSaveError": "Kunne ikke lagre dagbok.",
        "todo.journalImageTitle": "Bilde",
        "todo.journalImageWidth": "Bredde",
        "todo.journalImageWidthHint": "Piksler (320) eller prosent (50 %).",
        "todo.journalImageHeight": "Høyde",
        "todo.journalImageHeightPlaceholder": "Valgfri (tom = automatisk)",
        "todo.journalImageAlt": "Beskrivelse (alt-tekst)",
        "todo.journalImageSizePresets": "Hurtigstørrelse",
        "todo.journalImageOriginal": "Nullstill størrelse",
        "todo.journalImageAlign": "Justering",
        "todo.journalImageAlignLeft": "Venstre",
        "todo.journalImageAlignCenter": "Senter",
        "todo.journalImageAlignRight": "Høyre",
        "todo.journalImageApply": "Bruk",
        "todo.journalImageRemove": "Fjern bilde",
        "todo.digestTitle": "E-post påminnelser",
        "todo.digestMorning": "Morgen (ca. 07:00, din tidssone)",
        "todo.digestEvening": "Kveld (ca. 17:00)",
        "todo.digestTimezone": "Tidssone",
        "todo.digestSaved": "Innstillinger lagret",
        "todo.digestSaveError": "Kunne ikke lagre e-postinnstillinger.",
        "todo.prevDay": "Forrige dag",
        "todo.nextDay": "Neste dag",
        "todo.today": "I dag",
        "richTextEditor.contextMenu.ariaLabel": "Handlinger for rik tekst",
        "richTextEditor.contextMenu.cut": "Klipp ut",
        "richTextEditor.contextMenu.copy": "Kopier",
        "richTextEditor.contextMenu.paste": "Lim inn",
        "richTextEditor.contextMenu.insertImage": "Sett inn bilde…",
        "richTextEditor.contextMenu.moveSelectionToPage": "Flytt merking til side…",
        "richTextEditor.contextMenu.createPageWithSelection": "Ny side fra merking…",
        "richTextEditor.contextMenu.handlerMissing": "Knytt en behandler i foreldrekomponenten for å bruke denne handlingen.",
        "richTextEditor.table.insert": "Sett inn tabell",
        "richTextEditor.table.hint": "Legger til en redigerbar 3 x 3-tabell.",
        "richTextEditor.table.defaultHeader": "Kolonne",
        "automile.checkoutConfirmTitle": "Sjekke ut av kjøretøy?",
        "automile.checkoutConfirmMessage": "Er du sikker på at du vil sjekke ut? Kjøretøyet blir frigjort for andre sjåfører.",
        "automile.checkoutConfirm": "Ja, sjekk ut",
        "automile.checkoutCancel": "Avbryt",
        "automile.checkInDriver": "Sjekk inn sjåfør",
        "automile.checkOutVehicle": "Sjekk ut sjåfør",
        "automile.linkUser": "Knytt bruker",
        "automile.selectEmployee": "Velg ansatt",
        "automile.noVehiclesAvailable": "Ingen ledige kjøretøy (aktive og uten innlogget sjåfør).",
        "automile.settingsHint": "Fullfør Automile under Firma → Integrasjoner.",
        "automile.driverNeedsSync": "Sjåføren må være synkronisert med Automile før innlogging.",
        "automile.onlyAvailableVehiclesSubtitle": "Bare aktive kjøretøy uten innlogget sjåfør vises.",
        "automile.noDriversFreeForCheckin": "Ingen sjåfører uten innlogget kjøretøy (med tilkoblet bruker).",
        "automile.adminVehiclePickerSubtitle":
          "Alle aktive kjøretøy vises. Er kjøretøyet sjekket inn på noen andre, flyttes det til denne sjåføren når du velger det (for flåteansvarlige).",
        "automile.noActiveVehiclesForFleet": "Ingen aktive kjøretøy funnet.",
        "automile.vehicleOccupiedBadge": "Innlogget — ny tildeling sjekker ut nåværende sjåfør først",
        "automile.userName": "Bruker / Navn",
        "automile.checkedIntoVehicle": "Sjekket inn i kjøretøy",
        "automile.distanceDriven": "Kjørt distanse",
        "automile.notCheckedIn": "Ikke sjekket inn",
        "automile.noUserLinked": "Bruker ikke tilknyttet",
        "automile.from": "Fra",
        "automile.to": "Til",
        "Drivers": "Sjåfører",
        "Driver": "Sjåfør",
        "Module": "Modul",
        "Distance": "Distanse",

        "platformBroadcast.scheduledLabel": "Planlagt oppdatering",
        "platformBroadcast.countdownPrefix": "Om {{time}}",
        "platformBroadcast.scheduledOverdue": "Starttid er nådd — lagre arbeidet ditt",
        "platformBroadcast.activeNoticesRegion": "Aktive meldinger fra Promang",
        "platformBroadcast.noticeWarningTag": "Advarsel",
        "platformBroadcast.noticeInfoTag": "Info",
        "platformBroadcast.updatingTitle": "Promang oppdateres",
        "platformBroadcast.updatingHint": "Vi er tilbake så snart oppdateringen er ferdig. Takk for tålmodigheten.",
        "platformBroadcast.updatingAdminHint":
          "Administrator: Når du er ferdig med utrullingen, trykk på skiftenøkkelen nede til høyre og velg «Bekreft at Promang er oppdatert».",
        "platformBroadcast.dev.menuAria": "Plattform-dev-meny",
        "platformBroadcast.dev.noActiveUpdate": "Ingen aktiv vedlikeholdssesjon.",
        "platformBroadcast.dev.statusLine": "{{phase}}: {{title}}",
        "platformBroadcast.dev.scheduleUpdate": "Planlegg oppdatering",
        "platformBroadcast.dev.startMaintenance": "Start vedlikehold (oppdatering pågår)",
        "platformBroadcast.dev.confirmComplete": "Bekreft at Promang er oppdatert",
        "platformBroadcast.dev.addNotice": "Legg til melding (info / advarsel)",
        "platformBroadcast.dev.manageNotices": "Håndter meldinger",
        "platformBroadcast.dev.fieldTitle": "Tittel",
        "platformBroadcast.dev.fieldDescription": "Beskrivelse",
        "platformBroadcast.dev.fieldScheduledAt": "Tidspunkt for oppdatering",
        "platformBroadcast.dev.fieldExpectedEnd": "Forventet ferdig ca.",
        "platformBroadcast.dev.fieldKind": "Type",
        "platformBroadcast.dev.kindInfo": "Info",
        "platformBroadcast.dev.kindWarning": "Advarsel",
        "platformBroadcast.dev.cancel": "Avbryt",
        "platformBroadcast.dev.save": "Lagre",
        "platformBroadcast.dev.start": "Start",
        "platformBroadcast.dev.close": "Lukk",
        "platformBroadcast.dev.maintenanceHint": "Brukere ser nå fullskjerms «Promang oppdateres» med nedtelling til forventet slutt.",
        "platformBroadcast.dev.validationTitleTime": "Fyll inn tittel og tidspunkt.",
        "platformBroadcast.dev.validationTitle": "Fyll inn tittel.",
        "platformBroadcast.dev.invalidTime": "Ugyldig tidspunkt.",
        "platformBroadcast.dev.saved": "Planlagt oppdatering er lagret.",
        "platformBroadcast.dev.maintenanceStarted": "Vedlikehold startet.",
        "platformBroadcast.dev.confirmCompletePrompt": "Bekreft at oppdateringen er ferdig og fjern alle vedlikeholdsmeldinger for denne runden?",
        "platformBroadcast.dev.confirmed": "Bekreftet.",
        "platformBroadcast.dev.noticeCreated": "Melding opprettet.",
        "platformBroadcast.dev.noticeHidden": "Melding skjult.",
        "platformBroadcast.dev.noticeShown": "Melding vist igjen.",
        "platformBroadcast.dev.requestFailed": "Forespørsel feilet.",
        "platformBroadcast.dev.historyHint": "Skjul meldinger når problemet er løst. Oppdateringshistorikk lagres i databasen.",
        "platformBroadcast.dev.recentUpdates": "Siste planlagte oppdateringer",
        "platformBroadcast.dev.allNotices": "Alle meldinger",
        "platformBroadcast.dev.hidden": "skjult",
        "platformBroadcast.dev.hide": "Skjul",
        "platformBroadcast.dev.show": "Vis igjen",
        "platformBroadcast.dev.roleViewMenu": "Simuler rollevisning (kun UI)",
        "platformBroadcast.dev.sentryReporting": "Send feil til Sentry",
        "platformBroadcast.dev.sentryReportingHint":
          "Av som standard i utvikling. Demper denne nettleseren og API-feil fra forespørslene dine.",
        "platformBroadcast.dev.sentryReportingOn": "Sentry-rapportering slått på.",
        "platformBroadcast.dev.sentryReportingOff": "Sentry-rapportering slått av.",
        "platformBroadcast.dev.roleViewTitle": "Hvordan Promang ser ut for deg",
        "platformBroadcast.dev.roleViewTabPresets": "Forhåndsvalg",
        "platformBroadcast.dev.roleViewTabCustom": "Tilpasset (som brukeradmin)",
        "platformBroadcast.dev.roleViewHintCustom":
          "Samme brytere som under Selskap → Brukere. Trykk «Bruk simulering» nederst når du er ferdig.",
        "platformBroadcast.dev.roleViewCustomApply": "Bruk simulering",
        "platformBroadcast.dev.roleViewHint":
          "Gjelder bare denne nettleseren: meny, rutetilgang, RoleOnly og tilhørende hooks. API-et bruker fortsatt dine ekte rettigheter.",
        "platformBroadcast.dev.roleViewApply": "Bruk",
        "platformBroadcast.dev.roleViewReset": "Nullstill simulering",
        "platformBroadcast.dev.roleViewResetNow": "Nullstill simulering",
        "platformBroadcast.dev.roleViewActiveBanner":
          "Rolle-simulering er på — grensesnittet viser ikke dine ekte rettigheter.",
        "platformBroadcast.dev.roleViewToastApplied": "Rolle-simulering oppdatert.",
        "platformBroadcast.dev.roleViewToastReset": "Rolle-simulering fjernet.",
        "platformBroadcast.dev.roleViewPreset.off.label": "Ekte rettigheter",
        "platformBroadcast.dev.roleViewPreset.off.description":
          "Bruk roller fra serveren (standard).",
        "platformBroadcast.dev.roleViewPreset.none.label": "Ingen roller",
        "platformBroadcast.dev.roleViewPreset.none.description":
          "Tom rolliste — nesten ingen moduler i menyen.",
        "platformBroadcast.dev.roleViewPreset.hours_time_only.label":
          "Kun timeregistrering",
        "platformBroadcast.dev.roleViewPreset.hours_time_only.description":
          "Timer-modul med registrering/redigering av egne timer — ikke godkjenning, innstillinger eller fravær.",
        "platformBroadcast.dev.roleViewPreset.hours_extended.label":
          "Timer + godkjenning og fravær",
        "platformBroadcast.dev.roleViewPreset.hours_extended.description":
          "Bred timer-profil: lister, godkjenning, lesetilgang til innstillinger, fraværsregistrering.",
        "platformBroadcast.dev.roleViewPreset.service_field.label":
          "Service ute i felt",
        "platformBroadcast.dev.roleViewPreset.service_field.description":
          "Fokus på serviceoversikt og rapporter; begrenset avtaletilgang.",
        "platformBroadcast.dev.roleViewPreset.projects_participant.label":
          "Prosjektdeltaker",
        "platformBroadcast.dev.roleViewPreset.projects_participant.description":
          "Prosjekter og arbeidsordrer med typiske utfører-handlinger.",
        "platformBroadcast.dev.roleViewPreset.project_leader_all.label":
          "Prosjektleder (alle prosjekter)",
        "platformBroadcast.dev.roleViewPreset.project_leader_all.description":
          "Prosjektadministrator med full tilgang til alle prosjekter og arbeidsordrer.",
        "platformBroadcast.dev.roleViewPreset.project_leader_selected.label":
          "Prosjektleder (valgte prosjekter)",
        "platformBroadcast.dev.roleViewPreset.project_leader_selected.description":
          "Prosjektroller uten full firmaadministrasjon; full tilgang gis per prosjekt.",
        "Send Offer": "Send tilbud",
        "Choose recipient, offer PDF version and customer message before sending.":
          "Velg mottaker, PDF-variant og kundemelding før tilbudet sendes.",
        "Offer sending has been queued. You will be notified when it's complete.":
          "Tilbudssending er lagt i kø. Du får beskjed når den er ferdig.",
        "Something went wrong. Could not send offer.":
          "Noe gikk galt. Kunne ikke sende tilbudet.",
        "Offer Type": "Tilbudstype",
        "Internal offer": "Internt tilbud",
        "Customer offer": "Kundetilbud",
        "Open selected offer PDF": "Åpne valgt tilbuds-PDF",
        "PDF preview will be available when the selected offer type is generated.":
          "PDF-forhåndsvisning blir tilgjengelig når valgt tilbudstype er generert.",
        "Message to customer": "Melding til kunde",
        "Offer sent successfully!": "Tilbudet ble sendt.",
        "Offer sending queued...": "Tilbudssending er lagt i kø...",
        "Generating PDF and sending offer...":
          "Genererer PDF og sender tilbud...",
        "Failed to send offer": "Kunne ikke sende tilbud",
        "Failed to send offer. Please try again.":
          "Kunne ikke sende tilbudet. Prøv igjen.",
        "Request timed out. Please check the offer status manually.":
          "Forespørselen tok for lang tid. Sjekk tilbudsstatus manuelt.",
        "publicAppointment.title": "Bekreft avtalen",
        "publicAppointment.subtitle": "Kontroller detaljene og bekreft at tidspunktet fortsatt passer.",
        "publicAppointment.sectionAppointment": "Avtale",
        "publicAppointment.sectionWork": "Oppdraget",
        "publicAppointment.reportType": "Type oppdrag",
        "publicAppointment.serviceAddress": "Oppdragsadresse",
        "publicAppointment.workDescription": "Oppdragsbeskrivelse",
        "publicAppointment.timeExactHint": "Oppmøte skjer omtrent ved dette tidspunktet.",
        "publicAppointment.timeWindowHint": "Oppmøte skjer innenfor dette tidsrommet.",
        "publicAppointment.reportNumber": "Oppdrag / rapportnr.",
        "publicAppointment.date": "Dato",
        "publicAppointment.time": "Tid",
        "publicAppointment.companyFallback": "Leverandør",
        "publicAppointment.confirmHint":
          "Når du bekrefter, registrerer vi avtalen som akseptert. Trenger du endringer, ta kontakt på telefon eller e-post.",
        "publicAppointment.termsAcceptPlain":
          "Ved å bekrefte avtalen godtar du våre betingelser for bruk av tjenester, salg og serviceavtaler.",
        "publicAppointment.termsAcceptPrefix": "Ved å bekrefte avtalen godtar du våre ",
        "publicAppointment.termsAcceptLink": "betingelser for bruk av tjenester, salg og serviceavtaler",
        "publicAppointment.termsAcceptSuffix": ".",
        "publicAppointment.confirmButton": "Bekreft avtalen",
        "publicAppointment.submitting": "Bekrefter…",
        "publicAppointment.successTitle": "Takk — avtalen er bekreftet",
        "publicAppointment.successBody": "Du kan lukke siden. Ved endringer, kontakt selskapet direkte.",
        "publicAppointment.alreadyConfirmed": "Denne avtalen er allerede bekreftet.",
        "publicAppointment.loadFailed": "Vi fant ikke avtalen. Lenken kan være ugyldig eller utløpt.",
        "publicAppointment.confirmFailed": "Vi kunne ikke registrere bekreftelsen. Prøv igjen eller ta kontakt.",
        "publicAppointment.missingToken": "Bekreftelseslenken mangler nødvendig informasjon.",

        "community.title": "Tilbakemelding og forslag",
        "community.subtitle": "Rapporter feil, foreslå forbedringer og stem på hva vi bør bygge videre.",
        "community.tab.feed": "Ideer og stemmer",
        "community.tab.mine": "Mine innsendinger",
        "community.tab.report": "Send inn",
        "community.feed.section.accepted": "Godkjent av Promang",
        "community.feed.section.accepted_help": "Disse forslagene er godkjent og forblir synlige her etter admin-godkjenning.",
        "community.feed.section.open": "Åpne for avstemning",
        "community.kind.bug": "Feilrapport",
        "community.kind.feature": "Ny funksjon",
        "community.kind.improvement": "Forbedring",
        "community.form.title": "Tittel",
        "community.form.description": "Beskrivelse",
        "community.form.kind": "Type",
        "community.form.submit": "Send inn",
        "community.form.submitting": "Sender…",
        "community.form.success": "Takk! AI og teamet vårt vurderer innsendingen.",
        "community.form.error": "Kunne ikke sende inn melding",
        "community.form.screenshot": "Skjermbilde (valgfritt)",
        "community.form.screenshot_help": "Legg ved eit skjermbilde for å hjelpe oss å reprodusere feil eller illustrere idéen din.",
        "community.form.screenshot_add": "Legg til bilete",
        "community.form.screenshot_preview": "Førehandsvisning av skjermbilde",
        "community.form.screenshot_remove": "Fjern skjermbilde",
        "community.form.image_invalid": "Vel eit biletfil (PNG, JPG, GIF eller WebP).",
        "community.fab_label": "Idear og tilbakemelding",
        "community.votes": "stemmer",
        "community.vote": "Stem",
        "community.unvote": "Fjern stemme",
        "community.status.submitted": "Sendt inn",
        "community.status.triaging": "AI-vurdering",
        "community.status.pending_approval": "Venter på admin",
        "community.status.approved": "Godkjent",
        "community.status.in_progress": "Fiks pågår",
        "community.status.resolved": "Løst",
        "community.status.declined": "Avslått",
        "community.status.spam": "Avvist",
        "community.triage_summary": "AI-vurdering",
        "community.empty_feed": "Ingen forslag ennå — vær den første.",
        "community.empty_mine": "Du har ikke sendt inn noe ennå.",

        "globalSearch.trigger_label": "Søk i Promang",
        "globalSearch.trigger_short": "Søk …",
        "globalSearch.input_label": "Søk i Promang",
        "globalSearch.input_placeholder": "Søk kunder, prosjekt, rapporter, saker, HMS-dokumenter, kontakter …",
        "globalSearch.searching": "Søker…",
        "globalSearch.error": "Noe gikk galt under søket. Prøv igjen.",
        "globalSearch.empty_title": "Søk i hele Promang",
        "globalSearch.empty_hint": "Skriv for å finne kunder, prosjekt, rapporter, saker, HMS-dokumenter og kontakter. Prøv et forslag under, eller skriv på norsk eller engelsk.",
        "globalSearch.footer_navigate": "↑↓ for å navigere",
        "globalSearch.footer_open": "Enter for å åpne",
        "globalSearch.footer_shortcut": "{{shortcut}} for å søke",
        "globalSearch.suggestion.latest_project": "Siste prosjekt",
        "globalSearch.suggestion.latest_report": "Siste rapport på kunde …",
        "globalSearch.suggestion.find_customer": "Finn kunde …",
        "globalSearch.suggestion.find_project": "Finn prosjekt …",
        "globalSearch.suggestion.find_hse_document": "Finn HMS-dokument …",
        "globalSearch.suggestion.report_status": "Status rapport …",
        "globalSearch.no_customer": "Fant ingen kunde med navn «{{name}}».",
        "globalSearch.multiple_customers": "Fant flere kunder som matcher «{{name}}». Velg riktig kunde:",
        "globalSearch.no_results_for_customer": "Fant ingen {{entity}} for {{customer}}.",
        "globalSearch.no_results": "Ingen treff for «{{query}}».",
        "globalSearch.latest_for_customer": "Nyeste {{entity}} for {{customer}}:",
        "globalSearch.latest_entity": "Nyeste {{entity}} i Promang:",
        "globalSearch.no_latest_entity": "Fant ingen {{entity}} i Promang.",
        "globalSearch.found_count": "Fant {{count}} treff",
        "globalSearch.status_result": "{{title}} — status: {{status}}",
        "globalSearch.status.unknown": "Ukjent",
        "globalSearch.status.customer.active": "Aktiv kunde",
        "globalSearch.status.customer.inactive": "Inaktiv kunde",
        "globalSearch.status.project.active": "Aktivt prosjekt",
        "globalSearch.status.project.inactive": "Inaktivt prosjekt",
        "globalSearch.status.project.finished": "Avsluttet prosjekt",
        "globalSearch.module.hse_document": "HMS-dokumenter",
        "globalSearch.entity.hse_document": "HMS-dokument",

        "dashboard.header.open_menu": "Åpne meny",
        "dashboard.header.close_sidebar": "Lukk sidemeny",
        "dashboard.header.more_actions": "Flere handlinger",
        "dashboard.header.view_notifications": "Vis varsler",
        "dashboard.header.view_tasks": "Vis oppgaver",
        "dashboard.header.tasks": "Oppgaver",
        "dashboard.header.loading_tasks": "Laster oppgaver…",
        "dashboard.header.unfinished": "Ikke ferdige",
        "dashboard.header.due_today": "Forfaller i dag",
        "dashboard.header.overdue": "Har forfalt",
        "dashboard.header.go_to_tasks": "Gå til oppgaver",
        "dashboard.header.companies": "Bedrifter",
        "dashboard.header.switch_company": "Bytt bedrift",
        "dashboard.header.loading_companies": "Laster bedrifter…",
        "dashboard.header.no_companies": "Ingen bedrifter tilgjengelig",
        "dashboard.header.open_user_menu": "Åpne brukermeny",
        "dashboard.header.your_profile": "Din profil",
        "dashboard.header.settings": "Innstillinger",
        "dashboard.header.microsoft_outlook": "Microsoft / Outlook",
        "dashboard.header.sign_out": "Logg ut",
        "dashboard.header.company_switched": "Bedrift byttet",
        "dashboard.header.company_switch_failed": "Kunne ikke bytte bedrift",
        "Oppdatering": "Oppdatering",
        "Innlegg": "Oppdatering",
        "status_update.mine_title": "Mine oppdateringer",
        "status_update.mine_search_placeholder": "Søk i mine oppdateringer…",
        "status_update.mine_empty": "Du har ingen oppdateringer ennå.",
        "status_update.mine_empty_search": "Ingen treff for søket.",
        "status_update.mine_load_more": "Last mer",
        "status_update.mine_untitled": "Uten tittel",
        "status_update.mine_no_subject_link": "Kunne ikke åpne tilknyttet objekt.",
        "status_update.mine_company_scope": "Firma",
        "status_update.subject_project": "Prosjekt",
        "status_update.subject_customer": "Kunde",
        "status_update.subject_work_order": "Arbeidsordre",
        "status_update.subject_project_activity": "Prosjektaktivitet",
        "status_update.unavailable_title": "Oppdatering er ikke tilgjengelig",
        "status_update.unavailable_description": "Modulen eller API-et er ikke rullet ut ennå, eller er midlertidig utilgjengelig. Prøv igjen senere.",
        "status_update.unavailable_nav_hint": "Oppdatering er ikke tilgjengelig akkurat nå",
        "status_update.load_error": "Kunne ikke laste oppdateringer.",
        "status_update.load_more_error": "Kunne ikke laste flere oppdateringer.",
        "status_update.delete_failed": "Kunne ikke slette oppdateringen.",
        "status_update.save_failed": "Kunne ikke lagre oppdateringen.",
        "status_update.saved": "Oppdatering lagret",
        "status_update.edit": "Rediger",
        "status_update.save": "Lagre",
        "status_update.cancel": "Avbryt",
        "status_update.edited": "redigert",
        "status_update.mentioned_here": "Nevnt her",
        "status_update.search_placeholder": "Søk i oppdateringer…",
        "status_update.search_empty": "Ingen treff for søket.",
        "status_update.retry": "Prøv igjen",
        "work_order.redesign.status_updates_title": "Oppdatering",
        "work_order.redesign.status_updates_meta": "Status, bilder og oppfølging",
        "notes.legacy_title": "Tidligere notater",
        "notes.legacy_hint": "Eldre notater og bilder (kun lesing). Nye oppdateringer skrives under Oppdatering.",
        "project.activities.status_updates_title": "Oppdatering",
        "Skriv oppdatering": "Skriv oppdatering",
        "Skriv innlegg": "Skriv oppdatering",
        "Skriv en oppdatering… bruk @ for å nevne, / for å koble modul": "Skriv en oppdatering… bruk @ for å nevne, / for å koble modul",
        "Skriv et innlegg… bruk @ for å nevne, / for å koble modul": "Skriv en oppdatering… bruk @ for å nevne, / for å koble modul",
        "Tittel (valgfritt)": "Tittel (valgfritt)",
        "Tittel": "Tittel",
        "Legg til tittel": "Legg til tittel",
        "Alle med tilgang": "Alle med tilgang",
        "Kun admin": "Kun admin",
        "Kun meg": "Kun meg",
        "Publiser": "Publiser",
        "Sender…": "Sender…",
        "Publisert": "Publisert",
        "Ingen oppdateringer ennå. Skriv den første!": "Ingen oppdateringer ennå. Skriv den første!",
        "Ingen innlegg ennå. Skriv det første!": "Ingen oppdateringer ennå. Skriv den første!",
        "Slette denne oppdateringen?": "Slette denne oppdateringen?",
        "Slette dette innlegget?": "Slette denne oppdateringen?",
        "Slett": "Slett",
        "Clear": "Tøm",
        "Velg…": "Velg…",
        "Skriv litt tekst eller legg til vedlegg for å publisere": "Skriv litt tekst eller legg til vedlegg for å publisere",
        "Kunne ikke publisere oppdateringen": "Kunne ikke publisere oppdateringen",
        "Kunne ikke publisere innlegget": "Kunne ikke publisere oppdateringen",
        "oppdatering.subject_optional_hint": "Prosjekt eller kunde er valgfritt. AI kan foreslå prosjekt ut fra teksten.",
        "Dikter": "Dikter",
        "Tekst": "Tekst",
        "Dikter oppdatering": "Dikter oppdatering",
        "Dikter innlegg": "Dikter oppdatering",
        "Hvordan vil du legge inn oppdateringen?": "Hvordan vil du legge inn oppdateringen?",
        "Trykk for å stoppe opptaket. Teksten vises etterpå.": "Trykk for å stoppe opptaket. Teksten vises etterpå.",
        "Bytt metode": "Bytt metode",
        "Foreslå": "Foreslå",
        "Foreslå oppgaver": "Foreslå oppgaver",
        "Foreslåtte oppgaver": "Foreslåtte oppgaver",
        "Velg hvilke som skal opprettes": "Velg hvilke som skal opprettes",
        "Hopp over": "Hopp over",
        "Opprett valgte": "Opprett valgte",
        "Oppretter…": "Oppretter…",
        "AI-forslag": "AI-forslag",
        "oppdatering.suggestion_add": "Legg til",
        "oppdatering.suggestion_dismiss": "Skjul forslag",
        "oppdatering.todos_created": "{{count}} oppgave(r) opprettet",
        "oppdatering.todos_create_failed": "Kunne ikke opprette {{count}} oppgave(r)",
        "oppdatering.todos_publish_first": "Du kan opprette oppgaver før du publiserer.",
        "oppdatering.todo_created_badge": "Opprettet",
        "oppdatering.todos_created_section": "Opprettede oppgaver",
        "oppdatering.hours_title": "Foreslåtte timer",
        "oppdatering.hours_hint": "Velg hvilke som skal registreres",
        "oppdatering.hours_created": "{{count}} timeføring(er) opprettet",
        "oppdatering.hours_create_failed": "Kunne ikke registrere {{count}} timeføring(er)",
        "oppdatering.hours_created_section": "Registrerte timer",
        "oppdatering.hours_created_badge": "Registrert",
        "oppdatering.hours_col_project": "Prosjekt",
        "oppdatering.hours_col_activity": "Aktivitet",
        "oppdatering.hours_col_description": "Beskrivelse",
        "oppdatering.hours_col_time": "Timer",
        "oppdatering.hours_col_date": "Dato",
        "oppdatering.hours_missing_project": "Velg prosjekt",
        "oppdatering.hours_missing_activity": "Velg aktivitet",
        "oppdatering.hours_open": "Åpne timeliste",
        "oppdatering.new_draft": "Ny oppdatering",
        "oppdatering.already_published": "Allerede publisert — start en ny oppdatering",
        "Lukk": "Lukk",
        "Stopp": "Stopp",
        "Stopp opptak": "Stopp opptak",
        "Tolker…": "Tolker…",
        "Opptak støttes ikke i denne nettleseren.": "Opptak støttes ikke i denne nettleseren.",
        "Kunne ikke transkribere lyden.": "Kunne ikke transkribere lyden.",
        "Fikk ikke tilgang til mikrofonen.": "Fikk ikke tilgang til mikrofonen.",
        "Fjern vedlegg": "Fjern vedlegg",
        // --- offer sidebar / route titles (exact t(title) keys) ---
        "Tilbud": "Tilbud",
        "Oversikt": "Oversikt",
        "Nytt tilbud": "Nytt tilbud",
        "Offer": "Tilbud",
        "Offers": "Tilbud",
        "Kalkyler": "Kalkyler",
        "Kalkyle": "Kalkyle",
        "Ny Kalkyle": "Ny kalkyle",
        "Timesatser": "Timesatser",
        "Timesats": "Timesats",
        "Ny Timesats": "Ny timesats",
        "Maler": "Maler",
        "Innstillinger": "Innstillinger",
        "Templates": "Maler",
        "Settings": "Innstillinger",
        // --- offer redesign recovery keys ---
        "offers.list.title": "Tilbud",
        "offers.list.subtitle": "Oversikt over alle tilbud og kalkyler",
        "offers.list.new": "Nytt tilbud",
        "offers.list.import_quantity_list": "Importer mengdeliste",
        "offers.list.import_coming_soon": "Importer mengdeliste kommer snart.",
        "offers.list.search_placeholder": "Søk i tilbud...",
        "offers.list.active_only": "Aktive tilbud",
        "offers.list.offer_fallback": "Tilbud #{{id}}",
        "offers.list.valid_to": "Gyldig til",
        "offers.list.columns.offer": "Tilbud",
        "offers.list.columns.customer": "Kunde",
        "offers.list.columns.responsible": "Ansvarlig",
        "offers.list.columns.project": "Prosjekt",
        "offers.list.columns.status": "Status",
        "offers.list.columns.revision": "Rev.",
        "offers.list.columns.sum": "Sum",
        "offers.list.columns.margin": "DG%",
        "offers.list.columns.updated": "Sist endret",
        "offers.list.empty": "Ingen tilbud funnet",
        "offers.list.error": "Kunne ikke laste tilbud",
        "offers.stats.total_sales": "Total salg",
        "offers.stats.count": "Antall",
        "offers.stats.sent": "Sendt",
        "offers.stats.accepted": "Akseptert",
        "offers.stats.margin": "DG%",
        "offers.status.none": "Ingen",
        "offers.status.new": "Ny",
        "offers.status.sent": "Sendt",
        "offers.status.accepted": "Akseptert",
        "offers.status.rejected": "Avvist",
        "offers.status.expired": "Utløpt",
        "offers.status.cancelled": "Kansellert",
        "offers.info.title": "Tittel",
        "offers.info.offer_number": "Tilbudsnummer",
        "offers.info.offer_date": "Tilbudsdato",
        "offers.info.not_set": "Ikke satt",
        "offers.info.not_assigned": "Ikke tildelt",
        "offers.info.copy": "Kopier",
        "offers.info.valid_from": "Gyldig fra",
        "offers.info.valid_to": "Gyldig til",
        "offers.info.currency": "Valuta",
        "offers.info.draft_revision": "Utkast-revisjon",
        "offers.info.accepted_revision": "Akseptert revisjon",
        "offers.info.none": "Ingen",
        "offers.convert.to_project": "Konverter til prosjekt",
        "offers.convert.open_project": "Åpne prosjekt",
        "offers.convert.converting": "Konverterer…",
        "offers.convert.success": "Tilbudet ble konvertert til prosjekt.",
        "offers.convert.already_linked": "Tilbudet er allerede koblet til et prosjekt.",
        "offers.convert.order_created": "Ordre {{order_number}} ble opprettet fra tilbudet.",
        "offers.convert.failed": "Kunne ikke konvertere tilbudet til prosjekt.",
        "offers.errors.not_authorized": "Du har ikke tilgang til å utføre denne handlingen på tilbudet.",
        "offers.errors.revision_locked": "Tilbudet er godkjent og låst. Opprett en ny revisjon for å redigere kalkylen.",
        "offers.send.failed": "Noe gikk galt. Kunne ikke sende tilbudet.",
        "offers.send.success": "Tilbudet ble sendt",
        "offers.send.timeout": "Forespørselen tok for lang tid. Sjekk tilbudsstatus manuelt.",
        "offers.send.status_unconfirmed": "Sendingen er ikke bekreftet ennå. Ikke start en ny utsendelse.",
        "offers.send.status_unconfirmed_hint": "Vi beholder samme sendeforsøk. Bruk «Sjekk status» — det oppretter ikke en ny e-post.",
        "offers.send.check_status": "Sjekk status",
        "offers.send.status_check_resumed": "Sjekker status for samme sendeforsøk …",
        "offers.send.mailed_needs_followup": "E-post er sendt, men revisjonen trenger oppfølging.",
        "offers.send.mailed_needs_followup_hint": "E-posten er allerede sendt. Bruk «Fullfør revisjon» — samme sendeforsøk gjenopptas uten ny e-post.",
        "offers.send.sent_needs_attention": "E-post er sendt, men revisjonen trenger oppfølging.",
        "offers.send.finish_revision": "Fullfør revisjon",
        "offers.send.queued": "Tilbudet er lagt i kø for sending …",
        "offers.send.retry": "Sendingen feilet. Prøv igjen.",
        "offers.send.title": "Send tilbud",
        "offers.send.subtitle": "Velg mottaker, PDF-format og melding før sending.",
        "offers.send.revision_lock_note": "Når du sender tilbudet, låses den aktuelle revisjonen. Etter sending kan den ikke endres.",
        "offers.send.success_with_revision": "Tilbudet ble sendt (revisjon {{number}}).",
        "offers.history.revisions_title": "Revisjoner",
        "offers.history.revisions_subtitle": "Sendte og utkast-revisjoner for dette tilbudet.",
        "offers.history.revisions_pending_api": "Full revisjonsliste kommer når API for revisjoner er klart.",
        "offers.history.revisions_empty": "Ingen revisjoner ennå.",
        "offers.history.revisions_empty_hint": "Et utkast opprettes automatisk når du åpner denne fanen. Du kan også opprette utkast manuelt, eller sende tilbudet til kunden for å låse en revisjon.",
        "offers.history.ensure_draft_cta": "Opprett utkast-revisjon",
        "offers.history.ensure_draft_success": "Utkast-revisjon er klar.",
        "offers.history.ensure_draft_failed": "Kunne ikke opprette utkast-revisjon.",
        "offers.history.compare_need_two": "Sammenligning krever minst to revisjoner.",
        "offers.history.revisions_error": "Kunne ikke hente revisjoner.",
        "offers.history.revision_number": "Revisjon {{number}}",
        "offers.history.revision_id_fallback": "ID {{id}}",
        "offers.history.submit_review_hint": "Send utkastet til intern kontroll med",
        "offers.history.send_lock_hint": "«Send tilbud» til kunden låser den aktuelle revisjonen.",
        "offers.history.send_lock_cta": "Send tilbud",
        "offers.history.approval_tab_hint": "Godkjenning og kundens aksept håndteres under fanen Godkjenning.",
        "offers.history.lines_count": "{{count}} linjer",
        "offers.history.amount": "Beløp",
        "offers.history.locked": "Låst",
        "offers.history.locked_at": "Låst",
        "offers.history.submitted_for_review_at": "Sendt til kontroll",
        "offers.history.reviewer": "Kontrollør",
        "offers.history.is_accepted": "Akseptert",
        "offers.history.open_pdf": "Åpne PDF",
        "offers.history.pdf_failed": "Kunne ikke åpne PDF for revisjonen.",
        "offers.history.accept": "Aksepter",
        "offers.history.restore_calc": "Gjenopprett kalkyle",
        "offers.history.restore_calc_confirm": "Erstatt utkastets kalkyle med låst tre fra revisjon {{number}}? Ulagrede kalkyleendringer går tapt.",
        "offers.history.restore_calc_success": "Kalkyle gjenopprettet fra revisjon {{number}}",
        "offers.history.restore_calc_failed": "Kunne ikke gjenopprette kalkyle fra revisjon",
        "offers.history.restore_calc_note": "Gjenopprettet kalkyle fra revisjon {{number}}",
        "offers.history.accept_success": "Revisjon {{number}} ble akseptert.",
        "offers.history.accept_failed": "Kunne ikke akseptere revisjonen.",
        "offers.history.revision_status.draft": "Utkast",
        "offers.history.revision_status.pending_review": "Til kontroll",
        "offers.history.revision_status.approved": "Godkjent",
        "offers.history.revision_status.issued": "Utstedt",
        "offers.history.revision_status.sent": "Sendt",
        "offers.history.revision_status.accepted": "Akseptert",
        "offers.history.revision_status.rejected": "Avvist",
        "offers.history.revision_status.superseded": "Erstattet",
        "offers.history.send_title": "Sendhistorikk",
        "offers.history.send_subtitle": "Oversikt over alle ganger dette tilbudet har blitt sendt.",
        "offers.history.send_empty": "Ingen sendhistorikk ennå.",
        "offers.history.send_empty_hint": "Når du sender tilbudet, vises det her.",
        "offers.history.sent_to": "Sendt til {{recipient}}",
        "offers.history.sent_by": "Sendt av",
        "offers.history.status_delivered": "Levert",
        "offers.history.status_pending": "Venter",
        "offers.history.status_failed": "Feilet",
        "offers.approval.title": "Godkjenning kreves",
        "offers.approval.subtitle": "Kontroller nøkkeltall og godkjenn eller avvis revisjonen før sending og kundens aksept.",
        "offers.approval.unavailable": "Godkjenning er ikke tilgjengelig før revisjoner er aktivert for firmaet.",

        "offers.settings.title": "Innstillinger for tilbud",
        "offers.settings.subtitle": "Velg hvilke tilbudsverktøy som skal være tilgjengelige for firmaet.",
        "offers.settings.intro":
          "Disse valgene styrer faner og arbeidsflyt i tilbudsmodulen. Anbefalte valg er merket. Endringer gjelder hele firmaet og tar effekt med en gang.",
        "offers.settings.open_guide": "Åpne oppstartsguide for tilbud",
        "offers.settings.recommended": "Anbefalt",
        "offers.settings.saved": "Innstilling lagret",
        "offers.settings.load_error": "Kunne ikke laste tilbudsinnstillinger",
        "offers.settings.save_error": "Kunne ikke lagre innstillingen",
        "offers.settings.groups.workflow": "Arbeidsflyt",
        "offers.settings.groups.workflow_hint": "Sjekkliste, intern kontroll og godkjenning før sending.",
        "offers.settings.groups.calculation": "Kalkyle",
        "offers.settings.groups.calculation_hint": "Ny kalkylemotor, formler, modulbygger og maler.",
        "offers.settings.groups.document": "Dokument",
        "offers.settings.groups.document_hint": "Tilbudsdokument og AI-hjelp til tekst.",
        "offers.settings.groups.import": "Import og prosjekt",
        "offers.settings.groups.import_hint": "Mengdeliste, anbud og konvertering til prosjekt.",
        "offers.settings.groups.overview": "Oversikt",
        "offers.settings.groups.overview_hint": "Ny oversikt og versjonering av maler.",
        "offers.settings.groups.other": "Andre",
        "offers.settings.groups.other_hint": "",
        "offers.settings.flags.offer_revisions.title": "Revisjoner og godkjenning",
        "offers.settings.flags.offer_revisions.description":
          "Gir fanene Godkjenning og Revisjoner. Intern kontroll før tilbudet sendes til kunden.",
        "offers.settings.flags.offer_checklist.title": "Sjekkliste",
        "offers.settings.flags.offer_checklist.description":
          "Viser sjekkliste-fanen på tilbudet, så dere kan kvalitetssikre før sending.",
        "offers.settings.flags.offer_checklist_required_on_send.title": "Krev sjekkliste før sending",
        "offers.settings.flags.offer_checklist_required_on_send.description":
          "Blokkerer sending til kunden til sjekklisten er fullført. Slå på etter at sjekkliste er i bruk.",
        "offers.settings.flags.offer_calculation_v2.title": "Kalkyle v2",
        "offers.settings.flags.offer_calculation_v2.description":
          "Nøyaktigere summer (kost, dekningsbidrag og DG%) fra serveren. Anbefales.",
        "offers.settings.flags.offer_safe_formula_engine.title": "Trygg formelmotor",
        "offers.settings.flags.offer_safe_formula_engine.description":
          "Tillater bare enkle regneformler i kalkyletyper, uten usikker kodekjøring.",
        "offers.settings.flags.offer_module_builder.title": "Modulbygger",
        "offers.settings.flags.offer_module_builder.description":
          "Visuell graf for sammensatte kalkylemoduler (aggregat, kanal og lignende).",
        "offers.settings.flags.offer_calculation_templates.title": "Kalkylemaler",
        "offers.settings.flags.offer_calculation_templates.description":
          "Utvidet malbibliotek. Å legge til og lagre kalkylemaler i et tilbud fungerer alltid.",
        "offers.settings.flags.offer_calculation_template_versions.title": "Versjoner av kalkylemaler",
        "offers.settings.flags.offer_calculation_template_versions.description":
          "Historikk og gjenoppretting av kalkylemaler.",
        "offers.settings.flags.offer_document_builder.title": "Dokumentbygger",
        "offers.settings.flags.offer_document_builder.description":
          "Bygg tilbudsdokumentet med tekstblokker, forbehold og visning mot kunde.",
        "offers.settings.flags.offer_document_ai.title": "AI i dokument",
        "offers.settings.flags.offer_document_ai.description":
          "AI-hjelp til tekst og analyse av vedlegg. Krever at dokumentbygger er på.",
        "offers.settings.flags.offer_import_v2.title": "Import av mengdeliste",
        "offers.settings.flags.offer_import_v2.description":
          "Importer rader til kalkylen fra fil, med produktmatch.",
        "offers.settings.flags.offer_inquiries.title": "Anbud med flere forespørrere",
        "offers.settings.flags.offer_inquiries.description":
          "Håndter flere forespørrere på samme anbud.",
        "offers.settings.flags.offer_project_conversion_v2.title": "Konvertering til prosjekt",
        "offers.settings.flags.offer_project_conversion_v2.description":
          "Ny flyt for å opprette prosjekt fra akseptert tilbud.",
        "offers.settings.flags.offer_v2_overview.title": "Ny oversikt",
        "offers.settings.flags.offer_v2_overview.description":
          "Rikere oversikt med nøkkeltall for dekningsbidrag og status.",
        "offers.settings.flags.offer_template_versions.title": "Versjoner av tilbudsmaler",
        "offers.settings.flags.offer_template_versions.description":
          "Historikk for hele tilbudsmaler, ikke bare kalkylen.",
        "offers.approval.empty": "Ingen revisjon å behandle ennå.",
        "offers.approval.empty_hint": "Opprett eller rediger tilbudet for å få et utkast. Bruk «Send til kontroll» for intern gjennomgang.",
        "offers.approval.approvers_title": "Godkjennere",
        "offers.approval.approvers_mvp_note": "Flere godkjennere og stegvis flyt kommer senere. Du godkjenner med din egen bruker.",
        "offers.approval.approvers_one_step_note": "Én-stegs godkjenning: valgt kontrollør vises her. Du godkjenner med egen bruker når du har tilgang.",
        "offers.approval.approver_you": "Du",
        "offers.approval.approver_unassigned": "Ingen kontrollør valgt",
        "offers.approval.approver_role": "Tilbudstilgang",
        "offers.approval.approver_pending": "Venter",
        "offers.approval.approver_done": "Utført",
        "offers.approval.approver_idle": "Klar",
        "offers.approval.pending_review_hint": "Revisjonen er sendt til intern kontroll og kan godkjennes.",
        "offers.approval.pending_review_hint_reviewer": "Revisjonen er sendt til kontroll ({{reviewer}}) og kan godkjennes.",
        "offers.approval.section_internal_title": "Intern godkjenning",
        "offers.approval.section_internal_subtitle": "Kontroll, godkjenning og avvisning internt i firmaet. Godkjent revisjon låses — ny redigering krever ny revisjon.",
        "offers.approval.section_customer_title": "Kundegodkjenning",
        "offers.approval.section_customer_subtitle": "Send tilbud til kunden og registrer at kunden har akseptert.",
        "offers.approval.approved_at_hint": "En tidligere revisjon er godkjent internt. Du arbeider nå på et nytt utkast.",
        "offers.approval.approved_locked_hint": "Revisjonen er godkjent og låst. Opprett en ny revisjon for å redigere videre.",
        "offers.approval.reopen_cta": "Opprett ny revisjon",
        "offers.approval.reopen_success": "Ny revisjon opprettet basert på revisjon {{number}}.",
        "offers.approval.reopen_failed": "Kunne ikke opprette ny revisjon.",
        "offers.approval.reopen_note": "Gjenåpnet for redigering fra revisjon {{number}}",
        "offers.create_revision.title": "Opprett ny revisjon",
        "offers.create_revision.intro":
          "Velg hvordan du vil gå videre. En ny revisjon er riktig når du skal endre dette tilbudet videre — ikke når du trenger et helt nytt tilbud.",
        "offers.create_revision.bullet_based_on":
          "Ny revisjon baseres på siste låste revisjon (based_on).",
        "offers.create_revision.bullet_locked":
          "Den godkjente/sendte revisjonen forblir låst og uendret.",
        "offers.create_revision.bullet_draft":
          "Du får et redigerbart utkast som blir gjeldende draft.",
        "offers.create_revision.bullet_kalkyle":
          "Kalkylen låses opp for redigering på det nye utkastet.",
        "offers.create_revision.based_on_label":
          "Ny revisjon opprettes basert på låst revisjon {{number}}.",
        "offers.create_revision.choose_label": "Hva vil du gjøre?",
        "offers.create_revision.option_revision_title": "Opprett ny revisjon av dette tilbudet",
        "offers.create_revision.option_revision_hint":
          "Beholder tilbudsnr. og historikk. Anbefalt etter intern godkjenning eller sending.",
        "offers.create_revision.option_copy_title": "Kopier som nytt tilbud",
        "offers.create_revision.option_copy_hint":
          "Bedre når du trenger et separat tilbud (annen kunde, prosjekt eller variant).",
        "offers.create_revision.option_blank_title": "Start tomt tilbud",
        "offers.create_revision.option_blank_hint":
          "Når du ikke skal bygge videre på innholdet her.",
        "offers.create_revision.already_draft":
          "Tilbudet har allerede et redigerbart utkast. Bruk det, eller kopier som nytt tilbud.",
        "offers.create_revision.already_draft_hint":
          "Du har allerede et utkast. Ny revisjon er ikke nødvendig — rediger videre, eller velg kopi/tomt tilbud under.",
        "offers.create_revision.missing_locked":
          "Fant ingen låst revisjon å basere ny revisjon på.",
        "offers.create_revision.confirm": "Opprett revisjon",
        "offers.create_revision.confirm_copy": "Gå til kopiering",
        "offers.create_revision.confirm_blank": "Åpne nytt tilbud",
        "offers.approval.approve": "Godkjenn",
        "offers.approval.reject": "Avvis",
        "offers.approval.accept": "Registrer aksept",
        "offers.approval.send": "Send til kontroll",
        "offers.approval.key_figures": "Nøkkeltall",
        "offers.approval.discount": "Rabatt",
        "offers.approval.workflow_hint": "Flyt: intern kontroll → godkjenn (låses) → ved behov opprett ny revisjon → send tilbud til kunde → registrer aksept. Detaljer og PDF finner du under Revisjoner.",
        "offers.approval.approve_success": "Revisjon {{number}} ble godkjent og låst.",
        "offers.approval.approve_failed": "Kunne ikke godkjenne revisjonen.",
        "offers.approval.reject_success": "Revisjon {{number}} ble avvist.",
        "offers.approval.reject_failed": "Kunne ikke avvise revisjonen.",
        "offers.approval.api_unavailable": "Godkjennings-API er ikke tilgjengelig ennå. Prøv igjen senere.",
        "offers.approval.confirm_approve_title": "Bekreft godkjenning",
        "offers.approval.confirm_approve_body": "Godkjenn revisjon {{number}}? Revisjonen låses. For å redigere videre må du opprette en ny revisjon.",
        "offers.approval.confirm_approve_submit": "Ja, godkjenn",
        "offers.approval.confirm_accept_title": "Bekreft kundeaksept",
        "offers.approval.confirm_accept_body": "Registrer at kunden har akseptert revisjon {{number}}?",
        "offers.approval.confirm_accept_submit": "Ja, registrer aksept",
        "offers.approval.reject_dialog_title": "Avvis revisjon",
        "offers.approval.reject_dialog_body": "Avvis revisjon {{number}}. Beskriv hva som må endres før tilbudet kan godkjennes på nytt.",
        "offers.approval.reject_reason_label": "Hva må endres?",
        "offers.approval.reject_reason_placeholder": "F.eks. juster mengder, rett priser, legg til montasje…",
        "offers.approval.reject_reason_required": "Du må beskrive hva som må endres.",
        "offers.approval.reject_confirm": "Avvis revisjon",
        "offers.approval.warning.low_dg": "Dekningsgrad ({{value}}) er under grense ({{threshold}} %).",
        "offers.approval.warning.low_dg_short": "Under grense på {{threshold}} %",
        "offers.approval.warning.negative_margin": "Negativt dekningsbidrag — kontroller kalkylen før godkjenning.",
        "offers.approval.warning.no_lines": "Tilbudet mangler både kalkyle og kundelinjer.",
        "offers.approval.warning.lines_materialize_on_approve": "Kundelinjer materialiseres ved godkjenning/sending fra kalkyle (ADR-005).",
        "offers.diff.title": "Sammenlign revisjoner",
        "offers.diff.locked_calc_title": "Låst kalkyle",
        "offers.diff.locked_calc_hint": "Snapshot fra revisjonen — endringer i live kalkyle påvirker ikke dette bildet.",
        "offers.diff.locked_calc_from": "Låst kalkyle · rev. {{number}} (fra)",
        "offers.diff.locked_calc_to": "Låst kalkyle · rev. {{number}} (til)",
        "offers.diff.no_locked_calc": "Ingen kalkyle-snapshot i denne revisjonen (eldre send før REV-001).",
        "offers.diff.no_locked_calc_public": "Ingen kalkyle-snapshot i denne revisjonen.",
        "offers.diff.subtitle": "Se forskjeller i økonomi og linjer mellom to revisjoner.",
        "offers.diff.toggle_show": "Sammenlign",
        "offers.diff.toggle_hide": "Skjul sammenligning",
        "offers.diff.from": "Fra",
        "offers.diff.to": "Til",
        "offers.diff.metric": "Nøkkeltall",
        "offers.diff.change": "Endring",
        "offers.diff.offer_total": "Tilbudssum",
        "offers.diff.contribution_margin": "Dekningsbidrag",
        "offers.diff.contribution_margin_percent": "Dekningsgrad",
        "offers.diff.no_change": "Ingen endring",
        "offers.diff.lines_title": "Linjeendringer",
        "offers.diff.added": "Lagt til",
        "offers.diff.removed": "Fjernet",
        "offers.diff.changed": "Endret",
        "offers.diff.no_line_changes": "Ingen endringer i linjene.",
        "offers.diff.unchanged_count": "{{count}} uendrede linjer",
        "offers.diff.untitled_line": "Uten tittel",
        "offers.diff.field.quantity": "Mengde",
        "offers.diff.field.sales_price": "Pris",
        "offers.diff.field.line_total": "Sum",
        "offers.diff.field.title": "Tittel",
        "offers.diff.field.description": "Beskrivelse",
        "offers.diff.error": "Kunne ikke hente revisjonene for sammenligning.",
        "offers.diff.empty": "Velg to revisjoner for å sammenligne.",
        "offers.diff.same_revision": "Velg to forskjellige revisjoner for å se forskjeller.",
        "offers.overview.kpi.total": "Tilbudssum",
        "offers.overview.kpi.cost": "Kostnad",
        "offers.overview.kpi.contribution_margin": "Dekningsbidrag",
        "offers.overview.kpi.contribution_margin_percent": "Dekningsgrad",
        "offers.overview.kpi.probability": "Sannsynlighet",
        "offers.overview.kpi.cost.info_aria": "Informasjon om kostnad",
        "offers.overview.kpi.cost.info_body": "Kostnad er total kostpris for tilbudet. Verdien hentes fra lagret cost_total på tilbudet når den finnes, ellers summeres den fra kalkyler (offer_calculation_v2) eller estimeres fra linjer (kostpris × mengde). Dette er grunnlaget for dekningsbidrag og dekningsgrad.",
        "offers.overview.kpi.contribution_margin.info_aria": "Informasjon om dekningsbidrag",
        "offers.overview.kpi.contribution_margin.info_body": "Dekningsbidrag (DB) er salgssum minus kostnad. Når tilbudet har lagret contribution_margin, brukes den. Ellers summeres eller utledes verdien fra kalkylene, eller estimeres som salg minus kostnad.",
        "offers.overview.kpi.contribution_margin_percent.info_aria": "Informasjon om dekningsgrad",
        "offers.overview.kpi.contribution_margin_percent.info_body": "Dekningsgrad (DG%) er dekningsbidraget i prosent av salgssummen. Når contribution_margin_percent er lagret på tilbudet, brukes den. Ellers beregnes den som DB ÷ salg × 100 ut fra kalkyle- eller estimerte verdier.",
        "offers.overview.kpi.probability.info_aria": "Informasjon om sannsynlighet",
        "offers.overview.kpi.probability.info_body": "Sannsynlighet er forventet vinnersjanse for tilbudet (0–100 %). Verdien settes på tilbudet når feltet er i bruk. Den beregnes ikke automatisk fra kalkyle eller linjer.",
        "offers.overview.kpi.probability_empty_hint": "Ikke satt",
        "offers.overview.authoritative_hint": "Serverberegnet",
        "offers.overview.estimate_hint": "Estimat",
        "offers.overview.negative_margin": "Negativt dekningsbidrag",
        "offers.overview.activity.title": "Aktivitet",
        "offers.overview.activity.empty": "Ingen aktivitet ennå",
        "offers.overview.activity.revision_status": "Revisjon {{number}} – {{status}}",
        "offers.overview.activity.converted": "Konvertert til prosjekt",
        "offers.overview.activity.created": "Tilbud opprettet",
        "offers.overview.activity.today": "I dag",
        "offers.overview.activity.yesterday": "I går",
        "offers.overview.activity.days_ago": "{{count}} dager",
        "offers.overview.activity.with_actor": "{{text}} av {{actor}}",
        "offers.inquiries.title": "Forespørsler / anbud",
        "offers.inquiries.subtitle": "Flere forespørrende firmaer på samme tilbud. Samme kalkyle og revisjon deles.",
        "offers.inquiries.add": "Ny forespørsel",
        "offers.inquiries.add_title": "Ny forespørsel",
        "offers.inquiries.edit": "Rediger",
        "offers.inquiries.edit_title": "Rediger forespørsel",
        "offers.inquiries.delete": "Slett",
        "offers.inquiries.delete_title": "Slett forespørsel",
        "offers.inquiries.delete_confirm": "Er du sikker på at du vil slette denne forespørselen?",
        "offers.inquiries.empty": "Ingen forespørsler ennå.",
        "offers.inquiries.no_contact": "Ingen kontaktperson",
        "offers.inquiries.due": "Frist",
        "offers.inquiries.created": "Forespørsel opprettet",
        "offers.inquiries.updated": "Forespørsel oppdatert",
        "offers.inquiries.deleted": "Forespørsel slettet",
        "offers.inquiries.save_failed": "Kunne ikke lagre forespørselen.",
        "offers.inquiries.delete_failed": "Kunne ikke slette forespørselen.",
        "offers.inquiries.validation.company_required": "Velg forespørrende firma fra kunderegisteret.",
        "offers.inquiries.fields.company": "Forespørrende firma",
        "offers.inquiries.fields.contact_name": "Kontaktperson",
        "offers.inquiries.fields.contact_email": "E-post",
        "offers.inquiries.fields.contact_phone": "Telefon",
        "offers.inquiries.fields.status": "Status",
        "offers.inquiries.fields.due_at": "Frist",
        "offers.inquiries.fields.notes": "Notater",
        "offers.inquiries.change_status": "Endre status",
        "offers.inquiries.status_title": "Endre status",
        "offers.inquiries.status_updated": "Status oppdatert",
        "offers.inquiries.status.requested": "Forespurt",
        "offers.inquiries.status.in_progress": "Under arbeid",
        "offers.inquiries.status.offered": "Tilbudt",
        "offers.inquiries.status.declined": "Avslått",
        "offers.inquiries.status.won": "Vunnet",
        "offers.inquiries.status.lost": "Tapt",
        "offers.banner.offer": "Tilbud",
        "offers.banner.new": "Nytt tilbud",
        "offers.banner.revision": "Rev.",
        "offers.banner.project": "Prosjekt",
        "offers.banner.responsible": "Ansvarlig",
        "offers.banner.total": "Tilbudssum",
        "offers.banner.valid_to": "Gyldig til",
        "offers.banner.edit": "Rediger",
        "offers.banner.send": "Send til kontroll",
        "offers.banner.send_offer": "Send tilbud",
        "offers.menu.send_offer": "Send tilbud",
        "offers.menu.create_revision": "Opprett ny revisjon",
        "offers.banner.pdf": "PDF",
        "offers.banner.pdf_simple": "PDF — enkelt",
        "offers.banner.pdf_document": "PDF — dokument",
        "offers.banner.print_current": "Skriv ut ({{layout}})",
        "offers.banner.print_other": "Annen layout ({{layout}})",
        "offers.banner.convert": "Konverter",
        "offers.banner.more": "Flere handlinger",
        "offers.banner.copy": "Kopier",
        "offers.banner.delete": "Slett",
        "offers.banner.tabs": "Faner",
        "offers.banner.copy_coming": "Kopiering av tilbud kommer snart.",
        "offers.submit_review.title": "Send til kontroll",
        "offers.submit_review.description": "Merk revisjonen som klar for intern gjennomgang. Dette sender ikke tilbudet til kunden.",
        "offers.submit_review.reviewer_label": "Kontrollør (valgfritt)",
        "offers.submit_review.reviewer_optional_hint": "Du kan bekrefte uten å velge kontrollør.",
        "offers.submit_review.confirm": "Send til kontroll",
        "offers.submit_review.success": "Sendt til kontroll",
        "offers.submit_review.failed": "Kunne ikke sende til kontroll.",
        "offers.submit_review.missing_revision": "Fant ingen utkast-revisjon å sende til kontroll.",
        "offers.tabs.calculation": "Kalkyle",
        "offers.tabs.overview": "Oversikt",
        "offers.tabs.lines": "Kundevisning",
        "offers.tabs.update_snapshot": "Oppdater snapshot",
        "offers.template_wizard.title": "Tilpass mal før innlasting",
        "offers.template_wizard.hint": "Svar på parametrene malen spør om. Deretter lastes kalkylen inn med dine verdier.",
        "offers.template_wizard.empty": "Denne malen har ingen parametre — den lastes inn direkte.",
        "offers.template_wizard.apply": "Last inn mal",
        "offers.template_wizard.root_section": "Hovedkalkyle",
        "offers.tabs.advanced_menu": "Avansert",
        "offers.tabs.enable_legacy_edit": "Tillat legacy linje-redigering",
        "offers.tabs.legacy_edit_banner": "Avansert snapshot-redigering — ikke daglig tilbudsbygging. Bygg i kalkylen; dette lager kun midlertidige kundelinjer.",
        "offers.tabs.legacy_edit_locked_hint": "Kundebildet styres fra kalkyle + presentasjon. Skru på legacy-redigering under Avansert om nødvendig.",
        "offers.pricing.open_button": "Prismetode…",
        "offers.pricing.dialog_title": "Prismetode (påslag / mål-DG)",
        "offers.pricing.dialog_hint": "Skill påslag (kost × (1+p)) fra mål-DG (kost / (1−DG)). Legacy «Påslag %» er salgsjustering.",
        "offers.pricing.method": "Metode",
        "offers.pricing.method_legacy": "Legacy surcharge (standard)",
        "offers.pricing.method_markup": "Påslag på kost",
        "offers.pricing.method_target_margin": "Mål-dekningsgrad",
        "offers.pricing.method_fixed_sales": "Fast salgspris",
        "offers.pricing.rate_percent": "Prosent",
        "offers.pricing.price_status": "Prisstatus",
        "offers.pricing.status_estimated": "Estimert",
        "offers.pricing.status_missing": "Mangler",
        "offers.pricing.status_confirmed_zero": "Bekreftet null",
        "offers.pricing.surcharge_disabled_hint": "Deaktivert mens prismetode er satt",
        "offers.presentation.open_button": "Presentasjon…",
        "offers.presentation.dialog_title": "Presentasjon for kunde / PDF",
        "offers.presentation.dialog_hint": "Én tilbudskalkyle. Linje kalkyler vises som grupper. Velg kun sum eller vis underlinjer — ikke flere rotkalkyler.",
        "offers.presentation.default_group": "Standard for grupper / rotkalkyle",
        "offers.presentation.default_nested": "Standard for linje kalkyler",
        "offers.presentation.show_product_info": "Vis produktinfo under linjer",
        "offers.presentation.show_product_info_hint": "Gjelder når barn vises (vis underlinjer). Av = kun tittel/pris, uten produktbeskrivelse.",
        "offers.presentation.include_product_short": "Ta med kort produktbeskrivelse",
        "offers.presentation.include_product_short_hint": "Skriver til presentasjonsregler og tilbudskalkyler. Viser produktets short_description i kundevisning og PDF når feltet er fylt ut.",
        "offers.presentation.tab.structure": "Struktur",
        "offers.presentation.tab.document": "Dokument",
        "offers.presentation.tab.lines": "Linjer",
        "offers.presentation.include_notes": "Vis notater i tilbudet",
        "offers.presentation.include_notes_hint": "Notater fra kalkylen (tekstlinjer og modulnotater). Av = skjules i kundevisning. Per notat styres også med «Vis i tilbudet» på linjen.",
        "offers.presentation.fields_heading": "Felt som vises på linjer",
        "offers.presentation.field.description": "Beskrivelse",
        "offers.presentation.field.quantity": "Mengde",
        "offers.presentation.field.unit": "Enhet",
        "offers.presentation.field.unit_price": "Enhetspris",
        "offers.presentation.field.product_image": "Produktbilde",
        "offers.presentation.field.product_url": "Produktlenke",
        "offers.presentation.lines_hint": "Skjul hele linjen, eller skru av enkeltfelt. Bare linjer som ligger i kalkylen vises her — ikke firmamaler som ikke er brukt.",
        "offers.presentation.line_visible": "Synlig",
        "offers.presentation.line_fallback": "Linje {{n}}",
        "offers.presentation.empty_lines": "Ingen kalkylelinjer ennå — bygg innholdet i Kalkyle først.",
        "offers.presentation.overview_only_hint": "Kundevisning viser bare det som er lagt til i kalkylen. En kalkylemal som ikke ligger som linje i oversikten, vises ikke.",
        "offers.presentation.kind.group": "Gruppe",
        "offers.presentation.kind.root_calc": "Tilbudskalkyle",
        "offers.presentation.kind.nested_calculation": "Linje kalkyle",
        "offers.presentation.empty_tree": "Ingen grupper eller kalkyler ennå — bygg struktur i Kalkyle først.",
        "offers.presentation.mode.show_children": "Vis underlinjer",
        "offers.presentation.mode.sum_only": "Kun sum",
        "offers.presentation.mode.hide": "Skjul",
        "offers.presentation.cancel": "Avbryt",
        "offers.presentation.save": "Lagre",
        "offers.presentation.saving": "Lagrer…",
        "offers.presentation.save_success": "Presentasjonsregler lagret",
        "offers.presentation.save_failed": "Kunne ikke lagre presentasjonsregler",
        "offers.tabs.document": "Dokument",
        "offers.tabs.attachments": "Vedlegg",
        "offers.tabs.checklist": "Sjekkliste",
        "offers.tabs.revisions": "Revisjoner",
        "offers.tabs.approval": "Godkjenning",
        "offers.tabs.history": "Historikk",
        "offers.activity.filters.all": "Alle",
        "offers.activity.filters.kalkyle": "Kalkyle",
        "offers.activity.filters.linjer": "Linjer",
        "offers.activity.filters.grupper": "Grupper",
        "offers.activity.filters.dokument": "Dokument",
        "offers.activity.filters.revisjoner": "Revisjoner",
        "offers.activity.filters.import": "Import",
        "offers.activity.filters.godkjenning": "Godkjenning",
        "offers.activity.filters.system": "System",
        "offers.activity.groups.this_week": "Denne uken",
        "offers.activity.groups.last_week": "Forrige uke",
        "offers.activity.groups.older": "Eldre",
        "offers.activity.system_actor": "System",
        "offers.activity.empty_title": "Ingen aktivitet ennå",
        "offers.activity.empty_hint": "Når noe skjer med tilbudet — kalkyle, linjer, grupper, dokument, revisjoner, import eller godkjenning — vises det her.",
        "offers.activity.error": "Kunne ikke hente aktivitetshistorikk.",
        "offers.activity.error_unauthorized": "Du har ikke tilgang til aktivitetshistorikk.",
        "offers.activity.loading": "Laster aktivitet…",
        "offers.activity.badge.rev": "Rev. {{number}}",
        "offers.activity.badge.version": "v{{from}} → v{{to}}",
        "offers.activity.badge.matched": "{{matched}} / {{rows}} matchet",
        "offers.activity.time.just_now": "Akkurat nå",
        "offers.activity.time.minutes_ago": "{{count}} min siden",
        "offers.activity.time.today_at": "I dag {{time}}",
        "offers.activity.time.yesterday_at": "I går {{time}}",
        "offers.activity.time.days_ago": "{{count}} dager siden",
        "offers.activity.actions.compare_revisions": "Sammenlign revisjoner →",
        "offers.activity.actions.view_import_log": "Vis importlogg →",
        "offers.activity.actions.open_revision": "Åpne revisjon →",
        "offers.activity.actions.open_related": "Åpne →",
        "offers.activity.actions.import_coming": "Importlogg åpnes fra kalkylefanen. Detaljert logg kommer snart.",
        "offers.activity.events.unknown.title": "Aktivitet",
        "offers.activity.events.currency_changed.title": "Valuta endret ({{from}} → {{to}})",
        "offers.activity.events.currency_changed.description": "Tilbudsvaluta ble endret fra {{from}} til {{to}}.",
        "offers.activity.events.document_structure_changed.title": "Dokumentstruktur oppdatert",
        "offers.activity.events.document_structure_changed.description": "Blokker i utgående dokument ble endret.",
        "offers.activity.events.template_loaded.title": "Mal lastet",
        "offers.activity.events.template_loaded.title_named": "Mal lastet: {{title}}",
        "offers.activity.events.template_loaded.description": "Innhold ble lastet fra en mal.",
        "offers.activity.events.lines_changed.title": "Tilbudslinjer endret",
        "offers.activity.events.lines_changed.description": "{{created}} lagt til, {{updated}} oppdatert, {{deleted}} slettet.",
        "offers.activity.events.groups_changed.title": "Grupper endret",
        "offers.activity.events.groups_changed.description": "{{created}} lagt til, {{updated}} oppdatert, {{deleted}} slettet.",
        "offers.activity.events.lines_generated.title": "Linjer generert fra kalkyle",
        "offers.activity.events.lines_generated.title_count": "{{count}} linjer generert fra kalkyle",
        "offers.activity.events.lines_generated.description": "Kundevendte tilbudslinjer ble generert fra kalkylen.",
        "offers.activity.events.lines_generated_from_calculation.title": "Linjer generert fra kalkyle",
        "offers.activity.events.lines_generated_from_calculation.description": "Kundevendte tilbudslinjer ble generert fra kalkylen.",
        "offers.activity.events.offer_accepted.title": "Tilbud akseptert",
        "offers.activity.events.offer_accepted.description": "Tilbudet ble akseptert.",
        "offers.activity.events.line_created.title": "Linje lagt til",
        "offers.activity.events.line_created.title_named": "Linje lagt til: {{title}}",
        "offers.activity.events.line_added.title": "Linje lagt til",
        "offers.activity.events.line_updated.title": "Linje oppdatert",
        "offers.activity.events.line_updated.title_named": "Linje oppdatert: {{title}}",
        "offers.activity.events.line_deleted.title": "Linje slettet",
        "offers.activity.events.line_deleted.title_named": "Linje slettet: {{title}}",
        "offers.activity.events.group_created.title": "Gruppe opprettet",
        "offers.activity.events.group_created.title_named": "Gruppe opprettet: {{title}}",
        "offers.activity.events.group_updated.title": "Gruppe oppdatert",
        "offers.activity.events.group_updated.title_named": "Gruppe oppdatert: {{title}}",
        "offers.activity.events.group_renamed.title": "Gruppe omdøpt",
        "offers.activity.events.group_renamed.title_named": "Gruppe omdøpt: {{title}}",
        "offers.activity.events.group_deleted.title": "Gruppe slettet",
        "offers.activity.events.group_deleted.title_named": "Gruppe slettet: {{title}}",
        "offers.activity.events.document_updated.title": "Dokument oppdatert",
        "offers.activity.events.document_updated.description": "Dokumentinnhold ble endret.",
        "offers.activity.events.offer_created.title": "Tilbud opprettet",
        "offers.activity.events.offer_created.title_template": "Tilbud opprettet fra mal",
        "offers.activity.events.offer_created.description": "Tilbudet ble opprettet.",
        "offers.activity.events.offer_created.description_template": "Mal: {{title}}",
        "offers.activity.events.revision_created.title": "Revisjon {{revision_number}} opprettet",
        "offers.activity.events.revision_created.description": "Revisjon {{revision_number}} ble opprettet.",
        "offers.activity.events.revision_created.description_based": "Basert på Revisjon {{based_on}}. {{lines}} linjer registrert.",
        "offers.activity.events.revision_approved.title": "Revisjon {{revision_number}} godkjent",
        "offers.activity.events.revision_approved.title_named": "Revisjon {{number}} godkjent",
        "offers.activity.events.revision_approved.description": "Revisjon {{revision_number}} ble godkjent internt.",
        "offers.activity.events.revision_approved.description_empty": "Godkjent uten kommentarer.",
        "offers.activity.events.revision_rejected.title": "Revisjon {{revision_number}} avvist",
        "offers.activity.events.revision_rejected.description": "Revisjon {{revision_number}} ble avvist.",
        "offers.activity.events.revision_rejected.description_with_note": "Revisjon {{revision_number}} ble avvist: {{note}}",
        "offers.activity.events.revision_sent.title": "Revisjon {{revision_number}} sendt",
        "offers.activity.events.revision_sent.description": "Revisjon {{revision_number}} ble sendt til kunden.",
        "offers.activity.events.revision_submitted_for_review.title": "Revisjon {{revision_number}} sendt til kontroll",
        "offers.activity.events.revision_submitted_for_review.title_named": "Revisjon {{number}} sendt til kontroll",
        "offers.activity.events.revision_submitted_for_review.description": "Revisjon {{revision_number}} ble sendt til intern kontroll.",
        "offers.activity.events.revision_accepted.title": "Revisjon {{revision_number}} akseptert",
        "offers.activity.events.revision_accepted.description": "Kunden aksepterte revisjon {{revision_number}}.",
        "offers.activity.events.calc_version_created.title": "Kalkyleversjon opprettet",
        "offers.activity.events.calc_version_created.title_named": "{{title}} oppdatert",
        "offers.activity.events.calc_version_created.description": "Ny kalkyleversjon ble lagret.",
        "offers.activity.events.calc_version_created.description_bump": "Versjon v{{from}} → v{{to}}.",
        "offers.activity.events.import_applied.title": "Mengdeliste importert",
        "offers.activity.events.import_applied.title_file": "Mengdeliste importert ({{filename}})",
        "offers.activity.events.import_applied.description": "Import ble anvendt på kalkylen.",
        "offers.activity.events.import_applied.description_stats": "{{applied}} linjer importert. {{matched}} av {{rows}} matchet med produktkatalog.",
        "offers.activity.events.calculation_lines_changed.title": "Kalkylinjer endret",
        "offers.activity.events.calculation_lines_changed.description": "Linjer i kalkylen ble oppdatert.",
        "offers.edit.currency_option.NOK": "NOK — Norske kroner",
        "offers.edit.currency_option.SEK": "SEK — Svenske kroner",
        "offers.edit.currency_option.DKK": "DKK — Danske kroner",
        "offers.edit.currency_option.EUR": "EUR — Euro",
        "offers.edit.currency_option.USD": "USD — Amerikanske dollar",
        "offers.edit.currency_coming_soon": "kommer snart",
        "offers.edit.currency_hint": "Foreløpig kan bare NOK velges.",
        "offers.help.open": "Hjelp",
        "offers.help.eyebrow": "Tilbudsmodul",
        "offers.help.title": "Slik fungerer tilbud",
        "offers.help.intro": "Tilbudet har flere faner med ulike roller. Her er en kort oversikt — se også dokumentasjonen for detaljer.",
        "offers.help.calc_vs_lines_title": "Kalkyle vs tilbudslinjer",
        "offers.help.calc_vs_lines_body": "Kalkylen er intern kost-/salgsberegning (manuell, timer, produkter, beregninger). Tilbudslinjer er det kunden ser — ofte generert fra kalkylen, med synlighet per linje.",
        "offers.help.doc_vs_attachments_title": "Dokument vs vedlegg",
        "offers.help.doc_vs_attachments_body": "Dokument er selve tilbudsdokumentet (struktur, forside, seksjoner). Vedlegg er ekstra filer som følger med tilbudet.",
        "offers.help.revisions_title": "Revisjoner, godkjenning og historikk",
        "offers.help.revisions_body": "Revisjoner håndterer utkast, PDF og diff. Godkjenning er intern approve/reject og kundeaksept. Historikk er tidslinjen over hva som har skjedd.",
        "offers.help.grouping_title": "Gruppering og nummerering",
        "offers.help.grouping_body": "Grupper kan ha fag/bransje og hierarkiske nummer (f.eks. Ventilasjon 1.0, Aggregater 1.1). Opprett og gi nytt navn under Tilbudslinjer.",
        "offers.help.link_module": "Moduldocs",
        "offers.help.link_screens": "Skjermspesifikasjon",
        "offers.help.link_calculations": "Kalkyledokumentasjon",
        "offers.help.link_document": "Dokumentstruktur",
        "offers.groups.discipline": "Fag/bransje",
        "offers.groups.save_failed": "Kunne ikke lagre grupper.",
        "offers.groups.saved": "Grupper lagret.",
        "offers.groups.prompt_child_title": "Tittel på undergruppe",
        "offers.groups.prompt_top_title": "Tittel på gruppe (f.eks. Ventilasjon)",
        "offers.groups.add_top": "Ny gruppe",
        "offers.groups.add_child": "Ny undergruppe",
        "offers.groups.rename": "Gi nytt navn",
        "offers.groups.edit": "Rediger gruppe",
        "offers.groups.delete": "Slett gruppe",
        "offers.groups.delete_confirm": "Slette strukturgruppen «{{title}}»? Linjer i gruppen blir stående uten gruppe.",
        "offers.groups.delete_confirm_with_children": "Slette «{{title}}» og {{count}} undergruppe(r)? Linjer blir stående uten gruppe.",
        "offers.groups.edit_hint": "Dobbeltklikk eller bruk blyant for å redigere",
        "offers.groups.dialog_title_create": "Ny strukturgruppe",
        "offers.groups.dialog_title_edit": "Rediger strukturgruppe",
        "offers.groups.field_title": "Tittel",
        "offers.groups.field_description": "Beskrivelse",
        "offers.groups.field_discipline": "Fag",
        "offers.groups.field_parent": "Velg overordnet gruppe. Tom = toppnivå.",
        "offers.groups.field_number": "Nummer",
        "offers.groups.field_group_type": "Gruppetype",
        "offers.groups.group_type_default": "Ikke angitt",
        "offers.groups.group_type_discipline": "Fag",
        "offers.groups.group_type_section": "Seksjon",
        "offers.groups.parent_root": "Toppnivå (rot)",
        "offers.groups.move_to": "Flytt til…",
        "offers.groups.save": "Lagre",
        "offers.groups.cancel": "Avbryt",
        "offers.groups.empty_title": "Ingen grupper ennå",
        "offers.groups.empty_hint": "Bruk «Ny struktur» i linjeeditoren eller + i strukturpanelet for å opprette faggrupper (1.0, 1.1, …).",
        "offers.groups.title_required": "Tittel er påkrevd.",
        "offers.groups.panel_title": "Fag og grupper",
        "offers.groups.panel_hint": "Redigeres i Kalkyle-fanens strukturpanel (nummer 1.0, 1.1, …).",
        "offers.groups.saving": "Lagrer…",
        "offers.groups.save_rename": "Lagre",
        "offers.groups.selected": "Valgt gruppe",
        "offers.groups.select_hint": "Velg en gruppe i treet, eller legg til ny.",
        "offers.groups.untitled": "Uten tittel",
        "offers.groups.rename_hint": "Dobbeltklikk for å gi nytt navn",
        "offers.groups.ungrouped": "Uten gruppe",
        "offers.groups.move_line": "Flytt til gruppe",
        "offers.groups.folder_aria": "Mappe {{name}}",
        "offers.help.open_short": "Hjelp",
        "offers.tabs.lines_coming_title": "Tilbudslinjer kommer snart",
        "offers.tabs.lines_coming_desc": "Redigering av tilbudslinjer flyttes hit i en senere oppdatering.",
        "offers.tabs.document_coming_title": "Dokument kommer snart",
        "offers.tabs.document_coming_desc": "Forside og dokumentoppsett for tilbudet flyttes hit i en senere oppdatering.",
        "offers.tabs.lines_intro": "Forhåndsvisning av det kunden ser. Innhold og struktur styres i kalkylen; synlighet styres med presentasjonsregler.",
        "offers.tabs.lines_customer_hint": "Kundevisning (ADR-005) — generert fra kalkylen. Ikke en parallell linje-editor. Interne priser og detaljer skjules.",
        "offers.tabs.lines_customer_hint_public": "Kundevisning — generert fra kalkylen. Interne priser og detaljer skjules.",
        "offers.tabs.lines_view.label": "Visningsvalg",
        "offers.tabs.lines_view.hint": "Visningsvalg styrer hvordan linjene grupperes for kunde/PDF. Inkludering (inkl./valgfri/skjult) på hver linje avgjør om den vises for kunden.",
        "offers.tabs.lines_view.per_calc": "Per kalkyle",
        "offers.tabs.lines_view.kapittel": "Kapitler",
        "offers.tabs.lines_view.flat": "Flat liste",
        "offers.tabs.lines_view.kundegrupper": "Kun kundegrupper",
        "offers.tabs.lines_view.ungrouped": "Uten gruppe",
        "offers.tabs.generate_from_calculation": "Generer fra kalkyle",
        "offers.tabs.generate_from_calculation_success": "Tilbudslinjer generert fra kalkyle.",
        "offers.tabs.generate_from_calculation_failed": "Kunne ikke generere tilbudslinjer fra kalkyle.",
        "offers.tabs.generate_from_calculation_empty": "Ingen kalkyle å generere fra. Legg til en kalkyle først.",
        "offers.tabs.columns.chapter": "Kapittel / beskrivelse",
        "offers.tabs.columns.qty": "Mengde",
        "offers.tabs.columns.unit": "Enh.",
        "offers.tabs.columns.unit_price": "Enhetspris",
        "offers.tabs.columns.line_sum": "Linjesum",
        "offers.tabs.columns.visible": "Synlig",
        "offers.tabs.lines_empty_title": "Ingen kundelinjer ennå",
        "offers.tabs.lines_empty_desc": "Bygg tilbudet i kalkylen. Kundebildet genereres automatisk — manuell redigering ligger under Avansert.",
        "offers.printLinesPreview.toggle": "Forhåndsvis linjer",
        "offers.printLinesPreview.edit_mode": "Rediger",
        "offers.printLinesPreview.empty": "Ingen synlige linjer for kunden",
        "offers.printLinesPreview.empty_no_lines": "Ingen tilbudslinjer ennå",
        "offers.printLinesPreview.empty_all_hidden": "Alle linjer er skjult for kunden",
        "offers.printLinesPreview.empty_hint": "Legg til linjer, eller generer fra kalkylen. Sett inkludering til «Inkludert» for at de skal vises her.",
        "offers.printLinesPreview.empty_hidden_hint": "{{count}} linje(r) er satt til skjult. Endre inkludering under Rediger for å vise dem for kunden.",
        "offers.printLinesPreview.total": "Sum eks. mva",
        "offers.printLinesPreview.mode_hint": "Slik vises linjene på PDF/utskrift (kundens visning).",
        "offers.printLinesPreview.mode_hint_document": "Utskrift er det utformede dokumentet til venstre — samme PDF som kunden får. Linjetabellen er innholdet i prisdelen.",
        "offers.tabs.calculation_use_template": "Fra mal",
        "offers.tabs.calculation_new": "Ny kalkyle",
        "offers.tabs.calculation_empty": "Ingen kalkyler ennå",
        "offers.tabs.calculation_empty_hint": "Kalkyle er valgfritt. Du kan fortsette med tilbudslinjer uten, eller legge til en kalkyle hvis du trenger den.",
        "offers.tabs.calculation_page_title": "Kalkyle",
        "offers.tabs.calculation_creating": "Oppretter kalkyle…",
        "offers.tabs.calculation_added": "Kalkyle lagt til i tilbudet",
        "offers.tabs.calculation_load_failed": "Kunne ikke laste kalkyle",
        "offers.tabs.calculation_save_failed": "Kunne ikke lagre kalkylen. Endringen er ikke lagret ennå.",
        "offers.tabs.calculation_conflict": "Kalkylen er endret i en annen fane eller av en annen bruker. Slettede rader beholdes lokalt — last inn på nytt før du lagrer.",
        "offers.tabs.calculation_conflict_resolve_hint": "Autosave er stoppet. Velg «Bruk mine» for å lagre dine lokale endringer oppå serverversjonen, eller «Bruk siste lagrede versjon» for å forkaste lokale endringer.",
        "offers.tabs.calculation_conflict_use_mine": "Bruk mine",
        "offers.tabs.calculation_conflict_blocked": "Løs konflikten før du lagrer eller sender.",
        "offers.tabs.calculation_conflict_server_unavailable": "Kunne ikke hente siste lagrede versjon. Prøv «Bruk siste lagrede versjon» igjen, eller «Bruk mine».",
        "offers.tabs.calculation_locked_title": "Kalkylen er skrivebeskyttet",
        "offers.tabs.calculation_locked_hint": "Tilbudet er godkjent av reviewer og låst. Opprett en ny revisjon under Godkjenning for å redigere videre.",
        "offers.tabs.calculation_locked_save": "Kunne ikke lagre — tilbudet er låst. Opprett en ny revisjon for å redigere kalkylen.",
        "offers.tabs.calculation_locked_empty": "Ingen kalkyle å vise. Opprett en ny revisjon for å bygge kalkyle.",
        "offers.tabs.calculation_removed": "Kalkyle fjernet",
        "offers.tabs.calculation_remove": "Fjern",
        "offers.tabs.calculation_remove_confirm": "Er du sikker på at du vil fjerne denne kalkylen fra tilbudet?",
        "offers.tabs.calculation_select_title": "Velg kalkyle",
        "offers.tabs.calculation_select_template_title": "Velg kalkylemal",
        "offers.tabs.calculation_select_template_as_line": "Velg kalkylemal som linje",
        "offers.tabs.calculation_select_template_replace": "Last inn kalkylemal i kalkylesiden",
        "offers.tabs.calculation_select_template_attach": "Knytt kalkylemal til linje",
        "offers.tabs.calculation_replace_template_confirm": "Erstatt innholdet på kalkylesiden med den valgte malen? Eksisterende linjer blir erstattet.",
        "offers.tabs.calculation_template_loaded": "Kalkylemal lastet inn",
        "offers.tabs.calculation_line_added": "Kalkylemal lagt til som linje i kalkylen",
        "offers.tabs.calculation_untitled": "Kalkyle {{n}}",
        "offers.menu.save_as": "Lagre som nytt tilbud",
        "offers.menu.overwrite": "Overskriv eksisterende tilbud",
        "offers.menu.save_as_template": "Lagre som tilbudsmal",
        "offers.menu.save_to_template": "Oppdater tilbudsmal…",
        "offers.menu.template_versions": "Versjonshistorikk (mal)",
        "offers.save_as.title": "Lagre som nytt tilbud",
        "offers.save_as.description": "Opprett en kopi av dette tilbudet som et nytt, uavhengig tilbud.",
        "offers.save_as.reference_label": "Referanse (valgfritt)",
        "offers.save_as.reference_placeholder": "F.eks. tittel på det nye tilbudet",
        "offers.save_as.customer_label": "Kunde (valgfritt)",
        "offers.save_as.project_label": "Prosjekt (valgfritt)",
        "offers.save_as.confirm": "Lagre som nytt tilbud",
        "offers.save_as.success": "Tilbudet ble lagret som et nytt tilbud",
        "offers.save_as.failed": "Kunne ikke lagre som nytt tilbud",
        "offers.overwrite.title": "Overskriv eksisterende tilbud",
        "offers.overwrite.warning": "Denne handlingen overskriver innholdet i det valgte tilbudet med innholdet i dette tilbudet. Dette kan ikke reverseres.",
        "offers.overwrite.search_placeholder": "Søk etter tilbud …",
        "offers.overwrite.no_results": "Ingen tilbud funnet",
        "offers.overwrite.confirm_label": "Skriv inn «{{number}}» for å bekrefte",
        "offers.overwrite.confirm": "Overskriv tilbud",
        "offers.overwrite.success": "Tilbud {{number}} ble overskrevet",
        "offers.overwrite.failed": "Kunne ikke overskrive tilbudet",
        "offers.save_as_template.title": "Lagre som tilbudsmal",
        "offers.save_as_template.description": "Lagre innholdet i dette tilbudet som en ny tilbudsmal som kan brukes i fremtidige tilbud.",
        "offers.save_as_template.reference_label": "Referanse (valgfritt)",
        "offers.save_as_template.reference_placeholder": "Navn på malen",
        "offers.save_as_template.change_note_label": "Kommentar til versjonen (valgfritt)",
        "offers.save_as_template.confirm": "Lagre som mal",
        "offers.save_as_template.success": "Tilbudet ble lagret som tilbudsmal",
        "offers.save_as_template.failed": "Kunne ikke lagre tilbudet som mal",
        "offers.save_to_template.title": "Oppdater tilbudsmal",
        "offers.save_to_template.description": "Velg en eksisterende tilbudsmal som skal oppdateres med innholdet i dette tilbudet.",
        "offers.save_to_template.search_placeholder": "Søk etter tilbudsmaler …",
        "offers.save_to_template.no_results": "Ingen tilbudsmaler funnet",
        "offers.save_to_template.change_note_label": "Kommentar til versjonen (valgfritt)",
        "offers.save_to_template.confirm": "Oppdater mal",
        "offers.save_to_template.success": "Tilbudsmalen ble oppdatert",
        "offers.save_to_template.failed": "Kunne ikke oppdatere tilbudsmalen",
        "offers.versions.title": "Versjonshistorikk",
        "offers.versions.template_title": "Versjonshistorikk (mal)",
        "offers.versions.load_failed": "Kunne ikke laste versjonshistorikk",
        "offers.versions.unavailable": "Versjonshistorikk er ikke tilgjengelig ennå.",
        "offers.versions.empty": "Ingen versjoner registrert ennå",
        "offers.versions.empty_hint": "Versjoner opprettes automatisk når endringer lagres.",
        "offers.versions.restore": "Gjenopprett",
        "offers.versions.confirm_restore": "Bekreft gjenoppretting",
        "offers.versions.restore_success": "Versjonen ble gjenopprettet",
        "offers.versions.restore_failed": "Kunne ikke gjenopprette versjonen",
        "offers.versions.version_number": "Versjon {{number}}",
        "offers.versions.by": "Av {{name}}",
        "offers.templates.versions.title": "Versjonshistorikk for tilbudsmal",
        "offers.calculation.versions.title": "Malversjoner",
        "offers.calculation.template_actions.menu_label": "Mal",
        "offers.calculation.template_actions.versions": "Malversjoner",
        "offers.calculation.template_actions.versions_title": "Malversjoner",
        "offers.calculation.template_actions.update_template": "Oppdater mal",
        "offers.calculation.template_actions.update_description": "Oppdater kalkylemalen med innholdet i denne tilbudsspesifikke kalkylen. Endringen gjelder for alle fremtidige bruk av malen.",
        "offers.calculation.template_actions.update_confirm": "Oppdater mal",
        "offers.calculation.template_actions.update_success": "Kalkylemalen ble oppdatert",
        "offers.calculation.template_actions.update_failed": "Kunne ikke oppdatere kalkylemalen",
        "offers.calculation.template_actions.save_new_template": "Lagre som ny mal",
        "offers.calculation.template_actions.save_new_description": "Lagre denne kalkylen som en helt ny kalkylemal.",
        "offers.calculation.template_actions.save_new_confirm": "Lagre som ny mal",
        "offers.calculation.template_actions.save_new_success": "Kalkylen ble lagret som ny mal",
        "offers.calculation.template_actions.save_new_failed": "Kunne ikke lagre kalkylen som ny mal",
        "offers.calculation.template_actions.title_label": "Navn på ny mal",
        "offers.calculation.template_actions.title_placeholder": "F.eks. Standard elektrikerarbeid",
        "offers.calculation.template_actions.title_required": "Du må angi et navn på den nye malen",
        "offers.calculation.template_actions.change_note_label": "Kommentar til versjonen (valgfritt)",
        "offers.calculation.template_actions.change_note_placeholder": "Hva ble endret?",
        "offers.calculation.selector.title": "Velg kalkylemal",
        "offers.calculation.selector.title_multiple": "Velg kalkylemaler",
        "offers.calculation.selector.search_placeholder": "Søk etter kalkylemaler…",
        "offers.calculation.selector.loading": "Laster kalkylemaler…",
        "offers.calculation.selector.error": "Kunne ikke laste kalkylemaler",
        "offers.calculation.selector.empty": "Ingen kalkylemaler ennå",
        "offers.calculation.selector.empty_hint": "Firmaets maler opprettes under Tilbud → Kalkyler, eller ved å lagre kalkylen du jobber med som mal.",
        "offers.calculation.selector.empty_search": "Ingen maler treffer søket",
        "offers.calculation.selector.create_template": "Opprett mal",
        "offers.calculation.selector.load_more": "Last flere maler",
        "offers.calculation.selector.selected_count": "{{count}} valgt",
        "offers.calculation.selector.clear": "Fjern alle valg",
        "offers.calculation.selector.close": "Lukk",
        "offers.calculation.selector.total": "Total",
        "offers.calculation.selector.type": "Type",
        "offers.calculation.selector.untitled": "Kalkyle #{{id}}",
        "offers.calculation.nested.edit_title": "Rediger kalkyle: {{title}}",
        "offers.calculation.nested.eyebrow": "Rediger kalkyle",
        "offers.calculation.nested.offer_only_hint": "Endringer gjelder bare dette tilbudet. Firmamalen endres ikke.",
        "offers.calculation.nested.save": "Lagre",
        "offers.calculation.nested.save_success": "Kalkylen ble lagret for dette tilbudet",
        "offers.calculation.nested.tab_products": "Produkter og felter",
        "offers.calculation.nested.tab_notes": "Notater",
        "offers.calculation.nested.tab_display": "Visning",
        "offers.calculation.nested.tab_builder": "Modulbygger",
        "offers.calculation.nested.products_panel_hint": "Knytt linjer til produkter i registeret og oppdater priser. Dette er hovedflaten for daglig arbeid på linjekalkylen.",
        "offers.calculation.nested.no_product_catalogs": "Ingen produktliste-noder i denne modulen ennå. Legg til «Produktliste» i modulbyggeren.",
        "offers.calculation.nested.unit_total_label": "Enhetssum (modul)",
        "offers.calculation.nested.unit_total_hint": "Linjesum på tilbudet = mengde × denne enhetssummen.",
        "offers.calculation.nested.notes_heading": "Notater i modul",
        "offers.calculation.nested.notes_panel_hint": "Rediger modulnotater og velg hva som skal vises på tilbudet/PDF. Rekkefølgen her styrer rekkefølgen i tilbudsteksten.",
        "offers.calculation.nested.notes_offer_text_hint": "Valgfri kundetekst for hele modulen (vises på tilbudet når den er fylt ut).",
        "offers.calculation.nested.notes_empty": "Ingen notat-noder i modulen ennå. Legg til «Notat» i modulbyggeren.",
        "offers.calculation.nested.notes_item_label": "Notat {{n}}",
        "offers.calculation.nested.notes_body_placeholder": "Skriv notateksten…",
        "offers.calculation.nested.notes_show_in_offer_hint": "Avkrysset = teksten blir kundetekst på tilbudet/PDF. Standard er synlig.",
        "offers.calculation.nested.tab_lines": "Linjer",
        "offers.calculation.nested.display.panel_hint": "Styr hvordan denne kalkylen, underliggende moduler/linjer og produkter vises for kunden og i PDF. Innhold og priser redigeres i de andre fanene.",
        "offers.calculation.nested.display.structure_heading": "Struktur for kunden",
        "offers.calculation.nested.display.structure_hint": "Velg om kunden ser underlinjer, kun sum, eller om noden skjules. Lagres i tilbudets presentasjonsregler.",
        "offers.calculation.nested.display.structure_needs_offer": "Strukturregler krever at kalkylen er knyttet til et tilbud.",
        "offers.calculation.nested.display.show_product_info_hint": "Gjelder hele tilbudet når underlinjer vises. Av = kun tittel/pris uten produktbeskrivelse.",
        "offers.calculation.nested.display.content_heading": "Innhold i tilbud/PDF",
        "offers.calculation.nested.display.content_hint": "Kalkylefelter som allerede finnes på denne kalkylen (show_*).",
        "offers.calculation.nested.display.show_hours": "Vis timeantall",
        "offers.calculation.nested.display.show_hours_hint": "Vis timer for denne kalkylen i tilbud/PDF.",
        "offers.calculation.nested.display.show_quantities": "Vis mengder",
        "offers.calculation.nested.display.show_quantities_hint": "Vis mengder for linjer under denne kalkylen.",
        "offers.calculation.nested.display.show_products": "Vis produkter",
        "offers.calculation.nested.display.show_products_hint": "Vis produktlinjer i tilbud/PDF.",
        "offers.calculation.nested.display.show_setup_only": "Kun oppsett (tittel/sum)",
        "offers.calculation.nested.display.show_setup_only_hint": "Når på: kun tittel, beskrivelse og delbeløp — ikke produkter eller timeberegning.",
        "offers.calculation.nested.display.show_quantities_offer_item": "Kun mengde på tilbudspost",
        "offers.calculation.nested.display.show_quantities_offer_item_hint": "Skjul antall på underliggende produkter; vis mengde på tilbudsposten.",
        "offers.calculation.nested.display.include_product_short": "Ta med kort produktbeskrivelse",
        "offers.calculation.nested.display.include_product_short_hint": "Vis produktets short_description når bilde/URL vises.",
        "offers.calculation.nested.display.products_heading": "Produktlinjer",
        "offers.calculation.nested.display.products_hint": "Per-linje synlighet (bilde, URL, timer) lagret på linjen.",
        "offers.calculation.nested.display.product_line_fallback": "Produktlinje {{n}}",
        "offers.calculation.nested.display.line_show_hours": "Vis timer på linjen",
        "offers.calculation.nested.display.notes_heading": "Notatsynlighet",
        "offers.calculation.nested.display.notes_hint": "Samme show_in_offer som under Notater — her kun synlighet, ikke tekstinnhold.",
        "offers.calculation.nested.this_calculation": "Denne kalkylen",
        "offers.calculation.nested.structure_heading": "Kalkylastruktur",
        "offers.calculation.nested.structure_hint": "Nestede kalkylemaler under denne linjen. Åpne for å redigere anbefalte felter og struktur på hvert nivå.",
        "offers.calculation.nested.edit_structure": "Rediger",
        "offers.calculation.nested.back_in_tree": "Tilbake",
        "offer.calculation.line.insert_title": "Anbefalte felter",
        "offer.calculation.line.insert_hint": "Felt malen åpner for redigering. Full modulbygger er tilgjengelig via knappen.",
        "offer.calculation.line.insert_locked": "Alle felt er låst i malen. Åpne modulbygger for å redigere.",
        "offer.calculation.line.open_builder": "Åpne linjekalkyle",
        "offer.calculation.line.products_in_builder": "Produkter redigeres under fanen Produkter og felter.",
        "offer.calculation.line.products_jump": "Gå til produktliste",
        "offer.calculation.line.insert_needs_attention": "Anbefalte felter er ikke gjennomgått ennå",
        "offer.calculation.line.insert_done": "Ferdig",
        "offer.calculation.line.qty_times_unit": "Mengde × enhetspris: {{formula}}",
        "offer.calculation.line.module_notes_count": "{{count}} notat i modul",
        "offer.calculation.line.module_notes_count_plural": "{{count}} notater i modul",
        "offers.calculation.save_template_dialog.title": "Lagre kalkylemal?",
        "offers.calculation.save_template_dialog.description": "Du redigerer en kalkylemal fra et tilbud. Vil du også oppdatere malen, eller bare lagre endringene for dette tilbudet?",
        "offers.calculation.save_template_dialog.update_template": "Oppdater mal",
        "offers.calculation.save_template_dialog.update_template_hint": "Endringene vil gjelde for alle fremtidige bruk av denne malen.",
        "offers.calculation.save_template_dialog.offer_only": "Kun for dette tilbudet",
        "offers.calculation.save_template_dialog.offer_only_hint": "Endringene lagres kun for dette tilbudet. Malen forblir uendret.",
        "offers.calculation.save_template_dialog.save_failed": "Kunne ikke lagre kalkylen",
        "offers.tabs.document_intro": "Utgående tilbudsdokument — struktur og forhåndsvisning for sending og PDF. Dette er ikke en generell filliste.",
        "offers.documentBuilder.structure_title": "Dokumentstruktur",
        "offers.documentBuilder.add_block": "+ Legg til blokk",
        "offers.documentBuilder.move_up": "Flytt opp",
        "offers.documentBuilder.move_down": "Flytt ned",
        "offers.documentBuilder.saving": "Lagrer…",
        "offers.documentBuilder.saved": "Lagret",
        "offers.documentBuilder.blocks.cover": "Forside",
        "offers.documentBuilder.blocks.letter": "Tilbudsbrev",
        "offers.documentBuilder.blocks.project_description": "Prosjektbeskrivelse",
        "offers.documentBuilder.blocks.scope": "Leveranseomfang",
        "offers.documentBuilder.blocks.price": "Pris",
        "offers.documentBuilder.blocks.alternatives": "Alternativer",
        "offers.documentBuilder.blocks.attachments": "Vedlegg",
        "offers.documentBuilder.blocks.signature": "Signatur",
        "offers.documentBuilder.blocks.custom_text": "Egen tekst",
        "offers.documentBuilder.preview.label": "Forhåndsvisning",
        "offers.documentBuilder.preview.title_prefix": "Tilbud:",
        "offers.documentBuilder.preview.untitled": "Uten tittel",
        "offers.documentBuilder.preview.rev": "Rev. {{rev}}",
        "offers.documentBuilder.preview.price_label": "Tilbudssum eks. mva",
        "offers.documentBuilder.preview.attachments_placeholder": "Vedlegg listes i det ferdige dokumentet. Last opp filer under fanen Vedlegg.",
        "offers.documentBuilder.preview.empty_section": "Ingen tekst ennå",
        "offers.documentBuilder.preview.alternatives_hint": "Alternativer og valgfrie tillegg inngår ikke i tilbudssummen med mindre de velges.",
        "offers.documentBuilder.preview.alternative_selected": "Valgt i tilbudet",
        "offers.documentBuilder.preview.alternative_option": "Alternativ",
        "offers.documentBuilder.preview.optional_extras": "Valgfrie tillegg",
        "offers.documentBuilder.editor.title_label": "Tittel",
        "offers.documentBuilder.editor.body_label": "Tekst",
        "offers.documentBuilder.editor.body_placeholder": "Skriv innhold for denne seksjonen…",
        "offers.documentBuilder.editor.title_placeholder": "Tittel på blokken",
        "offers.documentBuilder.editor.custom_section": "Egen tekstblokk",
        "offers.documentBuilder.editor.price_hint": "Pris hentes live fra tilbudssummen (eks. mva) og kan ikke redigeres her.",
        "offers.documentBuilder.editor.attachments_hint": "Denne blokken er en seksjon i dokumentstrukturen. Filene administreres under fanen Vedlegg.",
        "offers.documentBuilder.editor.offer_edit_sourced_hint": "Teksten redigeres under «Rediger tilbud → Prosjektbeskrivelse».",
        "offers.documentBuilder.editor.alternatives_hint": "Alternativer hentes automatisk fra linjer med alternativgruppe eller rolle «valgfri». Du kan legge til innledningstekst under Avansert layout om ønskelig.",
        "offers.documentBuilder.preview.page_break": "Sideskift",
        "offers.documentBuilder.preview.refresh": "Oppdater forhåndsvisning",
        "offers.documentBuilder.preview.showing_saved": "Viser lagret versjon",
        "offers.documentBuilder.preview.loading": "Laster forhåndsvisning…",
        "offers.documentBuilder.preview.pdf_failed": "Kunne ikke laste PDF-forhåndsvisning",
        "offers.documentBuilder.preview.empty_live": "Ingen PDF å vise ennå. Oppdater forhåndsvisningen når dokumentet er lagret.",
        "offers.documentBuilder.preview.show_html_mock": "Vis HTML-skisse",
        "offers.documentBuilder.preview.show_live_pdf": "Vis live PDF",
        "offers.documentBuilder.editor.inspector_title": "Blokkinnstillinger",
        "offers.documentBuilder.editor.inspector_subtitle": "{{type}} — innhold og innstillinger for denne seksjonen",
        "offers.documentBuilder.editor.settings_title": "Innstillinger",
        "offers.documentBuilder.editor.enabled_label": "Aktiv",
        "offers.documentBuilder.editor.enabled_hint": "Vis denne seksjonen i dokumentet",
        "offers.documentBuilder.editor.show_in_pdf_label": "Vis i PDF",
        "offers.documentBuilder.editor.show_in_pdf_hint": "Inkluder seksjonen når tilbudet eksporteres til PDF",
        "offers.documentBuilder.editor.page_break_label": "Sideskift før",
        "offers.documentBuilder.editor.page_break_hint": "Start denne seksjonen på en ny side i PDF-en",
        "offers.documentBuilder.editor.heading_level_label": "Overskriftsnivå",
        "offers.documentBuilder.editor.heading_level_none": "Ingen",
        "offers.documentBuilder.editor.visibility_label": "Synlighet",
        "offers.documentBuilder.editor.visibility_all": "Overalt",
        "offers.documentBuilder.editor.visibility_pdf_only": "Kun PDF",
        "offers.documentBuilder.editor.visibility_screen_only": "Kun skjerm",
        "offers.documentBuilder.editor.advanced_layout": "Avansert layout",
        "offers.documentBuilder.editor.padding_label": "Innvendig marg (padding)",
        "offers.documentBuilder.editor.margin_label": "Utvendig marg (margin)",
        "offers.documentBuilder.editor.side_top": "Topp",
        "offers.documentBuilder.editor.side_right": "Høyre",
        "offers.documentBuilder.editor.side_bottom": "Bunn",
        "offers.documentBuilder.editor.side_left": "Venstre",
        "offers.documentBuilder.editor.load_template": "Last inn Promang-mal",
        "offers.documentBuilder.editor.cover.settings_title": "Forsideinnstillinger",
        "offers.documentBuilder.editor.cover.subtitle_label": "Undertittel",
        "offers.documentBuilder.editor.cover.subtitle_placeholder": "Skriv undertittel for forsiden…",
        "offers.documentBuilder.editor.cover.show_customer_label": "Vis kunde",
        "offers.documentBuilder.editor.cover.show_offer_date_label": "Vis tilbudsdato",
        "offers.documentBuilder.editor.cover.image_hint": "Forsidebilde settes under Forside-seksjonen nedenfor og gjenbrukes automatisk for denne blokken.",
        "offers.documentBuilder.editor.letter.settings_title": "Brevinnstillinger",
        "offers.documentBuilder.editor.letter.greeting_label": "Hilsen (åpning)",
        "offers.documentBuilder.editor.letter.greeting_placeholder": "F.eks. «Hei,»",
        "offers.documentBuilder.editor.letter.signoff_label": "Avslutning",
        "offers.documentBuilder.editor.letter.signoff_placeholder": "F.eks. «Med vennlig hilsen»",
        "offers.documentBuilder.editor.price.settings_title": "Prisinnstillinger",
        "offers.documentBuilder.editor.price.show_vat_label": "Vis mva",
        "offers.documentBuilder.editor.price.show_summary_table_label": "Vis sammendragstabell",
        "offers.documentBuilder.editor.price.note_label": "Notat",
        "offers.documentBuilder.editor.price.note_placeholder": "Valgfritt notat under prisen…",
        "offers.documentBuilder.editor.signature.settings_title": "Signaturinnstillinger",
        "offers.documentBuilder.editor.signature.show_date_field_label": "Vis datofelt",
        "offers.documentBuilder.editor.signature.show_title_field_label": "Vis stillingstittel-felt",
        "offers.documentBuilder.editor.signature.signatory_count_label": "Antall signaturer",
        "offers.tabs.attachments_intro": "Generelle vedlegg og dokumentasjon for tilbudet (Promang DocumentManager). Last opp filer her.",
        "offers.tabs.save_lines": "Lagre linjer",
        "offers.tabs.no_offer": "Tilbudet må lagres før du kan redigere dette.",
        "offers.edit.title": "Rediger tilbud",
        "offers.edit.tab.stamdata": "Stamdata",
        "offers.edit.tab.comments": "Kommentarer",
        "offers.edit.tab.project_description": "Prosjektbeskrivelse",
        "offers.edit.customer": "Kunde",
        "offers.edit.customer_required": "Kunde er påkrevd",
        "offers.edit.contact": "Kundekontakt",
        "offers.edit.project": "Prosjekt",
        "offers.edit.department": "Avdeling",
        "offers.edit.responsible": "Vår kontaktperson",
        "offers.edit.currency": "Valuta",
        "offers.edit.offer_title": "Tittel",
        "offers.edit.offer_number": "Tilbudsnummer",
        "offers.edit.reference": "Referanse",
        "offers.edit.offer_date": "Tilbudsdato",
        "offers.edit.valid_from": "Gyldig fra",
        "offers.edit.valid_to": "Gyldig til",
        "offers.edit.comment": "Kommentar",
        "offers.edit.comment_hint": "Brukes i enkelt PDF-oppsett.",
        "offers.edit.comment_placeholder": "Skriv kommentar til tilbudet…",
        "offers.edit.project_description": "Prosjektbeskrivelse",
        "offers.edit.project_description_hint": "Vises i dokumentoppsett og utskrift.",
        "offers.edit.project_description_placeholder": "Beskriv prosjektet…",
        "offers.edit.scope": "Omfang / Leveranseomfang",
        "offers.edit.scope_hint": "Vises i dokumentoppsett og utskrift.",
        "offers.edit.scope_placeholder": "Beskriv omfang og leveranse…",
        "offers.edit.cancel": "Avbryt",
        "offers.edit.save": "Lagre",
        "offers.edit.saving": "Lagrer…",
        "offers.delete.confirm": "Dette tilbudet vil bli fjernet for godt og kan ikke reverseres.",
        "offers.create.title": "Opprett tilbud",
        "offers.create.intro": "Fyll inn stamdata for å starte et nytt tilbud.",
        "offers.create.customer": "Kunde",
        "offers.create.customer_required": "Kunde må velges før tilbudet kan opprettes.",
        "offers.create.project": "Prosjekt",
        "offers.create.contact": "Kundekontakt",
        "offers.create.responsible": "Vår kontaktperson",
        "offers.create.reference": "Referanse",
        "offers.create.description": "Beskrivelse",
        "offers.create.cancel": "Avbryt",
        "offers.create.submit": "Opprett tilbud",
        "offers.create.creating": "Oppretter…",
        "offers.create.success": "Tilbudet ble opprettet.",
        "offers.create.failed": "Kunne ikke opprette tilbudet.",
        "offers.checklist.title": "Sjekkliste",
        "offers.checklist.intro": "Planlegg og følg opp punkter for dette tilbudet.",
        "offers.checklist.empty_title": "Ingen sjekkliste er opprettet",
        "offers.checklist.empty_description": "Opprett en sjekkliste for å sikre at tilbudet er komplett før det sendes.",
        "offers.checklist.create": "Opprett sjekkliste",
        "offers.checklist.created": "Sjekklisten ble opprettet.",
        "offers.checklist.create_error": "Kunne ikke opprette sjekklisten.",
        "offers.checklist.load_error": "Kunne ikke laste sjekklisten.",
        "offers.checklist.save_error": "Kunne ikke lagre sjekklisten.",
        "offers.checklist.delete": "Slett sjekkliste",
        "offers.checklist.deleted": "Sjekklisten ble slettet.",
        "offers.checklist.delete_error": "Kunne ikke slette sjekklisten.",
        "offers.checklist.delete_confirm": "Er du sikker på at du vil slette sjekklisten?",
        "offers.checklist.unavailable": "Sjekkliste er ikke tilgjengelig for dette tilbudet.",
        "offers.checklist.type_label": "Sjekklistetype",
        "offers.checklist.type_blank": "Tom sjekkliste (uten mal)",
        "offers.checklist.types_loading": "Laster typer…",
        "offers.checklist.type_hint": "Valgfritt: velg en firmamal for å fylle punkter automatisk.",
        "offers.send.checklist_required": "Firmaet krever sjekkliste før sending. Opprett sjekkliste under fanen Sjekkliste.",
        "offers.send.contact_load_failed": "Kunne ikke hente kontaktinformasjon",
        "offers.send.send_to": "Send til",
        "offers.send.me": "Meg",
        "offers.send.customer": "Kunde",
        "offers.send.contact": "Kontakt",
        "offers.send.loading": "Laster …",
        "offers.send.name": "Navn",
        "offers.send.email": "E-post",
        "offers.send.offer_type": "Tilbudstype",
        "offers.send.internal_offer": "Internt tilbud",
        "offers.send.customer_offer": "Kundetilbud",
        "offers.send.open_pdf": "Åpne valgt tilbuds-PDF",
        "offers.send.pdf_preview_pending": "PDF-forhåndsvisning blir tilgjengelig når valgt tilbudstype er generert.",
        "offers.send.message": "Melding til kunden",
        "offers.send.close": "Lukk",
        "offers.send.sending": "Sender …",
        "offers.send.submit": "Send",
        "offers.workspace.save_idle": "Ingen ulagrede endringer",
        "offers.documentAi.attachments_title": "Vedlegg",
        "offers.documentAi.attachments_intro": "Last opp og administrer dokumenter som hører til tilbudet.",
        "offers.attachments.dropzone_title": "Dra og slipp filer her, eller klikk for å velge",
        "offers.attachments.dropzone_hint": "PDF, bilder, Word, Excel og flere formater",
        "offers.attachments.drop_here": "Slipp filene her",
        "offers.documentAi.title": "Dokumentgjennomgang",
        "offers.documentAi.intro": "Analyser et vedlegg eller lim inn tekst. Forslagene må godkjennes før de legges til.",
        "offers.documentAi.document": "Velg vedlegg",
        "offers.documentAi.select_document": "Velg dokument",
        "offers.documentAi.paste_text": "Eller lim inn tekst",
        "offers.documentAi.source_required": "Velg et vedlegg eller lim inn tekst først.",
        "offers.documentAi.analyze": "Analyser dokument",
        "offers.documentAi.analyzing": "Analyserer…",
        "offers.documentAi.failed": "Kunne ikke analysere dokumentet.",
        "offers.documentAi.summary": "Sammendrag",
        "offers.documentAi.gaps": "Manglende informasjon",
        "offers.documentAi.suggested_lines": "Foreslåtte linjer",
        "offers.documentAi.checklist_hints": "Forslag til sjekkliste",
        "offers.documentAi.copy": "Kopier valgte",
        "offers.documentAi.copied": "Valgte linjer ble kopiert.",
        "offers.documentAi.copy_failed": "Kunne ikke kopiere de valgte linjene.",
        "offers.documentAi.apply_notes": "Legg til i kommentar",
        "offers.documentAi.applied": "Valgte linjer ble lagt til i kommentaren.",
        "offers.documentAi.apply_failed": "Kunne ikke legge til de valgte linjene.",
        "offer.calculation.totals.summary_title": "Summer (fra server)",
        "offer.calculation.totals.sales_total": "Salgstotal",
        "offer.calculation.totals.cost_total": "Kostnadstotal",
        "offer.calculation.totals.contribution_margin": "Dekningsbidrag",
        "offer.calculation.totals.contribution_margin_percent": "Dekningsgrad",
        "offer.calculation.totals.authoritative_hint": "Serverberegnet",
        "offer.calculation.totals.estimate_hint": "Estimat",
        "offer.calculation.line.total": "Linjetotal",
        "offer.calculation.line.cost_total": "Linjekostnad",
        "offer.calculation.line.price_source": "Priskilde",
        "offer.calculation.line.price_dated_at": "Prisdato",
        "offer.calculation.import.title": "Importer mengder (CSV/Excel)",
        "offer.calculation.import.subtitle": "Last opp CSV eller Excel, kontroller kapittel, produktmatch, foreslått pris/timer og legg til linjer. Endringer skrives først ved «Legg til i kalkyle».",
        "offer.calculation.import.upload": "Last opp",
        "offer.calculation.import.apply": "Legg til i kalkyle",
        "offer.calculation.import.file_required": "Velg en CSV- eller Excel-fil først.",
        "offer.calculation.import.failed": "Kunne ikke fullføre importen.",
        "offer.calculation.import.upload_success": "Filen er lastet opp og matchet.",
        "offer.calculation.import.apply_success": "{{count}} linjer ble lagt til i kalkylen.",
        "offer.calculation.import.job_status": "Status",
        "offer.calculation.import.confirm": "Bekreft match",
        "offer.calculation.import.skip": "Hopp over",
        "offer.calculation.import.col.confirm": "Bekreft",
        "offer.calculation.import.col.sheet": "Ark",
        "offer.calculation.import.col.chapter": "Kapittel",
        "offer.calculation.import.col.sku": "Postnr",
        "offer.calculation.import.col.name": "Beskrivelse",
        "offer.calculation.import.col.qty": "Antall",
        "offer.calculation.import.col.price": "Foreslått pris",
        "offer.calculation.import.col.discount": "Rabatt",
        "offer.calculation.import.col.surcharge": "Påslag",
        "offer.calculation.import.col.hours": "Timer",
        "offer.calculation.import.col.match": "Match",
        "offer.calculation.import.col.product": "Produkt",
        "offer.calculation.import.col.actions": "Handlinger",
        "offer.calculation.import.counts.confirmed": "Bekreftet",
        "offer.calculation.import.counts.suggested": "Forslag",
        "offer.calculation.import.counts.unmatched": "Uten match",
        "offer.calculation.import.match_status.unmatched": "Ingen match",
        "offer.calculation.import.match_status.suggested": "Forslag",
        "offer.calculation.import.match_status.confirmed": "Bekreftet",
        "offer.calculation.import.match_status.skipped": "Hoppet over",
        "offer.calculation.import.match_status.applied": "Lagt til",
        "offer.calculation.workspace.title": "Kalkylearbeidsflate",
        "offer.calculation.workspace.structure_title": "Struktur",
        "offer.calculation.workspace.add_structure": "Ny struktur",
        "offer.calculation.workspace.context_title": "Linjedetaljer",
        "offer.calculation.workspace.properties": "Egenskaper",
        "offer.calculation.workspace.show_structure": "Vis struktur",
        "offer.calculation.workspace.hide_structure": "Skjul struktur",
        "offer.calculation.workspace.show_context": "Vis kontekst",
        "offer.calculation.workspace.hide_context": "Skjul kontekst",
        "offer.calculation.workspace.structure_empty_title": "Ingen linjer ennå",
        "offer.calculation.workspace.structure_empty_hint": "Legg til en linje i midten for å bygge strukturen.",
        "offer.calculation.workspace.context_empty_title": "Ingen linje valgt",
        "offer.calculation.workspace.context_empty_hint": "Velg en linje i strukturen eller i listen for å se detaljer her.",
        "offer.calculation.workspace.chapter_properties": "Kapittel",
        "offer.calculation.workspace.chapter_subtotal": "Kapittelsum",
        "offer.calculation.workspace.chapter_lines": "{{count}} linje(r) i kapittel",
        "offer.calculation.workspace.lines_empty_title": "Ingen linjer",
        "offer.calculation.workspace.lines_empty_hint": "Klikk «Ny manuell linje» for å legge til første rad.",
        "offer.calculation.workspace.untitled_line": "Linje {{n}}",
        "offer.calculation.workspace.selected_line": "Valgt linje {{n}}",
        "offer.calculation.workspace.edit_line": "Rediger linje",
        "offer.calculation.workspace.field.quantity": "Mengde",
        "offer.calculation.workspace.field.hours": "Timer",
        "offer.calculation.workspace.field.cost_unit": "Kostpris/enhet",
        "offer.calculation.workspace.field.markup": "Påslag",
        "offer.calculation.workspace.field.sales_unit": "Salgspris/enhet",
        "offer.calculation.workspace.field.cost": "Kostnad",
        "offer.calculation.workspace.field.total": "Total",
        "offer.calculation.workspace.field.margin": "Dekningsgrad",
        "offer.calculation.workspace.override_title": "Manuell overstyring",
        "offer.calculation.workspace.override_hint": "Linjen har manuell prisoverstyring.",
        "offer.calculation.workspace.validation_title": "Validering",
        "offer.calculation.workspace.source": "Kilde",
        "offer.calculation.workspace.line_type.manual": "Manuell",
        "offer.calculation.workspace.line_type.product": "Produkt",
        "offer.calculation.workspace.line_type.hours": "Timer",
        "offer.calculation.workspace.line_type.calculation": "Beregning",
        "offer.calculation.workspace.line_type.note": "Notat",
        "offer.calculation.workspace.line_type.other": "Annet",
        "offer.calculation.workspace.col.line": "#",
        "offer.calculation.workspace.col.description": "Beskrivelse",
        "offer.calculation.workspace.col.type": "Type",
        "offer.calculation.workspace.col.quantity": "Mengde",
        "offer.calculation.workspace.col.unit": "Enhet",
        "offer.calculation.workspace.col.cost_price": "Kostpris",
        "offer.calculation.workspace.col.sales_price": "Salgspris",
        "offer.calculation.workspace.col.line_sum": "Linjesum",
        "offer.calculation.workspace.col.margin": "DG%",
        "offer.calculation.workspace.totals_cost": "Kostnad",
        "offer.calculation.workspace.totals_sales": "Tilbudssum",
        "offer.calculation.workspace.totals_margin": "Dekningsbidrag",
        "offer.calculation.workspace.totals_margin_percent": "Dekningsgrad",
        "offer.calculation.workspace.col.unit_short": "Enh.",
        "offer.calculation.workspace.col.hours": "Timer",
        "offer.calculation.workspace.col.cost": "Kostnad",
        "offer.calculation.workspace.col.markup": "Påslag",
        "offer.calculation.workspace.col.total": "Total",
        "offer.calculation.workspace.col.risk": "Risiko",
        "offer.calculation.workspace.col.source": "Kilde",
        "offer.calculation.workspace.columns": "Kolonner",
        "offer.calculation.workspace.settings": "Visningsinnstillinger",
        "offer.calculation.workspace.settings_aria": "Åpne visningsinnstillinger for tetthet og kolonner",
        "offer.calculation.workspace.density": "Tetthet",
        "offer.calculation.workspace.density.compact": "Kompakt",
        "offer.calculation.workspace.density.comfortable": "Komfortabel",
        "offer.calculation.workspace.use_template": "Bruk kalkylemal",
        "offer.calculation.workspace.load_page_template": "Last inn kalkylemal",
        "offer.calculation.workspace.use_template_stub": "Kalkylemal er ikke tilgjengelig ennå.",
        "offer.calculation.nested.blank_title": "Ny nestet kalkyle",
        "offer.calculation.nested_source.title": "Bruk kalkylemal",
        "offer.calculation.nested_source.hint": "Velg om du vil opprette en ny nestet kalkyle, eller bruke en eksisterende firmamal.",
        "offer.calculation.nested_source.new_title": "Ny",
        "offer.calculation.nested_source.new_hint": "Opprett en tom nestet kalkyle (kalkyle i kalkyle) som du kan redigere.",
        "offer.calculation.nested_source.existing_title": "Eksisterende",
        "offer.calculation.nested_source.existing_hint": "Velg en firmamal og kopier den inn som nestet kalkyle. Malen endres ikke.",
        "offer.calculation.nested_source.cancel": "Avbryt",
        "offer.calculation.workspace.save_status.idle": "Klar",
        "offer.calculation.workspace.save_status.pending": "Endringer venter…",
        "offer.calculation.workspace.save_status.saved": "Alle endringer er lagret",
        "offer.calculation.workspace.save_status.saving": "Lagrer…",
        "offer.calculation.workspace.save_status.error": "Lagring feilet",
        "offer.calculation.workspace.missing_cost_line": "Kostpris mangler på denne linjen.",
        "offer.calculation.workspace.missing_cost": "{{count}} linje(r) mangler kostpris",
        "offer.calculation.workspace.totals.material": "Materialkost",
        "offer.calculation.workspace.totals.labor": "Arbeid",
        "offer.calculation.workspace.totals.module": "Modul",
        "offer.calculation.workspace.totals.hours_sum": "Sum timer",
        "offer.calculation.workspace.totals.total_cost": "Total kostnad",
        "offer.calculation.workspace.totals.contribution": "Dekningsbidrag",
        "offer.calculation.workspace.totals.margin_rate": "Dekningsgrad",
        "offer.calculation.workspace.totals.offer_ex_vat": "Tilbudssum eks. mva",
        "offer.calculation.workspace.totals.compact": "Tilbudssum eks. mva: {{sales}} · DG {{dg}}",
        "offer.calculation.workspace.totals.collapse": "Skjul totalsone",
        "offer.calculation.workspace.totals.expand": "Vis totalsone",
        "offer.calculation.summary.title": "Kalkylsammendrag",
        "offer.calculation.summary.subtitle": "Autoritative tall fra API (BigDecimal)",
        "offer.calculation.summary.hours_total": "Sum timer",
        "offer.calculation.summary.hours_by_role": "Timer per rolle",
        "offer.calculation.summary.material_cost": "Materiell kost",
        "offer.calculation.summary.labor_cost": "Arbeid kost",
        "offer.calculation.summary.cost_total": "Total kostnad",
        "offer.calculation.summary.db": "Dekningsbidrag (DB)",
        "offer.calculation.summary.dg": "Dekningsgrad (DG%)",
        "offer.calculation.summary.sales_total": "Tilbudssum eks. mva",
        "offer.calculation.summary.info_aria": "Hvordan beregnes {{label}}?",
        "offer.calculation.summary.role.montor": "Montør",
        "offer.calculation.summary.role.montasjeleder": "Montasjeleder",
        "offer.calculation.summary.role.prosjektleder": "Prosjektleder",
        "offer.calculation.summary.role.prosjektering": "Prosjektering",
        "offer.calculation.summary.role.innleid": "Innleid",
        "offer.calculation.summary.role_key_label": "Rolle",
        "offer.calculation.summary.guide.hours.title": "Sum timer",
        "offer.calculation.summary.guide.hours.body": "Summerer timer per linje (quantity × hours) fordelt på roller via labor_role eller hours_by_role. Backend er autoritativ.",
        "offer.calculation.summary.guide.material.title": "Materiellkost",
        "offer.calculation.summary.guide.material.body": "Kostnad for produkt-/manuelle linjer (ikke timer). Hentes fra summary.material_cost i API.",
        "offer.calculation.summary.guide.labor.title": "Arbeidskost",
        "offer.calculation.summary.guide.labor.body": "Kostnad for timelinjer (line_type hours eller linjer med timer). Hentes fra summary.labor_cost.",
        "offer.calculation.summary.guide.cost.title": "Total kostnad",
        "offer.calculation.summary.guide.cost.body": "Samlet kostnad (materiell + arbeid + modul). Ved offer_calculation_v2 brukes lagret cost_total fra Offers::RecalculateCalculation.",
        "offer.calculation.summary.guide.db.title": "Dekningsbidrag (DB)",
        "offer.calculation.summary.guide.db.body": "DB = tilbudssum − kostnad. Samme som contribution_margin fra backend.",
        "offer.calculation.summary.guide.dg.title": "Dekningsgrad (DG%)",
        "offer.calculation.summary.guide.dg.body": "DG% = (DB / tilbudssum) × 100. Null når tilbudssum er 0.",
        "offer.calculation.summary.guide.sales.title": "Tilbudssum",
        "offer.calculation.summary.guide.sales.body": "Total salgssum eks. mva fra kalkylelinjene (total_amount / summary.sales_total).",
        "offer.calculation.workspace.display_settings": "Innstillinger for visning",

        "offer.calculation.workspace.bulk.select_all": "Velg alle linjer",
        "offer.calculation.workspace.bulk.select_row": "Velg linje",
        "offer.calculation.workspace.bulk.delete_selected": "Slett valgte",
        "offer.calculation.workspace.bulk.clear": "Fjern markering",
        "offer.calculation.workspace.bulk.delete_confirm": "Er du sikker på at du vil slette {{count}} valgte linjer?",
        "offer.calculation.line_editor.standard_fields": "Standardfelter",
        "offer.calculation.line_editor.quantity": "Antall / mengde",
        "offer.calculation.line_editor.hours_count": "Antall timer",
        "offer.calculation.line_editor.sales_price_auto": "Salgspris (auto)",
        "offer.calculation.line_editor.cost_price_auto": "Kostpris (auto)",
        "offer.calculation.line_editor.show_in_offer": "Vis i tilbudet",
        "offer.calculation.line_editor.delete_confirm": "Er du sikker på at du vil slette denne raden?",
        "offer.calculation.line_editor.hour_rate": "Timepris",
        "offer.calculation.line_editor.cost_hour_rate": "Timekost",
        "offer.calculation.line_editor.select_hour_rate": "Velg timesats",
        "offer.calculation.line_editor.hour_rate_from_catalog": "Hentes fra Timesatser (/offers/hour-rates)",
        "offer.calculation.line_editor.no_hour_rates": "Ingen timesatser funnet.",
        "offer.calculation.line_editor.create_hour_rate": "Opprett ny timesats",
        "offer.calculation.line_editor.hours_section": "Timeberegning",
        "offer.calculation.line_editor.hide_hours": "Skjul",
        "offer.calculation.line_editor.add_hours": "Legg til timeberegning",
        "offer.calculation.line_editor.hours_pricing_mode": "Hvordan skal tiden beregnes?",
        "offer.calculation.line_editor.hours_mode_product_plus_hours": "Tid i tillegg til produktpris",
        "offer.calculation.line_editor.hours_mode_from_price": "Beregn timer ut fra pris (utledning, legges ikke til)",
        "offer.calculation.line_editor.hours_mode_product_plus_hours_hint": "Enhetspris = produktpris + timer × timepris. Linjebeløp = enhetspris × mengde.",
        "offer.calculation.line_editor.auto_calc_hours": "Beregn timeantall automatisk",
        "offer.calculation.line_editor.from_sales_price": "Ut fra salgspris",
        "offer.calculation.line_editor.from_cost_price": "Ut fra kostpris",
        "offer.calculation.line_editor.hours_amount": "Timebeløp",
        "offer.calculation.line_editor.unit_with_hours": "Enhetspris med tid",
        "offer.calculation.line_editor.hours_focus_hint": "Kun tid — beskrivelse, timer og satser",
        "offer.calculation.line_editor.product_focus_hint": "Produkt, mengde og priser",
        "offer.calculation.line_editor.manual_focus_hint": "Fri beskrivelse og beløp",
        "offer.calculation.line_editor.calculation_focus_hint": "Nestet kalkyle / modul",
        "offer.calculation.line_editor.note_focus_hint": "Kun tekst til kunde / PDF — uten mengde eller pris",
        "offer.calculation.line_editor.note_text": "Notattekst",
        "offer.calculation.line_editor.select_product": "Velg produkt",
        "offer.calculation.line_editor.unit_hours": "Time",
        "offer.calculation.line_editor.price_mode": "Prisberegning",
        "offer.calculation.line_editor.price_mode_automatic": "Automatisk (fra timer)",
        "offer.calculation.line_editor.price_mode_custom": "Manuell",
        "offer.calculation.line_editor.hours_notes_section": "Notater (kalkyler / produkter)",
        "offer.calculation.line_editor.hours_notes_hint": "På timelinjer lagres kalkyler og produkter kun som notater — de påvirker ikke pris eller product_id.",
        "offer.calculation.line_editor.add_calc_as_note": "Legg til kalkyle som notat",
        "offer.calculation.line_editor.add_product_as_note": "Legg til produkt som notat",
        "offer.calculation.line_editor.calcs_and_products": "Kalkyler og produkter",
        "offer.calculation.line_editor.line_n": "Linje {{n}}",
        "offer.calculation.line_editor.discount_pct": "Rabatt %",
        "offer.calculation.line_editor.surcharge_pct": "Påslag %",
        "offer.calculation.line_editor.display_options": "Visningsalternativer",
        "offer.calculation.line_editor.show_product_image_pdf": "Vis produktbilde i PDF",
        "offer.calculation.line_editor.show_product_url_pdf": "Vis produkt-URL i PDF",
        "offer.calculation.line_editor.add_note": "Legg til notat",
        "offer.calculation.line_editor.edit_note": "Rediger notat",
        "offer.calculation.line_editor.update_note": "Oppdater",
        "offer.calculation.line_editor.notes_section": "Notater",
        "offer.calculation.line_editor.note_title": "Tittel",
        "offer.calculation.line_editor.note_title_placeholder": "Tittel på notatet (valgfritt)",
        "offer.calculation.line_editor.show_note_title": "Vis tittel",
        "offer.calculation.line_editor.note_use_template_title": "Bruk mal-tittel",
        "offer.calculation.line_editor.note_placeholder": "Skriv notat eller sett inn en mal…",
        "offer.calculation.line_editor.note_template_button": "Mal",
        "offer.calculation.line_editor.note_from_template": "Mal: {{title}}",
        "offer.calculation.line_editor.shown_in_offer": "Vises i tilbudet",
        "offer.calculation.line_editor.delete_row": "Slett linje",
        "offer.calculation.module.result_hint_server": "Serverberegnet total (etter lagring). Rediger canvas for lokal forhåndsvisning.",
        "offer.calculation.module.formula.assistant_subtitle_safe": "Velg en ferdig mal eller sett inn variabler. Trygg modus støtter + − × ÷, IF, MIN, MAX, ROUND, SUM og modulreferanser.",
        "offer.calculation.module.formula.error.empty": "{{title}}: Formelen er tom",
        "offer.calculation.module.formula.error.division_by_zero": "{{title}}: Kan ikke dele på null",
        "offer.calculation.module.formula.error.unknown_variable": "{{title}}: Ukjent variabel «{{name}}»",
        "offer.calculation.module.formula.error.invalid": "{{title}}: Formelen er ugyldig",
        "offer.calculation.module.formula.error.unsupported_chars": "{{title}}: Formelen inneholder tegn som ikke støttes",
        "offer.calculation.module.formula.error.unsupported_function": "{{title}}: Ukjent funksjon. Tillatt: IF, MIN, MAX, ROUND, SUM",
        "offer.calculation.module.formula.error.wrong_arity": "{{title}}: Funksjonen har feil antall argumenter",
        "offer.calculation.module.formula.error.circular": "Sirkulær referanse rundt {{title}}",
        "offer.calculation.module.evaluation_order": "Beregningsrekkefølge",
        "Processing": "Under behandling",
        "Closed": "Lukket",
        "case.view.new_case": "Ny sak",
        "case.view.close_case": "Lukk sak",
        "cases.access.forbidden_title": "Ingen tilgang",
        "cases.access.save_step": "Lagre sak",
        "cases.access.edit_forbidden": "Du har ikke tilgang til å redigere denne saken.",
        "cases.access.create_forbidden": "Du har ikke tilgang til å opprette saker.",
        "case.view.due": "Forfaller",
        "case.view.sent_email_to_employee": "sendte e-post til ansatt",
        "case.summary.title": "AI-sammendrag",
        "case.summary.updated": "Oppdatert {{time}}",
        "case.summary.empty":
          "Sammendraget lages automatisk så snart det er nok innhold i saken.",
        "case.summary.new_updates": "Nye oppdateringer",
        "case.summary.generating": "Oppdaterer …",
        "case.summary.error": "Kunne ikke laste sammendraget akkurat nå.",
        "case.summary.disabled": "AI-sammendrag er ikke aktivert",
        "case.summary.show_more": "Vis mer",
        "case.summary.show_less": "Vis mindre",
        "case.feed.activity._default": "oppdaterte saken",
        "case.feed.activity.ADDED._default": "la til en oppdatering",
        "case.feed.activity.ADDED.description": "la til en oppdatering",
        "case.feed.activity.ADDED.report": "la til en rapport i saken",
        "case.feed.activity.ADDED.service_agreement": "la til en serviceavtale",
        "case.feed.activity.ADDED.project": "la til et prosjekt",
        "case.feed.activity.ADDED.order": "la til en ordre",
        "case.feed.activity.ADDED.customer": "la til en kunde",
        "case.feed.activity.ADDED.contact": "la til en kontakt",
        "case.feed.activity.ADDED.note": "la til et notat",
        "case.feed.activity.ADDED.customer_communication": "la til en melding",
        "case.feed.activity.ADDED.phone": "la til en telefonsamtale",
        "case.feed.activity.ADDED.employee": "la til en ansatt",
        "case.feed.activity.ATTACHED._default": "la til et vedlegg",
        "case.feed.activity.LINKED._default": "lenket til saken",
        "case.feed.activity.LINKED.report": "lenket en rapport til saken",
        "case.feed.activity.CREATE._default": "opprettet saken",
        "case.feed.activity.CREATE.case": "opprettet saken",
        "case.feed.activity.CREATE.report": "opprettet en rapport",
        "case.feed.activity.CREATED._default": "opprettet saken",
        "case.feed.activity.CREATED.case": "opprettet saken",
        "case.feed.activity.UPDATE._default": "oppdaterte saken",
        "case.feed.activity.UPDATE.case": "oppdaterte denne saken",
        "case.feed.activity.UPDATED._default": "oppdaterte saken",
        "case.feed.activity.UPDATED.case": "oppdaterte denne saken",
        "case.feed.activity.CHANGED._default": "gjorde en endring",
        "case.feed.activity.STATUS_UPDATE._default": "oppdaterte status på saken",
        "case.feed.activity.DELETED._default": "slettet et element",
        "case.feed.activity.FINISHED._default": "ferdigstilte saken",
        "case.feed.activity.CLOSED._default": "lukket saken",
        "case.feed.activity.EMAIL_SENT_TO_EMPLOYEE._default": "sendte e-post til ansatt",
        "case.feed.activity.sent_sms_to_customer._default": "sendte SMS til kunde",
        "case.feed.activity.cancel_report_agreement._default": "kansellerte en avtale",
        "case.feed.activity.new_report_agreement._default": "opprettet en ny avtale",
        "case.feed.activity.case_guide_run.request_info": "besvarte etterspurt informasjon",
        "case.feed.activity.case_guide_run.completed": "fullførte en veiledning",
        "case.view.composer_placeholder": "Skriv en kommentar … bruk @ for å nevne noen",
        "case.view.composer_open": "Skriv en kommentar",
        "case.empty.updates": "Ingen oppdateringer ennå",
        "case.empty.hint": "Skriv en oppdatering nedenfor for å komme i gang",
        "case.load.error_title": "Kunne ikke laste saken",
        "case.load.error_hint": "Noe gikk galt under henting av saken. Sjekk tilkoblingen og prøv igjen.",
        "case.load.retry": "Prøv igjen",
        "case.feed.error_title": "Kunne ikke laste oppdateringer",
        "case.finish_after_prompt": "Ønsker du å ferdigstille saken etterpå?",
        "Felter": "Felter",
        "Dokumenter": "Dokumenter",
        "Internt notat": "Internt notat",
        "Slipp filer her for å laste opp": "Slipp filer her for å laste opp",
        "Attach file": "Legg ved fil",
        "Add image": "Legg til bilde",
        "Prioritering": "Prioritering",
        "Ctrl+Enter for å sende": "Ctrl+Enter for å sende",
        "Remove": "Fjern",
        "Dokument": "Dokument",
        "Handlinger": "Handlinger",
        "Lukk sak": "Lukk sak",
        "Saksbehandler": "Saksbehandler",
        "Forfallsdato": "Forfallsdato",
        "Kart": "Kart",
        "Åpne i Google Maps": "Åpne i Google Maps",
        "Åpne": "Åpne",
        "Vis mer": "Vis mer",
        "Vis mindre": "Vis mindre",
        "Select Priority": "Velg prioritet",
        "Phone Call": "Telefonsamtale",
        "duration": "Varighet",
        "Sak": "Sak",
        "Kunde": "Kunde",
        "Prosjekt": "Prosjekt",
        "Serviceavtale": "Serviceavtale",
        "Avtale": "Avtale",
        "Ordre": "Ordre",
        "Servicerapport": "Servicerapport",
        "Rapport": "Rapport",
        "Notat": "Notat",
        "Telefon": "Telefon",
        "SMS": "SMS",
        "E-post": "E-post",
        "Select status": "Velg status",
        "Moduler": "Moduler",
        "Kontakt": "Kontakt",
        "Ingen tilknyttede moduler": "Ingen tilknyttede moduler",
        "Legg til modul": "Legg til modul",
        "Service Report": "Servicerapport",
        "Service Agreement": "Serviceavtale",
        "Project": "Prosjekt",
        "Order": "Ordre",
        "Egendefinerte felter": "Egendefinerte felter",
        "Ingen felter ennå": "Ingen felter ennå",
        "Legg til felt": "Legg til felt",
        "Bilde": "Bilde",

        "Human resources": "Human resources",
        "Ledige stillinger": "Ledige stillinger",
        "Employees": "Ansatte",
        "Users": "Brukere",

        "hr.employees.page_title": "Ansatte",
        "hr.employees.hero.kicker": "Human resources",
        "hr.employees.hero.subtitle":
          "Viser kun brukere som er ansatt i firmaet (aktiv ansettelse).",
        "hr.employees.section.title": "Ansatte",
        "hr.employees.section.subtitle": "Filtrert til aktive ansettelser",
        "hr.employees.section.kicker": "Employees",

        "hr.common.loading": "Laster…",
        "hr.common.cancel": "Avbryt",
        "hr.common.create": "Opprett",
        "hr.common.save": "Lagre",
        "hr.common.edit": "Rediger",
        "hr.common.delete": "Slett",
        "hr.common.close": "Lukk",
        "hr.common.back": "Tilbake",
        "hr.common.open": "Åpne",
        "hr.common.yes": "Ja",
        "hr.common.no": "Nei",
        "hr.common.empty": "Ikke utfylt ennå",
        "hr.common.uploading": "Laster opp…",
        "hr.common.all": "Alle",
        "hr.common.all_statuses": "Alle statuser",

        "hr.job_openings.title": "Ledige stillinger",
        "hr.job_openings.subtitle": "Administrer utlysninger, public visning og kandidater",
        "hr.job_openings.new": "Ny stilling",
        "hr.job_openings.edit": "Rediger stilling",
        "hr.job_openings.status": "Status",
        "hr.job_openings.candidates": "Kandidater",
        "hr.job_openings.on_website": "På nettside",
        "hr.job_openings.search_placeholder": "Søk i stillinger…",
        "hr.job_openings.empty_title": "Ingen ledige stillinger ennå",
        "hr.job_openings.empty_body": "Opprett en stilling for å starte rekrutteringen.",
        "hr.job_openings.load_failed": "Kunne ikke laste stillinger",
        "hr.job_openings.create_failed": "Kunne ikke opprette stilling",
        "hr.job_openings.created": "Stilling opprettet",
        "hr.job_openings.updated": "Stilling oppdatert",
        "hr.job_openings.update_failed": "Kunne ikke oppdatere stilling",
        "hr.job_openings.deleted": "Stilling slettet",
        "hr.job_openings.delete_failed": "Kunne ikke slette stilling",
        "hr.job_openings.delete_confirm": "Er du sikker på at du vil arkivere denne stillingen?",
        "hr.job_openings.validation.title": "Tittel er påkrevd",
        "hr.job_openings.fields.title": "Tittel",
        "hr.job_openings.fields.short_description": "Kort beskrivelse",
        "hr.job_openings.fields.description": "Beskrivelse",
        "hr.job_openings.fields.responsibilities": "Arbeidsoppgaver",
        "hr.job_openings.fields.requirements": "Kvalifikasjoner",
        "hr.job_openings.fields.requirements_hint": "Sjekkliste som vises i søknadsskjemaet på nettsiden og når du legger til kandidat manuelt.",
        "hr.job_openings.fields.requirements_add": "Legg til kvalifikasjon",
        "hr.job_openings.fields.benefits": "Vi tilbyr",
        "hr.job_openings.fields.location": "Sted",
        "hr.job_openings.fields.employment_type": "Ansettelsesform",
        "hr.job_openings.fields.department": "Avdeling",
        "hr.job_openings.fields.salary_info": "Lønn",
        "hr.job_openings.fields.work_percentage": "Stillingsprosent",
        "hr.job_openings.fields.deadline": "Søknadsfrist",
        "hr.job_openings.fields.starts_on": "Oppstart",
        "hr.job_openings.fields.contact_name": "Kontaktperson",
        "hr.job_openings.fields.contact_email": "Kontakt-e-post",
        "hr.job_openings.fields.contact_phone": "Kontakttelefon",
        "hr.job_openings.fields.contact_user": "Ansvarlig kontakt",
        "hr.job_openings.fields.contact_user_hint": "Velg en ansatt. Navn, e-post og telefon hentes fra profilen og vises på stillingen. HR-ansvarlige vises som «Andre kontakter».",
        "hr.job_openings.fields.contact_user_empty": "Ingen ansvarlig kontakt er valgt.",
        "hr.job_openings.fields.contact_user_pick": "Velg ansatt",
        "hr.job_openings.fields.contact_user_change": "Bytt ansatt",
        "hr.job_openings.fields.contact_user_clear": "Fjern",
        "hr.job_openings.fields.show_on_website": "Vis på nettside",
        "hr.job_openings.hide_from_website": "Skjul fra nettside",
        "hr.job_openings.open_on_website": "Åpne på nettside",
        "hr.job_openings.website_shown": "Stillingen vises på nettsiden",
        "hr.job_openings.website_hidden": "Stillingen er skjult fra nettsiden",
        "hr.job_openings.employment_types.full_time": "Heltid",
        "hr.job_openings.employment_types.part_time": "Deltid",
        "hr.job_openings.employment_types.temporary": "Vikariat / midlertidig",
        "hr.job_openings.employment_types.internship": "Praktikant",
        "hr.job_openings.employment_types.freelance": "Freelance",
        "hr.job_openings.statuses.draft": "Utkast",
        "hr.job_openings.statuses.published": "Publisert",
        "hr.job_openings.statuses.closed": "Stengt",
        "hr.job_openings.statuses.archived": "Arkivert",
        "hr.job_openings.sections.overview": "Nøkkelinfo",
        "hr.job_openings.sections.description": "Om stillingen",
        "hr.job_openings.sections.responsibilities": "Arbeidsoppgaver",
        "hr.job_openings.sections.requirements": "Kvalifikasjoner",
        "hr.job_openings.sections.benefits": "Vi tilbyr",
        "hr.job_openings.sections.contact": "Kontakt",
        "hr.job_openings.sections.updates": "Oppdateringer",
        "hr.job_openings.sections.history": "Historikk / Oppdateringer",
        "hr.job_openings.sections.history_hint": "Egne notater på stillingen, pluss statusendringer på kandidater.",
        "hr.job_openings.json.open_dialog": "JSON / AI",
        "hr.job_openings.json.dialog_title": "Ledige stillinger — JSON og AI",
        "hr.job_openings.json.tab_json": "Lim inn JSON",
        "hr.job_openings.json.tab_ai_guide": "AI-instruksjoner",
        "hr.job_openings.json.hint":
          "Lim inn eller last opp JSON. Oppretter nye stillinger eller oppdaterer etter slug i firmaet. Eksisterende stillinger slettes ikke. Kvalifikasjoner: preferer requirement_items [{id,text}] (slug-id, ikke UUID). Kontakt velges som ansatt i Promang — ikke finn på navn, e-post eller telefon. Valgfrie kandidater kan ligge under applications med requirement_checks.",
        "hr.job_openings.json.existing_openings": "Eksisterende stillinger (ikke dupliser)",
        "hr.job_openings.json.loading": "laster…",
        "hr.job_openings.json.copy_json": "Kopier JSON",
        "hr.job_openings.json.copy_success": "JSON kopiert",
        "hr.job_openings.json.reload_blank": "Tøm mal",
        "hr.job_openings.json.reload_success": "Tom mal lastet",
        "hr.job_openings.json.insert_sample": "Sett inn eksempel",
        "hr.job_openings.json.upload": "Last opp JSON",
        "hr.job_openings.json.file_loaded": "JSON-fil lastet",
        "hr.job_openings.json.file_failed": "Kunne ikke lese filen",
        "hr.job_openings.json.preview": "Forhåndsvis import",
        "hr.job_openings.json.preview_title": "Forhåndsvisning: {{count}} stilling(er)",
        "hr.job_openings.json.preview_applications": "søker(e)",
        "hr.job_openings.json.preview_hint":
          "Ingenting er lagret ennå. Kontroller listen og bekreft for å importere til Promang.",
        "hr.job_openings.json.confirm_import": "Bekreft import ({{count}})",
        "hr.job_openings.json.importing": "Importerer…",
        "hr.job_openings.json.imported":
          "Importert: {{created}} ny(e), {{updated}} oppdatert, {{applications}} søker(e)",
        "hr.job_openings.json.import_failed": "Import feilet",
        "hr.job_openings.json.clipboard_failed": "Kunne ikke kopiere til utklippstavlen",
        "hr.job_openings.json.ai_guide_intro":
          "Kopier instruksjonene under til ChatGPT, Claude eller annen AI. Lim deretter JSON-svaret inn under fanen Lim inn JSON.",
        "hr.job_openings.json.copy_ai_guide": "Kopier AI-instruksjoner",
        "hr.job_openings.json.ai_guide_copied": "AI-instruksjoner kopiert",
        "hr.job_openings.json.generate_with_ai": "Generer med AI",
        "hr.job_openings.json.ai_parse_error": "Kunne ikke lese AI-svar som JSON",
        "hr.job_openings.json.ai_apply_success":
          "{{count}} stilling(er) lagt inn fra AI — kontroller og importer",
        "hr.job_openings.json.error_empty": "JSON er tom",
        "hr.job_openings.json.error_invalid_json": "Ugyldig JSON",
        "hr.job_openings.json.error_invalid_shape": "Ugyldig JSON-struktur",
        "hr.job_openings.json.error_no_valid_items": "Ingen gyldige stillinger i JSON",
        "hr.job_openings.json.error_too_many_openings": "For mange stillinger (maks 50)",
        "hr.job_openings.json.atomic": "Atomisk import (stopp/rull tilbake ved feil)",
        "hr.job_openings.json.dropped_rows":
          "{{count}} rad(er) hoppet over før import: {{detail}}",
        "hr.job_openings.json.result_title": "Importresultat",
        "hr.job_openings.json.result_hint": "Åpne stillingene under for å kontrollere tekst og pipeline.",
        "hr.job_openings.json.result_none": "Ingen stillinger ble opprettet eller oppdatert.",

        "hr.candidates.title": "Kandidater",
        "hr.candidates.add": "Legg til kandidat",
        "hr.candidates.empty": "Ingen kandidater er registrert på denne stillingen ennå.",
        "hr.candidates.pipeline": "Pipeline",
        "hr.candidates.total": "Totalt",
        "hr.candidates.documents": "Dokumentasjon",
        "hr.candidates.upload": "Last opp CV / fil",
        "hr.candidates.no_docs": "Ingen dokumenter lastet opp.",
        "hr.candidates.created": "Kandidat lagt til",
        "hr.candidates.create_failed": "Kunne ikke legge til kandidat",
        "hr.candidates.updated": "Kandidat oppdatert",
        "hr.candidates.update_failed": "Kunne ikke oppdatere kandidat",
        "hr.candidates.deleted": "Kandidat slettet",
        "hr.candidates.delete_failed": "Kunne ikke slette kandidat",
        "hr.candidates.delete_confirm": "Er du sikker på at du vil slette denne kandidaten?",
        "hr.candidates.docs_uploaded": "Dokument lastet opp",
        "hr.candidates.docs_upload_failed": "Kunne ikke laste opp dokument",
        "hr.candidates.validation.first_name": "Fornavn er påkrevd",
        "hr.candidates.validation.last_name": "Etternavn er påkrevd",
        "hr.candidates.validation.email": "Gyldig e-post er påkrevd",
        "hr.candidates.fields.first_name": "Fornavn",
        "hr.candidates.fields.last_name": "Etternavn",
        "hr.candidates.fields.email": "E-post",
        "hr.candidates.fields.phone": "Telefon",
        "hr.candidates.fields.city": "Sted",
        "hr.candidates.fields.linkedin": "LinkedIn",
        "hr.candidates.fields.cover_letter": "Søknadstekst",
        "hr.candidates.fields.requirements": "Kvalifikasjoner",
        "hr.candidates.fields.requirements_hint": "Kryss av det som gjelder.",
        "hr.candidates.fields.requirements_toggle_hint": "Kryss av det som gjelder. Teksten kan ikke endres her.",
        "hr.candidates.fields.requirements_readonly_hint": "Kandidaten har fylt ut dette selv. Listen er skrivebeskyttet.",
        "hr.candidates.fields.requirements_add": "Legg til kvalifikasjon",
        "hr.candidates.fields.notes": "Intern merknad",
        "hr.candidates.fields.legacy_note": "Intern merknad",
        "hr.candidates.fields.notes_hint": "Valgfritt. Videre oppfølging skjer under Oppdatering etter at kandidaten er opprettet.",
        "hr.candidates.sections.updates": "Oppdateringer",
        "hr.candidates.sections.history": "Historikk / Oppdateringer",
        "hr.candidates.sections.history_hint": "Statusendringer logges automatisk. Skriv videre oppfølging her.",
        "hr.candidates.sections.details": "Kontakt",
        "hr.candidates.not_found": "Fant ikke kandidaten på denne stillingen.",
        "hr.candidates.load_failed": "Kunne ikke laste kandidaten",
        "hr.candidates.fields.source": "Kilde",
        "hr.candidates.sources.manual": "Manuelt",
        "hr.candidates.sources.website": "Nettside",
        "hr.candidates.sources.email": "E-post",
        "hr.candidates.sources.other": "Annet",
        "hr.candidates.fields.status": "Status",
        "hr.candidates.fields.applied_at": "Søkt",
        "hr.candidates.statuses.new": "Ny",
        "hr.candidates.statuses.reviewing": "Under vurdering",
        "hr.candidates.statuses.interview": "Intervju",
        "hr.candidates.statuses.offer": "Tilbud",
        "hr.candidates.statuses.hired": "Ansatt",
        "hr.candidates.statuses.rejected": "Avslått",
        "hr.candidates.statuses.withdrawn": "Trukket",

        "hr.settings.title": "HR-innstillinger",
        "hr.settings.subtitle": "Ansvarlige, nettsideskjema og varsler",
        "hr.settings.load_failed": "Kunne ikke laste HR-innstillinger",
        "hr.settings.saved": "HR-innstillinger lagret",
        "hr.settings.save_failed": "Kunne ikke lagre HR-innstillinger",
        "hr.settings.form.title": "Søknadsskjema på nettside",
        "hr.settings.form.description": "Aktiver skjemaet som sendes inn via public API, for eksempel Airon-nettsiden.",
        "hr.settings.form.toggle": "Aktiver skjema for ekstern nettside",
        "hr.settings.form.toggle_hint": "Når dette er av, vises stillinger fortsatt, men søkere kan ikke sende skjema.",
        "hr.settings.responsibles.title": "HR-ansvarlige",
        "hr.settings.responsibles.description": "En eller flere personer får e-post ved ny søknad, og en daglig oppsummering av endringer på åpne stillinger. Navn, e-post og telefon vises også på den offentlige stillings- og søknadssiden.",
        "hr.settings.responsibles.empty": "Ingen HR-ansvarlige er lagt til ennå.",
        "hr.settings.responsibles.add": "Legg til ansvarlig",
        "hr.settings.responsibles.remove": "Fjern",
        "hr.settings.digest.title": "Daglig oppsummering",
        "hr.settings.digest.description": "Statusendringer og andre kandidatoppdateringer samles og sendes én gang per dag, kun for åpne stillinger. Nye søknader varsles med en gang.",
        "hr.settings.digest.hour": "Send oppsummering kl. (Europe/Oslo)",

        "hse.evaluation.title": "Evaluering",
        "hse.evaluation.subtitle": "KPI, internrevisjon, ledelsens gjennomgang og kundetilfredshet",
        "hse.evaluation.restricted": "Begrenset tilgang",
        "hse.evaluation.restricted_body": "Du har ikke tilgang til evalueringsoversikt. Kontakt ledelse for mer informasjon.",
        "hse.evaluation.back": "Tilbake",
        "hse.evaluation.recent": "Siste evalueringer",
        "hse.evaluation.nav.kpi": "KPI",
        "hse.evaluation.nav.kpi_hint": "Nøkkeltall og målinger",
        "hse.evaluation.nav.audit_hint": "Sjekk at rutinene faktisk følges",
        "hse.evaluation.nav.review_hint": "Ledelsen vurderer om systemet virker",
        "hse.evaluation.nav.feedback": "Kundetilfredshet",
        "hse.evaluation.nav.feedback_hint": "Tilbakemeldinger og tilfredshet",
        "hse.evaluation.types.management_review": "Ledelsens gjennomgang",
        "hse.evaluation.types.internal_audit": "Internrevisjon",
        "hse.evaluation.help.open": "Hva betyr {{term}}?",
        "hse.evaluation.help.management_review.title": "Ledelsens gjennomgang",
        "hse.evaluation.help.management_review.body": "Ledelsen går gjennom HMS/KS-systemet med jevne mellomrom: virker det, hva må endres, og hvilke tiltak skal følges opp? Dette er krav i ISO 9001 og internkontrollforskriften.",
        "hse.evaluation.help.internal_audit.title": "Internrevisjon",
        "hse.evaluation.help.internal_audit.body": "En planlagt sjekk av at firmaet følger egne rutiner og lover. Funn dokumenteres, og tiltak opprettes der noe må rettes.",
        "hse.evaluation.help.tiltak.title": "Tiltak",
        "hse.evaluation.help.tiltak.body": "En konkret oppgave som skal rette eller forebygge et funn. Har ansvarlig, frist og status.",
        "hse.evaluation.help.finding.title": "Funn",
        "hse.evaluation.help.finding.body": "Noe som ble avdekket i gjennomgangen eller revisjonen. Et funn kan knyttes til ett eller flere tiltak.",
        "hse.evaluation.list.title_reviews": "Ledelsens gjennomgang",
        "hse.evaluation.list.title_audits": "Internrevisjon",
        "hse.evaluation.list.subtitle_reviews": "Planlagte og gjennomførte ledelsesgjennomganger",
        "hse.evaluation.list.subtitle_audits": "Planlagte og gjennomførte internrevisjoner",
        "hse.evaluation.list.search": "Søk i tittel eller konklusjon…",
        "hse.evaluation.list.empty": "Ingen evalueringer ennå. Opprett den første.",
        "hse.evaluation.list.load_failed": "Kunne ikke laste evalueringer",
        "hse.evaluation.list.new_review": "Ny gjennomgang",
        "hse.evaluation.list.new_audit": "Ny revisjon",
        "hse.evaluation.list.findings_count": "{{count}} funn",
        "hse.evaluation.fields.title": "Tittel",
        "hse.evaluation.fields.description": "Beskrivelse",
        "hse.evaluation.fields.status": "Status",
        "hse.evaluation.fields.type": "Type",
        "hse.evaluation.fields.scheduled_on": "Planlagt",
        "hse.evaluation.fields.conducted_on": "Gjennomført",
        "hse.evaluation.fields.next_review_on": "Neste",
        "hse.evaluation.fields.scope": "Omfang",
        "hse.evaluation.fields.conclusion": "Konklusjon",
        "hse.evaluation.fields.notes": "Notater",
        "hse.evaluation.fields.lead": "Leder",
        "hse.evaluation.fields.participants": "Deltakere",
        "hse.evaluation.fields.responsible": "Ansvarlig",
        "hse.evaluation.fields.due_date": "Frist",
        "hse.evaluation.statuses.draft": "Utkast",
        "hse.evaluation.statuses.planned": "Planlagt",
        "hse.evaluation.statuses.in_progress": "Pågår",
        "hse.evaluation.statuses.completed": "Fullført",
        "hse.evaluation.statuses.cancelled": "Avbrutt",
        "hse.evaluation.severities.low": "Lav",
        "hse.evaluation.severities.medium": "Middels",
        "hse.evaluation.severities.high": "Høy",
        "hse.evaluation.severities.critical": "Kritisk",
        "hse.evaluation.form.new_review": "Ny gjennomgang",
        "hse.evaluation.form.edit_review": "Rediger gjennomgang",
        "hse.evaluation.form.new_audit": "Ny revisjon",
        "hse.evaluation.form.edit_audit": "Rediger revisjon",
        "hse.evaluation.form.save": "Lagre",
        "hse.evaluation.form.saving": "Lagrer…",
        "hse.evaluation.form.cancel": "Avbryt",
        "hse.evaluation.form.saved": "Evaluering lagret",
        "hse.evaluation.form.save_failed": "Kunne ikke lagre evalueringen",
        "hse.evaluation.form.title_required": "Tittel er påkrevd",
        "hse.evaluation.form.section.basics": "Grunnlag",
        "hse.evaluation.form.section.dates": "Datoer",
        "hse.evaluation.form.section.people": "Folk",
        "hse.evaluation.form.section.conclusion": "Konklusjon",
        "hse.evaluation.view.open": "Åpne",
        "hse.evaluation.view.edit": "Rediger",
        "hse.evaluation.view.findings": "Alle funn",
        "hse.evaluation.view.report": "Rapport",
        "hse.evaluation.view.not_found": "Fant ikke evalueringen",
        "hse.evaluation.view.no_conclusion": "Ingen konklusjon er skrevet ennå.",
        "hse.evaluation.findings.title": "Funn",
        "hse.evaluation.findings.empty": "Ingen funn registrert.",
        "hse.evaluation.findings.add": "Legg til",
        "hse.evaluation.findings.title_placeholder": "Kort funn",
        "hse.evaluation.findings.description_placeholder": "Hva ble observert?",
        "hse.evaluation.findings.title_required": "Funn trenger en tittel",
        "hse.evaluation.findings.saved": "Funn lagret",
        "hse.evaluation.findings.save_failed": "Kunne ikke lagre funn",
        "hse.evaluation.findings.create_tiltak": "Opprett tiltak",
        "hse.evaluation.participants.choose": "Velg deltakere",
        "hse.evaluation.participants.choose_one": "Velg person",
        "hse.evaluation.participants.chosen": "{{count}} valgt",
        "hse.evaluation.participants.empty": "Ingen deltakere registrert",
        "hse.evaluation.tiltak": "Tiltak",
        "hse.evaluation.tiltak.dialog_title": "Nytt tiltak",
        "hse.evaluation.tiltak.dialog_hint": "Opprett et tiltak fra dette funnet, eller åpne tiltakssiden.",
        "hse.evaluation.tiltak.create": "Opprett tiltak",
        "hse.evaluation.tiltak.created": "Tiltak opprettet",
        "hse.evaluation.tiltak.create_failed": "Kunne ikke opprette tiltak her. Åpne tiltakssiden i stedet.",
        "hse.evaluation.tiltak.title_required": "Tiltak trenger en tittel",
        "hse.evaluation.tiltak.open_page": "Åpne tiltakssiden",
        "hse.evaluation.tiltak.open_existing": "Vis tiltak",
        "hse.evaluation.statuses.closed": "Lukket",
        "hse.evaluation.fields.held_on": "Gjennomført",
        "hse.evaluation.fields.period_from": "Periode fra",
        "hse.evaluation.fields.period_to": "Periode til",
        "hse.evaluation.fields.result": "Resultat",
        "hse.evaluation.fields.summary": "Sammendrag",
        "hse.evaluation.fields.conclusions": "Konklusjon",
        "hse.evaluation.fields.action_type": "Type tiltak",
        "hse.evaluation.results.none": "Ikke satt",
        "hse.evaluation.results.passed": "Godkjent",
        "hse.evaluation.results.failed": "Ikke godkjent",
        "hse.evaluation.results.conditional": "Med vilkår",
        "hse.evaluation.export_pdf": "Last ned PDF",
        "hse.evaluation.exporting": "Laster PDF…",
        "hse.evaluation.export_failed": "Kunne ikke laste ned PDF",
        "hse.evaluation.tiltak.empty": "Ingen tiltak knyttet til denne evalueringen.",
        "hse.evaluation.tiltak.open_count": "{{count}} åpne tiltak",
        "hse.evaluation.tiltak.deadline_required": "Tiltak trenger en frist",
        "hse.evaluation.tiltak.responsible_required": "Tiltak trenger en ansvarlig",
        "hse.evaluation.tiltak.types.generic": "Oppfølging",
        "hse.evaluation.tiltak.types.new_routine": "Ny rutine",
        "hse.evaluation.tiltak.types.linked_document": "Dokumenttiltak",
        "common.error_state.not_found.title": "Siden ble ikke funnet",
        "common.error_state.not_found.description": "Vi fant ikke det du lette etter. Det kan være slettet, flyttet, eller adressen er feil.",
        "common.error_state.forbidden.title": "Ingen tilgang",
        "common.error_state.forbidden.description": "Du har ikke tilgang til denne siden eller ressursen.",
        "common.error_state.load_error.title": "Kunne ikke laste inn",
        "common.error_state.load_error.description": "Noe gikk galt da vi hentet data. Sjekk tilkoblingen og prøv igjen.",
        "common.unexpected_error": "Noe gikk galt. Prøv igjen.",
        "common.error_state.empty.title": "Ingen treff",
        "common.error_state.empty.description": "Det er ingen elementer å vise her ennå.",
        "common.error_state.action.back": "Tilbake",
        "common.error_state.action.dashboard": "Til dashboard",
        "common.error_state.action.retry": "Prøv igjen",
        "common.error_state.action.home": "Til forsiden",
        "common.error_state.details_heading": "Detaljer",
        "hse.events.title": "Hendelser",
        "hse.events.subtitle": "Avvik, nestenulykker, ulykker og observasjoner",
        "hse.events.search": "Søk i hendelser…",
        "hse.events.empty": "Ingen hendelser funnet",
        "hse.events.nav.aria": "Hendelsestyper",
        "hse.events.tab.all": "Alle",
        "hse.events.tab.deviations": "Avvik",
        "hse.events.tab.near_misses": "Nestenulykker",
        "hse.events.tab.accidents": "Ulykker",
        "hse.events.tab.complaints": "Reklamasjoner",
        "hse.events.tab.observations": "Observasjoner",
        "hse.competency.nav.aria": "Kompetanse-sider",
        "hse.competency.nav.my": "Min kompetanse",
        "hse.competency.nav.definitions": "Definisjoner",
        "hse.competency.nav.matrix": "Matrise",
        "hse.competency.nav.roles": "Roller",
        "hse.competency.nav.employees": "Ansatte",
        "hse.competency.nav.expiring": "Utløper",
        "hse.competency.nav.courses": "Kurs",
        "hse.competency.nav.training_plan": "Opplæringsplan",
        "hse.competency.nav.guide": "Guide",
        "hse.events.new": "Ny hendelse",
        "hse.events.type.injury": "Skade",
        "hse.events.type.near_miss": "Nærhendelse",
        "hse.events.type.property_damage": "Materiellskade",
        "hse.events.type.environmental": "Miljøhendelse",
        "hse.events.type.other": "Annet",
        "hse.documents.title": "Dokumenter",
        "hse.documents.subtitle": "Styrende dokumenter med versjonskontroll",
        "hse.documents.nav.aria": "Dokumenttyper",
        "hse.documents.tab.all": "Alle",
        "hse.documents.tab.policies": "Policyer",
        "hse.documents.tab.procedures": "Prosedyrer",
        "hse.documents.tab.instructions": "Instrukser",
        "hse.documents.tab.forms": "Skjemaer",
        "hse.documents.tab.guidance": "Veiledninger",
        "hse.documents.tab.record": "Registreringer",
        "hse.documents.tab.template": "Maler",
        "hse.documents.new": "Nytt dokument",
        "hse.actions.open": "Åpne",
        "hse.actions.edit": "Rediger",
        "hse.actions.export_pdf": "Eksporter PDF",
        "hse.actions.export_pdf_loading": "Eksporterer…",
        "hse.actions.export_pdf_success": "PDF lastet ned",
        "hse.actions.export_pdf_error": "Kunne ikke eksportere PDF",
        "hse.actions.approve": "Godkjenn",
        "hse.actions.revisions": "Revisjoner",
        "hse.actions.submit": "Send inn",
        "hse.actions.close_event": "Lukk hendelse",
        "hse.actions.delete": "Slett",
        "hse.events.delete_confirm": "Er du sikker på at du vil slette denne hendelsen?",
        "hse.events.deleted": "Hendelse ble slettet",
        "hse.events.delete_error": "Kunne ikke slette hendelse",
        "hse.events.submitted": "Hendelse ble innsendt",
        "hse.events.submit_error": "Kunne ikke sende hendelse",
        "hse.events.closed": "Hendelse ble lukket",
        "hse.events.close_error": "Kunne ikke lukke hendelse",
        "hse.protective.title": "Vernerunder",
        "hse.protective.subtitle": "Vernerunder og personlig verneutstyr",
        "hse.protective.new": "Ny vernerunde",
        "hse.protective.search": "Søk i vernerunder…",
        "hse.protective.empty": "Ingen vernerunder funnet",
        "hse.protective.equipment_title": "Personlig verneutstyr",
        "hse.protective.equipment_empty": "Ingen verneutstyr funnet",
        "hse.protective.status.draft": "Kladd",
        "hse.protective.status.in_progress": "Under gjennomføring",
        "hse.protective.status.completed": "Gjennomført",
        "hse.protective.status.closed": "Lukket",
        "hse.actions.menu": "Handlinger",
        "hse.protective.open": "Åpne",
        "hse.protective.edit": "Rediger",
        "hse.protective.actions": "Handlinger",
        "hse.protective.col_title": "Tittel",
        "hse.protective.col_date": "Dato",
        "hse.protective.col_location": "Lokasjon",
        "hse.protective.col_status": "Status",
        "hse.protective.field.description": "Beskrivelse",
        "hse.protective.field.registered_by": "Registrert av",
        "hse.protective.view_title": "Vernerunde",
        "hse.protective.view_subtitle": "Detaljer og resultater for vernerunden",
        "hse.protective.load_failed": "Kunne ikke laste vernerunden",
        "hse.protective.export_pdf": "Last ned PDF",
        "hse.protective.export_pdf_loading": "Laster ned PDF…",
        "hse.protective.export_pdf_success": "PDF lastet ned",
        "hse.protective.export_pdf_error": "Kunne ikke laste ned PDF",

        // i18n hotfix 2026-09-07 — filled missing dotted keys
        "absence.overview.export_hint": "Last ned fraværsoversikten som PDF.",
        "absence.overview.export_pdf": "Eksporter PDF",
        "absence.overview.exporting": "Eksporterer…",
        "absence.overview.pdf_export_failed": "Kunne ikke eksportere PDF",
        "absence.overview.pdf_exported": "PDF lastet ned",
        "absence.overview.pdf_too_small": "PDF-filen ble for liten. Prøv igjen.",
        "absence.overview.debug_export": "Eksporter avspassering-JSON",
        "absence.overview.debug_exporting": "Eksporterer…",
        "absence.overview.debug_export_hint": "Last ned beregningen for gjenstående avspassering (timer, formel og linjer).",
        "absence.overview.debug_exported": "Avspassering-JSON lastet ned",
        "absence.overview.debug_export_failed": "Kunne ikke eksportere avspassering-JSON",
        "absence.stats.avspassering.title": "Avspasering",
        "absence.stats.avspassering.earned_last_year": "Opptjent i fjor",
        "absence.stats.avspassering.used_last_year": "Brukt i fjor",
        "absence.stats.avspassering.earned_this_year": "Opptjent i perioden",
        "absence.stats.avspassering.used_this_year": "Brukt i perioden",
        "absence.stats.avspassering.remaining": "Gjenstående",
        "absence.stats.avspassering.guide_aria": "Slik beregnes avspassering",
        "absence.stats.avspassering.guide_title": "Slik beregnes avspassering",
        "absence.stats.avspassering.guide_body": "Gjenstående = (opptjent i fjor − brukt i fjor) + (opptjent i perioden − brukt i perioden).\n\nOpptjent er overtid per dag: registrerte timer minus forventet tid fra arbeidsplanen (skalert med stillingsprosent). Røde dager og dager uten planlagt tid har forventet 0.\n\nBrukt er arbeidstid på avspasseringsfravær som ikke er avslått, klippet til perioden.\n\nBare forrige kalenderår overføres. Last ned JSON fra oversikten for å se alle linjer.",
        "cases.create.user_assigned": "Sak opprettet og tildelt",
        "cases.settings.notify.description": "Send e-post når en ny sak kommer inn automatisk.",
        "cases.settings.notify.load_failed": "Kunne ikke laste varslingsinnstillinger",
        "cases.settings.notify.loading": "Laster innstillinger…",
        "cases.settings.notify.missing_email": "Oppgi en e-postadresse for varsling.",
        "cases.settings.notify.no_company_email": "ingen firmadresse",
        "cases.settings.notify.override_hint": "La stå tom for å bruke {{email}}.",
        "cases.settings.notify.override_label": "Annen varslingsadresse",
        "cases.settings.notify.save": "Lagre",
        "cases.settings.notify.save_failed": "Kunne ikke lagre varslingsinnstillinger",
        "cases.settings.notify.saved": "Varslingsinnstillinger lagret",
        "cases.settings.notify.saving": "Lagrer…",
        "cases.settings.notify.title": "Automatisk sakvarsling",
        "cases.settings.notify.toggle": "Varsle ved nye saker",
        "cases.settings.notify.toggle_hint": "Sender e-post når en sak opprettes automatisk.",
        "common.cancel": "Avbryt",
        "common.active": "Aktiv",
        "common.description": "Beskrivelse",
        "common.no": "Nei",
        "common.yes": "Ja",
        "common.back": "Tilbake",
        "common.close": "Lukk",
        "common.new": "Ny",
        "common.menu": "Meny",
        "common.edit": "Rediger",
        "common.delete": "Slett",
        "common.open": "Åpne",
        "common.details": "Detaljer",
        "common.none": "Ingen",
        "common.create": "Opprett",
        "common.creating": "Oppretter…",
        "common.saving": "Lagrer…",
        "common.update": "Oppdater",
        "confirmation.sure": "Er du sikker på at du vil",
        "connected.to.phonero.but.presence.not.available": "Tilkoblet Phonero, men tilstedeværelse er ikke tilgjengelig.",
        "contact.customer.explanation": "Kontaktpersonen knyttes til kunden.",
        "contact.email": "E-post",
        "contact.mobile": "Mobil",
        "contact.name": "Navn",
        "contacts.create": "Ny kontakt",
        "crew.shift.week_of": "Uke fra",
        "customer.required": "Kunde er påkrevd",
        "customers.create": "Ny kunde",
        "deviation.notification.failed_at": "Feilet",
        "deviation.notification.mode.digest": "Samledigest",
        "deviation.notification.mode.immediate": "Umiddelbart",
        "deviation.notification.scheduled_at": "Planlagt",
        "deviation.notification.send_log_empty": "Ingen sendinger ennå.",
        "deviation.notification.send_log_title": "Sendelogg",
        "deviation.notification.sent_at": "Sendt",
        "deviation.notification.status.failed": "Feilet",
        "deviation.notification.status.cancelled": "Kansellert",
        "deviation.notification.status.scheduled": "Planlagt",
        "deviation.email_failed.banner": "Sending på e-post feilet. Se avviket og send på nytt.",
        "deviation.email_failed.row": "E-post feilet",
        "deviation.description.title": "Beskrivelse",
        "deviation.description.help": "Beskrivelsen lagres på avviket. Bilder og dokumentasjon ligger samlet under.",
        "deviation.description.placeholder": "Skriv hva som har skjedd",
        "deviation.description.save": "Lagre beskrivelse",
        "deviation.description.saved": "Beskrivelsen er lagret",
        "deviation.description.empty": "Ingen beskrivelse er skrevet ennå.",
        "deviation.description.legacy_title": "Tidligere forklaring",
        "deviation.description.legacy_help": "Dette er tekst fra eldre avvikspunkter. Den blir stående og blir ikke flyttet eller slettet.",
        "deviation.documents.help": "Last opp bilder og dokumentasjon. Fra tegning lagres både utsnitt og bilde på avviket.",
        "deviation.priority": "Prioritet",
        "deviation.item.consequence": "Konsekvens",
        "common.title": "Tittel",
        "deviation.form.choose_who_should_own_this_deviation": "Velg hvem som skal eie dette avviket",
        "deviation.form.create": "Opprett",
        "deviation.form.create_deviation": "Opprett avvik",
        "deviation.form.deviation_type": "Avvikstype",
        "deviation.form.edit_deviation": "Rediger avvik",
        "deviation.form.no_email": "Ingen e-post",
        "deviation.form.no_employees_found": "Ingen ansatte funnet",
        "deviation.form.responsible_for_follow_up": "Ansvarlig for oppfølging",
        "deviation.form.responsible_user": "Ansvarlig bruker",
        "deviation.form.search_employees": "Søk ansatte",
        "deviation.form.select_deviation_type": "Velg avvikstype",
        "deviation.form.select_priority": "Velg prioritet",
        "deviation.form.select_responsible_user": "Velg ansvarlig bruker",
        "deviation.form.select_severity": "Velg alvorlighetsgrad",
        "deviation.form.selected": "Valgt",
        "deviation.form.update": "Oppdater",

        "vehicle.body_style": "Karosseri",
        "vehicle.current_odometer_km": "Nåværende kilometerstand (km)",
        "vehicle.edit_vehicle": "Rediger kjøretøy",
        "vehicle.engine_size_cc": "Slagvolum (cc)",
        "vehicle.first_registration": "Første gangs registrering",
        "vehicle.fuel_type": "Drivstofftype",
        "vehicle.inspection_information": "Kontrollinformasjon",
        "vehicle.inspection_result": "Kontrollresultat",
        "vehicle.inspection_station": "Kontrollstasjon",
        "vehicle.last_inspection_date": "Siste kontrolldato",
        "vehicle.last_ride": "Siste tur",
        "vehicle.last_service_date": "Siste servicedato",
        "vehicle.make": "Merke",
        "vehicle.model": "Modell",
        "vehicle.model_year": "Årsmodell",
        "vehicle.next_inspection_date": "Neste kontrolldato",
        "vehicle.next_service_date": "Neste servicedato",
        "vehicle.nickname": "Kallenavn",
        "vehicle.norwegian": "Norsk",
        "vehicle.number_plate": "Registreringsnummer",
        "vehicle.power_kw": "Effekt (kW)",
        "vehicle.registration_date": "Registreringsdato",
        "vehicle.service_information": "Serviceinformasjon",
        "vehicle.service_interval_km": "Serviceintervall (km)",
        "vehicle.service_provider": "Serviceleverandør",
        "vehicle.statens_vegvesen_information": "Informasjon fra Statens vegvesen",
        "vehicle.vehicle_handbook": "Kjøretøyhåndbok",
        "vehicle.vehicle_information": "Kjøretøyinformasjon",
        "vehicle.vehicle_type": "Kjøretøytype",
        "vehicle.vin_chassis_number": "VIN (understellsnummer)",
        "vehicle.warranty_end_date": "Garanti utløper",
        "vehicle.warranty_type": "Garantitype",

        "deviation.list.title": "Avvik",
        "deviation.list.statuses": "Statuser",
        "deviation.list.types": "Avvikstyper",
        "deviation.list.priorities": "Prioriteringer",
        "deviation.list.type": "Type",
        "deviation.table.number": "Nummer",
        "deviation.table.deviation": "Avvik",
        "deviation.table.untitled": "Uten tittel",
        "deviation.table.type_missing": "Type mangler",
        "deviation.table.unlinked": "Ikke knyttet",
        "deviation.table.status": "Status",
        "deviation.table.responsible": "Ansvarlig",
        "deviation.table.unassigned": "Ikke tildelt",
        "deviation.table.created": "Opprettet",
        "deviation.consequence.pick": "Velg type konsekvens",
        "deviation.consequence.dialog_title": "Konsekvens: {{type}}",
        "deviation.consequence.save": "Lagre konsekvens",
        "deviation.consequence.type.1": "Økonomisk",
        "deviation.consequence.type.2": "Fremdrift",
        "deviation.consequence.type.3": "Sikkerhet",
        "deviation.consequence.type.4": "Miljø",
        "deviation.consequence.type.5": "Kvalitet",
        "deviation.consequence.type.6": "Myndighet",
        "deviation.consequence.type.7": "Annet",
        "deviation.delete.action": "Slett",
        "deviation.delete.forbidden": "Du har ikke tilgang til å slette eller avslutte avviket.",
        "deviation.delete.can_delete_title": "Avviket kan slettes",
        "deviation.delete.can_delete_body": "Viktige koblinger er fjernet eller avsluttet. Avviket slettes.",
        "deviation.delete.close_title": "Avviket kan ikke slettes",
        "deviation.delete.close_body": "Du kan avslutte uten ferdigstillelse. Avviket lukkes, men merkes ikke som ferdigstilt.",
        "deviation.delete.confirm_delete": "Slett avviket",
        "deviation.delete.confirm_close": "Avslutt uten ferdigstillelse",
        "deviation.delete.reasons": "Derfor kan det ikke slettes",
        "deviation.delete.closed": "Avviket er avsluttet uten ferdigstillelse",
        "deviation.delete.deleted": "Avviket er slettet",
        "deviation.history.caption": "Her ser du hva som er gjort med avviket, blant annet arbeidsordre og sending.",
        "deviation.work_order.linked_banner": "Dette avviket er knyttet til arbeidsordre {{title}}.",
        "deviation.send.copy_always": "Alltid kopi",
        "deviation.send.copy_off": "Ingen kopi",
        "deviation.send.digest_hint": "Samles og sendes i neste digest.",
        "deviation.send.immediate_hint": "Sendes med en gang.",
        "deviation.send.failed": "Kunne ikke sende avviket",
        "deviation.send.success_partial": "Noen mottakere fikk avviket. Se sendeloggen.",
        "deviation.send.success_scheduled": "Avviket er lagt i kø for sending.",
        "deviation.send.success_sent": "Avviket er sendt.",
        "deviation.settings.subtitle": "Varsling og sending av avvik",
        "employee.contact.information": "Kontaktinformasjon",
        "employee.view.profile": "Vis profil",
        "employee.work.mobile": "Jobbmobil",
        "employee_selector.clear_all": "Fjern alle",
        "employee_selector.confirm": "Velg",
        "employee_selector.empty_hint": "Søk etter navn eller e-post.",
        "employee_selector.load_error": "Kunne ikke laste ansatte",
        "employee_selector.load_more": "Last flere",
        "employee_selector.loading": "Laster…",
        "employee_selector.no_results": "Ingen treff",
        "employee_selector.search_placeholder": "Søk ansatte…",
        "employee_selector.selected_count": "{{count}} valgt",
        "employee_selector.title_multiple": "Velg ansatte",
        "employee_selector.title_single": "Velg ansatt",
        "error.fetching_communcations": "Kunne ikke hente kommunikasjon",
        "failed.to.create.communication": "Kunne ikke opprette kommunikasjon",
        "failed.to.load.report": "Kunne ikke laste rapporten",
        "folder_selector.clear": "Fjern valg",
        "folder_selector.collapse": "Skjul",
        "folder_selector.create_failed": "Kunne ikke opprette mappe",
        "folder_selector.deselect": "Fjern merking",
        "folder_selector.empty": "Ingen mapper ennå.",
        "folder_selector.expand": "Vis",
        "folder_selector.move_failed": "Kunne ikke flytte mappen",
        "folder_selector.new_folder": "Ny mappe",
        "folder_selector.new_folder_default": "Ny mappe",
        "folder_selector.new_subfolder": "Ny undermappe",
        "folder_selector.no_match": "Ingen mapper matcher «{{query}}»",
        "folder_selector.none": "Ingen mappe",
        "folder_selector.project_required": "Velg et prosjekt først",
        "folder_selector.rename": "Gi nytt navn",
        "folder_selector.rename_failed": "Kunne ikke endre navn",
        "folder_selector.scope_kind": "Prosjekt",
        "folder_selector.search_placeholder": "Søk mapper…",
        "folder_selector.select": "Velg",
        "folder_selector.select_hint": "Velg en eller flere mapper.",
        "folder_selector.selected_count": "{{count}} valgt",
        "hours.resource_plan.planned_tasks": "Planlagte oppgaver",
        "hours.resource_plan.table.planned": "Planlagt",
        "hse_document_selector.all_documents": "Alle dokumenter",
        "hse_document_selector.no_documents": "Ingen dokumenter",
        "hse_document_selector.recent": "Nylige",
        "hse_document_selector.search_placeholder": "Søk dokumenter…",
        "hse_document_selector.search_results": "Søkeresultater",
        "image.change": "Bytt bilde",
        "image.select": "Velg bilde",
        "inventory.count.add_items": "Legg til varer",
        "inventory.count.add_items_bulk": "Legg til flere varer",
        "inventory.count.add_products_bulk": "Legg til flere produkter",
        "inventory.count.adding_products": "Legger til produkter…",
        "inventory.count.bulk.no_valid_items": "Ingen gyldige linjer å legge til.",
        "inventory.count.copy_all_products_from_storage": "Kopier alle produkter fra lager",
        "inventory.count.copy_all_products_info": "Kopierer alle produkter som ligger på lageret inn i tellingen.",
        "inventory.count.copy_from_count": "Kopier fra telling",
        "inventory.count.copy_from_existing": "Kopier fra eksisterende",
        "inventory.count.copy_options": "Kopieringsvalg",
        "inventory.count.create_and_copy": "Opprett og kopier",
        "inventory.count.create_description": "Opprett en ny varetelling.",
        "inventory.count.created": "Telling opprettet",
        "inventory.count.description": "Beskrivelse",
        "inventory.count.item.approve_error": "Kunne ikke godkjenne linjen",
        "inventory.count.item.approved": "Godkjent",
        "inventory.count.item.unapproved": "Ikke godkjent",
        "inventory.count.item_number_placeholder": "Varenummer",
        "inventory.count.items_add_error": "Kunne ikke legge til varer",
        "inventory.count.items_added": "Varer lagt til",
        "inventory.count.none": "Ingen tellinger",
        "inventory.count.product.add_error": "Kunne ikke legge til produktet",
        "inventory.count.product.found": "Produkt funnet",
        "inventory.count.product.no_exact_match": "Ingen eksakt treff",
        "inventory.count.products_added": "Produkter lagt til",
        "inventory.count.unapproved": "Ikke godkjent",
        "meeting_minutes.entry.deleted": "Oppføring slettet",
        "microsoft.ai_mailboxes.ai_routing.create_case_and_reply_hint": "Oppretter sak og foreslår svar.",
        "microsoft.ai_mailboxes.settings.case_filters_replaced_body": "De gamle saksfiltrene er erstattet av nye regler.",
        "microsoft.ai_mailboxes.settings.case_filters_replaced_title": "Saksfiltre erstattet",
        "no.communications.found": "Ingen kommunikasjon funnet",
        "no.number": "Ingen",
        "offer.calculation.load_error": "Kunne ikke laste kalkylen",
        "order.date": "Ordredato",
        "order.info": "Ordreinformasjon",
        "order.number": "Ordrenummer",
        "order.total": "Totalsum",
        "order.save.success": "Ordren er lagret",
        "order.items.storage.automatic": "Automatisk lager (størst saldo)",
        "order.items.storage.automatic_help": "Tomt lager velges automatisk ved leveringsdato eller faktura — lager med størst saldo for produktet.",
        "order.items.storage.active": "Aktivt lager: {{name}}",
        "order.items.pick_status.picked_delivered": "Plukket/levert {{qty}}",
        "order.items.pick_status.not_picked": "Ikke plukket",
        "order.items.pick_status.line_label": "Linjestatus",
        "order.items.qty.ordered": "Bestilt: {{qty}}",
        "order.items.qty.ordered_label": "Bestilt",
        "order.items.qty.picked_delivered": "Plukket/levert: {{qty}}",
        "order.items.qty.available": "Tilgjengelig: {{qty}}",
        "order.items.qty.tracked": "Lagerfort: {{qty}}",
        "order.items.warehouse_pick.open": "Lager og plukk",
        "product.brands.create": "Nytt merke",
        "product.brands.edit": "Rediger merke",
        "product.edit": "Rediger produkt",
        "project.activities.duplicate": "Dupliser",
        "project.activities.duplicate_error": "Kunne ikke duplisere aktiviteten",
        "project.activities.duplicated": "Aktivitet duplisert",
        "project.activities.duplicating": "Dupliserer…",
        "project.activities.export_pdf": "Eksporter PDF",
        "project.activities.export_pdf_error": "Kunne ikke eksportere PDF",
        "project.activities.export_pdf_loading": "Lager PDF…",
        "project.activities.export_pdf_success": "PDF lastet ned",
        "project.activities.group_add_activity": "Legg til aktivitet i gruppen",
        "project.activities.group_created": "Gruppe opprettet",
        "project.activities.group_delete": "Slett gruppe",
        "project.activities.group_delete_confirm": "Slette denne gruppen? Aktivitetene blir uten gruppe.",
        "project.activities.group_delete_error": "Kunne ikke slette gruppen",
        "project.activities.group_deleted": "Gruppe slettet",
        "project.activities.group_drag": "Dra for å flytte",
        "project.activities.group_duplicate": "Dupliser gruppe",
        "project.activities.group_duplicate_confirm": "Dupliser",
        "project.activities.group_duplicate_error": "Kunne ikke duplisere gruppen",
        "project.activities.group_duplicate_hint": "Opprett en kopi av gruppen og aktivitetene.",
        "project.activities.group_duplicate_name_suggestion": "{{name}} (kopi)",
        "project.activities.group_duplicated": "Gruppe duplisert",
        "project.activities.group_edit": "Rediger gruppe",
        "project.activities.group_empty": "Ingen aktiviteter i gruppen",
        "project.activities.group_load_error": "Kunne ikke laste grupper",
        "project.activities.group_new": "Ny gruppe",
        "project.activities.group_reorder_error": "Kunne ikke endre rekkefølge",
        "project.activities.group_save_error": "Kunne ikke lagre gruppen",
        "project.activities.group_title": "Gruppetittel",
        "project.activities.group_title_placeholder": "Navn på gruppen",
        "project.activities.group_title_required": "Gruppetittel er påkrevd",
        "project.activities.group_updated": "Gruppe oppdatert",
        "project.billing_plan.invoice": "Faktura",
        "project.description": "Beskrivelse",
        "project.end_date": "Sluttdato",
        "project.item_list.purchase_price": "Innkjøpspris",
        "project.item_list.sales_price": "Salgspris",
        "project.item_list.select_warehouse_description": "Velg lageret varene skal tas fra.",
        "project.manager.required": "Prosjektleder er påkrevd",
        "project.name": "Prosjektnavn",
        "project.name.required": "Prosjektnavn er påkrevd",
        "project.number": "Prosjektnummer",
        "project.required": "Prosjekt er påkrevd",
        "project.start_date": "Startdato",
        "project.supplier_invoices.error.title": "Feil ved leverandørfaktura",
        "project.supplier_invoices.status.approved": "Godkjent",
        "project.supplier_invoices.status.not_approved": "Ikke godkjent",
        "project.supplier_invoices.status.overdue": "Forfalt",
        "project.supplier_invoices.status.paid": "Betalt",
        "project.supplier_invoices.status.pending": "Avventer",
        "project_activity.ungrouped": "Ugruppert",
        "projects.create": "Nytt prosjekt",
        "projects.edit": "Rediger prosjekt",
        "quality.checklist.item.uploadImageDestination": "Sjekklistepunkt: {{title}}",
        "quality.checklist.page.missingTitle": "Sjekkliste uten tittel",
        "quality.checklist.page.qualitySubtitle": "Kvalitetssjekkliste",
        "quality.checklist.page.reportSubtitle": "Rapportsjekkliste",
        "report.agreement.redesign.day_help": "Velg hvilken dag avtalen gjelder.",
        "report.agreement.redesign.next_day_time": "Neste dag og tid",
        "report.agreement.redesign.next_settings": "Neste innstillinger",
        "report.agreement.redesign.step_day": "Dag",
        "report.finish.description": "Fullfør og lukk rapporten.",
        "report.hours.description": "Timer ført på rapporten.",
        "report.list.agreed_date": "Avtalt dato",
        "report.price_lines.confirm_delete": "Slette denne prislinsen?",
        "report.variables.description": "Variabler på rapporten.",
        "report.write.description": "Skriv og fyll ut rapporten.",
        "service.agreement_types": "Avtaletyper",
        "service.agreement_types.create": "Ny avtaletype",
        "service.agreement_types.edit": "Rediger avtaletype",
        "service.agreements.info.vat_excluded": "Priser er uten MVA",
        "service.checklist_types.create": "Ny sjekklistetype",
        "service.checklist_types.edit": "Rediger sjekklistetype",
        "service.report_types": "Rapporttyper",
        "service.report_types.create": "Ny rapporttype",
        "service.report_types.edit": "Rediger rapporttype",
        "service.variable_types": "Variabeltyper",
        "service.variable_types.create": "Ny variabeltype",
        "service.variable_types.edit": "Rediger variabeltype",
        "storage.add": "Legg til lager",
        "storage.create": "Nytt lager",
        "storage.edit": "Rediger lager",
        "title.required": "Tittel er påkrevd",
        "work_order.plan_modal.add_plan": "Legg til plan",
        "work_order.plan_modal.empty_multi": "Ingen planer ennå.",
        "work_order.plan_modal.plan_description": "Planbeskrivelse",
        "work_order.plan_modal.plan_description_placeholder": "Hva skal gjøres?",
        "work_order.plan_modal.plan_index": "Plan {{number}}",
        "work_order.plan_modal.plan_title_help": "Kort tittel som vises i planen.",
        "work_order.plan_modal.plans_count": "{{count}} planer",
        "work_order.plan_modal.plans_section_subtitle": "Planlegg arbeidet",
        "work_order.redesign.all_met": "Alle krav er oppfylt",
        "work_order.redesign.assigned_count": "{{count}} tildelt",
        "work_order.redesign.budget_hours_unit": "t",
        "work_order.redesign.completed": "Fullført",
        "work_order.redesign.crew": "Mannskap",
        "work_order.redesign.detail_customer": "Kunde",
        "work_order.redesign.detail_project": "Prosjekt",
        "work_order.redesign.details": "Detaljer",
        "work_order.redesign.due": "Frist",
        "work_order.redesign.field_log": "Feltlogg",
        "work_order.redesign.field_log_sub": "Notater fra felt",
        "work_order.redesign.finish": "Fullfør",
        "work_order.redesign.hours": "Timer",
        "work_order.redesign.items_left": "{{count}} gjenstår",
        "work_order.redesign.mark_complete": "Merk som fullført",
        "work_order.redesign.material_lines": "Materiallinjer",
        "work_order.redesign.materials": "Materialer",
        "work_order.redesign.no_crew": "Ingen tildelt",
        "work_order.redesign.no_description": "Ingen beskrivelse",
        "work_order.redesign.open": "Åpen",
        "work_order.redesign.print": "Skriv ut",
        "work_order.redesign.ready_title": "Klar til å fullføre?",
        "work_order.redesign.req_crew": "Mannskap tildelt",
        "work_order.redesign.req_desc": "Beskrivelse fylt ut",
        "work_order.redesign.req_hours": "Timer ført",
        "work_order.redesign.req_items": "Materialer registrert",
        "work_order.redesign.urgent": "Haster",
        "work_order.redesign.what_to_do": "Hva skal gjøres",
        "work_orders.details_section_title": "Detaljer",
        "work_orders.edit_details": "Rediger detaljer",
        "operation_feedback.processing": "Behandlingen pågår.",
        "operation_feedback.hide": "Skjul fremdrift",
        "operation_feedback.close": "Lukk",
        "operation_feedback.step.pending": "Venter",
        "operation_feedback.step.running": "Pågår",
        "operation_feedback.step.completed": "Fullført",
        "operation_feedback.step.already_applied": "Allerede utført",
        "operation_feedback.step.not_relevant": "Ikke relevant",
        "operation_feedback.step.needs_fix": "Må rettes",
        "operation_feedback.step.not_done": "Ikke utført",
        "operation_feedback.step.failed": "Feilet",
        "operation_feedback.step.rolled_back": "Tilbakerullet",
        "operation_feedback.step.unconfirmed": "Ikke bekreftet",
        "operation_feedback.step.cancelled": "Avbrutt",
        "operation_feedback.saved_list_refresh_failed": "Lagret. Listen kunne ikke oppdateres.",
        "operation_feedback.taking_longer": "Behandlingen tar lengre tid. Vi avklarer status.",
        "operation_feedback.finish_report.title": "Ferdigstiller serviceoppdrag {{number}}",
        "operation_feedback.finish_report.step.preflight": "Kontrollert påkrevde opplysninger",
        "operation_feedback.finish_report.step.save": "Rapporten lagres",
        "operation_feedback.finish_report.step.finish_checklist": "Sjekkliste oppdateres",
        "operation_feedback.finish_report.step.update_agreement": "Serviceavtale oppdateres",
        "operation_feedback.finish_report.step.refresh": "Oppdaterer visning",
        "operation_feedback.finish_report.preflight_ok": "Forutsetninger er oppfylt.",
        "operation_feedback.finish_report.preflight_skipped": "Ingen forhåndskontroll lastet.",
        "operation_feedback.finish_report.preflight_blocked": "Rapporten kan ikke ferdigstilles. Rett sjekkpunktene først.",
        "operation_feedback.finish_report.save_ok": "Rapporten er lagret som ferdigstilt.",
        "operation_feedback.finish_report.success": "Serviceoppdraget er ferdigstilt.",
        "operation_feedback.finish_report.open_report": "Åpne rapport",
        "operation_feedback.create_reports.title": "Oppretter serviceoppdrag for {{count}} underavtaler",
        "operation_feedback.create_reports.step.preflight": "Kontrollerer valg og leveringsadresse",
        "operation_feedback.create_reports.step.create": "Oppretter serviceoppdrag",
        "operation_feedback.create_reports.step.refresh": "Oppdaterer visning",
        "operation_feedback.create_reports.preflight_ok": "Valg og adresser er i orden.",
        "operation_feedback.create_reports.preflight_no_selection": "Ingen underavtaler er valgt.",
        "operation_feedback.create_reports.create_ok": "Opprettet {{count}} serviceoppdrag.",
        "operation_feedback.create_reports.success": "{{count}} serviceoppdrag er opprettet.",
        "operation_feedback.create_reports.atomic_failed": "Ingen serviceoppdrag ble opprettet.",
        "operation_feedback.create_reports.open_report": "Åpne rapport {{id}}",
        "operation_feedback.send_report.title": "Sender serviceoppdrag {{number}}",
        "operation_feedback.send_report.step.preflight": "Kontrollerer mottaker og rapporttype",
        "operation_feedback.send_report.step.queue": "Setter sending i kø",
        "operation_feedback.send_report.step.deliver": "Genererer PDF og sender",
        "operation_feedback.send_report.step.refresh": "Oppdaterer visning",
        "operation_feedback.send_report.preflight_ok": "Mottaker og rapporttype er i orden.",
        "operation_feedback.send_report.preflight_missing_email": "E-postadresse mangler.",
        "operation_feedback.send_report.preflight_missing_type": "Rapporttype mangler.",
        "operation_feedback.send_report.preflight_missing_id": "Rapport-ID mangler.",
        "operation_feedback.send_report.queue_ok": "Sending er satt i kø.",
        "operation_feedback.send_report.deliver_sync": "Sending fullført uten bakgrunnsjobb.",
        "operation_feedback.send_report.deliver_queued": "Venter i kø…",
        "operation_feedback.send_report.deliver_processing": "Genererer PDF og sender…",
        "operation_feedback.send_report.deliver_ok": "Rapporten er sendt.",
        "operation_feedback.send_report.deliver_failed": "Sending feilet.",
        "operation_feedback.send_report.deliver_poll_retry": "Statussjekk feilet (prøver igjen): {{message}}",
        "operation_feedback.send_report.deliver_timeout": "Sending tok for lang tid. Sjekk status manuelt.",
        "operation_feedback.send_report.success": "Serviceoppdraget er sendt.",
        "operation_feedback.send_report.open_report": "Åpne rapport",
        "operation_feedback.list_update_agreements.title": "Oppdaterer {{count}} serviceavtaler",
        "operation_feedback.list_update_agreements.dialog_title": "Redigerer {{count}} avtaler",
        "operation_feedback.list_update_agreements.step.preflight": "Kontrollerer utvalg",
        "operation_feedback.list_update_agreements.step.update": "Oppdaterer avtaler",
        "operation_feedback.list_update_agreements.step.refresh": "Oppdaterer listen",
        "operation_feedback.list_update_agreements.preflight_ok": "{{count}} avtaler er valgt.",
        "operation_feedback.list_update_agreements.preflight_no_selection": "Ingen avtaler er valgt.",
        "operation_feedback.list_update_agreements.update_ok": "{{count}} avtaler er oppdatert.",
        "operation_feedback.list_update_agreements.success": "{{count}} serviceavtaler er oppdatert.",
        "operation_feedback.list_update_agreements.confirm_title": "Er du sikker?",
        "operation_feedback.list_update_agreements.confirm_body": "Du redigerer nå {{count}} avtale(r). Dette kan ikke reverseres.",
        "operation_feedback.list_update_reports.title": "Oppdaterer {{count}} serviceoppdrag",
        "operation_feedback.list_update_reports.dialog_title": "Redigerer {{count}} oppdrag",
        "operation_feedback.list_update_reports.step.preflight": "Kontrollerer utvalg",
        "operation_feedback.list_update_reports.step.update": "Oppdaterer oppdrag",
        "operation_feedback.list_update_reports.step.refresh": "Oppdaterer listen",
        "operation_feedback.list_update_reports.preflight_ok": "{{count}} oppdrag er valgt.",
        "operation_feedback.list_update_reports.preflight_no_selection": "Ingen oppdrag er valgt.",
        "operation_feedback.list_update_reports.update_ok": "{{count}} oppdrag er oppdatert.",
        "operation_feedback.list_update_reports.success": "{{count}} serviceoppdrag er oppdatert.",
        "operation_feedback.list_update_reports.confirm_title": "Er du sikker?",
        "operation_feedback.list_update_reports.confirm_body": "Du redigerer nå {{count}} oppdrag. Dette kan ikke reverseres.",
        "operation_feedback.create_next_job.title_report": "Oppretter serviceoppdrag for avtale {{id}}",
        "operation_feedback.create_next_job.title_order": "Oppretter ordre for avtale {{id}}",
        "operation_feedback.create_next_job.step.preflight": "Kontrollerer avtale",
        "operation_feedback.create_next_job.step.create_report": "Oppretter serviceoppdrag",
        "operation_feedback.create_next_job.step.create_order": "Oppretter ordre",
        "operation_feedback.create_next_job.step.refresh": "Oppdaterer visning",
        "operation_feedback.create_next_job.preflight_ok": "Avtalen er klar.",
        "operation_feedback.create_next_job.preflight_failed": "Kan ikke starte neste jobb.",
        "operation_feedback.create_next_job.create_report_ok": "Serviceoppdrag er opprettet.",
        "operation_feedback.create_next_job.create_order_ok": "Ordre er opprettet.",
        "operation_feedback.create_next_job.success_report": "Serviceoppdraget er opprettet.",
        "operation_feedback.create_next_job.success_order": "Ordren er opprettet.",
        "operation_feedback.create_next_job.open_report": "Åpne rapport {{id}}",
        "operation_feedback.create_next_job.open_order": "Åpne ordre {{id}}",
        "operation_feedback.create_next_job.create_unconfirmed": "Opprettelsen er ikke bekreftet. Kontroller avtalen før du prøver igjen.",
        "operation_feedback.update_agreement_orderlines.title": "Lagrer ordrelinjer for avtale {{id}}",
        "operation_feedback.update_agreement_orderlines.step.preflight": "Kontrollerer avtale",
        "operation_feedback.update_agreement_orderlines.step.save": "Lagrer ordrelinjer",
        "operation_feedback.update_agreement_orderlines.step.refresh": "Oppdaterer visning",
        "operation_feedback.update_agreement_orderlines.preflight_ok": "Avtalen er klar.",
        "operation_feedback.update_agreement_orderlines.preflight_failed": "Kan ikke lagre ordrelinjer.",
        "operation_feedback.update_agreement_orderlines.save_ok": "Ordrelinjer er lagret.",
        "operation_feedback.update_agreement_orderlines.success": "Ordrelinjene er lagret.",
        "operation_feedback.copy_report.title": "Kopierer serviceoppdrag {{number}}",
        "operation_feedback.copy_report.step.preflight": "Kontrollerer rapport",
        "operation_feedback.copy_report.step.copy": "Kopierer rapport",
        "operation_feedback.copy_report.step.checklist": "Oppretter sjekkliste",
        "operation_feedback.copy_report.preflight_ok": "Rapporten er klar for kopiering.",
        "operation_feedback.copy_report.preflight_failed": "Kan ikke kopiere rapporten.",
        "operation_feedback.copy_report.copy_ok": "Rapporten er kopiert.",
        "operation_feedback.copy_report.checklist_ok": "Sjekkliste er opprettet.",
        "operation_feedback.copy_report.partial_checklist": "Rapporten er kopiert, men sjekkliste kunne ikke opprettes.",
        "operation_feedback.copy_report.success": "Rapporten er kopiert.",
        "operation_feedback.copy_report.open_report": "Åpne rapport {{id}}",
        "operation_feedback.rectify_report.title": "Oppretter oppfølger for {{number}}",
        "operation_feedback.rectify_report.step.preflight": "Kontrollerer rapport",
        "operation_feedback.rectify_report.step.create_sequel": "Oppretter oppfølger",
        "operation_feedback.rectify_report.step.checklist": "Oppretter sjekkliste",
        "operation_feedback.rectify_report.preflight_ok": "Rapporten er klar.",
        "operation_feedback.rectify_report.preflight_failed": "Kan ikke opprette oppfølger.",
        "operation_feedback.rectify_report.preflight_has_sequel": "Rapporten har allerede en oppfølger.",
        "operation_feedback.rectify_report.create_ok": "Oppfølger er opprettet.",
        "operation_feedback.rectify_report.checklist_ok": "Sjekkliste er opprettet.",
        "operation_feedback.rectify_report.partial_checklist": "Oppfølger er opprettet, men sjekkliste kunne ikke opprettes.",
        "operation_feedback.rectify_report.success": "Oppfølgeren er opprettet.",
        "operation_feedback.rectify_report.open_report": "Åpne rapport {{id}}",
        "operation_feedback.export_reports_excel.title": "Eksporterer serviceoppdrag til Excel",
        "operation_feedback.export_reports_excel.step.preflight": "Kontrollerer filter",
        "operation_feedback.export_reports_excel.step.export": "Genererer Excel",
        "operation_feedback.export_reports_excel.preflight_ok": "Filter er klare.",
        "operation_feedback.export_reports_excel.preflight_failed": "Kan ikke starte eksport.",
        "operation_feedback.export_reports_excel.export_ok": "Excel er klar.",
        "operation_feedback.export_reports_excel.export_failed": "Kunne ikke generere Excel.",
        "operation_feedback.export_reports_excel.success": "Excel-eksport er klar.",
        "operation_feedback.export_reports_excel.download": "Last ned Excel",
        "operation_feedback.generic_error": "En uventet feil oppstod.",
        "operation_feedback.diagnostics.toggle": "Tekniske detaljer",
        "operation_feedback.diagnostics.loading": "Henter tekniske detaljer…",
        "operation_feedback.diagnostics.copy": "Kopier feildetaljer",
        "operation_feedback.diagnostics.copied": "Kopiert",
        "operation_feedback.diagnostics.not_found": "Fant ingen tekniske detaljer for denne referansen.",
        "operation_feedback.diagnostics.forbidden": "Du har ikke tilgang til tekniske detaljer.",
        "operation_feedback.diagnostics.load_failed": "Kunne ikke hente tekniske detaljer.",
    }
}
